import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/Production/Production - (sub) Prepare environment/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import * as React from 'react';
import React__default, { forwardRef, useMemo, useState, useCallback, useEffect, useRef, createContext, useContext, useLayoutEffect, Children, createElement as createElement$2 } from 'react';
import styled, { css, ThemeProvider as ThemeProvider$1, createGlobalStyle } from 'styled-components';
import { Typography as Typography$1, createTheme, MuiThemeProvider, Checkbox as Checkbox$1, FormControlLabel, IconButton as IconButton$1, TextField as TextField$1, InputAdornment, Chip as Chip$1, Popover, ClickAwayListener, Radio as Radio$1, Fab as Fab$1, Dialog as Dialog$1, Card as Card$1, DialogContent, Divider as Divider$1, FormControl, LinearProgress, CircularProgress, Paper, Popper as Popper$1, ButtonGroup } from '@material-ui/core';
import { getFirstLetterUpperCase, formatDate, DATE_FORMATS, addMonths, addYears, getListOfMonths, isSameYear, isSameMonth, setDayOfWeek, addDays, formatOrdinals, isSameDay, isBefore, toDate, isDate as isDate$2, searchStringCompare, isAfter, startOfMonth, endOfMonth, startOfYear, endOfYear, addQuarters, startOfQuarter, endOfQuarter, addWeeks, startOfWeek, endOfWeek, firstLetterToUpperCase, isNumber } from '@hub-mono/utils';
import MuiAvatar from '@material-ui/core/Avatar';
import BaseButton from '@material-ui/core/Button';
import { useField } from 'formik';
import { AutoSizer, List as List$1 } from 'react-virtualized';
import { touch } from 'redux-form';
import debounce from 'lodash/debounce';
import { TwitterPicker } from 'react-color';
import MenuComponent from '@material-ui/core/Menu';
import { debounce as debounce$1 } from 'lodash';
import MenuItem$1 from '@material-ui/core/MenuItem';
import ReactDatePicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import MUIRadioGroup from '@material-ui/core/RadioGroup';
import Popper from '@material-ui/core/Popper';
import { Autocomplete, TreeView, TreeItem, createFilterOptions } from '@material-ui/lab';
import List$2 from '@material-ui/core/List';
import ListItem$1 from '@material-ui/core/ListItem';
import io from 'react-dom';
import uuid from 'uuid';
import MuiSwitch from '@material-ui/core/Switch';
import Card from '@material-ui/core/Card';
import MuiTooltip from '@material-ui/core/Tooltip';
import { parsePhoneNumber, getCountryCallingCode } from 'react-phone-number-input';
import Input from 'react-phone-number-input/input';
import 'react-phone-number-input/style.css';
import MuiSlider from '@material-ui/core/Slider';
import SwipeableViews from 'react-swipeable-views';
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from '@tanstack/react-table';
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var fails$q = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};
var fails$p = fails$q;
var functionBindNative = !fails$p(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () {/* empty */}.bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var NATIVE_BIND$3 = functionBindNative;
var FunctionPrototype$2 = Function.prototype;
var call$m = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$3 && FunctionPrototype$2.bind.bind(call$m, call$m);
var functionUncurryThis = NATIVE_BIND$3 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$m.apply(fn, arguments);
  };
};
var uncurryThis$o = functionUncurryThis;
var toString$c = uncurryThis$o({}.toString);
var stringSlice$5 = uncurryThis$o(''.slice);
var classofRaw$2 = function (it) {
  return stringSlice$5(toString$c(it), 8, -1);
};
var uncurryThis$n = functionUncurryThis;
var fails$o = fails$q;
var classof$8 = classofRaw$2;
var $Object$4 = Object;
var split$1 = uncurryThis$n(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$o(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) === 'String' ? split$1(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$5 = function (it) {
  return it === null || it === undefined;
};
var isNullOrUndefined$4 = isNullOrUndefined$5;
var $TypeError$j = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (isNullOrUndefined$4(it)) throw new $TypeError$j("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;
var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$6(it));
};
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$p =
// eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
// eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
// eslint-disable-next-line no-new-func -- fallback
function () {
  return this;
}() || Function('return this')();
var sharedStore = {
  exports: {}
};
var isPure = false;
var global$o = global$p;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;
var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$o, key, {
      value: value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global$o[key] = value;
  }
  return value;
};
var globalThis$1 = global$p;
var defineGlobalProperty$2 = defineGlobalProperty$3;
var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty$2(SHARED, {});
(store$3.versions || (store$3.versions = [])).push({
  version: '3.36.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
var store$2 = sharedStore.exports;
var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};
var requireObjectCoercible$5 = requireObjectCoercible$7;
var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$7 = function (argument) {
  return $Object$3(requireObjectCoercible$5(argument));
};
var uncurryThis$m = functionUncurryThis;
var toObject$6 = toObject$7;
var hasOwnProperty = uncurryThis$m({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$6(it), key);
};
var uncurryThis$l = functionUncurryThis;
var id = 0;
var postfix = Math.random();
var toString$b = uncurryThis$l(1.0.toString);
var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$b(++id + postfix, 36);
};
var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';
var global$n = global$p;
var userAgent$5 = engineUserAgent;
var process$4 = global$n.process;
var Deno$1 = global$n.Deno;
var versions = process$4 && process$4.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}
var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$n = fails$q;
var global$m = global$p;
var $String$5 = global$m.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$n(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var useSymbolAsUid = NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var global$l = global$p;
var shared$3 = shared$4;
var hasOwn$b = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var Symbol$3 = global$l.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$3['for'] || Symbol$3 : Symbol$3 && Symbol$3.withoutSetter || uid$1;
var wellKnownSymbol$l = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$b(Symbol$3, name) ? Symbol$3[name] : createWellKnownSymbol('Symbol.' + name);
  }
  return WellKnownSymbolsStore[name];
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$n = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};
var isCallable$m = isCallable$n;
var isObject$e = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$m(it);
};
var isObject$d = isObject$e;
var $String$4 = String;
var $TypeError$i = TypeError;

// `Assert: Type(argument) is Object`
var anObject$n = function (argument) {
  if (isObject$d(argument)) return argument;
  throw new $TypeError$i($String$4(argument) + ' is not an object');
};
var objectDefineProperties = {};
var fails$m = fails$q;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$m(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, {
    get: function () {
      return 7;
    }
  })[1] !== 7;
});
var DESCRIPTORS$e = descriptors;
var fails$l = fails$q;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$e && fails$l(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () {/* empty */}, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});
var objectDefineProperty = {};
var global$k = global$p;
var isObject$c = isObject$e;
var document$3 = global$k.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$c(document$3) && isObject$c(document$3.createElement);
var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};
var DESCRIPTORS$d = descriptors;
var fails$k = fails$q;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$d && !fails$k(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () {
      return 7;
    }
  }).a !== 7;
});
var NATIVE_BIND$2 = functionBindNative;
var call$l = Function.prototype.call;
var functionCall = NATIVE_BIND$2 ? call$l.bind(call$l) : function () {
  return call$l.apply(call$l, arguments);
};
var global$j = global$p;
var isCallable$l = isCallable$n;
var aFunction = function (argument) {
  return isCallable$l(argument) ? argument : undefined;
};
var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$j[namespace]) : global$j[namespace] && global$j[namespace][method];
};
var uncurryThis$k = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$k({}.isPrototypeOf);
var getBuiltIn$7 = getBuiltIn$8;
var isCallable$k = isCallable$n;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var $Object$2 = Object;
var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$7('Symbol');
  return isCallable$k($Symbol) && isPrototypeOf$3($Symbol.prototype, $Object$2(it));
};
var $String$3 = String;
var tryToString$5 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};
var isCallable$j = isCallable$n;
var tryToString$4 = tryToString$5;
var $TypeError$h = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$i = function (argument) {
  if (isCallable$j(argument)) return argument;
  throw new $TypeError$h(tryToString$4(argument) + ' is not a function');
};
var aCallable$h = aCallable$i;
var isNullOrUndefined$3 = isNullOrUndefined$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$5 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$3(func) ? undefined : aCallable$h(func);
};
var call$k = functionCall;
var isCallable$i = isCallable$n;
var isObject$b = isObject$e;
var $TypeError$g = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$i(fn = input.toString) && !isObject$b(val = call$k(fn, input))) return val;
  if (isCallable$i(fn = input.valueOf) && !isObject$b(val = call$k(fn, input))) return val;
  if (pref !== 'string' && isCallable$i(fn = input.toString) && !isObject$b(val = call$k(fn, input))) return val;
  throw new $TypeError$g("Can't convert object to primitive value");
};
var call$j = functionCall;
var isObject$a = isObject$e;
var isSymbol$1 = isSymbol$2;
var getMethod$4 = getMethod$5;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$k = wellKnownSymbol$l;
var $TypeError$f = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$k('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$2 = function (input, pref) {
  if (!isObject$a(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$4(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$j(exoticToPrim, input, pref);
    if (!isObject$a(result) || isSymbol$1(result)) return result;
    throw new $TypeError$f("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};
var toPrimitive$1 = toPrimitive$2;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol(key) ? key : key + '';
};
var DESCRIPTORS$c = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$m = anObject$n;
var toPropertyKey$2 = toPropertyKey$3;
var $TypeError$e = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$c ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$m(O);
  P = toPropertyKey$2(P);
  anObject$m(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$m(O);
  P = toPropertyKey$2(P);
  anObject$m(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$e('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};
var ceil = Math.ceil;
var floor$2 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2 : ceil)(n);
};
var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};
var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;
var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};
var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;
var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  var len = toIntegerOrInfinity$2(argument);
  return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$6 = function (obj) {
  return toLength$1(obj.length);
};
var toIndexedObject$4 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$5 = lengthOfArrayLike$6;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$5(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};
var hiddenKeys$4 = {};
var uncurryThis$j = functionUncurryThis;
var hasOwn$a = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;
var push$3 = uncurryThis$j([].push);
var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$a(hiddenKeys$3, key) && hasOwn$a(O, key) && push$3(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$a(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$3(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};
var DESCRIPTORS$b = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$4 = objectDefineProperty;
var anObject$l = anObject$n;
var toIndexedObject$2 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$b && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$l(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$4.f(O, key = keys[index++], props[key]);
  return O;
};
var getBuiltIn$6 = getBuiltIn$8;
var html$2 = getBuiltIn$6('document', 'documentElement');
var shared$2 = shared$4;
var uid = uid$2;
var keys = shared$2('keys');
var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */
var anObject$k = anObject$n;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');
var EmptyConstructor = function () {/* empty */};
var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) {/* ignore */}
  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};
hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$k(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};
var wellKnownSymbol$j = wellKnownSymbol$l;
var create$3 = objectCreate;
var defineProperty$6 = objectDefineProperty.f;
var UNSCOPABLES = wellKnownSymbol$j('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$6(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};
var iterators = {};
var global$i = global$p;
var isCallable$h = isCallable$n;
var WeakMap$2 = global$i.WeakMap;
var weakMapBasicDetection = isCallable$h(WeakMap$2) && /native code/.test(String(WeakMap$2));
var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};
var DESCRIPTORS$a = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var createNonEnumerableProperty$9 = DESCRIPTORS$a ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$4(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};
var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$h = global$p;
var isObject$9 = isObject$e;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$9 = hasOwnProperty_1;
var shared$1 = sharedStore.exports;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$h.TypeError;
var WeakMap$1 = global$h.WeakMap;
var set$1, get, has;
var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};
var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$9(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    }
    return state;
  };
};
if (NATIVE_WEAK_MAP || shared$1.state) {
  var store$1 = shared$1.state || (shared$1.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store$1.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$9(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$9(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$9(it, STATE);
  };
}
var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};
var objectGetOwnPropertyDescriptor = {};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({
  1: 2
}, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;
var DESCRIPTORS$9 = descriptors;
var call$i = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;
var toIndexedObject$1 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$3;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) {/* empty */}
  if (hasOwn$8(O, P)) return createPropertyDescriptor$3(!call$i(propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var makeBuiltIn$3 = {
  exports: {}
};
var DESCRIPTORS$8 = descriptors;
var hasOwn$7 = hasOwnProperty_1;
var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$8 && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$7(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$8 || DESCRIPTORS$8 && getDescriptor(FunctionPrototype$1, 'name').configurable);
var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};
var uncurryThis$i = functionUncurryThis;
var isCallable$g = isCallable$n;
var store = sharedStore.exports;
var functionToString = uncurryThis$i(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$g(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}
var inspectSource$3 = store.inspectSource;
var uncurryThis$h = functionUncurryThis;
var fails$j = fails$q;
var isCallable$f = isCallable$n;
var hasOwn$6 = hasOwnProperty_1;
var DESCRIPTORS$7 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$3 = internalState;
var enforceInternalState = InternalStateModule$3.enforce;
var getInternalState$2 = InternalStateModule$3.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$4 = uncurryThis$h(''.slice);
var replace$4 = uncurryThis$h(''.replace);
var join = uncurryThis$h([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS$7 && !fails$j(function () {
  return defineProperty$5(function () {/* empty */}, 'length', {
    value: 8
  }).length !== 8;
});
var TEMPLATE = String(String).split('String');
var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$4($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$4($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$6(value, 'name') || CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
    if (DESCRIPTORS$7) defineProperty$5(value, 'name', {
      value: name,
      configurable: true
    });else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$6(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', {
      value: options.arity
    });
  }
  try {
    if (options && hasOwn$6(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$7) defineProperty$5(value, 'prototype', {
        writable: false
      });
      // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) {/* empty */}
  var state = enforceInternalState(value);
  if (!hasOwn$6(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  }
  return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$f(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');
var isCallable$e = isCallable$n;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;
var defineBuiltIn$7 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$e(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
    } catch (error) {/* empty */}
    if (simple) O[key] = value;else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  }
  return O;
};
var objectGetOwnPropertyNames = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};
var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$5 = getBuiltIn$8;
var uncurryThis$g = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$j = anObject$n;
var concat$2 = uncurryThis$g([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$5 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$j(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};
var hasOwn$5 = hasOwnProperty_1;
var ownKeys$4 = ownKeys$5;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;
var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys$4(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};
var fails$i = fails$q;
var isCallable$d = isCallable$n;
var replacement = /#|\.prototype\./;
var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true : value === NATIVE ? false : isCallable$d(detection) ? fails$i(detection) : !!detection;
};
var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';
var isForced_1 = isForced$2;
var global$g = global$p;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var defineBuiltIn$6 = defineBuiltIn$7;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$g;
  } else if (STATIC) {
    target = global$g[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$g[TARGET] && global$g[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || targetProperty && targetProperty.sham) {
      createNonEnumerableProperty$7(sourceProperty, 'sham', true);
    }
    defineBuiltIn$6(target, key, sourceProperty, options);
  }
};
var fails$h = fails$q;
var correctPrototypeGetter = !fails$h(function () {
  function F() {/* empty */}
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var hasOwn$4 = hasOwnProperty_1;
var isCallable$c = isCallable$n;
var toObject$5 = toObject$7;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$5(O);
  if (hasOwn$4(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$c(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof $Object$1 ? ObjectPrototype : null;
};
var fails$g = fails$q;
var isCallable$b = isCallable$n;
var isObject$8 = isObject$e;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$5 = defineBuiltIn$7;
var wellKnownSymbol$i = wellKnownSymbol$l;
var ITERATOR$8 = wellKnownSymbol$i('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = !isObject$8(IteratorPrototype$4) || fails$g(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$8].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$b(IteratorPrototype$4[ITERATOR$8])) {
  defineBuiltIn$5(IteratorPrototype$4, ITERATOR$8, function () {
    return this;
  });
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};
var defineProperty$4 = objectDefineProperty.f;
var hasOwn$3 = hasOwnProperty_1;
var wellKnownSymbol$h = wellKnownSymbol$l;
var TO_STRING_TAG$4 = wellKnownSymbol$h('toStringTag');
var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$3(target, TO_STRING_TAG$4)) {
    defineProperty$4(target, TO_STRING_TAG$4, {
      configurable: true,
      value: TAG
    });
  }
};
var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var create$2 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var setToStringTag$3 = setToStringTag$4;
var Iterators$4 = iterators;
var returnThis$1 = function () {
  return this;
};
var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$2(IteratorPrototype$3, {
    next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next)
  });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};
var uncurryThis$f = functionUncurryThis;
var aCallable$g = aCallable$i;
var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$f(aCallable$g(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) {/* empty */}
};
var isObject$7 = isObject$e;
var isPossiblePrototype$1 = function (argument) {
  return isObject$7(argument) || argument === null;
};
var isPossiblePrototype = isPossiblePrototype$1;
var $String$1 = String;
var $TypeError$d = TypeError;
var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$d("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$6 = isObject$e;
var requireObjectCoercible$4 = requireObjectCoercible$7;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) {/* empty */}
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$4(O);
    aPossiblePrototype(proto);
    if (!isObject$6(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);else O.__proto__ = proto;
    return O;
  };
}() : undefined);
var $$r = _export;
var call$h = functionCall;
var FunctionName = functionName;
var isCallable$a = isCallable$n;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$3 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var defineBuiltIn$4 = defineBuiltIn$7;
var wellKnownSymbol$g = wellKnownSymbol$l;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;
var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype$2 = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$7 = wellKnownSymbol$g('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';
var returnThis = function () {
  return this;
};
var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);
  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function () {
      return new IteratorConstructor(this);
    };
  };
  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$7] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (setPrototypeOf$3) {
          setPrototypeOf$3(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable$a(CurrentIteratorPrototype[ITERATOR$7])) {
          defineBuiltIn$4(CurrentIteratorPrototype, ITERATOR$7, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$6(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() {
        return call$h(nativeIterator, this);
      };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$4(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$r({
      target: NAME,
      proto: true,
      forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
    }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$7] !== defaultIterator) {
    defineBuiltIn$4(IterablePrototype, ITERATOR$7, defaultIterator, {
      name: DEFAULT
    });
  }
  Iterators$3[NAME] = defaultIterator;
  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return {
    value: value,
    done: done
  };
};
var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$2 = internalState;
var defineProperty$3 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;
var DESCRIPTORS$6 = descriptors;
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState$1 = InternalStateModule$2.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$2(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated),
    // target
    index: 0,
    // next index
    kind: kind // kind
  });
  // `%ArrayIteratorPrototype%.next` method
  // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys':
      return createIterResultObject$1(index, false);
    case 'values':
      return createIterResultObject$1(target[index], false);
  }
  return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$6 && values.name !== 'values') try {
  defineProperty$3(values, 'name', {
    value: 'values'
  });
} catch (error) {/* empty */}
var isPrototypeOf$2 = objectIsPrototypeOf;
var $TypeError$c = TypeError;
var anInstance$2 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw new $TypeError$c('Incorrect invocation');
};
var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$2 = objectDefineProperty;
var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, {
    getter: true
  });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, {
    setter: true
  });
  return defineProperty$2.f(target, name, descriptor);
};
var DESCRIPTORS$5 = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;
var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$5) definePropertyModule.f(object, key, createPropertyDescriptor$1(0, value));else object[key] = value;
};
var $$q = _export;
var global$f = global$p;
var anInstance$1 = anInstance$2;
var anObject$i = anObject$n;
var isCallable$9 = isCallable$n;
var getPrototypeOf = objectGetPrototypeOf;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var createProperty = createProperty$1;
var fails$f = fails$q;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$f = wellKnownSymbol$l;
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var DESCRIPTORS$4 = descriptors;
var CONSTRUCTOR = 'constructor';
var ITERATOR$6 = 'Iterator';
var TO_STRING_TAG$3 = wellKnownSymbol$f('toStringTag');
var $TypeError$b = TypeError;
var NativeIterator = global$f[ITERATOR$6];

// FF56- have non-standard global helper `Iterator`
var FORCED$5 = !isCallable$9(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$1
// FF44- non-standard `Iterator` passes previous tests
|| !fails$f(function () {
  NativeIterator({});
});
var IteratorConstructor = function Iterator() {
  anInstance$1(this, IteratorPrototype$1);
  if (getPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$b('Abstract class Iterator not directly constructable');
};
var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS$4) {
    defineBuiltInAccessor$1(IteratorPrototype$1, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$i(this);
        if (this === IteratorPrototype$1) throw new $TypeError$b("You can't redefine this property");
        if (hasOwn$2(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype$1[key] = value;
};
if (!hasOwn$2(IteratorPrototype$1, TO_STRING_TAG$3)) defineIteratorPrototypeAccessor(TO_STRING_TAG$3, ITERATOR$6);
if (FORCED$5 || !hasOwn$2(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}
IteratorConstructor.prototype = IteratorPrototype$1;

// `Iterator` constructor
// https://github.com/tc39/proposal-iterator-helpers
$$q({
  global: true,
  constructor: true,
  forced: FORCED$5
}, {
  Iterator: IteratorConstructor
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$9 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};
var defineBuiltIn$3 = defineBuiltIn$7;
var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$3(target, key, src[key], options);
  return target;
};
var call$g = functionCall;
var anObject$h = anObject$n;
var getMethod$3 = getMethod$5;
var iteratorClose$4 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$h(iterator);
  try {
    innerResult = getMethod$3(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$g(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$h(innerResult);
  return value;
};
var call$f = functionCall;
var create$1 = objectCreate;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var defineBuiltIns = defineBuiltIns$1;
var wellKnownSymbol$e = wellKnownSymbol$l;
var InternalStateModule$1 = internalState;
var getMethod$2 = getMethod$5;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var createIterResultObject = createIterResultObject$2;
var iteratorClose$3 = iteratorClose$4;
var TO_STRING_TAG$2 = wellKnownSymbol$e('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var setInternalState$1 = InternalStateModule$1.set;
var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule$1.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
  return defineBuiltIns(create$1(IteratorPrototype), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      try {
        var result = state.done ? undefined : state.nextHandler();
        return createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod$2(iterator, 'return');
        return returnMethod ? call$f(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$3(state.inner.iterator, 'normal');
      } catch (error) {
        return iteratorClose$3(iterator, 'throw', error);
      }
      iteratorClose$3(iterator, 'normal');
      return createIterResultObject(undefined, true);
    }
  });
};
var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);
createNonEnumerableProperty$5(IteratorHelperPrototype, TO_STRING_TAG$2, 'Iterator Helper');
var iteratorCreateProxy = function (nextHandler, IS_ITERATOR) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState$1(this, state);
  };
  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
  return IteratorProxy;
};
var anObject$g = anObject$n;
var iteratorClose$2 = iteratorClose$4;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$2 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$g(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$2(iterator, 'throw', error);
  }
};
var $$p = _export;
var call$e = functionCall;
var aCallable$f = aCallable$i;
var anObject$f = anObject$n;
var getIteratorDirect$8 = getIteratorDirect$9;
var createIteratorProxy$2 = iteratorCreateProxy;
var callWithSafeIterationClosing$1 = callWithSafeIterationClosing$2;
var IS_PURE$2 = isPure;
var IteratorProxy$2 = createIteratorProxy$2(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject$f(call$e(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing$1(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://github.com/tc39/proposal-iterator-helpers
$$p({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: IS_PURE$2
}, {
  filter: function filter(predicate) {
    anObject$f(this);
    aCallable$f(predicate);
    return new IteratorProxy$2(getIteratorDirect$8(this), {
      predicate: predicate
    });
  }
});
var call$d = functionCall;
var aCallable$e = aCallable$i;
var anObject$e = anObject$n;
var getIteratorDirect$7 = getIteratorDirect$9;
var createIteratorProxy$1 = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$2;
var IteratorProxy$1 = createIteratorProxy$1(function () {
  var iterator = this.iterator;
  var result = anObject$e(call$d(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://github.com/tc39/proposal-iterator-helpers
var iteratorMap = function map(mapper) {
  anObject$e(this);
  aCallable$e(mapper);
  return new IteratorProxy$1(getIteratorDirect$7(this), {
    mapper: mapper
  });
};
var $$o = _export;
var map = iteratorMap;
var IS_PURE$1 = isPure;

// `Iterator.prototype.map` method
// https://github.com/tc39/proposal-iterator-helpers
$$o({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: IS_PURE$1
}, {
  map: map
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;
var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;
var global$e = global$p;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
var setToStringTag$1 = setToStringTag$4;
var wellKnownSymbol$d = wellKnownSymbol$l;
var ITERATOR$5 = wellKnownSymbol$d('iterator');
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$5] !== ArrayValues) try {
      createNonEnumerableProperty$4(CollectionPrototype, ITERATOR$5, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$5] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$4(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};
for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$e[COLLECTION_NAME] && global$e[COLLECTION_NAME].prototype, COLLECTION_NAME);
}
handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
var tryToString$3 = tryToString$5;
var $TypeError$a = TypeError;
var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw new $TypeError$a('Cannot delete property ' + tryToString$3(P) + ' of ' + tryToString$3(O));
};
var wellKnownSymbol$c = wellKnownSymbol$l;
var TO_STRING_TAG$1 = wellKnownSymbol$c('toStringTag');
var test$1 = {};
test$1[TO_STRING_TAG$1] = 'z';
var toStringTagSupport = String(test$1) === '[object z]';
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$8 = isCallable$n;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$b = wellKnownSymbol$l;
var TO_STRING_TAG = wellKnownSymbol$b('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () {
  return arguments;
}()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) {/* empty */}
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
  // builtinTag case
  : CORRECT_ARGUMENTS ? classofRaw$1(O)
  // ES3 arguments fallback
  : (result = classofRaw$1(O)) === 'Object' && isCallable$8(O.callee) ? 'Arguments' : result;
};
var classof$6 = classof$7;
var $String = String;
var toString$a = function (argument) {
  if (classof$6(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};
var uncurryThis$e = functionUncurryThis;
var arraySlice$2 = uncurryThis$e([].slice);
var arraySlice$1 = arraySlice$2;
var floor$1 = Math.floor;
var sort = function (array, comparefn) {
  var length = array.length;
  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;
    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor$1(length / 2);
    var left = sort(arraySlice$1(array, 0, middle), comparefn);
    var right = sort(arraySlice$1(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }
  return array;
};
var arraySort = sort;
var fails$e = fails$q;
var arrayMethodIsStrict$2 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$e(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () {
      return 1;
    }, 1);
  });
};
var userAgent$4 = engineUserAgent;
var firefox = userAgent$4.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];
var UA = engineUserAgent;
var engineIsIeOrEdge = /MSIE|Trident/.test(UA);
var userAgent$3 = engineUserAgent;
var webkit = userAgent$3.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];
var $$n = _export;
var uncurryThis$d = functionUncurryThis;
var aCallable$d = aCallable$i;
var toObject$4 = toObject$7;
var lengthOfArrayLike$4 = lengthOfArrayLike$6;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$9 = toString$a;
var fails$d = fails$q;
var internalSort = arraySort;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$2;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;
var test = [];
var nativeSort = uncurryThis$d(test.sort);
var push$2 = uncurryThis$d(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$d(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$d(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict$1('sort');
var STABLE_SORT = !fails$d(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;
  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);
    switch (code) {
      case 66:
      case 69:
      case 70:
      case 72:
        value = 3;
        break;
      case 68:
      case 71:
        value = 4;
        break;
      default:
        value = 2;
    }
    for (index = 0; index < 47; index++) {
      test.push({
        k: chr + index,
        v: value
      });
    }
  }
  test.sort(function (a, b) {
    return b.v - a.v;
  });
  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }
  return result !== 'DGBEFHACIJK';
});
var FORCED$4 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$9(x) > toString$9(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$n({
  target: 'Array',
  proto: true,
  forced: FORCED$4
}, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable$d(comparefn);
    var array = toObject$4(this);
    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
    var items = [];
    var arrayLength = lengthOfArrayLike$4(array);
    var itemsLength, index;
    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$2(items, array[index]);
    }
    internalSort(items, getSortCompare(comparefn));
    itemsLength = lengthOfArrayLike$4(items);
    index = 0;
    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);
    return array;
  }
});
var _g$24;
var _excluded$2p = ["title", "titleId"];
function _extends$2p() {
  return _extends$2p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2p.apply(null, arguments);
}
function _objectWithoutProperties$2o(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2p(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2p(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAccessTime = function SvgAccessTime(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2o(_ref, _excluded$2p);
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$24 || (_g$24 = /*#__PURE__*/React.createElement("g", {
    id: "Icons/access_time_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11 13.07L16.49 16.36L17.51 14.64L13 11.93V6.42H11V13.07Z",
    fill: "black"
  }))));
};
var ForwardRef$2o = /*#__PURE__*/forwardRef(SvgAccessTime);
var _rect$15, _g$23;
var _excluded$2o = ["title", "titleId"];
function _extends$2o() {
  return _extends$2o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2o.apply(null, arguments);
}
function _objectWithoutProperties$2n(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2o(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2o(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAddCircle = function SvgAddCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2n(_ref, _excluded$2o);
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2512_1610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect$15 || (_rect$15 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.666748,
    y: 0.666504,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g$23 || (_g$23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2512_1610)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_circle",
    d: "M8 11.9998H9.33333V9.33309H12V7.99976H9.33333V5.33309H8V7.99976H5.33333V9.33309H8V11.9998ZM8.66667 15.3331C7.74444 15.3331 6.87778 15.1581 6.06667 14.8081C5.25556 14.4581 4.55 13.9831 3.95 13.3831C3.35 12.7831 2.875 12.0775 2.525 11.2664C2.175 10.4553 2 9.58864 2 8.66642C2 7.7442 2.175 6.87753 2.525 6.06642C2.875 5.25531 3.35 4.54976 3.95 3.94976C4.55 3.34976 5.25556 2.87476 6.06667 2.52476C6.87778 2.17476 7.74444 1.99976 8.66667 1.99976C9.58889 1.99976 10.4556 2.17476 11.2667 2.52476C12.0778 2.87476 12.7833 3.34976 13.3833 3.94976C13.9833 4.54976 14.4583 5.25531 14.8083 6.06642C15.1583 6.87753 15.3333 7.7442 15.3333 8.66642C15.3333 9.58864 15.1583 10.4553 14.8083 11.2664C14.4583 12.0775 13.9833 12.7831 13.3833 13.3831C12.7833 13.9831 12.0778 14.4581 11.2667 14.8081C10.4556 15.1581 9.58889 15.3331 8.66667 15.3331ZM8.66667 13.9998C10.1556 13.9998 11.4167 13.4831 12.45 12.4498C13.4833 11.4164 14 10.1553 14 8.66642C14 7.17753 13.4833 5.91642 12.45 4.88309C11.4167 3.84976 10.1556 3.33309 8.66667 3.33309C7.17778 3.33309 5.91667 3.84976 4.88333 4.88309C3.85 5.91642 3.33333 7.17753 3.33333 8.66642C3.33333 10.1553 3.85 11.4164 4.88333 12.4498C5.91667 13.4831 7.17778 13.9998 8.66667 13.9998Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$2n = /*#__PURE__*/forwardRef(SvgAddCircle);
var _g$22;
var _excluded$2n = ["title", "titleId"];
function _extends$2n() {
  return _extends$2n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2n.apply(null, arguments);
}
function _objectWithoutProperties$2m(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2n(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2n(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAdd = function SvgAdd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2m(_ref, _excluded$2n);
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$22 || (_g$22 = /*#__PURE__*/React.createElement("g", {
    id: "Icons/add_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M20 13H13V20H11V13H4V11H11V4H13V11H20V13Z",
    fill: "black"
  }))));
};
var ForwardRef$2m = /*#__PURE__*/forwardRef(SvgAdd);
var _rect$14, _g$21;
var _excluded$2m = ["title", "titleId"];
function _extends$2m() {
  return _extends$2m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2m.apply(null, arguments);
}
function _objectWithoutProperties$2l(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2m(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2m(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAlarm = function SvgAlarm(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2l(_ref, _excluded$2m);
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "alarm"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2808_18012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$14 || (_rect$14 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$21 || (_g$21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2808_18012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "alarm_2",
    d: "M12.0001 22.0001C10.7501 22.0001 9.57927 21.7626 8.4876 21.2876C7.39593 20.8126 6.44593 20.1709 5.6376 19.3626C4.82926 18.5543 4.1876 17.6043 3.7126 16.5126C3.2376 15.4209 3.0001 14.2501 3.0001 13.0001C3.0001 11.7501 3.2376 10.5793 3.7126 9.4876C4.1876 8.39593 4.82926 7.44593 5.6376 6.6376C6.44593 5.82926 7.39593 5.1876 8.4876 4.7126C9.57927 4.2376 10.7501 4.0001 12.0001 4.0001C13.2501 4.0001 14.4209 4.2376 15.5126 4.7126C16.6043 5.1876 17.5543 5.82926 18.3626 6.6376C19.1709 7.44593 19.8126 8.39593 20.2876 9.4876C20.7626 10.5793 21.0001 11.7501 21.0001 13.0001C21.0001 14.2501 20.7626 15.4209 20.2876 16.5126C19.8126 17.6043 19.1709 18.5543 18.3626 19.3626C17.5543 20.1709 16.6043 20.8126 15.5126 21.2876C14.4209 21.7626 13.2501 22.0001 12.0001 22.0001ZM14.8001 17.2001L16.2001 15.8001L13.0001 12.6001V8.0001H11.0001V13.4001L14.8001 17.2001ZM5.6001 2.3501L7.0001 3.7501L2.7501 8.0001L1.3501 6.6001L5.6001 2.3501ZM18.4001 2.3501L22.6501 6.6001L21.2501 8.0001L17.0001 3.7501L18.4001 2.3501ZM12.0001 20.0001C13.9501 20.0001 15.6043 19.3209 16.9626 17.9626C18.3209 16.6043 19.0001 14.9501 19.0001 13.0001C19.0001 11.0501 18.3209 9.39593 16.9626 8.0376C15.6043 6.67926 13.9501 6.0001 12.0001 6.0001C10.0501 6.0001 8.39593 6.67926 7.0376 8.0376C5.67926 9.39593 5.0001 11.0501 5.0001 13.0001C5.0001 14.9501 5.67926 16.6043 7.0376 17.9626C8.39593 19.3209 10.0501 20.0001 12.0001 20.0001Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$2l = /*#__PURE__*/forwardRef(SvgAlarm);
var _rect$13, _g$20;
var _excluded$2l = ["title", "titleId"];
function _extends$2l() {
  return _extends$2l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2l.apply(null, arguments);
}
function _objectWithoutProperties$2k(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2l(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2l(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgArchive = function SvgArchive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2k(_ref, _excluded$2l);
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "archive"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56921_13493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$13 || (_rect$13 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$20 || (_g$20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56921_13493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "archive_2",
    d: "M12 10C11.7167 10 11.4792 10.0958 11.2875 10.2875C11.0958 10.4792 11 10.7167 11 11V14.2L10.1 13.3C9.91667 13.1167 9.68333 13.025 9.4 13.025C9.11667 13.025 8.88333 13.1167 8.7 13.3C8.51667 13.4833 8.425 13.7167 8.425 14C8.425 14.2833 8.51667 14.5167 8.7 14.7L11.3 17.3C11.5 17.5 11.7333 17.6 12 17.6C12.2667 17.6 12.5 17.5 12.7 17.3L15.3 14.7C15.4833 14.5167 15.575 14.2833 15.575 14C15.575 13.7167 15.4833 13.4833 15.3 13.3C15.1167 13.1167 14.8833 13.025 14.6 13.025C14.3167 13.025 14.0833 13.1167 13.9 13.3L13 14.2V11C13 10.7167 12.9042 10.4792 12.7125 10.2875C12.5208 10.0958 12.2833 10 12 10ZM5 8V19H19V8H5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V6.525C3 6.29167 3.0375 6.06667 3.1125 5.85C3.1875 5.63333 3.3 5.43333 3.45 5.25L4.7 3.725C4.88333 3.49167 5.1125 3.3125 5.3875 3.1875C5.6625 3.0625 5.95 3 6.25 3H17.75C18.05 3 18.3375 3.0625 18.6125 3.1875C18.8875 3.3125 19.1167 3.49167 19.3 3.725L20.55 5.25C20.7 5.43333 20.8125 5.63333 20.8875 5.85C20.9625 6.06667 21 6.29167 21 6.525V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5.4 6H18.6L17.75 5H6.25L5.4 6Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$2k = /*#__PURE__*/forwardRef(SvgArchive);
var _path$o;
var _excluded$2k = ["title", "titleId"];
function _extends$2k() {
  return _extends$2k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2k.apply(null, arguments);
}
function _objectWithoutProperties$2j(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2k(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2k(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgArrowBack = function SvgArrowBack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2j(_ref, _excluded$2k);
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z",
    fill: "black"
  })));
};
var ForwardRef$2j = /*#__PURE__*/forwardRef(SvgArrowBack);
var _path$n;
var _excluded$2j = ["title", "titleId"];
function _extends$2j() {
  return _extends$2j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2j.apply(null, arguments);
}
function _objectWithoutProperties$2i(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2j(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2j(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgArrowDropDown = function SvgArrowDropDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2i(_ref, _excluded$2j);
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M7 10L12 15L17 10H7Z",
    fill: "black"
  })));
};
var ForwardRef$2i = /*#__PURE__*/forwardRef(SvgArrowDropDown);
var _path$m;
var _excluded$2i = ["title", "titleId"];
function _extends$2i() {
  return _extends$2i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2i.apply(null, arguments);
}
function _objectWithoutProperties$2h(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2i(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2i(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgArrowDropUp = function SvgArrowDropUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2h(_ref, _excluded$2i);
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    d: "M7 14L12 9L17 14H7Z",
    fill: "black"
  })));
};
var ForwardRef$2h = /*#__PURE__*/forwardRef(SvgArrowDropUp);
var _g$1$;
var _excluded$2h = ["title", "titleId"];
function _extends$2h() {
  return _extends$2h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2h.apply(null, arguments);
}
function _objectWithoutProperties$2g(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2h(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2h(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgArrowForward = function SvgArrowForward(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2g(_ref, _excluded$2h);
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1$ || (_g$1$ = /*#__PURE__*/React.createElement("g", {
    id: "Icons/arrow_forward_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z",
    fill: "black"
  }))));
};
var ForwardRef$2g = /*#__PURE__*/forwardRef(SvgArrowForward);
var _rect$12, _g$1_;
var _excluded$2g = ["title", "titleId"];
function _extends$2g() {
  return _extends$2g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2g.apply(null, arguments);
}
function _objectWithoutProperties$2f(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2g(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2g(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgArrowOutward = function SvgArrowOutward(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2f(_ref, _excluded$2g);
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_outward"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55392_360",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$12 || (_rect$12 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1_ || (_g$1_ = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55392_360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_outward_2",
    d: "M6.4 18L5 16.6L14.6 7H6V5H18V17H16V8.4L6.4 18Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$2f = /*#__PURE__*/forwardRef(SvgArrowOutward);
var _rect$11, _g$1Z;
var _excluded$2f = ["title", "titleId"];
function _extends$2f() {
  return _extends$2f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2f.apply(null, arguments);
}
function _objectWithoutProperties$2e(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2f(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2f(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAttachMoney = function SvgAttachMoney(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2e(_ref, _excluded$2f);
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56403_27930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$11 || (_rect$11 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1Z || (_g$1Z = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56403_27930)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "attach_money",
    d: "M11.025 21V18.85C10.1416 18.65 9.37912 18.2667 8.73745 17.7C8.09578 17.1333 7.62495 16.3333 7.32495 15.3L9.17495 14.55C9.42495 15.35 9.79578 15.9583 10.2875 16.375C10.7791 16.7917 11.425 17 12.225 17C12.9083 17 13.4875 16.8458 13.9625 16.5375C14.4375 16.2292 14.675 15.75 14.675 15.1C14.675 14.5167 14.4916 14.0542 14.125 13.7125C13.7583 13.3708 12.9083 12.9833 11.575 12.55C10.1416 12.1 9.15828 11.5625 8.62495 10.9375C8.09162 10.3125 7.82495 9.55 7.82495 8.65C7.82495 7.56667 8.17495 6.725 8.87495 6.125C9.57495 5.525 10.2916 5.18333 11.025 5.1V3H13.025V5.1C13.8583 5.23333 14.5458 5.5375 15.0875 6.0125C15.6291 6.4875 16.025 7.06667 16.275 7.75L14.425 8.55C14.225 8.01667 13.9416 7.61667 13.575 7.35C13.2083 7.08333 12.7083 6.95 12.075 6.95C11.3416 6.95 10.7833 7.1125 10.4 7.4375C10.0166 7.7625 9.82495 8.16667 9.82495 8.65C9.82495 9.2 10.075 9.63333 10.575 9.95C11.075 10.2667 11.9416 10.6 13.175 10.95C14.325 11.2833 15.1958 11.8125 15.7875 12.5375C16.3791 13.2625 16.675 14.1 16.675 15.05C16.675 16.2333 16.325 17.1333 15.625 17.75C14.925 18.3667 14.0583 18.75 13.025 18.9V21H11.025Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$2e = /*#__PURE__*/forwardRef(SvgAttachMoney);
var _g$1Y;
var _excluded$2e = ["title", "titleId"];
function _extends$2e() {
  return _extends$2e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2e.apply(null, arguments);
}
function _objectWithoutProperties$2d(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2e(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2e(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAvatar = function SvgAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2d(_ref, _excluded$2e);
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1Y || (_g$1Y = /*#__PURE__*/React.createElement("g", {
    id: "Style=avatar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#AFECFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Avatar Placeholder"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0002 16C26.0002 19.3137 23.314 22 20.0002 22C16.6865 22 14.0002 19.3137 14.0002 16C14.0002 12.6863 16.6865 10 20.0002 10C23.314 10 26.0002 12.6863 26.0002 16ZM24.0002 16C24.0002 18.2091 22.2094 20 20.0002 20C17.7911 20 16.0002 18.2091 16.0002 16C16.0002 13.7909 17.7911 12 20.0002 12C22.2094 12 24.0002 13.7909 24.0002 16Z",
    fill: "#003844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 25C13.5259 25 8.00952 28.8284 5.9082 34.192C6.4201 34.7004 6.95934 35.1812 7.52353 35.6321C9.08827 30.7077 13.997 27 20.0002 27C26.0035 27 30.9122 30.7077 32.477 35.6321C33.0412 35.1812 33.5804 34.7004 34.0923 34.1921C31.991 28.8284 26.4746 25 20.0002 25Z",
    fill: "#003844"
  })))));
};
var ForwardRef$2d = /*#__PURE__*/forwardRef(SvgAvatar);
var _rect$10, _g$1X;
var _excluded$2d = ["title", "titleId"];
function _extends$2d() {
  return _extends$2d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2d.apply(null, arguments);
}
function _objectWithoutProperties$2c(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2d(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2d(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAvgPace = function SvgAvgPace(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2c(_ref, _excluded$2d);
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_12000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect$10 || (_rect$10 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g$1X || (_g$1X = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_12000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3334 6.66699C19.8667 6.66699 19.4723 6.50588 19.1501 6.18366C18.8279 5.86144 18.6667 5.46699 18.6667 5.00033C18.6667 4.53366 18.8279 4.13921 19.1501 3.81699C19.4723 3.49477 19.8667 3.33366 20.3334 3.33366C20.8001 3.33366 21.1945 3.49477 21.5167 3.81699C21.839 4.13921 22.0001 4.53366 22.0001 5.00033C22.0001 5.46699 21.839 5.86144 21.5167 6.18366C21.1945 6.50588 20.8001 6.66699 20.3334 6.66699ZM20.3334 28.667C19.8667 28.667 19.4723 28.5059 19.1501 28.1837C18.8279 27.8614 18.6667 27.467 18.6667 27.0003C18.6667 26.5337 18.8279 26.1392 19.1501 25.817C19.4723 25.4948 19.8667 25.3337 20.3334 25.3337C20.8001 25.3337 21.1945 25.4948 21.5167 25.817C21.839 26.1392 22.0001 26.5337 22.0001 27.0003C22.0001 27.467 21.839 27.8614 21.5167 28.1837C21.1945 28.5059 20.8001 28.667 20.3334 28.667ZM25.6667 11.3337C25.2001 11.3337 24.8056 11.1725 24.4834 10.8503C24.1612 10.5281 24.0001 10.1337 24.0001 9.66699C24.0001 9.20033 24.1612 8.80588 24.4834 8.48366C24.8056 8.16144 25.2001 8.00033 25.6667 8.00033C26.1334 8.00033 26.5279 8.16144 26.8501 8.48366C27.1723 8.80588 27.3334 9.20033 27.3334 9.66699C27.3334 10.1337 27.1723 10.5281 26.8501 10.8503C26.5279 11.1725 26.1334 11.3337 25.6667 11.3337ZM25.6667 24.0003C25.2001 24.0003 24.8056 23.8392 24.4834 23.517C24.1612 23.1948 24.0001 22.8003 24.0001 22.3337C24.0001 21.867 24.1612 21.4725 24.4834 21.1503C24.8056 20.8281 25.2001 20.667 25.6667 20.667C26.1334 20.667 26.5279 20.8281 26.8501 21.1503C27.1723 21.4725 27.3334 21.867 27.3334 22.3337C27.3334 22.8003 27.1723 23.1948 26.8501 23.517C26.5279 23.8392 26.1334 24.0003 25.6667 24.0003ZM27.6667 17.667C27.2001 17.667 26.8056 17.5059 26.4834 17.1837C26.1612 16.8614 26.0001 16.467 26.0001 16.0003C26.0001 15.5337 26.1612 15.1392 26.4834 14.817C26.8056 14.4948 27.2001 14.3337 27.6667 14.3337C28.1334 14.3337 28.5279 14.4948 28.8501 14.817C29.1723 15.1392 29.3334 15.5337 29.3334 16.0003C29.3334 16.467 29.1723 16.8614 28.8501 17.1837C28.5279 17.5059 28.1334 17.667 27.6667 17.667ZM16.0001 29.3337C14.1556 29.3337 12.4223 28.9837 10.8001 28.2837C9.17786 27.5837 7.76675 26.6337 6.56675 25.4337C5.36675 24.2337 4.41675 22.8225 3.71675 21.2003C3.01675 19.5781 2.66675 17.8448 2.66675 16.0003C2.66675 14.1559 3.01675 12.4225 3.71675 10.8003C4.41675 9.1781 5.36675 7.76699 6.56675 6.56699C7.76675 5.36699 9.17786 4.41699 10.8001 3.71699C12.4223 3.01699 14.1556 2.66699 16.0001 2.66699V5.33366C13.0223 5.33366 10.5001 6.36699 8.43341 8.43366C6.36675 10.5003 5.33341 13.0225 5.33341 16.0003C5.33341 18.9781 6.36675 21.5003 8.43341 23.567C10.5001 25.6337 13.0223 26.667 16.0001 26.667V29.3337ZM16.0001 18.667C15.2667 18.667 14.639 18.4059 14.1167 17.8837C13.5945 17.3614 13.3334 16.7337 13.3334 16.0003C13.3334 15.8892 13.339 15.7725 13.3501 15.6503C13.3612 15.5281 13.389 15.4114 13.4334 15.3003L10.6667 12.5337L12.5334 10.667L15.3001 13.4337C15.389 13.4114 15.6223 13.3781 16.0001 13.3337C16.7334 13.3337 17.3612 13.5948 17.8834 14.117C18.4056 14.6392 18.6667 15.267 18.6667 16.0003C18.6667 16.7337 18.4056 17.3614 17.8834 17.8837C17.3612 18.4059 16.7334 18.667 16.0001 18.667Z",
    fill: "#BDCAC0"
  }))));
};
var ForwardRef$2c = /*#__PURE__*/forwardRef(SvgAvgPace);
var _rect$$, _g$1W;
var _excluded$2c = ["title", "titleId"];
function _extends$2c() {
  return _extends$2c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2c.apply(null, arguments);
}
function _objectWithoutProperties$2b(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2c(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2c(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBadge = function SvgBadge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2b(_ref, _excluded$2c);
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "badge"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2705_12535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$$ || (_rect$$ = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1W || (_g$1W = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2705_12535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "badge_2",
    d: "M6 18.5H12V18.05C12 17.7667 11.9208 17.5042 11.7625 17.2625C11.6042 17.0208 11.3833 16.8333 11.1 16.7C10.7667 16.55 10.4292 16.4375 10.0875 16.3625C9.74583 16.2875 9.38333 16.25 9 16.25C8.61667 16.25 8.25417 16.2875 7.9125 16.3625C7.57083 16.4375 7.23333 16.55 6.9 16.7C6.61667 16.8333 6.39583 17.0208 6.2375 17.2625C6.07917 17.5042 6 17.7667 6 18.05V18.5ZM14.75 17H17.25C17.4667 17 17.6458 16.9292 17.7875 16.7875C17.9292 16.6458 18 16.4667 18 16.25C18 16.0333 17.9292 15.8542 17.7875 15.7125C17.6458 15.5708 17.4667 15.5 17.25 15.5H14.75C14.5333 15.5 14.3542 15.5708 14.2125 15.7125C14.0708 15.8542 14 16.0333 14 16.25C14 16.4667 14.0708 16.6458 14.2125 16.7875C14.3542 16.9292 14.5333 17 14.75 17ZM9 15.5C9.41667 15.5 9.77083 15.3542 10.0625 15.0625C10.3542 14.7708 10.5 14.4167 10.5 14C10.5 13.5833 10.3542 13.2292 10.0625 12.9375C9.77083 12.6458 9.41667 12.5 9 12.5C8.58333 12.5 8.22917 12.6458 7.9375 12.9375C7.64583 13.2292 7.5 13.5833 7.5 14C7.5 14.4167 7.64583 14.7708 7.9375 15.0625C8.22917 15.3542 8.58333 15.5 9 15.5ZM14.75 14H17.25C17.4667 14 17.6458 13.9292 17.7875 13.7875C17.9292 13.6458 18 13.4667 18 13.25C18 13.0333 17.9292 12.8542 17.7875 12.7125C17.6458 12.5708 17.4667 12.5 17.25 12.5H14.75C14.5333 12.5 14.3542 12.5708 14.2125 12.7125C14.0708 12.8542 14 13.0333 14 13.25C14 13.4667 14.0708 13.6458 14.2125 13.7875C14.3542 13.9292 14.5333 14 14.75 14ZM4 22.5C3.45 22.5 2.97917 22.3042 2.5875 21.9125C2.19583 21.5208 2 21.05 2 20.5V9.5C2 8.95 2.19583 8.47917 2.5875 8.0875C2.97917 7.69583 3.45 7.5 4 7.5H9V4.5C9 3.95 9.19583 3.47917 9.5875 3.0875C9.97917 2.69583 10.45 2.5 11 2.5H13C13.55 2.5 14.0208 2.69583 14.4125 3.0875C14.8042 3.47917 15 3.95 15 4.5V7.5H20C20.55 7.5 21.0208 7.69583 21.4125 8.0875C21.8042 8.47917 22 8.95 22 9.5V20.5C22 21.05 21.8042 21.5208 21.4125 21.9125C21.0208 22.3042 20.55 22.5 20 22.5H4ZM4 20.5H20V9.5H15C15 10.05 14.8042 10.5208 14.4125 10.9125C14.0208 11.3042 13.55 11.5 13 11.5H11C10.45 11.5 9.97917 11.3042 9.5875 10.9125C9.19583 10.5208 9 10.05 9 9.5H4V20.5ZM11 9.5H13V4.5H11V9.5Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$2b = /*#__PURE__*/forwardRef(SvgBadge);
var _g$1V, _defs$H;
var _excluded$2b = ["title", "titleId"];
function _extends$2b() {
  return _extends$2b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2b.apply(null, arguments);
}
function _objectWithoutProperties$2a(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2b(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2b(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBookOpenText = function SvgBookOpenText(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2a(_ref, _excluded$2b);
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1V || (_g$1V = /*#__PURE__*/React.createElement("g", {
    id: "BookOpenText",
    clipPath: "url(#clip0_55728_437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 11C16 9.93913 16.4214 8.92172 17.1716 8.17157C17.9217 7.42143 18.9391 7 20 7H29V25H20C18.9391 25 17.9217 25.4214 17.1716 26.1716C16.4214 26.9217 16 27.9391 16 29",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 25H12C13.0609 25 14.0783 25.4214 14.8284 26.1716C15.5786 26.9217 16 27.9391 16 29V11C16 9.93913 15.5786 8.92172 14.8284 8.17157C14.0783 7.42143 13.0609 7 12 7H3V25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 12H25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20 16H25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 20H25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$H || (_defs$H = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55728_437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef$2a = /*#__PURE__*/forwardRef(SvgBookOpenText);
var _g$1U, _defs$G;
var _excluded$2a = ["title", "titleId"];
function _extends$2a() {
  return _extends$2a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2a.apply(null, arguments);
}
function _objectWithoutProperties$29(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2a(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2a(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBookmarks = function SvgBookmarks(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$29(_ref, _excluded$2a);
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1U || (_g$1U = /*#__PURE__*/React.createElement("g", {
    id: "Bookmarks",
    clipPath: "url(#clip0_2024_15402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 28L14 23L7 28V9C7 8.73478 7.10536 8.48043 7.29289 8.29289C7.48043 8.10536 7.73478 8 8 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V28Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 8V5C11 4.73478 11.1054 4.48043 11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4H24C24.2652 4 24.5196 4.10536 24.7071 4.29289C24.8946 4.48043 25 4.73478 25 5V24L21 21.1437",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$G || (_defs$G = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2024_15402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef$29 = /*#__PURE__*/forwardRef(SvgBookmarks);
var _g$1T, _defs$F;
var _excluded$29 = ["title", "titleId"];
function _extends$29() {
  return _extends$29 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$29.apply(null, arguments);
}
function _objectWithoutProperties$28(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$29(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$29(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBroom = function SvgBroom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$28(_ref, _excluded$29);
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1T || (_g$1T = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57832_3672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C9.16248 19.807 8.21511 18.239 7.78125 16.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.25C18 17.2191 19.2478 19.7813 21.75 21H5.71875C3.97243 19.1871 2.99776 16.7672 3 14.25C3 11.6053 4.05282 9.47906 5.76282 7.72125C5.86653 7.61606 5.999 7.54385 6.1436 7.51366C6.2882 7.48347 6.43849 7.49666 6.57563 7.55156L8.955 8.51531C9.13852 8.58857 9.33469 8.62484 9.53226 8.62205C9.72984 8.61926 9.92491 8.57747 10.1063 8.49906C10.2877 8.42066 10.4518 8.3072 10.5891 8.16519C10.7265 8.02318 10.8345 7.85543 10.9069 7.67156L12.8756 2.6925C13.2647 1.755 14.3259 1.25625 15.2784 1.61156C15.5147 1.69937 15.7308 1.83391 15.9139 2.00713C16.097 2.18035 16.2432 2.38871 16.344 2.61974C16.4447 2.85078 16.4978 3.09975 16.5001 3.35177C16.5025 3.6038 16.4539 3.85371 16.3575 4.08656L14.3559 9.06469C14.2094 9.43384 14.2152 9.84604 14.3722 10.2109C14.5291 10.5757 14.8243 10.8635 15.1931 11.0109L17.5313 11.9334C17.67 11.9895 17.7887 12.0859 17.8722 12.21C17.9558 12.3341 18.0003 12.4804 18 12.63V14.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11841 9.89719L18.075 15.48",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$F || (_defs$F = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57832_3672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$28 = /*#__PURE__*/forwardRef(SvgBroom);
var _path$l, _path2$7, _path3$5, _path4$4, _path5$2, _path6$2, _path7$1;
var _excluded$28 = ["title", "titleId"];
function _extends$28() {
  return _extends$28 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$28.apply(null, arguments);
}
function _objectWithoutProperties$27(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$28(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$28(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBuildings = function SvgBuildings(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$27(_ref, _excluded$28);
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.9999V1.99989C15.9999 1.81891 15.9507 1.64135 15.8576 1.48615C15.7645 1.33094 15.631 1.20391 15.4714 1.11859C15.3118 1.03327 15.1321 0.992861 14.9513 1.00168C14.7705 1.01049 14.5955 1.06819 14.445 1.16864L4.445 7.83489C4.30784 7.9264 4.19543 8.05041 4.11779 8.19588C4.04015 8.34134 3.99969 8.50375 4 8.66864V24.9999",
    stroke: "#3A205C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9H25C25.2652 9 25.5196 9.10536 25.7071 9.29289C25.8946 9.48043 26 9.73478 26 10V25",
    stroke: "#3A205C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 25H29",
    stroke: "#3A205C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V14",
    stroke: "#3A205C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5$2 || (_path5$2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12V14",
    stroke: "#3A205C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6$2 || (_path6$2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19V21",
    stroke: "#3A205C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7$1 || (_path7$1 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19V21",
    stroke: "#3A205C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef$27 = /*#__PURE__*/forwardRef(SvgBuildings);
var _rect$_, _g$1S;
var _excluded$27 = ["title", "titleId"];
function _extends$27() {
  return _extends$27 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$27.apply(null, arguments);
}
function _objectWithoutProperties$26(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$27(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$27(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCalendarAddOn = function SvgCalendarAddOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$26(_ref, _excluded$27);
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_295_3355",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$_ || (_rect$_ = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1S || (_g$1S = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_295_3355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 22.5V19.5H14V17.5H17V14.5H19V17.5H22V19.5H19V22.5H17ZM5 20.5C4.45 20.5 3.97917 20.3042 3.5875 19.9125C3.19583 19.5208 3 19.05 3 18.5V6.5C3 5.95 3.19583 5.47917 3.5875 5.0875C3.97917 4.69583 4.45 4.5 5 4.5H6V2.5H8V4.5H14V2.5H16V4.5H17C17.55 4.5 18.0208 4.69583 18.4125 5.0875C18.8042 5.47917 19 5.95 19 6.5V12.6C18.6667 12.55 18.3333 12.525 18 12.525C17.6667 12.525 17.3333 12.55 17 12.6V10.5H5V18.5H12C12 18.8333 12.025 19.1667 12.075 19.5C12.125 19.8333 12.2167 20.1667 12.35 20.5H5ZM5 8.5H17V6.5H5V8.5Z",
    fill: "#1C1B1F"
  }))));
};
var ForwardRef$26 = /*#__PURE__*/forwardRef(SvgCalendarAddOn);
var _rect$Z, _g$1R;
var _excluded$26 = ["title", "titleId"];
function _extends$26() {
  return _extends$26 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$26.apply(null, arguments);
}
function _objectWithoutProperties$25(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$26(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$26(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCalendarClock = function SvgCalendarClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$25(_ref, _excluded$26);
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "calendar_clock"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55892_27587",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$Z || (_rect$Z = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1R || (_g$1R = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55892_27587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_clock_2",
    d: "M5 8H19V6H5V8ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V11.675C20.6833 11.525 20.3583 11.4 20.025 11.3C19.6917 11.2 19.35 11.125 19 11.075V10H5V20H11.3C11.4167 20.3667 11.5542 20.7167 11.7125 21.05C11.8708 21.3833 12.0583 21.7 12.275 22H5ZM18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23ZM19.675 20.375L20.375 19.675L18.5 17.8V15H17.5V18.2L19.675 20.375Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$25 = /*#__PURE__*/forwardRef(SvgCalendarClock);
var _g$1Q, _defs$E;
var _excluded$25 = ["title", "titleId"];
function _extends$25() {
  return _extends$25 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$25.apply(null, arguments);
}
function _objectWithoutProperties$24(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$25(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$25(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCalendarDots = function SvgCalendarDots(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$24(_ref, _excluded$25);
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1Q || (_g$1Q = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55972_27551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 5H6C5.44772 5 5 5.44772 5 6V26C5 26.5523 5.44772 27 6 27H26C26.5523 27 27 26.5523 27 26V6C27 5.44772 26.5523 5 26 5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3V7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3V7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11H27",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.75C16.6904 17.75 17.25 17.1904 17.25 16.5C17.25 15.8096 16.6904 15.25 16 15.25C15.3096 15.25 14.75 15.8096 14.75 16.5C14.75 17.1904 15.3096 17.75 16 17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.75C22.1904 17.75 22.75 17.1904 22.75 16.5C22.75 15.8096 22.1904 15.25 21.5 15.25C20.8096 15.25 20.25 15.8096 20.25 16.5C20.25 17.1904 20.8096 17.75 21.5 17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.75C11.1904 22.75 11.75 22.1904 11.75 21.5C11.75 20.8096 11.1904 20.25 10.5 20.25C9.80964 20.25 9.25 20.8096 9.25 21.5C9.25 22.1904 9.80964 22.75 10.5 22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.75C16.6904 22.75 17.25 22.1904 17.25 21.5C17.25 20.8096 16.6904 20.25 16 20.25C15.3096 20.25 14.75 20.8096 14.75 21.5C14.75 22.1904 15.3096 22.75 16 22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.75C22.1904 22.75 22.75 22.1904 22.75 21.5C22.75 20.8096 22.1904 20.25 21.5 20.25C20.8096 20.25 20.25 20.8096 20.25 21.5C20.25 22.1904 20.8096 22.75 21.5 22.75Z"
  }))), _defs$E || (_defs$E = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55972_27551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef$24 = /*#__PURE__*/forwardRef(SvgCalendarDots);
var _rect$Y, _g$1P;
var _excluded$24 = ["title", "titleId"];
function _extends$24() {
  return _extends$24 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$24.apply(null, arguments);
}
function _objectWithoutProperties$23(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$24(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$24(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCalendarMonth = function SvgCalendarMonth(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$23(_ref, _excluded$24);
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "calendar_month"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55892_27588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$Y || (_rect$Y = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1P || (_g$1P = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55892_27588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_month_2",
    d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8ZM12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$23 = /*#__PURE__*/forwardRef(SvgCalendarMonth);
var _g$1O;
var _excluded$23 = ["title", "titleId"];
function _extends$23() {
  return _extends$23 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$23.apply(null, arguments);
}
function _objectWithoutProperties$22(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$23(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$23(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCancel = function SvgCancel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$22(_ref, _excluded$23);
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1O || (_g$1O = /*#__PURE__*/React.createElement("g", {
    id: "Icons/cancel_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z",
    fill: "black"
  }))));
};
var ForwardRef$22 = /*#__PURE__*/forwardRef(SvgCancel);
var _rect$X, _g$1N;
var _excluded$22 = ["title", "titleId"];
function _extends$22() {
  return _extends$22 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$22.apply(null, arguments);
}
function _objectWithoutProperties$21(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$22(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$22(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCategory = function SvgCategory(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$21(_ref, _excluded$22);
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "category"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2705_18266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$X || (_rect$X = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1N || (_g$1N = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2705_18266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "category_2",
    d: "M7.425 9.97505L11.15 3.90005C11.25 3.73338 11.375 3.61255 11.525 3.53755C11.675 3.46255 11.8333 3.42505 12 3.42505C12.1667 3.42505 12.325 3.46255 12.475 3.53755C12.625 3.61255 12.75 3.73338 12.85 3.90005L16.575 9.97505C16.675 10.1417 16.725 10.3167 16.725 10.5C16.725 10.6834 16.6833 10.85 16.6 11C16.5167 11.15 16.4 11.2709 16.25 11.3625C16.1 11.4542 15.925 11.5 15.725 11.5H8.275C8.075 11.5 7.9 11.4542 7.75 11.3625C7.6 11.2709 7.48333 11.15 7.4 11C7.31667 10.85 7.275 10.6834 7.275 10.5C7.275 10.3167 7.325 10.1417 7.425 9.97505ZM17.5 22.5C16.25 22.5 15.1875 22.0625 14.3125 21.1875C13.4375 20.3125 13 19.25 13 18C13 16.75 13.4375 15.6875 14.3125 14.8125C15.1875 13.9375 16.25 13.5 17.5 13.5C18.75 13.5 19.8125 13.9375 20.6875 14.8125C21.5625 15.6875 22 16.75 22 18C22 19.25 21.5625 20.3125 20.6875 21.1875C19.8125 22.0625 18.75 22.5 17.5 22.5ZM3 21V15C3 14.7167 3.09583 14.4792 3.2875 14.2875C3.47917 14.0959 3.71667 14 4 14H10C10.2833 14 10.5208 14.0959 10.7125 14.2875C10.9042 14.4792 11 14.7167 11 15V21C11 21.2834 10.9042 21.5209 10.7125 21.7125C10.5208 21.9042 10.2833 22 10 22H4C3.71667 22 3.47917 21.9042 3.2875 21.7125C3.09583 21.5209 3 21.2834 3 21ZM17.5 20.5C18.2 20.5 18.7917 20.2584 19.275 19.775C19.7583 19.2917 20 18.7 20 18C20 17.3 19.7583 16.7084 19.275 16.225C18.7917 15.7417 18.2 15.5 17.5 15.5C16.8 15.5 16.2083 15.7417 15.725 16.225C15.2417 16.7084 15 17.3 15 18C15 18.7 15.2417 19.2917 15.725 19.775C16.2083 20.2584 16.8 20.5 17.5 20.5ZM5 20H9V16H5V20ZM10.05 9.50005H13.95L12 6.35005L10.05 9.50005Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$21 = /*#__PURE__*/forwardRef(SvgCategory);
var _g$1M;
var _excluded$21 = ["title", "titleId"];
function _extends$21() {
  return _extends$21 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$21.apply(null, arguments);
}
function _objectWithoutProperties$20(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$21(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$21(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$20(_ref, _excluded$21);
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1M || (_g$1M = /*#__PURE__*/React.createElement("g", {
    id: "Icons/check_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M9.00003 16.17L4.83003 12L3.41003 13.41L9.00003 19L21 7.00003L19.59 5.59003L9.00003 16.17Z",
    fill: "black"
  }))));
};
var ForwardRef$20 = /*#__PURE__*/forwardRef(SvgCheck);
var _path$k;
var _excluded$20 = ["title", "titleId"];
function _extends$20() {
  return _extends$20 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$20.apply(null, arguments);
}
function _objectWithoutProperties$1$(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$20(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$20(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCheckBox = function SvgCheckBox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1$(_ref, _excluded$20);
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17.99 9L16.58 7.58L9.99 14.17L7.41 11.6L5.99 13.01L9.99 17L17.99 9Z",
    fill: "#171D19"
  })));
};
var ForwardRef$1$ = /*#__PURE__*/forwardRef(SvgCheckBox);
var _path$j;
var _excluded$1$ = ["title", "titleId"];
function _extends$1$() {
  return _extends$1$ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1$.apply(null, arguments);
}
function _objectWithoutProperties$1_(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1$(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1$(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgChevronDown = function SvgChevronDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1_(_ref, _excluded$1$);
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z",
    fill: "#1C1B1F"
  })));
};
var ForwardRef$1_ = /*#__PURE__*/forwardRef(SvgChevronDown);
var _rect$W, _g$1L;
var _excluded$1_ = ["title", "titleId"];
function _extends$1_() {
  return _extends$1_ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1_.apply(null, arguments);
}
function _objectWithoutProperties$1Z(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1_(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1_(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgChevronUp = function SvgChevronUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1Z(_ref, _excluded$1_);
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Chevron_Up"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55141_28942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$W || (_rect$W = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1L || (_g$1L = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55141_28942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_less",
    d: "M7.4 15.375L6 13.975L12 7.97501L18 13.975L16.6 15.375L12 10.775L7.4 15.375Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$1Z = /*#__PURE__*/forwardRef(SvgChevronUp);
var _g$1K, _defs$D;
var _excluded$1Z = ["title", "titleId"];
function _extends$1Z() {
  return _extends$1Z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1Z.apply(null, arguments);
}
function _objectWithoutProperties$1Y(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1Z(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1Z(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgClockUser = function SvgClockUser(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1Y(_ref, _excluded$1Z);
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1K || (_g$1K = /*#__PURE__*/React.createElement("g", {
    id: "ClockUser",
    clipPath: "url(#clip0_1026_28303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.7212 14.417L18.0671 17.744V9.98102",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.0673 31.0521C15.4352 31.0521 12.8623 30.2716 10.6738 28.8093C8.48527 27.347 6.77955 25.2686 5.7723 22.8368C4.76504 20.4051 4.5015 17.7293 5.01499 15.1478C5.52849 12.5663 6.79595 10.195 8.65711 8.33387C10.5183 6.47271 12.8895 5.20524 15.471 4.69175C18.0525 4.17826 20.7283 4.4418 23.1601 5.44905C25.5918 6.45631 27.6702 8.16203 29.1325 10.3505C30.5948 12.539 31.3753 15.112 31.3753 17.7441",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.9393 27.7251C28.7768 27.7251 30.2663 26.2355 30.2663 24.3981C30.2663 22.5606 28.7768 21.071 26.9393 21.071C25.1019 21.071 23.6123 22.5606 23.6123 24.3981C23.6123 26.2355 25.1019 27.7251 26.9393 27.7251Z",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.5032 31.052C23.0119 29.139 24.8044 27.725 26.9392 27.725C29.074 27.725 30.8664 29.139 31.3752 31.052",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$D || (_defs$D = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_28303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.4881,
    height: 35.4881,
    fill: "white",
    transform: "translate(0.323242)"
  })))));
};
var ForwardRef$1Y = /*#__PURE__*/forwardRef(SvgClockUser);
var _g$1J;
var _excluded$1Y = ["title", "titleId"];
function _extends$1Y() {
  return _extends$1Y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1Y.apply(null, arguments);
}
function _objectWithoutProperties$1X(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1Y(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1Y(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgClose = function SvgClose(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1X(_ref, _excluded$1Y);
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1J || (_g$1J = /*#__PURE__*/React.createElement("g", {
    id: "Icons/close_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
    fill: "black"
  }))));
};
var ForwardRef$1X = /*#__PURE__*/forwardRef(SvgClose);
var _rect$V, _g$1I;
var _excluded$1X = ["title", "titleId"];
function _extends$1X() {
  return _extends$1X = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1X.apply(null, arguments);
}
function _objectWithoutProperties$1W(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1X(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1X(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgColors = function SvgColors(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1W(_ref, _excluded$1X);
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55869_27553",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$V || (_rect$V = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1I || (_g$1I = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55869_27553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.65 20.5L2.5 14.35C2.33333 14.1833 2.20833 14 2.125 13.8C2.04167 13.6 2 13.3917 2 13.175C2 12.9583 2.04167 12.75 2.125 12.55C2.20833 12.35 2.33333 12.1667 2.5 12L8.25 6.275L5.6 3.625L7.15 2L17.15 12C17.3167 12.1667 17.4375 12.35 17.5125 12.55C17.5875 12.75 17.625 12.9583 17.625 13.175C17.625 13.3917 17.5875 13.6 17.5125 13.8C17.4375 14 17.3167 14.1833 17.15 14.35L11 20.5C10.8333 20.6667 10.65 20.7917 10.45 20.875C10.25 20.9583 10.0417 21 9.825 21C9.60833 21 9.4 20.9583 9.2 20.875C9 20.7917 8.81667 20.6667 8.65 20.5ZM9.825 7.85L4.475 13.2H15.175L9.825 7.85ZM19.8 21C19.2 21 18.6917 20.7875 18.275 20.3625C17.8583 19.9375 17.65 19.4167 17.65 18.8C17.65 18.35 17.7625 17.925 17.9875 17.525C18.2125 17.125 18.4667 16.7333 18.75 16.35L19.8 15L20.9 16.35C21.1667 16.7333 21.4167 17.125 21.65 17.525C21.8833 17.925 22 18.35 22 18.8C22 19.4167 21.7833 19.9375 21.35 20.3625C20.9167 20.7875 20.4 21 19.8 21Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$1W = /*#__PURE__*/forwardRef(SvgColors);
var _rect$U, _g$1H;
var _excluded$1W = ["title", "titleId"];
function _extends$1W() {
  return _extends$1W = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1W.apply(null, arguments);
}
function _objectWithoutProperties$1V(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1W(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1W(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgContentCopy = function SvgContentCopy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1V(_ref, _excluded$1W);
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "content_copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55809_225",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$U || (_rect$U = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1H || (_g$1H = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55809_225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "content_copy_2",
    d: "M9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$1V = /*#__PURE__*/forwardRef(SvgContentCopy);
var _g$1G;
var _excluded$1V = ["title", "titleId"];
function _extends$1V() {
  return _extends$1V = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1V.apply(null, arguments);
}
function _objectWithoutProperties$1U(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1V(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1V(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgContentCut = function SvgContentCut(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1U(_ref, _excluded$1V);
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1G || (_g$1G = /*#__PURE__*/React.createElement("g", {
    id: "Icons/content_cut_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64 7.64C9.87 7.14 10 6.59 10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6C2 8.21 3.79 10 6 10C6.59 10 7.14 9.87 7.64 9.64L10 12L7.64 14.36C7.14 14.13 6.59 14 6 14C3.79 14 2 15.79 2 18C2 20.21 3.79 22 6 22C8.21 22 10 20.21 10 18C10 17.41 9.87 16.86 9.64 16.36L12 14L19 21H22V20L9.64 7.64ZM6 8C4.9 8 4 7.11 4 6C4 4.89 4.9 4 6 4C7.1 4 8 4.89 8 6C8 7.11 7.1 8 6 8ZM4 18C4 19.11 4.9 20 6 20C7.1 20 8 19.11 8 18C8 16.89 7.1 16 6 16C4.9 16 4 16.89 4 18ZM12 12.5C11.72 12.5 11.5 12.28 11.5 12C11.5 11.72 11.72 11.5 12 11.5C12.28 11.5 12.5 11.72 12.5 12C12.5 12.28 12.28 12.5 12 12.5ZM13 9L19 3H22V4L15 11L13 9Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$1U = /*#__PURE__*/forwardRef(SvgContentCut);
var _path$i;
var _excluded$1U = ["title", "titleId"];
function _extends$1U() {
  return _extends$1U = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1U.apply(null, arguments);
}
function _objectWithoutProperties$1T(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1U(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1U(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgDelete = function SvgDelete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1T(_ref, _excluded$1U);
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3V4H20V6H19V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V6H4V4H9V3H15ZM7 19H17V6H7V19ZM9 8H11V17H9V8ZM15 8H13V17H15V8Z",
    fill: "black"
  })));
};
var ForwardRef$1T = /*#__PURE__*/forwardRef(SvgDelete);
var _rect$T, _g$1F;
var _excluded$1T = ["title", "titleId"];
function _extends$1T() {
  return _extends$1T = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1T.apply(null, arguments);
}
function _objectWithoutProperties$1S(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1T(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1T(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgDependent = function SvgDependent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1S(_ref, _excluded$1T);
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Dependent"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55892_27556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$T || (_rect$T = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1F || (_g$1F = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55892_27556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "escalator_warning",
    d: "M6.5 6C5.95 6 5.47917 5.80417 5.0875 5.4125C4.69583 5.02083 4.5 4.55 4.5 4C4.5 3.45 4.69583 2.97917 5.0875 2.5875C5.47917 2.19583 5.95 2 6.5 2C7.05 2 7.52083 2.19583 7.9125 2.5875C8.30417 2.97917 8.5 3.45 8.5 4C8.5 4.55 8.30417 5.02083 7.9125 5.4125C7.52083 5.80417 7.05 6 6.5 6ZM17 11C16.5833 11 16.2292 10.8542 15.9375 10.5625C15.6458 10.2708 15.5 9.91667 15.5 9.5C15.5 9.08333 15.6458 8.72917 15.9375 8.4375C16.2292 8.14583 16.5833 8 17 8C17.4167 8 17.7708 8.14583 18.0625 8.4375C18.3542 8.72917 18.5 9.08333 18.5 9.5C18.5 9.91667 18.3542 10.2708 18.0625 10.5625C17.7708 10.8542 17.4167 11 17 11ZM4.5 22V15H3V9C3 8.45 3.19583 7.97917 3.5875 7.5875C3.97917 7.19583 4.45 7 5 7H8C8.36667 7 8.7 7.0875 9 7.2625C9.3 7.4375 9.54167 7.68333 9.725 8L13.3 14.175L14.325 12.65C14.4583 12.45 14.6375 12.2917 14.8625 12.175C15.0875 12.0583 15.325 12 15.575 12H18.5C18.9167 12 19.2708 12.1458 19.5625 12.4375C19.8542 12.7292 20 13.0833 20 13.5V17H19V22H15V14.9L14.225 16H12.025L9.5 11.6V22H4.5Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1S = /*#__PURE__*/forwardRef(SvgDependent);
var _rect$S, _g$1E;
var _excluded$1S = ["title", "titleId"];
function _extends$1S() {
  return _extends$1S = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1S.apply(null, arguments);
}
function _objectWithoutProperties$1R(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1S(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1S(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgDescription = function SvgDescription(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1R(_ref, _excluded$1S);
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1015_2441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$S || (_rect$S = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1E || (_g$1E = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1015_2441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z",
    fill: "black"
  }))));
};
var ForwardRef$1R = /*#__PURE__*/forwardRef(SvgDescription);
var _rect$R, _g$1D;
var _excluded$1R = ["title", "titleId"];
function _extends$1R() {
  return _extends$1R = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1R.apply(null, arguments);
}
function _objectWithoutProperties$1Q(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1R(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1R(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgDoNotDisturbOn = function SvgDoNotDisturbOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1Q(_ref, _excluded$1R);
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "do_not_disturb_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56273_2409",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$R || (_rect$R = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1D || (_g$1D = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56273_2409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "do_not_disturb_on_2",
    d: "M8 13H16C16.2833 13 16.5208 12.9042 16.7125 12.7125C16.9042 12.5208 17 12.2833 17 12C17 11.7167 16.9042 11.4792 16.7125 11.2875C16.5208 11.0958 16.2833 11 16 11H8C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$1Q = /*#__PURE__*/forwardRef(SvgDoNotDisturbOn);
var _rect$Q, _g$1C;
var _excluded$1Q = ["title", "titleId"];
function _extends$1Q() {
  return _extends$1Q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1Q.apply(null, arguments);
}
function _objectWithoutProperties$1P(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1Q(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1Q(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgDragIndicator = function SvgDragIndicator(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1P(_ref, _excluded$1Q);
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4075_55636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$Q || (_rect$Q = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1C || (_g$1C = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4075_55636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 20C8.45 20 7.97917 19.8042 7.5875 19.4125C7.19583 19.0208 7 18.55 7 18C7 17.45 7.19583 16.9792 7.5875 16.5875C7.97917 16.1958 8.45 16 9 16C9.55 16 10.0208 16.1958 10.4125 16.5875C10.8042 16.9792 11 17.45 11 18C11 18.55 10.8042 19.0208 10.4125 19.4125C10.0208 19.8042 9.55 20 9 20ZM15 20C14.45 20 13.9792 19.8042 13.5875 19.4125C13.1958 19.0208 13 18.55 13 18C13 17.45 13.1958 16.9792 13.5875 16.5875C13.9792 16.1958 14.45 16 15 16C15.55 16 16.0208 16.1958 16.4125 16.5875C16.8042 16.9792 17 17.45 17 18C17 18.55 16.8042 19.0208 16.4125 19.4125C16.0208 19.8042 15.55 20 15 20ZM9 14C8.45 14 7.97917 13.8042 7.5875 13.4125C7.19583 13.0208 7 12.55 7 12C7 11.45 7.19583 10.9792 7.5875 10.5875C7.97917 10.1958 8.45 10 9 10C9.55 10 10.0208 10.1958 10.4125 10.5875C10.8042 10.9792 11 11.45 11 12C11 12.55 10.8042 13.0208 10.4125 13.4125C10.0208 13.8042 9.55 14 9 14ZM15 14C14.45 14 13.9792 13.8042 13.5875 13.4125C13.1958 13.0208 13 12.55 13 12C13 11.45 13.1958 10.9792 13.5875 10.5875C13.9792 10.1958 14.45 10 15 10C15.55 10 16.0208 10.1958 16.4125 10.5875C16.8042 10.9792 17 11.45 17 12C17 12.55 16.8042 13.0208 16.4125 13.4125C16.0208 13.8042 15.55 14 15 14ZM9 8C8.45 8 7.97917 7.80417 7.5875 7.4125C7.19583 7.02083 7 6.55 7 6C7 5.45 7.19583 4.97917 7.5875 4.5875C7.97917 4.19583 8.45 4 9 4C9.55 4 10.0208 4.19583 10.4125 4.5875C10.8042 4.97917 11 5.45 11 6C11 6.55 10.8042 7.02083 10.4125 7.4125C10.0208 7.80417 9.55 8 9 8ZM15 8C14.45 8 13.9792 7.80417 13.5875 7.4125C13.1958 7.02083 13 6.55 13 6C13 5.45 13.1958 4.97917 13.5875 4.5875C13.9792 4.19583 14.45 4 15 4C15.55 4 16.0208 4.19583 16.4125 4.5875C16.8042 4.97917 17 5.45 17 6C17 6.55 16.8042 7.02083 16.4125 7.4125C16.0208 7.80417 15.55 8 15 8Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1P = /*#__PURE__*/forwardRef(SvgDragIndicator);
var _rect$P, _g$1B;
var _excluded$1P = ["title", "titleId"];
function _extends$1P() {
  return _extends$1P = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1P.apply(null, arguments);
}
function _objectWithoutProperties$1O(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1P(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1P(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgDropDown = function SvgDropDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1O(_ref, _excluded$1P);
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4075_55854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$P || (_rect$P = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1B || (_g$1B = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4075_55854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15L16 11H8L12 15ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
    fill: "#3E4A42"
  }))));
};
var ForwardRef$1O = /*#__PURE__*/forwardRef(SvgDropDown);
var _rect$O, _g$1A;
var _excluded$1O = ["title", "titleId"];
function _extends$1O() {
  return _extends$1O = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1O.apply(null, arguments);
}
function _objectWithoutProperties$1N(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1O(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1O(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgEarthquake = function SvgEarthquake(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1N(_ref, _excluded$1O);
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56403_27822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$O || (_rect$O = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1A || (_g$1A = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56403_27822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "earthquake",
    d: "M9.025 22C8.79167 22 8.5875 21.9375 8.4125 21.8125C8.2375 21.6875 8.11667 21.5167 8.05 21.3L5.5 13H2V11H6.25C6.46667 11 6.6625 11.0625 6.8375 11.1875C7.0125 11.3125 7.13333 11.4833 7.2 11.7L8.85 17.075L12.025 2.8C12.075 2.56667 12.1917 2.375 12.375 2.225C12.5583 2.075 12.7667 2 13 2C13.2333 2 13.4417 2.07083 13.625 2.2125C13.8083 2.35417 13.925 2.54167 13.975 2.775L16.15 12.175L17.55 7.7C17.6167 7.48333 17.7375 7.3125 17.9125 7.1875C18.0875 7.0625 18.2833 7 18.5 7C18.7167 7 18.9083 7.05833 19.075 7.175C19.2417 7.29167 19.3667 7.45 19.45 7.65L20.7 11H22V13H20C19.7833 13 19.5917 12.9417 19.425 12.825C19.2583 12.7083 19.1333 12.55 19.05 12.35L18.575 11.075L16.95 16.3C16.8833 16.5167 16.7583 16.6917 16.575 16.825C16.3917 16.9583 16.1833 17.0167 15.95 17C15.7167 16.9833 15.5167 16.9042 15.35 16.7625C15.1833 16.6208 15.075 16.4417 15.025 16.225L13 7.525L9.975 21.225C9.925 21.4583 9.8125 21.6417 9.6375 21.775C9.4625 21.9083 9.25833 21.9833 9.025 22Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1N = /*#__PURE__*/forwardRef(SvgEarthquake);
var _rect$N, _g$1z;
var _excluded$1N = ["title", "titleId"];
function _extends$1N() {
  return _extends$1N = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1N.apply(null, arguments);
}
function _objectWithoutProperties$1M(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1N(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1N(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgEdit = function SvgEdit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1M(_ref, _excluded$1N);
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_756_4527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$N || (_rect$N = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1z || (_g$1z = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_756_4527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99997 19H6.2615L16.4981 8.7634L15.2366 7.50188L4.99997 17.7385V19ZM4.40385 20.5C4.14777 20.5 3.93311 20.4133 3.75987 20.2401C3.58662 20.0668 3.5 19.8522 3.5 19.5961V17.8635C3.5 17.6196 3.5468 17.3871 3.6404 17.1661C3.73398 16.9451 3.86282 16.7526 4.02692 16.5885L16.6904 3.93078C16.8416 3.79343 17.0086 3.68729 17.1913 3.61237C17.374 3.53746 17.5656 3.5 17.7661 3.5C17.9666 3.5 18.1608 3.53558 18.3488 3.60675C18.5368 3.6779 18.7032 3.79103 18.848 3.94615L20.0692 5.18268C20.2243 5.32754 20.3349 5.49424 20.4009 5.68278C20.4669 5.87129 20.5 6.05981 20.5 6.24833C20.5 6.44941 20.4656 6.64131 20.3969 6.82403C20.3283 7.00676 20.219 7.17373 20.0692 7.32495L7.41147 19.973C7.24738 20.1371 7.05483 20.266 6.83383 20.3596C6.61281 20.4532 6.38037 20.5 6.1365 20.5H4.40385ZM15.8563 8.1437L15.2366 7.50188L16.4981 8.7634L15.8563 8.1437Z",
    fill: "#484646"
  }))));
};
var ForwardRef$1M = /*#__PURE__*/forwardRef(SvgEdit);
var _g$1y, _defs$C;
var _excluded$1M = ["title", "titleId"];
function _extends$1M() {
  return _extends$1M = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1M.apply(null, arguments);
}
function _objectWithoutProperties$1L(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1M(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1M(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgEquals = function SvgEquals(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1L(_ref, _excluded$1M);
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1y || (_g$1y = /*#__PURE__*/React.createElement("g", {
    id: "Equals",
    clipPath: "url(#clip0_55944_27554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 15H20.25",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.75 9H20.25",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$C || (_defs$C = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55944_27554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$1L = /*#__PURE__*/forwardRef(SvgEquals);
var _g$1x;
var _excluded$1L = ["title", "titleId"];
function _extends$1L() {
  return _extends$1L = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1L.apply(null, arguments);
}
function _objectWithoutProperties$1K(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1L(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1L(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgError = function SvgError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1K(_ref, _excluded$1L);
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1x || (_g$1x = /*#__PURE__*/React.createElement("g", {
    id: "Icons/error_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z",
    fill: "black"
  }))));
};
var ForwardRef$1K = /*#__PURE__*/forwardRef(SvgError);
var _rect$M, _g$1w;
var _excluded$1K = ["title", "titleId"];
function _extends$1K() {
  return _extends$1K = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1K.apply(null, arguments);
}
function _objectWithoutProperties$1J(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1K(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1K(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgEventRepeat = function SvgEventRepeat(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1J(_ref, _excluded$1K);
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "event_repeat"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2089_28287",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$M || (_rect$M = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1w || (_g$1w = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2089_28287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "event_repeat_2",
    d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V12H19V10H5V20H12V22H5ZM19 24C17.7833 24 16.7208 23.6208 15.8125 22.8625C14.9042 22.1042 14.3333 21.15 14.1 20H15.65C15.8667 20.7333 16.2792 21.3333 16.8875 21.8C17.4958 22.2667 18.2 22.5 19 22.5C19.9667 22.5 20.7917 22.1583 21.475 21.475C22.1583 20.7917 22.5 19.9667 22.5 19C22.5 18.0333 22.1583 17.2083 21.475 16.525C20.7917 15.8417 19.9667 15.5 19 15.5C18.5167 15.5 18.0667 15.5875 17.65 15.7625C17.2333 15.9375 16.8667 16.1833 16.55 16.5H18V18H14V14H15.5V15.425C15.95 14.9917 16.475 14.6458 17.075 14.3875C17.675 14.1292 18.3167 14 19 14C20.3833 14 21.5625 14.4875 22.5375 15.4625C23.5125 16.4375 24 17.6167 24 19C24 20.3833 23.5125 21.5625 22.5375 22.5375C21.5625 23.5125 20.3833 24 19 24ZM5 8H19V6H5V8Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$1J = /*#__PURE__*/forwardRef(SvgEventRepeat);
var _rect$L, _g$1v;
var _excluded$1J = ["title", "titleId"];
function _extends$1J() {
  return _extends$1J = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1J.apply(null, arguments);
}
function _objectWithoutProperties$1I(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1J(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1J(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgEvent = function SvgEvent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1I(_ref, _excluded$1J);
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_13084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect$L || (_rect$L = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g$1v || (_g$1v = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_13084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 11.9997C9.2 11.9997 8.80556 11.8386 8.48333 11.5163C8.16111 11.1941 8 10.7997 8 10.333C8 9.86634 8.16111 9.4719 8.48333 9.14967C8.80556 8.82745 9.2 8.66634 9.66667 8.66634C10.1333 8.66634 10.5278 8.82745 10.85 9.14967C11.1722 9.4719 11.3333 9.86634 11.3333 10.333C11.3333 10.7997 11.1722 11.1941 10.85 11.5163C10.5278 11.8386 10.1333 11.9997 9.66667 11.9997ZM3.33333 14.6663C2.96667 14.6663 2.65278 14.5358 2.39167 14.2747C2.13056 14.0136 2 13.6997 2 13.333V3.99967C2 3.63301 2.13056 3.31912 2.39167 3.05801C2.65278 2.7969 2.96667 2.66634 3.33333 2.66634H4V1.33301H5.33333V2.66634H10.6667V1.33301H12V2.66634H12.6667C13.0333 2.66634 13.3472 2.7969 13.6083 3.05801C13.8694 3.31912 14 3.63301 14 3.99967V13.333C14 13.6997 13.8694 14.0136 13.6083 14.2747C13.3472 14.5358 13.0333 14.6663 12.6667 14.6663H3.33333ZM3.33333 13.333H12.6667V6.66634H3.33333V13.333ZM3.33333 5.33301H12.6667V3.99967H3.33333V5.33301Z",
    fill: "#BDCAC0"
  }))));
};
var ForwardRef$1I = /*#__PURE__*/forwardRef(SvgEvent);
var _g$1u, _defs$B;
var _excluded$1I = ["title", "titleId"];
function _extends$1I() {
  return _extends$1I = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1I.apply(null, arguments);
}
function _objectWithoutProperties$1H(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1I(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1I(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgExcel = function SvgExcel(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1H(_ref, _excluded$1I);
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1u || (_g$1u = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55285_27455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9H19.5",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15H19.5",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.75V3.75C6 3.55109 6.07902 3.36032 6.21967 3.21967C6.36032 3.07902 6.55109 3 6.75 3H18.75C18.9489 3 19.1397 3.07902 19.2803 3.21967C19.421 3.36032 19.5 3.55109 19.5 3.75V20.25C19.5 20.4489 19.421 20.6397 19.2803 20.7803C19.1397 20.921 18.9489 21 18.75 21H6.75C6.55109 21 6.36032 20.921 6.21967 20.7803C6.07902 20.6397 6 20.4489 6 20.25V17.25",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.25V21",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3V6.75",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V16.5C3 16.9142 3.33579 17.25 3.75 17.25H13.5C13.9142 17.25 14.25 16.9142 14.25 16.5V7.5C14.25 7.08579 13.9142 6.75 13.5 6.75Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.75L10.5 14.25",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.75L6.75 14.25",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$B || (_defs$B = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55285_27455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$1H = /*#__PURE__*/forwardRef(SvgExcel);
var _g$1t, _defs$A;
var _excluded$1H = ["title", "titleId"];
function _extends$1H() {
  return _extends$1H = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1H.apply(null, arguments);
}
function _objectWithoutProperties$1G(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1H(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1H(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFaders = function SvgFaders(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1G(_ref, _excluded$1H);
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1t || (_g$1t = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55385_279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 15V27",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5V11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25V27",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 5V21",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 21H22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21V27",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5V17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17H10",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11H13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$A || (_defs$A = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55385_279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef$1G = /*#__PURE__*/forwardRef(SvgFaders);
var _rect$K, _g$1s;
var _excluded$1G = ["title", "titleId"];
function _extends$1G() {
  return _extends$1G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1G.apply(null, arguments);
}
function _objectWithoutProperties$1F(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1G(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1G(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFeaturedSeasonalAndGifts = function SvgFeaturedSeasonalAndGifts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1F(_ref, _excluded$1G);
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_13071",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect$K || (_rect$K = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g$1s || (_g$1s = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_13071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 14.667V7.33366H1.33301V3.33366H4.79967C4.74412 3.23366 4.70801 3.1281 4.69134 3.01699C4.67467 2.90588 4.66634 2.78921 4.66634 2.66699C4.66634 2.11144 4.86079 1.63921 5.24967 1.25033C5.63856 0.861437 6.11079 0.666992 6.66634 0.666992C6.9219 0.666992 7.16079 0.714214 7.38301 0.808659C7.60523 0.903103 7.81079 1.03366 7.99967 1.20033C8.18856 1.02255 8.39412 0.889214 8.61634 0.800326C8.83856 0.711437 9.07745 0.666992 9.33301 0.666992C9.88856 0.666992 10.3608 0.861437 10.7497 1.25033C11.1386 1.63921 11.333 2.11144 11.333 2.66699C11.333 2.78921 11.3219 2.9031 11.2997 3.00866C11.2775 3.11421 11.2441 3.22255 11.1997 3.33366H14.6663V7.33366H13.333V14.667H2.66634ZM9.33301 2.00033C9.14412 2.00033 8.98579 2.06421 8.85801 2.19199C8.73023 2.31977 8.66634 2.4781 8.66634 2.66699C8.66634 2.85588 8.73023 3.01421 8.85801 3.14199C8.98579 3.26977 9.14412 3.33366 9.33301 3.33366C9.5219 3.33366 9.68023 3.26977 9.80801 3.14199C9.93579 3.01421 9.99967 2.85588 9.99967 2.66699C9.99967 2.4781 9.93579 2.31977 9.80801 2.19199C9.68023 2.06421 9.5219 2.00033 9.33301 2.00033ZM5.99967 2.66699C5.99967 2.85588 6.06356 3.01421 6.19134 3.14199C6.31912 3.26977 6.47745 3.33366 6.66634 3.33366C6.85523 3.33366 7.01356 3.26977 7.14134 3.14199C7.26912 3.01421 7.33301 2.85588 7.33301 2.66699C7.33301 2.4781 7.26912 2.31977 7.14134 2.19199C7.01356 2.06421 6.85523 2.00033 6.66634 2.00033C6.47745 2.00033 6.31912 2.06421 6.19134 2.19199C6.06356 2.31977 5.99967 2.4781 5.99967 2.66699ZM2.66634 4.66699V6.00033H7.33301V4.66699H2.66634ZM7.33301 13.3337V7.33366H3.99967V13.3337H7.33301ZM8.66634 13.3337H11.9997V7.33366H8.66634V13.3337ZM13.333 6.00033V4.66699H8.66634V6.00033H13.333Z",
    fill: "#BDCAC0"
  }))));
};
var ForwardRef$1F = /*#__PURE__*/forwardRef(SvgFeaturedSeasonalAndGifts);
var _path$h, _g$1r, _defs$z;
var _excluded$1F = ["title", "titleId"];
function _extends$1F() {
  return _extends$1F = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1F.apply(null, arguments);
}
function _objectWithoutProperties$1E(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1F(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1F(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFeedbackThumb = function SvgFeedbackThumb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1E(_ref, _excluded$1F);
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    d: "M10.5333 26.6667C13.0781 27.9721 16.0054 28.3257 18.7878 27.6637C21.5702 27.0018 24.0247 25.3678 25.709 23.0563C27.3932 20.7447 28.1965 17.9076 27.9741 15.0562C27.7516 12.2048 26.5181 9.52664 24.4957 7.50427C22.4733 5.4819 19.7951 4.24835 16.9437 4.0259C14.0923 3.80345 11.2553 4.60674 8.94372 6.29101C6.63218 7.97527 4.99821 10.4298 4.33626 13.2122C3.6743 15.9946 4.02788 18.9219 5.33329 21.4667L2.66663 29.3333L10.5333 26.6667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g$1r || (_g$1r = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57353_14156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 15.3333L15.3334 9.33334C15.8638 9.33334 16.3725 9.54406 16.7476 9.91913C17.1227 10.2942 17.3334 10.8029 17.3334 11.3333V14H21.1067C21.3 13.9978 21.4914 14.0377 21.6678 14.1168C21.8441 14.196 22.0011 14.3125 22.1279 14.4584C22.2548 14.6042 22.3484 14.7759 22.4023 14.9615C22.4562 15.1471 22.469 15.3422 22.44 15.5333L21.52 21.5333C21.4718 21.8513 21.3103 22.1411 21.0653 22.3493C20.8203 22.5576 20.5083 22.6703 20.1867 22.6667H12.6667M12.6667 15.3333V22.6667M12.6667 15.3333H10.6667C10.3131 15.3333 9.97395 15.4738 9.7239 15.7239C9.47385 15.9739 9.33337 16.3131 9.33337 16.6667V21.3333C9.33337 21.687 9.47385 22.0261 9.7239 22.2762C9.97395 22.5262 10.3131 22.6667 10.6667 22.6667H12.6667",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$z || (_defs$z = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57353_14156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
var ForwardRef$1E = /*#__PURE__*/forwardRef(SvgFeedbackThumb);
var _rect$J, _g$1q;
var _excluded$1E = ["title", "titleId"];
function _extends$1E() {
  return _extends$1E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1E.apply(null, arguments);
}
function _objectWithoutProperties$1D(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1E(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1E(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFileCopy = function SvgFileCopy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1D(_ref, _excluded$1E);
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "file_copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56013_27499",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$J || (_rect$J = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1q || (_g$1q = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56013_27499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "file_copy_2",
    d: "M19 19H8C7.45 19 6.97917 18.8042 6.5875 18.4125C6.19583 18.0208 6 17.55 6 17V3C6 2.45 6.19583 1.97917 6.5875 1.5875C6.97917 1.19583 7.45 1 8 1H15L21 7V17C21 17.55 20.8042 18.0208 20.4125 18.4125C20.0208 18.8042 19.55 19 19 19ZM14 8V3H8V17H19V8H14ZM4 23C3.45 23 2.97917 22.8042 2.5875 22.4125C2.19583 22.0208 2 21.55 2 21V7H4V21H15V23H4Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1D = /*#__PURE__*/forwardRef(SvgFileCopy);
var _rect$I, _g$1p;
var _excluded$1D = ["title", "titleId"];
function _extends$1D() {
  return _extends$1D = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1D.apply(null, arguments);
}
function _objectWithoutProperties$1C(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1D(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1D(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFilterList = function SvgFilterList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1C(_ref, _excluded$1D);
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "filter_list"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56018_27552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$I || (_rect$I = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1p || (_g$1p = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56018_27552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "filter_list_2",
    d: "M10 18V16H14V18H10ZM6 13V11H18V13H6ZM3 8V6H21V8H3Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1C = /*#__PURE__*/forwardRef(SvgFilterList);
var _rect$H, _g$1o;
var _excluded$1C = ["title", "titleId"];
function _extends$1C() {
  return _extends$1C = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1C.apply(null, arguments);
}
function _objectWithoutProperties$1B(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1C(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1C(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFixedCost = function SvgFixedCost(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1B(_ref, _excluded$1C);
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56478_238",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$H || (_rect$H = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1o || (_g$1o = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56478_238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "price_change",
    d: "M2 20V4H22V20H2ZM4 18H20V6H4V18ZM8 17H10V16H11C11.2833 16 11.5208 15.9042 11.7125 15.7125C11.9042 15.5208 12 15.2833 12 15V12C12 11.7167 11.9042 11.4792 11.7125 11.2875C11.5208 11.0958 11.2833 11 11 11H8V10H12V8H10V7H8V8H7C6.71667 8 6.47917 8.09583 6.2875 8.2875C6.09583 8.47917 6 8.71667 6 9V12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13H10V14H6V16H8V17ZM16 16.25L18 14.25H14L16 16.25ZM14 10H18L16 8L14 10Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1B = /*#__PURE__*/forwardRef(SvgFixedCost);
var _rect$G, _g$1n;
var _excluded$1B = ["title", "titleId"];
function _extends$1B() {
  return _extends$1B = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1B.apply(null, arguments);
}
function _objectWithoutProperties$1A(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1B(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1B(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFlag = function SvgFlag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1A(_ref, _excluded$1B);
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56403_27914",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$G || (_rect$G = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1n || (_g$1n = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56403_27914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flag",
    d: "M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21H5ZM14.65 14H18V8H12.75L12.35 6H7V12H14.25L14.65 14Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1A = /*#__PURE__*/forwardRef(SvgFlag);
var _rect$F, _g$1m;
var _excluded$1A = ["title", "titleId"];
function _extends$1A() {
  return _extends$1A = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1A.apply(null, arguments);
}
function _objectWithoutProperties$1z(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1A(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1A(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFolderManaged = function SvgFolderManaged(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1z(_ref, _excluded$1A);
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "folder_managed"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55892_27589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$F || (_rect$F = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1m || (_g$1m = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55892_27589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "folder_managed_2",
    d: "M17 22L16.7 20.5C16.5 20.4167 16.3125 20.3292 16.1375 20.2375C15.9625 20.1458 15.7833 20.0333 15.6 19.9L14.15 20.35L13.15 18.65L14.3 17.65C14.2667 17.45 14.25 17.2333 14.25 17C14.25 16.7667 14.2667 16.55 14.3 16.35L13.15 15.35L14.15 13.65L15.6 14.1C15.7833 13.9667 15.9625 13.8542 16.1375 13.7625C16.3125 13.6708 16.5 13.5833 16.7 13.5L17 12H19L19.3 13.5C19.5 13.5833 19.6875 13.6708 19.8625 13.7625C20.0375 13.8542 20.2167 13.9667 20.4 14.1L21.85 13.65L22.85 15.35L21.7 16.35C21.7333 16.55 21.75 16.7667 21.75 17C21.75 17.2333 21.7333 17.45 21.7 17.65L22.85 18.65L21.85 20.35L20.4 19.9C20.2167 20.0333 20.0375 20.1458 19.8625 20.2375C19.6875 20.3292 19.5 20.4167 19.3 20.5L19 22H17ZM18 19C18.55 19 19.0208 18.8042 19.4125 18.4125C19.8042 18.0208 20 17.55 20 17C20 16.45 19.8042 15.9792 19.4125 15.5875C19.0208 15.1958 18.55 15 18 15C17.45 15 16.9792 15.1958 16.5875 15.5875C16.1958 15.9792 16 16.45 16 17C16 17.55 16.1958 18.0208 16.5875 18.4125C16.9792 18.8042 17.45 19 18 19ZM4 18V6V10.3V10V18ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H10L12 6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V11.275C21.7 11.0583 21.3833 10.8708 21.05 10.7125C20.7167 10.5542 20.3667 10.4167 20 10.3V8H11.175L9.175 6H4V18H11.075C11.125 18.35 11.2042 18.6917 11.3125 19.025C11.4208 19.3583 11.55 19.6833 11.7 20H4Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1z = /*#__PURE__*/forwardRef(SvgFolderManaged);
var _g$1l;
var _excluded$1z = ["title", "titleId"];
function _extends$1z() {
  return _extends$1z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1z.apply(null, arguments);
}
function _objectWithoutProperties$1y(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1z(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1z(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFolder = function SvgFolder(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1y(_ref, _excluded$1z);
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1l || (_g$1l = /*#__PURE__*/React.createElement("g", {
    id: "Icons/folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z",
    fill: "#3E4A42"
  }))));
};
var ForwardRef$1y = /*#__PURE__*/forwardRef(SvgFolder);
var _rect$E, _g$1k;
var _excluded$1y = ["title", "titleId"];
function _extends$1y() {
  return _extends$1y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1y.apply(null, arguments);
}
function _objectWithoutProperties$1x(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1y(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1y(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFormatSize = function SvgFormatSize(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1x(_ref, _excluded$1y);
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "format_size"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55869_27557",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$E || (_rect$E = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1k || (_g$1k = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55869_27557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "format_size_2",
    d: "M14 20V7H9V4H22V7H17V20H14ZM5 20V12H2V9H11V12H8V20H5Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1x = /*#__PURE__*/forwardRef(SvgFormatSize);
var _rect$D, _g$1j;
var _excluded$1x = ["title", "titleId"];
function _extends$1x() {
  return _extends$1x = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1x.apply(null, arguments);
}
function _objectWithoutProperties$1w(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1x(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1x(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgForward = function SvgForward(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1w(_ref, _excluded$1x);
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55986_27535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$D || (_rect$D = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1j || (_g$1j = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55986_27535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 17L14.575 15.6L19.175 11L14.575 6.4L16 5L22 11L16 17ZM2 19V15C2 13.6167 2.4875 12.4375 3.4625 11.4625C4.4375 10.4875 5.61667 10 7 10H13.175L9.575 6.4L11 5L17 11L11 17L9.575 15.6L13.175 12H7C6.16667 12 5.45833 12.2917 4.875 12.875C4.29167 13.4583 4 14.1667 4 15V19H2Z",
    fill: "#1C1B1F"
  }))));
};
var ForwardRef$1w = /*#__PURE__*/forwardRef(SvgForward);
var _g$1i;
var _excluded$1w = ["title", "titleId"];
function _extends$1w() {
  return _extends$1w = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1w.apply(null, arguments);
}
function _objectWithoutProperties$1v(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1w(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1w(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFrame = function SvgFrame(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1v(_ref, _excluded$1w);
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1i || (_g$1i = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6825 7.29102C20.3949 7.29102 20.1617 7.5242 20.1617 7.81185V12.821H30.0193V7.81185C30.0193 7.5242 29.786 7.29102 29.4985 7.29102H20.6825ZM33.1443 12.821V7.81185C33.1443 5.79831 31.5118 4.16602 29.4985 4.16602H20.6825C18.669 4.16602 17.0367 5.79831 17.0367 7.81185V12.821H11.383C8.21883 12.821 5.65381 15.386 5.65381 18.5502V37.97C5.65381 41.1341 8.21885 43.6991 11.383 43.6991H12.6184V44.1908C12.6184 45.0539 13.3179 45.7533 14.1809 45.7533C15.0438 45.7533 15.7434 45.0539 15.7434 44.1908V43.6991H33.4518V44.1908C33.4518 45.0539 34.1512 45.7533 35.0143 45.7533C35.8772 45.7533 36.5768 45.0539 36.5768 44.1908V43.6991H38.6162C41.7803 43.6991 44.3453 41.1341 44.3453 37.97V18.5502C44.3453 15.386 41.7803 12.821 38.6162 12.821H33.1443ZM11.383 15.946C9.94473 15.946 8.77881 17.1119 8.77881 18.5502V37.97C8.77881 39.4083 9.94473 40.5741 11.383 40.5741H38.6162C40.0545 40.5741 41.2203 39.4083 41.2203 37.97V18.5502C41.2203 17.1119 40.0545 15.946 38.6162 15.946H11.383ZM16.3446 20.2063C17.2076 20.2063 17.9071 20.9058 17.9071 21.7687V34.2687C17.9071 35.1318 17.2076 35.8312 16.3446 35.8312C15.4817 35.8312 14.7821 35.1318 14.7821 34.2687V21.7687C14.7821 20.9058 15.4817 20.2063 16.3446 20.2063ZM24.678 20.2063C25.541 20.2063 26.2405 20.9058 26.2405 21.7687V34.2687C26.2405 35.1318 25.541 35.8312 24.678 35.8312C23.8149 35.8312 23.1155 35.1318 23.1155 34.2687V21.7687C23.1155 20.9058 23.8149 20.2063 24.678 20.2063ZM33.0114 20.2063C33.8743 20.2063 34.5739 20.9058 34.5739 21.7687V34.2687C34.5739 35.1318 33.8743 35.8312 33.0114 35.8312C32.1482 35.8312 31.4489 35.1318 31.4489 34.2687V21.7687C31.4489 20.9058 32.1482 20.2063 33.0114 20.2063Z",
    fill: "black"
  }))));
};
var ForwardRef$1v = /*#__PURE__*/forwardRef(SvgFrame);
var _rect$C, _g$1h;
var _excluded$1v = ["title", "titleId"];
function _extends$1v() {
  return _extends$1v = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1v.apply(null, arguments);
}
function _objectWithoutProperties$1u(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1v(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1v(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFullscreen = function SvgFullscreen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1u(_ref, _excluded$1v);
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "fullscreen"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56015_27524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$C || (_rect$C = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1h || (_g$1h = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56015_27524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullscreen_2",
    d: "M3 21V16H5V19H8V21H3ZM16 21V19H19V16H21V21H16ZM3 8V3H8V5H5V8H3ZM19 8V5H16V3H21V8H19Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1u = /*#__PURE__*/forwardRef(SvgFullscreen);
var _rect$B, _g$1g;
var _excluded$1u = ["title", "titleId"];
function _extends$1u() {
  return _extends$1u = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1u.apply(null, arguments);
}
function _objectWithoutProperties$1t(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1u(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1u(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFullscreenExit = function SvgFullscreenExit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1t(_ref, _excluded$1u);
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "fullscreen_exit"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56015_27525",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$B || (_rect$B = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1g || (_g$1g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56015_27525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullscreen_exit_2",
    d: "M6 21V18H3V16H8V21H6ZM16 21V16H21V18H18V21H16ZM3 8V6H6V3H8V8H3ZM16 8V3H18V6H21V8H16Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1t = /*#__PURE__*/forwardRef(SvgFullscreenExit);
var _g$1f, _defs$y;
var _excluded$1t = ["title", "titleId"];
function _extends$1t() {
  return _extends$1t = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1t.apply(null, arguments);
}
function _objectWithoutProperties$1s(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1t(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1t(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgG2 = function SvgG2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1s(_ref, _excluded$1t);
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1f || (_g$1f = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2563_15263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4573 0.559082C6.6257 0.559082 0.27478 6.91001 0.27478 14.7416C0.27478 22.5732 6.6257 28.9241 14.4573 28.9241C22.2889 28.9241 28.6398 22.5732 28.6398 14.7416C28.6398 6.91001 22.2889 0.559082 14.4573 0.559082ZM16.9307 12.2568C16.9307 11.6356 17.0527 11.1165 17.3023 10.7138C17.5519 10.311 17.983 9.94506 18.6042 9.63021L18.8907 9.49122C19.3956 9.23594 19.5261 9.01752 19.5261 8.75373C19.5261 8.43888 19.2566 8.21196 18.817 8.21196C18.2979 8.21196 17.9036 8.48143 17.6313 9.03171L16.9307 8.32826C17.0839 7.99922 17.3307 7.73543 17.6625 7.5312C17.9919 7.32117 18.3753 7.21175 18.7659 7.21635C19.2708 7.21635 19.7105 7.34683 20.0679 7.61913C20.4253 7.89143 20.6182 8.26302 20.6182 8.73671C20.6182 9.49122 20.1927 9.95357 19.3956 10.362L18.9503 10.5889C18.4738 10.83 18.2383 11.0428 18.1731 11.4229H20.5955V12.427H16.9307V12.2568ZM14.6019 22.8455C10.1259 22.8455 6.49806 19.2176 6.49806 14.7416C6.49806 10.2656 10.1259 6.6377 14.6019 6.6377C15.1343 6.63762 15.6654 6.68988 16.1875 6.79371L14.6019 10.1096C12.0491 10.1096 9.96994 12.1887 9.96994 14.7416C9.96994 17.2944 12.0491 19.3736 14.6019 19.3736C15.7101 19.3734 16.7813 18.9748 17.62 18.2503L19.3729 21.2911C17.9887 22.3041 16.3172 22.8487 14.6019 22.8455ZM20.2721 20.5309L18.2667 17.0562H14.2559L16.2613 13.5843H20.2721L22.2775 17.0562L20.2721 20.5309Z",
    fill: "#FDFDFD"
  }))), _defs$y || (_defs$y = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2563_15263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.365,
    height: 28.365,
    fill: "white",
    transform: "translate(0.27417 0.559082)"
  })))));
};
var ForwardRef$1s = /*#__PURE__*/forwardRef(SvgG2);
var _path$g, _g$1e;
var _excluded$1s = ["title", "titleId"];
function _extends$1s() {
  return _extends$1s = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1s.apply(null, arguments);
}
function _objectWithoutProperties$1r(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1s(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1s(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgGoogle = function SvgGoogle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1r(_ref, _excluded$1s);
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55689_241",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    d: "M23.2704 0.088501H0.731201V23.1285H23.2704V0.088501Z",
    fill: "white"
  }))), _g$1e || (_g$1e = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55689_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.271 11.884C23.271 11.1076 23.1959 10.3062 23.0707 9.55493H12.2268V13.9876H18.4376C18.1872 15.4152 17.3608 16.6673 16.1336 17.4687L19.8401 20.3487C22.0188 18.3201 23.271 15.365 23.271 11.884Z",
    fill: "#4280EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2253 23.1035C15.3307 23.1035 17.9352 22.0767 19.8385 20.3236L16.1322 17.4687C15.1053 18.1699 13.778 18.5706 12.2253 18.5706C9.22013 18.5706 6.69074 16.5421 5.76413 13.8374L1.95752 16.7675C3.91092 20.6492 7.86778 23.1035 12.2253 23.1035Z",
    fill: "#34A353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76429 13.8123C5.28847 12.3848 5.28847 10.8321 5.76429 9.40459L1.95769 6.44946C0.329859 9.70511 0.329859 13.5368 1.95769 16.7674L5.76429 13.8123Z",
    fill: "#F6B704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2253 4.67139C13.8532 4.64634 15.4559 5.27244 16.633 6.39939L19.9137 3.09365C17.8351 1.14026 15.0803 0.0884309 12.2253 0.113474C7.86778 0.113474 3.91092 2.56773 1.95752 6.44947L5.76413 9.40461C6.69074 6.67487 9.22013 4.67139 12.2253 4.67139Z",
    fill: "#E54335"
  }))));
};
var ForwardRef$1r = /*#__PURE__*/forwardRef(SvgGoogle);
var _g$1d, _defs$x;
var _excluded$1r = ["title", "titleId"];
function _extends$1r() {
  return _extends$1r = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1r.apply(null, arguments);
}
function _objectWithoutProperties$1q(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1r(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1r(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgGreaterThanOrEqual = function SvgGreaterThanOrEqual(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1q(_ref, _excluded$1r);
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1d || (_g$1d = /*#__PURE__*/React.createElement("g", {
    id: "GreaterThanOrEqual",
    clipPath: "url(#clip0_55944_27552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 4.5L19.5 9.75L5.25 15",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.5 18.75H5.25",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$x || (_defs$x = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55944_27552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$1q = /*#__PURE__*/forwardRef(SvgGreaterThanOrEqual);
var _g$1c, _defs$w;
var _excluded$1q = ["title", "titleId"];
function _extends$1q() {
  return _extends$1q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1q.apply(null, arguments);
}
function _objectWithoutProperties$1p(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1q(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1q(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgGreaterThan = function SvgGreaterThan(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1p(_ref, _excluded$1q);
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1c || (_g$1c = /*#__PURE__*/React.createElement("g", {
    id: "GreaterThan",
    clipPath: "url(#clip0_55944_27549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 5.25L20.25 12L6 18.75",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$w || (_defs$w = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55944_27549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$1p = /*#__PURE__*/forwardRef(SvgGreaterThan);
var _rect$A, _g$1b;
var _excluded$1p = ["title", "titleId"];
function _extends$1p() {
  return _extends$1p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1p.apply(null, arguments);
}
function _objectWithoutProperties$1o(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1p(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1p(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgGroupAdd = function SvgGroupAdd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1o(_ref, _excluded$1p);
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56403_27860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$A || (_rect$A = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1b || (_g$1b = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56403_27860)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "group_add",
    d: "M12.5 11.95C12.9833 11.4167 13.3542 10.8083 13.6125 10.125C13.8708 9.44167 14 8.73333 14 8C14 7.26667 13.8708 6.55833 13.6125 5.875C13.3542 5.19167 12.9833 4.58333 12.5 4.05C13.5 4.18333 14.3333 4.625 15 5.375C15.6667 6.125 16 7 16 8C16 9 15.6667 9.875 15 10.625C14.3333 11.375 13.5 11.8167 12.5 11.95ZM18 20V17C18 16.4 17.8667 15.8292 17.6 15.2875C17.3333 14.7458 16.9833 14.2667 16.55 13.85C17.4 14.15 18.1875 14.5375 18.9125 15.0125C19.6375 15.4875 20 16.15 20 17V20H18ZM20 13V11H18V9H20V7H22V9H24V11H22V13H20ZM8 12C6.9 12 5.95833 11.6083 5.175 10.825C4.39167 10.0417 4 9.1 4 8C4 6.9 4.39167 5.95833 5.175 5.175C5.95833 4.39167 6.9 4 8 4C9.1 4 10.0417 4.39167 10.825 5.175C11.6083 5.95833 12 6.9 12 8C12 9.1 11.6083 10.0417 10.825 10.825C10.0417 11.6083 9.1 12 8 12ZM0 20V17.2C0 16.6333 0.145833 16.1125 0.4375 15.6375C0.729167 15.1625 1.11667 14.8 1.6 14.55C2.63333 14.0333 3.68333 13.6458 4.75 13.3875C5.81667 13.1292 6.9 13 8 13C9.1 13 10.1833 13.1292 11.25 13.3875C12.3167 13.6458 13.3667 14.0333 14.4 14.55C14.8833 14.8 15.2708 15.1625 15.5625 15.6375C15.8542 16.1125 16 16.6333 16 17.2V20H0ZM8 10C8.55 10 9.02083 9.80417 9.4125 9.4125C9.80417 9.02083 10 8.55 10 8C10 7.45 9.80417 6.97917 9.4125 6.5875C9.02083 6.19583 8.55 6 8 6C7.45 6 6.97917 6.19583 6.5875 6.5875C6.19583 6.97917 6 7.45 6 8C6 8.55 6.19583 9.02083 6.5875 9.4125C6.97917 9.80417 7.45 10 8 10ZM2 18H14V17.2C14 17.0167 13.9542 16.85 13.8625 16.7C13.7708 16.55 13.65 16.4333 13.5 16.35C12.6 15.9 11.6917 15.5625 10.775 15.3375C9.85833 15.1125 8.93333 15 8 15C7.06667 15 6.14167 15.1125 5.225 15.3375C4.30833 15.5625 3.4 15.9 2.5 16.35C2.35 16.4333 2.22917 16.55 2.1375 16.7C2.04583 16.85 2 17.0167 2 17.2V18Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1o = /*#__PURE__*/forwardRef(SvgGroupAdd);
var _rect$z, _g$1a;
var _excluded$1o = ["title", "titleId"];
function _extends$1o() {
  return _extends$1o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1o.apply(null, arguments);
}
function _objectWithoutProperties$1n(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1o(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1o(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgGroupWork = function SvgGroupWork(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1n(_ref, _excluded$1o);
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "group_work"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2808_12359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$z || (_rect$z = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.000488281,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$1a || (_g$1a = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2808_12359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "group_work_2",
    d: "M8 16.0005C8.55 16.0005 9.02083 15.8047 9.4125 15.413C9.80417 15.0213 10 14.5505 10 14.0005C10 13.4505 9.80417 12.9797 9.4125 12.588C9.02083 12.1963 8.55 12.0005 8 12.0005C7.45 12.0005 6.97917 12.1963 6.5875 12.588C6.19583 12.9797 6 13.4505 6 14.0005C6 14.5505 6.19583 15.0213 6.5875 15.413C6.97917 15.8047 7.45 16.0005 8 16.0005ZM16 16.0005C16.55 16.0005 17.0208 15.8047 17.4125 15.413C17.8042 15.0213 18 14.5505 18 14.0005C18 13.4505 17.8042 12.9797 17.4125 12.588C17.0208 12.1963 16.55 12.0005 16 12.0005C15.45 12.0005 14.9792 12.1963 14.5875 12.588C14.1958 12.9797 14 13.4505 14 14.0005C14 14.5505 14.1958 15.0213 14.5875 15.413C14.9792 15.8047 15.45 16.0005 16 16.0005ZM12 10.0005C12.55 10.0005 13.0208 9.80466 13.4125 9.41299C13.8042 9.02132 14 8.55049 14 8.00049C14 7.45049 13.8042 6.97966 13.4125 6.58799C13.0208 6.19632 12.55 6.00049 12 6.00049C11.45 6.00049 10.9792 6.19632 10.5875 6.58799C10.1958 6.97966 10 7.45049 10 8.00049C10 8.55049 10.1958 9.02132 10.5875 9.41299C10.9792 9.80466 11.45 10.0005 12 10.0005ZM12 22.0005C10.6167 22.0005 9.31667 21.738 8.1 21.213C6.88333 20.688 5.825 19.9755 4.925 19.0755C4.025 18.1755 3.3125 17.1172 2.7875 15.9005C2.2625 14.6838 2 13.3838 2 12.0005C2 10.6172 2.2625 9.31715 2.7875 8.10049C3.3125 6.88382 4.025 5.82549 4.925 4.92549C5.825 4.02549 6.88333 3.31299 8.1 2.78799C9.31667 2.26299 10.6167 2.00049 12 2.00049C13.3833 2.00049 14.6833 2.26299 15.9 2.78799C17.1167 3.31299 18.175 4.02549 19.075 4.92549C19.975 5.82549 20.6875 6.88382 21.2125 8.10049C21.7375 9.31715 22 10.6172 22 12.0005C22 13.3838 21.7375 14.6838 21.2125 15.9005C20.6875 17.1172 19.975 18.1755 19.075 19.0755C18.175 19.9755 17.1167 20.688 15.9 21.213C14.6833 21.738 13.3833 22.0005 12 22.0005ZM12 20.0005C14.2333 20.0005 16.125 19.2255 17.675 17.6755C19.225 16.1255 20 14.2338 20 12.0005C20 9.76715 19.225 7.87549 17.675 6.32549C16.125 4.77549 14.2333 4.00049 12 4.00049C9.76667 4.00049 7.875 4.77549 6.325 6.32549C4.775 7.87549 4 9.76715 4 12.0005C4 14.2338 4.775 16.1255 6.325 17.6755C7.875 19.2255 9.76667 20.0005 12 20.0005Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$1n = /*#__PURE__*/forwardRef(SvgGroupWork);
var _rect$y, _g$19;
var _excluded$1n = ["title", "titleId"];
function _extends$1n() {
  return _extends$1n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1n.apply(null, arguments);
}
function _objectWithoutProperties$1m(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1n(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1n(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgHelp = function SvgHelp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1m(_ref, _excluded$1n);
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "help"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54831_13697",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$y || (_rect$y = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$19 || (_g$19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54831_13697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "help_2",
    d: "M11.95 18C12.3 18 12.5958 17.8792 12.8375 17.6375C13.0792 17.3958 13.2 17.1 13.2 16.75C13.2 16.4 13.0792 16.1042 12.8375 15.8625C12.5958 15.6208 12.3 15.5 11.95 15.5C11.6 15.5 11.3042 15.6208 11.0625 15.8625C10.8208 16.1042 10.7 16.4 10.7 16.75C10.7 17.1 10.8208 17.3958 11.0625 17.6375C11.3042 17.8792 11.6 18 11.95 18ZM11.05 14.15H12.9C12.9 13.6 12.9625 13.1667 13.0875 12.85C13.2125 12.5333 13.5667 12.1 14.15 11.55C14.5833 11.1167 14.925 10.7042 15.175 10.3125C15.425 9.92083 15.55 9.45 15.55 8.9C15.55 7.96667 15.2083 7.25 14.525 6.75C13.8417 6.25 13.0333 6 12.1 6C11.15 6 10.3792 6.25 9.7875 6.75C9.19583 7.25 8.78333 7.85 8.55 8.55L10.2 9.2C10.2833 8.9 10.4708 8.575 10.7625 8.225C11.0542 7.875 11.5 7.7 12.1 7.7C12.6333 7.7 13.0333 7.84583 13.3 8.1375C13.5667 8.42917 13.7 8.75 13.7 9.1C13.7 9.43333 13.6 9.74583 13.4 10.0375C13.2 10.3292 12.95 10.6 12.65 10.85C11.9167 11.5 11.4667 11.9917 11.3 12.325C11.1333 12.6583 11.05 13.2667 11.05 14.15ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1m = /*#__PURE__*/forwardRef(SvgHelp);
var _rect$x, _g$18;
var _excluded$1m = ["title", "titleId"];
function _extends$1m() {
  return _extends$1m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1m.apply(null, arguments);
}
function _objectWithoutProperties$1l(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1m(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1m(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgHourglassBottom = function SvgHourglassBottom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1l(_ref, _excluded$1m);
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_12069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect$x || (_rect$x = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g$18 || (_g$18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_12069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 14.667C17.4668 14.667 18.7224 14.1448 19.7668 13.1003C20.8113 12.0559 21.3335 10.8003 21.3335 9.33366V5.33366H10.6668V9.33366C10.6668 10.8003 11.1891 12.0559 12.2335 13.1003C13.2779 14.1448 14.5335 14.667 16.0002 14.667ZM5.3335 29.3337V26.667H8.00016V22.667C8.00016 21.3114 8.31683 20.0392 8.95016 18.8503C9.5835 17.6614 10.4668 16.7114 11.6002 16.0003C10.4668 15.2892 9.5835 14.3392 8.95016 13.1503C8.31683 11.9614 8.00016 10.6892 8.00016 9.33366V5.33366H5.3335V2.66699H26.6668V5.33366H24.0002V9.33366C24.0002 10.6892 23.6835 11.9614 23.0502 13.1503C22.4168 14.3392 21.5335 15.2892 20.4002 16.0003C21.5335 16.7114 22.4168 17.6614 23.0502 18.8503C23.6835 20.0392 24.0002 21.3114 24.0002 22.667V26.667H26.6668V29.3337H5.3335Z",
    fill: "#BDCAC0"
  }))));
};
var ForwardRef$1l = /*#__PURE__*/forwardRef(SvgHourglassBottom);
var _path$f, _path2$6;
var _excluded$1l = ["title", "titleId"];
function _extends$1l() {
  return _extends$1l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1l.apply(null, arguments);
}
function _objectWithoutProperties$1k(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1l(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1l(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgHpLogo = function SvgHpLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1k(_ref, _excluded$1l);
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    width: 54,
    height: 49,
    viewBox: "0 0 54 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M0.406372 10.7637C0.406372 5.10844 4.99089 0.523926 10.6462 0.523926H25.2319C31.1114 0.523926 35.8783 5.09809 35.8783 10.7382C35.8783 16.4076 31.2824 21.0035 25.6131 21.0035H10.6462C4.99089 21.0035 0.406372 16.419 0.406372 10.7637Z",
    fill: "white"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5943 38.7241C53.5943 44.3934 48.9983 48.9894 43.329 48.9894H10.6461C4.99077 48.9894 0.40625 44.4048 0.40625 38.7496C0.40625 33.0943 4.99076 28.5098 10.646 28.5098H42.9478C48.8273 28.5098 53.5943 33.0839 53.5943 38.7241Z",
    fill: "white"
  })));
};
var ForwardRef$1k = /*#__PURE__*/forwardRef(SvgHpLogo);
var _rect$w, _g$17;
var _excluded$1k = ["title", "titleId"];
function _extends$1k() {
  return _extends$1k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1k.apply(null, arguments);
}
function _objectWithoutProperties$1j(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1k(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1k(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgInfo = function SvgInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1j(_ref, _excluded$1k);
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_12043",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect$w || (_rect$w = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g$17 || (_g$17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_12043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 11.333H8.66659V7.33301H7.33325V11.333ZM7.99992 5.99967C8.18881 5.99967 8.34714 5.93579 8.47492 5.80801C8.6027 5.68023 8.66659 5.5219 8.66659 5.33301C8.66659 5.14412 8.6027 4.98579 8.47492 4.85801C8.34714 4.73023 8.18881 4.66634 7.99992 4.66634C7.81103 4.66634 7.6527 4.73023 7.52492 4.85801C7.39714 4.98579 7.33325 5.14412 7.33325 5.33301C7.33325 5.5219 7.39714 5.68023 7.52492 5.80801C7.6527 5.93579 7.81103 5.99967 7.99992 5.99967ZM7.99992 14.6663C7.0777 14.6663 6.21103 14.4913 5.39992 14.1413C4.58881 13.7913 3.88325 13.3163 3.28325 12.7163C2.68325 12.1163 2.20825 11.4108 1.85825 10.5997C1.50825 9.78856 1.33325 8.9219 1.33325 7.99967C1.33325 7.07745 1.50825 6.21079 1.85825 5.39967C2.20825 4.58856 2.68325 3.88301 3.28325 3.28301C3.88325 2.68301 4.58881 2.20801 5.39992 1.85801C6.21103 1.50801 7.0777 1.33301 7.99992 1.33301C8.92214 1.33301 9.78881 1.50801 10.5999 1.85801C11.411 2.20801 12.1166 2.68301 12.7166 3.28301C13.3166 3.88301 13.7916 4.58856 14.1416 5.39967C14.4916 6.21079 14.6666 7.07745 14.6666 7.99967C14.6666 8.9219 14.4916 9.78856 14.1416 10.5997C13.7916 11.4108 13.3166 12.1163 12.7166 12.7163C12.1166 13.3163 11.411 13.7913 10.5999 14.1413C9.78881 14.4913 8.92214 14.6663 7.99992 14.6663ZM7.99992 13.333C9.48881 13.333 10.7499 12.8163 11.7833 11.783C12.8166 10.7497 13.3333 9.48856 13.3333 7.99967C13.3333 6.51079 12.8166 5.24967 11.7833 4.21634C10.7499 3.18301 9.48881 2.66634 7.99992 2.66634C6.51103 2.66634 5.24992 3.18301 4.21659 4.21634C3.18325 5.24967 2.66659 6.51079 2.66659 7.99967C2.66659 9.48856 3.18325 10.7497 4.21659 11.783C5.24992 12.8163 6.51103 13.333 7.99992 13.333Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$1j = /*#__PURE__*/forwardRef(SvgInfo);
var _g$16;
var _excluded$1j = ["title", "titleId"];
function _extends$1j() {
  return _extends$1j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1j.apply(null, arguments);
}
function _objectWithoutProperties$1i(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1j(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1j(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgInformation2 = function SvgInformation2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1i(_ref, _excluded$1j);
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$16 || (_g$16 = /*#__PURE__*/React.createElement("g", {
    id: "Information 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_55108_218",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3806 2.56011C11.3457 1.85692 12.6543 1.85692 13.6194 2.56011C13.7754 2.67375 13.9285 2.82199 14.1269 3.01405C14.139 3.02577 14.1513 3.03766 14.1637 3.04971C14.297 3.17865 14.3335 3.21313 14.3677 3.24115C14.6105 3.44015 14.9194 3.54049 15.2328 3.52223C15.2769 3.51965 15.3267 3.51321 15.5103 3.48724C15.5275 3.48481 15.5444 3.48241 15.5611 3.48005C15.8345 3.44128 16.0455 3.41136 16.2385 3.4111C17.4326 3.40948 18.4913 4.17867 18.8588 5.31484C18.9181 5.49846 18.9549 5.70837 19.0025 5.98036C19.0054 5.99697 19.0084 6.01381 19.0114 6.03089C19.0434 6.21354 19.0527 6.26289 19.0638 6.30566C19.1433 6.60939 19.3342 6.87208 19.5985 7.04153C19.6357 7.06539 19.6798 7.08945 19.8436 7.17636C19.8589 7.18449 19.874 7.19251 19.8889 7.20041C20.1329 7.32973 20.3212 7.42954 20.4774 7.54276C21.4444 8.24333 21.8488 9.48791 21.4783 10.6231C21.4184 10.8065 21.3247 10.998 21.2034 11.246C21.196 11.2612 21.1885 11.2765 21.1809 11.2921C21.0994 11.4587 21.0779 11.504 21.0618 11.5452C20.9476 11.8377 20.9476 12.1624 21.0618 12.4548C21.0779 12.496 21.0994 12.5413 21.1809 12.7079C21.1885 12.7235 21.196 12.7388 21.2034 12.754C21.3247 13.002 21.4184 13.1935 21.4783 13.3769C21.8488 14.5121 21.4444 15.7567 20.4774 16.4573C20.3212 16.5705 20.1329 16.6703 19.8889 16.7996C19.874 16.8075 19.8589 16.8155 19.8436 16.8237C19.6798 16.9106 19.6357 16.9346 19.5985 16.9585C19.3342 17.1279 19.1433 17.3906 19.0638 17.6944C19.0527 17.7371 19.0434 17.7865 19.0114 17.9691C19.0084 17.9862 19.0054 18.003 19.0025 18.0196C18.9549 18.2916 18.9181 18.5016 18.8588 18.6852C18.4913 19.8213 17.4326 20.5905 16.2385 20.5889C16.0455 20.5887 15.8345 20.5587 15.5611 20.52C15.5444 20.5176 15.5275 20.5152 15.5103 20.5128C15.3267 20.4868 15.2769 20.4804 15.2328 20.4778C14.9194 20.4595 14.6105 20.5599 14.3677 20.7589C14.3335 20.7869 14.297 20.8214 14.1637 20.9503C14.1513 20.9623 14.139 20.9742 14.1269 20.986C13.9285 21.178 13.7754 21.3263 13.6194 21.4399C12.6543 22.1431 11.3457 22.1431 10.3806 21.4399C10.2246 21.3263 10.0715 21.178 9.87312 20.986C9.86099 20.9743 9.8487 20.9624 9.83623 20.9503C9.70296 20.8214 9.66645 20.7869 9.63225 20.7589C9.38943 20.5599 9.08061 20.4595 8.7672 20.4778C8.72305 20.4804 8.67325 20.4868 8.48965 20.5128C8.47248 20.5152 8.45555 20.5176 8.43886 20.52C8.16547 20.5587 7.95447 20.5887 7.76149 20.5889C6.56737 20.5905 5.50868 19.8213 5.14121 18.6852C5.08183 18.5016 5.04508 18.2916 4.99747 18.0197C4.99456 18.0031 4.99161 17.9862 4.98862 17.9691C4.95658 17.7865 4.94732 17.7371 4.93612 17.6943C4.85665 17.3906 4.66579 17.1279 4.40149 16.9585C4.36427 16.9346 4.32019 16.9106 4.15639 16.8237C4.14106 16.8155 4.12595 16.8075 4.11105 16.7996C3.8671 16.6703 3.67881 16.5705 3.52254 16.4573C2.55553 15.7567 2.15114 14.5121 2.52168 13.3769C2.58156 13.1935 2.67522 13.0021 2.79657 12.754C2.80398 12.7389 2.8115 12.7235 2.81911 12.7079C2.90055 12.5414 2.92206 12.496 2.93815 12.4548C3.05237 12.1624 3.05237 11.8377 2.93815 11.5452C2.92206 11.504 2.90055 11.4587 2.81911 11.2921C2.8115 11.2765 2.80398 11.2611 2.79657 11.246C2.67522 10.998 2.58156 10.8065 2.52168 10.6231C2.15114 9.48791 2.55553 8.24333 3.52254 7.54276C3.67881 7.42954 3.8671 7.32972 4.11106 7.2004C4.12596 7.1925 4.14107 7.18449 4.15639 7.17636C4.32019 7.08945 4.36427 7.06539 4.40149 7.04152C4.66579 6.87208 4.85665 6.60939 4.93612 6.30566C4.94732 6.26289 4.95658 6.21354 4.98862 6.03089C4.99161 6.01381 4.99456 5.99697 4.99747 5.98036C5.04508 5.70837 5.08183 5.49846 5.14121 5.31484C5.50868 4.17867 6.56737 3.40948 7.76149 3.4111C7.95447 3.41136 8.16547 3.44128 8.43885 3.48005C8.45555 3.48241 8.47248 3.48481 8.48965 3.48724C8.67325 3.51321 8.72306 3.51965 8.7672 3.52223C9.08061 3.54049 9.38943 3.44015 9.63225 3.24115C9.66645 3.21313 9.70295 3.17864 9.83623 3.04971C9.84869 3.03765 9.86098 3.02576 9.8731 3.01403C10.0715 2.82198 10.2246 2.67375 10.3806 2.56011ZM12.7361 3.77244C12.2974 3.45281 11.7026 3.45281 11.2639 3.77244C11.2041 3.81602 11.1318 3.88343 10.8792 4.1278C10.8729 4.13386 10.8667 4.13985 10.8606 4.14576C10.7544 4.24855 10.6712 4.32912 10.583 4.40132C10.0488 4.83913 9.36944 5.05987 8.67992 5.01969C8.56619 5.01306 8.45149 4.99681 8.30513 4.97608C8.29672 4.97489 8.2882 4.97368 8.27958 4.97246C7.93158 4.92324 7.83346 4.9112 7.75946 4.9111C7.21668 4.91036 6.73545 5.25999 6.56842 5.77643C6.54565 5.84684 6.52678 5.94388 6.46606 6.29006C6.46455 6.29864 6.46307 6.30712 6.4616 6.31549C6.43609 6.46108 6.4161 6.5752 6.38726 6.6854C6.21241 7.35359 5.79252 7.93152 5.21107 8.30429C5.11516 8.36578 5.01281 8.42006 4.88222 8.48931C4.87472 8.49329 4.86712 8.49732 4.85942 8.5014C4.54895 8.66613 4.4625 8.71406 4.40257 8.75748C3.96302 9.07592 3.77921 9.64163 3.94764 10.1576C3.9706 10.228 4.01237 10.3176 4.16672 10.6333C4.17055 10.6411 4.17433 10.6489 4.17806 10.6565C4.243 10.7893 4.2939 10.8934 4.33535 10.9995C4.58664 11.6428 4.58664 12.3572 4.33535 13.0005C4.2939 13.1067 4.243 13.2107 4.17805 13.3435C4.17432 13.3511 4.17055 13.3589 4.16672 13.3667C4.01237 13.6825 3.9706 13.772 3.94764 13.8424C3.77921 14.3584 3.96302 14.9241 4.40257 15.2425C4.4625 15.286 4.54895 15.3339 4.85942 15.4986L4.88225 15.5107C5.01283 15.58 5.11517 15.6342 5.21107 15.6957C5.79252 16.0685 6.21241 16.6464 6.38726 17.3146C6.4161 17.4248 6.43609 17.5389 6.4616 17.6845L6.46606 17.71C6.52678 18.0561 6.54565 18.1532 6.56842 18.2236C6.73545 18.74 7.21668 19.0897 7.75946 19.0889C7.83346 19.0888 7.93158 19.0768 8.27958 19.0276L8.30516 19.0239C8.4515 19.0032 8.5662 18.987 8.67992 18.9803C9.36944 18.9401 10.0488 19.1609 10.583 19.5987C10.6712 19.6709 10.7544 19.7515 10.8606 19.8543L10.8792 19.8722C11.1318 20.1166 11.2041 20.184 11.2639 20.2276C11.7026 20.5472 12.2974 20.5472 12.7361 20.2276C12.7959 20.184 12.8682 20.1166 13.1208 19.8722L13.1394 19.8542C13.2456 19.7515 13.3288 19.6709 13.4169 19.5987C13.9511 19.1609 14.6305 18.9401 15.32 18.9803C15.4338 18.987 15.5485 19.0032 15.6948 19.0239L15.7204 19.0276C16.0684 19.0768 16.1665 19.0888 16.2405 19.0889C16.7833 19.0897 17.2645 18.74 17.4315 18.2236C17.4543 18.1532 17.4732 18.0561 17.5339 17.71L17.5384 17.6845C17.5639 17.5389 17.5839 17.4248 17.6127 17.3146C17.7876 16.6464 18.2075 16.0685 18.7889 15.6957C18.8848 15.6342 18.9871 15.58 19.1177 15.5107L19.1405 15.4986C19.451 15.3339 19.5375 15.286 19.5974 15.2425C20.0369 14.9241 20.2208 14.3584 20.0523 13.8424C20.0294 13.772 19.9876 13.6825 19.8333 13.3667L19.8219 13.3435C19.757 13.2107 19.7061 13.1066 19.6646 13.0005C19.4133 12.3572 19.4133 11.6428 19.6646 10.9995C19.7061 10.8934 19.757 10.7893 19.8219 10.6565L19.8333 10.6333C19.9876 10.3176 20.0294 10.228 20.0523 10.1576C20.2208 9.64163 20.0369 9.07592 19.5974 8.75748C19.5375 8.71406 19.451 8.66613 19.1405 8.5014L19.1178 8.48932C18.9872 8.42006 18.8848 8.36578 18.7889 8.30429C18.2075 7.93152 17.7876 7.35359 17.6127 6.6854C17.5839 6.5752 17.5639 6.4611 17.5384 6.31553L17.5339 6.29006C17.4732 5.94388 17.4543 5.84684 17.4315 5.77643C17.2645 5.25999 16.7833 4.91036 16.2405 4.9111C16.1665 4.9112 16.0684 4.92324 15.7204 4.97246L15.6948 4.97608C15.5485 4.99681 15.4338 5.01306 15.32 5.01969C14.6305 5.05987 13.9511 4.83912 13.4169 4.40132C13.3288 4.32912 13.2456 4.24855 13.1394 4.14577L13.1208 4.1278C12.8682 3.88343 12.7959 3.81602 12.7361 3.77244ZM11.998 8.25001C12.4122 8.25001 12.748 8.58579 12.748 9.00001V12.9586C12.748 13.3728 12.4122 13.7086 11.998 13.7086C11.5838 13.7086 11.248 13.3728 11.248 12.9586V9.00001C11.248 8.58579 11.5838 8.25001 11.998 8.25001ZM11.248 15C11.248 14.5858 11.5838 14.25 11.998 14.25H12.002C12.4162 14.25 12.752 14.5858 12.752 15C12.752 15.4142 12.4162 15.75 12.002 15.75H11.998C11.5838 15.75 11.248 15.4142 11.248 15Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3806 2.56011C11.3457 1.85692 12.6543 1.85692 13.6194 2.56011C13.7754 2.67375 13.9285 2.82199 14.1269 3.01405C14.139 3.02577 14.1513 3.03766 14.1637 3.04971C14.297 3.17865 14.3335 3.21313 14.3677 3.24115C14.6105 3.44015 14.9194 3.54049 15.2328 3.52223C15.2769 3.51965 15.3267 3.51321 15.5103 3.48724C15.5275 3.48481 15.5444 3.48241 15.5611 3.48005C15.8345 3.44128 16.0455 3.41136 16.2385 3.4111C17.4326 3.40948 18.4913 4.17867 18.8588 5.31484C18.9181 5.49846 18.9549 5.70837 19.0025 5.98036C19.0054 5.99697 19.0084 6.01381 19.0114 6.03089C19.0434 6.21354 19.0527 6.26289 19.0638 6.30566C19.1433 6.60939 19.3342 6.87208 19.5985 7.04153C19.6357 7.06539 19.6798 7.08945 19.8436 7.17636C19.8589 7.18449 19.874 7.19251 19.8889 7.20041C20.1329 7.32973 20.3212 7.42954 20.4774 7.54276C21.4444 8.24333 21.8488 9.48791 21.4783 10.6231C21.4184 10.8065 21.3247 10.998 21.2034 11.246C21.196 11.2612 21.1885 11.2765 21.1809 11.2921C21.0994 11.4587 21.0779 11.504 21.0618 11.5452C20.9476 11.8377 20.9476 12.1624 21.0618 12.4548C21.0779 12.496 21.0994 12.5413 21.1809 12.7079C21.1885 12.7235 21.196 12.7388 21.2034 12.754C21.3247 13.002 21.4184 13.1935 21.4783 13.3769C21.8488 14.5121 21.4444 15.7567 20.4774 16.4573C20.3212 16.5705 20.1329 16.6703 19.8889 16.7996C19.874 16.8075 19.8589 16.8155 19.8436 16.8237C19.6798 16.9106 19.6357 16.9346 19.5985 16.9585C19.3342 17.1279 19.1433 17.3906 19.0638 17.6944C19.0527 17.7371 19.0434 17.7865 19.0114 17.9691C19.0084 17.9862 19.0054 18.003 19.0025 18.0196C18.9549 18.2916 18.9181 18.5016 18.8588 18.6852C18.4913 19.8213 17.4326 20.5905 16.2385 20.5889C16.0455 20.5887 15.8345 20.5587 15.5611 20.52C15.5444 20.5176 15.5275 20.5152 15.5103 20.5128C15.3267 20.4868 15.2769 20.4804 15.2328 20.4778C14.9194 20.4595 14.6105 20.5599 14.3677 20.7589C14.3335 20.7869 14.297 20.8214 14.1637 20.9503C14.1513 20.9623 14.139 20.9742 14.1269 20.986C13.9285 21.178 13.7754 21.3263 13.6194 21.4399C12.6543 22.1431 11.3457 22.1431 10.3806 21.4399C10.2246 21.3263 10.0715 21.178 9.87312 20.986C9.86099 20.9743 9.8487 20.9624 9.83623 20.9503C9.70296 20.8214 9.66645 20.7869 9.63225 20.7589C9.38943 20.5599 9.08061 20.4595 8.7672 20.4778C8.72305 20.4804 8.67325 20.4868 8.48965 20.5128C8.47248 20.5152 8.45555 20.5176 8.43886 20.52C8.16547 20.5587 7.95447 20.5887 7.76149 20.5889C6.56737 20.5905 5.50868 19.8213 5.14121 18.6852C5.08183 18.5016 5.04508 18.2916 4.99747 18.0197C4.99456 18.0031 4.99161 17.9862 4.98862 17.9691C4.95658 17.7865 4.94732 17.7371 4.93612 17.6943C4.85665 17.3906 4.66579 17.1279 4.40149 16.9585C4.36427 16.9346 4.32019 16.9106 4.15639 16.8237C4.14106 16.8155 4.12595 16.8075 4.11105 16.7996C3.8671 16.6703 3.67881 16.5705 3.52254 16.4573C2.55553 15.7567 2.15114 14.5121 2.52168 13.3769C2.58156 13.1935 2.67522 13.0021 2.79657 12.754C2.80398 12.7389 2.8115 12.7235 2.81911 12.7079C2.90055 12.5414 2.92206 12.496 2.93815 12.4548C3.05237 12.1624 3.05237 11.8377 2.93815 11.5452C2.92206 11.504 2.90055 11.4587 2.81911 11.2921C2.8115 11.2765 2.80398 11.2611 2.79657 11.246C2.67522 10.998 2.58156 10.8065 2.52168 10.6231C2.15114 9.48791 2.55553 8.24333 3.52254 7.54276C3.67881 7.42954 3.8671 7.32972 4.11106 7.2004C4.12596 7.1925 4.14107 7.18449 4.15639 7.17636C4.32019 7.08945 4.36427 7.06539 4.40149 7.04152C4.66579 6.87208 4.85665 6.60939 4.93612 6.30566C4.94732 6.26289 4.95658 6.21354 4.98862 6.03089C4.99161 6.01381 4.99456 5.99697 4.99747 5.98036C5.04508 5.70837 5.08183 5.49846 5.14121 5.31484C5.50868 4.17867 6.56737 3.40948 7.76149 3.4111C7.95447 3.41136 8.16547 3.44128 8.43885 3.48005C8.45555 3.48241 8.47248 3.48481 8.48965 3.48724C8.67325 3.51321 8.72306 3.51965 8.7672 3.52223C9.08061 3.54049 9.38943 3.44015 9.63225 3.24115C9.66645 3.21313 9.70295 3.17864 9.83623 3.04971C9.84869 3.03765 9.86098 3.02576 9.8731 3.01403C10.0715 2.82198 10.2246 2.67375 10.3806 2.56011ZM12.7361 3.77244C12.2974 3.45281 11.7026 3.45281 11.2639 3.77244C11.2041 3.81602 11.1318 3.88343 10.8792 4.1278C10.8729 4.13386 10.8667 4.13985 10.8606 4.14576C10.7544 4.24855 10.6712 4.32912 10.583 4.40132C10.0488 4.83913 9.36944 5.05987 8.67992 5.01969C8.56619 5.01306 8.45149 4.99681 8.30513 4.97608C8.29672 4.97489 8.2882 4.97368 8.27958 4.97246C7.93158 4.92324 7.83346 4.9112 7.75946 4.9111C7.21668 4.91036 6.73545 5.25999 6.56842 5.77643C6.54565 5.84684 6.52678 5.94388 6.46606 6.29006C6.46455 6.29864 6.46307 6.30712 6.4616 6.31549C6.43609 6.46108 6.4161 6.5752 6.38726 6.6854C6.21241 7.35359 5.79252 7.93152 5.21107 8.30429C5.11516 8.36578 5.01281 8.42006 4.88222 8.48931C4.87472 8.49329 4.86712 8.49732 4.85942 8.5014C4.54895 8.66613 4.4625 8.71406 4.40257 8.75748C3.96302 9.07592 3.77921 9.64163 3.94764 10.1576C3.9706 10.228 4.01237 10.3176 4.16672 10.6333C4.17055 10.6411 4.17433 10.6489 4.17806 10.6565C4.243 10.7893 4.2939 10.8934 4.33535 10.9995C4.58664 11.6428 4.58664 12.3572 4.33535 13.0005C4.2939 13.1067 4.243 13.2107 4.17805 13.3435C4.17432 13.3511 4.17055 13.3589 4.16672 13.3667C4.01237 13.6825 3.9706 13.772 3.94764 13.8424C3.77921 14.3584 3.96302 14.9241 4.40257 15.2425C4.4625 15.286 4.54895 15.3339 4.85942 15.4986L4.88225 15.5107C5.01283 15.58 5.11517 15.6342 5.21107 15.6957C5.79252 16.0685 6.21241 16.6464 6.38726 17.3146C6.4161 17.4248 6.43609 17.5389 6.4616 17.6845L6.46606 17.71C6.52678 18.0561 6.54565 18.1532 6.56842 18.2236C6.73545 18.74 7.21668 19.0897 7.75946 19.0889C7.83346 19.0888 7.93158 19.0768 8.27958 19.0276L8.30516 19.0239C8.4515 19.0032 8.5662 18.987 8.67992 18.9803C9.36944 18.9401 10.0488 19.1609 10.583 19.5987C10.6712 19.6709 10.7544 19.7515 10.8606 19.8543L10.8792 19.8722C11.1318 20.1166 11.2041 20.184 11.2639 20.2276C11.7026 20.5472 12.2974 20.5472 12.7361 20.2276C12.7959 20.184 12.8682 20.1166 13.1208 19.8722L13.1394 19.8542C13.2456 19.7515 13.3288 19.6709 13.4169 19.5987C13.9511 19.1609 14.6305 18.9401 15.32 18.9803C15.4338 18.987 15.5485 19.0032 15.6948 19.0239L15.7204 19.0276C16.0684 19.0768 16.1665 19.0888 16.2405 19.0889C16.7833 19.0897 17.2645 18.74 17.4315 18.2236C17.4543 18.1532 17.4732 18.0561 17.5339 17.71L17.5384 17.6845C17.5639 17.5389 17.5839 17.4248 17.6127 17.3146C17.7876 16.6464 18.2075 16.0685 18.7889 15.6957C18.8848 15.6342 18.9871 15.58 19.1177 15.5107L19.1405 15.4986C19.451 15.3339 19.5375 15.286 19.5974 15.2425C20.0369 14.9241 20.2208 14.3584 20.0523 13.8424C20.0294 13.772 19.9876 13.6825 19.8333 13.3667L19.8219 13.3435C19.757 13.2107 19.7061 13.1066 19.6646 13.0005C19.4133 12.3572 19.4133 11.6428 19.6646 10.9995C19.7061 10.8934 19.757 10.7893 19.8219 10.6565L19.8333 10.6333C19.9876 10.3176 20.0294 10.228 20.0523 10.1576C20.2208 9.64163 20.0369 9.07592 19.5974 8.75748C19.5375 8.71406 19.451 8.66613 19.1405 8.5014L19.1178 8.48932C18.9872 8.42006 18.8848 8.36578 18.7889 8.30429C18.2075 7.93152 17.7876 7.35359 17.6127 6.6854C17.5839 6.5752 17.5639 6.4611 17.5384 6.31553L17.5339 6.29006C17.4732 5.94388 17.4543 5.84684 17.4315 5.77643C17.2645 5.25999 16.7833 4.91036 16.2405 4.9111C16.1665 4.9112 16.0684 4.92324 15.7204 4.97246L15.6948 4.97608C15.5485 4.99681 15.4338 5.01306 15.32 5.01969C14.6305 5.05987 13.9511 4.83912 13.4169 4.40132C13.3288 4.32912 13.2456 4.24855 13.1394 4.14577L13.1208 4.1278C12.8682 3.88343 12.7959 3.81602 12.7361 3.77244ZM11.998 8.25001C12.4122 8.25001 12.748 8.58579 12.748 9.00001V12.9586C12.748 13.3728 12.4122 13.7086 11.998 13.7086C11.5838 13.7086 11.248 13.3728 11.248 12.9586V9.00001C11.248 8.58579 11.5838 8.25001 11.998 8.25001ZM11.248 15C11.248 14.5858 11.5838 14.25 11.998 14.25H12.002C12.4162 14.25 12.752 14.5858 12.752 15C12.752 15.4142 12.4162 15.75 12.002 15.75H11.998C11.5838 15.75 11.248 15.4142 11.248 15Z",
    fill: "#171D19",
    stroke: "#171D19",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_55108_218)"
  })))));
};
var ForwardRef$1i = /*#__PURE__*/forwardRef(SvgInformation2);
var _path$e;
var _excluded$1i = ["title", "titleId"];
function _extends$1i() {
  return _extends$1i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1i.apply(null, arguments);
}
function _objectWithoutProperties$1h(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1i(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1i(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgLanguage = function SvgLanguage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1h(_ref, _excluded$1i);
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 11.99 22C6.47 22 2 17.52 2 12ZM15.97 8H18.92C17.96 6.35 16.43 5.07 14.59 4.44C15.19 5.55 15.65 6.75 15.97 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4 12C4 12.69 4.1 13.36 4.26 14H7.64C7.56 13.34 7.5 12.68 7.5 12C7.5 11.32 7.56 10.66 7.64 10H4.26C4.1 10.64 4 11.31 4 12ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM5.08 8H8.03C8.35 6.75 8.81 5.55 9.41 4.44C7.57 5.07 6.04 6.34 5.08 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM9.5 12C9.5 12.68 9.57 13.34 9.66 14H14.34C14.43 13.34 14.5 12.68 14.5 12C14.5 11.32 14.43 10.65 14.34 10H9.66C9.57 10.65 9.5 11.32 9.5 12ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.5 12C16.5 12.68 16.44 13.34 16.36 14H19.74C19.9 13.36 20 12.69 20 12C20 11.31 19.9 10.64 19.74 10H16.36C16.44 10.66 16.5 11.32 16.5 12Z",
    fill: "#171D19"
  })));
};
var ForwardRef$1h = /*#__PURE__*/forwardRef(SvgLanguage);
var _g$15, _defs$v;
var _excluded$1h = ["title", "titleId"];
function _extends$1h() {
  return _extends$1h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1h.apply(null, arguments);
}
function _objectWithoutProperties$1g(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1h(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1h(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgLego = function SvgLego(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1g(_ref, _excluded$1h);
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$15 || (_g$15 = /*#__PURE__*/React.createElement("g", {
    id: "Lego",
    clipPath: "url(#clip0_1026_28288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 20V28",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 15C12.2091 15 14 13.8807 14 12.5C14 11.1193 12.2091 10 10 10C7.79086 10 6 11.1193 6 12.5C6 13.8807 7.79086 15 10 15Z",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 10C22.2091 10 24 8.88071 24 7.5C24 6.11929 22.2091 5 20 5C17.7909 5 16 6.11929 16 7.5C16 8.88071 17.7909 10 20 10Z",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2 16L10 20L30 10L23.9037 6.95129",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.5238 8.73755L12.6951 10.6525",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30 10V18L10 28L2 24V16L6.52375 13.7375",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$v || (_defs$v = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_28288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef$1g = /*#__PURE__*/forwardRef(SvgLego);
var _g$14, _defs$u;
var _excluded$1g = ["title", "titleId"];
function _extends$1g() {
  return _extends$1g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1g.apply(null, arguments);
}
function _objectWithoutProperties$1f(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1g(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1g(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgLessThanOrEqual = function SvgLessThanOrEqual(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1f(_ref, _excluded$1g);
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$14 || (_g$14 = /*#__PURE__*/React.createElement("g", {
    id: "LessThanOrEqual",
    clipPath: "url(#clip0_55944_27550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 4.5L4.5 9.75L18.75 15",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.75 18.75H4.5",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$u || (_defs$u = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55944_27550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$1f = /*#__PURE__*/forwardRef(SvgLessThanOrEqual);
var _g$13, _defs$t;
var _excluded$1f = ["title", "titleId"];
function _extends$1f() {
  return _extends$1f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1f.apply(null, arguments);
}
function _objectWithoutProperties$1e(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1f(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1f(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgLessThan = function SvgLessThan(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1e(_ref, _excluded$1f);
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$13 || (_g$13 = /*#__PURE__*/React.createElement("g", {
    id: "LessThan",
    clipPath: "url(#clip0_55944_27551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 5.25L4.5 12L18.75 18.75",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$t || (_defs$t = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55944_27551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$1e = /*#__PURE__*/forwardRef(SvgLessThan);
var _rect$v, _g$12;
var _excluded$1e = ["title", "titleId"];
function _extends$1e() {
  return _extends$1e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1e.apply(null, arguments);
}
function _objectWithoutProperties$1d(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1e(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1e(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgLink = function SvgLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1d(_ref, _excluded$1e);
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55825_27458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$v || (_rect$v = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$12 || (_g$12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55825_27458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 17H7C5.61667 17 4.4375 16.5125 3.4625 15.5375C2.4875 14.5625 2 13.3833 2 12C2 10.6167 2.4875 9.4375 3.4625 8.4625C4.4375 7.4875 5.61667 7 7 7H11V9H7C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15H11V17ZM8 13V11H16V13H8ZM13 17V15H17C17.8333 15 18.5417 14.7083 19.125 14.125C19.7083 13.5417 20 12.8333 20 12C20 11.1667 19.7083 10.4583 19.125 9.875C18.5417 9.29167 17.8333 9 17 9H13V7H17C18.3833 7 19.5625 7.4875 20.5375 8.4625C21.5125 9.4375 22 10.6167 22 12C22 13.3833 21.5125 14.5625 20.5375 15.5375C19.5625 16.5125 18.3833 17 17 17H13Z",
    fill: "#1C1B1F"
  }))));
};
var ForwardRef$1d = /*#__PURE__*/forwardRef(SvgLink);
var _g$11, _defs$s;
var _excluded$1d = ["title", "titleId"];
function _extends$1d() {
  return _extends$1d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1d.apply(null, arguments);
}
function _objectWithoutProperties$1c(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1d(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1d(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgLinkedin = function SvgLinkedin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1c(_ref, _excluded$1d);
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$11 || (_g$11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56353_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.562465H2.25C1.80756 0.557962 1.3814 0.72916 1.06504 1.0385C0.74867 1.34783 0.56794 1.77003 0.5625 2.21246V21.7912C0.568923 22.233 0.750087 22.6542 1.06634 22.9628C1.3826 23.2713 1.8082 23.442 2.25 23.4375H21.75C22.1925 23.441 22.6183 23.2692 22.9345 22.9597C23.2507 22.6501 23.4316 22.228 23.4375 21.7856V2.20684C23.4296 1.76571 23.2479 1.34552 22.9319 1.0376C22.6159 0.729686 22.1912 0.558935 21.75 0.562465Z",
    fill: "#0076B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94871 9.13684H7.34434V20.0625H3.94871V9.13684ZM5.64746 3.69934C6.03692 3.69934 6.41764 3.81485 6.74144 4.03127C7.06523 4.24768 7.31757 4.55527 7.46653 4.91512C7.61548 5.27497 7.65436 5.67091 7.57824 6.05286C7.50213 6.43482 7.31444 6.78561 7.03891 7.06087C6.76339 7.33613 6.41242 7.52349 6.0304 7.59924C5.64837 7.67499 5.25246 7.63574 4.89275 7.48644C4.53304 7.33714 4.2257 7.08451 4.00959 6.7605C3.79349 6.4365 3.67834 6.05568 3.67871 5.66622C3.67921 5.1444 3.88685 4.64412 4.25601 4.27531C4.62517 3.9065 5.12564 3.69934 5.64746 3.69934ZM9.47434 9.13684H12.7293V10.6368H12.7743C13.2281 9.77809 14.3343 8.87247 15.9862 8.87247C19.425 8.86497 20.0625 11.1281 20.0625 14.0625V20.0625H16.6668V14.7468C16.6668 13.4812 16.6443 11.8518 14.9025 11.8518C13.1606 11.8518 12.8643 13.2318 12.8643 14.6643V20.0625H9.47434V9.13684Z",
    fill: "white"
  }))), _defs$s || (_defs$s = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56353_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$1c = /*#__PURE__*/forwardRef(SvgLinkedin);
var _rect$u, _g$10;
var _excluded$1c = ["title", "titleId"];
function _extends$1c() {
  return _extends$1c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1c.apply(null, arguments);
}
function _objectWithoutProperties$1b(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1c(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1c(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgListAltAdd = function SvgListAltAdd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1b(_ref, _excluded$1c);
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "list_alt_add"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55968_27500",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$u || (_rect$u = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$10 || (_g$10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55968_27500)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "list_alt_add_2",
    d: "M17 23V20H14V18H17V15H19V18H22V20H19V23H17ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V13.825C20.7 13.6417 20.3833 13.4917 20.05 13.375C19.7167 13.2583 19.3667 13.1667 19 13.1V5H5V19H12C12 19.35 12.025 19.6917 12.075 20.025C12.125 20.3583 12.2083 20.6833 12.325 21H5ZM8 17C8.28333 17 8.52083 16.9042 8.7125 16.7125C8.90417 16.5208 9 16.2833 9 16C9 15.7167 8.90417 15.4792 8.7125 15.2875C8.52083 15.0958 8.28333 15 8 15C7.71667 15 7.47917 15.0958 7.2875 15.2875C7.09583 15.4792 7 15.7167 7 16C7 16.2833 7.09583 16.5208 7.2875 16.7125C7.47917 16.9042 7.71667 17 8 17ZM8 13C8.28333 13 8.52083 12.9042 8.7125 12.7125C8.90417 12.5208 9 12.2833 9 12C9 11.7167 8.90417 11.4792 8.7125 11.2875C8.52083 11.0958 8.28333 11 8 11C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13ZM8 9C8.28333 9 8.52083 8.90417 8.7125 8.7125C8.90417 8.52083 9 8.28333 9 8C9 7.71667 8.90417 7.47917 8.7125 7.2875C8.52083 7.09583 8.28333 7 8 7C7.71667 7 7.47917 7.09583 7.2875 7.2875C7.09583 7.47917 7 7.71667 7 8C7 8.28333 7.09583 8.52083 7.2875 8.7125C7.47917 8.90417 7.71667 9 8 9ZM11 13H17V11H11V13ZM11 9H17V7H11V9ZM11 17H12.35C12.4833 16.6167 12.65 16.2583 12.85 15.925C13.05 15.5917 13.2833 15.2833 13.55 15H11V17Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1b = /*#__PURE__*/forwardRef(SvgListAltAdd);
var _rect$t, _g$$;
var _excluded$1b = ["title", "titleId"];
function _extends$1b() {
  return _extends$1b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1b.apply(null, arguments);
}
function _objectWithoutProperties$1a(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1b(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1b(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgList = function SvgList(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1a(_ref, _excluded$1b);
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56403_27875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$t || (_rect$t = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$$ || (_g$$ = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56403_27875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "list",
    d: "M7 9V7H21V9H7ZM7 13V11H21V13H7ZM7 17V15H21V17H7ZM4 9C3.71667 9 3.47917 8.90417 3.2875 8.7125C3.09583 8.52083 3 8.28333 3 8C3 7.71667 3.09583 7.47917 3.2875 7.2875C3.47917 7.09583 3.71667 7 4 7C4.28333 7 4.52083 7.09583 4.7125 7.2875C4.90417 7.47917 5 7.71667 5 8C5 8.28333 4.90417 8.52083 4.7125 8.7125C4.52083 8.90417 4.28333 9 4 9ZM4 13C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11C4.28333 11 4.52083 11.0958 4.7125 11.2875C4.90417 11.4792 5 11.7167 5 12C5 12.2833 4.90417 12.5208 4.7125 12.7125C4.52083 12.9042 4.28333 13 4 13ZM4 17C3.71667 17 3.47917 16.9042 3.2875 16.7125C3.09583 16.5208 3 16.2833 3 16C3 15.7167 3.09583 15.4792 3.2875 15.2875C3.47917 15.0958 3.71667 15 4 15C4.28333 15 4.52083 15.0958 4.7125 15.2875C4.90417 15.4792 5 15.7167 5 16C5 16.2833 4.90417 16.5208 4.7125 16.7125C4.52083 16.9042 4.28333 17 4 17Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$1a = /*#__PURE__*/forwardRef(SvgList);
var _rect$s, _g$_;
var _excluded$1a = ["title", "titleId"];
function _extends$1a() {
  return _extends$1a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1a.apply(null, arguments);
}
function _objectWithoutProperties$19(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1a(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1a(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgLock = function SvgLock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$19(_ref, _excluded$1a);
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55036_28601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$s || (_rect$s = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$_ || (_g$_ = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55036_28601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$19 = /*#__PURE__*/forwardRef(SvgLock);
var _path$d;
var _excluded$19 = ["title", "titleId"];
function _extends$19() {
  return _extends$19 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$19.apply(null, arguments);
}
function _objectWithoutProperties$18(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$19(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$19(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMailOutline = function SvgMailOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$18(_ref, _excluded$19);
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z",
    fill: "#171D19"
  })));
};
var ForwardRef$18 = /*#__PURE__*/forwardRef(SvgMailOutline);
var _path$c;
var _excluded$18 = ["title", "titleId"];
function _extends$18() {
  return _extends$18 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$18.apply(null, arguments);
}
function _objectWithoutProperties$17(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$18(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$18(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMenu = function SvgMenu(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$17(_ref, _excluded$18);
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8V6H21V8H3ZM3 13H21V11H3V13ZM3 18H21V16H3V18Z",
    fill: "black"
  })));
};
var ForwardRef$17 = /*#__PURE__*/forwardRef(SvgMenu);
var _path$b, _path2$5, _path3$4, _path4$3;
var _excluded$17 = ["title", "titleId"];
function _extends$17() {
  return _extends$17 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$17.apply(null, arguments);
}
function _objectWithoutProperties$16(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$17(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$17(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMissingExtension = function SvgMissingExtension(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$16(_ref, _excluded$17);
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    width: 135,
    height: 133,
    viewBox: "0 0 135 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    d: "M1.45654 42V84C1.45654 85.1046 2.35197 86 3.45654 86H14.9565C16.0611 86 16.9565 85.1046 16.9565 84V79.75C16.9565 74.9175 20.8741 71 25.7065 71C30.539 71 34.4565 74.9175 34.4565 79.75V84C34.4565 85.1046 35.352 86 36.4565 86H45.9565C47.0611 86 47.9565 85.1046 47.9565 84V73C47.9565 71.8954 48.852 71 49.9565 71H54.7065C59.8152 71 63.9565 66.8586 63.9565 61.75C63.9565 56.6414 59.8152 52.5 54.7065 52.5H49.9565C48.852 52.5 47.9565 51.6046 47.9565 50.5V42C47.9565 40.8954 47.0611 40 45.9565 40H3.45654C2.35197 40 1.45654 40.8954 1.45654 42Z",
    stroke: "#3E4A42",
    strokeWidth: 2
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.562 2L65.1886 23C64.232 23.5523 63.9042 24.7755 64.4565 25.732L70.2065 35.6913C70.7588 36.6479 71.982 36.9757 72.9386 36.4234L76.6192 34.2984C80.8043 31.8821 86.1557 33.3161 88.5719 37.5011C90.9882 41.6862 89.5543 47.0376 85.3692 49.4538L81.6886 51.5788C80.732 52.1311 80.4042 53.3543 80.9565 54.3109L85.7065 62.5381C86.2588 63.4947 87.482 63.8225 88.4386 63.2702L97.9649 57.7702C98.9214 57.2179 100.145 57.5456 100.697 58.5022L103.072 62.6159C105.626 67.0401 111.283 68.5559 115.708 66.0016C120.132 63.4473 121.648 57.7901 119.093 53.3659L116.718 49.2522C116.166 48.2956 116.494 47.0725 117.45 46.5202L124.812 42.2702C125.768 41.7179 126.096 40.4947 125.544 39.5381L104.294 2.73205C103.741 1.77547 102.518 1.44771 101.562 2Z",
    stroke: "#BDCAC0",
    strokeWidth: 2
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4565 117.5L48.4565 130C48.4565 131.105 49.352 132 50.4565 132L92.9565 132C94.0611 132 94.9565 131.105 94.9565 130L94.9565 88C94.9565 86.8954 94.0611 86 92.9565 86L81.4565 86C80.352 86 79.4565 86.8954 79.4565 88L79.4565 92.25C79.4565 97.0825 75.539 101 70.7065 101V101C65.8741 101 61.9565 97.0825 61.9565 92.25L61.9565 88C61.9565 86.8954 61.0611 86 59.9565 86L50.4565 86C49.352 86 48.4565 86.8954 48.4565 88L48.4565 99",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2718 86L3.45654 86C2.35197 86 1.45654 86.8954 1.45654 88L1.45654 130C1.45654 131.105 2.35197 132 3.45654 132L46.4565 132C47.5611 132 48.4565 131.105 48.4565 130L48.4565 118.667C48.4565 117.562 47.5611 116.667 46.4565 116.667L41.7864 116.667C37.0058 116.667 33.1305 112.791 33.1305 108.011V108.011C33.1305 103.23 37.0058 99.3548 41.7864 99.3548L46.4565 99.3548C47.5611 99.3548 48.4565 98.4594 48.4565 97.3548L48.4565 88C48.4565 86.8954 47.5611 86 46.4565 86L35.1739 86",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
var ForwardRef$16 = /*#__PURE__*/forwardRef(SvgMissingExtension);
var _path$a;
var _excluded$16 = ["title", "titleId"];
function _extends$16() {
  return _extends$16 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$16.apply(null, arguments);
}
function _objectWithoutProperties$15(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$16(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$16(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMobileFriendly = function SvgMobileFriendly(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$15(_ref, _excluded$16);
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21V3C4 1.9 4.9 1.01 6 1.01L16 1C17.1 1 18 1.9 18 3V7H16V6H6V18H16V17H18V21C18 22.1 17.1 23 16 23H6C4.9 23 4 22.1 4 21ZM16 21V20H6V21H16ZM6 3H16V4H6V3ZM21.2 9.55L19.8 8.15L14.75 13.2L12.4 10.85L11 12.25L14.75 16L21.2 9.55Z",
    fill: "black"
  })));
};
var ForwardRef$15 = /*#__PURE__*/forwardRef(SvgMobileFriendly);
var _g$Z;
var _excluded$15 = ["title", "titleId"];
function _extends$15() {
  return _extends$15 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$15.apply(null, arguments);
}
function _objectWithoutProperties$14(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$15(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$15(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMoreVert = function SvgMoreVert(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$14(_ref, _excluded$15);
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$Z || (_g$Z = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C9.825 6 10.5 5.325 10.5 4.5C10.5 3.675 9.825 3 9 3C8.175 3 7.5 3.675 7.5 4.5C7.5 5.325 8.175 6 9 6ZM9 7.5C8.175 7.5 7.5 8.175 7.5 9C7.5 9.825 8.175 10.5 9 10.5C9.825 10.5 10.5 9.825 10.5 9C10.5 8.175 9.825 7.5 9 7.5ZM7.5 13.5C7.5 12.675 8.175 12 9 12C9.825 12 10.5 12.675 10.5 13.5C10.5 14.325 9.825 15 9 15C8.175 15 7.5 14.325 7.5 13.5Z",
    fill: "#006C47"
  }))));
};
var ForwardRef$14 = /*#__PURE__*/forwardRef(SvgMoreVert);
var _path$9;
var _excluded$14 = ["title", "titleId"];
function _extends$14() {
  return _extends$14 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$14.apply(null, arguments);
}
function _objectWithoutProperties$13(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$14(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$14(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMore = function SvgMore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$13(_ref, _excluded$14);
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12Z",
    fill: "#171D19"
  })));
};
var ForwardRef$13 = /*#__PURE__*/forwardRef(SvgMore);
var _rect$r, _g$Y;
var _excluded$13 = ["title", "titleId"];
function _extends$13() {
  return _extends$13 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$13.apply(null, arguments);
}
function _objectWithoutProperties$12(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$13(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$13(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMoveGroup = function SvgMoveGroup(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$12(_ref, _excluded$13);
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "move_group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2808_13456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$r || (_rect$r = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.000488281,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$Y || (_g$Y = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2808_13456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "move_group_2",
    d: "M8 18.0005C7.45 18.0005 6.97917 17.8047 6.5875 17.413C6.19583 17.0213 6 16.5505 6 16.0005V14.0005H8V16.0005H20V6.00049H8V8.00049H6V4.00049C6 3.45049 6.19583 2.97966 6.5875 2.58799C6.97917 2.19632 7.45 2.00049 8 2.00049H20C20.55 2.00049 21.0208 2.19632 21.4125 2.58799C21.8042 2.97966 22 3.45049 22 4.00049V16.0005C22 16.5505 21.8042 17.0213 21.4125 17.413C21.0208 17.8047 20.55 18.0005 20 18.0005H8ZM4 22.0005C3.45 22.0005 2.97917 21.8047 2.5875 21.413C2.19583 21.0213 2 20.5505 2 20.0005V6.00049H4V20.0005H18V22.0005H4ZM13 15.0005L11.6 13.6005L13.175 12.0005H6V10.0005H13.175L11.6 8.40049L13 7.00049L17 11.0005L13 15.0005Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$12 = /*#__PURE__*/forwardRef(SvgMoveGroup);
var _rect$q, _g$X;
var _excluded$12 = ["title", "titleId"];
function _extends$12() {
  return _extends$12 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$12.apply(null, arguments);
}
function _objectWithoutProperties$11(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$12(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$12(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMoveItem = function SvgMoveItem(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$11(_ref, _excluded$12);
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "move_item"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54808_21902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect$q || (_rect$q = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.433105,
    y: 0.143738,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$X || (_g$X = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54808_21902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "move_item_2",
    d: "M20.5831 13.1437H8.43311V11.1437H20.5831L19.0331 9.59374L20.4331 8.14374L24.4331 12.1437L20.4331 16.1437L19.0331 14.6937L20.5831 13.1437ZM15.4331 9.14374V5.14374H5.43311V19.1437H15.4331V15.1437H17.4331V19.1437C17.4331 19.6937 17.2373 20.1646 16.8456 20.5562C16.4539 20.9479 15.9831 21.1437 15.4331 21.1437H5.43311C4.88311 21.1437 4.41227 20.9479 4.02061 20.5562C3.62894 20.1646 3.43311 19.6937 3.43311 19.1437V5.14374C3.43311 4.59374 3.62894 4.1229 4.02061 3.73124C4.41227 3.33957 4.88311 3.14374 5.43311 3.14374H15.4331C15.9831 3.14374 16.4539 3.33957 16.8456 3.73124C17.2373 4.1229 17.4331 4.59374 17.4331 5.14374V9.14374H15.4331Z",
    fill: "black"
  })))));
};
var ForwardRef$11 = /*#__PURE__*/forwardRef(SvgMoveItem);
var _rect$p, _g$W;
var _excluded$11 = ["title", "titleId"];
function _extends$11() {
  return _extends$11 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$11.apply(null, arguments);
}
function _objectWithoutProperties$10(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$11(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$11(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgMystery = function SvgMystery(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$10(_ref, _excluded$11);
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56017_27545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$p || (_rect$p = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$W || (_g$W = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56017_27545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18C12.9333 18 14.5833 17.3208 15.95 15.9625C17.3167 14.6042 18 12.95 18 11C18 9.06667 17.3167 7.41667 15.95 6.05C14.5833 4.68333 12.9333 4 11 4C9.05 4 7.39583 4.68333 6.0375 6.05C4.67917 7.41667 4 9.06667 4 11C4 12.95 4.67917 14.6042 6.0375 15.9625C7.39583 17.3208 9.05 18 11 18ZM11 15C9.61667 15 8.3875 14.6292 7.3125 13.8875C6.2375 13.1458 5.46667 12.1833 5 11C5.46667 9.83333 6.2375 8.875 7.3125 8.125C8.3875 7.375 9.61667 7 11 7C12.3667 7 13.5875 7.375 14.6625 8.125C15.7375 8.875 16.5167 9.83333 17 11C16.5167 12.1833 15.7375 13.1458 14.6625 13.8875C13.5875 14.6292 12.3667 15 11 15ZM11 13.5C11.9167 13.5 12.7583 13.2792 13.525 12.8375C14.2917 12.3958 14.8917 11.7833 15.325 11C14.8917 10.2333 14.2917 9.625 13.525 9.175C12.7583 8.725 11.9167 8.5 11 8.5C10.0667 8.5 9.21667 8.725 8.45 9.175C7.68333 9.625 7.08333 10.2333 6.65 11C7.08333 11.7833 7.68333 12.3958 8.45 12.8375C9.21667 13.2792 10.0667 13.5 11 13.5ZM11 12.5C11.4167 12.5 11.7708 12.3583 12.0625 12.075C12.3542 11.7917 12.5 11.4333 12.5 11C12.5 10.5833 12.3542 10.2292 12.0625 9.9375C11.7708 9.64583 11.4167 9.5 11 9.5C10.5667 9.5 10.2083 9.64583 9.925 9.9375C9.64167 10.2292 9.5 10.5833 9.5 11C9.5 11.4333 9.64167 11.7917 9.925 12.075C10.2083 12.3583 10.5667 12.5 11 12.5ZM11 20C9.75 20 8.57917 19.7625 7.4875 19.2875C6.39583 18.8125 5.44583 18.1708 4.6375 17.3625C3.82917 16.5542 3.1875 15.6042 2.7125 14.5125C2.2375 13.4208 2 12.25 2 11C2 9.76667 2.2375 8.60417 2.7125 7.5125C3.1875 6.42083 3.82917 5.46667 4.6375 4.65C5.44583 3.83333 6.39583 3.1875 7.4875 2.7125C8.57917 2.2375 9.75 2 11 2C12.2333 2 13.3958 2.2375 14.4875 2.7125C15.5792 3.1875 16.5333 3.83333 17.35 4.65C18.1667 5.46667 18.8125 6.42083 19.2875 7.5125C19.7625 8.60417 20 9.76667 20 11C20 12.0667 19.825 13.075 19.475 14.025C19.125 14.975 18.6417 15.8417 18.025 16.625L22 20.6L20.575 22L16.6 18.05C15.8167 18.6667 14.95 19.1458 14 19.4875C13.05 19.8292 12.05 20 11 20Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$10 = /*#__PURE__*/forwardRef(SvgMystery);
var _path$8;
var _excluded$10 = ["title", "titleId"];
function _extends$10() {
  return _extends$10 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$10.apply(null, arguments);
}
function _objectWithoutProperties$$(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$10(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$10(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNavigateBefore = function SvgNavigateBefore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$$(_ref, _excluded$10);
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z",
    fill: "#3E4A42"
  })));
};
var ForwardRef$$ = /*#__PURE__*/forwardRef(SvgNavigateBefore);
var _path$7;
var _excluded$$ = ["title", "titleId"];
function _extends$$() {
  return _extends$$ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$$.apply(null, arguments);
}
function _objectWithoutProperties$_(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$$(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$$(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNavigateNext = function SvgNavigateNext(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$_(_ref, _excluded$$);
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z",
    fill: "#3E4A42"
  })));
};
var ForwardRef$_ = /*#__PURE__*/forwardRef(SvgNavigateNext);
var _g$V, _defs$r;
var _excluded$_ = ["title", "titleId"];
function _extends$_() {
  return _extends$_ = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$_.apply(null, arguments);
}
function _objectWithoutProperties$Z(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$_(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$_(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNotEquals = function SvgNotEquals(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$Z(_ref, _excluded$_);
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$V || (_g$V = /*#__PURE__*/React.createElement("g", {
    id: "NotEquals",
    clipPath: "url(#clip0_55944_27553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 15H20.25",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.75 9H20.25",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5 3.75L4.5 20.25",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$r || (_defs$r = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55944_27553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$Z = /*#__PURE__*/forwardRef(SvgNotEquals);
var _rect$o, _g$U;
var _excluded$Z = ["title", "titleId"];
function _extends$Z() {
  return _extends$Z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$Z.apply(null, arguments);
}
function _objectWithoutProperties$Y(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$Z(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$Z(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPageInfo = function SvgPageInfo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$Y(_ref, _excluded$Z);
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2285_7865",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect$o || (_rect$o = /*#__PURE__*/React.createElement("rect", {
    x: 0.400024,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$U || (_g$U = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2285_7865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.15 20.25C17.1 20.25 16.2125 19.8875 15.4875 19.1625C14.7625 18.4375 14.4 17.55 14.4 16.5C14.4 15.45 14.7625 14.5625 15.4875 13.8375C16.2125 13.1125 17.1 12.75 18.15 12.75C19.2 12.75 20.0875 13.1125 20.8125 13.8375C21.5375 14.5625 21.9 15.45 21.9 16.5C21.9 17.55 21.5375 18.4375 20.8125 19.1625C20.0875 19.8875 19.2 20.25 18.15 20.25ZM18.15 18.25C18.6334 18.25 19.0459 18.0792 19.3875 17.7375C19.7292 17.3958 19.9 16.9833 19.9 16.5C19.9 16.0167 19.7292 15.6042 19.3875 15.2625C19.0459 14.9208 18.6334 14.75 18.15 14.75C17.6667 14.75 17.2542 14.9208 16.9125 15.2625C16.5709 15.6042 16.4 16.0167 16.4 16.5C16.4 16.9833 16.5709 17.3958 16.9125 17.7375C17.2542 18.0792 17.6667 18.25 18.15 18.25ZM11.4 17.5H5.40002C5.11669 17.5 4.87919 17.4042 4.68752 17.2125C4.49586 17.0208 4.40002 16.7833 4.40002 16.5C4.40002 16.2167 4.49586 15.9792 4.68752 15.7875C4.87919 15.5958 5.11669 15.5 5.40002 15.5H11.4C11.6834 15.5 11.9209 15.5958 12.1125 15.7875C12.3042 15.9792 12.4 16.2167 12.4 16.5C12.4 16.7833 12.3042 17.0208 12.1125 17.2125C11.9209 17.4042 11.6834 17.5 11.4 17.5ZM6.65002 11.25C5.60002 11.25 4.71252 10.8875 3.98752 10.1625C3.26252 9.4375 2.90002 8.55 2.90002 7.5C2.90002 6.45 3.26252 5.5625 3.98752 4.8375C4.71252 4.1125 5.60002 3.75 6.65002 3.75C7.70002 3.75 8.58752 4.1125 9.31252 4.8375C10.0375 5.5625 10.4 6.45 10.4 7.5C10.4 8.55 10.0375 9.4375 9.31252 10.1625C8.58752 10.8875 7.70002 11.25 6.65002 11.25ZM6.65002 9.25C7.13336 9.25 7.54586 9.07917 7.88752 8.7375C8.22919 8.39583 8.40002 7.98333 8.40002 7.5C8.40002 7.01667 8.22919 6.60417 7.88752 6.2625C7.54586 5.92083 7.13336 5.75 6.65002 5.75C6.16669 5.75 5.75419 5.92083 5.41252 6.2625C5.07086 6.60417 4.90002 7.01667 4.90002 7.5C4.90002 7.98333 5.07086 8.39583 5.41252 8.7375C5.75419 9.07917 6.16669 9.25 6.65002 9.25ZM19.4 8.5H13.4C13.1167 8.5 12.8792 8.40417 12.6875 8.2125C12.4959 8.02083 12.4 7.78333 12.4 7.5C12.4 7.21667 12.4959 6.97917 12.6875 6.7875C12.8792 6.59583 13.1167 6.5 13.4 6.5H19.4C19.6834 6.5 19.9209 6.59583 20.1125 6.7875C20.3042 6.97917 20.4 7.21667 20.4 7.5C20.4 7.78333 20.3042 8.02083 20.1125 8.2125C19.9209 8.40417 19.6834 8.5 19.4 8.5Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$Y = /*#__PURE__*/forwardRef(SvgPageInfo);
var _g$T, _defs$q;
var _excluded$Y = ["title", "titleId"];
function _extends$Y() {
  return _extends$Y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$Y.apply(null, arguments);
}
function _objectWithoutProperties$X(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$Y(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$Y(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPaperPlaneTilt = function SvgPaperPlaneTilt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$X(_ref, _excluded$Y);
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$T || (_g$T = /*#__PURE__*/React.createElement("g", {
    id: "PaperPlaneTilt",
    clipPath: "url(#clip0_1026_28327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9714 20.5165L22.18 13.308",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.0089 5.84709C31.0623 5.65739 31.0643 5.45686 31.0145 5.26616C30.9647 5.07546 30.865 4.90147 30.7256 4.76211C30.5863 4.62274 30.4123 4.52303 30.2216 4.47325C30.0309 4.42346 29.8303 4.4254 29.6406 4.47886L3.02458 12.5496C2.80728 12.611 2.61388 12.7371 2.47022 12.9113C2.32657 13.0855 2.2395 13.2994 2.22066 13.5244C2.20183 13.7494 2.25211 13.9748 2.36481 14.1704C2.4775 14.3661 2.64722 14.5227 2.8513 14.6193L14.9713 20.5164L20.8684 32.635C20.965 32.8391 21.1216 33.0088 21.3173 33.1215C21.5129 33.2342 21.7383 33.2845 21.9633 33.2657C22.1883 33.2468 22.4022 33.1598 22.5764 33.0161C22.7506 32.8725 22.8768 32.6791 22.9381 32.4618L31.0089 5.84709Z",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$q || (_defs$q = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_28327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.4881,
    height: 35.4881,
    fill: "white"
  })))));
};
var ForwardRef$X = /*#__PURE__*/forwardRef(SvgPaperPlaneTilt);
var _g$S, _defs$p;
var _excluded$X = ["title", "titleId"];
function _extends$X() {
  return _extends$X = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$X.apply(null, arguments);
}
function _objectWithoutProperties$W(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$X(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$X(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPdf = function SvgPdf(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$W(_ref, _excluded$X);
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$S || (_g$S = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55285_27456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.25H17.25V19.5",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.25H17.25",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18H6C6.49728 18 6.97419 17.8025 7.32583 17.4508C7.67746 17.0992 7.875 16.6223 7.875 16.125C7.875 15.6277 7.67746 15.1508 7.32583 14.7992C6.97419 14.4475 6.49728 14.25 6 14.25H4.5V19.5",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.25V19.5H12C12.6962 19.5 13.3639 19.2234 13.8562 18.7312C14.3484 18.2389 14.625 17.5712 14.625 16.875C14.625 16.1788 14.3484 15.5111 13.8562 15.0188C13.3639 14.5266 12.6962 14.25 12 14.25H10.5Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H14.25L19.5 8.25V10.5",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3V8.25H19.5",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$p || (_defs$p = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55285_27456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$W = /*#__PURE__*/forwardRef(SvgPdf);
var _rect$n, _g$R;
var _excluded$W = ["title", "titleId"];
function _extends$W() {
  return _extends$W = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$W.apply(null, arguments);
}
function _objectWithoutProperties$V(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$W(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$W(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPendingActions = function SvgPendingActions(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$V(_ref, _excluded$W);
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_12046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect$n || (_rect$n = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g$R || (_g$R = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 29.333C20.8222 29.333 19.25 28.683 17.95 27.383C16.65 26.083 16 24.5108 16 22.6663C16 20.8219 16.65 19.2497 17.95 17.9497C19.25 16.6497 20.8222 15.9997 22.6667 15.9997C24.5111 15.9997 26.0833 16.6497 27.3833 17.9497C28.6833 19.2497 29.3333 20.8219 29.3333 22.6663C29.3333 24.5108 28.6833 26.083 27.3833 27.383C26.0833 28.683 24.5111 29.333 22.6667 29.333ZM24.9 25.833L25.8333 24.8997L23.3333 22.3997V18.6663H22V22.933L24.9 25.833ZM6.66667 27.9997C5.93333 27.9997 5.30556 27.7386 4.78333 27.2163C4.26111 26.6941 4 26.0663 4 25.333V6.66634C4 5.93301 4.26111 5.30523 4.78333 4.78301C5.30556 4.26079 5.93333 3.99967 6.66667 3.99967H12.2333C12.4778 3.2219 12.9556 2.58301 13.6667 2.08301C14.3778 1.58301 15.1556 1.33301 16 1.33301C16.8889 1.33301 17.6833 1.58301 18.3833 2.08301C19.0833 2.58301 19.5556 3.2219 19.8 3.99967H25.3333C26.0667 3.99967 26.6944 4.26079 27.2167 4.78301C27.7389 5.30523 28 5.93301 28 6.66634V14.9997C27.6 14.7108 27.1778 14.4663 26.7333 14.2663C26.2889 14.0663 25.8222 13.8886 25.3333 13.733V6.66634H22.6667V10.6663H9.33333V6.66634H6.66667V25.333H13.7333C13.8889 25.8219 14.0667 26.2886 14.2667 26.733C14.4667 27.1775 14.7111 27.5997 15 27.9997H6.66667ZM16 6.66634C16.3778 6.66634 16.6944 6.53856 16.95 6.28301C17.2056 6.02745 17.3333 5.71079 17.3333 5.33301C17.3333 4.95523 17.2056 4.63856 16.95 4.38301C16.6944 4.12745 16.3778 3.99967 16 3.99967C15.6222 3.99967 15.3056 4.12745 15.05 4.38301C14.7944 4.63856 14.6667 4.95523 14.6667 5.33301C14.6667 5.71079 14.7944 6.02745 15.05 6.28301C15.3056 6.53856 15.6222 6.66634 16 6.66634Z",
    fill: "#BDCAC0"
  }))));
};
var ForwardRef$V = /*#__PURE__*/forwardRef(SvgPendingActions);
var _rect$m, _g$Q;
var _excluded$V = ["title", "titleId"];
function _extends$V() {
  return _extends$V = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$V.apply(null, arguments);
}
function _objectWithoutProperties$U(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$V(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$V(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPeople = function SvgPeople(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$U(_ref, _excluded$V);
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2031_23255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$m || (_rect$m = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$Q || (_g$Q = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2031_23255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 20V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V20H1ZM19 20V17C19 16.2667 18.7958 15.5625 18.3875 14.8875C17.9792 14.2125 17.4 13.6333 16.65 13.15C17.5 13.25 18.3 13.4208 19.05 13.6625C19.8 13.9042 20.5 14.2 21.15 14.55C21.75 14.8833 22.2083 15.2542 22.525 15.6625C22.8417 16.0708 23 16.5167 23 17V20H19ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM19 8C19 9.1 18.6083 10.0417 17.825 10.825C17.0417 11.6083 16.1 12 15 12C14.8167 12 14.5833 11.9792 14.3 11.9375C14.0167 11.8958 13.7833 11.85 13.6 11.8C14.05 11.2667 14.3958 10.675 14.6375 10.025C14.8792 9.375 15 8.7 15 8C15 7.3 14.8792 6.625 14.6375 5.975C14.3958 5.325 14.05 4.73333 13.6 4.2C13.8333 4.11667 14.0667 4.0625 14.3 4.0375C14.5333 4.0125 14.7667 4 15 4C16.1 4 17.0417 4.39167 17.825 5.175C18.6083 5.95833 19 6.9 19 8ZM3 18H15V17.2C15 17.0167 14.9542 16.85 14.8625 16.7C14.7708 16.55 14.65 16.4333 14.5 16.35C13.6 15.9 12.6917 15.5625 11.775 15.3375C10.8583 15.1125 9.93333 15 9 15C8.06667 15 7.14167 15.1125 6.225 15.3375C5.30833 15.5625 4.4 15.9 3.5 16.35C3.35 16.4333 3.22917 16.55 3.1375 16.7C3.04583 16.85 3 17.0167 3 17.2V18ZM9 10C9.55 10 10.0208 9.80417 10.4125 9.4125C10.8042 9.02083 11 8.55 11 8C11 7.45 10.8042 6.97917 10.4125 6.5875C10.0208 6.19583 9.55 6 9 6C8.45 6 7.97917 6.19583 7.5875 6.5875C7.19583 6.97917 7 7.45 7 8C7 8.55 7.19583 9.02083 7.5875 9.4125C7.97917 9.80417 8.45 10 9 10Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$U = /*#__PURE__*/forwardRef(SvgPeople);
var _g$P;
var _excluded$U = ["title", "titleId"];
function _extends$U() {
  return _extends$U = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$U.apply(null, arguments);
}
function _objectWithoutProperties$T(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$U(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$U(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPersonOutline = function SvgPersonOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$T(_ref, _excluded$U);
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$P || (_g$P = /*#__PURE__*/React.createElement("g", {
    id: "Icons/person_outline_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14 8C14 6.9 13.1 6 12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C13.1 10 14 9.1 14 8ZM18 17C17.8 16.29 14.7 15 12 15C9.3 15 6.2 16.29 6 17.01V18H18V17ZM4 17C4 14.34 9.33 13 12 13C14.67 13 20 14.34 20 17V20H4V17Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$T = /*#__PURE__*/forwardRef(SvgPersonOutline);
var _rect$l, _g$O;
var _excluded$T = ["title", "titleId"];
function _extends$T() {
  return _extends$T = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$T.apply(null, arguments);
}
function _objectWithoutProperties$S(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$T(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$T(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPin = function SvgPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$S(_ref, _excluded$T);
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4110_32857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$l || (_rect$l = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$O || (_g$O = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4110_32857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM6.5 15H7.65V9H6.75L5 10.25L5.6 11.15L6.5 10.5V15ZM9.6 15H13.5V14H11.15L11.1 13.95C11.45 13.6167 11.7375 13.3333 11.9625 13.1C12.1875 12.8667 12.3667 12.6833 12.5 12.55C12.8 12.25 13.025 11.95 13.175 11.65C13.325 11.35 13.4 11.0333 13.4 10.7C13.4 10.2167 13.2167 9.8125 12.85 9.4875C12.4833 9.1625 12.0167 9 11.45 9C11.0167 9 10.625 9.125 10.275 9.375C9.925 9.625 9.68333 9.95 9.55 10.35L10.55 10.75C10.6333 10.5333 10.7542 10.3625 10.9125 10.2375C11.0708 10.1125 11.25 10.05 11.45 10.05C11.7 10.05 11.9042 10.1167 12.0625 10.25C12.2208 10.3833 12.3 10.55 12.3 10.75C12.3 10.9333 12.2667 11.1042 12.2 11.2625C12.1333 11.4208 11.9833 11.6167 11.75 11.85L9.6 14V15ZM17 15C17.6 15 18.0833 14.8333 18.45 14.5C18.8167 14.1667 19 13.7333 19 13.2C19 12.9 18.9167 12.6333 18.75 12.4C18.5833 12.1667 18.35 11.9833 18.05 11.85V11.8C18.2833 11.6667 18.4667 11.4958 18.6 11.2875C18.7333 11.0792 18.8 10.8333 18.8 10.55C18.8 10.1 18.625 9.72917 18.275 9.4375C17.925 9.14583 17.4833 9 16.95 9C16.5333 9 16.1458 9.12083 15.7875 9.3625C15.4292 9.60417 15.2 9.9 15.1 10.25L16.1 10.65C16.1667 10.45 16.275 10.2917 16.425 10.175C16.575 10.0583 16.75 10 16.95 10C17.1667 10 17.3458 10.0625 17.4875 10.1875C17.6292 10.3125 17.7 10.4667 17.7 10.65C17.7 10.8833 17.6167 11.0667 17.45 11.2C17.2833 11.3333 17.0667 11.4 16.8 11.4H16.35V12.4H16.85C17.1833 12.4 17.4417 12.4667 17.625 12.6C17.8083 12.7333 17.9 12.9167 17.9 13.15C17.9 13.3667 17.8083 13.5542 17.625 13.7125C17.4417 13.8708 17.2333 13.95 17 13.95C16.7167 13.95 16.5 13.8875 16.35 13.7625C16.2 13.6375 16.0667 13.4167 15.95 13.1L14.95 13.5C15.0667 13.9833 15.3042 14.3542 15.6625 14.6125C16.0208 14.8708 16.4667 15 17 15ZM4 18H20V6H4V18Z",
    fill: "#3E4A42"
  }))));
};
var ForwardRef$S = /*#__PURE__*/forwardRef(SvgPin);
var _rect$k, _g$N;
var _excluded$S = ["title", "titleId"];
function _extends$S() {
  return _extends$S = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$S.apply(null, arguments);
}
function _objectWithoutProperties$R(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$S(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$S(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPriceChange = function SvgPriceChange(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$R(_ref, _excluded$S);
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56403_27936",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$k || (_rect$k = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$N || (_g$N = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56403_27936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "price_change",
    d: "M2 20V4H22V20H2ZM4 18H20V6H4V18ZM8 17H10V16H11C11.2833 16 11.5208 15.9042 11.7125 15.7125C11.9042 15.5208 12 15.2833 12 15V12C12 11.7167 11.9042 11.4792 11.7125 11.2875C11.5208 11.0958 11.2833 11 11 11H8V10H12V8H10V7H8V8H7C6.71667 8 6.47917 8.09583 6.2875 8.2875C6.09583 8.47917 6 8.71667 6 9V12C6 12.2833 6.09583 12.5208 6.2875 12.7125C6.47917 12.9042 6.71667 13 7 13H10V14H6V16H8V17ZM16 16.25L18 14.25H14L16 16.25ZM14 10H18L16 8L14 10Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$R = /*#__PURE__*/forwardRef(SvgPriceChange);
var _rect$j, _g$M;
var _excluded$R = ["title", "titleId"];
function _extends$R() {
  return _extends$R = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$R.apply(null, arguments);
}
function _objectWithoutProperties$Q(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$R(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$R(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPrint = function SvgPrint(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$Q(_ref, _excluded$R);
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1015_6477",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$j || (_rect$j = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$M || (_g$M = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1015_6477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30729 20.4998C7.81017 20.4998 7.38461 20.3228 7.03061 19.9688C6.67659 19.6148 6.49959 19.1893 6.49959 18.6921V16.4998H4.59576C4.09864 16.4998 3.67309 16.3228 3.31909 15.9688C2.96509 15.6148 2.78809 15.1893 2.78809 14.6921V10.8075C2.78809 10.0992 3.03007 9.50548 3.51404 9.02632C3.998 8.54717 4.58934 8.30759 5.28804 8.30759H18.7111C19.4194 8.30759 20.0131 8.54717 20.4923 9.02632C20.9715 9.50548 21.211 10.0992 21.211 10.8075V14.6921C21.211 15.1893 21.034 15.6148 20.68 15.9688C20.326 16.3228 19.9005 16.4998 19.4034 16.4998H17.4995V18.6921C17.4995 19.1893 17.3225 19.6148 16.9685 19.9688C16.6145 20.3228 16.189 20.4998 15.6918 20.4998H8.30729ZM4.59576 14.9999H6.49959C6.51242 14.514 6.69395 14.0976 7.04419 13.7508C7.39442 13.404 7.81545 13.2306 8.30729 13.2306H15.6918C16.1837 13.2306 16.6047 13.404 16.9549 13.7508C17.3052 14.0976 17.4867 14.514 17.4995 14.9999H19.4034C19.4931 14.9999 19.5668 14.971 19.6245 14.9133C19.6822 14.8556 19.7111 14.7819 19.7111 14.6921V10.8075C19.7111 10.5242 19.6153 10.2867 19.4236 10.095C19.2319 9.90338 18.9944 9.80754 18.7111 9.80754H5.28804C5.0047 9.80754 4.7672 9.90338 4.57554 10.095C4.38387 10.2867 4.28804 10.5242 4.28804 10.8075V14.6921C4.28804 14.7819 4.31689 14.8556 4.37459 14.9133C4.43229 14.971 4.50601 14.9999 4.59576 14.9999ZM15.9996 8.30759V5.61529C15.9996 5.52554 15.9707 5.45182 15.913 5.39412C15.8553 5.33643 15.7816 5.30759 15.6918 5.30759H8.30729C8.21754 5.30759 8.14381 5.33643 8.08611 5.39412C8.02841 5.45182 7.99956 5.52554 7.99956 5.61529V8.30759H6.49959V5.61529C6.49959 5.11819 6.67659 4.69263 7.03061 4.33862C7.38461 3.98462 7.81017 3.80762 8.30729 3.80762H15.6918C16.189 3.80762 16.6145 3.98462 16.9685 4.33862C17.3225 4.69263 17.4995 5.11819 17.4995 5.61529V8.30759H15.9996ZM17.8072 12.3075C18.0906 12.3075 18.3281 12.2117 18.5197 12.02C18.7114 11.8284 18.8072 11.5909 18.8072 11.3075C18.8072 11.0242 18.7114 10.7867 18.5197 10.595C18.3281 10.4034 18.0906 10.3075 17.8072 10.3075C17.5239 10.3075 17.2864 10.4034 17.0947 10.595C16.9031 10.7867 16.8072 11.0242 16.8072 11.3075C16.8072 11.5909 16.9031 11.8284 17.0947 12.02C17.2864 12.2117 17.5239 12.3075 17.8072 12.3075ZM15.9996 18.6921V15.0383C15.9996 14.9486 15.9707 14.8749 15.913 14.8172C15.8553 14.7595 15.7816 14.7306 15.6918 14.7306H8.30729C8.21754 14.7306 8.14381 14.7595 8.08611 14.8172C8.02841 14.8749 7.99956 14.9486 7.99956 15.0383V18.6921C7.99956 18.7819 8.02841 18.8556 8.08611 18.9133C8.14381 18.971 8.21754 18.9999 8.30729 18.9999H15.6918C15.7816 18.9999 15.8553 18.971 15.913 18.9133C15.9707 18.8556 15.9996 18.7819 15.9996 18.6921Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$Q = /*#__PURE__*/forwardRef(SvgPrint);
var _g$L, _defs$o;
var _excluded$Q = ["title", "titleId"];
function _extends$Q() {
  return _extends$Q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$Q.apply(null, arguments);
}
function _objectWithoutProperties$P(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$Q(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$Q(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgProjectGroup = function SvgProjectGroup(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$P(_ref, _excluded$Q);
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$L || (_g$L = /*#__PURE__*/React.createElement("g", {
    id: "Project Group",
    clipPath: "url(#clip0_2705_33798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 11V19.3334C18.75 19.421 18.7328 19.5076 18.6993 19.5885C18.6658 19.6694 18.6167 19.7429 18.5548 19.8048C18.4929 19.8667 18.4194 19.9158 18.3385 19.9493C18.2576 19.9828 18.171 20 18.0834 20H3.75C3.55109 20 3.36032 19.921 3.21967 19.7803C3.07902 19.6397 3 19.4489 3 19.25V8.75C3 8.55109 3.07902 8.36032 3.21967 8.21967C3.36032 8.07902 3.55109 8 3.75 8H7.99969C8.16197 8 8.31987 8.05263 8.44969 8.15L11.25 10.25H18C18.1989 10.25 18.3897 10.329 18.5303 10.4697C18.671 10.6103 18.75 10.8011 18.75 11Z",
    stroke: "#3E4A42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.75 11V19.3334C18.75 19.421 18.7328 19.5076 18.6993 19.5885C18.6658 19.6694 18.6167 19.7429 18.5548 19.8048C18.4929 19.8667 18.4194 19.9158 18.3385 19.9493C18.2576 19.9828 18.171 20 18.0834 20H3.75C3.55109 20 3.36032 19.921 3.21967 19.7803C3.07902 19.6397 3 19.4489 3 19.25V8.75C3 8.55109 3.07902 8.36032 3.21967 8.21967C3.36032 8.07902 3.55109 8 3.75 8H7.99969C8.16197 8 8.31987 8.05263 8.44969 8.15L11.25 10.25H18C18.1989 10.25 18.3897 10.329 18.5303 10.4697C18.671 10.6103 18.75 10.8011 18.75 11Z",
    stroke: "#3E4A42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6 8V5.75C6 5.55109 6.07902 5.36032 6.21967 5.21967C6.36032 5.07902 6.55109 5 6.75 5H10.9997C11.162 5 11.3199 5.05263 11.4497 5.15L14.25 7.25H21C21.1989 7.25 21.3897 7.32902 21.5303 7.46967C21.671 7.61032 21.75 7.80109 21.75 8V16.3334C21.75 16.5102 21.6798 16.6798 21.5548 16.8048C21.4298 16.9298 21.2602 17 21.0834 17H18.75",
    stroke: "#3E4A42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$o || (_defs$o = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2705_33798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef$P = /*#__PURE__*/forwardRef(SvgProjectGroup);
var _path$6, _path2$4;
var _excluded$P = ["title", "titleId"];
function _extends$P() {
  return _extends$P = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$P.apply(null, arguments);
}
function _objectWithoutProperties$O(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$P(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$P(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgRadioButtonChecked = function SvgRadioButtonChecked(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$O(_ref, _excluded$P);
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "#3E4A42"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
    fill: "#3E4A42"
  })));
};
var ForwardRef$O = /*#__PURE__*/forwardRef(SvgRadioButtonChecked);
var _rect$i, _g$K;
var _excluded$O = ["title", "titleId"];
function _extends$O() {
  return _extends$O = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$O.apply(null, arguments);
}
function _objectWithoutProperties$N(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$O(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$O(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgRedo = function SvgRedo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$N(_ref, _excluded$O);
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "redo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56027_27566",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$i || (_rect$i = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$K || (_g$K = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56027_27566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "redo_2",
    d: "M9.9 19C8.28333 19 6.89583 18.475 5.7375 17.425C4.57917 16.375 4 15.0667 4 13.5C4 11.9333 4.57917 10.625 5.7375 9.575C6.89583 8.525 8.28333 8 9.9 8H16.2L13.6 5.4L15 4L20 9L15 14L13.6 12.6L16.2 10H9.9C8.85 10 7.9375 10.3333 7.1625 11C6.3875 11.6667 6 12.5 6 13.5C6 14.5 6.3875 15.3333 7.1625 16C7.9375 16.6667 8.85 17 9.9 17H17V19H9.9Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$N = /*#__PURE__*/forwardRef(SvgRedo);
var _g$J, _defs$n;
var _excluded$N = ["title", "titleId"];
function _extends$N() {
  return _extends$N = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$N.apply(null, arguments);
}
function _objectWithoutProperties$M(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$N(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$N(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgRegistration = function SvgRegistration(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$M(_ref, _excluded$N);
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 455,
    height: 455,
    viewBox: "0 0 455 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$J || (_g$J = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04,
    clipPath: "url(#clip0_3224_22134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.672 383.906H426.562V127.969C426.562 120.427 423.566 113.193 418.233 107.86C412.9 102.527 405.667 99.5312 398.125 99.5312H362.578V7.10938C362.578 5.22385 361.829 3.41555 360.496 2.08229C359.163 0.749021 357.354 0 355.469 0L99.5312 0C97.6457 0 95.8374 0.749021 94.5042 2.08229C93.1709 3.41555 92.4219 5.22385 92.4219 7.10938V99.5312H56.875C49.3329 99.5312 42.0997 102.527 36.7667 107.86C31.4336 113.193 28.4375 120.427 28.4375 127.969V383.906H21.3281C15.6716 383.906 10.2467 386.153 6.24686 390.153C2.24706 394.153 0 399.578 0 405.234L0 419.453C0 428.881 3.74511 437.922 10.4114 444.589C17.0778 451.255 26.1193 455 35.5469 455H419.453C428.881 455 437.922 451.255 444.589 444.589C451.255 437.922 455 428.881 455 419.453V405.234C455 399.578 452.753 394.153 448.753 390.153C444.753 386.153 439.328 383.906 433.672 383.906ZM71.0938 355.469V142.188H92.4219V355.469H71.0938ZM106.641 56.875H348.359V355.469H106.641V56.875ZM362.578 142.188H383.906V355.469H362.578V142.188ZM106.641 14.2188H348.359V42.6562H106.641V14.2188ZM42.6562 127.969C42.6562 124.198 44.1543 120.581 46.8208 117.915C49.4874 115.248 53.104 113.75 56.875 113.75H92.4219V127.969H63.9844C62.0989 127.969 60.2906 128.718 58.9573 130.051C57.624 131.384 56.875 133.193 56.875 135.078V362.578C56.875 364.464 57.624 366.272 58.9573 367.605C60.2906 368.938 62.0989 369.688 63.9844 369.688H391.016C392.901 369.688 394.709 368.938 396.043 367.605C397.376 366.272 398.125 364.464 398.125 362.578V135.078C398.125 133.193 397.376 131.384 396.043 130.051C394.709 128.718 392.901 127.969 391.016 127.969H362.578V113.75H398.125C401.896 113.75 405.513 115.248 408.179 117.915C410.846 120.581 412.344 124.198 412.344 127.969V383.906H42.6562V127.969ZM285.299 398.125L280.536 405.234H174.464L169.701 398.125H285.299ZM440.781 419.453C440.781 425.11 438.534 430.535 434.534 434.534C430.535 438.534 425.11 440.781 419.453 440.781H35.5469C29.8903 440.781 24.4654 438.534 20.4656 434.534C16.4658 430.535 14.2188 425.11 14.2188 419.453V405.234C14.2188 403.349 14.9678 401.541 16.301 400.207C17.6343 398.874 19.4426 398.125 21.3281 398.125H152.567L164.724 416.254C167.71 420.804 161.809 419.453 284.375 419.453C289.28 419.453 289.636 417.32 302.433 398.125H433.672C435.557 398.125 437.366 398.874 438.699 400.207C440.032 401.541 440.781 403.349 440.781 405.234V419.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.969 21.3281C126.083 21.3281 124.275 22.0771 122.942 23.4104C121.608 24.7437 120.859 26.552 120.859 28.4375C120.859 30.323 121.608 32.1313 122.942 33.4646C124.275 34.7979 126.083 35.5469 127.969 35.5469C129.854 35.5469 131.663 34.7979 132.996 33.4646C134.329 32.1313 135.078 30.323 135.078 28.4375C135.078 26.552 134.329 24.7437 132.996 23.4104C131.663 22.0771 129.854 21.3281 127.969 21.3281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.406 21.3281C154.521 21.3281 152.712 22.0771 151.379 23.4104C150.046 24.7437 149.297 26.552 149.297 28.4375C149.297 30.323 150.046 32.1313 151.379 33.4646C152.712 34.7979 154.521 35.5469 156.406 35.5469C158.292 35.5469 160.1 34.7979 161.433 33.4646C162.767 32.1313 163.516 30.323 163.516 28.4375C163.516 26.552 162.767 24.7437 161.433 23.4104C160.1 22.0771 158.292 21.3281 156.406 21.3281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.844 21.3281C182.958 21.3281 181.15 22.0771 179.817 23.4104C178.483 24.7437 177.734 26.552 177.734 28.4375C177.734 30.323 178.483 32.1313 179.817 33.4646C181.15 34.7979 182.958 35.5469 184.844 35.5469C186.729 35.5469 188.538 34.7979 189.871 33.4646C191.204 32.1313 191.953 30.323 191.953 28.4375C191.953 26.552 191.204 24.7437 189.871 23.4104C188.538 22.0771 186.729 21.3281 184.844 21.3281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.241 208.234C183.859 214.966 192.758 220.092 202.404 223.305C212.746 226.786 223.699 228.078 234.567 227.099C245.435 226.119 255.981 222.891 265.535 217.618C335.989 178.445 307.551 71.0938 227.5 71.0938C211.591 71.1229 196.069 76.0037 183.006 85.0846C169.943 94.1655 159.96 107.015 154.39 121.917C148.82 136.819 147.927 153.066 151.832 168.489C155.736 183.911 164.251 197.777 176.241 208.234ZM208.731 136.358V129.888C208.731 124.91 210.708 120.137 214.228 116.617C217.748 113.097 222.522 111.12 227.5 111.12C232.478 111.12 237.251 113.097 240.771 116.617C244.291 120.137 246.269 124.91 246.269 129.888V136.358C246.269 141.336 244.291 146.109 240.771 149.629C237.251 153.149 232.478 155.127 227.5 155.127C222.522 155.127 217.748 153.149 214.228 149.629C210.708 146.109 208.731 141.336 208.731 136.358ZM263.615 202.048C252.976 209.323 240.388 213.216 227.5 213.216C214.611 213.216 202.023 209.323 191.384 202.048C189.251 200.555 189.536 201.693 191.384 194.939C193.914 187.461 198.724 180.964 205.139 176.362C211.554 171.76 219.25 169.285 227.144 169.285C235.039 169.285 242.735 171.76 249.15 176.362C255.564 180.964 260.375 187.461 262.905 194.939C265.464 201.693 265.748 200.555 263.615 202.048ZM227.5 85.3125C239.657 85.3198 251.56 88.7901 261.816 95.3172C272.071 101.844 280.256 111.158 285.41 122.168C290.564 133.178 292.476 145.428 290.92 157.485C289.364 169.542 284.406 180.906 276.626 190.247C274.393 183.748 270.893 177.756 266.329 172.619C261.765 167.481 256.227 163.3 250.037 160.316C254.016 156.4 257.032 151.613 258.845 146.333C260.659 141.053 261.221 135.423 260.487 129.888C260.487 121.139 257.012 112.749 250.826 106.563C244.639 100.376 236.249 96.9008 227.5 96.9008C218.751 96.9008 210.36 100.376 204.174 106.563C197.988 112.749 194.512 121.139 194.512 129.888C194.512 140.268 194.512 150.292 204.963 160.316C198.772 163.3 193.235 167.481 188.671 172.619C184.107 177.756 180.607 183.748 178.374 190.247C170.594 180.906 165.635 169.542 164.08 157.485C162.524 145.428 164.435 133.178 169.59 122.168C174.744 111.158 182.928 101.844 193.184 95.3172C203.44 88.7901 215.343 85.3198 227.5 85.3125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.703 241.719H149.297C147.411 241.719 145.603 242.468 144.27 243.801C142.937 245.134 142.188 246.943 142.188 248.828V277.266C142.188 279.151 142.937 280.959 144.27 282.293C145.603 283.626 147.411 284.375 149.297 284.375H305.703C307.589 284.375 309.397 283.626 310.73 282.293C312.063 280.959 312.812 279.151 312.812 277.266V248.828C312.812 246.943 312.063 245.134 310.73 243.801C309.397 242.468 307.589 241.719 305.703 241.719ZM298.594 270.156H156.406V255.938H298.594V270.156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.703 298.594H149.297C147.411 298.594 145.603 299.343 144.27 300.676C142.937 302.009 142.188 303.818 142.188 305.703V334.141C142.188 336.026 142.937 337.834 144.27 339.168C145.603 340.501 147.411 341.25 149.297 341.25H305.703C307.589 341.25 309.397 340.501 310.73 339.168C312.063 337.834 312.812 336.026 312.812 334.141V305.703C312.812 303.818 312.063 302.009 310.73 300.676C309.397 299.343 307.589 298.594 305.703 298.594ZM298.594 327.031H156.406V312.812H298.594V327.031Z",
    fill: "black"
  }))), _defs$n || (_defs$n = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3224_22134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 455,
    height: 455,
    fill: "white"
  })))));
};
var ForwardRef$M = /*#__PURE__*/forwardRef(SvgRegistration);
var _rect$h, _g$I;
var _excluded$M = ["title", "titleId"];
function _extends$M() {
  return _extends$M = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$M.apply(null, arguments);
}
function _objectWithoutProperties$L(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$M(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$M(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgReplyAll = function SvgReplyAll(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$L(_ref, _excluded$M);
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55987_27542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$h || (_rect$h = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$I || (_g$I = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55987_27542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17L2 11L8 5L9.425 6.4L4.825 11L9.425 15.6L8 17ZM20 19V15C20 14.1667 19.7083 13.4583 19.125 12.875C18.5417 12.2917 17.8333 12 17 12H10.825L14.425 15.6L13 17L7 11L13 5L14.425 6.4L10.825 10H17C18.3833 10 19.5625 10.4875 20.5375 11.4625C21.5125 12.4375 22 13.6167 22 15V19H20Z",
    fill: "#1C1B1F"
  }))));
};
var ForwardRef$L = /*#__PURE__*/forwardRef(SvgReplyAll);
var _g$H, _defs$m;
var _excluded$L = ["title", "titleId"];
function _extends$L() {
  return _extends$L = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$L.apply(null, arguments);
}
function _objectWithoutProperties$K(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$L(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$L(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgResourceMgmt = function SvgResourceMgmt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$K(_ref, _excluded$L);
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$H || (_g$H = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55718_27480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 25C12.2091 25 14 23.2091 14 21C14 18.7909 12.2091 17 10 17C7.79086 17 6 18.7909 6 21C6 23.2091 7.79086 25 10 25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 25C24.2091 25 26 23.2091 26 21C26 18.7909 24.2091 17 22 17C19.7909 17 18 18.7909 18 21C18 23.2091 19.7909 25 22 25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 28C4.6986 27.0685 5.60448 26.3125 6.6459 25.7918C7.68731 25.2711 8.83566 25 10 25C11.1643 25 12.3127 25.2711 13.3541 25.7918C14.3955 26.3125 15.3014 27.0685 16 28C16.6986 27.0685 17.6045 26.3125 18.6459 25.7918C19.6873 25.2711 20.8357 25 22 25C23.1643 25 24.3127 25.2711 25.3541 25.7918C26.3955 26.3125 27.3014 27.0685 28 28",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C24.2091 12 26 10.2091 26 8C26 5.79086 24.2091 4 22 4C19.7909 4 18 5.79086 18 8C18 10.2091 19.7909 12 22 12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15C4.6986 14.0685 5.60448 13.3125 6.6459 12.7918C7.68731 12.2711 8.83566 12 10 12C11.1643 12 12.3127 12.2711 13.3541 12.7918C14.3955 13.3125 15.3014 14.0685 16 15C16.6986 14.0685 17.6045 13.3125 18.6459 12.7918C19.6873 12.2711 20.8357 12 22 12C23.1643 12 24.3127 12.2711 25.3541 12.7918C26.3955 13.3125 27.3014 14.0685 28 15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$m || (_defs$m = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55718_27480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef$K = /*#__PURE__*/forwardRef(SvgResourceMgmt);
var _rect$g, _g$G;
var _excluded$K = ["title", "titleId"];
function _extends$K() {
  return _extends$K = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$K.apply(null, arguments);
}
function _objectWithoutProperties$J(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$K(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$K(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgResubmit = function SvgResubmit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$J(_ref, _excluded$K);
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55668_234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$g || (_rect$g = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$G || (_g$G = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55668_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.75 22 9.57917 21.7625 8.4875 21.2875C7.39583 20.8125 6.44583 20.1708 5.6375 19.3625C4.82917 18.5542 4.1875 17.6042 3.7125 16.5125C3.2375 15.4208 3 14.25 3 13H5C5 14.95 5.67917 16.6042 7.0375 17.9625C8.39583 19.3208 10.05 20 12 20C13.95 20 15.6042 19.3208 16.9625 17.9625C18.3208 16.6042 19 14.95 19 13C19 11.05 18.3208 9.39583 16.9625 8.0375C15.6042 6.67917 13.95 6 12 6H11.85L13.4 7.55L12 9L8 5L12 1L13.4 2.45L11.85 4H12C13.25 4 14.4208 4.2375 15.5125 4.7125C16.6042 5.1875 17.5542 5.82917 18.3625 6.6375C19.1708 7.44583 19.8125 8.39583 20.2875 9.4875C20.7625 10.5792 21 11.75 21 13C21 14.25 20.7625 15.4208 20.2875 16.5125C19.8125 17.6042 19.1708 18.5542 18.3625 19.3625C17.5542 20.1708 16.6042 20.8125 15.5125 21.2875C14.4208 21.7625 13.25 22 12 22Z",
    fill: "#1C1B1F"
  }))));
};
var ForwardRef$J = /*#__PURE__*/forwardRef(SvgResubmit);
var _rect$f, _g$F;
var _excluded$J = ["title", "titleId"];
function _extends$J() {
  return _extends$J = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$J.apply(null, arguments);
}
function _objectWithoutProperties$I(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$J(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$J(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSavings = function SvgSavings(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$I(_ref, _excluded$J);
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_522_12023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect$f || (_rect$f = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g$F || (_g$F = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_522_12023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 14.667C21.7112 14.667 22.0279 14.5392 22.2834 14.2837C22.539 14.0281 22.6667 13.7114 22.6667 13.3337C22.6667 12.9559 22.539 12.6392 22.2834 12.3837C22.0279 12.1281 21.7112 12.0003 21.3334 12.0003C20.9556 12.0003 20.639 12.1281 20.3834 12.3837C20.1279 12.6392 20.0001 12.9559 20.0001 13.3337C20.0001 13.7114 20.1279 14.0281 20.3834 14.2837C20.639 14.5392 20.9556 14.667 21.3334 14.667ZM10.6667 12.0003H17.3334V9.33366H10.6667V12.0003ZM6.00008 28.0003C5.24453 25.467 4.50008 22.9392 3.76675 20.417C3.03341 17.8948 2.66675 15.3114 2.66675 12.667C2.66675 10.6225 3.37786 8.88921 4.80008 7.46699C6.2223 6.04477 7.95564 5.33366 10.0001 5.33366H16.6667C17.3112 4.48921 18.0945 3.83366 19.0167 3.36699C19.939 2.90033 20.9334 2.66699 22.0001 2.66699C22.5556 2.66699 23.0279 2.86144 23.4167 3.25033C23.8056 3.63921 24.0001 4.11144 24.0001 4.66699C24.0001 4.80033 23.9834 4.93366 23.9501 5.06699C23.9167 5.20033 23.8779 5.32255 23.8334 5.43366C23.7445 5.6781 23.6612 5.9281 23.5834 6.18366C23.5056 6.43921 23.4445 6.70033 23.4001 6.96699L26.4334 10.0003H29.3334V19.3003L25.5667 20.5337L23.3334 28.0003H16.0001V25.3337H13.3334V28.0003H6.00008ZM8.00008 25.3337H10.6667V22.667H18.6667V25.3337H21.3334L23.4001 18.467L26.6667 17.367V12.667H25.3334L20.6667 8.00033C20.6667 7.55588 20.6945 7.1281 20.7501 6.71699C20.8056 6.30588 20.889 5.88921 21.0001 5.46699C20.3556 5.64477 19.789 5.95033 19.3001 6.38366C18.8112 6.81699 18.4556 7.35588 18.2334 8.00033H10.0001C8.71119 8.00033 7.61119 8.45588 6.70008 9.36699C5.78897 10.2781 5.33341 11.3781 5.33341 12.667C5.33341 14.8448 5.63341 16.9725 6.23341 19.0503C6.83341 21.1281 7.4223 23.2225 8.00008 25.3337Z",
    fill: "#BDCAC0"
  }))));
};
var ForwardRef$I = /*#__PURE__*/forwardRef(SvgSavings);
var _g$E;
var _excluded$I = ["title", "titleId"];
function _extends$I() {
  return _extends$I = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$I.apply(null, arguments);
}
function _objectWithoutProperties$H(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$I(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$I(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSearchFace = function SvgSearchFace(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$H(_ref, _excluded$I);
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$E || (_g$E = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.875 88.529C79.5324 96.7074 68.1054 101.75 55.5 101.75C29.9568 101.75 9.25 81.0429 9.25 55.5C9.25 29.9568 29.9568 9.25 55.5 9.25C68.438 9.25 80.1351 14.5625 88.529 23.125",
    stroke: "#6E7A71",
    strokeWidth: 6.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.0001 69.375C41.2187 74.9916 47.935 78.625 55.5001 78.625C58.789 78.625 61.9173 77.9382 64.7501 76.7005",
    stroke: "#6E7A71",
    strokeWidth: 6.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.0412 41.625H37.0001",
    stroke: "#6E7A71",
    strokeWidth: 9.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.9999 60.1252C81.6628 60.1252 87.8749 53.9132 87.8749 46.2502C87.8749 38.5873 81.6628 32.3752 73.9999 32.3752C66.3369 32.3752 60.1249 38.5873 60.1249 46.2502C60.1249 53.9132 66.3369 60.1252 73.9999 60.1252Z",
    stroke: "#6E7A71",
    strokeWidth: 6.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M101.75 55.5002C100.791 53.6692 100.312 52.7539 99.6779 51.9519C98.0568 49.9012 95.6375 48.2885 92.758 47.339C91.6322 46.9676 90.3798 46.7285 87.8749 46.2502",
    stroke: "#6E7A71",
    strokeWidth: 6.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef$H = /*#__PURE__*/forwardRef(SvgSearchFace);
var _g$D;
var _excluded$H = ["title", "titleId"];
function _extends$H() {
  return _extends$H = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$H.apply(null, arguments);
}
function _objectWithoutProperties$G(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$H(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$H(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$G(_ref, _excluded$H);
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$D || (_g$D = /*#__PURE__*/React.createElement("g", {
    id: "Icons/search_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.76 13.27L20.49 19L19 20.49L13.27 14.76C12.2 15.53 10.91 16 9.5 16C5.91 16 3 13.09 3 9.5C3 5.91 5.91 3 9.5 3C13.09 3 16 5.91 16 9.5C16 10.91 15.53 12.2 14.76 13.27ZM9.5 5C7.01 5 5 7.01 5 9.5C5 11.99 7.01 14 9.5 14C11.99 14 14 11.99 14 9.5C14 7.01 11.99 5 9.5 5Z",
    fill: "black"
  }))));
};
var ForwardRef$G = /*#__PURE__*/forwardRef(SvgSearch);
var _g$C, _defs$l;
var _excluded$G = ["title", "titleId"];
function _extends$G() {
  return _extends$G = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$G.apply(null, arguments);
}
function _objectWithoutProperties$F(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$G(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$G(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSelectionPlus = function SvgSelectionPlus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$F(_ref, _excluded$G);
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$C || (_g$C = /*#__PURE__*/React.createElement("g", {
    id: "SelectionPlus",
    clipPath: "url(#clip0_2007_714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 5H14",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 27H18",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23 5H26C26.2652 5 26.5196 5.10536 26.7071 5.29289C26.8946 5.48043 27 5.73478 27 6V9",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27 18V14",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5 14V18",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9 27H6C5.73478 27 5.48043 26.8946 5.29289 26.7071C5.10536 26.5196 5 26.2652 5 26V23",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9 5H6C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V9",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27 24V30",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24 27H30",
    stroke: "#6E7A71",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$l || (_defs$l = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
var ForwardRef$F = /*#__PURE__*/forwardRef(SvgSelectionPlus);
var _rect$e, _g$B;
var _excluded$F = ["title", "titleId"];
function _extends$F() {
  return _extends$F = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$F.apply(null, arguments);
}
function _objectWithoutProperties$E(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$F(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$F(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSettings = function SvgSettings(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$E(_ref, _excluded$F);
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56403_27816",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$e || (_rect$e = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$B || (_g$B = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56403_27816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings",
    d: "M9.24995 22L8.84995 18.8C8.63328 18.7167 8.42912 18.6167 8.23745 18.5C8.04578 18.3833 7.85828 18.2583 7.67495 18.125L4.69995 19.375L1.94995 14.625L4.52495 12.675C4.50828 12.5583 4.49995 12.4458 4.49995 12.3375V11.6625C4.49995 11.5542 4.50828 11.4417 4.52495 11.325L1.94995 9.375L4.69995 4.625L7.67495 5.875C7.85828 5.74167 8.04995 5.61667 8.24995 5.5C8.44995 5.38333 8.64995 5.28333 8.84995 5.2L9.24995 2H14.75L15.15 5.2C15.3666 5.28333 15.5708 5.38333 15.7625 5.5C15.9541 5.61667 16.1416 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4916 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1416 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.24995ZM11 20H12.975L13.325 17.35C13.8416 17.2167 14.3208 17.0208 14.7625 16.7625C15.2041 16.5042 15.6083 16.1917 15.975 15.825L18.45 16.85L19.425 15.15L17.275 13.525C17.3583 13.2917 17.4166 13.0458 17.45 12.7875C17.4833 12.5292 17.5 12.2667 17.5 12C17.5 11.7333 17.4833 11.4708 17.45 11.2125C17.4166 10.9542 17.3583 10.7083 17.275 10.475L19.425 8.85L18.45 7.15L15.975 8.2C15.6083 7.81667 15.2041 7.49583 14.7625 7.2375C14.3208 6.97917 13.8416 6.78333 13.325 6.65L13 4H11.025L10.675 6.65C10.1583 6.78333 9.67912 6.97917 9.23745 7.2375C8.79578 7.49583 8.39162 7.80833 8.02495 8.175L5.54995 7.15L4.57495 8.85L6.72495 10.45C6.64162 10.7 6.58328 10.95 6.54995 11.2C6.51662 11.45 6.49995 11.7167 6.49995 12C6.49995 12.2667 6.51662 12.525 6.54995 12.775C6.58328 13.025 6.64162 13.275 6.72495 13.525L4.57495 15.15L5.54995 16.85L8.02495 15.8C8.39162 16.1833 8.79578 16.5042 9.23745 16.7625C9.67912 17.0208 10.1583 17.2167 10.675 17.35L11 20ZM12.05 15.5C13.0166 15.5 13.8416 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8416 8.84167 13.0166 8.5 12.05 8.5C11.0666 8.5 10.2375 8.84167 9.56245 9.525C8.88745 10.2083 8.54995 11.0333 8.54995 12C8.54995 12.9667 8.88745 13.7917 9.56245 14.475C10.2375 15.1583 11.0666 15.5 12.05 15.5Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$E = /*#__PURE__*/forwardRef(SvgSettings);
var _g$A, _defs$k;
var _excluded$E = ["title", "titleId"];
function _extends$E() {
  return _extends$E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$E.apply(null, arguments);
}
function _objectWithoutProperties$D(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$E(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$E(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSlidersHorizontal = function SvgSlidersHorizontal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$D(_ref, _excluded$E);
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$A || (_g$A = /*#__PURE__*/React.createElement("g", {
    id: "SlidersHorizontal",
    clipPath: "url(#clip0_1026_28311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4171 14.417C16.2546 14.417 17.7441 12.9274 17.7441 11.09C17.7441 9.25252 16.2546 7.76297 14.4171 7.76297C12.5796 7.76297 11.0901 9.25252 11.0901 11.09C11.0901 12.9274 12.5796 14.417 14.4171 14.417Z",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.2889 27.725C25.1264 27.725 26.6159 26.2354 26.6159 24.398C26.6159 22.5605 25.1264 21.071 23.2889 21.071C21.4515 21.071 19.9619 22.5605 19.9619 24.398C19.9619 26.2354 21.4515 27.725 23.2889 27.725Z",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.7439 11.09H29.9429",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.54492 11.09H11.0899",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M26.616 24.398H29.943",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.54492 24.398H19.962",
    stroke: "#3E4A42",
    strokeWidth: 2.218,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$k || (_defs$k = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_28311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.4881,
    height: 35.4881,
    fill: "white"
  })))));
};
var ForwardRef$D = /*#__PURE__*/forwardRef(SvgSlidersHorizontal);
var _g$z, _defs$j;
var _excluded$D = ["title", "titleId"];
function _extends$D() {
  return _extends$D = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$D.apply(null, arguments);
}
function _objectWithoutProperties$C(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$D(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$D(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSso = function SvgSso(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$C(_ref, _excluded$D);
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$z || (_g$z = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57072_13212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49999 12C7.49999 10.5166 7.93986 9.06656 8.76397 7.83319C9.58808 6.59982 10.5104 5.76749 11.8809 5.19983M21.4363 8.66739C22.8943 10.1253 22.4967 13.4996 21.9291 14.8701C21.3614 16.2405 20.4001 17.4119 19.1668 18.236C17.9334 19.0601 16.4834 19.5 15 19.5H6.74999C6.00558 19.499 5.26987 19.3398 4.59169 19.0329C3.91351 18.7259 3.30835 18.2783 2.81639 17.7196C2.32442 17.1609 1.95689 16.504 1.73817 15.7924C1.51946 15.0809 1.45457 14.3309 1.54781 13.5924C1.64105 12.8538 1.89029 12.1436 2.27899 11.5087C2.66768 10.8738 3.18695 10.3289 3.80233 9.90998C4.41771 9.4911 5.11513 9.20788 5.84832 9.07911C6.58151 8.95034 7.33371 8.97897 8.05499 9.16309",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_57072_13212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4052 4.40222H12.4012C12.1802 4.40222 12.001 4.5814 12.001 4.80242V10.4052C12.001 10.6262 12.1802 10.8054 12.4012 10.8054H20.4052C20.6262 10.8054 20.8054 10.6262 20.8054 10.4052V4.80242C20.8054 4.5814 20.6262 4.40222 20.4052 4.40222Z",
    stroke: "black",
    strokeWidth: 1.334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4032 8.10402C16.6795 8.10402 16.9035 7.88005 16.9035 7.60377C16.9035 7.32749 16.6795 7.10352 16.4032 7.10352C16.1269 7.10352 15.903 7.32749 15.903 7.60377C15.903 7.88005 16.1269 8.10402 16.4032 8.10402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4022 4.40221V2.80141C14.4022 2.27072 14.613 1.76175 14.9883 1.38649C15.3636 1.01123 15.8725 0.800415 16.4032 0.800415C16.9339 0.800415 17.4429 1.01123 17.8181 1.38649C18.1934 1.76175 18.4042 2.27072 18.4042 2.80141V4.40221",
    stroke: "black",
    strokeWidth: 1.334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs$j || (_defs$j = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57072_13212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_57072_13212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8064,
    height: 12.8064,
    fill: "white",
    transform: "translate(10)"
  })))));
};
var ForwardRef$C = /*#__PURE__*/forwardRef(SvgSso);
var _path$5;
var _excluded$C = ["title", "titleId"];
function _extends$C() {
  return _extends$C = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$C.apply(null, arguments);
}
function _objectWithoutProperties$B(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$C(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$C(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgStarFilled = function SvgStarFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$B(_ref, _excluded$C);
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64456 0.174539C6.69615 0.0699872 6.84524 0.0699875 6.89684 0.174539L8.74304 3.91534C8.76353 3.95686 8.80314 3.98564 8.84895 3.99229L12.9772 4.59216C13.0926 4.60893 13.1386 4.75072 13.0551 4.8321L10.0679 7.74391C10.0348 7.77622 10.0196 7.82279 10.0275 7.86842L10.7327 11.98C10.7524 12.0949 10.6317 12.1825 10.5286 12.1282L6.83616 10.187C6.79518 10.1655 6.74622 10.1655 6.70524 10.187L3.01285 12.1282C2.90965 12.1825 2.78903 12.0949 2.80874 11.98L3.51393 7.86842C3.52175 7.82279 3.50662 7.77622 3.47347 7.74391L0.486261 4.8321C0.402771 4.75072 0.448842 4.60893 0.564222 4.59216L4.69244 3.99229C4.73826 3.98564 4.77787 3.95686 4.79836 3.91534L6.64456 0.174539Z",
    fill: "#FDFDFD"
  })));
};
var ForwardRef$B = /*#__PURE__*/forwardRef(SvgStarFilled);
var _path$4;
var _excluded$B = ["title", "titleId"];
function _extends$B() {
  return _extends$B = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$B.apply(null, arguments);
}
function _objectWithoutProperties$A(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$B(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$B(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgStarStroke = function SvgStarStroke(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$A(_ref, _excluded$B);
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52938 7.54542L3.3359 7.74391L3.52938 7.54542L0.740253 4.82669L4.59473 4.2666C4.73083 4.24683 4.84848 4.16135 4.90935 4.03802L6.63312 0.545269L8.3569 4.03802C8.41776 4.16135 8.53542 4.24683 8.67152 4.2666L12.526 4.82669L9.73687 7.54542C9.63839 7.64141 9.59345 7.77972 9.6167 7.91528L10.2751 11.7542L6.82757 9.94169C6.70584 9.87769 6.56041 9.87769 6.43867 9.9417L2.99113 11.7542L3.64955 7.91528C3.6728 7.77972 3.62786 7.64141 3.52938 7.54542Z",
    stroke: "#D9E6DB",
    strokeWidth: 0.554378
  })));
};
var ForwardRef$A = /*#__PURE__*/forwardRef(SvgStarStroke);
var _rect$d, _g$y;
var _excluded$A = ["title", "titleId"];
function _extends$A() {
  return _extends$A = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$A.apply(null, arguments);
}
function _objectWithoutProperties$z(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$A(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$A(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgStatus = function SvgStatus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$z(_ref, _excluded$A);
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "status"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2705_33906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$d || (_rect$d = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$y || (_g$y = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2705_33906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "troubleshoot",
    d: "M11 18.5C9.95 18.5 8.97083 18.3167 8.0625 17.95C7.15417 17.5833 6.35 17.0833 5.65 16.45C5.45 16.2667 5.35833 16.0458 5.375 15.7875C5.39167 15.5292 5.50833 15.3083 5.725 15.125C5.94167 14.9417 6.19167 14.8542 6.475 14.8625C6.75833 14.8708 7.00833 14.9667 7.225 15.15C7.75833 15.5833 8.3375 15.9167 8.9625 16.15C9.5875 16.3833 10.2667 16.5 11 16.5C12.6667 16.5 14.0833 15.9167 15.25 14.75C16.4167 13.5833 17 12.1667 17 10.5C17 8.83333 16.4167 7.41667 15.25 6.25C14.0833 5.08333 12.6667 4.5 11 4.5C9.61667 4.5 8.39583 4.91667 7.3375 5.75C6.27917 6.58333 5.575 7.64167 5.225 8.925C5.14167 9.20833 4.99167 9.45833 4.775 9.675C4.55833 9.89167 4.30833 10 4.025 10C3.74167 10 3.5125 9.8875 3.3375 9.6625C3.1625 9.4375 3.10833 9.18333 3.175 8.9C3.55833 7.06667 4.47083 5.54167 5.9125 4.325C7.35417 3.10833 9.05 2.5 11 2.5C13.2333 2.5 15.125 3.275 16.675 4.825C18.225 6.375 19 8.26667 19 10.5C19 11.4333 18.85 12.3125 18.55 13.1375C18.25 13.9625 17.8333 14.7167 17.3 15.4L21.3 19.4C21.4833 19.5833 21.575 19.8167 21.575 20.1C21.575 20.3833 21.4833 20.6167 21.3 20.8C21.1167 20.9833 20.8833 21.075 20.6 21.075C20.3167 21.075 20.0833 20.9833 19.9 20.8L15.9 16.8C15.2167 17.3333 14.4625 17.75 13.6375 18.05C12.8125 18.35 11.9333 18.5 11 18.5ZM10.675 11.85L11.6 8.975C11.65 8.84167 11.7292 8.72917 11.8375 8.6375C11.9458 8.54583 12.075 8.5 12.225 8.5H12.825C12.9583 8.5 13.075 8.53333 13.175 8.6C13.275 8.66667 13.3583 8.75833 13.425 8.875L14.75 11.5C14.9667 11.5 15.1458 11.5708 15.2875 11.7125C15.4292 11.8542 15.5 12.0333 15.5 12.25C15.5 12.4667 15.4292 12.6458 15.2875 12.7875C15.1458 12.9292 14.9667 13 14.75 13H14.3C14.1667 13 14.0375 12.9625 13.9125 12.8875C13.7875 12.8125 13.6917 12.7083 13.625 12.575L12.65 10.65L11.55 14.025C11.5 14.175 11.4167 14.2917 11.3 14.375C11.1833 14.4583 11.05 14.5 10.9 14.5H10.45C10.3 14.5 10.1625 14.4542 10.0375 14.3625C9.9125 14.2708 9.825 14.15 9.775 14L8.35 9.3L7.225 12.5C7.175 12.65 7.0875 12.7708 6.9625 12.8625C6.8375 12.9542 6.69167 13 6.525 13H2.75C2.53333 13 2.35417 12.9292 2.2125 12.7875C2.07083 12.6458 2 12.4667 2 12.25C2 12.0333 2.07083 11.8542 2.2125 11.7125C2.35417 11.5708 2.53333 11.5 2.75 11.5H6L7.475 7.225C7.525 7.075 7.6125 6.95833 7.7375 6.875C7.8625 6.79167 8 6.75 8.15 6.75H8.625C8.79167 6.75 8.93333 6.8 9.05 6.9C9.16667 7 9.25 7.125 9.3 7.275L10.675 11.85Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$z = /*#__PURE__*/forwardRef(SvgStatus);
var _rect$c, _g$x;
var _excluded$z = ["title", "titleId"];
function _extends$z() {
  return _extends$z = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$z.apply(null, arguments);
}
function _objectWithoutProperties$y(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$z(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$z(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgSupervisorAccount = function SvgSupervisorAccount(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$y(_ref, _excluded$z);
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "supervisor_account"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2705_33448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$c || (_rect$c = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$x || (_g$x = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2705_33448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "supervisor_account_2",
    d: "M17 15.5C16.3 15.5 15.7083 15.2583 15.225 14.775C14.7417 14.2917 14.5 13.7 14.5 13C14.5 12.3 14.7417 11.7083 15.225 11.225C15.7083 10.7417 16.3 10.5 17 10.5C17.7 10.5 18.2917 10.7417 18.775 11.225C19.2583 11.7083 19.5 12.3 19.5 13C19.5 13.7 19.2583 14.2917 18.775 14.775C18.2917 15.2583 17.7 15.5 17 15.5ZM12 19.5V19.1C12 18.7 12.1042 18.3292 12.3125 17.9875C12.5208 17.6458 12.8167 17.4 13.2 17.25C13.8 17 14.4208 16.8125 15.0625 16.6875C15.7042 16.5625 16.35 16.5 17 16.5C17.65 16.5 18.2958 16.5625 18.9375 16.6875C19.5792 16.8125 20.2 17 20.8 17.25C21.1833 17.4 21.4792 17.6458 21.6875 17.9875C21.8958 18.3292 22 18.7 22 19.1V19.5C22 19.7833 21.9042 20.0208 21.7125 20.2125C21.5208 20.4042 21.2833 20.5 21 20.5H13C12.7167 20.5 12.4792 20.4042 12.2875 20.2125C12.0958 20.0208 12 19.7833 12 19.5ZM10 12.5C8.9 12.5 7.95833 12.1083 7.175 11.325C6.39167 10.5417 6 9.6 6 8.5C6 7.4 6.39167 6.45833 7.175 5.675C7.95833 4.89167 8.9 4.5 10 4.5C11.1 4.5 12.0417 4.89167 12.825 5.675C13.6083 6.45833 14 7.4 14 8.5C14 9.6 13.6083 10.5417 12.825 11.325C12.0417 12.1083 11.1 12.5 10 12.5ZM2 17.7C2 17.1333 2.14167 16.6125 2.425 16.1375C2.70833 15.6625 3.1 15.3 3.6 15.05C4.6 14.55 5.6375 14.1667 6.7125 13.9C7.7875 13.6333 8.88333 13.5 10 13.5C10.5833 13.5 11.1667 13.55 11.75 13.65C12.3333 13.75 12.9167 13.8667 13.5 14L11.8 15.7C11.5 15.6167 11.2 15.5625 10.9 15.5375C10.6 15.5125 10.3 15.5 10 15.5C9.03333 15.5 8.0875 15.6167 7.1625 15.85C6.2375 16.0833 5.35 16.4167 4.5 16.85C4.33333 16.9333 4.20833 17.05 4.125 17.2C4.04167 17.35 4 17.5167 4 17.7V18.5H10V19.475C10 19.6917 10.0417 19.8875 10.125 20.0625C10.2083 20.2375 10.325 20.3833 10.475 20.5H4C3.45 20.5 2.97917 20.3042 2.5875 19.9125C2.19583 19.5208 2 19.05 2 18.5V17.7ZM10 10.5C10.55 10.5 11.0208 10.3042 11.4125 9.9125C11.8042 9.52083 12 9.05 12 8.5C12 7.95 11.8042 7.47917 11.4125 7.0875C11.0208 6.69583 10.55 6.5 10 6.5C9.45 6.5 8.97917 6.69583 8.5875 7.0875C8.19583 7.47917 8 7.95 8 8.5C8 9.05 8.19583 9.52083 8.5875 9.9125C8.97917 10.3042 9.45 10.5 10 10.5Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$y = /*#__PURE__*/forwardRef(SvgSupervisorAccount);
var _rect$b, _g$w;
var _excluded$y = ["title", "titleId"];
function _extends$y() {
  return _extends$y = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$y.apply(null, arguments);
}
function _objectWithoutProperties$x(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$y(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$y(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgTableRowsNarrow = function SvgTableRowsNarrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$x(_ref, _excluded$y);
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2285_7879",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$b || (_rect$b = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$w || (_g$w = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2285_7879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 15V13H5V15H19ZM19 11V9H5V11H19ZM19 7V5H5V7H19ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM19 19V17H5V19H19Z",
    fill: "white"
  }))));
};
var ForwardRef$x = /*#__PURE__*/forwardRef(SvgTableRowsNarrow);
var _rect$a, _g$v;
var _excluded$x = ["title", "titleId"];
function _extends$x() {
  return _extends$x = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$x.apply(null, arguments);
}
function _objectWithoutProperties$w(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$x(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$x(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgTag = function SvgTag(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$w(_ref, _excluded$x);
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tag"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2705_33522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect$a || (_rect$a = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$v || (_g$v = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2705_33522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sell",
    d: "M21.4 14.75L14.25 21.9C14.05 22.1 13.825 22.25 13.575 22.35C13.325 22.45 13.075 22.5 12.825 22.5C12.575 22.5 12.325 22.45 12.075 22.35C11.825 22.25 11.6 22.1 11.4 21.9L2.575 13.075C2.39167 12.8917 2.25 12.6792 2.15 12.4375C2.05 12.1958 2 11.9417 2 11.675V4.5C2 3.95 2.19583 3.47917 2.5875 3.0875C2.97917 2.69583 3.45 2.5 4 2.5H11.175C11.4417 2.5 11.7 2.55417 11.95 2.6625C12.2 2.77083 12.4167 2.91667 12.6 3.1L21.4 11.925C21.6 12.125 21.7458 12.35 21.8375 12.6C21.9292 12.85 21.975 13.1 21.975 13.35C21.975 13.6 21.9292 13.8458 21.8375 14.0875C21.7458 14.3292 21.6 14.55 21.4 14.75ZM12.825 20.5L19.975 13.35L11.15 4.5H4V11.65L12.825 20.5ZM6.5 8.5C6.91667 8.5 7.27083 8.35417 7.5625 8.0625C7.85417 7.77083 8 7.41667 8 7C8 6.58333 7.85417 6.22917 7.5625 5.9375C7.27083 5.64583 6.91667 5.5 6.5 5.5C6.08333 5.5 5.72917 5.64583 5.4375 5.9375C5.14583 6.22917 5 6.58333 5 7C5 7.41667 5.14583 7.77083 5.4375 8.0625C5.72917 8.35417 6.08333 8.5 6.5 8.5Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$w = /*#__PURE__*/forwardRef(SvgTag);
var _rect$9, _g$u;
var _excluded$w = ["title", "titleId"];
function _extends$w() {
  return _extends$w = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$w.apply(null, arguments);
}
function _objectWithoutProperties$v(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$w(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$w(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgTextAd = function SvgTextAd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$v(_ref, _excluded$w);
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "text_ad"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2808_14872",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$9 || (_rect$9 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$u || (_g$u = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2808_14872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "text_ad_2",
    d: "M5 17H19V15H5V17ZM5 13H19V11H5V13ZM5 9H15V7H5V9ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V6H4V18Z",
    fill: "#3E4A42"
  })))));
};
var ForwardRef$v = /*#__PURE__*/forwardRef(SvgTextAd);
var _g$t, _defs$i;
var _excluded$v = ["title", "titleId"];
function _extends$v() {
  return _extends$v = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$v.apply(null, arguments);
}
function _objectWithoutProperties$u(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$v(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$v(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgTimesheets = function SvgTimesheets(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$u(_ref, _excluded$v);
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$t || (_g$t = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_56403_27829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 9.75H21",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3 14.25H21",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.25 9.75V18.75",
    stroke: "#171D19",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$i || (_defs$i = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56403_27829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$u = /*#__PURE__*/forwardRef(SvgTimesheets);
var _g$s;
var _excluded$u = ["title", "titleId"];
function _extends$u() {
  return _extends$u = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$u.apply(null, arguments);
}
function _objectWithoutProperties$t(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$u(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$u(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgToday24Px = function SvgToday24Px(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$t(_ref, _excluded$u);
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$s || (_g$s = /*#__PURE__*/React.createElement("g", {
    id: "Icons/today_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20ZM6.5 13C6.5 11.62 7.62 10.5 9 10.5C10.38 10.5 11.5 11.62 11.5 13C11.5 14.38 10.38 15.5 9 15.5C7.62 15.5 6.5 14.38 6.5 13Z",
    fill: "black"
  }))));
};
var ForwardRef$t = /*#__PURE__*/forwardRef(SvgToday24Px);
var _rect$8, _g$r;
var _excluded$t = ["title", "titleId"];
function _extends$t() {
  return _extends$t = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$t.apply(null, arguments);
}
function _objectWithoutProperties$s(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$t(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$t(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgTune = function SvgTune(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$s(_ref, _excluded$t);
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2285_7886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect$8 || (_rect$8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.800049,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$r || (_g$r = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2285_7886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8 21V15H13.8V17H21.8V19H13.8V21H11.8ZM3.80005 19V17H9.80005V19H3.80005ZM7.80005 15V13H3.80005V11H7.80005V9H9.80005V15H7.80005ZM11.8 13V11H21.8V13H11.8ZM15.8 9V3H17.8V5H21.8V7H17.8V9H15.8ZM3.80005 7V5H13.8V7H3.80005Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$s = /*#__PURE__*/forwardRef(SvgTune);
var _rect$7, _g$q;
var _excluded$s = ["title", "titleId"];
function _extends$s() {
  return _extends$s = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$s.apply(null, arguments);
}
function _objectWithoutProperties$r(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$s(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$s(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUmbrella = function SvgUmbrella(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$r(_ref, _excluded$s);
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "umbrella"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_55809_232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$7 || (_rect$7 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$q || (_g$q = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_55809_232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "beach_access",
    d: "M19.6 21L13.25 14.65L14.65 13.25L21 19.6L19.6 21ZM5.95 20.3C4.95 19.3 4.20833 18.175 3.725 16.925C3.24167 15.675 3 14.4 3 13.1C3 11.8 3.24167 10.5333 3.725 9.29998C4.20833 8.06664 4.95 6.94998 5.95 5.94998C6.95 4.94998 8.07083 4.20414 9.3125 3.71248C10.5542 3.22081 11.825 2.97498 13.125 2.97498C14.425 2.97498 15.6958 3.22081 16.9375 3.71248C18.1792 4.20414 19.3 4.94998 20.3 5.94998L5.95 20.3ZM6.15 17.25L7.5 15.9C7.23333 15.55 6.97917 15.1916 6.7375 14.825C6.49583 14.4583 6.275 14.0916 6.075 13.725C5.875 13.3583 5.7 12.9916 5.55 12.625C5.4 12.2583 5.26667 11.9 5.15 11.55C4.96667 12.5333 4.95417 13.5166 5.1125 14.5C5.27083 15.4833 5.61667 16.4 6.15 17.25ZM8.95 14.5L14.5 8.89998C13.7833 8.34998 13.0625 7.90414 12.3375 7.56248C11.6125 7.22081 10.9333 6.98748 10.3 6.86248C9.66667 6.73748 9.09583 6.71664 8.5875 6.79998C8.07917 6.88331 7.68333 7.06664 7.4 7.34998C7.11667 7.64998 6.93333 8.05414 6.85 8.56248C6.76667 9.07081 6.7875 9.64581 6.9125 10.2875C7.0375 10.9291 7.27083 11.6083 7.6125 12.325C7.95417 13.0416 8.4 13.7666 8.95 14.5ZM15.9 7.49998L17.3 6.14998C16.4167 5.61664 15.4833 5.26664 14.5 5.09998C13.5167 4.93331 12.5333 4.94998 11.55 5.14998C11.9167 5.26664 12.2833 5.39998 12.65 5.54998C13.0167 5.69998 13.3833 5.87081 13.75 6.06248C14.1167 6.25414 14.4792 6.47081 14.8375 6.71248C15.1958 6.95414 15.55 7.21664 15.9 7.49998Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$r = /*#__PURE__*/forwardRef(SvgUmbrella);
var _rect$6, _g$p;
var _excluded$r = ["title", "titleId"];
function _extends$r() {
  return _extends$r = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$r.apply(null, arguments);
}
function _objectWithoutProperties$q(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$r(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$r(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUnassigned = function SvgUnassigned(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$q(_ref, _excluded$r);
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "unassigned"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56987_15702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$6 || (_rect$6 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$p || (_g$p = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56987_15702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "assignment_add",
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H9.2C9.41667 2.4 9.77917 1.91667 10.2875 1.55C10.7958 1.18333 11.3667 1 12 1C12.6333 1 13.2042 1.18333 13.7125 1.55C14.2208 1.91667 14.5833 2.4 14.8 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V10.025C21 10.3083 20.9042 10.5458 20.7125 10.7375C20.5208 10.9292 20.2833 11.025 20 11.025C19.7167 11.025 19.4792 10.9292 19.2875 10.7375C19.0958 10.5458 19 10.3083 19 10.025V5H5V19H10C10.2833 19 10.5208 19.0958 10.7125 19.2875C10.9042 19.4792 11 19.7167 11 20C11 20.2833 10.9042 20.5208 10.7125 20.7125C10.5208 20.9042 10.2833 21 10 21H5ZM5 19V5V11.075V11V19ZM8 17H10.5C10.7833 17 11.0208 16.9042 11.2125 16.7125C11.4042 16.5208 11.5 16.2833 11.5 16C11.5 15.7167 11.4042 15.4792 11.2125 15.2875C11.0208 15.0958 10.7833 15 10.5 15H8C7.71667 15 7.47917 15.0958 7.2875 15.2875C7.09583 15.4792 7 15.7167 7 16C7 16.2833 7.09583 16.5208 7.2875 16.7125C7.47917 16.9042 7.71667 17 8 17ZM8 13H13C13.2833 13 13.5208 12.9042 13.7125 12.7125C13.9042 12.5208 14 12.2833 14 12C14 11.7167 13.9042 11.4792 13.7125 11.2875C13.5208 11.0958 13.2833 11 13 11H8C7.71667 11 7.47917 11.0958 7.2875 11.2875C7.09583 11.4792 7 11.7167 7 12C7 12.2833 7.09583 12.5208 7.2875 12.7125C7.47917 12.9042 7.71667 13 8 13ZM8 9H16C16.2833 9 16.5208 8.90417 16.7125 8.7125C16.9042 8.52083 17 8.28333 17 8C17 7.71667 16.9042 7.47917 16.7125 7.2875C16.5208 7.09583 16.2833 7 16 7H8C7.71667 7 7.47917 7.09583 7.2875 7.2875C7.09583 7.47917 7 7.71667 7 8C7 8.28333 7.09583 8.52083 7.2875 8.7125C7.47917 8.90417 7.71667 9 8 9ZM12 4.25C12.2167 4.25 12.3958 4.17917 12.5375 4.0375C12.6792 3.89583 12.75 3.71667 12.75 3.5C12.75 3.28333 12.6792 3.10417 12.5375 2.9625C12.3958 2.82083 12.2167 2.75 12 2.75C11.7833 2.75 11.6042 2.82083 11.4625 2.9625C11.3208 3.10417 11.25 3.28333 11.25 3.5C11.25 3.71667 11.3208 3.89583 11.4625 4.0375C11.6042 4.17917 11.7833 4.25 12 4.25ZM18 23C16.6167 23 15.4375 22.5125 14.4625 21.5375C13.4875 20.5625 13 19.3833 13 18C13 16.6167 13.4875 15.4375 14.4625 14.4625C15.4375 13.4875 16.6167 13 18 13C19.3833 13 20.5625 13.4875 21.5375 14.4625C22.5125 15.4375 23 16.6167 23 18C23 19.3833 22.5125 20.5625 21.5375 21.5375C20.5625 22.5125 19.3833 23 18 23ZM17.5 18.5V20.5C17.5 20.6333 17.55 20.75 17.65 20.85C17.75 20.95 17.8667 21 18 21C18.1333 21 18.25 20.95 18.35 20.85C18.45 20.75 18.5 20.6333 18.5 20.5V18.5H20.5C20.6333 18.5 20.75 18.45 20.85 18.35C20.95 18.25 21 18.1333 21 18C21 17.8667 20.95 17.75 20.85 17.65C20.75 17.55 20.6333 17.5 20.5 17.5H18.5V15.5C18.5 15.3667 18.45 15.25 18.35 15.15C18.25 15.05 18.1333 15 18 15C17.8667 15 17.75 15.05 17.65 15.15C17.55 15.25 17.5 15.3667 17.5 15.5V17.5H15.5C15.3667 17.5 15.25 17.55 15.15 17.65C15.05 17.75 15 17.8667 15 18C15 18.1333 15.05 18.25 15.15 18.35C15.25 18.45 15.3667 18.5 15.5 18.5H17.5Z",
    fill: "#1C1B1F"
  })))));
};
var ForwardRef$q = /*#__PURE__*/forwardRef(SvgUnassigned);
var _rect$5, _g$o;
var _excluded$q = ["title", "titleId"];
function _extends$q() {
  return _extends$q = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$q.apply(null, arguments);
}
function _objectWithoutProperties$p(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$q(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$q(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUndo = function SvgUndo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$p(_ref, _excluded$q);
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "undo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56027_27565",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$5 || (_rect$5 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$o || (_g$o = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56027_27565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "undo_2",
    d: "M7 19V17H14.1C15.15 17 16.0625 16.6667 16.8375 16C17.6125 15.3333 18 14.5 18 13.5C18 12.5 17.6125 11.6667 16.8375 11C16.0625 10.3333 15.15 10 14.1 10H7.8L10.4 12.6L9 14L4 9L9 4L10.4 5.4L7.8 8H14.1C15.7167 8 17.1042 8.525 18.2625 9.575C19.4208 10.625 20 11.9333 20 13.5C20 15.0667 19.4208 16.375 18.2625 17.425C17.1042 18.475 15.7167 19 14.1 19H7Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$p = /*#__PURE__*/forwardRef(SvgUndo);
var _rect$4, _g$n;
var _excluded$p = ["title", "titleId"];
function _extends$p() {
  return _extends$p = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$p.apply(null, arguments);
}
function _objectWithoutProperties$o(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$p(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$p(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUnfold = function SvgUnfold(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$o(_ref, _excluded$p);
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57045_210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$4 || (_rect$4 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$n || (_g$n = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57045_210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4648 19.8489L13.4849 19.8489V13.4849H19.8489L19.8489 15.4648L15.4648 15.4648L15.4648 19.8489ZM10.515 10.5151L4.15108 10.5151V8.53517L8.53514 8.53517L8.53514 4.1511L10.515 4.1511L10.515 10.5151Z",
    fill: "#171D19"
  }))));
};
var ForwardRef$o = /*#__PURE__*/forwardRef(SvgUnfold);
var _g$m;
var _excluded$o = ["title", "titleId"];
function _extends$o() {
  return _extends$o = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$o.apply(null, arguments);
}
function _objectWithoutProperties$n(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$o(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$o(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUnhappy = function SvgUnhappy(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$n(_ref, _excluded$o);
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$m || (_g$m = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.9998 100.833C80.3129 100.833 100.833 80.3131 100.833 55.0001C100.833 29.687 80.3129 9.16675 54.9998 9.16675C29.6868 9.16675 9.1665 29.687 9.1665 55.0001C9.1665 80.3131 29.6868 100.833 54.9998 100.833Z",
    stroke: "#6E7A71",
    strokeWidth: 6.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.7076 41.25H36.6665M73.3332 41.25H73.2919",
    stroke: "#6E7A71",
    strokeWidth: 9.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.8335 73.3334L68.7502 64.1667",
    stroke: "#6E7A71",
    strokeWidth: 6.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef$n = /*#__PURE__*/forwardRef(SvgUnhappy);
var _g$l;
var _excluded$n = ["title", "titleId"];
function _extends$n() {
  return _extends$n = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$n.apply(null, arguments);
}
function _objectWithoutProperties$m(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$n(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$n(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUnplug = function SvgUnplug(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$m(_ref, _excluded$n);
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$l || (_g$l = /*#__PURE__*/React.createElement("g", {
    id: "Unplug "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3333 6.6665L29.3333 2.6665",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.66675 29.3335L6.66675 25.3335",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.40004 27.0667C8.69734 27.365 9.05059 27.6017 9.43956 27.7632C9.82852 27.9247 10.2455 28.0079 10.6667 28.0079C11.0879 28.0079 11.5049 27.9247 11.8939 27.7632C12.2828 27.6017 12.6361 27.365 12.9334 27.0667L16 24L8.00004 16L4.93338 19.0667C4.63505 19.364 4.39835 19.7172 4.23684 20.1062C4.07533 20.4951 3.99219 20.9122 3.99219 21.3333C3.99219 21.7545 4.07533 22.1715 4.23684 22.5605C4.39835 22.9495 4.63505 23.3027 4.93338 23.6L8.40004 27.0667Z",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 17.9998L13.3333 14.6665",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14 21.9998L17.3333 18.6665",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16 8.00004L24 16L27.0667 12.9334C27.365 12.6361 27.6017 12.2828 27.7632 11.8939C27.9247 11.5049 28.0079 11.0879 28.0079 10.6667C28.0079 10.2455 27.9247 9.82852 27.7632 9.43956C27.6017 9.05059 27.365 8.69734 27.0667 8.40004L23.6 4.93338C23.3027 4.63505 22.9495 4.39835 22.5605 4.23684C22.1715 4.07533 21.7545 3.99219 21.3333 3.99219C20.9122 3.99219 20.4951 4.07533 20.1062 4.23684C19.7172 4.39835 19.364 4.63505 19.0667 4.93338L16 8.00004Z",
    stroke: "#3E4A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef$m = /*#__PURE__*/forwardRef(SvgUnplug);
var _rect$3, _g$k;
var _excluded$m = ["title", "titleId"];
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$m.apply(null, arguments);
}
function _objectWithoutProperties$l(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$m(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$m(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgVideocam = function SvgVideocam(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$l(_ref, _excluded$m);
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2043_77",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g$k || (_g$k = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2043_77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "videocam",
    d: "M3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64688 14.2656 1.5 13.9125 1.5 13.5V4.5C1.5 4.0875 1.64688 3.73438 1.94063 3.44063C2.23438 3.14688 2.5875 3 3 3H12C12.4125 3 12.7656 3.14688 13.0594 3.44063C13.3531 3.73438 13.5 4.0875 13.5 4.5V7.875L16.5 4.875V13.125L13.5 10.125V13.5C13.5 13.9125 13.3531 14.2656 13.0594 14.5594C12.7656 14.8531 12.4125 15 12 15H3ZM3 13.5H12V4.5H3V13.5Z",
    fill: "#171D19"
  })))));
};
var ForwardRef$l = /*#__PURE__*/forwardRef(SvgVideocam);
var _rect$2, _g$j;
var _excluded$l = ["title", "titleId"];
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$l.apply(null, arguments);
}
function _objectWithoutProperties$k(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$l(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$l(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgWrench = function SvgWrench(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$k(_ref, _excluded$l);
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57279_14029",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g$j || (_g$j = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57279_14029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15C7.33333 15 5.91667 14.4167 4.75 13.25C3.58333 12.0833 3 10.6667 3 9C3 8.66667 3.025 8.33333 3.075 8C3.125 7.66667 3.21667 7.35 3.35 7.05C3.43333 6.88333 3.5375 6.75833 3.6625 6.675C3.7875 6.59167 3.925 6.53333 4.075 6.5C4.225 6.46667 4.37917 6.47083 4.5375 6.5125C4.69583 6.55417 4.84167 6.64167 4.975 6.775L7.6 9.4L9.4 7.6L6.775 4.975C6.64167 4.84167 6.55417 4.69583 6.5125 4.5375C6.47083 4.37917 6.46667 4.225 6.5 4.075C6.53333 3.925 6.59167 3.7875 6.675 3.6625C6.75833 3.5375 6.88333 3.43333 7.05 3.35C7.35 3.21667 7.66667 3.125 8 3.075C8.33333 3.025 8.66667 3 9 3C10.6667 3 12.0833 3.58333 13.25 4.75C14.4167 5.91667 15 7.33333 15 9C15 9.38333 14.9667 9.74583 14.9 10.0875C14.8333 10.4292 14.7333 10.7667 14.6 11.1L19.65 16.1C20.1333 16.5833 20.375 17.175 20.375 17.875C20.375 18.575 20.1333 19.1667 19.65 19.65C19.1667 20.1333 18.575 20.375 17.875 20.375C17.175 20.375 16.5833 20.125 16.1 19.625L11.1 14.6C10.7667 14.7333 10.4292 14.8333 10.0875 14.9C9.74583 14.9667 9.38333 15 9 15ZM9 13C9.43333 13 9.86667 12.9333 10.3 12.8C10.7333 12.6667 11.125 12.4583 11.475 12.175L17.55 18.25C17.6333 18.3333 17.7458 18.3708 17.8875 18.3625C18.0292 18.3542 18.1417 18.3083 18.225 18.225C18.3083 18.1417 18.35 18.0292 18.35 17.8875C18.35 17.7458 18.3083 17.6333 18.225 17.55L12.15 11.5C12.45 11.1667 12.6667 10.7792 12.8 10.3375C12.9333 9.89583 13 9.45 13 9C13 8 12.6792 7.12917 12.0375 6.3875C11.3958 5.64583 10.6 5.2 9.65 5.05L11.5 6.9C11.7 7.1 11.8 7.33333 11.8 7.6C11.8 7.86667 11.7 8.1 11.5 8.3L8.3 11.5C8.1 11.7 7.86667 11.8 7.6 11.8C7.33333 11.8 7.1 11.7 6.9 11.5L5.05 9.65C5.2 10.6 5.64583 11.3958 6.3875 12.0375C7.12917 12.6792 8 13 9 13Z",
    fill: "#1C1B1F"
  }))));
};
var ForwardRef$k = /*#__PURE__*/forwardRef(SvgWrench);
var _g$i, _defs$h;
var _excluded$k = ["title", "titleId"];
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$k.apply(null, arguments);
}
function _objectWithoutProperties$j(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$k(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$k(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBatteryVerticalFull = function SvgBatteryVerticalFull(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$j(_ref, _excluded$k);
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$i || (_g$i = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56539_30105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.75C8.25 0.551088 8.32902 0.360322 8.46967 0.21967C8.61032 0.0790176 8.80109 0 9 0L15 0C15.1989 0 15.3897 0.0790176 15.5303 0.21967C15.671 0.360322 15.75 0.551088 15.75 0.75C15.75 0.948912 15.671 1.13968 15.5303 1.28033C15.3897 1.42098 15.1989 1.5 15 1.5H9C8.80109 1.5 8.61032 1.42098 8.46967 1.28033C8.32902 1.13968 8.25 0.948912 8.25 0.75ZM18.75 5.25V21C18.75 21.5967 18.5129 22.169 18.091 22.591C17.669 23.0129 17.0967 23.25 16.5 23.25H7.5C6.90326 23.25 6.33097 23.0129 5.90901 22.591C5.48705 22.169 5.25 21.5967 5.25 21V5.25C5.25 4.65326 5.48705 4.08097 5.90901 3.65901C6.33097 3.23705 6.90326 3 7.5 3H16.5C17.0967 3 17.669 3.23705 18.091 3.65901C18.5129 4.08097 18.75 4.65326 18.75 5.25ZM17.25 5.25C17.25 5.05109 17.171 4.86032 17.0303 4.71967C16.8897 4.57902 16.6989 4.5 16.5 4.5H7.5C7.30109 4.5 7.11032 4.57902 6.96967 4.71967C6.82902 4.86032 6.75 5.05109 6.75 5.25V21C6.75 21.1989 6.82902 21.3897 6.96967 21.5303C7.11032 21.671 7.30109 21.75 7.5 21.75H16.5C16.6989 21.75 16.8897 21.671 17.0303 21.5303C17.171 21.3897 17.25 21.1989 17.25 21V5.25ZM15 6H9C8.80109 6 8.61032 6.07902 8.46967 6.21967C8.32902 6.36032 8.25 6.55109 8.25 6.75V19.5C8.25 19.6989 8.32902 19.8897 8.46967 20.0303C8.61032 20.171 8.80109 20.25 9 20.25H15C15.1989 20.25 15.3897 20.171 15.5303 20.0303C15.671 19.8897 15.75 19.6989 15.75 19.5V6.75C15.75 6.55109 15.671 6.36032 15.5303 6.21967C15.3897 6.07902 15.1989 6 15 6Z",
    fill: "#D9E6DB"
  }))), _defs$h || (_defs$h = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56539_30105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$j = /*#__PURE__*/forwardRef(SvgBatteryVerticalFull);
var _g$h, _defs$g;
var _excluded$j = ["title", "titleId"];
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$j.apply(null, arguments);
}
function _objectWithoutProperties$i(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$j(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$j(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBatteryVerticalLow = function SvgBatteryVerticalLow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$i(_ref, _excluded$j);
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$h || (_g$h = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56539_30103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.75C8.25 0.551088 8.32902 0.360322 8.46967 0.21967C8.61032 0.0790176 8.80109 0 9 0L15 0C15.1989 0 15.3897 0.0790176 15.5303 0.21967C15.671 0.360322 15.75 0.551088 15.75 0.75C15.75 0.948912 15.671 1.13968 15.5303 1.28033C15.3897 1.42098 15.1989 1.5 15 1.5H9C8.80109 1.5 8.61032 1.42098 8.46967 1.28033C8.32902 1.13968 8.25 0.948912 8.25 0.75ZM15 17.25H9C8.80109 17.25 8.61032 17.329 8.46967 17.4697C8.32902 17.6103 8.25 17.8011 8.25 18V19.5C8.25 19.6989 8.32902 19.8897 8.46967 20.0303C8.61032 20.171 8.80109 20.25 9 20.25H15C15.1989 20.25 15.3897 20.171 15.5303 20.0303C15.671 19.8897 15.75 19.6989 15.75 19.5V18C15.75 17.8011 15.671 17.6103 15.5303 17.4697C15.3897 17.329 15.1989 17.25 15 17.25ZM18.75 5.25V21C18.75 21.5967 18.5129 22.169 18.091 22.591C17.669 23.0129 17.0967 23.25 16.5 23.25H7.5C6.90326 23.25 6.33097 23.0129 5.90901 22.591C5.48705 22.169 5.25 21.5967 5.25 21V5.25C5.25 4.65326 5.48705 4.08097 5.90901 3.65901C6.33097 3.23705 6.90326 3 7.5 3H16.5C17.0967 3 17.669 3.23705 18.091 3.65901C18.5129 4.08097 18.75 4.65326 18.75 5.25ZM17.25 5.25C17.25 5.05109 17.171 4.86032 17.0303 4.71967C16.8897 4.57902 16.6989 4.5 16.5 4.5H7.5C7.30109 4.5 7.11032 4.57902 6.96967 4.71967C6.82902 4.86032 6.75 5.05109 6.75 5.25V21C6.75 21.1989 6.82902 21.3897 6.96967 21.5303C7.11032 21.671 7.30109 21.75 7.5 21.75H16.5C16.6989 21.75 16.8897 21.671 17.0303 21.5303C17.171 21.3897 17.25 21.1989 17.25 21V5.25Z",
    fill: "#D9E6DB"
  }))), _defs$g || (_defs$g = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56539_30103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$i = /*#__PURE__*/forwardRef(SvgBatteryVerticalLow);
var _g$g, _defs$f;
var _excluded$i = ["title", "titleId"];
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$i.apply(null, arguments);
}
function _objectWithoutProperties$h(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$i(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$i(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgBatteryWarningVertical = function SvgBatteryWarningVertical(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$h(_ref, _excluded$i);
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$g || (_g$g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56539_30104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.75C8.25 0.551088 8.32902 0.360322 8.46967 0.21967C8.61032 0.0790176 8.80109 0 9 0L15 0C15.1989 0 15.3897 0.0790176 15.5303 0.21967C15.671 0.360322 15.75 0.551088 15.75 0.75C15.75 0.948912 15.671 1.13968 15.5303 1.28033C15.3897 1.42098 15.1989 1.5 15 1.5H9C8.80109 1.5 8.61032 1.42098 8.46967 1.28033C8.32902 1.13968 8.25 0.948912 8.25 0.75ZM18.75 5.25V21C18.75 21.5967 18.5129 22.169 18.091 22.591C17.669 23.0129 17.0967 23.25 16.5 23.25H7.5C6.90326 23.25 6.33097 23.0129 5.90901 22.591C5.48705 22.169 5.25 21.5967 5.25 21V5.25C5.25 4.65326 5.48705 4.08097 5.90901 3.65901C6.33097 3.23705 6.90326 3 7.5 3H16.5C17.0967 3 17.669 3.23705 18.091 3.65901C18.5129 4.08097 18.75 4.65326 18.75 5.25ZM11.25 12.75C11.25 12.9489 11.329 13.1397 11.4697 13.2803C11.6103 13.421 11.8011 13.5 12 13.5C12.1989 13.5 12.3897 13.421 12.5303 13.2803C12.671 13.1397 12.75 12.9489 12.75 12.75V9C12.75 8.80109 12.671 8.61032 12.5303 8.46967C12.3897 8.32902 12.1989 8.25 12 8.25C11.8011 8.25 11.6103 8.32902 11.4697 8.46967C11.329 8.61032 11.25 8.80109 11.25 9V12.75ZM13.125 16.125C13.125 15.9025 13.059 15.685 12.9354 15.5C12.8118 15.315 12.6361 15.1708 12.4305 15.0856C12.225 15.0005 11.9988 14.9782 11.7805 15.0216C11.5623 15.065 11.3618 15.1722 11.2045 15.3295C11.0472 15.4868 10.94 15.6873 10.8966 15.9055C10.8532 16.1238 10.8755 16.35 10.9606 16.5555C11.0458 16.7611 11.19 16.9368 11.375 17.0604C11.56 17.184 11.7775 17.25 12 17.25C12.2984 17.25 12.5845 17.1315 12.7955 16.9205C13.0065 16.7095 13.125 16.4234 13.125 16.125Z",
    fill: "#D9E6DB"
  }))), _defs$f || (_defs$f = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56539_30104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$h = /*#__PURE__*/forwardRef(SvgBatteryWarningVertical);
var _g$f, _defs$e;
var _excluded$h = ["title", "titleId"];
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$h.apply(null, arguments);
}
function _objectWithoutProperties$g(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$h(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$h(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUserSwitch = function SvgUserSwitch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$g(_ref, _excluded$h);
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$f || (_g$f = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56539_30106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.87499 11.25C7.87499 10.4341 8.11691 9.63659 8.57017 8.95824C9.02344 8.27988 9.66767 7.75117 10.4214 7.43896C11.1752 7.12675 12.0046 7.04506 12.8047 7.20423C13.6049 7.36339 14.3399 7.75626 14.9168 8.33315C15.4937 8.91004 15.8866 9.64504 16.0457 10.4452C16.2049 11.2454 16.1232 12.0748 15.811 12.8285C15.4988 13.5823 14.9701 14.2265 14.2917 14.6798C13.6134 15.133 12.8158 15.375 12 15.375C10.906 15.375 9.85676 14.9404 9.08317 14.1668C8.30958 13.3932 7.87499 12.344 7.87499 11.25ZM19.7025 16.6106C19.5354 16.5136 19.3379 16.483 19.1493 16.5248C18.9607 16.5667 18.7947 16.678 18.6844 16.8365C18.5227 17.0591 18.35 17.2735 18.1669 17.4787C17.6212 16.6867 16.9279 16.0074 16.125 15.4781C16.0565 15.4327 15.975 15.411 15.893 15.4165C15.8111 15.4219 15.7331 15.4541 15.6712 15.5081C14.6524 16.3897 13.3501 16.8749 12.0028 16.8749C10.6555 16.8749 9.3532 16.3897 8.33436 15.5081C8.27202 15.4527 8.19301 15.4197 8.10982 15.4143C8.02663 15.4089 7.944 15.4313 7.87499 15.4781C7.07189 16.0064 6.37827 16.6848 5.83217 17.4759C4.66092 16.1607 3.94316 14.504 3.78467 12.75H5.22842C5.34982 12.7519 5.46995 12.725 5.57896 12.6716C5.68797 12.6181 5.78278 12.5396 5.85561 12.4425C5.96129 12.298 6.01182 12.1205 5.99806 11.942C5.98431 11.7636 5.90718 11.5959 5.78061 11.4693L3.53061 9.21934C3.46096 9.14961 3.37824 9.09429 3.28719 9.05654C3.19614 9.0188 3.09855 8.99937 2.99999 8.99937C2.90143 8.99937 2.80383 9.0188 2.71278 9.05654C2.62173 9.09429 2.53902 9.14961 2.46936 9.21934L0.219362 11.4693C0.0927953 11.5959 0.015668 11.7636 0.0019135 11.942C-0.011841 12.1205 0.0386844 12.298 0.144362 12.4425C0.217194 12.5396 0.311999 12.6181 0.421014 12.6716C0.530028 12.725 0.650152 12.7519 0.771549 12.75H2.27811C2.4315 14.7439 3.19435 16.6425 4.46321 18.1883C5.73208 19.7341 7.44559 20.8523 9.37144 21.3913C11.2973 21.9303 13.3423 21.8641 15.2293 21.2016C17.1162 20.5391 18.7538 19.3124 19.92 17.6878C19.9802 17.604 20.0224 17.5087 20.0441 17.4079C20.0658 17.3071 20.0664 17.2029 20.046 17.1018C20.0256 17.0007 19.9846 16.9049 19.9255 16.8204C19.8663 16.7359 19.7904 16.6644 19.7025 16.6106ZM23.9428 11.7131C23.8861 11.576 23.79 11.4589 23.6666 11.3764C23.5433 11.294 23.3983 11.25 23.25 11.25H21.7219C21.5685 9.25599 20.8056 7.35742 19.5368 5.81165C18.2679 4.26587 16.5544 3.14767 14.6285 2.60864C12.7027 2.06961 10.6577 2.13583 8.77072 2.79832C6.88378 3.46081 5.24619 4.68753 4.07999 6.31215C3.96387 6.47377 3.91671 6.67489 3.94889 6.87128C3.98106 7.06766 4.08993 7.24322 4.25155 7.35934C4.41317 7.47545 4.61429 7.52261 4.81068 7.49044C5.00706 7.45826 5.18262 7.34939 5.29874 7.18778C6.2799 5.82169 7.65517 4.78813 9.24023 4.2256C10.8253 3.66306 12.5444 3.59844 14.1673 4.04038C15.7901 4.48232 17.2391 5.40971 18.32 6.69827C19.401 7.98684 20.0623 9.57501 20.2153 11.25H18.75C18.6016 11.2498 18.4564 11.2938 18.333 11.3762C18.2096 11.4586 18.1133 11.5758 18.0565 11.7129C17.9997 11.85 17.9849 12.0009 18.0138 12.1464C18.0428 12.292 18.1144 12.4257 18.2194 12.5306L20.4694 14.7806C20.539 14.8503 20.6217 14.9056 20.7128 14.9434C20.8038 14.9811 20.9014 15.0006 21 15.0006C21.0985 15.0006 21.1961 14.9811 21.2872 14.9434C21.3782 14.9056 21.461 14.8503 21.5306 14.7806L23.7806 12.5306C23.8855 12.4256 23.9568 12.292 23.9857 12.1464C24.0146 12.0009 23.9996 11.8501 23.9428 11.7131Z",
    fill: "#D9E6DB"
  }))), _defs$e || (_defs$e = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56539_30106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$g = /*#__PURE__*/forwardRef(SvgUserSwitch);
var _g$e, _defs$d;
var _excluded$g = ["title", "titleId"];
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$g.apply(null, arguments);
}
function _objectWithoutProperties$f(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$g(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$g(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFullAvailability = function SvgFullAvailability(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$f(_ref, _excluded$g);
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$e || (_g$e = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57141_11398)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15ZM12 15C8.11406 15 4.81594 17.1122 3 20.25M12 15C15.8859 15 19.1841 17.1122 21 20.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$d || (_defs$d = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57141_11398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$f = /*#__PURE__*/forwardRef(SvgFullAvailability);
var _g$d, _defs$c;
var _excluded$f = ["title", "titleId"];
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$f.apply(null, arguments);
}
function _objectWithoutProperties$e(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$f(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$f(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgFullAvailabilityWhite = function SvgFullAvailabilityWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$e(_ref, _excluded$f);
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$d || (_g$d = /*#__PURE__*/React.createElement("g", {
    id: "0%",
    clipPath: "url(#clip0_2588_2665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M12.5 15C15.8137 15 18.5 12.3137 18.5 9C18.5 5.68629 15.8137 3 12.5 3C9.18629 3 6.5 5.68629 6.5 9C6.5 12.3137 9.18629 15 12.5 15ZM12.5 15C8.61406 15 5.31594 17.1122 3.5 20.25M12.5 15C16.3859 15 19.6841 17.1122 21.5 20.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$c || (_defs$c = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2588_2665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef$e = /*#__PURE__*/forwardRef(SvgFullAvailabilityWhite);
var _g$c, _defs$b;
var _excluded$e = ["title", "titleId"];
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$e.apply(null, arguments);
}
function _objectWithoutProperties$d(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$e(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$e(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgHalfAvailability = function SvgHalfAvailability(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$d(_ref, _excluded$e);
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$c || (_g$c = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57141_11397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21C3 17.5 8.61406 15 12.5 15C12.5 16.875 12.5 16.875 12.5 21",
    fill: "#6E7A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15V9V3C9.18629 3 6.5 5.68629 6.5 9C6.5 12.3137 9.18629 15 12.5 15Z",
    fill: "#6E7A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3C8.68629 3 6 5.68629 6 9C6 12.3137 9.18629 15 12.5 15C8.61406 15 4.81594 17.1122 3 20.25",
    stroke: "#171D19",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 3C15.3137 3 18 5.68629 18 9C18 12.3137 15.3137 15 12 15C15.8859 15 19.1841 17.1122 21 20.25",
    stroke: "#171D19",
    strokeLinecap: "round"
  }))), _defs$b || (_defs$b = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57141_11397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$d = /*#__PURE__*/forwardRef(SvgHalfAvailability);
var _g$b, _defs$a;
var _excluded$d = ["title", "titleId"];
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$d.apply(null, arguments);
}
function _objectWithoutProperties$c(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$d(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$d(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgHalfAvailabilityWhite = function SvgHalfAvailabilityWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$c(_ref, _excluded$d);
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$b || (_g$b = /*#__PURE__*/React.createElement("g", {
    id: "Under",
    clipPath: "url(#clip0_2357_4126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M3.5 21C3.5 17.5 9.11406 15 13 15C13 16.875 13 16.875 13 21",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M13 15V9V3C9.68629 3 7 5.68629 7 9C7 12.3137 9.68629 15 13 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 3C9.18629 3 6.5 5.68629 6.5 9C6.5 12.3137 9.68629 15 13 15C9.11406 15 5.31594 17.1122 3.5 20.25",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M12.5 3C15.8137 3 18.5 5.68629 18.5 9C18.5 12.3137 15.8137 15 12.5 15C16.3859 15 19.6841 17.1122 21.5 20.25",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs$a || (_defs$a = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2357_4126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef$c = /*#__PURE__*/forwardRef(SvgHalfAvailabilityWhite);
var _path$3, _path2$3, _path3$3, _rect$1, _g$a, _defs$9;
var _excluded$c = ["title", "titleId"];
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$c.apply(null, arguments);
}
function _objectWithoutProperties$b(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$c(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$c(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNegativeAvailability = function SvgNegativeAvailability(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$b(_ref, _excluded$c);
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57141_11400)"
  }, _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63525 17.0625C6.7975 17.0625 4.02387 19.2688 2.69775 21.6875H9.63525H16.5728C15.2466 19.2688 12.473 17.0625 9.63525 17.0625Z",
    fill: "#BDCAC0"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 17.0625C11.8043 17.0625 13.875 14.9918 13.875 12.4375C13.875 9.88318 11.8043 7.8125 9.25 7.8125C6.69568 7.8125 4.625 9.88318 4.625 12.4375C4.625 14.9918 6.69568 17.0625 9.25 17.0625Z",
    fill: "#BDCAC0",
    stroke: "#171D19",
    strokeWidth: 0.770833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69775 21.1094C4.09754 18.6906 6.63984 17.0625 9.63525 17.0625C12.6307 17.0625 15.173 18.6906 16.5728 21.1094",
    stroke: "#171D19",
    strokeWidth: 0.770833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_57141_11400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: -1,
    width: 15,
    height: 14
  }, _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: -1,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g$a || (_g$a = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_57141_11400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.25C18.1792 11.25 17.9046 11.1358 17.6761 10.9073C17.4476 10.6788 17.3334 10.4042 17.3334 10.0833C17.3334 9.7625 17.4476 9.48785 17.6761 9.25937C17.9046 9.0309 18.1792 8.91667 18.5 8.91667C18.8209 8.91667 19.0955 9.0309 19.324 9.25937C19.5525 9.48785 19.6667 9.7625 19.6667 10.0833C19.6667 10.4042 19.5525 10.6788 19.324 10.9073C19.0955 11.1358 18.8209 11.25 18.5 11.25ZM18.5 7.75C18.1792 7.75 17.9046 7.63576 17.6761 7.40729C17.4476 7.17882 17.3334 6.90417 17.3334 6.58333V1.91667C17.3334 1.59583 17.4476 1.32118 17.6761 1.09271C17.9046 0.864236 18.1792 0.75 18.5 0.75C18.8209 0.75 19.0955 0.864236 19.324 1.09271C19.5525 1.32118 19.6667 1.59583 19.6667 1.91667V6.58333C19.6667 6.90417 19.5525 7.17882 19.324 7.40729C19.0955 7.63576 18.8209 7.75 18.5 7.75Z",
    fill: "#171D19"
  })))), _defs$9 || (_defs$9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57141_11400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$b = /*#__PURE__*/forwardRef(SvgNegativeAvailability);
var _g$9, _rect, _g2$1, _defs$8;
var _excluded$b = ["title", "titleId"];
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$b.apply(null, arguments);
}
function _objectWithoutProperties$a(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$b(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$b(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNegativeAvailabilityWhite = function SvgNegativeAvailabilityWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$a(_ref, _excluded$b);
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Over",
    clipPath: "url(#clip0_2352_21849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, _g$9 || (_g$9 = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1353 17.0625C7.2975 17.0625 4.52387 19.2688 3.19775 21.6875H10.1353H17.0728C15.7466 19.2688 12.973 17.0625 10.1353 17.0625Z",
    fill: "#BDCAC0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75 17.0625C12.3043 17.0625 14.375 14.9918 14.375 12.4375C14.375 9.88318 12.3043 7.8125 9.75 7.8125C7.19568 7.8125 5.125 9.88318 5.125 12.4375C5.125 14.9918 7.19568 17.0625 9.75 17.0625Z",
    fill: "white",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 0.770833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.19775 21.1094C4.59754 18.6906 7.13984 17.0625 10.1353 17.0625C13.1307 17.0625 15.673 18.6906 17.0728 21.1094",
    stroke: "white",
    strokeWidth: 0.770833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "priority_high"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2352_21849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: -1,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 12,
    y: -1,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g2$1 || (_g2$1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2352_21849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "priority_high_2",
    d: "M19.0002 11.25C18.6793 11.25 18.4047 11.1358 18.1762 10.9073C17.9477 10.6788 17.8335 10.4042 17.8335 10.0833C17.8335 9.7625 17.9477 9.48785 18.1762 9.25937C18.4047 9.0309 18.6793 8.91667 19.0002 8.91667C19.321 8.91667 19.5956 9.0309 19.8241 9.25937C20.0526 9.48785 20.1668 9.7625 20.1668 10.0833C20.1668 10.4042 20.0526 10.6788 19.8241 10.9073C19.5956 11.1358 19.321 11.25 19.0002 11.25ZM19.0002 7.75C18.6793 7.75 18.4047 7.63576 18.1762 7.40729C17.9477 7.17882 17.8335 6.90417 17.8335 6.58333V1.91667C17.8335 1.59583 17.9477 1.32118 18.1762 1.09271C18.4047 0.864236 18.6793 0.75 19.0002 0.75C19.321 0.75 19.5956 0.864236 19.8241 1.09271C20.0526 1.32118 20.1668 1.59583 20.1668 1.91667V6.58333C20.1668 6.90417 20.0526 7.17882 19.8241 7.40729C19.5956 7.63576 19.321 7.75 19.0002 7.75Z",
    fill: "white"
  })))))), _defs$8 || (_defs$8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2352_21849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef$a = /*#__PURE__*/forwardRef(SvgNegativeAvailabilityWhite);
var _g$8, _defs$7;
var _excluded$a = ["title", "titleId"];
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$a.apply(null, arguments);
}
function _objectWithoutProperties$9(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$a(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$a(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNoAvailability = function SvgNoAvailability(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$9(_ref, _excluded$a);
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57141_11399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 15C8.81859 15 5.22036 17.8622 3.5 21H12.5H21.5C19.7796 17.8622 16.1814 15 12.5 15Z",
    fill: "#6E7A71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z",
    fill: "#6E7A71",
    stroke: "#171D19",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 20.25C5.31594 17.1122 8.61406 15 12.5 15C16.3859 15 19.6841 17.1122 21.5 20.25",
    stroke: "#171D19",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$7 || (_defs$7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57141_11399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef$9 = /*#__PURE__*/forwardRef(SvgNoAvailability);
var _g$7, _defs$6;
var _excluded$9 = ["title", "titleId"];
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$9.apply(null, arguments);
}
function _objectWithoutProperties$8(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$9(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$9(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgNoAvailabilityWhite = function SvgNoAvailabilityWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$8(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    id: "100%",
    clipPath: "url(#clip0_2357_8769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15C9.31859 15 5.72036 17.8622 4 21H13H22C20.2796 17.8622 16.6814 15 13 15Z",
    fill: "#6E7A71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 15C15.8137 15 18.5 12.3137 18.5 9C18.5 5.68629 15.8137 3 12.5 3C9.18629 3 6.5 5.68629 6.5 9C6.5 12.3137 9.18629 15 12.5 15Z",
    fill: "white",
    fillOpacity: 0.4,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 20.25C5.81594 17.1122 9.11406 15 13 15C16.8859 15 20.1841 17.1122 22 20.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$6 || (_defs$6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2357_8769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef$8 = /*#__PURE__*/forwardRef(SvgNoAvailabilityWhite);
var _path$2, _path2$2, _path3$2, _path4$2, _path5$1, _path6$1, _g$6, _defs$5;
var _excluded$8 = ["title", "titleId"];
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$8.apply(null, arguments);
}
function _objectWithoutProperties$7(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$8(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$8(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgRocketgraph = function SvgRocketgraph(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$7(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 138,
    height: 155,
    viewBox: "0 0 138 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.5078V151.122H135",
    stroke: "#BDCAC0",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8193 124L32.8193 149.446",
    stroke: "#BDCAC0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2656 112L58.2656 150.169",
    stroke: "#BDCAC0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7109 91L83.7109 149.048",
    stroke: "#BDCAC0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 72L109.156 150.723",
    stroke: "#BDCAC0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33 107.5C48.5 102 64.5 86.9998 72.5 71.9998",
    stroke: "#BDCAC0",
    strokeWidth: 2.01703,
    strokeLinecap: "round",
    strokeDasharray: "4.03 4.03"
  })), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.3511 55.9876C85.3511 55.9876 86.072 64.1189 74.847 68.0064C70.9595 56.7815 77.7948 52.3189 77.7948 52.3189",
    stroke: "#BDCAC0",
    strokeWidth: 3.9597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.835 31.6552C105.504 24.0989 103.542 17.3009 102.336 14.3847C102.15 13.9411 101.808 13.5805 101.375 13.3704C100.942 13.1602 100.448 13.1149 99.984 13.2428C96.9463 14.0985 90.3943 16.7552 86.7225 24.3178L77.0754 44.1876L92.1879 51.525L101.835 31.6552Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.9597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6351 26.5563L71.218 31.5494C70.7226 31.7212 70.3156 32.0826 70.0863 32.5542L64.8354 43.3691C64.6753 43.6998 64.6104 44.0686 64.6479 44.4341C64.6855 44.7997 64.824 45.1475 65.048 45.4388C65.272 45.7301 65.5727 45.9533 65.9164 46.0834C66.26 46.2135 66.6331 46.2454 66.9938 46.1756L77.0748 44.1875",
    stroke: "#BDCAC0",
    strokeWidth: 3.9597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.749 33.8935L105.742 48.3105C105.914 48.8061 105.881 49.3494 105.653 49.8213L100.402 60.6362C100.241 60.9666 99.9913 61.2457 99.6808 61.4423C99.3704 61.6388 99.0113 61.7451 98.6439 61.7493C98.2764 61.7534 97.9151 61.6551 97.6003 61.4656C97.2855 61.276 97.0297 61.0026 96.8615 60.6759L92.1888 51.5247",
    stroke: "#BDCAC0",
    strokeWidth: 3.9597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.3552,
    height: 63.3552,
    fill: "white",
    transform: "translate(48 20.7336) rotate(-19.1026)"
  })))));
};
var ForwardRef$7 = /*#__PURE__*/forwardRef(SvgRocketgraph);
var _g$5, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path$1, _path2$1, _path3$1, _path4$1, _path5, _path6, _path7, _path8, _path9;
var _excluded$7 = ["title", "titleId"];
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$7.apply(null, arguments);
}
function _objectWithoutProperties$6(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$7(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$7(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUsersmid = function SvgUsersmid(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$6(_ref, _excluded$7);
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 19.1994C82.7496 19.1994 86.5998 15.3492 86.5998 10.5997C86.5998 5.85022 82.7496 2 78.0001 2C73.2506 2 69.4004 5.85022 69.4004 10.5997C69.4004 15.3492 73.2506 19.1994 78.0001 19.1994Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9604 26.079C67.1951 23.9838 68.9552 22.247 71.0667 21.0405C73.1783 19.8339 75.5681 19.1992 78.0001 19.1992C80.432 19.1992 82.8218 19.8339 84.9334 21.0405C87.0449 22.247 88.805 23.9838 90.0397 26.079",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0001 147.12C82.7496 147.12 86.5998 143.27 86.5998 138.521C86.5998 133.771 82.7496 129.921 78.0001 129.921C73.2506 129.921 69.4004 133.771 69.4004 138.521C69.4004 143.27 73.2506 147.12 78.0001 147.12Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9604 154C67.1951 151.905 68.9552 150.168 71.0667 148.961C73.1783 147.755 75.5681 147.12 78.0001 147.12C80.432 147.12 82.8218 147.755 84.9334 148.961C87.0449 150.168 88.805 151.905 90.0397 154",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0397 83.1599C18.7892 83.1599 22.6394 79.3097 22.6394 74.5602C22.6394 69.8107 18.7892 65.9604 14.0397 65.9604C9.29017 65.9604 5.43994 69.8107 5.43994 74.5602C5.43994 79.3097 9.29017 83.1599 14.0397 83.1599Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 90.0394C3.23468 87.9442 4.99477 86.2075 7.10629 85.0009C9.21781 83.7943 11.6077 83.1597 14.0396 83.1597C16.4715 83.1597 18.8614 83.7943 20.9729 85.0009C23.0844 86.2075 24.8445 87.9442 26.0792 90.0394",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.96 83.1599C146.71 83.1599 150.56 79.3097 150.56 74.5602C150.56 69.8107 146.71 65.9604 141.96 65.9604C137.211 65.9604 133.361 69.8107 133.361 74.5602C133.361 79.3097 137.211 83.1599 141.96 83.1599Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.921 90.0394C131.155 87.9442 132.915 86.2075 135.027 85.0009C137.138 83.7943 139.528 83.1597 141.96 83.1597C144.392 83.1597 146.782 83.7943 148.894 85.0009C151.005 86.2075 152.765 87.9442 154 90.0394",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.099 37.259C36.8485 37.259 40.6987 33.4088 40.6987 28.6593C40.6987 23.9098 36.8485 20.0596 32.099 20.0596C27.3495 20.0596 23.4993 23.9098 23.4993 28.6593C23.4993 33.4088 27.3495 37.259 32.099 37.259Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0596 44.1386C21.2943 42.0433 23.0543 40.3066 25.1659 39.1C27.2774 37.8934 29.6672 37.2588 32.0992 37.2588C34.5311 37.2588 36.921 37.8934 39.0325 39.1C41.144 40.3066 42.9041 42.0433 44.1388 44.1386",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.901 37.259C128.65 37.259 132.501 33.4088 132.501 28.6593C132.501 23.9098 128.65 20.0596 123.901 20.0596C119.151 20.0596 115.301 23.9098 115.301 28.6593C115.301 33.4088 119.151 37.259 123.901 37.259Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.862 44.1386C113.096 42.0433 114.856 40.3066 116.968 39.1C119.079 37.8934 121.469 37.2588 123.901 37.2588C126.333 37.2588 128.723 37.8934 130.834 39.1C132.946 40.3066 134.706 42.0433 135.941 44.1386",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.099 129.061C36.8485 129.061 40.6987 125.211 40.6987 120.461C40.6987 115.712 36.8485 111.861 32.099 111.861C27.3495 111.861 23.4993 115.712 23.4993 120.461C23.4993 125.211 27.3495 129.061 32.099 129.061Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0596 135.941C21.2943 133.846 23.0543 132.109 25.1659 130.902C27.2774 129.696 29.6672 129.061 32.0992 129.061C34.5311 129.061 36.921 129.696 39.0325 130.902C41.144 132.109 42.9041 133.846 44.1388 135.941",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.901 129.061C128.65 129.061 132.501 125.211 132.501 120.461C132.501 115.712 128.65 111.861 123.901 111.861C119.151 111.861 115.301 115.712 115.301 120.461C115.301 125.211 119.151 129.061 123.901 129.061Z",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.862 135.941C113.096 133.846 114.856 132.109 116.968 130.902C119.079 129.696 121.469 129.061 123.901 129.061C126.333 129.061 128.723 129.696 130.834 130.902C132.946 132.109 134.706 133.846 135.941 135.941",
    stroke: "#BDCAC0",
    strokeWidth: 3.43989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9998 49.7822C62.4236 49.7822 49.782 62.4238 49.782 78C49.782 93.5763 62.4236 106.218 77.9998 106.218C93.576 106.218 106.218 93.5763 106.218 78C106.218 62.4238 93.576 49.7822 77.9998 49.7822ZM95.9463 91.6293C91.9112 86.7194 82.1196 85.0545 77.9998 85.0545C73.88 85.0545 64.0884 86.7194 60.0533 91.6293C57.1751 87.8481 55.4255 83.1357 55.4255 78C55.4255 65.556 65.5557 55.4258 77.9998 55.4258C90.4439 55.4258 100.574 65.556 100.574 78C100.574 83.1357 98.8246 87.8481 95.9463 91.6293ZM68.1236 70.9456C68.1236 65.4713 72.5255 61.0694 77.9998 61.0694C83.4741 61.0694 87.876 65.4713 87.876 70.9456C87.876 76.4199 83.4741 80.8218 77.9998 80.8218C72.5255 80.8218 68.1236 76.4199 68.1236 70.9456Z",
    fill: "#BDCAC0"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M100.574 101.327L109.088 109.84",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9009 47.1484L56.4142 55.6617",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M109.088 47.1484L100.574 55.6617",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4143 101.327L47.901 109.84",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.862 77.624L123.901 77.624",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0991 77.624L44.1387 77.624",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3762 32.0991L78.3762 44.1387",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3762 111.861L78.3762 123.901",
    stroke: "#BDCAC0",
    strokeWidth: 1.50495,
    strokeLinecap: "round"
  })));
};
var ForwardRef$6 = /*#__PURE__*/forwardRef(SvgUsersmid);
var _g$4, _defs$4;
var _excluded$6 = ["title", "titleId"];
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$6.apply(null, arguments);
}
function _objectWithoutProperties$5(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$6(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$6(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgUsersthree = function SvgUsersthree(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$5(_ref, _excluded$6);
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    id: "UsersThree",
    clipPath: "url(#clip0_3325_4623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90 129.375C105.533 129.375 118.125 116.783 118.125 101.25C118.125 85.717 105.533 73.125 90 73.125C74.467 73.125 61.875 85.717 61.875 101.25C61.875 116.783 74.467 129.375 90 129.375Z",
    stroke: "#BDCAC0",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.625 151.875C54.663 145.023 60.4193 139.343 67.3249 135.397C74.2305 131.451 82.0464 129.375 90 129.375C97.9536 129.375 105.769 131.451 112.675 135.397C119.581 139.343 125.337 145.023 129.375 151.875",
    stroke: "#BDCAC0",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M168.75 101.25C164.824 96.0068 159.729 91.7515 153.87 88.8222C148.011 85.8928 141.55 84.3701 135 84.375C139.208 84.3729 143.331 83.1909 146.9 80.9632C150.47 78.7356 153.344 75.5516 155.195 71.7728C157.046 67.9941 157.8 63.772 157.372 59.586C156.944 55.4001 155.351 51.418 152.773 48.0921C150.195 44.7663 146.737 42.2298 142.79 40.7708C138.843 39.3118 134.567 38.9888 130.446 39.8384C126.324 40.6881 122.524 42.6763 119.476 45.5773C116.428 48.4783 114.255 52.1758 113.203 56.25",
    stroke: "#BDCAC0",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M11.25 101.25C15.1762 96.0068 20.2711 91.7515 26.1298 88.8222C31.9886 85.8928 38.4497 84.3701 45 84.375C40.7922 84.3729 36.669 83.1909 33.0993 80.9632C29.5295 78.7356 26.656 75.5516 24.805 71.7728C22.954 67.9941 22.1997 63.772 22.6277 59.586C23.0558 55.4001 24.6491 51.418 27.2267 48.0921C29.8042 44.7663 33.2628 42.2298 37.2095 40.7708C41.1562 39.3118 45.433 38.9888 49.5541 39.8384C53.6752 40.6881 57.4755 42.6763 60.5234 45.5773C63.5713 48.4783 65.7446 52.1758 66.7965 56.25",
    stroke: "#BDCAC0",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3325_4623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })))));
};
var ForwardRef$5 = /*#__PURE__*/forwardRef(SvgUsersthree);
var _g$3, _defs$3;
var _excluded$5 = ["title", "titleId"];
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$5.apply(null, arguments);
}
function _objectWithoutProperties$4(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$5(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$5(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgCode = function SvgCode(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$4(_ref, _excluded$5);
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3325_11439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 41.75L7.5 60.5L30 79.25",
    stroke: "#BDCAC0",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 41.75L112.5 60.5L90 79.25",
    stroke: "#BDCAC0",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 19.25L45 101.75",
    stroke: "#BDCAC0",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3325_11439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef$4 = /*#__PURE__*/forwardRef(SvgCode);
var _g$2, _defs$2;
var _excluded$4 = ["title", "titleId"];
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$4.apply(null, arguments);
}
function _objectWithoutProperties$3(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$4(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$4(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPennib = function SvgPennib(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$3(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3325_11426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.125 71.75C63.3027 71.75 67.5 67.5527 67.5 62.375C67.5 57.1973 63.3027 53 58.125 53C52.9473 53 48.75 57.1973 48.75 62.375C48.75 67.5527 52.9473 71.75 58.125 71.75Z",
    stroke: "#BDCAC0",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7549 101.75L51.4971 69.0034",
    stroke: "#BDCAC0",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 101.75L84.1172 90.8562C84.7657 90.7477 85.3743 90.4706 85.882 90.0527C86.3896 89.6347 86.7784 89.0906 87.0094 88.475L97.5 60.5L60 23L32.025 33.4906C31.4094 33.7216 30.8653 34.1104 30.4473 34.618C30.0294 35.1257 29.7523 35.7343 29.6438 36.3828L18.75 101.75Z",
    stroke: "#BDCAC0",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5 60.4996L111.403 46.5965C112.106 45.8933 112.501 44.9399 112.501 43.9457C112.501 42.9516 112.106 41.9981 111.403 41.2949L79.2188 9.0965C78.5156 8.39377 77.5621 7.99902 76.568 7.99902C75.5738 7.99902 74.6204 8.39377 73.9172 9.0965L60 22.9996",
    stroke: "#BDCAC0",
    strokeWidth: 7.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3325_11426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef$3 = /*#__PURE__*/forwardRef(SvgPennib);
var _g$1, _defs$1;
var _excluded$3 = ["title", "titleId"];
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$3.apply(null, arguments);
}
function _objectWithoutProperties$2(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$3(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$3(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgPuzzlepiece = function SvgPuzzlepiece(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 124,
    height: 125,
    viewBox: "0 0 124 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3325_6294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 105.125C29.9724 105.125 28.9868 104.717 28.2601 103.99C27.5334 103.263 27.1252 102.278 27.1252 101.25V80.5719C25.058 81.55 22.7771 81.9895 20.4945 81.8495C18.2119 81.7095 16.0018 80.9946 14.0696 79.7713C12.1375 78.5479 10.546 76.8559 9.44324 74.8524C8.34047 72.849 7.76221 70.5993 7.76221 68.3124C7.76221 66.0255 8.34047 63.7758 9.44324 61.7724C10.546 59.7689 12.1375 58.0769 14.0696 56.8536C16.0018 55.6302 18.2119 54.9153 20.4945 54.7753C22.7771 54.6354 25.058 55.0748 27.1252 56.0529V35.3749C27.1252 34.3472 27.5334 33.3616 28.2601 32.6349C28.9868 31.9082 29.9724 31.4999 31.0002 31.4999H53.6156C52.6365 29.4327 52.1961 27.1515 52.3354 24.8684C52.4747 22.5852 53.1892 20.3745 54.4124 18.4416C55.6356 16.5088 57.3277 14.9168 59.3315 13.8135C61.3352 12.7103 63.5854 12.1318 65.8727 12.1318C68.1601 12.1318 70.4103 12.7103 72.414 13.8135C74.4177 14.9168 76.1099 16.5088 77.3331 18.4416C78.5563 20.3745 79.2708 22.5852 79.4101 24.8684C79.5494 27.1515 79.109 29.4327 78.1299 31.4999H100.75C101.778 31.4999 102.763 31.9082 103.49 32.6349C104.217 33.3616 104.625 34.3472 104.625 35.3749V56.0529C102.558 55.0748 100.277 54.6354 97.9945 54.7753C95.7119 54.9153 93.5018 55.6302 91.5696 56.8536C89.6375 58.0769 88.046 59.7689 86.9432 61.7724C85.8405 63.7758 85.2622 66.0255 85.2622 68.3124C85.2622 70.5993 85.8405 72.849 86.9432 74.8524C88.046 76.8559 89.6375 78.5479 91.5696 79.7713C93.5018 80.9946 95.7119 81.7095 97.9945 81.8495C100.277 81.9895 102.558 81.55 104.625 80.5719V101.25C104.625 102.278 104.217 103.263 103.49 103.99C102.763 104.717 101.778 105.125 100.75 105.125H31.0002Z",
    stroke: "#BDCAC0",
    strokeWidth: 6.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3325_6294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef$2 = /*#__PURE__*/forwardRef(SvgPuzzlepiece);
var _g, _defs;
var _excluded$2 = ["title", "titleId"];
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$2.apply(null, arguments);
}
function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$2(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$2(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgTerminal = function SvgTerminal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 144,
    height: 141,
    viewBox: "0 0 144 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TerminalWindow",
    clipPath: "url(#clip0_3325_6311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45 52.8755L67.5 70.5005L45 88.1255",
    stroke: "#BDCAC0",
    strokeWidth: 7.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M76.5 88.125H99",
    stroke: "#BDCAC0",
    strokeWidth: 7.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M121.5 26.437H22.5C20.0147 26.437 18 28.4098 18 30.8433V110.156C18 112.589 20.0147 114.562 22.5 114.562H121.5C123.985 114.562 126 112.589 126 110.156V30.8433C126 28.4098 123.985 26.437 121.5 26.437Z",
    stroke: "#BDCAC0",
    strokeWidth: 7.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3325_6311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 141,
    fill: "white"
  })))));
};
var ForwardRef$1 = /*#__PURE__*/forwardRef(SvgTerminal);
var color = {
  color: {
    light: {
      white: {
        description: "",
        type: "color",
        value: "#ffffffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:e1eb8c872eb9e41b68860b72e5d89fcd4e41580c,",
            exportKey: "color"
          }
        }
      },
      black: {
        description: "",
        type: "color",
        value: "#000000ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:578ee03235cd1eccd6f689bb6e92b24d10b823fd,",
            exportKey: "color"
          }
        }
      },
      outline: {
        description: "",
        type: "color",
        value: "#6e7a71ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:647de2713130a1f25be66ac033cb46a0acafa7e9,",
            exportKey: "color"
          }
        }
      },
      "outline-variant": {
        description: "",
        type: "color",
        value: "#bdcac0ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:b5455a02c22d2a33ccb54facc070179b6a29b287,",
            exportKey: "color"
          }
        }
      },
      shadow: {
        description: "",
        type: "color",
        value: "#000000ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:de83dbdac19e7ce311217d147b285c33bf381f62,",
            exportKey: "color"
          }
        }
      },
      scrim: {
        description: "",
        type: "color",
        value: "#000000ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:98a57a912724f69eaef39078f57d3389da21d511,",
            exportKey: "color"
          }
        }
      }
    },
    primary: {
      primary: {
        description: "Primary / On Primary\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ❌ Fail\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#006c47ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:fe6e900847b148824f0f368922dbdee8608bf093,",
            exportKey: "color"
          }
        }
      }
    },
    secondary: {
      secondary: {
        description: "Secondary / On Secondary\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#113f1eff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:6614a90c593616a17383b20dd646b17e8f8ae133,",
            exportKey: "color"
          }
        }
      }
    },
    tertiary: {
      tertiary: {
        description: "Tertiary / On Tertiary\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#13677aff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:2529101ba5aadd680f97901493f6eaae81b0af9a,",
            exportKey: "color"
          }
        }
      }
    },
    signal: {
      info: {
        description: "",
        type: "color",
        value: "#62d6ffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:622bc82ef6e37c619880b0e1552e440f77dedc74,",
            exportKey: "color"
          }
        }
      },
      warning: {
        description: "",
        type: "color",
        value: "#ffbe00ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:55f218be9d96f299b6e73152fb5e0eb8e91aacaf,",
            exportKey: "color"
          }
        }
      },
      "warning - medium": {
        description: "",
        type: "color",
        value: "#ff6600ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:719031105a69e167d9d559330d1a2ea62cbd7c7f,",
            exportKey: "color"
          }
        }
      },
      success: {
        description: "",
        type: "color",
        value: "#01ca8fff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:765dc7c0a792d8a6222423ef0d786112586b97ab,",
            exportKey: "color"
          }
        }
      },
      error: {
        description: "Error / On Error\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#710005ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:b2af94f5e4f69cc73d4a81203f7eee80e68be47b,",
            exportKey: "color"
          }
        }
      }
    },
    neutral: {
      neutral0: {
        description: "",
        type: "color",
        value: "#000000ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:b11e80eef28655718947e3414829e8355b21a596,",
            exportKey: "color"
          }
        }
      },
      neutral4: {
        description: "",
        type: "color",
        value: "#0f0d13ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:f9d8223fa55046e2a2375a52e025a7c927e0610a,",
            exportKey: "color"
          }
        }
      },
      neutral5: {
        description: "",
        type: "color",
        value: "#111111ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:db87a4f97b8e167301377df93683ec6af8d73599,",
            exportKey: "color"
          }
        }
      },
      neutral6: {
        description: "",
        type: "color",
        value: "#141218ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:8accfd4bd15dfd60f068678eab983abb254811a2,",
            exportKey: "color"
          }
        }
      },
      neutral10: {
        description: "",
        type: "color",
        value: "#1c1b1bff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:e4872630e8a1213dcb396061f054b1958b2318ca,",
            exportKey: "color"
          }
        }
      },
      neutral12: {
        description: "",
        type: "color",
        value: "#211f26ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:a14fda55c8697fef5ed8e8971f4f7747eb72967f,",
            exportKey: "color"
          }
        }
      },
      neutral15: {
        description: "",
        type: "color",
        value: "#262625ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:0f6a368836c10756d7bc69d10d76fd9e221b6fc8,",
            exportKey: "color"
          }
        }
      },
      neutral17: {
        description: "",
        type: "color",
        value: "#2b2930ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:b641a48e02ca090178623f0ee25dfe37fcdcede0,",
            exportKey: "color"
          }
        }
      },
      neutral20: {
        description: "",
        type: "color",
        value: "#313030ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:590bca3140d6dd4c519a33210300dae6ecdf902d,",
            exportKey: "color"
          }
        }
      },
      neutral22: {
        description: "",
        type: "color",
        value: "#36343bff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:a6659c7d235206b32d264dc16982b86c56a05f72,",
            exportKey: "color"
          }
        }
      },
      neutral25: {
        description: "",
        type: "color",
        value: "#3c3b3bff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:7577932389775b340690fa8a02d076967df46d87,",
            exportKey: "color"
          }
        }
      },
      neutral24: {
        description: "",
        type: "color",
        value: "#3b383eff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:f3f6788953fd23705fae50a90476bd3b88fa0a9d,",
            exportKey: "color"
          }
        }
      },
      neutral35: {
        description: "",
        type: "color",
        value: "#535252ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:839202be49fb83c39f90f56afc7114a8209fc177,",
            exportKey: "color"
          }
        }
      },
      neutral30: {
        description: "",
        type: "color",
        value: "#484646ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:378ee3a91bad390aecb6154d611709b2e34397f5,",
            exportKey: "color"
          }
        }
      },
      neutral40: {
        description: "",
        type: "color",
        value: "#5f5e5eff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:92d00a19d00554a2473289986920bb6c0e71957a,",
            exportKey: "color"
          }
        }
      },
      neutral50: {
        description: "",
        type: "color",
        value: "#787776ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:d9bcd6bf1c40f8f34469ff4a8ae88c67022bacba,",
            exportKey: "color"
          }
        }
      },
      neutral60: {
        description: "",
        type: "color",
        value: "#929090ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:c528be2d1fa80708ef7d0cdb3adffcbb441905c9,",
            exportKey: "color"
          }
        }
      },
      neutral70: {
        description: "",
        type: "color",
        value: "#adaaaaff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:7c86245a13a2233bd27f9959a71166a293113acc,",
            exportKey: "color"
          }
        }
      },
      neutral80: {
        description: "",
        type: "color",
        value: "#c9c6c5ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:b0850a8a41c698f3dcf6bb00432f3016b5e4f25f,",
            exportKey: "color"
          }
        }
      },
      neutral87: {
        description: "",
        type: "color",
        value: "#ded8e1ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:bbb07d7b47a4fb200332c08586dc5bf4d1b5366b,",
            exportKey: "color"
          }
        }
      },
      neutral90: {
        description: "",
        type: "color",
        value: "#e5e2e1ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:d5114e86372819222b12eacf6025c94a6f732449,",
            exportKey: "color"
          }
        }
      },
      neutral92: {
        description: "",
        type: "color",
        value: "#ece6f0ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:9020aab52365f1551a976520da467bb1b576fece,",
            exportKey: "color"
          }
        }
      },
      neutral94: {
        description: "",
        type: "color",
        value: "#f3edf7ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:6142f6c78020f1b5178bbb2a3dedd6270a17a451,",
            exportKey: "color"
          }
        }
      },
      neutral95: {
        description: "",
        type: "color",
        value: "#f4f0efff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:bb43f4abdf9f403e5031acbabf3d9e74f5219768,",
            exportKey: "color"
          }
        }
      },
      neutral98: {
        description: "",
        type: "color",
        value: "#fcf8f8ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:995a1e1058834f81724348b071dab718959c50f0,",
            exportKey: "color"
          }
        }
      },
      neutral96: {
        description: "",
        type: "color",
        value: "#f7f2faff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:e35c8ae88211ecea12cdc6eeca08aa214d8b0b9e,",
            exportKey: "color"
          }
        }
      },
      neutral99: {
        description: "",
        type: "color",
        value: "#fafcffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:ec40f32b395731ed70effba1373db679e7f0dd2c,",
            exportKey: "color"
          }
        }
      },
      neutral100: {
        description: "",
        type: "color",
        value: "#ffffffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:52e6b9461bb67764bb9b76c850b229f6265eb462,",
            exportKey: "color"
          }
        }
      }
    },
    surfaces: {
      background: {
        description: "Background / On Background\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#fdfdfdff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:677ef7581888f8c9e069ff877c07ec2da9d4b0c8,",
            exportKey: "color"
          }
        }
      },
      "on-background": {
        description: "",
        type: "color",
        value: "#171d19ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:a46bef0c13659838e824c960f63554cd05be2984,",
            exportKey: "color"
          }
        }
      },
      surface: {
        description: "Surface / On Surface\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#f9fafcff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:10bf6a7fc6f358078dec3d7dd44cbb59fdf2fd88,",
            exportKey: "color"
          }
        }
      },
      "inverse-surface": {
        description: "",
        type: "color",
        value: "#2c322eff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:061845ec459c887be9402fc8dd6b85087c7476a4,",
            exportKey: "color"
          }
        }
      },
      "primary-container": {
        description: "Primary Container / On Primary Container\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#42b381ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:17bc5c2fd60e7581b1d738b4732d9c27a885d351,",
            exportKey: "color"
          }
        }
      },
      "secondary-container": {
        description: "Secondary Container / On Secondary Container\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ❌ Fail\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#36633eff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:b9cf2be1de1c685f6b148c415b3abba751c30dd9,",
            exportKey: "color"
          }
        }
      },
      "tertiary-container": {
        description: "Tertiary Container / On Tertiary Container\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ❌ Fail\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#afecffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:158009fcf43ba0f79562c3b12a6cf7b1abe62749,",
            exportKey: "color"
          }
        }
      },
      "surface-container-low": {
        description: "",
        type: "color",
        value: "#eff5efff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:a9b8f2d92c5c2636c5c9b9781639cb16120b6191,",
            exportKey: "color"
          }
        }
      },
      "surface-container": {
        description: "",
        type: "color",
        value: "#f9f7f6ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:9539522bef608d9d913f62983a8f32c24e4cf05e,",
            exportKey: "color"
          }
        }
      },
      "surface-container-high": {
        description: "",
        type: "color",
        value: "#f3ede6ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:fbbf2770840b41026f05921ee6c9165f822ed2de,",
            exportKey: "color"
          }
        }
      },
      "surface-container-highest": {
        description: "",
        type: "color",
        value: "#dee4deff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:5213d167f2256dfc3ac7b08023da0d113f465ac4,",
            exportKey: "color"
          }
        }
      },
      "error-container": {
        description: "Error Container / On Error Container\n\nRegular text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nLarge text:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass\n\nIcons:\nLevel AA - ✅ Pass\nLevel AAA - ✅ Pass",
        type: "color",
        value: "#ad1817ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:4e7f342a49b5146fb73883ef8134bf536b587aae,",
            exportKey: "color"
          }
        }
      },
      light: {
        surface1: {
          "0": {
            type: "color",
            value: "#f5fbf4ff",
            blendMode: "normal"
          },
          "1": {
            type: "color",
            value: "#006c470d",
            blendMode: "normal"
          },
          description: "Surface 1",
          extensions: {
            "org.lukasoppermann.figmaDesignTokens": {
              styleId: "S:9df6534f0eb7e841c2a96fa4bc433763a72b173d,",
              exportKey: "color"
            }
          }
        },
        surface2: {
          "0": {
            type: "color",
            value: "#f5fbf4ff",
            blendMode: "normal"
          },
          "1": {
            type: "color",
            value: "#006c4714",
            blendMode: "normal"
          },
          description: "Surface 2",
          extensions: {
            "org.lukasoppermann.figmaDesignTokens": {
              styleId: "S:4e74c5db651b8838bb1bf365586844e10520f563,",
              exportKey: "color"
            }
          }
        },
        surface3: {
          "0": {
            type: "color",
            value: "#f5fbf4ff",
            blendMode: "normal"
          },
          "1": {
            type: "color",
            value: "#006c471c",
            blendMode: "normal"
          },
          description: "Surface 3",
          extensions: {
            "org.lukasoppermann.figmaDesignTokens": {
              styleId: "S:6ba9c472947a58f2e0a0bbe69609b79808bcefcf,",
              exportKey: "color"
            }
          }
        },
        surface4: {
          "0": {
            type: "color",
            value: "#f5fbf4ff",
            blendMode: "normal"
          },
          "1": {
            type: "color",
            value: "#006c471f",
            blendMode: "normal"
          },
          description: "Surface 4",
          extensions: {
            "org.lukasoppermann.figmaDesignTokens": {
              styleId: "S:6966478aab4a1075b7ef3939dcdef29ce8a122ca,",
              exportKey: "color"
            }
          }
        },
        surface5: {
          "0": {
            type: "color",
            value: "#f5fbf4ff",
            blendMode: "normal"
          },
          "1": {
            type: "color",
            value: "#006c4724",
            blendMode: "normal"
          },
          description: "Surface 5",
          extensions: {
            "org.lukasoppermann.figmaDesignTokens": {
              styleId: "S:92f43050afcb2e7a57cb24e384f4ed5b1a29d6cb,",
              exportKey: "color"
            }
          }
        }
      }
    },
    "state-layers": {
      light: {
        primary: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#006c4714",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:496bd37f0e77680f5e94399e8afe4c5c533418fa,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#006c471f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6dd4139f34ae2c339f7a3b41a9339e5d4033af9d,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#006c4729",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:164236f8b9ab898d7f661912aefde5fba97ecb23,",
                exportKey: "color"
              }
            }
          }
        },
        "on-primary": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ffffff14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:987d1bad0ce97bf05e70dc2126a4e883c86ffe1a,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ffffff1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:0208f8fd1ada5d276c214826c0eaaa160b7fa7e8,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ffffff29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:588947594c6b0f9bc28e8bca0fcdfb6565ba4ba7,",
                exportKey: "color"
              }
            }
          }
        },
        "primary-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#eaddff14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:3d1aa73d6e0cb722dc8631ceae883f13851939ca,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#eaddff1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:ffe9392e7bc0663d8c8740c6966e0680be38b76f,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#eaddff29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:810e0a596ea0e8e4a91755e6d8d4049bf706b396,",
                exportKey: "color"
              }
            }
          }
        },
        "on-primary-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#21005d14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:b86df504605f363907c0232f8202f2728dafa9fd,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#21005d1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:90f0278d59972c64905d0eaecd57fe354059a6d6,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#21005d29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6dfcea7d5b09a701a43949b1831b18cc80d0bba4,",
                exportKey: "color"
              }
            }
          }
        },
        secondary: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#113f1e14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:fca83663c61db9b90e496b37a662949868832567,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#113f1e1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:46da30cd53835d134737fb8b7f7a23c2180b0e02,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#113f1e29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:7ebc8b8ea38ba44d52d3ea9769d99576aede8473,",
                exportKey: "color"
              }
            }
          }
        },
        "on-secondary": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ffffff14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:8de69fbb3a3388e42bbca875a26e48770d434593,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ffffff1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:9f4594e89334881cb46b5a9da8400d5d51a68a19,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ffffff29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:570e5cd20e0c07f2eb75d32c98cae71de43b413c,",
                exportKey: "color"
              }
            }
          }
        },
        "secondary-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#e8def814",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:222458ee430509607c7e9b1b1ffa50dab1348a30,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#e8def81f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:55e929838c9fa2f1221e6b3b73d3c4d37fe91bf3,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#e8def829",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:0144be89ec179cea7928b78f4934fa461eaeb59f,",
                exportKey: "color"
              }
            }
          }
        },
        "on-secondary-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#1d192b14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:5356f4b61a2a631fe47bd3620cae6309bed53930,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#1d192b1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:1b2138f377bf08b08ee79ce577dc2daec6594c6d,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#1d192b29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:16df5a007b010ab9c56336564c3b22d2648cb870,",
                exportKey: "color"
              }
            }
          }
        },
        tertiary: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#003d4914",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:d8779837c09a0b74e82cc1814c37fa5810ce40be,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#003d491f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:ab2d147550287333f6f09664ae91baae9e34a322,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#003d4929",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:a450b20c2e1e4bad50dcab3f3eb58ef386182896,",
                exportKey: "color"
              }
            }
          }
        },
        "on-tertiary": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ffffff14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:cdf69d8194c38947010f7641751c7b9b36ff732c,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ffffff1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:973f0e16242f1a89ebc3b71b92cf9e617d789389,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ffffff29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:4f3793f0ed0c0b19827df86b96285e5b13146edb,",
                exportKey: "color"
              }
            }
          }
        },
        "tertiary-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ffd8e414",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:c21638848d3e353187b57e652ad0223017d0af0b,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ffd8e41f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:1cc928e94436b28d769d0468ef83802b24c7fe18,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ffd8e429",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:97fb329006e36f30102e4cd4f50e1eb9f58b47a3,",
                exportKey: "color"
              }
            }
          }
        },
        "on-tertiary-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#31111d14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:8c55f41d17aab191b17504faf8ac04740020a779,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#31111d1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:220209d84fb74bf470e27defcf6fbbba546ec79a,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#31111d29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:f06f46701f876b93b421720dc8b8104b97c07827,",
                exportKey: "color"
              }
            }
          }
        },
        error: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#71000514",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6c26561649595c7028bc472e3a59af0d77dacf06,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#7100051f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:f722df7d853dad9cb8655c73c3e641d63acaf210,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#71000529",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:60a92defea40fbfcca3e8b730ae424eebfa35541,",
                exportKey: "color"
              }
            }
          }
        },
        "on-error": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ffffff14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:a1b771d9be55122722f8d7351c2572df454c1207,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ffffff1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:ed39ee2097cd4c1280418d1959991c240f61bdf3,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ffffff29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6827878a30d283b245e364229523fb8628f9098a,",
                exportKey: "color"
              }
            }
          }
        },
        "error-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#f9dedc14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:ec4c882adea393dff1bc9920f41a6330bb75a472,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#f9dedc1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:04540d619fffc16567347d83f76fbcf15df3ca94,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#f9dedc29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:d3b60a383b4b3dd113ee40acc004dbfdab466132,",
                exportKey: "color"
              }
            }
          }
        },
        "on-error-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#410e0b14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:e2ed6b55e9b76cb3852dde4d3552eb5cd12eb315,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#410e0b1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:4281285471e1b2145a2c568b717d111678b4fd67,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#410e0b29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:a4764912c7a32be502e577a3ce5f250f3a4d47f6,",
                exportKey: "color"
              }
            }
          }
        },
        outline: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#6e7a7114",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:d187d2c5c224fb20854e3579d48ce0833c739b34,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#6e7a711f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:c71d530d8551df068848eab2044c9d5c1f7c6351,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#6e7a7129",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:e5314af7a65ac044f8f0584a3379d79aebe70384,",
                exportKey: "color"
              }
            }
          }
        },
        background: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#f5fbf414",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:8fb3a1c95b447b344418b593cd045813bb6aba78,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#f5fbf41f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:9331cae42c4a7d3561457b00a4afe0b35c2e5993,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#f5fbf429",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:981f4acac2be7b78f106e6c2af5ece92fd6075ae,",
                exportKey: "color"
              }
            }
          }
        },
        "on-background": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#1d1b2014",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:f57374724b1e652d8f27ce9960a04593287b3d87,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#1d1b201f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:005e09482eeacaac592a8894672ce64af3294a0e,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#1d1b2029",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:7a334a2c17da77d7202488ffb2b49fd3529bbc35,",
                exportKey: "color"
              }
            }
          }
        },
        surface: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#f5fbf414",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:c4fb91236de73e6403a1eacb8cd51c64dbc19433,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#f5fbf41f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:a270afdef79c9fff6db58be414367542035b498b,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#f5fbf429",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:9abea4e00a2986d05e754e7468fbe435bf46f662,",
                exportKey: "color"
              }
            }
          }
        },
        "on-surface": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#1d1b2014",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:48cf28329173bb5f7ec5fa26f820676f7b20036d,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#1d1b201f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:af2e49ece4c773a3307c7e129e7a1d946be4ce7c,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#1d1b2029",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:f9b001162cbc71b479446df6dd06af73599ee6c5,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-variant": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#e7e0ec14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:f555b9aa789a1583ba2e04945926b63a2e9ffd1c,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#e7e0ec1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:4c0f7d5627e682b91c845d7ab7e4fd69361ec28f,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#e7e0ec29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:de84b830d1027c0ef97ded6c4434bf0a8d2e5618,",
                exportKey: "color"
              }
            }
          }
        },
        "on-surface-variant": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#49454f14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:bce3fc0078d9f2cdd40a705cdfe4ba745cc4bbcd,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#49454f1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:31935f300ce3c2f715742d125da06f7f22258ebb,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#49454f29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:916f4c5b3d7fb2867c4aa2df55e2d17bfbfbe555,",
                exportKey: "color"
              }
            }
          }
        },
        "inverse-surface": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#322f3514",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6bc26f834f15cf22cdb652538666781b53caeff2,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#322f351f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:a6aae4fc79a0702ae4089fbd11151a499f953b14,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#322f3529",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:11ef565f2de4bec9d888816d9711689f4461d1f2,",
                exportKey: "color"
              }
            }
          }
        },
        "inverse-on-surface": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#f5eff714",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:91d2bcccea8ef825c4a0d98dc11663c233870d62,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#f5eff71f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:4251ff846f7da494da017f974f3a8d2c44b5cad9,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#f5eff729",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:2cfee6524113d5ca3e587dfc5c3fe7b1c9d4be6e,",
                exportKey: "color"
              }
            }
          }
        },
        shadow: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#00000014",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:56eece1d113e9fdecbdc69d7cfab424ae5b35600,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#0000001f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6152b45a2abbbdb2e01f54ea87f1535d6c910249,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#00000029",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:a14623f23a0c1cb4a6cb80436c1895d677255555,",
                exportKey: "color"
              }
            }
          }
        },
        "outline-variant": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#cac4d014",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:9ccfa4584435dc3902da09a21112e3db1e5948fa,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#cac4d01f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:cb72db4c8bee975a5ef054d5591675db9dbb3e57,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#cac4d029",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:a99128a003a1339ae501dc9c5b53694098d87e8c,",
                exportKey: "color"
              }
            }
          }
        },
        scrim: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#00000014",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:296ac5b0f9ea8b88209d82c3ce5985e7c0c42a76,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#0000001f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6f3e30a74b906784056996d79c82e1cd86c1fc85,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#00000029",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:fbe914b520a17be9bbea3b398519043a6368e40d,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-container-highest": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#e6e0e914",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:5b264523f39c3e3e542c7ebfc52f5d8aa19791b6,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#e6e0e91f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:2e6b067ac45a177129ef8aa675a1136df367c4ef,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#e6e0e929",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:b6acc4042d37a9a2608b8ebea2c5334c9037e306,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-container-high": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ece6f014",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:cf59a693f3de83efc7111fd58e3f2be7a59d5371,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ece6f01f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:cfc4834195c92891540ff0ce6cfa2eacb758e4b6,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ece6f029",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:fb46bee7f33cfb3da1c783f5f4f62aa769425348,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-container": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#f3edf714",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:276d7c0d95a369aa3bbc66af33733bf226f27e4e,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#f3edf71f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:9be3d56282a7191c6507fcb943b38ae623b68b9b,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#f3edf729",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:d94250612c2023e644a86f581c558192034458b2,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-container-low": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#f7f2fa14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:4416bb6a8d199bcab0da49a2e608470ebfd79e89,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#f7f2fa1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:f5ca6d62436b603539751ab44a97d1161cb8a41a,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#f7f2fa29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:5a6acae3c23a716998f0b840e93f1bd1c339f2bd,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-container-lowest": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ffffff14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:9967b2189df744c343f308b7634bcd341e20e330,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ffffff1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:d5dd9fdfc011270e897265ba49b0013adc25e69b,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ffffff29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:cab7ee63b706b51ad103b46c0915c6695e0d1c74,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-bright": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#fef7ff14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:214f4ab3e1948eda8f8de2dec39413079c9f153a,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#fef7ff1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:1c01ae350767acf6f4a4b5c89793a59d5182c277,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#fef7ff29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:7d20256336cc5855afd03d88bf639ba825448614,",
                exportKey: "color"
              }
            }
          }
        },
        "surface-dim": {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#ded8e114",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:24c44eca6b7f7873226fd89b909803d06d5e1abe,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#ded8e11f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:29b61cf5cfa36f9b7db8bafe4d1250e5a4eefb96,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#ded8e129",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:b8c927eaddbd776b897edbb8662854142e0324c2,",
                exportKey: "color"
              }
            }
          }
        },
        surfacetint: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#006c4714",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:d338f1126811a20d28b55e6ea1ba2c9d1f3cfdd3,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#006c471f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:76c29bfae5f1ac6a279915fe02d702a706a441f8,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#006c4729",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:6018fadfcad1d5822ee086dc905d3654a6259c63,",
                exportKey: "color"
              }
            }
          }
        },
        surfacecontainerhigh: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#e4eae314",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:e68ac261d5311b818e4f327a79e834ed8d146d82,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#e4eae31f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:4ab099124ffbfc5182324ab545704e50a2cf703a,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#e4eae329",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:8a690d4b6b88dab1ccb1885ec0030ca286898293,",
                exportKey: "color"
              }
            }
          }
        },
        surfacecontainerhighest: {
          "opacity-0.08": {
            description: "",
            type: "color",
            value: "#dee4de14",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:53d0499a2b4768550fc100931e6ecda4a5cf0107,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.12": {
            description: "",
            type: "color",
            value: "#dee4de1f",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:1d9b38783cd373bb4a3a065a7dce51d538464356,",
                exportKey: "color"
              }
            }
          },
          "opacity-0.16": {
            description: "",
            type: "color",
            value: "#dee4de29",
            blendMode: "normal",
            extensions: {
              "org.lukasoppermann.figmaDesignTokens": {
                styleId: "S:3adfefc8b95ffb700194c50c07a29d68ddfc746e,",
                exportKey: "color"
              }
            }
          }
        }
      }
    }
  },
  "on color": {
    primary: {
      "on-primary": {
        description: "",
        type: "color",
        value: "#ffffffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:876092e8b072728061faab4d8a28655f04b8d510,",
            exportKey: "color"
          }
        }
      }
    },
    secondary: {
      "on-secondary": {
        description: "",
        type: "color",
        value: "#ffffffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:a8942e945054247447d9f3217f21123586bf36b8,",
            exportKey: "color"
          }
        }
      }
    },
    tertiary: {
      "on-tertiary": {
        description: "",
        type: "color",
        value: "#ffffffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:0b644417c4ab5bc4a6bcbfd574b8d9d47e1bf548,",
            exportKey: "color"
          }
        }
      }
    },
    signal: {
      "on-error": {
        description: "",
        type: "color",
        value: "#ffffffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:729cf8a4472192a6060bcb29e7723c55413c0647,",
            exportKey: "color"
          }
        }
      },
      "on-info": {
        description: "",
        type: "color",
        value: "#003844ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:995fc52b746c9ac343996d0c818e9c2d2135736c,",
            exportKey: "color"
          }
        }
      },
      "on-success": {
        description: "",
        type: "color",
        value: "#00180dff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:92c8e196bfc71bfb0b5a6b8ecfe574076e213a5f,",
            exportKey: "color"
          }
        }
      },
      "on-warning": {
        description: "",
        type: "color",
        value: "#171d19ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:5aa4c37bc3c62ac0374bcab3a57d53138fc11bf9,",
            exportKey: "color"
          }
        }
      }
    },
    surface: {
      "on-surface": {
        description: "",
        type: "color",
        value: "#171d19ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:39f990ed45a932a067591823171bacc217e0e310,",
            exportKey: "color"
          }
        }
      },
      "on-surface-variant": {
        description: "",
        type: "color",
        value: "#3e4a42ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:854da5674bf98231f84b4bef6b62521e85f581d9,",
            exportKey: "color"
          }
        }
      },
      "inverse-on-surface": {
        description: "",
        type: "color",
        value: "#edf2ecff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:b44da40ff3b31c72b96ce912f0755923402258da,",
            exportKey: "color"
          }
        }
      },
      "on-primary-container": {
        description: "",
        type: "color",
        value: "#00180dff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:6d41c4891b1111cbc89ab33ad6cd522c0f2584f4,",
            exportKey: "color"
          }
        }
      },
      "on-secondary-container": {
        description: "",
        type: "color",
        value: "#ffffffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:e4734e7f0bd504f545208d462c4bf9af9a55d569,",
            exportKey: "color"
          }
        }
      },
      "on-tertiary-container": {
        description: "",
        type: "color",
        value: "#003844ff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:302e8218ab50f867f575d1d2208f052e83d0b5be,",
            exportKey: "color"
          }
        }
      },
      "on-error-container": {
        description: "",
        type: "color",
        value: "#fffcffff",
        blendMode: "normal",
        extensions: {
          "org.lukasoppermann.figmaDesignTokens": {
            styleId: "S:d12c80a364828b80ca30e71c9942705ecc078e46,",
            exportKey: "color"
          }
        }
      }
    }
  }
};
var grid = {
  large: {
    "large (1440+dp) layout regions off": {
      "0": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 120,
          gutterSize: 20,
          alignment: "max",
          count: 1,
          offset: 0
        }
      },
      "1": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 80,
          gutterSize: 51,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      "2": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 8,
          gutterSize: 0,
          alignment: "min",
          count: 1000,
          offset: 0
        }
      },
      "3": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 82,
          gutterSize: 24,
          alignment: "center",
          count: 12
        }
      },
      description: null,
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:ca8f8d8c95b358fd3dc0cd05af6261c3a85e1041,",
          exportKey: "grid"
        }
      }
    },
    "large (1440+dp) layout regions on": {
      "0": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 78,
          gutterSize: 24,
          alignment: "min",
          count: 12,
          offset: 160
        }
      },
      "1": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 80,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      "2": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 48,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      description: null,
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:96b677a597042ed4d592d27a67fe4640146cbce4,",
          exportKey: "grid"
        }
      }
    },
    "large (1440+dp) layout regions expanded": {
      "0": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 60,
          gutterSize: 24,
          alignment: "min",
          count: 12,
          offset: 378
        }
      },
      "1": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 268,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      "2": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 48,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      description: null,
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:efd6c3331a5716e0ecc239e51dfa310f5ffecd5f,",
          exportKey: "grid"
        }
      }
    }
  },
  medium: {
    "medium (905-1239dp) layout regions off": {
      description: null,
      type: "custom-grid",
      value: {
        pattern: "columns",
        gutterSize: 24,
        alignment: "stretch",
        count: 12,
        offset: 24
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:c405c07b80801588c6cfd34df8f2558c39f42926,",
          exportKey: "grid"
        }
      }
    },
    "medium (1240-1439dp) layout regions off": {
      description: null,
      type: "custom-grid",
      value: {
        pattern: "columns",
        gutterSize: 24,
        alignment: "stretch",
        count: 12,
        offset: 200
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:5851ad5f1a5a12860588cef6a48cc7022948fbc5,",
          exportKey: "grid"
        }
      }
    },
    "medium (1240-1439dp) layout regions on": {
      "0": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          gutterSize: 24,
          alignment: "stretch",
          count: 12,
          offset: 200
        }
      },
      "1": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 72,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      "2": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 56,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      description: null,
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:76e39f206d8488feea95b7370219568b20f6014c,",
          exportKey: "grid"
        }
      }
    },
    "medium (905-1239dp) layout regions on": {
      "0": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 52,
          gutterSize: 12,
          alignment: "max",
          count: 12,
          offset: 32
        }
      },
      "1": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 72,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      "2": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 56,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      description: null,
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:c86e61ecdf2d2979abd0c6eabeb7eae22ac794f5,",
          exportKey: "grid"
        }
      }
    }
  },
  small: {
    "small (600-904dp) layout regions on": {
      "0": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 46,
          gutterSize: 16,
          alignment: "max",
          count: 8,
          offset: 32
        }
      },
      "1": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          sectionSize: 72,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      "2": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 56,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      description: null,
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:b0d8af5c6f15118795b05de7c04ee8ae3815b78d,",
          exportKey: "grid"
        }
      }
    },
    "small (600-904dp) layout regions off": {
      description: null,
      type: "custom-grid",
      value: {
        pattern: "columns",
        gutterSize: 16,
        alignment: "stretch",
        count: 8,
        offset: 32
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:14f3fddec85baa6dd00fcfc0c67a1c1acf7c985a,",
          exportKey: "grid"
        }
      }
    }
  },
  "extra small": {
    "extra small (0-599dp) layout regions on": {
      "0": {
        type: "custom-grid",
        value: {
          pattern: "columns",
          gutterSize: 16,
          alignment: "stretch",
          count: 4,
          offset: 16
        }
      },
      "1": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 34,
          gutterSize: 46,
          alignment: "max",
          count: 1,
          offset: 0
        }
      },
      "2": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 51,
          gutterSize: 50,
          alignment: "max",
          count: 1,
          offset: 34
        }
      },
      "3": {
        type: "custom-grid",
        value: {
          pattern: "rows",
          sectionSize: 62,
          gutterSize: 1,
          alignment: "min",
          count: 1,
          offset: 0
        }
      },
      description: null,
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:5a37b3ab2ab145df370ba43aa38cc4038fed88fd,",
          exportKey: "grid"
        }
      }
    },
    "extra small (0-599dp) layout regions off": {
      description: null,
      type: "custom-grid",
      value: {
        pattern: "columns",
        gutterSize: 16,
        alignment: "stretch",
        count: 4,
        offset: 16
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:8e8cf7a6159f6985d82613e799a21b05d07e7581,",
          exportKey: "grid"
        }
      }
    }
  }
};
var font = {
  display: {
    xl: {
      description: "Mainly for Web Use",
      type: "custom-fontStyle",
      value: {
        fontSize: 64,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 700,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 70.4,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:0bd81db9b9c062d0395dcf9900d3550f940865dc,",
          exportKey: "font"
        }
      }
    },
    large: {
      type: "custom-fontStyle",
      value: {
        fontSize: 57,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: -0.25,
        lineHeight: 64,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:65e6bad331f30fef2d30e7eae26e8a051cd4dd60,",
          exportKey: "font"
        }
      }
    },
    medium: {
      type: "custom-fontStyle",
      value: {
        fontSize: 45,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 52,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:8c4232cfac7336ea383c9114c926d5f188771bd5,",
          exportKey: "font"
        }
      }
    },
    "small - prominent": {
      description: "Used in Web",
      type: "custom-fontStyle",
      value: {
        fontSize: 36,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 700,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 44,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:605b7d3a260a5aa32efeab1961e361c31705aa91,",
          exportKey: "font"
        }
      }
    },
    small: {
      type: "custom-fontStyle",
      value: {
        fontSize: 36,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 44,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:d4f363947afd0c60d9b062788bc83134ac916a16,",
          exportKey: "font"
        }
      }
    }
  },
  headline: {
    xl: {
      type: "custom-fontStyle",
      value: {
        fontSize: 36,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 700,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 40,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:72f55148531dcfcdde0bd785bfc5fe418ce6bd6d,",
          exportKey: "font"
        }
      }
    },
    large: {
      type: "custom-fontStyle",
      value: {
        fontSize: 32,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 40,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:7e26580ff029fd1b2e43e0de91cfb217d7d8bfaa,",
          exportKey: "font"
        }
      }
    },
    medium: {
      type: "custom-fontStyle",
      value: {
        fontSize: 28,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 36,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:9b1675a8e1fc5465bdd3db9f78f17ef6284881f0,",
          exportKey: "font"
        }
      }
    },
    small: {
      type: "custom-fontStyle",
      value: {
        fontSize: 24,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 32,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:81d4d29f056d05fcd886b46bd0a1f0063c288024,",
          exportKey: "font"
        }
      }
    }
  },
  title: {
    xl: {
      type: "custom-fontStyle",
      value: {
        fontSize: 28,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 33.6,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:5ad02f1903843451b902f718e30aa93611548853,",
          exportKey: "font"
        }
      }
    },
    large: {
      type: "custom-fontStyle",
      value: {
        fontSize: 22,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 28,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:fbfbf82581845103cacde890d006b1b72b366166,",
          exportKey: "font"
        }
      }
    },
    medium: {
      type: "custom-fontStyle",
      value: {
        fontSize: 16,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.15,
        lineHeight: 24,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:b85f6a9f13a581a54832e65990d2e2a78ca4a151,",
          exportKey: "font"
        }
      }
    },
    small: {
      type: "custom-fontStyle",
      value: {
        fontSize: 14,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.1,
        lineHeight: 20,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:776f9052d6a3a2a8b396ebe897c20ef38325f56f,",
          exportKey: "font"
        }
      }
    }
  },
  body: {
    xl: {
      type: "custom-fontStyle",
      value: {
        fontSize: 18,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.5,
        lineHeight: 21.6,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:c715520d15c2a0d2553cb20765585aa9f6968c3f,",
          exportKey: "font"
        }
      }
    },
    large: {
      type: "custom-fontStyle",
      value: {
        fontSize: 16,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.5,
        lineHeight: 24,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:3db5c26e19b57ba99e584a0a1739f4b3e2ba9233,",
          exportKey: "font"
        }
      }
    },
    medium: {
      type: "custom-fontStyle",
      value: {
        fontSize: 14,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 400,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.25,
        lineHeight: 20,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:c719658ba5baa36efc0c4e53f63427199a2b2408,",
          exportKey: "font"
        }
      }
    },
    small: {
      description: "0.4",
      type: "custom-fontStyle",
      value: {
        fontSize: 12,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 300,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 16,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:7402d80df1e412a44dfb8ed4e1d1b07b2ea0362d,",
          exportKey: "font"
        }
      }
    },
    "extra small": {
      type: "custom-fontStyle",
      value: {
        fontSize: 8,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 300,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0,
        lineHeight: 9.6,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:e56203896bdfec8c512d99b7498e12939c80e6c3,",
          exportKey: "font"
        }
      }
    }
  },
  label: {
    "label extra large - prominent": {
      type: "custom-fontStyle",
      value: {
        fontSize: 16,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.1,
        lineHeight: 19.2,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:b9fdd606a4b1de5dced201e2f99d61ab8d10379d,",
          exportKey: "font"
        }
      }
    },
    "label extra large": {
      type: "custom-fontStyle",
      value: {
        fontSize: 16,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.1,
        lineHeight: 19.2,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:e4f59f81ea32f247e03961910a2c74831a4a7ef5,",
          exportKey: "font"
        }
      }
    },
    "large - prominent": {
      type: "custom-fontStyle",
      value: {
        fontSize: 14,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.1,
        lineHeight: 20,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:c3d7e0e5b36430128cf79dea86065554990fd5b0,",
          exportKey: "font"
        }
      }
    },
    large: {
      type: "custom-fontStyle",
      value: {
        fontSize: 14,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.1,
        lineHeight: 20,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:a851ef12bb7885107daa5857b2ae71947b81efec,",
          exportKey: "font"
        }
      }
    },
    "medium - prominent": {
      type: "custom-fontStyle",
      value: {
        fontSize: 12,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 600,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.5,
        lineHeight: 16,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:6bb079150abdd3bec3d7793ba19c77625c7d6293,",
          exportKey: "font"
        }
      }
    },
    medium: {
      type: "custom-fontStyle",
      value: {
        fontSize: 12,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.5,
        lineHeight: 16,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:1eae49cd0d9a0d2761587d3227ca65ac06c958f5,",
          exportKey: "font"
        }
      }
    },
    small: {
      type: "custom-fontStyle",
      value: {
        fontSize: 11,
        textDecoration: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: 0.5,
        lineHeight: 16,
        paragraphIndent: 0,
        paragraphSpacing: 0,
        textCase: "none"
      },
      extensions: {
        "org.lukasoppermann.figmaDesignTokens": {
          styleId: "S:38c5c51a096e2731291fe3f4f50e18673088a01a,",
          exportKey: "font"
        }
      }
    }
  }
};
var effect = {
  "1": {
    "0": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 1,
        color: "#0000001f",
        offsetX: 0,
        offsetY: 0,
        spread: 0
      }
    },
    "1": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 2,
        color: "#0000001a",
        offsetX: 1,
        offsetY: 2,
        spread: 0
      }
    },
    "2": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 2,
        color: "#0000000f",
        offsetX: 2,
        offsetY: 4,
        spread: 0
      }
    },
    "3": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 3,
        color: "#00000005",
        offsetX: 3,
        offsetY: 7,
        spread: 0
      }
    },
    "4": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 3,
        color: "#00000000",
        offsetX: 5,
        offsetY: 10,
        spread: 0
      }
    },
    description: null,
    extensions: {
      "org.lukasoppermann.figmaDesignTokens": {
        styleId: "S:8d94d1dccc988bc4243385937e3d72154a1051e9,",
        exportKey: "effect"
      }
    }
  },
  "2": {
    "0": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 2,
        color: "#0000001f",
        offsetX: 0,
        offsetY: 1,
        spread: 0
      }
    },
    "1": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 4,
        color: "#0000001a",
        offsetX: 2,
        offsetY: 3,
        spread: 0
      }
    },
    "2": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 5,
        color: "#0000000f",
        offsetX: 3,
        offsetY: 7,
        spread: 0
      }
    },
    "3": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 6,
        color: "#00000005",
        offsetX: 6,
        offsetY: 13,
        spread: 0
      }
    },
    "4": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 6,
        color: "#00000000",
        offsetX: 10,
        offsetY: 20,
        spread: 0
      }
    },
    description: null,
    extensions: {
      "org.lukasoppermann.figmaDesignTokens": {
        styleId: "S:345574f8d0c7786bbc0dfe73d7944a8e084d1428,",
        exportKey: "effect"
      }
    }
  },
  "3": {
    "0": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 4,
        color: "#0000001f",
        offsetX: 1,
        offsetY: 2,
        spread: 0
      }
    },
    "1": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 7,
        color: "#0000001a",
        offsetX: 3,
        offsetY: 7,
        spread: 0
      }
    },
    "2": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 10,
        color: "#0000000f",
        offsetX: 7,
        offsetY: 15,
        spread: 0
      }
    },
    "3": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 12,
        color: "#00000005",
        offsetX: 13,
        offsetY: 27,
        spread: 0
      }
    },
    "4": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 13,
        color: "#00000000",
        offsetX: 20,
        offsetY: 42,
        spread: 0
      }
    },
    description: null,
    extensions: {
      "org.lukasoppermann.figmaDesignTokens": {
        styleId: "S:9bae1a0a027cf1e50ce2b51692b1cca1553fe447,",
        exportKey: "effect"
      }
    }
  },
  "4": {
    "0": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 6,
        color: "#0000001f",
        offsetX: 1,
        offsetY: 2,
        spread: 0
      }
    },
    "1": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 11,
        color: "#0000001a",
        offsetX: 5,
        offsetY: 10,
        spread: 0
      }
    },
    "2": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 15,
        color: "#0000000f",
        offsetX: 10,
        offsetY: 22,
        spread: 0
      }
    },
    "3": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 17,
        color: "#00000005",
        offsetX: 18,
        offsetY: 39,
        spread: 0
      }
    },
    "4": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 19,
        color: "#00000000",
        offsetX: 29,
        offsetY: 61,
        spread: 0
      }
    },
    description: null,
    extensions: {
      "org.lukasoppermann.figmaDesignTokens": {
        styleId: "S:fa597e003b3c7ff685f653e9245eb788a28fec20,",
        exportKey: "effect"
      }
    }
  },
  "5": {
    "0": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 9,
        color: "#0000001f",
        offsetX: 2,
        offsetY: 4,
        spread: 0
      }
    },
    "1": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 17,
        color: "#0000001a",
        offsetX: 7,
        offsetY: 15,
        spread: 0
      }
    },
    "2": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 23,
        color: "#0000000f",
        offsetX: 16,
        offsetY: 34,
        spread: 0
      }
    },
    "3": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 27,
        color: "#00000005",
        offsetX: 28,
        offsetY: 61,
        spread: 0
      }
    },
    "4": {
      type: "custom-shadow",
      value: {
        shadowType: "dropShadow",
        radius: 29,
        color: "#00000000",
        offsetX: 44,
        offsetY: 95,
        spread: 0
      }
    },
    description: null,
    extensions: {
      "org.lukasoppermann.figmaDesignTokens": {
        styleId: "S:94c0ccad770043b919ec8be80af1f67b97757e20,",
        exportKey: "effect"
      }
    }
  }
};
var typography = {
  display: {
    xl: {
      description: "Mainly for Web Use",
      fontSize: {
        type: "dimension",
        value: 64
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 700
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 70.4
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    large: {
      fontSize: {
        type: "dimension",
        value: 57
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 400
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: -0.25
      },
      lineHeight: {
        type: "dimension",
        value: 64
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    medium: {
      fontSize: {
        type: "dimension",
        value: 45
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 400
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 52
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    "small - prominent": {
      description: "Used in Web",
      fontSize: {
        type: "dimension",
        value: 36
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 700
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 44
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    small: {
      fontSize: {
        type: "dimension",
        value: 36
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 44
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    }
  },
  headline: {
    xl: {
      fontSize: {
        type: "dimension",
        value: 36
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 700
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 40
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    large: {
      fontSize: {
        type: "dimension",
        value: 32
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 400
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 40
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    medium: {
      fontSize: {
        type: "dimension",
        value: 28
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 36
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    small: {
      fontSize: {
        type: "dimension",
        value: 24
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 400
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 32
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    }
  },
  title: {
    xl: {
      fontSize: {
        type: "dimension",
        value: 28
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 600
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 33.6
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    large: {
      fontSize: {
        type: "dimension",
        value: 22
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 28
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    medium: {
      fontSize: {
        type: "dimension",
        value: 16
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.15
      },
      lineHeight: {
        type: "dimension",
        value: 24
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    small: {
      fontSize: {
        type: "dimension",
        value: 14
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.1
      },
      lineHeight: {
        type: "dimension",
        value: 20
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    }
  },
  body: {
    xl: {
      fontSize: {
        type: "dimension",
        value: 18
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 400
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.5
      },
      lineHeight: {
        type: "dimension",
        value: 21.6
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    large: {
      fontSize: {
        type: "dimension",
        value: 16
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 400
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.5
      },
      lineHeight: {
        type: "dimension",
        value: 24
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    medium: {
      fontSize: {
        type: "dimension",
        value: 14
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 400
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.25
      },
      lineHeight: {
        type: "dimension",
        value: 20
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    small: {
      description: "0.4",
      fontSize: {
        type: "dimension",
        value: 12
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 300
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 16
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    "extra small": {
      fontSize: {
        type: "dimension",
        value: 8
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 300
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0
      },
      lineHeight: {
        type: "dimension",
        value: 9.6
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    }
  },
  label: {
    "label extra large - prominent": {
      fontSize: {
        type: "dimension",
        value: 16
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 600
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.1
      },
      lineHeight: {
        type: "dimension",
        value: 19.2
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    "label extra large": {
      fontSize: {
        type: "dimension",
        value: 16
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.1
      },
      lineHeight: {
        type: "dimension",
        value: 19.2
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    "large - prominent": {
      fontSize: {
        type: "dimension",
        value: 14
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 600
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.1
      },
      lineHeight: {
        type: "dimension",
        value: 20
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    large: {
      fontSize: {
        type: "dimension",
        value: 14
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.1
      },
      lineHeight: {
        type: "dimension",
        value: 20
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    "medium - prominent": {
      fontSize: {
        type: "dimension",
        value: 12
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 600
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.5
      },
      lineHeight: {
        type: "dimension",
        value: 16
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    medium: {
      fontSize: {
        type: "dimension",
        value: 12
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.5
      },
      lineHeight: {
        type: "dimension",
        value: 16
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    },
    small: {
      fontSize: {
        type: "dimension",
        value: 11
      },
      textDecoration: {
        type: "string",
        value: "none"
      },
      fontFamily: {
        type: "string",
        value: "Poppins"
      },
      fontWeight: {
        type: "number",
        value: 500
      },
      fontStyle: {
        type: "string",
        value: "normal"
      },
      fontStretch: {
        type: "string",
        value: "normal"
      },
      letterSpacing: {
        type: "dimension",
        value: 0.5
      },
      lineHeight: {
        type: "dimension",
        value: 16
      },
      paragraphIndent: {
        type: "dimension",
        value: 0
      },
      paragraphSpacing: {
        type: "dimension",
        value: 0
      },
      textCase: {
        type: "string",
        value: "none"
      }
    }
  }
};
var designTokens = {
  color: color,
  grid: grid,
  font: font,
  effect: effect,
  typography: typography
};
const isColorSurface = color => {
  if (color && color in designTokens.color.color.surfaces) {
    return true;
  }
  return false;
};
const isOnColorSurface = color => {
  if (color && color in designTokens.color['on color'].surface) {
    return true;
  }
  return false;
};
const isColorOnSignal = color => {
  if (color && color in designTokens.color['on color'].signal) {
    return true;
  }
  return false;
};
const isColorSignal = color => {
  if (color && color in designTokens.color.color.signal) {
    return true;
  }
  return false;
};
const isColorNeutral = color => {
  if (color && color in designTokens.color.color.neutral) {
    return true;
  }
  return false;
};
const isColorLight = color => {
  if (color && color in designTokens.color.color.neutral) {
    return true;
  }
  return false;
};
const getColor = color => {
  if (!color) return undefined;
  let colorObject = {
    value: ''
  };
  if (isColorSurface(color)) {
    colorObject = designTokens.color['color'].surfaces[color];
  } else if (isOnColorSurface(color)) {
    colorObject = designTokens.color['on color'].surface[color];
  } else if (isColorOnSignal(color)) {
    colorObject = designTokens.color['on color'].signal[color];
  } else if (isColorSignal(color)) {
    colorObject = designTokens.color.color.signal[color];
  } else if (isColorNeutral(color)) {
    colorObject = designTokens.color.color.neutral[color];
  } else if (isColorLight(color)) {
    colorObject = designTokens.color.color.light[color];
  }
  switch (color) {
    case 'primary':
      colorObject = designTokens.color.color.primary.primary;
      break;
    case 'on-primary':
      colorObject = designTokens.color['on color'].primary['on-primary'];
      break;
    case 'secondary':
      colorObject = designTokens.color.color.secondary.secondary;
      break;
    case 'on-secondary':
      colorObject = designTokens.color['on color'].secondary['on-secondary'];
      break;
    case 'tertiary':
      colorObject = designTokens.color.color.tertiary.tertiary;
      break;
    case 'on-tertiary':
      colorObject = designTokens.color['on color'].tertiary['on-tertiary'];
      break;
  }
  return (colorObject === null || colorObject === void 0 ? void 0 : colorObject.value) || color;
};
const ICONS_WITH_STROKE = {
  excel: 'excel',
  pdf: 'pdf',
  timesheets: 'timesheets',
  resourceMgmt: 'resourceMgmt',
  calendarDots: 'calendarDots',
  equals: 'equals',
  notEquals: 'notEquals',
  greaterThan: 'graterThan',
  lessThan: 'lessThan',
  greaterThanOrEqual: 'graterThanOrEqual',
  lessThanOrEqual: 'lessThanOrEqual',
  bookOpenText: 'bookOpenText',
  feedback_thumb: 'feedback_thumb',
  projectGroup: 'projectGroup',
  buildings: 'buildings',
  star_stroke: 'star_stroke',
  broom: 'broom'
};
// TODO: check with Sean if can be simpler icon
const ICONS_WITH_STROKE_AND_FILL = {
  information2: 'information2'
};
const svgStyles = _ref7 => {
  let {
    color,
    size,
    name,
    noFill
  } = _ref7;
  return css(["width:", ";height:", ";", ""], typeof size === 'number' ? "".concat(size, "px") : size, typeof size === 'number' ? "".concat(size, "px") : size, () => {
    if (noFill) {
      return css([""]);
    }
    if (color) {
      if (ICONS_WITH_STROKE_AND_FILL[name]) {
        return css(["& path{stroke:", ";fill:", ";stroke-width:0.1;mask:none;}"], color, color);
      } else if (ICONS_WITH_STROKE[name]) {
        return css(["& path{stroke:", ";}"], color);
      } else {
        return css(["& path{fill:", ";}"], color);
      }
    }
    return css([""]);
  });
};
const icons = {
  add: styled(ForwardRef$2m).withConfig({
    displayName: "icon__add",
    componentId: "sc-2ga6s0-0"
  })(["", ""], props => svgStyles(props)),
  close: styled(ForwardRef$1X).withConfig({
    displayName: "icon__close",
    componentId: "sc-2ga6s0-1"
  })(["", ""], props => svgStyles(props)),
  delete: styled(ForwardRef$1T).withConfig({
    displayName: "icon__delete",
    componentId: "sc-2ga6s0-2"
  })(["", ""], props => svgStyles(props)),
  error: styled(ForwardRef$1K).withConfig({
    displayName: "icon__error",
    componentId: "sc-2ga6s0-3"
  })(["", ""], props => svgStyles(props)),
  mobileFriendly: styled(ForwardRef$15).withConfig({
    displayName: "icon__mobileFriendly",
    componentId: "sc-2ga6s0-4"
  })(["", ""], props => svgStyles(props)),
  moveItem: styled(ForwardRef$11).withConfig({
    displayName: "icon__moveItem",
    componentId: "sc-2ga6s0-5"
  })(["", ""], props => svgStyles(props)),
  avgPace: styled(ForwardRef$2c).withConfig({
    displayName: "icon__avgPace",
    componentId: "sc-2ga6s0-6"
  })(["", ""], props => svgStyles(props)),
  savings: styled(ForwardRef$I).withConfig({
    displayName: "icon__savings",
    componentId: "sc-2ga6s0-7"
  })(["", ""], props => svgStyles(props)),
  pendingActions: styled(ForwardRef$V).withConfig({
    displayName: "icon__pendingActions",
    componentId: "sc-2ga6s0-8"
  })(["", ""], props => svgStyles(props)),
  hourglassBottom: styled(ForwardRef$1l).withConfig({
    displayName: "icon__hourglassBottom",
    componentId: "sc-2ga6s0-9"
  })(["", ""], props => svgStyles(props)),
  info: styled(ForwardRef$1j).withConfig({
    displayName: "icon__info",
    componentId: "sc-2ga6s0-10"
  })(["", ""], props => svgStyles(props)),
  navigateBefore: styled(ForwardRef$$).withConfig({
    displayName: "icon__navigateBefore",
    componentId: "sc-2ga6s0-11"
  })(["", ""], props => svgStyles(props)),
  navigateNext: styled(ForwardRef$_).withConfig({
    displayName: "icon__navigateNext",
    componentId: "sc-2ga6s0-12"
  })(["", ""], props => svgStyles(props)),
  edit: styled(ForwardRef$1M).withConfig({
    displayName: "icon__edit",
    componentId: "sc-2ga6s0-13"
  })(["", ""], props => svgStyles(props)),
  arrowDropUp: styled(ForwardRef$2h).withConfig({
    displayName: "icon__arrowDropUp",
    componentId: "sc-2ga6s0-14"
  })(["", ""], props => svgStyles(props)),
  arrowDropDown: styled(ForwardRef$2i).withConfig({
    displayName: "icon__arrowDropDown",
    componentId: "sc-2ga6s0-15"
  })(["", ""], props => svgStyles(props)),
  event: styled(ForwardRef$1I).withConfig({
    displayName: "icon__event",
    componentId: "sc-2ga6s0-16"
  })(["", ""], props => svgStyles(props)),
  featuredSeasonalAndGifts: styled(ForwardRef$1F).withConfig({
    displayName: "icon__featuredSeasonalAndGifts",
    componentId: "sc-2ga6s0-17"
  })(["", ""], props => svgStyles(props)),
  cancel: styled(ForwardRef$22).withConfig({
    displayName: "icon__cancel",
    componentId: "sc-2ga6s0-18"
  })(["", ""], props => svgStyles(props)),
  chevronUp: styled(ForwardRef$1Z).withConfig({
    displayName: "icon__chevronUp",
    componentId: "sc-2ga6s0-19"
  })(["", ""], props => svgStyles(props)),
  chevronDown: styled(ForwardRef$1_).withConfig({
    displayName: "icon__chevronDown",
    componentId: "sc-2ga6s0-20"
  })(["", ""], props => svgStyles(props)),
  search: styled(ForwardRef$G).withConfig({
    displayName: "icon__search",
    componentId: "sc-2ga6s0-21"
  })(["", ""], props => svgStyles(props)),
  arrowBack: styled(ForwardRef$2j).withConfig({
    displayName: "icon__arrowBack",
    componentId: "sc-2ga6s0-22"
  })(["", ""], props => svgStyles(props)),
  menu: styled(ForwardRef$17).withConfig({
    displayName: "icon__menu",
    componentId: "sc-2ga6s0-23"
  })(["", ""], props => svgStyles(props)),
  check: styled(ForwardRef$20).withConfig({
    displayName: "icon__check",
    componentId: "sc-2ga6s0-24"
  })(["", ""], props => svgStyles(props)),
  pdf: styled(ForwardRef$W).withConfig({
    displayName: "icon__pdf",
    componentId: "sc-2ga6s0-25"
  })(["", ""], props => svgStyles(props)),
  print: styled(ForwardRef$Q).withConfig({
    displayName: "icon__print",
    componentId: "sc-2ga6s0-26"
  })(["", ""], props => svgStyles(props)),
  excel: styled(ForwardRef$1H).withConfig({
    displayName: "icon__excel",
    componentId: "sc-2ga6s0-27"
  })(["", ""], props => svgStyles(props)),
  description: styled(ForwardRef$1R).withConfig({
    displayName: "icon__description",
    componentId: "sc-2ga6s0-28"
  })(["", ""], props => svgStyles(props)),
  lego: styled(ForwardRef$1g).withConfig({
    displayName: "icon__lego",
    componentId: "sc-2ga6s0-29"
  })(["", ""], props => svgStyles(props)),
  arrowForward: styled(ForwardRef$2g).withConfig({
    displayName: "icon__arrowForward",
    componentId: "sc-2ga6s0-30"
  })(["", ""], props => svgStyles(props)),
  clockUser: styled(ForwardRef$1Y).withConfig({
    displayName: "icon__clockUser",
    componentId: "sc-2ga6s0-31"
  })(["", ""], props => svgStyles(props)),
  paperPlaneTilt: styled(ForwardRef$X).withConfig({
    displayName: "icon__paperPlaneTilt",
    componentId: "sc-2ga6s0-32"
  })(["", ""], props => svgStyles(props)),
  slidersHorizontal: styled(ForwardRef$D).withConfig({
    displayName: "icon__slidersHorizontal",
    componentId: "sc-2ga6s0-33"
  })(["", ""], props => svgStyles(props)),
  arrowOutward: styled(ForwardRef$2f).withConfig({
    displayName: "icon__arrowOutward",
    componentId: "sc-2ga6s0-34"
  })(["", ""], props => svgStyles(props)),
  resubmit: styled(ForwardRef$J).withConfig({
    displayName: "icon__resubmit",
    componentId: "sc-2ga6s0-35"
  })(["", ""], props => svgStyles(props)),
  accessTime: styled(ForwardRef$2o).withConfig({
    displayName: "icon__accessTime",
    componentId: "sc-2ga6s0-36"
  })(["", ""], props => svgStyles(props)),
  today: styled(ForwardRef$t).withConfig({
    displayName: "icon__today",
    componentId: "sc-2ga6s0-37"
  })(["", ""], props => svgStyles(props)),
  frame: styled(ForwardRef$1v).withConfig({
    displayName: "icon__frame",
    componentId: "sc-2ga6s0-38"
  })(["", ""], props => svgStyles(props)),
  attachMoney: styled(ForwardRef$2e).withConfig({
    displayName: "icon__attachMoney",
    componentId: "sc-2ga6s0-39"
  })(["", ""], props => svgStyles(props)),
  calendarAddOn: styled(ForwardRef$26).withConfig({
    displayName: "icon__calendarAddOn",
    componentId: "sc-2ga6s0-40"
  })(["", ""], props => svgStyles(props)),
  calendarMonth: styled(ForwardRef$23).withConfig({
    displayName: "icon__calendarMonth",
    componentId: "sc-2ga6s0-41"
  })(["", ""], props => svgStyles(props)),
  folder: styled(ForwardRef$1y).withConfig({
    displayName: "icon__folder",
    componentId: "sc-2ga6s0-42"
  })(["", ""], props => svgStyles(props)),
  personOutline: styled(ForwardRef$T).withConfig({
    displayName: "icon__personOutline",
    componentId: "sc-2ga6s0-43"
  })(["", ""], props => svgStyles(props)),
  link: styled(ForwardRef$1d).withConfig({
    displayName: "icon__link",
    componentId: "sc-2ga6s0-44"
  })(["", ""], props => svgStyles(props)),
  list: styled(ForwardRef$1a).withConfig({
    displayName: "icon__list",
    componentId: "sc-2ga6s0-45"
  })(["", ""], props => svgStyles(props)),
  settings: styled(ForwardRef$E).withConfig({
    displayName: "icon__settings",
    componentId: "sc-2ga6s0-46"
  })(["", ""], props => svgStyles(props)),
  selectionPlus: styled(ForwardRef$F).withConfig({
    displayName: "icon__selectionPlus",
    componentId: "sc-2ga6s0-47"
  })(["", ""], props => svgStyles(props)),
  contentCopy: styled(ForwardRef$1V).withConfig({
    displayName: "icon__contentCopy",
    componentId: "sc-2ga6s0-48"
  })(["", ""], props => svgStyles(props)),
  umbrella: styled(ForwardRef$r).withConfig({
    displayName: "icon__umbrella",
    componentId: "sc-2ga6s0-49"
  })(["", ""], props => svgStyles(props)),
  eventRepeat: styled(ForwardRef$1J).withConfig({
    displayName: "icon__eventRepeat",
    componentId: "sc-2ga6s0-50"
  })(["", ""], props => svgStyles(props)),
  contentCut: styled(ForwardRef$1U).withConfig({
    displayName: "icon__contentCut",
    componentId: "sc-2ga6s0-51"
  })(["", ""], props => svgStyles(props)),
  calendarClock: styled(ForwardRef$25).withConfig({
    displayName: "icon__calendarClock",
    componentId: "sc-2ga6s0-52"
  })(["", ""], props => svgStyles(props)),
  dependent: styled(ForwardRef$1S).withConfig({
    displayName: "icon__dependent",
    componentId: "sc-2ga6s0-53"
  })(["", ""], props => svgStyles(props)),
  earthquake: styled(ForwardRef$1N).withConfig({
    displayName: "icon__earthquake",
    componentId: "sc-2ga6s0-54"
  })(["", ""], props => svgStyles(props)),
  flag: styled(ForwardRef$1A).withConfig({
    displayName: "icon__flag",
    componentId: "sc-2ga6s0-55"
  })(["", ""], props => svgStyles(props)),
  folderManaged: styled(ForwardRef$1z).withConfig({
    displayName: "icon__folderManaged",
    componentId: "sc-2ga6s0-56"
  })(["", ""], props => svgStyles(props)),
  groupAdd: styled(ForwardRef$1o).withConfig({
    displayName: "icon__groupAdd",
    componentId: "sc-2ga6s0-57"
  })(["", ""], props => svgStyles(props)),
  moreVert: styled(ForwardRef$14).withConfig({
    displayName: "icon__moreVert",
    componentId: "sc-2ga6s0-58"
  })(["", ""], props => svgStyles(props)),
  priceChange: styled(ForwardRef$R).withConfig({
    displayName: "icon__priceChange",
    componentId: "sc-2ga6s0-59"
  })(["", ""], props => svgStyles(props)),
  timesheets: styled(ForwardRef$u).withConfig({
    displayName: "icon__timesheets",
    componentId: "sc-2ga6s0-60"
  })(["", ""], props => svgStyles(props)),
  alarm: styled(ForwardRef$2l).withConfig({
    displayName: "icon__alarm",
    componentId: "sc-2ga6s0-61"
  })(["", ""], props => svgStyles(props)),
  moveGroup: styled(ForwardRef$12).withConfig({
    displayName: "icon__moveGroup",
    componentId: "sc-2ga6s0-62"
  })(["", ""], props => svgStyles(props)),
  textAd: styled(ForwardRef$v).withConfig({
    displayName: "icon__textAd",
    componentId: "sc-2ga6s0-63"
  })(["", ""], props => svgStyles(props)),
  fixedCost: styled(ForwardRef$1B).withConfig({
    displayName: "icon__fixedCost",
    componentId: "sc-2ga6s0-64"
  })(["", ""], props => svgStyles(props)),
  groupWork: styled(ForwardRef$1n).withConfig({
    displayName: "icon__groupWork",
    componentId: "sc-2ga6s0-65"
  })(["", ""], props => svgStyles(props)),
  format_size: styled(ForwardRef$1x).withConfig({
    displayName: "icon__format_size",
    componentId: "sc-2ga6s0-66"
  })(["", ""], props => svgStyles(props)),
  listAltAdd: styled(ForwardRef$1b).withConfig({
    displayName: "icon__listAltAdd",
    componentId: "sc-2ga6s0-67"
  })(["", ""], props => svgStyles(props)),
  calendarDots: styled(ForwardRef$24).withConfig({
    displayName: "icon__calendarDots",
    componentId: "sc-2ga6s0-68"
  })(["", ""], props => svgStyles(props)),
  resourceMgmt: styled(ForwardRef$K).withConfig({
    displayName: "icon__resourceMgmt",
    componentId: "sc-2ga6s0-69"
  })(["", ""], props => svgStyles(props)),
  forward: styled(ForwardRef$1w).withConfig({
    displayName: "icon__forward",
    componentId: "sc-2ga6s0-70"
  })(["", ""], props => svgStyles(props)),
  people: styled(ForwardRef$U).withConfig({
    displayName: "icon__people",
    componentId: "sc-2ga6s0-71"
  })(["", ""], props => svgStyles(props)),
  replyAll: styled(ForwardRef$L).withConfig({
    displayName: "icon__replyAll",
    componentId: "sc-2ga6s0-72"
  })(["", ""], props => svgStyles(props)),
  more: styled(ForwardRef$13).withConfig({
    displayName: "icon__more",
    componentId: "sc-2ga6s0-73"
  })(["", ""], props => svgStyles(props)),
  tune: styled(ForwardRef$s).withConfig({
    displayName: "icon__tune",
    componentId: "sc-2ga6s0-74"
  })(["", ""], props => svgStyles(props)),
  tableRowsNarrow: styled(ForwardRef$x).withConfig({
    displayName: "icon__tableRowsNarrow",
    componentId: "sc-2ga6s0-75"
  })(["", ""], props => svgStyles(props)),
  pageInfo: styled(ForwardRef$Y).withConfig({
    displayName: "icon__pageInfo",
    componentId: "sc-2ga6s0-76"
  })(["", ""], props => svgStyles(props)),
  equals: styled(ForwardRef$1L).withConfig({
    displayName: "icon__equals",
    componentId: "sc-2ga6s0-77"
  })(["", ""], props => svgStyles(props)),
  notEquals: styled(ForwardRef$Z).withConfig({
    displayName: "icon__notEquals",
    componentId: "sc-2ga6s0-78"
  })(["", ""], props => svgStyles(props)),
  bookmarks: styled(ForwardRef$29).withConfig({
    displayName: "icon__bookmarks",
    componentId: "sc-2ga6s0-79"
  })(["", ""], props => svgStyles(props)),
  greaterThanOrEqual: styled(ForwardRef$1q).withConfig({
    displayName: "icon__greaterThanOrEqual",
    componentId: "sc-2ga6s0-80"
  })(["", ""], props => svgStyles(props)),
  greaterThan: styled(ForwardRef$1p).withConfig({
    displayName: "icon__greaterThan",
    componentId: "sc-2ga6s0-81"
  })(["", ""], props => svgStyles(props)),
  lessThanOrEqual: styled(ForwardRef$1f).withConfig({
    displayName: "icon__lessThanOrEqual",
    componentId: "sc-2ga6s0-82"
  })(["", ""], props => svgStyles(props)),
  lessThan: styled(ForwardRef$1e).withConfig({
    displayName: "icon__lessThan",
    componentId: "sc-2ga6s0-83"
  })(["", ""], props => svgStyles(props)),
  filterList: styled(ForwardRef$1C).withConfig({
    displayName: "icon__filterList",
    componentId: "sc-2ga6s0-84"
  })(["", ""], props => svgStyles(props)),
  help: styled(ForwardRef$1m).withConfig({
    displayName: "icon__help",
    componentId: "sc-2ga6s0-85"
  })(["", ""], props => svgStyles(props)),
  dragIndicator: styled(ForwardRef$1P).withConfig({
    displayName: "icon__dragIndicator",
    componentId: "sc-2ga6s0-86"
  })(["", ""], props => svgStyles(props)),
  pin: styled(ForwardRef$S).withConfig({
    displayName: "icon__pin",
    componentId: "sc-2ga6s0-87"
  })(["", ""], props => svgStyles(props)),
  radio_button_checked: styled(ForwardRef$O).withConfig({
    displayName: "icon__radio_button_checked",
    componentId: "sc-2ga6s0-88"
  })(["", ""], props => svgStyles(props)),
  mail_outline: styled(ForwardRef$18).withConfig({
    displayName: "icon__mail_outline",
    componentId: "sc-2ga6s0-89"
  })(["", ""], props => svgStyles(props)),
  colors: styled(ForwardRef$1W).withConfig({
    displayName: "icon__colors",
    componentId: "sc-2ga6s0-90"
  })(["", ""], props => svgStyles(props)),
  check_box: styled(ForwardRef$1$).withConfig({
    displayName: "icon__check_box",
    componentId: "sc-2ga6s0-91"
  })(["", ""], props => svgStyles(props)),
  drop_down: styled(ForwardRef$1O).withConfig({
    displayName: "icon__drop_down",
    componentId: "sc-2ga6s0-92"
  })(["", ""], props => svgStyles(props)),
  archive: styled(ForwardRef$2k).withConfig({
    displayName: "icon__archive",
    componentId: "sc-2ga6s0-93"
  })(["", ""], props => svgStyles(props)),
  information2: styled(ForwardRef$1i).withConfig({
    displayName: "icon__information2",
    componentId: "sc-2ga6s0-94"
  })(["", ""], props => svgStyles(props)),
  avatar: styled(ForwardRef$2d).withConfig({
    displayName: "icon__avatar",
    componentId: "sc-2ga6s0-95"
  })(["", ""], props => svgStyles(props)),
  unfold: styled(ForwardRef$o).withConfig({
    displayName: "icon__unfold",
    componentId: "sc-2ga6s0-96"
  })(["", ""], props => svgStyles(props)),
  unassigned: styled(ForwardRef$q).withConfig({
    displayName: "icon__unassigned",
    componentId: "sc-2ga6s0-97"
  })(["", ""], props => svgStyles(props)),
  bookOpenText: styled(ForwardRef$2a).withConfig({
    displayName: "icon__bookOpenText",
    componentId: "sc-2ga6s0-98"
  })(["", ""], props => svgStyles(props)),
  feedback_thumb: styled(ForwardRef$1E).withConfig({
    displayName: "icon__feedback_thumb",
    componentId: "sc-2ga6s0-99"
  })(["", ""], props => svgStyles(props)),
  faders: styled(ForwardRef$1G).withConfig({
    displayName: "icon__faders",
    componentId: "sc-2ga6s0-100"
  })(["", ""], props => svgStyles(props)),
  badge: styled(ForwardRef$2b).withConfig({
    displayName: "icon__badge",
    componentId: "sc-2ga6s0-101"
  })(["", ""], props => svgStyles(props)),
  buildings: styled(ForwardRef$27).withConfig({
    displayName: "icon__buildings",
    componentId: "sc-2ga6s0-102"
  })(["", ""], props => svgStyles(props)),
  projectGroup: styled(ForwardRef$P).withConfig({
    displayName: "icon__projectGroup",
    componentId: "sc-2ga6s0-103"
  })(["", ""], props => svgStyles(props)),
  status: styled(ForwardRef$z).withConfig({
    displayName: "icon__status",
    componentId: "sc-2ga6s0-104"
  })(["", ""], props => svgStyles(props)),
  supervisorAccount: styled(ForwardRef$y).withConfig({
    displayName: "icon__supervisorAccount",
    componentId: "sc-2ga6s0-105"
  })(["", ""], props => svgStyles(props)),
  tag: styled(ForwardRef$w).withConfig({
    displayName: "icon__tag",
    componentId: "sc-2ga6s0-106"
  })(["", ""], props => svgStyles(props)),
  category: styled(ForwardRef$21).withConfig({
    displayName: "icon__category",
    componentId: "sc-2ga6s0-107"
  })(["", ""], props => svgStyles(props)),
  searchFace: styled(ForwardRef$H).withConfig({
    displayName: "icon__searchFace",
    componentId: "sc-2ga6s0-108"
  })(["", ""], props => svgStyles(props)),
  unhappy: styled(ForwardRef$n).withConfig({
    displayName: "icon__unhappy",
    componentId: "sc-2ga6s0-109"
  })(["", ""], props => svgStyles(props)),
  videocam: styled(ForwardRef$l).withConfig({
    displayName: "icon__videocam",
    componentId: "sc-2ga6s0-110"
  })(["", ""], props => svgStyles(props)),
  addCircle: styled(ForwardRef$2n).withConfig({
    displayName: "icon__addCircle",
    componentId: "sc-2ga6s0-111"
  })(["", ""], props => svgStyles(props)),
  google: styled(ForwardRef$1r).withConfig({
    displayName: "icon__google",
    componentId: "sc-2ga6s0-112"
  })(["", ""], props => svgStyles(props)),
  linkedin: styled(ForwardRef$1c).withConfig({
    displayName: "icon__linkedin",
    componentId: "sc-2ga6s0-113"
  })(["", ""], props => svgStyles(props)),
  sso: styled(ForwardRef$C).withConfig({
    displayName: "icon__sso",
    componentId: "sc-2ga6s0-114"
  })(["", ""], props => svgStyles(props)),
  lock: styled(ForwardRef$19).withConfig({
    displayName: "icon__lock",
    componentId: "sc-2ga6s0-115"
  })(["", ""], props => svgStyles(props)),
  hp_logo: styled(ForwardRef$1k).withConfig({
    displayName: "icon__hp_logo",
    componentId: "sc-2ga6s0-116"
  })(["", ""], props => svgStyles(props)),
  star: styled(ForwardRef$B).withConfig({
    displayName: "icon__star",
    componentId: "sc-2ga6s0-117"
  })(["", ""], props => svgStyles(props)),
  star_stroke: styled(ForwardRef$A).withConfig({
    displayName: "icon__star_stroke",
    componentId: "sc-2ga6s0-118"
  })(["", ""], props => svgStyles(props)),
  g2: styled(ForwardRef$1s).withConfig({
    displayName: "icon__g2",
    componentId: "sc-2ga6s0-119"
  })(["", ""], props => svgStyles(props)),
  unplug: styled(ForwardRef$m).withConfig({
    displayName: "icon__unplug",
    componentId: "sc-2ga6s0-120"
  })(["", ""], props => svgStyles(props)),
  do_not_disturb_on: styled(ForwardRef$1Q).withConfig({
    displayName: "icon__do_not_disturb_on",
    componentId: "sc-2ga6s0-121"
  })(["", ""], props => svgStyles(props)),
  file_copy: styled(ForwardRef$1D).withConfig({
    displayName: "icon__file_copy",
    componentId: "sc-2ga6s0-122"
  })(["", ""], props => svgStyles(props)),
  undo: styled(ForwardRef$p).withConfig({
    displayName: "icon__undo",
    componentId: "sc-2ga6s0-123"
  })(["", ""], props => svgStyles(props)),
  redo: styled(ForwardRef$N).withConfig({
    displayName: "icon__redo",
    componentId: "sc-2ga6s0-124"
  })(["", ""], props => svgStyles(props)),
  battery_vertical_full: styled(ForwardRef$j).withConfig({
    displayName: "icon__battery_vertical_full",
    componentId: "sc-2ga6s0-125"
  })(["", ""], props => svgStyles(props)),
  battery_vertical_low: styled(ForwardRef$i).withConfig({
    displayName: "icon__battery_vertical_low",
    componentId: "sc-2ga6s0-126"
  })(["", ""], props => svgStyles(props)),
  battery_warning_vertical: styled(ForwardRef$h).withConfig({
    displayName: "icon__battery_warning_vertical",
    componentId: "sc-2ga6s0-127"
  })(["", ""], props => svgStyles(props)),
  fullscreen: styled(ForwardRef$1u).withConfig({
    displayName: "icon__fullscreen",
    componentId: "sc-2ga6s0-128"
  })(["", ""], props => svgStyles(props)),
  fullscreen_exit: styled(ForwardRef$1t).withConfig({
    displayName: "icon__fullscreen_exit",
    componentId: "sc-2ga6s0-129"
  })(["", ""], props => svgStyles(props)),
  user_switch: styled(ForwardRef$g).withConfig({
    displayName: "icon__user_switch",
    componentId: "sc-2ga6s0-130"
  })(["", ""], props => svgStyles(props)),
  full_availability_white: styled(ForwardRef$e).withConfig({
    displayName: "icon__full_availability_white",
    componentId: "sc-2ga6s0-131"
  })(["", ""], props => svgStyles(props)),
  full_availability: styled(ForwardRef$f).withConfig({
    displayName: "icon__full_availability",
    componentId: "sc-2ga6s0-132"
  })(["", ""], props => svgStyles(props)),
  half_availability: styled(ForwardRef$d).withConfig({
    displayName: "icon__half_availability",
    componentId: "sc-2ga6s0-133"
  })(["", ""], props => svgStyles(props)),
  half_availability_white: styled(ForwardRef$c).withConfig({
    displayName: "icon__half_availability_white",
    componentId: "sc-2ga6s0-134"
  })(["", ""], props => svgStyles(props)),
  no_availability: styled(ForwardRef$9).withConfig({
    displayName: "icon__no_availability",
    componentId: "sc-2ga6s0-135"
  })(["", ""], props => svgStyles(props)),
  no_availability_white: styled(ForwardRef$8).withConfig({
    displayName: "icon__no_availability_white",
    componentId: "sc-2ga6s0-136"
  })(["", ""], props => svgStyles(props)),
  negative_availability: styled(ForwardRef$b).withConfig({
    displayName: "icon__negative_availability",
    componentId: "sc-2ga6s0-137"
  })(["", ""], props => svgStyles(props)),
  negative_availability_white: styled(ForwardRef$a).withConfig({
    displayName: "icon__negative_availability_white",
    componentId: "sc-2ga6s0-138"
  })(["", ""], props => svgStyles(props)),
  missing_extension: styled(ForwardRef$16).withConfig({
    displayName: "icon__missing_extension",
    componentId: "sc-2ga6s0-139"
  })(["", ""], props => svgStyles(props)),
  registration: styled(ForwardRef$M).withConfig({
    displayName: "icon__registration",
    componentId: "sc-2ga6s0-140"
  })(["", ""], props => svgStyles(props)),
  language: styled(ForwardRef$1h).withConfig({
    displayName: "icon__language",
    componentId: "sc-2ga6s0-141"
  })(["", ""], props => svgStyles(props)),
  rocket_graph: styled(ForwardRef$7).withConfig({
    displayName: "icon__rocket_graph",
    componentId: "sc-2ga6s0-142"
  })(["", ""], props => svgStyles(props)),
  users_mid: styled(ForwardRef$6).withConfig({
    displayName: "icon__users_mid",
    componentId: "sc-2ga6s0-143"
  })(["", ""], props => svgStyles(props)),
  users_three: styled(ForwardRef$5).withConfig({
    displayName: "icon__users_three",
    componentId: "sc-2ga6s0-144"
  })(["", ""], props => svgStyles(props)),
  code: styled(ForwardRef$4).withConfig({
    displayName: "icon__code",
    componentId: "sc-2ga6s0-145"
  })(["", ""], props => svgStyles(props)),
  puzzle_piece: styled(ForwardRef$2).withConfig({
    displayName: "icon__puzzle_piece",
    componentId: "sc-2ga6s0-146"
  })(["", ""], props => svgStyles(props)),
  terminal: styled(ForwardRef$1).withConfig({
    displayName: "icon__terminal",
    componentId: "sc-2ga6s0-147"
  })(["", ""], props => svgStyles(props)),
  pen_nib: styled(ForwardRef$3).withConfig({
    displayName: "icon__pen_nib",
    componentId: "sc-2ga6s0-148"
  })(["", ""], props => svgStyles(props)),
  mystery: styled(ForwardRef$10).withConfig({
    displayName: "icon__mystery",
    componentId: "sc-2ga6s0-149"
  })(["", ""], props => svgStyles(props)),
  wrench: styled(ForwardRef$k).withConfig({
    displayName: "icon__wrench",
    componentId: "sc-2ga6s0-150"
  })(["", ""], props => svgStyles(props)),
  broom: styled(ForwardRef$28).withConfig({
    displayName: "icon__broom",
    componentId: "sc-2ga6s0-151"
  })(["", ""], props => svgStyles(props))
};
const iconNamesArray = Object.keys(icons).sort();
const isIcon = value => {
  if (!value) {
    return false;
  }
  if (typeof value !== 'string') {
    return false;
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return Boolean(icons[value]);
};
function Icon(props) {
  const {
    name,
    color,
    size = 24,
    className,
    noFill,
    onClick
  } = props;
  const Icon = icons[name];
  if (!Icon) {
    return null;
  }
  return jsx(Icon, {
    onClick: onClick,
    name: name,
    className: className,
    size: size,
    color: color ? getColor(color) : undefined,
    noFill: noFill
  });
}
function classNames() {
  for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classes[_key2] = arguments[_key2];
  }
  return classes.filter(Boolean).join(' ');
}
const typographyVariantStyles = {
  'display-xl': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.display.xl.value.fontWeight, props => props.theme.designTokens.font.display.xl.value.fontSize, props => props.theme.designTokens.font.display.xl.value.lineHeight, props => props.theme.designTokens.font.display.xl.value.letterSpacing),
  'display-large': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.display.large.value.fontWeight, props => props.theme.designTokens.font.display.large.value.fontSize, props => props.theme.designTokens.font.display.large.value.lineHeight, props => props.theme.designTokens.font.display.large.value.letterSpacing),
  'display-medium': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.display.medium.value.fontWeight, props => props.theme.designTokens.font.display.medium.value.fontSize, props => props.theme.designTokens.font.display.medium.value.lineHeight, props => props.theme.designTokens.font.display.medium.value.letterSpacing),
  'display-small': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;&.prominent{font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;}"], props => props.theme.designTokens.font.display.small.value.fontWeight, props => props.theme.designTokens.font.display.small.value.fontSize, props => props.theme.designTokens.font.display.small.value.lineHeight, props => props.theme.designTokens.font.display.small.value.letterSpacing, props => props.theme.designTokens.font.display['small - prominent'].value.fontWeight, props => props.theme.designTokens.font.display['small - prominent'].value.fontSize, props => props.theme.designTokens.font.display['small - prominent'].value.lineHeight, props => props.theme.designTokens.font.display['small - prominent'].value.letterSpacing),
  'headline-xl': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.headline.xl.value.fontWeight, props => props.theme.designTokens.font.headline.xl.value.fontSize, props => props.theme.designTokens.font.headline.xl.value.lineHeight, props => props.theme.designTokens.font.headline.xl.value.letterSpacing),
  'headline-large': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.headline.large.value.fontWeight, props => props.theme.designTokens.font.headline.large.value.fontSize, props => props.theme.designTokens.font.headline.large.value.lineHeight, props => props.theme.designTokens.font.headline.large.value.letterSpacing),
  'headline-medium': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.headline.medium.value.fontWeight, props => props.theme.designTokens.font.headline.medium.value.fontSize, props => props.theme.designTokens.font.headline.medium.value.lineHeight, props => props.theme.designTokens.font.headline.medium.value.letterSpacing),
  'headline-small': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.headline.small.value.fontWeight, props => props.theme.designTokens.font.headline.small.value.fontSize, props => props.theme.designTokens.font.headline.small.value.lineHeight, props => props.theme.designTokens.font.headline.small.value.letterSpacing),
  'title-xl': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.title.xl.value.fontWeight, props => props.theme.designTokens.font.title.xl.value.fontSize, props => props.theme.designTokens.font.title.xl.value.lineHeight, props => props.theme.designTokens.font.title.xl.value.letterSpacing),
  'title-large': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.title.large.value.fontWeight, props => props.theme.designTokens.font.title.large.value.fontSize, props => props.theme.designTokens.font.title.large.value.lineHeight, props => props.theme.designTokens.font.title.large.value.letterSpacing),
  'title-medium': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.title.medium.value.fontWeight, props => props.theme.designTokens.font.title.medium.value.fontSize, props => props.theme.designTokens.font.title.medium.value.lineHeight, props => props.theme.designTokens.font.title.medium.value.letterSpacing),
  'title-small': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.title.small.value.fontWeight, props => props.theme.designTokens.font.title.small.value.fontSize, props => props.theme.designTokens.font.title.small.value.lineHeight, props => props.theme.designTokens.font.title.small.value.letterSpacing),
  'label-xl': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;&.prominent{font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;}"], props => props.theme.designTokens.font.label['label extra large'].value.fontWeight, props => props.theme.designTokens.font.label['label extra large'].value.fontSize, props => props.theme.designTokens.font.label['label extra large'].value.lineHeight, props => props.theme.designTokens.font.label['label extra large'].value.letterSpacing, props => props.theme.designTokens.font.label['label extra large - prominent'].value.fontWeight, props => props.theme.designTokens.font.label['label extra large - prominent'].value.fontSize, props => props.theme.designTokens.font.label['label extra large - prominent'].value.lineHeight, props => props.theme.designTokens.font.label['label extra large - prominent'].value.letterSpacing),
  'label-large': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;&.prominent{font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;}"], props => props.theme.designTokens.font.label.large.value.fontWeight, props => props.theme.designTokens.font.label.large.value.fontSize, props => props.theme.designTokens.font.label.large.value.lineHeight, props => props.theme.designTokens.font.label.large.value.letterSpacing, props => props.theme.designTokens.font.label['large - prominent'].value.fontWeight, props => props.theme.designTokens.font.label['large - prominent'].value.fontSize, props => props.theme.designTokens.font.label['large - prominent'].value.lineHeight, props => props.theme.designTokens.font.label['large - prominent'].value.letterSpacing),
  'label-medium': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;&.prominent{font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;}"], props => props.theme.designTokens.font.label.medium.value.fontWeight, props => props.theme.designTokens.font.label.medium.value.fontSize, props => props.theme.designTokens.font.label.medium.value.lineHeight, props => props.theme.designTokens.font.label.medium.value.letterSpacing, props => props.theme.designTokens.font.label['medium - prominent'].value.fontWeight, props => props.theme.designTokens.font.label['medium - prominent'].value.fontSize, props => props.theme.designTokens.font.label['medium - prominent'].value.lineHeight, props => props.theme.designTokens.font.label['medium - prominent'].value.letterSpacing),
  'label-small': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.label.small.value.fontWeight, props => props.theme.designTokens.font.label.small.value.fontSize, props => props.theme.designTokens.font.label.small.value.lineHeight, props => props.theme.designTokens.font.label.small.value.letterSpacing),
  'body-xl': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.body.xl.value.fontWeight, props => props.theme.designTokens.font.body.xl.value.fontSize, props => props.theme.designTokens.font.body.xl.value.lineHeight, props => props.theme.designTokens.font.body.xl.value.letterSpacing),
  'body-large': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.body.large.value.fontWeight, props => props.theme.designTokens.font.body.large.value.fontSize, props => props.theme.designTokens.font.body.large.value.lineHeight, props => props.theme.designTokens.font.body.large.value.letterSpacing),
  'body-medium': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.body.medium.value.fontWeight, props => props.theme.designTokens.font.body.medium.value.fontSize, props => props.theme.designTokens.font.body.medium.value.lineHeight, props => props.theme.designTokens.font.body.medium.value.letterSpacing),
  'body-small': css(["font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;"], props => props.theme.designTokens.font.body.small.value.fontWeight, props => props.theme.designTokens.font.body.small.value.fontSize, props => props.theme.designTokens.font.body.small.value.lineHeight, props => props.theme.designTokens.font.body.small.value.letterSpacing)
};
const StyledTypography$1 = /*#__PURE__*/styled(Typography$1).withConfig({
  displayName: "typography__StyledTypography",
  componentId: "sc-1pe6d6l-0"
})(["&.MuiTypography-root{font-family:Poppins,'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-style:normal;color:var(--font-color,", ");text-align:var(--text-align,'inherit');white-space:var(--white-space,'pre-line');font-weight:var(--font-weight,400);", "}"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value, () => {
  return Object.keys(typographyVariantStyles).map(variantKey => {
    return css(["&.", "{", " font-weight:var(--font-weight,400);}"], variantKey, typographyVariantStyles[variantKey]);
  });
});
function Typography(props) {
  const {
    children,
    variant = 'body',
    size = 'medium',
    className,
    color,
    prominent = false,
    align,
    tagName = 'p',
    noWrap,
    dataCy,
    title,
    weight
  } = props;
  const styles = useMemo(() => {
    if (!color && !align && noWrap === undefined && !weight) {
      return undefined;
    }
    const styles = {
      '--text-align': align,
      '--font-color': getColor(color),
      '--white-space': noWrap ? 'nowrap' : 'pre-line',
      '--font-weight': weight
    };
    return styles;
  }, [color, align, noWrap, weight]);
  return jsx(StyledTypography$1, {
    title: title,
    "data-cy": dataCy,
    component: tagName,
    noWrap: noWrap,
    className: classNames(getTypographyClass(variant, size), prominent ? 'prominent' : undefined, className),
    style: styles,
    children: children
  });
}
function getTypographyClass() {
  let variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'body';
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'medium';
  return "".concat(variant, "-").concat(size);
}
const StyledAccordion = /*#__PURE__*/styled(MuiAccordion).withConfig({
  displayName: "accordion__StyledAccordion",
  componentId: "tg3esi-0"
})(["&.MuiAccordion-root{background-color:transparent;border-bottom:1px solid rgba(189,202,192,0.4);&:before{display:none;background-color:", ";}&.Mui-expanded{margin:0;border-bottom:1px solid rgba(189,202,192,0.4);}&:last-child{border:0;}.MuiAccordionSummary-expandIcon{padding:0;}}"], props => props.theme.designTokens.color.color.light['outline-variant'].value);
const StyledAccordionSummary = /*#__PURE__*/styled(MuiAccordionSummary).withConfig({
  displayName: "accordion__StyledAccordionSummary",
  componentId: "tg3esi-1"
})(["&.MuiAccordionSummary-root{min-height:44px;padding-top:2px;padding-bottom:2px;&.Mui-expanded{min-height:44px;padding-top:2px;padding-bottom:2px;}.MuiAccordionSummary-content{margin:0;width:100%;&.Mui-expanded{margin:0;}}}"]);
const AccordionContext = /*#__PURE__*/createContext({
  openItem: null,
  toggle: () => {
    // do nothing
  }
});
const AccordionContextProvider = props => {
  const {
    children,
    onOpen: onOpenProp,
    openItem: openItemProp
  } = props;
  const [openItem, setOpenItem] = useState(null);
  useEffect(() => {
    if (openItemProp !== undefined) {
      setOpenItem(openItemProp);
    }
  }, [openItemProp]);
  const toggle = useCallback(id => {
    setOpenItem(prev => {
      let newOpenItemId;
      if (prev === id) {
        newOpenItemId = null;
      } else {
        newOpenItemId = id;
      }
      onOpenProp === null || onOpenProp === void 0 ? void 0 : onOpenProp(newOpenItemId);
      return newOpenItemId;
    });
  }, [onOpenProp]);
  return jsx(AccordionContext.Provider, {
    value: {
      openItem,
      toggle
    },
    children: children
  });
};
const useAccordionContext = () => useContext(AccordionContext);
const AccordionItem = props => {
  const {
    id,
    header,
    content,
    dataCy,
    isOpen,
    scrollTop
  } = props;
  const {
    toggle,
    openItem
  } = useAccordionContext();
  const [isInView, setIsInView] = useState(false);
  const accordionRef = useRef(null);
  const headerRef = useRef(null);
  useEffect(() => {
    if (!scrollTop) {
      return;
    }
    const observer = new IntersectionObserver(_ref8 => {
      let [entry] = _ref8;
      setIsInView(entry.isIntersecting);
    }, {
      root: null,
      threshold: 0.5
    });
    const header = headerRef.current;
    if (header) {
      observer.observe(header);
    }
    return () => {
      if (header) {
        observer.unobserve(header);
      }
    };
  }, [scrollTop]);
  const transitionProps = useMemo(() => {
    return {
      onEntered: scrollTop ? () => {
        var _a;
        if (id === openItem && !isInView && accordionRef.current) {
          (_a = accordionRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      } : undefined
    };
  }, [id, isInView, openItem, scrollTop]);
  const handleOnChange = useCallback(() => {
    toggle(id);
  }, [id, toggle]);
  return jsxs(StyledAccordion, {
    elevation: 0,
    expanded: openItem === id,
    onChange: handleOnChange,
    ref: accordionRef,
    TransitionProps: transitionProps,
    children: [jsx(StyledAccordionSummary, {
      expandIcon: jsx(Icon, {
        name: "chevronDown"
      }),
      "data-cy": dataCy,
      ref: headerRef,
      children: typeof header === 'string' ? jsx(Typography, {
        variant: "body",
        size: "medium",
        noWrap: true,
        children: header
      }) : header
    }), jsx(MuiAccordionDetails, {
      children: jsx(React__default.Fragment, {
        children: content
      }, isOpen ? "".concat(id, "-open") : id)
    })]
  });
};
function Accordion(props) {
  const {
    items,
    onOpen,
    openItem,
    className,
    scrollTop
  } = props;
  const visibleItems = useMemo(() => {
    return items.filter(item => !item.hidden);
  }, [items]);
  return jsx(AccordionContextProvider, {
    onOpen: onOpen,
    openItem: openItem,
    children: jsx("div", {
      className: className,
      children: visibleItems.map(item => {
        return jsx(AccordionItem, {
          scrollTop: scrollTop,
          isOpen: openItem === item.id,
          id: item.id,
          header: item.header,
          content: item.content,
          dataCy: item.dataCy
        }, item.id);
      })
    })
  });
}
const useAccordionState = () => {
  const [expandedItem, setExpandedItem] = useState(null);
  const expand = useCallback(id => {
    if (!id) {
      setExpandedItem(null);
    }
    setExpandedItem(id);
  }, []);
  const collapse = useCallback(() => {
    setExpandedItem(null);
  }, []);
  return {
    expandedItem,
    expand,
    collapse
  };
};
const colors = {
  error: {
    background: designTokens.color.color.signal.error.value,
    color: designTokens.color['on color']['signal']['on-error'].value
  },
  info: {
    background: designTokens.color.color.signal.info,
    color: designTokens.color['on color']['surface']['on-tertiary-container'].value
  },
  success: {
    background: designTokens.color.color.signal.success.value,
    color: designTokens.color['on color']['surface']['on-primary-container'].value
  }
};
const StyledAlert = /*#__PURE__*/styled.div.withConfig({
  displayName: "alert__StyledAlert",
  componentId: "sc-1cl6gjb-0"
})(["padding-top:", "px;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;background-color:", ";border-radius:8px;font-family:Poppins,'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;", ";color:", ";& *{color:", ";}a{text-decoration:underline;font-weight:bold;color:", ";}"], props => props.theme.designSpacing['--Spacing-150'], props => props.theme.designSpacing['--Spacing-150'], props => props.theme.designSpacing['--Spacing-150'], props => props.theme.designSpacing['--Spacing-150'], props => colors[props.variant].background, () => typographyVariantStyles['body-medium'], props => colors[props.variant].color, props => colors[props.variant].color, props => colors[props.variant].color);
function Alert(props) {
  const {
    children,
    variant = 'success',
    className
  } = props;
  return jsx(StyledAlert, {
    className: className,
    variant: variant,
    children: children
  });
}

// TODO: read from process env
const AWS_S3_URL = 'https://d329beqc2zk6g7.cloudfront.net';
const AVATAR_PLACEHOLDER = '/img/placeholder_hub.jpg';
const AVATAR_PLACEHOLDER_2 = '/img/placeholder.png';
const getIconSource = function () {
  let urlString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!urlString) {
    return undefined;
  }
  if (urlString.indexOf('http') === 0) {
    return urlString;
  } else if (urlString.indexOf('/uploads') === 0) {
    return "".concat(AWS_S3_URL).concat(urlString);
  }
  return "".concat(AWS_S3_URL, "/img/placeholder_hub.jpg");
};
const isAvatarPlaceholder = urlString => {
  if (!urlString) {
    return false;
  }
  return urlString === AVATAR_PLACEHOLDER || urlString === AVATAR_PLACEHOLDER_2;
};
const StyledAvatar = /*#__PURE__*/styled(MuiAvatar).withConfig({
  displayName: "avatar__StyledAvatar",
  componentId: "sc-1wqm1df-0"
})(["&.MuiAvatar-root{width:", "px;height:", "px;}&.MuiAvatar-colorDefault{background-color:", ";}"], _ref9 => {
  let {
    size
  } = _ref9;
  return size;
}, _ref10 => {
  let {
    size
  } = _ref10;
  return size;
}, props => props.theme.designTokens.color.color.surfaces['primary-container'].value);
function Avatar(props) {
  const {
    alt,
    src,
    firstName = '',
    lastName = '',
    className,
    size = 40
  } = props;
  const text = useMemo(() => {
    return "".concat(getFirstLetterUpperCase(firstName)).concat(getFirstLetterUpperCase(lastName));
  }, [firstName, lastName]);
  const srcToUse = useMemo(() => {
    return getIconSource(src);
  }, [src]);
  return jsx(StyledAvatar, {
    alt: alt,
    src: srcToUse,
    className: className,
    size: size,
    children: text
  });
}
const overlayBaseStyles$2 = /*#__PURE__*/css(["border-radius:100px;height:100%;width:100%;position:absolute;top:0;left:0;content:'';"]);
const buttonVariantStyles = {
  destructive: css(["&.destructive{color:", ";background-color:", ";border:1px solid ", ";path{fill:", " !important;}&:hover{box-shadow:", ";}&:focus{background-color:#a61113;border:1px solid #a61113;color:", ";}&:active{background-color:#7e0007;border:1px solid #7e0007;color:", ";}&.Mui-disabled{color:", ";background-color:#ffb4ab;border:1px solid #ffb4ab;path{fill:", " !important;}.MuiButton-label{opacity:0.38;}}}"], props => props.theme.designTokens.color['on color'].signal['on-error'].value, props => props.theme.designTokens.color.color.surfaces['error-container'].value, props => props.theme.designTokens.color.color.surfaces['error-container'].value, props => props.theme.designTokens.color['on color'].signal['on-error'].value, props => props.theme.shadows[1], props => props.theme.designTokens.color['on color'].surface['on-error-container'].value, props => props.theme.designTokens.color['on color'].surface['on-error-container'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value),
  filled: css(["&.filled{color:", ";background-color:", ";border:1px solid ", ";path{fill:", " !important;}&:hover{background-color:#147856;box-shadow:", ";}&:focus{background-color:#1f7e5d;}&:active{background-color:#147856;}&.Mui-disabled{color:", ";background-color:", ";border:1px solid ", ";path{fill:", " !important;}.MuiButton-label{opacity:0.38;}}}"], props => props.theme.designTokens.color['on color'].primary['on-primary'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color['on color'].primary['on-primary'].value, props => props.theme.shadows[1], props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value),
  outlined: css(["&.outlined{color:", ";border:1px solid ", ";path{fill:", " !important;}&:hover{background-color:", ";}&:focus{border:1px solid ", ";background-color:", ";}&:active{background-color:", ";}&.Mui-disabled{color:", ";border:1px solid ", ";path{fill:", " !important;}.MuiButton-label{opacity:0.38;}}}"], props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.light.outline.value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.08'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value),
  text: css(["&.text{padding:10px 12px;color:", ";path{fill:", " !important;}&:hover{background-color:", ";}&:focus{background-color:", ";}&:active{background-color:", ";}&.Mui-disabled{color:", ";path{fill:", " !important;}.MuiButton-label{opacity:0.38;}}}"], props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value),
  elevated: css(["&.elevated{color:", ";background-color:", ";box-shadow:", ";path{fill:", " !important;}&:hover{background-color:", ";box-shadow:", ";&:after{", ";background-color:", ";}}&:focus{background-color:", ";box-shadow:", ";&:after{", ";background-color:", ";}}&:active{background-color:", ";box-shadow:", ";&:after{", ";background-color:", ";}}&.Mui-disabled{color:", ";background-color:", ";box-shadow:none;path{fill:", " !important;}.MuiButton-label{opacity:0.38;}}}"], props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.surfaces['surface-container-low'].value, props => props.theme.shadows[1], props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.surfaces['surface-container-low'].value, props => props.theme.shadows[2], overlayBaseStyles$2, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.08'].value, props => props.theme.designTokens.color.color.surfaces['surface-container-low'].value, props => props.theme.shadows[1], overlayBaseStyles$2, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color.color.surfaces['surface-container-low'].value, props => props.theme.shadows[1], overlayBaseStyles$2, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value),
  tonal: css(["&.tonal{color:", ";background-color:", ";path{fill:", " !important;}&:hover{&:after{", ";background-color:", ";box-shadow:", ";}}&:focus{&:after{", ";background-color:", ";}}&:active{&:after{", ";background-color:", ";}}&.Mui-disabled{color:", ";background-color:", ";path{fill:", " !important;}.MuiButton-label{opacity:0.38;}}}"], props => props.theme.designTokens.color['on color'].surface['on-secondary-container'].value, props => props.theme.designTokens.color.color.surfaces['secondary-container'].value, props => props.theme.designTokens.color['on color'].surface['on-secondary-container'].value, overlayBaseStyles$2, props => props.theme.designTokens.color.color['state-layers'].light['on-secondary-container']['opacity-0.08'].value, props => props.theme.shadows[1], overlayBaseStyles$2, props => props.theme.designTokens.color.color['state-layers'].light['on-secondary-container']['opacity-0.12'].value, overlayBaseStyles$2, props => props.theme.designTokens.color.color['state-layers'].light['on-secondary-container']['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value)
};
const StyledButton$1 = /*#__PURE__*/styled(BaseButton).withConfig({
  displayName: "button__StyledButton",
  componentId: "sc-1t5ylkg-0"
})(["&.MuiButton-root{text-transform:none;height:40px;padding:", ";svg{height:18px;width:18px;}.text-label{flex:1;}border-radius:100px;.MuiButton-label{display:inline-flex;flex-direction:row;justify-content:center;align-items:center;gap:8px;flex-shrink:0;", "}", "}"], props => props.hasIcon ? '10px 16px' : '10px 24px', () => typographyVariantStyles['label-large'], () => {
  return Object.keys(buttonVariantStyles).map(variantKey => {
    return buttonVariantStyles[variantKey];
  });
});
const Button = /*#__PURE__*/forwardRef((_ref11, ref) => {
  let {
    onClick,
    children,
    dataCy,
    variant: _variant = 'filled',
    disabled: _disabled = false,
    className,
    startIcon,
    endIcon,
    type,
    fullWidth,
    href,
    target
  } = _ref11;
  return jsxs(StyledButton$1, {
    className: classNames(_variant, className),
    "data-cy": dataCy,
    disabled: _disabled,
    disableElevation: true,
    hasIcon: Boolean(startIcon) || Boolean(endIcon),
    hasEndIcon: Boolean(endIcon),
    hasStartIcon: Boolean(startIcon),
    onClick: onClick,
    type: type,
    fullWidth: fullWidth,
    href: href,
    // for some reason mui doesn't export this prop
    // but it works
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    target: target,
    ref: ref,
    children: [startIcon ? jsx(Icon, {
      name: startIcon
    }) : null, children, endIcon ? jsx(Icon, {
      name: endIcon
    }) : null]
  });
});
var aCallable$c = aCallable$i;
var toObject$3 = toObject$7;
var IndexedObject$1 = indexedObject;
var lengthOfArrayLike$3 = lengthOfArrayLike$6;
var $TypeError$9 = TypeError;
var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject$3(that);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$3(O);
    aCallable$c(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError$9(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$9(REDUCE_EMPTY);
      }
    }
    for (; IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};
var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};
var global$d = global$p;
var classof$5 = classofRaw$2;
var engineIsNode = classof$5(global$d.process) === 'process';
var $$m = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$2;
var CHROME_VERSION = engineV8Version;
var IS_NODE$4 = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE$4 && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$3 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$m({
  target: 'Array',
  proto: true,
  forced: FORCED$3
}, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});
var DESCRIPTORS$3 = descriptors;
var uncurryThis$c = functionUncurryThis;
var call$c = functionCall;
var fails$c = fails$q;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$7;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;
var concat$1 = uncurryThis$c([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$c(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({
    b: 1
  }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), {
    b: 2
  })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) {
    B[chr] = chr;
  });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || call$c(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  }
  return T;
} : $assign;
var $$l = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$l({
  target: 'Object',
  stat: true,
  arity: 2,
  forced: Object.assign !== assign
}, {
  assign: assign
});
var classofRaw = classofRaw$2;
var uncurryThis$b = functionUncurryThis;
var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$b(fn);
};
var uncurryThis$a = functionUncurryThisClause;
var aCallable$b = aCallable$i;
var NATIVE_BIND$1 = functionBindNative;
var bind$7 = uncurryThis$a(uncurryThis$a.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$b(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$7(fn, that) : function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};
var wellKnownSymbol$a = wellKnownSymbol$l;
var Iterators$1 = iterators;
var ITERATOR$4 = wellKnownSymbol$a('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$4] === it);
};
var classof$4 = classof$7;
var getMethod$1 = getMethod$5;
var isNullOrUndefined$2 = isNullOrUndefined$5;
var Iterators = iterators;
var wellKnownSymbol$9 = wellKnownSymbol$l;
var ITERATOR$3 = wellKnownSymbol$9('iterator');
var getIteratorMethod$3 = function (it) {
  if (!isNullOrUndefined$2(it)) return getMethod$1(it, ITERATOR$3) || getMethod$1(it, '@@iterator') || Iterators[classof$4(it)];
};
var call$b = functionCall;
var aCallable$a = aCallable$i;
var anObject$d = anObject$n;
var tryToString$2 = tryToString$5;
var getIteratorMethod$2 = getIteratorMethod$3;
var $TypeError$8 = TypeError;
var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$2(argument) : usingIterator;
  if (aCallable$a(iteratorMethod)) return anObject$d(call$b(iteratorMethod, argument));
  throw new $TypeError$8(tryToString$2(argument) + ' is not iterable');
};
var bind$6 = functionBindContext;
var call$a = functionCall;
var anObject$c = anObject$n;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$6;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod$1 = getIteratorMethod$3;
var iteratorClose$1 = iteratorClose$4;
var $TypeError$7 = TypeError;
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};
var ResultPrototype = Result.prototype;
var iterate$7 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$6(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;
  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result(true, condition);
  };
  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$c(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }
    return INTERRUPTED ? fn(value, stop) : fn(value);
  };
  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw new $TypeError$7(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$2(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      }
      return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }
  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$a(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  }
  return new Result(false);
};
var $$k = _export;
var iterate$6 = iterate$7;
var aCallable$9 = aCallable$i;
var anObject$b = anObject$n;
var getIteratorDirect$6 = getIteratorDirect$9;
var $TypeError$6 = TypeError;

// `Iterator.prototype.reduce` method
// https://github.com/tc39/proposal-iterator-helpers
$$k({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  reduce: function reduce(reducer /* , initialValue */) {
    anObject$b(this);
    aCallable$9(reducer);
    var record = getIteratorDirect$6(this);
    var noInitial = arguments.length < 2;
    var accumulator = noInitial ? undefined : arguments[1];
    var counter = 0;
    iterate$6(record, function (value) {
      if (noInitial) {
        noInitial = false;
        accumulator = value;
      } else {
        accumulator = reducer(accumulator, value, counter);
      }
      counter++;
    }, {
      IS_RECORD: true
    });
    if (noInitial) throw new $TypeError$6('Reduce of empty iterator with no initial value');
    return accumulator;
  }
});
let _ = t => t,
  _t$1;
const primaryColor = '#32A675';
const designSpacing = {
  '--Spacing-00': 0,
  '--Spacing-50': 4,
  '--Spacing-100': 8,
  '--Spacing-150': 12,
  '--Spacing-200': 16,
  '--Spacing-300': 24,
  '--Spacing-400': 32
};
const shadowValueToCssPart = value => {
  return "".concat(value.offsetX, "px ").concat(value.offsetY, "px ").concat(value.radius, "px  ").concat(value.spread, "px ").concat(value.color);
};
const shadowTokenToCss = index => {
  const shadow = designTokens.effect[index];
  const firstPart = shadowValueToCssPart(shadow[4].value);
  const secondPart = shadowValueToCssPart(shadow[3].value);
  const thirdPart = shadowValueToCssPart(shadow[2].value);
  const fourthPart = shadowValueToCssPart(shadow[1].value);
  const fifthPart = shadowValueToCssPart(shadow[0].value);
  return "".concat(firstPart, ", ").concat(secondPart, ", ").concat(thirdPart, ", ").concat(fourthPart, ", ").concat(fifthPart);
};
const hubTheme = createTheme({
  designTokens,
  designSpacing,
  shadows: ["none", shadowTokenToCss('1'), shadowTokenToCss('2'), shadowTokenToCss('3'), shadowTokenToCss('4'), shadowTokenToCss('5'),
  // for all other set to 1 so won't break existing/old/legacy components
  // to be not used with new components
  shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1'), shadowTokenToCss('1')],
  typography: {
    fontFamily: "'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    h6: {
      fontSize: '1.4rem',
      '&.MuiTypography-gutterBottom': {
        marginBottom: '16px'
      }
    },
    body2: {
      fontSize: '0.9rem'
    },
    subtitle2: {
      fontSize: '1.2rem',
      fontWeight: 500
    }
  },
  palette: {
    primary: {
      main: primaryColor
    },
    white: '#ffffff',
    grey: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      halfLight: '#F3F4F7',
      light: '#E6E7ED',
      mid: '#C8C9D2',
      hintText: '#ADAEBB',
      dark: '#4E5252',
      primary: '#4E5252'
    },
    text: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      inverted: '#fff'
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
      disableTouchRipple: true
    },
    MuiChip: {
      // for some reason those props are not exported from mui but it works
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      disableRipple: true,
      disableTouchRipple: true,
      disableFocusRipple: true
    },
    MuiCheckbox: {
      disableRipple: true,
      disableTouchRipple: true,
      disableFocusRipple: true
    },
    MuiIconButton: {
      disableRipple: true,
      disableTouchRipple: true,
      disableFocusRipple: true
    },
    MuiMenuItem: {
      // for some reason those props are not exported from mui but it works
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      disableRipple: true,
      disableTouchRipple: true,
      disableFocusRipple: true
    },
    MuiRadio: {
      disableRipple: true,
      disableTouchRipple: true,
      disableFocusRipple: true
    },
    MuiSwitch: {
      disableRipple: true,
      disableTouchRipple: true,
      disableFocusRipple: true
    }
  },
  overrides: {
    MuiFormControlLabel: {
      root: {
        '&$focused': {
          color: '#000'
        }
      }
    },
    MuiTypography: {
      subtitle2: {
        fontSize: '1rem',
        fontWeight: 'bolder'
      }
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: '#000'
        }
      }
    },
    MuiInputLabel: {
      root: {
        '&$focused': {
          color: '#000'
        },
        lineHeight: 0
      }
    },
    MuiOutlinedInput: {
      root: {
        '&:hover $notchedOutline': {
          borderColor: primaryColor
        },
        '&$focused $notchedOutline': {
          borderWidth: '1px'
        },
        '& input': {
          background: 'transparent !important'
        },
        height: '37px',
        fontSize: '13px'
      },
      multiline: {
        height: 'initial'
      }
    },
    MuiIconButton: {
      root: {
        '&.MuiPickersDay-daySelected': {
          backgroundColor: primaryColor,
          '&:hover': {
            opacity: '0.9',
            backgroundColor: primaryColor
          }
        }
      }
    },
    MuiButton: {
      root: {
        textTransform: 'inherit',
        fontSize: '1rem',
        fontWeight: 500
      }
    },
    MuiCheckbox: {
      colorPrimary: {
        color: '#ADAEBB',
        '&$disabled': {
          color: '#EBE7ED'
        },
        '&$checked': {
          color: primaryColor
        }
      }
    },
    MuiTooltip: {
      tooltip: {
        padding: '10px 14px',
        fontSize: '13px',
        textAlign: 'center',
        fontWeight: 400
      }
    },
    MuiSwitch: {
      switchBase: {
        color: '#FFF'
      },
      colorPrimary: {
        color: '#FFF',
        '&$checked': {
          color: primaryColor
        },
        '&$checked + $track': {
          backgroundColor: primaryColor
        },
        '&$disabled + $track': {
          backgroundColor: '#f3f3f6',
          opacity: 1
        },
        '&$disabled': {
          color: '#EBE7ED'
        },
        '& + $track': {
          backgroundColor: '#C8C9D2'
        }
      },
      colorSecondary: {
        color: primaryColor,
        '&$checked': {
          color: primaryColor
        },
        '&$checked + $track': {
          backgroundColor: primaryColor
        },
        '&$disabled + $track': {
          backgroundColor: '#f3f3f6',
          opacity: 1
        },
        '&$disabled': {
          color: '#EBE7ED'
        },
        '& + $track': {
          backgroundColor: primaryColor
        }
      }
    },
    MuiDialogActions: {
      root: {
        padding: '16px 24px'
      }
    }
  }
});
const GlobalStyle = /*#__PURE__*/createGlobalStyle(_t$1 || (_t$1 = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    *, *::before, *::after {\n      box-sizing: border-box;\n    }\n    * {\n    &::-webkit-scrollbar {\n      width: 4px;\n    }\n    &::-webkit-scrollbar-track {\n      background: none;\n    }\n    &::-webkit-scrollbar-thumb {\n      background: ", ";\n      border-radius: 4px;\n      opacity: 0.6;\n      cursor: pointer;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n      background: ", ";\n      opacity: 1;\n    }\n  }\n"])), 0, 0)), props => props.theme.designTokens.color.color.light.outline.value, props => props.theme.designTokens.color.color.light.outline.value);
function ThemeProvider(props) {
  const {
    children
  } = props;
  return jsx(ThemeProvider$1, {
    theme: hubTheme,
    children: jsxs(MuiThemeProvider, {
      theme: hubTheme,
      children: [jsx(GlobalStyle, {}), children]
    })
  });
}
const isSpacing = val => {
  return typeof val === 'string';
};
const LayoutComponent = /*#__PURE__*/styled.div.withConfig({
  displayName: "layout__LayoutComponent",
  componentId: "sc-67hhhg-0"
})(["max-width:100%;display:flex;flex-direction:", ";flex-wrap:", ";padding-top:", "px;padding-bottom:", "px;padding-right:", "px;padding-left:", "px;gap:", "px;", " ", " ", ";", " ", ""], _ref12 => {
  let {
    stack
  } = _ref12;
  return stack ? 'column' : 'row';
}, props => props.wrap ? 'wrap' : 'nowrap', _ref13 => {
  let {
    pt
  } = _ref13;
  return pt;
}, _ref14 => {
  let {
    pb
  } = _ref14;
  return pb;
}, _ref15 => {
  let {
    pr
  } = _ref15;
  return pr;
}, _ref16 => {
  let {
    pl
  } = _ref16;
  return pl;
}, _ref17 => {
  let {
    gap
  } = _ref17;
  return gap !== null && gap !== void 0 ? gap : 0;
}, _ref18 => {
  let {
    clickable
  } = _ref18;
  return clickable ? css(["cursor:pointer;"]) : undefined;
}, _ref19 => {
  let {
    fullHeight
  } = _ref19;
  return fullHeight ? css(["height:100%;"]) : undefined;
}, _ref20 => {
  let {
    flex
  } = _ref20;
  return flex ? "flex: ".concat(flex) : '';
}, _ref21 => {
  let {
    vAlign,
    hAlign,
    stack
  } = _ref21;
  return stack ? css(["justify-content:", ";align-items:", ";"], vAlign || 'normal', hAlign || 'normal') : css(["justify-content:", ";align-items:", ";"], hAlign || 'normal', vAlign || 'normal');
}, _ref22 => {
  let {
    stretch,
    stack
  } = _ref22;
  return stretch && stack ? css(["flex:1;height:100%;"]) : stretch ? css(["flex:1;width:100%;"]) : '';
});
const Layout = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  const {
    stack = false,
    stretch = false,
    gap = 0,
    pr = 0,
    pb = 0,
    pt = 0,
    pl = 0,
    hAlign = 'normal',
    vAlign = 'normal',
    children,
    className,
    flex = '',
    wrap = false,
    onClick,
    dataCy,
    fullHeight = false
  } = props;
  const spacings = useMemo(() => {
    return {
      pr: isSpacing(pr) ? designSpacing[pr] : pr,
      pl: isSpacing(pl) ? designSpacing[pl] : pl,
      pt: isSpacing(pt) ? designSpacing[pt] : pt,
      pb: isSpacing(pb) ? designSpacing[pb] : pb,
      gap: isSpacing(gap) ? designSpacing[gap] : gap
    };
  }, [pr, pl, pt, pb, gap]);
  const clickable = Boolean(onClick);
  return jsx(LayoutComponent, {
    fullHeight: fullHeight,
    "data-role": clickable ? 'button' : undefined,
    clickable: clickable,
    onClick: event => {
      onClick === null || onClick === void 0 ? void 0 : onClick(event);
    },
    ref: ref,
    wrap: wrap,
    className: className,
    pr: spacings.pr,
    pt: spacings.pt,
    pb: spacings.pb,
    pl: spacings.pl,
    stack: stack,
    stretch: stretch,
    gap: spacings.gap,
    hAlign: hAlign,
    vAlign: vAlign,
    flex: flex,
    "data-cy": dataCy,
    children: children
  });
});
const StyledCheckbox$1 = /*#__PURE__*/styled(Checkbox$1).withConfig({
  displayName: "checkbox__StyledCheckbox",
  componentId: "sc-13vv425-0"
})(["&.MuiCheckbox-root{padding:8px;border-radius:100%;margin:none;", "}&.MuiCheckbox-colorPrimary{color:", ";.MuiTouchRipple-child{background-color:", ";}&:hover{background-color:", ";}&:focus{background-color:", ";}&.Mui-checked,&.MuiCheckbox-indeterminate{color:", ";.MuiTouchRipple-child{background-color:", ";}&:hover{background-color:", ";}&:focus{background-color:", ";}&.Mui-disabled{color:", ";opacity:0.38;}}}"], props => (props === null || props === void 0 ? void 0 : props.sizeNumber) && css(["width:", "px;height:", "px;"], props.sizeNumber, props.sizeNumber), props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
const StyledLabel$1 = /*#__PURE__*/styled(FormControlLabel).withConfig({
  displayName: "checkbox__StyledLabel",
  componentId: "sc-13vv425-1"
})(["&.MuiFormControlLabel{width:100%;&-root{margin:0 0 0 ", ";gap:0;display:flex;}}& .MuiFormControlLabel{&-label{flex:1 1 auto;display:flex;overflow:hidden;}}"], _ref23 => {
  let {
    noNegativeMargin
  } = _ref23;
  return noNegativeMargin ? 0 : '-11px';
});
const StyledLayout$2 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "checkbox__StyledLayout",
  componentId: "sc-13vv425-2"
})(["width:100%;"]);
const SupportingText = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "checkbox__SupportingText",
  componentId: "sc-13vv425-3"
})(["padding-left:38px;"]);
function Checkbox(props) {
  const {
    name,
    label,
    dataCy,
    checked,
    indeterminate,
    onChange,
    disabled,
    className,
    size,
    helperText,
    onClick,
    checkAtEnd,
    noNegativeMargin
  } = props;
  const inputProps = useMemo(() => {
    return {
      'data-cy': dataCy ? "".concat(dataCy) : undefined,
      id: name
    };
  }, [dataCy, name]);
  const control = jsx(StyledCheckbox$1, {
    color: "primary",
    name: name,
    inputProps: inputProps,
    checked: checked,
    indeterminate: indeterminate,
    disabled: disabled,
    onChange: onChange,
    onClick: onClick,
    sizeNumber: size
  });
  return jsxs(StyledLayout$2, {
    stack: true,
    className: className,
    children: [jsx(StyledLabel$1, {
      label: label ? typeof label === 'string' ? jsx(Typography, {
        variant: "body",
        size: "medium",
        tagName: "span",
        children: label
      }) : label : null,
      control: control,
      labelPlacement: checkAtEnd ? 'start' : 'end',
      noNegativeMargin: noNegativeMargin
    }), jsx(SupportingText, {
      variant: "body",
      size: "small",
      color: "on-surface-variant",
      children: helperText
    })]
  });
}
const CheckboxFormikWrapper = props => {
  const {
    name,
    label,
    dataCy,
    className,
    value,
    disabled,
    helperText,
    checkAtEnd = false
  } = props;
  const [field] = useField(name);
  return jsx(Checkbox, {
    className: className,
    name: name,
    label: label,
    dataCy: dataCy,
    disabled: disabled,
    checked: value === undefined ? Boolean(field.checked) : value === field.value,
    onChange: field.onChange,
    helperText: helperText,
    checkAtEnd: checkAtEnd
  });
};
const CheckboxReduxFormWrapper = props => {
  const {
    input,
    disabled,
    className,
    label,
    dataCy,
    helperText,
    checkAtEnd = false
  } = props;
  return jsx(Checkbox, {
    name: input.name,
    checked: props.value === undefined ? Boolean(input.checked) : input.value === props.value,
    label: label,
    onChange: input.onChange,
    disabled: disabled,
    className: className,
    dataCy: dataCy,
    helperText: helperText,
    checkAtEnd: checkAtEnd
  });
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
const overlayBaseStyles$1 = /*#__PURE__*/css(["border-radius:100px;height:100%;width:100%;position:absolute;top:0;left:0;content:'';"]);
const getColorValue = function (colorProp) {
  let defaultColorProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'on-surface-variant';
  const defaultColorObject = getColor(defaultColorProp);
  if (!colorProp) {
    return defaultColorObject || '#171d19ff';
  }
  const colorObject = getColor(colorProp);
  return colorObject || defaultColorObject || '#171d19ff';
};
const iconButtonStyles = (icon, color, noFill) => ({
  standard: css(["&.standard{path{", "}&:hover{background-color:", ";}&:focus{background-color:", ";}&:active{background-color:", ";}&.Mui-disabled{opacity:0.38;}}"], () => {
    if (noFill) {
      return;
    }
    if (ICONS_WITH_STROKE[icon]) {
      return css(["stroke:", " !important;"], () => getColorValue(color, 'on-surface-variant'));
    } else {
      return css(["fill:", " !important;"], () => getColorValue(color, 'on-surface-variant'));
    }
  }, props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.12'].value),
  filled: css(["&.filled{background-color:", ";path{", "}&:hover{&:after{", ";background-color:", ";}}&:focus,&:active{&:after{", ";background-color:", ";}}&.Mui-disabled{background-color:", ";opacity:0.38;path{", "}}}"], props => props.theme.designTokens.color.color.primary.primary.value, () => {
    if (noFill) return '';
    if (ICONS_WITH_STROKE[icon]) {
      return css(["stroke:", " !important;"], () => getColorValue(color, 'on-primary'));
    } else {
      return css(["fill:", " !important;"], () => getColorValue(color, 'on-primary'));
    }
  }, overlayBaseStyles$1, props => props.theme.designTokens.color.color['state-layers'].light['on-primary']['opacity-0.08'].value, overlayBaseStyles$1, props => props.theme.designTokens.color.color['state-layers'].light['on-primary']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, () => {
    if (noFill) {
      return;
    }
    if (ICONS_WITH_STROKE[icon]) {
      return css(["stroke:", " !important;"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
    } else {
      return css(["fill:", " !important;"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
    }
  }),
  outlined: css(["&.outlined{border:1px solid ", ";path{", "}&:hover,&:focus,&:active{&:after{", ";background-color:", ";}}&.Mui-disabled{border:1px solid ", ";opacity:0.38;path{", "}}}"], props => props.theme.designTokens.color.color.light.outline.value, () => {
    if (noFill) {
      return;
    }
    if (ICONS_WITH_STROKE[icon]) {
      return css(["stroke:", " !important;"], () => getColorValue(color, 'on-surface-variant'));
    } else {
      return css(["fill:", " !important;"], () => getColorValue(color, 'on-surface-variant'));
    }
  }, overlayBaseStyles$1, props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, () => {
    if (noFill) {
      return;
    }
    if (ICONS_WITH_STROKE[icon]) {
      return css(["stroke:", " !important;"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
    } else {
      return css(["fill:", " !important;"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
    }
  }),
  tonal: css(["&.tonal{background-color:", ";path{", "}&:hover,&:focus,&:active{&:after{", ";background-color:", ";}}&.Mui-disabled{background-color:", ";opacity:0.38;path{", "}}}"], props => props.theme.designTokens.color.color.surfaces['secondary-container'].value, () => {
    if (noFill) {
      return;
    }
    if (ICONS_WITH_STROKE[icon]) {
      return css(["stroke:", " !important;"], () => getColorValue(color, 'on-secondary-container'));
    } else {
      return css(["fill:", " !important;"], () => getColorValue(color, 'on-secondary-container'));
    }
  }, overlayBaseStyles$1, props => props.theme.designTokens.color.color['state-layers'].light['on-secondary-container']['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, () => {
    if (noFill) {
      return;
    }
    if (ICONS_WITH_STROKE[icon]) {
      return css(["stroke:", " !important;"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
    } else {
      return css(["fill:", " !important;"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
    }
  })
});
const sizeMap = {
  default: 40,
  medium: 32,
  small: 26
};
const paddingMap = {
  default: 8,
  medium: 8,
  small: 5
};
const StyledIconButton$2 = /*#__PURE__*/styled(IconButton$1).withConfig({
  displayName: "icon-button__StyledIconButton",
  componentId: "mruwtd-0"
})(["&.MuiIconButton-root{width:", "px;height:", "px;border-radius:100px;padding:", "px;", "}"], props => sizeMap[props.btnSize], props => sizeMap[props.btnSize], props => paddingMap[props.btnSize], _ref24 => {
  let {
    icon,
    iconColor,
    noFill
  } = _ref24;
  return Object.keys(iconButtonStyles(icon, iconColor, noFill)).map(variantKey => {
    return iconButtonStyles(icon, iconColor, noFill)[variantKey];
  });
});
function IconButton(props) {
  const {
    variant = 'standard',
    icon,
    color,
    dataCy,
    className,
    onClick,
    disabled,
    iconSize,
    size = 'default',
    noFill
  } = props;
  return jsx(StyledIconButton$2, {
    className: classNames(variant, className),
    "data-cy": dataCy,
    disabled: disabled,
    onClick: onClick,
    icon: icon,
    btnSize: size,
    iconColor: color,
    noFill: noFill,
    children: jsx(Icon, {
      name: icon,
      size: iconSize,
      noFill: noFill
    })
  });
}
const StyledInput$1 = /*#__PURE__*/styled(TextField$1).withConfig({
  displayName: "input__StyledInput",
  componentId: "v5lqn5-0"
})(["&.MuiTextField-root{.MuiOutlinedInput-root{min-height:44px;border:0;", ";", "}.MuiInputBase-root{.MuiOutlinedInput-input{min-height:17px;padding:13.5px 16px 13.5px 16px;", ";color:", ";&.Mui-disabled{opacity:0.38;}}textarea.MuiOutlinedInput-input{padding-top:12px;position:relative;}.MuiOutlinedInput-notchedOutline{border-radius:4px;border:1px solid ", ";}&:hover{.MuiOutlinedInput-notchedOutline{border:1px solid ", ";}}.MuiInputAdornment{&-positionStart{margin-right:0;}}&.Mui-focused{.MuiOutlinedInput-notchedOutline{border:3px solid ", ";}.MuiOutlinedInput-input{color:", ";}}&.Mui-error{.MuiOutlinedInput-notchedOutline{border:1px solid ", ";}&.Mui-focused{.MuiOutlinedInput-notchedOutline{border:3px solid ", ";}}}&.Mui-disabled{.MuiOutlinedInput-notchedOutline{opacity:0.38;}}}.MuiInputLabel-outlined{line-height:15px;transform:translate(14px,11px);", " color:", ";.MuiFormLabel-asterisk{color:", ";}&.Mui-error{color:", ";}}.MuiInputLabel-outlined.MuiInputLabel-shrink{", " transform:translate(16px,-8px) scale(.75);color:", ";.MuiFormLabel-asterisk{color:", ";}&.Mui-focused{color:", ";}&.Mui-error{color:", ";}&.Mui-disabled{opacity:0.38;}}&:hover{.MuiInputLabel-outlined.MuiInputLabel-shrink:not(.Mui-focused){color:", ";}.MuiInputLabel-outlined:not(.Mui-focused){color:", ";}.MuiInputLabel-outlined.Mui-error:not(.Mui-focused){color:", ";}}.MuiFormHelperText-root{", " padding:4px 16px 0 0;margin:0;color:", ";&.Mui-error{color:", ";}&.Mui-disabled{opacity:0.38;}}}"], () => typographyVariantStyles['body-medium'], props => {
  if (props.multiline) {
    return css(["padding-top:0;padding-bottom:0;"]);
  }
}, () => typographyVariantStyles['body-medium'], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color.color.light.outline.value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color.color.signal.error.value, props => props.theme.designTokens.color.color.signal.error.value, () => typographyVariantStyles['body-medium'], props => props.theme.designTokens.color.color.neutral.neutral50.value, props => props.theme.designTokens.color.color.signal.error.value, props => props.theme.designTokens.color.color.signal.error.value, () => typographyVariantStyles['body-medium'], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color.color.signal.error.value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.signal.error.value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color.signal.error.value, () => typographyVariantStyles['body-small'], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color.color.signal.error.value);
const getStartAdornment = (startAdornment, color) => {
  if (!startAdornment) {
    return undefined;
  } else if (isIcon(startAdornment)) {
    return jsx(InputAdornment, {
      position: "start",
      children: jsx(Icon, {
        name: startAdornment,
        color: color
      })
    });
  } else {
    return jsx(InputAdornment, {
      position: "start",
      color: color,
      children: startAdornment
    });
  }
};
const getEndAdornment = endAdornment => {
  if (!endAdornment) {
    return null;
  } else if (isIcon(endAdornment)) {
    return jsx(InputAdornment, {
      position: "end",
      children: jsx(Icon, {
        name: endAdornment
      })
    });
  } else {
    return jsx(InputAdornment, {
      position: "end",
      children: endAdornment
    });
  }
};
const ArrowButton = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "input__ArrowButton",
  componentId: "v5lqn5-1"
})(["cursor:pointer;height:14px;width:14px;border-radius:100%;transform:translate(-1px,-1px) scale(1.1);&:hover{background-color:", ";}", ""], props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.08'].value, props => {
  if (props.disabled) {
    return css(["cursor:auto;&:hover{background-color:transparent;}"]);
  }
});
const getNumberInputEndAdornment = _ref25 => {
  let {
    endAdornment,
    onIncrement,
    onDecrement,
    withSpinButtons,
    disabled
  } = _ref25;
  if (withSpinButtons) {
    return jsx(InputAdornment, {
      position: "end",
      children: jsxs(Layout, {
        stack: true,
        children: [jsx(ArrowButton, {
          disabled: disabled,
          name: "chevronUp",
          size: 14,
          onClick: disabled ? undefined : onIncrement,
          color: disabled ? 'on-surface' : undefined
        }), jsx(ArrowButton, {
          disabled: disabled,
          name: "chevronDown",
          size: 14,
          onClick: disabled ? undefined : onDecrement,
          color: disabled ? 'on-surface' : undefined
        })]
      })
    });
  }
  if (!endAdornment) {
    return null;
  } else if (isIcon(endAdornment)) {
    return jsx(InputAdornment, {
      position: "end",
      children: jsx(Icon, {
        name: endAdornment
      })
    });
  } else {
    return jsx(InputAdornment, {
      position: "end",
      children: endAdornment
    });
  }
};
const inputLabelProps$3 = {
  shrink: undefined
};
const StyledIconButton$1 = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "text-field__StyledIconButton",
  componentId: "sc-4h1wrg-0"
})(["position:relative;left:8px;"]);
function TextField(props) {
  const {
      name,
      className,
      dataCy,
      disabled,
      label,
      placeholder,
      value,
      onChange,
      onBlur,
      helperText,
      error,
      multiline,
      minRows,
      maxRows,
      endIcon,
      endIconOnClick,
      onKeyDown,
      onKeyUp,
      clearable,
      onClear,
      required,
      autoFocus,
      autoComplete,
      type,
      errorMessage
    } = props,
    rest = __rest(props, ["name", "className", "dataCy", "disabled", "label", "placeholder", "value", "onChange", "onBlur", "helperText", "error", "multiline", "minRows", "maxRows", "endIcon", "endIconOnClick", "onKeyDown", "onKeyUp", "clearable", "onClear", "required", "autoFocus", "autoComplete", "type", "errorMessage"]);
  const InputProps = useMemo(() => {
    const createEndAdornment = () => {
      if (clearable && value) {
        return jsx(InputAdornment, {
          position: "end",
          children: jsx(StyledIconButton$1, {
            icon: "cancel",
            onClick: event => {
              event.stopPropagation();
              onClear === null || onClear === void 0 ? void 0 : onClear(event);
            }
          })
        });
      }
      if (endIcon) {
        if (endIconOnClick) {
          return jsx(IconButton, {
            dataCy: dataCy ? "".concat(dataCy, "-endAdornment") : undefined,
            icon: endIcon,
            onClick: endIconOnClick
          });
        }
        return jsx(Icon, {
          name: endIcon
        });
      }
      return null;
    };
    return {
      endAdornment: createEndAdornment(),
      inputProps: {
        'data-cy': dataCy ? "".concat(dataCy) : undefined
      },
      id: name,
      type
    };
  }, [dataCy, endIcon, name, endIconOnClick, clearable, onClear, value, type]);
  return jsx(StyledInput$1, Object.assign({
    autoComplete: autoComplete,
    fullWidth: true,
    error: error,
    variant: "outlined",
    type: "text",
    label: label,
    helperText: errorMessage || helperText,
    placeholder: placeholder,
    name: name,
    className: className,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    multiline: multiline,
    minRows: minRows,
    maxRows: maxRows,
    InputProps: InputProps,
    InputLabelProps: inputLabelProps$3,
    onKeyUp: onKeyUp,
    required: required,
    autoFocus: autoFocus,
    onKeyDown: e => {
      if (onKeyDown) {
        onKeyDown(e);
      }
    }
  }, rest));
}
function TextFieldFormikWrapper(props) {
  const {
    name,
    className,
    dataCy,
    disabled,
    label,
    multiline,
    placeholder,
    helperText,
    minRows,
    maxRows,
    onKeyDown,
    onKeyUp,
    clearable,
    required,
    autoFocus,
    autoComplete
  } = props;
  const [field, meta, helpers] = useField(name);
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  const handleClear = useCallback(() => {
    if (!clearable) {
      return;
    }
    helpers.setValue('');
    helpers.setTouched(true, false);
  }, [clearable, helpers]);
  return jsx(TextField, {
    name: name,
    className: className,
    dataCy: dataCy,
    disabled: disabled,
    label: label,
    placeholder: placeholder,
    error: hasErrors,
    helperText: errorMsg || helperText,
    value: field.value,
    onChange: field.onChange,
    multiline: multiline,
    minRows: minRows,
    maxRows: maxRows,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    clearable: clearable,
    onClear: handleClear,
    required: required,
    autoFocus: autoFocus,
    autoComplete: autoComplete
  });
}
function TextFieldReduxFormWrapper(props) {
  const {
    input,
    disabled,
    className,
    helperText,
    dataCy,
    label,
    placeholder,
    multiline,
    meta,
    minRows,
    maxRows,
    onKeyDown,
    onKeyUp,
    clearable,
    required,
    autoFocus,
    autoComplete
  } = props;
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  const handleBlur = useCallback(() => {
    meta.dispatch(touch(meta.form, input.name));
  }, [input.name, meta]);
  const handleClear = useCallback(() => {
    if (!clearable) {
      return;
    }
    input.onChange('');
    meta.dispatch(touch(meta.form, input.name));
  }, [clearable, input, meta]);
  return jsx(TextField, {
    name: input.name,
    className: className,
    dataCy: dataCy,
    disabled: disabled,
    label: label,
    placeholder: placeholder,
    error: hasErrors,
    helperText: errorMsg || helperText,
    value: input.value,
    onChange: input.onChange,
    onBlur: handleBlur,
    multiline: multiline,
    minRows: minRows,
    maxRows: maxRows,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onClear: handleClear,
    required: required,
    autoFocus: autoFocus,
    autoComplete: autoComplete
  });
}
var anObject$a = anObject$n;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$a(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};
var fails$b = fails$q;
var global$c = global$p;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$c.RegExp;
var UNSUPPORTED_Y$1 = fails$b(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$b(function () {
  return !$RegExp$2('a', 'y').sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$b(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});
var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};
var fails$a = fails$q;
var global$b = global$p;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$b.RegExp;
var regexpUnsupportedDotAll = fails$a(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});
var fails$9 = fails$q;
var global$a = global$p;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$a.RegExp;
var regexpUnsupportedNcg = fails$9(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$9 = functionCall;
var uncurryThis$9 = functionUncurryThis;
var toString$8 = toString$a;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;
var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$4 = uncurryThis$9(''.charAt);
var indexOf = uncurryThis$9(''.indexOf);
var replace$3 = uncurryThis$9(''.replace);
var stringSlice$3 = uncurryThis$9(''.slice);
var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$9(nativeExec, re1, 'a');
  call$9(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$8(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$9(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$9(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
      flags = replace$3(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }
      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$4(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = call$9(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$9(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }
    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }
    return match;
  };
}
var regexpExec$2 = patchedExec;
var $$j = _export;
var exec$2 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$j({
  target: 'RegExp',
  proto: true,
  forced: /./.exec !== exec$2
}, {
  exec: exec$2
});
var NATIVE_BIND = functionBindNative;
var FunctionPrototype = Function.prototype;
var apply$3 = FunctionPrototype.apply;
var call$8 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$8.bind(apply$3) : function () {
  return call$8.apply(apply$3, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$7 = functionCall;
var defineBuiltIn$2 = defineBuiltIn$7;
var regexpExec$1 = regexpExec$2;
var fails$8 = fails$q;
var wellKnownSymbol$8 = wellKnownSymbol$l;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;
var SPECIES$4 = wellKnownSymbol$8('species');
var RegExpPrototype = RegExp.prototype;
var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$8(KEY);
  var DELEGATES_TO_SYMBOL = !fails$8(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () {
      return 7;
    };
    return ''[KEY](O) !== 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$8(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$4] = function () {
        return re;
      };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }
    re.exec = function () {
      execCalled = true;
      return null;
    };
    re[SYMBOL]('');
    return !execCalled;
  });
  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return {
            done: true,
            value: call$7(nativeRegExpMethod, regexp, str, arg2)
          };
        }
        return {
          done: true,
          value: call$7(nativeMethod, str, regexp, arg2)
        };
      }
      return {
        done: false
      };
    });
    defineBuiltIn$2(String.prototype, KEY, methods[0]);
    defineBuiltIn$2(RegExpPrototype, SYMBOL, methods[1]);
  }
  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype[SYMBOL], 'sham', true);
};
var uncurryThis$8 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$7 = toString$a;
var requireObjectCoercible$3 = requireObjectCoercible$7;
var charAt$3 = uncurryThis$8(''.charAt);
var charCodeAt = uncurryThis$8(''.charCodeAt);
var stringSlice$2 = uncurryThis$8(''.slice);
var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$7(requireObjectCoercible$3($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt$3(S, position) : first : CONVERT_TO_STRING ? stringSlice$2(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};
var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};
var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};
var uncurryThis$7 = functionUncurryThis;
var toObject$1 = toObject$7;
var floor = Math.floor;
var charAt$1 = uncurryThis$7(''.charAt);
var replace$2 = uncurryThis$7(''.replace);
var stringSlice$1 = uncurryThis$7(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$1(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$2(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$1(ch, 0)) {
      case '$':
        return '$';
      case '&':
        return matched;
      case '`':
        return stringSlice$1(str, 0, position);
      case "'":
        return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default:
        // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$1(ch, 1) : captures[f - 1] + charAt$1(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};
var call$6 = functionCall;
var anObject$9 = anObject$n;
var isCallable$7 = isCallable$n;
var classof$3 = classofRaw$2;
var regexpExec = regexpExec$2;
var $TypeError$5 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$7(exec)) {
    var result = call$6(exec, R, S);
    if (result !== null) anObject$9(result);
    return result;
  }
  if (classof$3(R) === 'RegExp') return call$6(regexpExec, R, S);
  throw new $TypeError$5('RegExp#exec called on incompatible receiver');
};
var apply$2 = functionApply;
var call$5 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$7 = fails$q;
var anObject$8 = anObject$n;
var isCallable$6 = isCallable$n;
var isNullOrUndefined$1 = isNullOrUndefined$5;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength = toLength$2;
var toString$6 = toString$a;
var requireObjectCoercible$2 = requireObjectCoercible$7;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$5;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol$7 = wellKnownSymbol$l;
var REPLACE = wellKnownSymbol$7('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis$6([].concat);
var push$1 = uncurryThis$6([].push);
var stringIndexOf$1 = uncurryThis$6(''.indexOf);
var stringSlice = uncurryThis$6(''.slice);
var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
}();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$7(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = {
      a: '7'
    };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
  return [
  // `String.prototype.replace` method
  // https://tc39.es/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = requireObjectCoercible$2(this);
    var replacer = isNullOrUndefined$1(searchValue) ? undefined : getMethod(searchValue, REPLACE);
    return replacer ? call$5(replacer, searchValue, O, replaceValue) : call$5(nativeReplace, toString$6(O), searchValue, replaceValue);
  },
  // `RegExp.prototype[@@replace]` method
  // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
  function (string, replaceValue) {
    var rx = anObject$8(this);
    var S = toString$6(string);
    if (typeof replaceValue == 'string' && stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf$1(replaceValue, '$<') === -1) {
      var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
      if (res.done) return res.value;
    }
    var functionalReplace = isCallable$6(replaceValue);
    if (!functionalReplace) replaceValue = toString$6(replaceValue);
    var global = rx.global;
    var fullUnicode;
    if (global) {
      fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }
    var results = [];
    var result;
    while (true) {
      result = regExpExec(rx, S);
      if (result === null) break;
      push$1(results, result);
      if (!global) break;
      var matchStr = toString$6(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
    }
    var accumulatedResult = '';
    var nextSourcePosition = 0;
    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = toString$6(result[0]);
      var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
      var captures = [];
      var replacement;
      // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
      for (var j = 1; j < result.length; j++) push$1(captures, maybeToString(result[j]));
      var namedCaptures = result.groups;
      if (functionalReplace) {
        var replacerArgs = concat([matched], captures, position, S);
        if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
        replacement = toString$6(apply$2(replaceValue, undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }
      if (position >= nextSourcePosition) {
        accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }
    return accumulatedResult + stringSlice(S, nextSourcePosition);
  }];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
const createCySelector = function () {
  let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return selector.replace(/\s/g, '-').toLowerCase();
};
var $$i = _export;
var iterate$5 = iterate$7;
var aCallable$8 = aCallable$i;
var anObject$7 = anObject$n;
var getIteratorDirect$5 = getIteratorDirect$9;

// `Iterator.prototype.forEach` method
// https://github.com/tc39/proposal-iterator-helpers
$$i({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  forEach: function forEach(fn) {
    anObject$7(this);
    aCallable$8(fn);
    var record = getIteratorDirect$5(this);
    var counter = 0;
    iterate$5(record, function (value) {
      fn(value, counter++);
    }, {
      IS_RECORD: true
    });
  }
});
class ObjectSet {
  constructor(_id, items) {
    this._items = new Map();
    this._id = _id;
    this.addItems(items);
    return this;
  }
  addItems(items) {
    items.forEach(item => {
      this._items.set(item[this._id], item);
    });
    return this;
  }
  removeItems(items) {
    items.forEach(item => {
      this._items.delete(item[this._id]);
    });
    return this;
  }
  getItems() {
    return Array.from(this._items.values());
  }
}
const DEFAULT_DELAY_TIME = 300; // [ms
const useDebouncedValue = _ref26 => {
  let {
    defaultValue,
    delayTime: _delayTime = DEFAULT_DELAY_TIME
  } = _ref26;
  const [stateValue, setStateValue] = useState(defaultValue);
  const [debounced, setDebounced] = useState(defaultValue);
  const debouncedSetter = useMemo(() => {
    return debounce(newValue => {
      setDebounced(newValue);
    }, _delayTime);
  }, [_delayTime]);
  const setDebouncedValue = useCallback(newValue => {
    setStateValue(newValue);
    debouncedSetter(newValue);
  }, [debouncedSetter]);
  const setValue = useCallback(newValue => {
    setStateValue(newValue);
    setDebounced(newValue);
  }, []);
  return {
    value: stateValue,
    setValue,
    debounced,
    setDebouncedValue
  };
};
const StyledRow$3 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "checkbox-list__StyledRow",
  componentId: "sc-1eiy9ba-0"
})(["height:100%;width:100%;"]);
const StyledContainer$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "checkbox-list__StyledContainer",
  componentId: "sc-1eiy9ba-1"
})(["height:100%;width:100%;"]);
const StyledListWrapper$4 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "checkbox-list__StyledListWrapper",
  componentId: "sc-1eiy9ba-2"
})(["flex-grow:1;min-height:100px;"]);
const StyledCheckbox = /*#__PURE__*/styled(Checkbox).withConfig({
  displayName: "checkbox-list__StyledCheckbox",
  componentId: "sc-1eiy9ba-3"
})(["&{width:100%;height:100%;.MuiFormControlLabel-root{width:100%;height:100%;padding-left:", "px;}", "}"], props => props.leftPadding || 0, props => {
  if (props.divider) {
    return css(["border-bottom:1px solid ", ";"], props => props.theme.designTokens.color.color.light['outline-variant'].value);
  }
  return undefined;
});
const CheckboxList = props => {
  const listRef = useRef(null);
  const {
    options = [],
    optionValue,
    optionLabel,
    labelRenderer,
    withSelectAll = false,
    withSearch,
    searchLabel,
    searchPlaceholder,
    selected = [],
    onChange,
    onSearch,
    dataCy,
    emptyStateText,
    className,
    itemProps = {
      divider: false,
      padding: {
        left: props.withSelectAll ? 24 : 0
      }
    },
    rowHeight = 48
  } = props;
  const {
    divider: itemDivider = false,
    padding: itemPadding = {
      left: props.withSelectAll ? 24 : 0
    }
  } = itemProps;
  const {
    value: displaySearchText,
    setDebouncedValue: setSearchText,
    debounced: debouncedSearchText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const filteredOptions = useMemo(() => {
    if (!onSearch) {
      return options;
    }
    return options.filter(option => onSearch(debouncedSearchText, option));
  }, [options, debouncedSearchText, onSearch]);
  const selectedMap = useMemo(() => {
    return selected.filter(Boolean).reduce((acc, selectedItem) => {
      acc[selectedItem[optionValue]] = selectedItem;
      return acc;
    }, {});
  }, [optionValue, selected]);
  const handleChange = useCallback((event, option) => {
    if (event.target.checked) {
      onChange([...selected, option]);
    } else {
      onChange(selected.filter(selectedItem => selectedItem && selectedItem[optionValue] !== option[optionValue]));
    }
  }, [onChange, optionValue, selected]);
  const getOptionLabel = useCallback(item => {
    if (typeof optionLabel === 'function') {
      return optionLabel(item);
    }
    return "".concat(item[optionLabel]);
  }, [optionLabel]);
  const rowRenderer = useCallback(props => {
    const {
      key,
      index,
      style
    } = props;
    const label = getOptionLabel(filteredOptions[index]);
    const labelToDisplay = labelRenderer ? labelRenderer(filteredOptions[index]) : label;
    return jsx("div", {
      style: style,
      children: jsx(StyledRow$3, {
        flex: "1 1 auto",
        gap: 8,
        pr: "--Spacing-200",
        vAlign: "center",
        children: jsx(StyledCheckbox, {
          leftPadding: itemPadding.left,
          divider: itemDivider,
          name: "".concat(index),
          dataCy: dataCy ? "".concat(dataCy, "-option-").concat(createCySelector(label)) : undefined,
          checked: Boolean(selectedMap[filteredOptions[index][optionValue]]),
          label: labelToDisplay,
          onChange: event => {
            handleChange(event, filteredOptions[index]);
          }
        })
      })
    }, key);
  }, [getOptionLabel, filteredOptions, labelRenderer, itemPadding.left, itemDivider, dataCy, selectedMap, optionValue, handleChange]);
  const handleSelectAllClick = useCallback(event => {
    if (event.target.checked) {
      onChange(new ObjectSet(optionValue, selected).addItems(filteredOptions).getItems());
    } else {
      onChange(new ObjectSet(optionValue, selected).removeItems(filteredOptions).getItems());
    }
  }, [onChange, selected, optionValue, filteredOptions]);
  const handleSearchChange = useCallback(event => {
    setSearchText(event.target.value);
  }, [setSearchText]);
  const noOfSelectedVisibleItems = useMemo(() => {
    return filteredOptions.reduce((acc, option) => selectedMap[option[optionValue]] ? acc + 1 : acc, 0);
  }, [filteredOptions, selectedMap, optionValue]);
  const filteredItemsCount = filteredOptions.length;
  const allSelected = noOfSelectedVisibleItems !== 0 && noOfSelectedVisibleItems === filteredItemsCount;
  const indeterminate = !allSelected && noOfSelectedVisibleItems !== 0;
  return jsxs(StyledContainer$1, {
    stack: true,
    stretch: true,
    className: className,
    children: [withSearch ? jsx(Layout, {
      pb: 24,
      children: jsx(TextField, {
        name: "search",
        dataCy: dataCy ? "".concat(dataCy, "-search-field") : undefined,
        label: searchLabel,
        placeholder: searchPlaceholder,
        value: displaySearchText,
        onChange: handleSearchChange
      })
    }) : null, !filteredOptions.length && emptyStateText ? jsx(Layout, {
      hAlign: "center",
      stretch: true,
      pt: 24,
      pb: 24,
      children: jsx(Typography, {
        variant: "label",
        size: "large",
        prominent: true,
        children: typeof emptyStateText === 'function' ? emptyStateText() : emptyStateText
      })
    }) : null, filteredOptions.length && withSelectAll ? jsx(Layout, {
      children: jsx(Checkbox, {
        name: "select-all",
        dataCy: dataCy ? "".concat(dataCy, "-select-all") : undefined,
        checked: allSelected,
        indeterminate: indeterminate,
        onChange: handleSelectAllClick,
        label: jsx(Typography, {
          variant: "label",
          size: "medium",
          prominent: true,
          tagName: "span",
          children: "Select All"
        })
      })
    }) : null, filteredOptions.length ? jsx(StyledListWrapper$4, {
      children: jsx(AutoSizer, {
        children: _ref27 => {
          let {
            height,
            width
          } = _ref27;
          return jsx(List$1, {
            ref: listRef,
            width: width,
            height: height,
            rowCount: filteredOptions.length,
            rowHeight: rowHeight,
            rowRenderer: rowRenderer
          });
        }
      })
    }) : null]
  });
};
const CheckboxListFormikWrapper = props => {
  const {
    name
  } = props;
  const [field,, helpers] = useField(name);
  const {
    setValue
  } = helpers;
  const handleChange = useCallback(selected => {
    setValue(selected);
  }, [setValue]);
  return jsx(CheckboxList, Object.assign({}, props, {
    onChange: handleChange,
    selected: field.value
  }));
};
const StyledChip$1 = /*#__PURE__*/styled(Chip$1).withConfig({
  displayName: "chip__StyledChip",
  componentId: "sc-1k0bk7q-0"
})(["&.MuiChip-root.MuiChip-outlined{*{cursor:", ";}cursor:", ";padding:6px 8px;border-radius:8px;border:", ";.MuiChip-label{padding-left:", ";padding-right:", ";font-weight:", ";font-size:", "px;line-height:", "px;letter-spacing:", "px;}.MuiChip-deleteIcon{width:18px;height:18px;padding:0;margin:0;}", " &:hover{", "}&:focus{", "}}"], props => props.clickable ? 'pointer' : 'default', props => props.clickable ? 'pointer' : 'default', props => {
  return props.selected ? "1px solid ".concat(props.theme.designTokens.color.color.light.outline.value) : "1px solid ".concat(props.theme.designTokens.color.color.surfaces['secondary-container'].value);
}, props => props.icon ? '8px' : '4px', props => props.onDelete ? '8px' : '4px', props => props.theme.designTokens.font.label['medium - prominent'].value.fontWeight, props => props.theme.designTokens.font.label['medium - prominent'].value.fontSize, props => props.theme.designTokens.font.label['medium - prominent'].value.lineHeight, props => props.theme.designTokens.font.label['medium - prominent'].value.letterSpacing, props => {
  if (props.selected) {
    return css(["background-color:", ";color:", ";"], props => props.theme.designTokens.color.color.surfaces['secondary-container'].value, props => props.theme.designTokens.color['on color'].surface['on-secondary-container'].value);
  }
  return css(["background-color:unset;color:", ";"], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value);
}, props => {
  if (!props.clickable) {
    return;
  }
  if (props.selected) {
    return css(["background-color:", ";color:", ";"], props => props.theme.designTokens.color.color.surfaces['secondary-container'].value, props => props.theme.designTokens.color['on color'].surface['on-secondary-container'].value);
  }
  return css(["background-color:", ";"], props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.08'].value);
}, props => {
  if (props.selected) {
    return css(["background-color:", ";color:", ";"], props => props.theme.designTokens.color.color.surfaces['secondary-container'].value, props => props.theme.designTokens.color['on color'].surface['on-secondary-container'].value);
  }
  return css(["background-color:", ";"], props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.12'].value);
});
function Chip(_ref28) {
  let {
    label,
    startIcon,
    onClick,
    dataCy,
    className,
    disabled,
    selected = false,
    endIcon,
    onDelete
  } = _ref28;
  const startIconColor = selected ? 'on-secondary-container' : 'primary';
  const endIconColor = selected ? 'on-secondary-container' : undefined;
  const StartIcon = useMemo(() => {
    if (!startIcon) return undefined;
    if (typeof startIcon === 'string') {
      return jsx(Icon, {
        name: startIcon,
        size: 18,
        color: startIconColor
      });
    }
    return startIcon;
  }, [startIcon, startIconColor]);
  return jsx(StyledChip$1, {
    clickable: Boolean(onClick),
    selected: selected,
    className: className,
    disabled: disabled,
    "data-cy": dataCy,
    variant: "outlined",
    label: jsxs(Layout, {
      vAlign: "center",
      gap: "--Spacing-100",
      children: [StartIcon, label, endIcon ? jsx(Icon, {
        name: endIcon,
        size: 18,
        color: endIconColor
      }) : null]
    }),
    onClick: onClick,
    onDelete: onDelete,
    deleteIcon: jsx(IconButton, {
      icon: "close",
      iconSize: 18,
      dataCy: dataCy ? "".concat(dataCy, "-delete") : undefined
    })
  });
}
const COLORS = ['#000', '#404040', '#7f7f7f', '#bfbfbf', '#fff', '#c00000', '#349E71', '#CF921A', '#DB6060', '#7A75C9', '#696C7A', '#ff0000', '#ffc000', '#ffff00', '#92d050', '#00b050', '#00b0f0', '#0070c0', '#002060', '#7030a0', '#EFC94C', '#F59C31', '#98CC96', '#17607D', '#F06C6C', '#CCCCCC', '#3F5666', '#EA6045', '#FEB41C', '#45B29D', '#c0504d', '#E8A386', '#4f81bd', '#52CFEA', '#9bbb59', '#8CD1B3', '#F2C572', '#81A489', '#E74C3C', '#90afb8', '#F2A054', '#C04D31', '#3498DB', '#C5F7D7', '#AFEFC8', '#99E7B9', '#83DFAA', '#6DD79B', '#57CF8C', '#41C77D', '#2BBF6E', '#15B75F', '#00B050', '#C7F0F9', '#B4E4F4', '#A0D8EE', '#8DCCE9', '#7AC1E3', '#66B5DE', '#53A9D8', '#3F9DD3', '#2C91CD', '#1986C8', '#F9C7CC', '#F4B4BB', '#EEA0A9', '#E98D98', '#E37A87', '#DE6675', '#D85364', '#D33F52', '#CD2C41', '#C81930'];
const DEFAULT_COLOR = '#349E71';
const StyledPicker = /*#__PURE__*/styled(TwitterPicker).withConfig({
  displayName: "color-picker__StyledPicker",
  componentId: "taspbn-0"
})(["box-shadow:none !important;div:nth-child(1){border:0 !important;}div:nth-child(2){display:none !important;}"]);
function ColorPicker(props) {
  const {
    className,
    value,
    onChange,
    onChangeComplete,
    dataCy,
    helperText,
    error,
    label,
    required
  } = props;
  const inputRef = useRef(null);
  const handleChange = useCallback(colorResult => {
    var _a;
    const isInputFieldFocused = inputRef.current === document.activeElement;
    const inputValue = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
    if (isInputFieldFocused && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) === 6) {
      // user uses text input of TwitterPicker
      onChange(colorResult.hex);
    } else if (!isInputFieldFocused) {
      // color block was clicked
      onChange(colorResult.hex);
      onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorResult.hex);
    }
  }, [onChange, onChangeComplete]);
  const handleRef = useCallback(ref => {
    if (!ref) {
      return;
    }
    const input = ref === null || ref === void 0 ? void 0 : ref.querySelector('input');
    if (!input) {
      return;
    }
    inputRef.current = input;
    if (dataCy) {
      input.setAttribute('data-cy', "".concat(dataCy, "-input"));
    }
  }, [dataCy]);
  useEffect(() => {
    const callback = event => {
      if (event.target && 'value' in event.target && event.key === 'Enter' && onChangeComplete) {
        onChangeComplete("#".concat(event.target.value).toLowerCase());
      }
    };
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', callback);
    }
    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('keydown', callback);
      }
    };
  }, [onChange, onChangeComplete]);
  return jsxs(Layout, {
    stack: true,
    className: className,
    dataCy: dataCy,
    ref: handleRef,
    children: [jsxs(Layout, {
      gap: 2,
      children: [label ? jsx(Typography, {
        children: label
      }) : null, required && jsx(Typography, {
        tagName: "span",
        color: "error",
        children: "*"
      })]
    }), jsx(StyledPicker, {
      colors: COLORS,
      color: value,
      onChangeComplete: handleChange
    }), helperText ? jsx(Typography, {
      variant: "body",
      size: "small",
      color: error ? 'error' : undefined,
      children: helperText
    }) : null]
  });
}
function ColorPickerFormikWrapper(props) {
  const {
    name,
    className,
    dataCy,
    label,
    required
  } = props;
  const [field, meta, helpers] = useField(name);
  const {
    setValue
  } = helpers;
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  const handleChange = useCallback(value => {
    setValue(value);
  }, [setValue]);
  return jsx(ColorPicker, {
    error: hasErrors,
    helperText: errorMsg,
    label: label,
    value: field.value,
    onChange: handleChange,
    className: className,
    dataCy: dataCy,
    required: required
  });
}
function ColorPickerReduxFormWrapper(props) {
  const {
    input,
    meta,
    className,
    dataCy,
    label,
    required
  } = props;
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  return jsx(ColorPicker, {
    error: hasErrors,
    helperText: errorMsg,
    label: label,
    value: input.value,
    onChange: input.onChange,
    dataCy: dataCy,
    className: className,
    required: required
  });
}
const infoTileVariantStyles$1 = {
  horizontal: css(["&.horizontal{height:1px;width:100%;}"]),
  vertical: css(["&.vertical{height:100%;width:1px;}"])
};
const StyledDivider$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "divider__StyledDivider",
  componentId: "sc-1rtwnrq-0"
})(["background-color:", ";", ""], props => props.theme.designTokens.color.color.light['outline-variant'].value, () => {
  return Object.keys(infoTileVariantStyles$1).map(variantKey => {
    return infoTileVariantStyles$1[variantKey];
  });
});
function Divider(_ref29) {
  let {
    type = 'horizontal',
    className
  } = _ref29;
  return jsx(StyledDivider$2, {
    className: classNames(type, className)
  });
}
const COMPONENT_LEVEL_BACKGROUND_COLOR = {
  default: designTokens.color.color.surfaces['surface-container'].value,
  high: designTokens.color.color.surfaces['surface-container-high'].value,
  highest: designTokens.color.color.surfaces['surface-container-highest'].value
};
const COMPONENT_LEVEL_ON_BACKGROUND_COLOR = {
  default: designTokens.color['on color']['surface']['on-surface'].value,
  high: designTokens.color['on color']['surface']['on-surface'].value,
  highest: designTokens.color['on color']['surface']['on-surface'].value
};
function useElementSize() {
  const [size, setSize] = useState({
    width: 0,
    height: 0
  });
  const elementRef = useRef(null);
  const resizeObserverCallback = useMemo(() => {
    return debounce(entries => {
      if (entries[0]) {
        const {
          width,
          height
        } = entries[0].contentRect;
        setSize({
          width,
          height
        });
      }
    }, 25);
  }, []);
  const resizeObserver = useMemo(() => {
    return new ResizeObserver(resizeObserverCallback);
  }, [resizeObserverCallback]);
  const updateRef = useCallback(node => {
    if (elementRef.current) {
      resizeObserver.unobserve(elementRef.current);
    }
    elementRef.current = node;
    if (node) {
      resizeObserver.observe(node);
      setSize({
        width: node.offsetWidth,
        height: node.offsetHeight
      });
    }
  }, [resizeObserver]);
  useEffect(() => {
    return () => {
      resizeObserver.disconnect();
    };
  }, [resizeObserver]);
  return [updateRef, size.width, size.height];
}
const HeaderDivider = /*#__PURE__*/styled(Divider).withConfig({
  displayName: "dialog__HeaderDivider",
  componentId: "d2a1zy-0"
})(["&&{margin-left:-24px;width:calc(100% + 48px);}"]);
const StyledDialog$5 = /*#__PURE__*/styled(Popover).withConfig({
  displayName: "dialog__StyledDialog",
  componentId: "d2a1zy-1"
})(["margin-top:", "px;.MuiPaper-root{padding:24px;border-radius:28px;background-color:", ";}"], props => props.gap && props.theme.designSpacing[props.gap], props => {
  return COMPONENT_LEVEL_BACKGROUND_COLOR[props.level];
});
const StyledContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "dialog__StyledContainer",
  componentId: "d2a1zy-2"
})(["height:100%;width:", ";"], _ref30 => {
  let {
    width
  } = _ref30;
  return width && Number(width) ? "".concat(width, "px") : width;
});
const StyledTitleDialog = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "dialog__StyledTitleDialog",
  componentId: "d2a1zy-3"
})(["padding-right:", "px;text-align:", ";overflow:hidden;"], props => props.hasCloseButton ? 28 : 0, props => props.hasIcon ? 'center' : 'left');
const CloseIconContainer$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "dialog__CloseIconContainer",
  componentId: "d2a1zy-4"
})(["position:absolute;right:16px;top:16px;"]);
const paperProps$5 = {
  elevation: 5,
  className: 'hub-ui__dialog-paper'
};
const DialogActions = /*#__PURE__*/styled.div.withConfig({
  displayName: "dialog__DialogActions",
  componentId: "d2a1zy-5"
})(["flex-shrink:0;min-height:40px;"]);
function Dialog(props) {
  const {
    id,
    open,
    anchorElement,
    title,
    icon,
    iconColor,
    content,
    actions,
    onClose,
    className,
    divider,
    headerDivider,
    position,
    disablePortal,
    level = 'high',
    anchorOriginPosition = {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOriginPosition = {
      vertical: 'top',
      horizontal: 'left'
    },
    width,
    gap,
    withCloseButton = false
  } = props;
  const [dialogRef] = useElementSize();
  const anchorOrigin = useMemo(() => ({
    vertical: anchorOriginPosition.vertical,
    horizontal: anchorOriginPosition.horizontal
  }), [anchorOriginPosition]);
  const transformOrigin = useMemo(() => ({
    vertical: transformOriginPosition.vertical,
    horizontal: transformOriginPosition.horizontal
  }), [transformOriginPosition]);
  const hasIcon = Boolean(icon);
  return jsx(StyledDialog$5, {
    id: id,
    disablePortal: disablePortal,
    className: className,
    open: open,
    anchorEl: anchorElement,
    onClose: onClose,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    PaperProps: paperProps$5,
    anchorPosition: position,
    anchorReference: position ? 'anchorPosition' : 'anchorEl',
    level: level,
    gap: gap,
    children: jsxs(StyledContainer, {
      stack: true,
      gap: 24,
      ref: dialogRef,
      className: "hub-ui__dialog-container",
      width: width,
      children: [withCloseButton ? jsx(CloseIconContainer$1, {
        children: jsx(IconButton, {
          icon: "close",
          onClick: onClose
        })
      }) : null, title ? jsxs(StyledTitleDialog, {
        stack: true,
        gap: 16,
        hAlign: hasIcon ? 'center' : 'flex-start',
        hasIcon: hasIcon,
        hasCloseButton: withCloseButton,
        children: [icon ? jsx(Icon, {
          name: icon,
          color: iconColor
        }) : null, title]
      }) : null, headerDivider ? jsx(HeaderDivider, {}) : null, content, divider ? jsx(Divider, {}) : null, jsx(DialogActions, {
        children: actions
      })]
    })
  });
}
function useOpenState() {
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const open = event => {
    setAnchorEl(event.currentTarget);
  };
  const close = () => {
    setAnchorEl(null);
  };
  const isOpen = Boolean(anchorEl);
  return {
    isOpen,
    open,
    close,
    anchorElement: anchorEl
  };
}
const CurrentColor = /*#__PURE__*/styled.div.withConfig({
  displayName: "color-picker-dialog__CurrentColor",
  componentId: "sc-1yhqsbd-0"
})(["background-color:", ";border:", ";width:32px;height:32px;cursor:pointer;border-radius:100%;float:right;"], props => props.color, props => props.color ? 0 : "1px solid ".concat(props.theme.designTokens.color.color.light.outline.value));
const StyledDialog$4 = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "color-picker-dialog__StyledDialog",
  componentId: "sc-1yhqsbd-1"
})(["& .MuiPaper-root{background-color:white;}"]);
function ColorPickerDialog(props) {
  const {
    className,
    value,
    onChange,
    dataCy,
    helperText,
    label,
    required,
    error,
    disablePortal = false
  } = props;
  const [innerValue, setInnerValue] = useState(value);
  const {
    open,
    isOpen,
    anchorElement,
    close
  } = useOpenState();
  const handleChange = useCallback(value => {
    setInnerValue(value);
  }, []);
  const handleChangeComplete = useCallback(value => {
    setInnerValue(value);
    onChange(value);
    close();
  }, [close, onChange]);
  const onSubmit = useCallback(() => {
    onChange(innerValue);
    close();
  }, [close, innerValue, onChange]);
  const title = undefined;
  const content = jsx("div", {
    children: jsx(ColorPicker, {
      value: innerValue,
      onChangeComplete: handleChangeComplete,
      onChange: handleChange,
      dataCy: dataCy ? "".concat(dataCy, "-popup") : undefined
    })
  });
  const actions = jsxs(Layout, {
    gap: "--Spacing-100",
    hAlign: "flex-end",
    children: [jsx(Button, {
      variant: "text",
      onClick: close,
      dataCy: "color-picker-cancel",
      children: "Cancel"
    }), jsx(Button, {
      onClick: onSubmit,
      dataCy: "color-picker-save",
      children: "Save"
    })]
  });
  return jsxs(Layout, {
    stack: true,
    className: className,
    gap: "--Spacing-100",
    children: [label ? jsxs(Layout, {
      gap: 2,
      children: [jsx(Typography, {
        children: label
      }), required && jsx(Typography, {
        tagName: "span",
        color: "error",
        children: "*"
      })]
    }) : null, jsx(CurrentColor, {
      className: "color-picker-current",
      onClick: open,
      color: value,
      "data-cy": dataCy
    }), helperText ? jsx(Typography, {
      variant: "body",
      size: "small",
      color: error ? 'error' : undefined,
      children: helperText
    }) : null, jsx(StyledDialog$4, {
      disablePortal: disablePortal,
      open: isOpen,
      anchorElement: anchorElement,
      title: title,
      content: content,
      actions: actions,
      onClose: close
    })]
  });
}
function ColorPickerDialogFormikWrapper(props) {
  const {
    name,
    className,
    dataCy,
    label,
    helperText,
    required
  } = props;
  const [field, meta, helpers] = useField(name);
  const {
    setValue
  } = helpers;
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  const handleChange = useCallback(value => {
    setValue(value);
  }, [setValue]);
  return jsx(ColorPickerDialog, {
    error: hasErrors,
    helperText: errorMsg || helperText,
    value: field.value,
    label: label,
    onChange: handleChange,
    className: className,
    dataCy: dataCy,
    required: required
  });
}
function ColorPickerDialogReduxFormWrapper(props) {
  const {
    input,
    meta,
    className,
    dataCy,
    label,
    required,
    helperText
  } = props;
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  return jsx(ColorPickerDialog, {
    error: hasErrors,
    helperText: errorMsg || helperText,
    label: label,
    value: input.value,
    onChange: input.onChange,
    className: className,
    dataCy: dataCy,
    required: required
  });
}
const HubUIConfigContext = /*#__PURE__*/createContext({
  firstDayOfWeek: 0
});
const HubUIConfigContextProvider = props => {
  const {
    firstDayOfWeek,
    children
  } = props;
  return jsx(HubUIConfigContext.Provider, {
    value: {
      firstDayOfWeek: firstDayOfWeek !== null && firstDayOfWeek !== void 0 ? firstDayOfWeek : 1
    },
    children: children
  });
};
const useHubUIConfigContext = () => useContext(HubUIConfigContext);
const useResizeObserver = _ref31 => {
  let {
    onResize,
    debounceTime: _debounceTime = 50
  } = _ref31;
  const targetRef = useRef(null);
  const observerRef = useRef(new ResizeObserver(debounce$1(() => {
    if (!targetRef.current) {
      return;
    }
    onResize(targetRef.current);
  }, _debounceTime)));
  const onResizeTargetRef = useCallback(ref => {
    if (ref) {
      targetRef.current = ref;
      observerRef.current.observe(ref);
    }
  }, []);
  useEffect(() => {
    const observer = observerRef.current;
    return () => {
      if (observer) {
        if (targetRef.current) {
          observer.unobserve(targetRef.current);
        }
        observer.disconnect();
      }
    };
  }, []);
  return {
    onResizeTargetRef
  };
};
const StyledContextMenuItem = /*#__PURE__*/styled(MenuItem$1).withConfig({
  displayName: "context-menu-item__StyledContextMenuItem",
  componentId: "qrt9qh-0"
})(["&.MuiButtonBase-root.Mui-disabled{pointer-events:all;}&.MuiMenuItem-root{min-height:40px;padding:8px 12px;display:flex;align-items:center;", " & *{cursor:pointer;}}&.MuiListItem-button:hover{background-color:", ";}"], () => typographyVariantStyles['body-medium'], props => props.theme.designTokens.color.color.surfaces['surface-container-highest'].value);
const ContextMenuItem = props => {
  const {
    children,
    disabled,
    className,
    dataCy,
    onClick,
    onMouseEnter
  } = props;
  return jsx(StyledContextMenuItem, {
    className: classNames(className, 'hub-ui-context-menu-item'),
    disabled: disabled,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    "data-cy": dataCy,
    children: children
  });
};
const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "context-menu__StyledIcon",
  componentId: "sc-1373xeu-0"
})(["position:relative;left:8px;"]);
const StyledDivider$1 = /*#__PURE__*/styled(Divider).withConfig({
  displayName: "context-menu__StyledDivider",
  componentId: "sc-1373xeu-1"
})(["margin:2px 0;opacity:0.4;"]);
const MenuLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "context-menu__MenuLayout",
  componentId: "sc-1373xeu-2"
})(["background-color:", ";width:350px;"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value);
const StyledMenu$1 = /*#__PURE__*/styled(MenuComponent).withConfig({
  displayName: "context-menu__StyledMenu",
  componentId: "sc-1373xeu-3"
})([".MuiMenu-paper{background-color:", ";width:350px;padding:", "px;}.MuiList-root{padding:0;}"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, props => props.theme.designSpacing['--Spacing-200']);
const ContextMenuManagerContext = /*#__PURE__*/createContext({
  openItem: null,
  open: elem => {
    // do nothing
  },
  close: () => {
    // do nothing
  }
});
const ContextMenuManagerContextProvider = props => {
  const {
    children
  } = props;
  const [openItem, setOpenItem] = useState(null);
  const open = useCallback(elem => {
    setOpenItem(elem);
  }, []);
  const close = useCallback(() => {
    setOpenItem(null);
  }, []);
  const value = useMemo(() => ({
    openItem,
    open,
    close
  }), [openItem, open, close]);
  return jsx(ContextMenuManagerContext.Provider, {
    value: value,
    children: children
  });
};
const useContextMenuManager = () => {
  return useContext(ContextMenuManagerContext);
};
const MenuItemStandard = props => {
  const {
    children,
    disabled,
    dataCy,
    onClick
  } = props;
  const {
    close
  } = useContextMenuManager();
  const handleOnMouseEnter = useCallback(() => {
    close();
  }, [close]);
  const handleClick = useCallback(event => {
    if (disabled) {
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  }, [disabled, onClick]);
  return jsx(ContextMenuItem, {
    onMouseEnter: handleOnMouseEnter,
    disabled: disabled,
    dataCy: dataCy,
    onClick: handleClick,
    children: children
  });
};
const MenuItemWithChildren = _ref32 => {
  let {
    children,
    label,
    dataCy,
    disabled
  } = _ref32;
  const {
    open,
    openItem
  } = useContextMenuManager();
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);
  const [anchorOrigin, setAnchorOrigin] = useState({
    vertical: 'top',
    horizontal: 'right'
  });
  const [transformOrigin, setTransformOrigin] = useState({
    vertical: 'top',
    horizontal: 'left'
  });
  const handleOnMouseEnter = useCallback(event => {
    if (disabled) {
      return;
    }
    open(event.currentTarget);
    wrapperRef.current = event.currentTarget;
  }, [disabled, open]);
  const isOpen = Boolean(openItem && wrapperRef.current === openItem);
  const resizeObserverProps = useMemo(() => {
    return {
      debounceTime: 10,
      onResize() {
        var _a;
        const wrapper = wrapperRef.current;
        const menu = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.children.item(2);
        if (!wrapper || !menu) {
          return;
        }
        const parentRect = wrapper.getBoundingClientRect();
        const menuRect = menu.getBoundingClientRect();
        const spaceOnRightParent = window.innerWidth - parentRect.right;
        if (spaceOnRightParent < menuRect.width) {
          setAnchorOrigin({
            horizontal: 'left',
            vertical: 'top'
          });
          setTransformOrigin({
            horizontal: 'right',
            vertical: 'top'
          });
        } else {
          setAnchorOrigin({
            horizontal: 'right',
            vertical: 'top'
          });
          setTransformOrigin({
            horizontal: 'left',
            vertical: 'top'
          });
        }
      }
    };
  }, []);
  const {
    onResizeTargetRef
  } = useResizeObserver(resizeObserverProps);
  return jsxs("div", {
    onMouseEnter: handleOnMouseEnter,
    children: [jsx(ContextMenuItem, {
      dataCy: dataCy,
      disabled: disabled,
      children: jsxs(Layout, {
        gap: "--Spacing-100",
        hAlign: "space-between",
        vAlign: "center",
        stretch: true,
        children: [typeof label === 'string' ? jsx(Typography, {
          variant: "body",
          size: "medium",
          noWrap: true,
          children: label
        }) : label, disabled ? null : jsx(Layout, {
          flex: "0 0 24px",
          children: jsx(StyledIcon, {
            name: "navigateNext"
          })
        })]
      })
    }), jsx(StyledMenu$1, {
      elevation: 5,
      open: isOpen,
      autoFocus: false,
      disableAutoFocus: true,
      disableEnforceFocus: true,
      style: {
        pointerEvents: 'none'
      },
      anchorEl: wrapperRef.current,
      transitionDuration: 80,
      anchorOrigin: anchorOrigin,
      transformOrigin: transformOrigin,
      anchorPosition: {
        top: 0,
        left: 0
      },
      ref: ref => menuRef.current = ref,
      MenuListProps: {
        ref: onResizeTargetRef
      },
      PaperProps: {
        elevation: 2,
        style: {
          pointerEvents: 'auto'
        }
      },
      children: children
    })]
  });
};
const isDivider$2 = value => {
  if ('divider' in value && value.divider) return true;
  return false;
};
const Items = props => {
  const {
    items
  } = props;
  return jsx("div", {
    children: items.filter(item => {
      if ('hidden' in item) {
        return !item.hidden;
      }
      return true;
    }).map((item, index) => {
      if (isDivider$2(item)) {
        return jsx(StyledDivider$1, {});
      }
      if (item.children) {
        return jsx(MenuItemWithChildren, {
          label: item.label,
          dataCy: item.dataCy,
          disabled: item.disabled,
          children: item.children
        }, index);
      }
      return jsx(MenuItemStandard, {
        disabled: item.disabled,
        dataCy: item.dataCy,
        onClick: item.onClick,
        children: item.label
      }, index);
    })
  });
};
const BlockContextMenu = props => {
  const {
    items
  } = props;
  return jsx(MenuLayout, {
    stack: true,
    children: jsx(Items, {
      items: items
    })
  });
};
const paperProps$4 = {
  elevation: 2
};
const AnchorContextMenu = props => {
  const {
    items,
    position,
    onClose,
    isOpen,
    anchorEl,
    className
  } = props;
  const handleClose = () => {
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  const anchorOrigin = useMemo(() => {
    return {
      vertical: 'bottom',
      horizontal: 'left'
    };
  }, []);
  return jsx(StyledMenu$1, {
    className: className,
    autoFocus: false,
    open: isOpen,
    style: {
      pointerEvents: 'none'
    },
    anchorReference: anchorEl ? 'anchorEl' : 'anchorPosition',
    anchorEl: anchorEl,
    anchorPosition: position,
    anchorOrigin: anchorOrigin,
    PaperProps: paperProps$4,
    children: jsx(ClickAwayListener, {
      onClickAway: handleClose,
      children: jsx("div", {
        style: {
          pointerEvents: 'auto'
        },
        children: jsx(Items, {
          items: items
        })
      })
    })
  });
};
const ContextMenuComponent = props => {
  const {
    variant,
    items
  } = props;
  if (variant === 'block') {
    return jsx(BlockContextMenu, {
      items: items
    });
  }
  const {
    position,
    onClose,
    isOpen,
    anchorEl
  } = props;
  return jsx(AnchorContextMenu, {
    position: position,
    onClose: onClose,
    isOpen: isOpen,
    items: items,
    anchorEl: anchorEl
  });
};
const ContextMenu = props => {
  return jsx(ContextMenuManagerContextProvider, {
    children: jsx(ContextMenuComponent, Object.assign({}, props))
  });
};
const Header = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "header__Header",
  componentId: "tqxzh7-0"
})(["border-bottom:1px solid ", ";"], props => props.theme.designTokens.color.color.light['outline-variant'].value);
const DateHeader = props => {
  const {
    label,
    date
  } = props;
  return jsxs(Header, {
    stack: true,
    pt: 16,
    pr: 12,
    pb: 12,
    pl: 24,
    gap: "--Spacing-100",
    children: [jsx(Typography, {
      variant: "label",
      size: "large",
      color: "on-surface-variant",
      children: label
    }), jsx(Typography, {
      variant: "headline",
      size: "medium",
      color: "on-surface-variant",
      children: formatDate(date, DATE_FORMATS.WEEK_SHORT_MONTH_SHORT_DAY)
    })]
  });
};
const DateMenuButton = /*#__PURE__*/styled(BaseButton).withConfig({
  displayName: "menu-button__DateMenuButton",
  componentId: "sc-6acaht-0"
})(["&.MuiButton-root{text-transform:none;height:40px;border-radius:100px;display:flex;padding:10px 4px 10px 8px;justify-content:center;align-items:center;gap:8px;svg{margin-left:", "px;height:18px;width:18px;fill:", ";}.MuiButton-label{color:", ";", ";}&:hover{background-color:", ";}&:focus{background-color:", ";}&:active{background-color:", ";}&.disabled{opacity:0.38;}}"], props => props.theme.designSpacing['--Spacing-100'], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, () => typographyVariantStyles['label-large'], props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface-variant']['opacity-0.12'].value);
const StyledNavigation = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "navigation__StyledNavigation",
  componentId: "sc-1525hed-0"
})(["width:100%;margin:0 auto;max-width:450px;height:56px;"]);
const DateNavigation = props => {
  const {
    onChange,
    date,
    open,
    onOpen
  } = props;
  const handleNavigateBack = useCallback(() => {
    onChange(addMonths(date, -1));
  }, [date, onChange]);
  const handleNavigateNext = useCallback(() => {
    onChange(addMonths(date, 1));
  }, [date, onChange]);
  return jsxs(StyledNavigation, {
    vAlign: "center",
    hAlign: "space-between",
    gap: "--Spacing-100",
    pt: "--Spacing-50",
    pr: "--Spacing-150",
    pb: "--Spacing-50",
    pl: "--Spacing-200",
    children: [jsxs(DateMenuButton, {
      "data-cy": "calendar-year-month-select-btn",
      onClick: onOpen,
      children: [formatDate(date, DATE_FORMATS.MONTH_YEAR), jsx(Icon, {
        name: open ? "arrowDropUp" : "arrowDropDown"
      })]
    }), jsxs(Layout, {
      children: [jsx(IconButton, {
        icon: "navigateBefore",
        dataCy: "calendar-navigate-back",
        onClick: handleNavigateBack
      }), jsx(IconButton, {
        icon: "navigateNext",
        dataCy: "calendar-navigate-next",
        onClick: handleNavigateNext
      })]
    })]
  });
};
const CommonDatePickerStyles = /*#__PURE__*/css([".DayPicker-Day{padding:", ";&--disabled{color:", ";opacity:0.38;}&--today{position:relative;z-index:10;&:after{z-index:1;position:absolute;top:", "px;left:", "px;height:", "px;width:", "px;content:'';display:block;border-radius:100%;border:1px solid ", ";}.custom-date-cell{border-radius:100%;color:", ";}}&--outside{&:after{display:none;}}&--selected .custom-date-cell{border-radius:100px;color:", ";background-color:transparent;}}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){background-color:transparent;position:relative;color:", ";&:after{z-index:1;position:absolute;top:", "px;left:", "px;height:", "px;width:", "px;content:'';display:block;border-radius:100%;background-color:", ";}&.DayPicker-Day--range{&:after{border-radius:0;}}&.DayPicker-Day--from{&:after{border-top-left-radius:100%;border-bottom-left-radius:100%;border-top-right-radius:0;border-bottom-right-radius:0;}}&.DayPicker-Day--to{&:after{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:100%;border-bottom-right-radius:100%;}}&.DayPicker-Day--from.DayPicker-Day--to{&:after{border-radius:100%;}}}.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{background-color:transparent;position:relative;&:after{z-index:1;position:absolute;top:", "px;left:", "px;height:", "px;width:", "px;content:'';display:block;border-radius:100%;background-color:", ";}}.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover{background-color:transparent;}"], props => props.dense ? "4px 0" : "2px 0", props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.dense ? 4 : 2, props => props.dense ? -2 : 0, props => props.dense ? 40 : 48, props => props.dense ? 40 : 48, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color['on color'].primary['on-primary'].value, props => props.theme.designTokens.color['on color'].primary['on-primary'].value, props => props.dense ? 4 : 2, props => props.dense ? -2 : 0, props => props.dense ? 40 : 48, props => props.dense ? 40 : 48, props => props.theme.designTokens.color.color.primary.primary.value, props => props.dense ? 4 : 2, props => props.dense ? -2 : 0, props => props.dense ? 40 : 48, props => props.dense ? 40 : 48, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value);
function scrollIntoView(elem, scrollableElem) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (scrollableElem && elem) {
    const scrollableRect = scrollableElem.getBoundingClientRect();
    const elemRect = elem.getBoundingClientRect();
    if (elemRect.bottom > scrollableRect.bottom) {
      scrollableElem.scrollTop += elemRect.bottom - scrollableRect.bottom + (options.center ? scrollableRect.height / 2 : 0);
    } else if (elemRect.top < scrollableRect.top) {
      scrollableElem.scrollTop -= scrollableRect.top - elemRect.top;
    }
  }
}
const overlayBaseStyles = /*#__PURE__*/css(["border-radius:100px;height:100%;width:100%;position:absolute;top:0;left:0;content:'';"]);
const getChipCommonStyles = _ref33 => {
  let {
    selected
  } = _ref33;
  if (selected) {
    return css(["background-color:", ";&:hover{&:after{", ";}}&:focus{&:after{", ";background-color:", ";}}&:active{&:after{", ";background-color:", ";}}"], props => props.theme.designTokens.color.color.primary.primary.value, overlayBaseStyles, overlayBaseStyles, props => props.theme.designTokens.color.color['state-layers'].light['on-primary']['opacity-0.12'].value, overlayBaseStyles, props => props.theme.designTokens.color.color['state-layers'].light['on-primary']['opacity-0.12'].value);
  }
  return css(["&:hover{background-color:", ";}&:focus{background-color:", ";}&:active{background-color:", ";}"], props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value);
};
const StyledYearMonthChip = /*#__PURE__*/styled.div.withConfig({
  displayName: "year-month-chip__StyledYearMonthChip",
  componentId: "ikbbf5-0"
})(["display:flex;width:88px;height:52px;flex-direction:column;justify-content:center;align-items:center;gap:10px;flex-shrink:0;cursor:pointer;"]);
const YearMonthChipTypography = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "year-month-chip__YearMonthChipTypography",
  componentId: "ikbbf5-1"
})(["display:flex;justify-content:center;align-items:center;height:36px;min-width:72px;border-radius:100px;position:relative;&.disabled{opacity:0.38;}", ""], props => {
  return getChipCommonStyles({
    selected: props.selected
  });
});
const YearMonthChip = props => {
  const {
    selected,
    label,
    onClick,
    disabled
  } = props;
  return jsx(StyledYearMonthChip, {
    role: "button",
    "data-selected": selected,
    onClick: onClick,
    className: disabled ? 'disabled' : undefined,
    children: jsx(YearMonthChipTypography, {
      className: disabled ? 'disabled' : undefined,
      selected: selected,
      variant: "title",
      size: "medium",
      color: selected ? 'on-primary' : undefined,
      children: label
    })
  });
};
const YearMonthPickerOverLay = /*#__PURE__*/styled.div.withConfig({
  displayName: "year-month-select__YearMonthPickerOverLay",
  componentId: "sc-74hy82-0"
})(["display:flex;gap:", ";justify-content:center;position:absolute;top:0;left:0;height:calc(100% - 56px);width:100%;margin:56px auto 0 auto;max-width:450px;background-color:", ";z-index:20;flex-wrap:wrap;overflow:auto;"], props => props.dense ? '4px' : '8px', props => COMPONENT_LEVEL_BACKGROUND_COLOR[props.level]);
const YearMonthSelect = props => {
  const {
    displayDate,
    onChange,
    onClose,
    level = 'high',
    dense = false
  } = props;
  const [startYear] = useState(addYears(new Date(), -100).getFullYear());
  const [yearOrMonth, setYearOrMonth] = useState('year');
  const [value, setValue] = useState(displayDate);
  useLayoutEffect(() => {
    const currentYear = document.querySelector('[data-selected="true"]');
    const scrollArea = document.querySelector('[data-scroll-area]');
    scrollIntoView(currentYear, scrollArea, {
      center: true
    });
  }, []);
  const yearOptions = useMemo(() => {
    return new Array(200).fill(startYear).map((val, i) => val + i);
  }, [startYear]);
  const monthOptions = useMemo(() => {
    return getListOfMonths(value);
  }, [value]);
  const handleYearSelect = useCallback(year => {
    setYearOrMonth('month');
    setValue(prev => {
      const newDate = new Date(prev);
      newDate.setFullYear(year);
      return newDate;
    });
  }, []);
  const handleMonthSelect = useCallback(date => {
    onChange(date);
  }, [onChange]);
  return jsx(ClickAwayListener, {
    onClickAway: () => {
      onClose();
    },
    children: jsx(YearMonthPickerOverLay, {
      "data-scroll-area": true,
      level: level,
      dense: dense,
      children: yearOrMonth === 'year' ? yearOptions.map(year => {
        const selected = displayDate.getFullYear() === year;
        return jsx(YearMonthChip, {
          selected: selected,
          label: year,
          dataCy: "year-".concat(year),
          onClick: () => handleYearSelect(year)
        }, year);
      }) : monthOptions.map(month => {
        const formatted = formatDate(month, DATE_FORMATS.MONTH_SHORT);
        const selected = isSameYear(month, displayDate) && isSameMonth(month, displayDate);
        return jsx(YearMonthChip, {
          selected: selected,
          label: formatted,
          dataCy: "month-".concat(month.getMonth() + 1),
          onClick: () => handleMonthSelect(month)
        }, month.getMonth());
      })
    })
  });
};
const CalendarWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "calendar__CalendarWrapper",
  componentId: "xpaybj-0"
})(["position:relative;font-family:Poppins,'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-style:normal;background-color:", ";"], props => props.theme.designTokens.color.color.surfaces['surface-container'].value);
const CalendarContainer$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "calendar__CalendarContainer",
  componentId: "xpaybj-1"
})(["max-width:450px;margin:0 auto;position:relative;"]);
const StyledDatePicker = /*#__PURE__*/styled(ReactDatePicker).withConfig({
  displayName: "calendar__StyledDatePicker",
  componentId: "xpaybj-2"
})(["", " .DayPicker-wrapper{padding:0;}.DayPicker-Caption{display:none;}.DayPicker-NavBar{display:none;}.DayPicker-Months{margin:0 auto;padding:0 12px 16px 12px;max-width:450px;}.DayPicker-Month{width:100%;margin:0;}.DayPicker-Weekdays{margin:0;}.DayPicker-Weekday,.DayPicker-Day{height:48px;width:60px;padding:4px 10px;color:", ";&:hover{background-color:transparent;}&--today{&:after{top:0;left:5px;}}}.DayPicker-Weekday{abbr{height:40px;width:40px;display:flex;justify-content:center;align-items:center;}}.DayPicker-Day{", " .custom-date-cell{border-radius:100%;height:40px;width:40px;display:flex;justify-content:center;align-items:center;}}"], CommonDatePickerStyles, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, typographyVariantStyles['body-large']);
const DateCell = /*#__PURE__*/styled.div.withConfig({
  displayName: "calendar__DateCell",
  componentId: "xpaybj-3"
})(["position:relative;border-radius:100%;"]);
const DateCellText = /*#__PURE__*/styled.div.withConfig({
  displayName: "calendar__DateCellText",
  componentId: "xpaybj-4"
})(["position:absolute;top:0;left:0;height:100%;width:100%;z-index:2;display:flex;justify-content:center;align-items:center;color:", ";"], props => {
  var _a;
  return ((_a = props.colors[0]) === null || _a === void 0 ? void 0 : _a.color) || 'black';
});
const DateCellBackground = /*#__PURE__*/styled.div.withConfig({
  displayName: "calendar__DateCellBackground",
  componentId: "xpaybj-5"
})(["position:absolute;top:0;left:0;height:100%;width:100%;border-radius:100%;rotate:", ";z-index:1;background-image:conic-gradient( from 0deg at 50% 50%,", " );"], props => props.slices % 2 === 0 ? "45deg" : "0", props => {
  var _a;
  const sliceSize = 360 / ((_a = props.slices) !== null && _a !== void 0 ? _a : 1);
  return props.colors.map((color, index) => {
    return css(["", " ", "deg,", " ", "deg", ""], color.backgroundColor, sliceSize * index, color.backgroundColor, sliceSize * (index + 1), index === props.slices - 1 ? '' : ',');
  });
});
const Legend = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "calendar__Legend",
  componentId: "xpaybj-6"
})(["flex-wrap:wrap;"]);
const Dot$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "calendar__Dot",
  componentId: "xpaybj-7"
})(["display:inline-block;width:", "px;height:", "px;border-radius:100%;background-color:", ";"], props => props.theme.designSpacing['--Spacing-100'], props => props.theme.designSpacing['--Spacing-100'], props => props.styles.backgroundColor);
function Calendar(props) {
  const {
    ranges,
    legend
  } = props;
  const [today] = useState(new Date());
  const [displayDate, setDisplayDate] = useState(today);
  const [showYearMonthSelect, setShowYearMonthSelect] = useState(false);
  const {
    firstDayOfWeek
  } = useHubUIConfigContext();
  const rangeLegendMap = Object.keys(ranges).reduce((acc, rangeKey) => {
    acc[rangeKey] = Object.assign(Object.assign({}, legend[ranges[rangeKey].type].styles), {
      type: ranges[rangeKey].type
    });
    return acc;
  }, {});
  const handleYearMonthChange = useCallback(date => {
    setDisplayDate(date);
    setShowYearMonthSelect(false);
  }, []);
  const handleCloseYearMonthSelect = useCallback(() => {
    setShowYearMonthSelect(false);
  }, []);
  return jsxs(CalendarWrapper, {
    stack: true,
    children: [jsx(DateHeader, {
      label: "Today is",
      date: today
    }), jsxs(CalendarContainer$1, {
      children: [jsx(DateNavigation, {
        date: displayDate,
        onChange: date => setDisplayDate(date),
        onOpen: () => setShowYearMonthSelect(true),
        open: showYearMonthSelect
      }), jsx(StyledDatePicker, {
        firstDayOfWeek: firstDayOfWeek,
        initialMonth: today,
        month: displayDate,
        modifiers: ranges,
        renderDay: (date, dayModifiers) => {
          const modifiersKeys = Object.keys(dayModifiers !== null && dayModifiers !== void 0 ? dayModifiers : {});
          const colors = Object.values(modifiersKeys.map(modifier => rangeLegendMap[modifier]).filter(Boolean).reduce((acc, color) => {
            acc[color.type] = color;
            return acc;
          }, {}));
          return jsxs(DateCell, {
            className: "custom-date-cell",
            children: [jsx(DateCellBackground, {
              colors: colors,
              slices: colors.length
            }), jsx(DateCellText, {
              colors: colors,
              slices: colors.length,
              children: date.getDate()
            })]
          });
        }
      }), showYearMonthSelect ? jsx(YearMonthSelect, {
        displayDate: displayDate,
        onChange: handleYearMonthChange,
        onClose: handleCloseYearMonthSelect
      }) : null]
    }), jsx(Legend, {
      gap: 16,
      pb: 16,
      pr: 12,
      pl: 12,
      hAlign: "center",
      children: Object.values(legend).map((legendItem, index) => {
        return jsxs(Layout, {
          gap: "--Spacing-50",
          vAlign: "center",
          children: [jsx(Dot$1, {
            styles: legendItem.styles
          }), jsx(Typography, {
            variant: "label",
            size: "small",
            children: legendItem.label
          })]
        }, index);
      })
    })]
  });
}
const StyledRadio = /*#__PURE__*/styled(Radio$1).withConfig({
  displayName: "radio__StyledRadio",
  componentId: "sc-15qeq6r-0"
})(["&.MuiRadio-root{color:", ";padding:8px;&:hover{color:", ";background-color:", ";}&.Mui-focusVisible{color:", ";background-color:", ";}.MuiTouchRipple-root{color:", ";}&.Mui-disabled{opacity:0.38;}&.Mui-checked{color:", ";&:hover{color:", ";background-color:", ";}&.Mui-focusVisible{color:", ";background-color:", ";}.MuiTouchRipple-root{color:", ";}&.Mui-disabled{color:", ";opacity:0.38;}}}"], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.08'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color['state-layers'].light.primary['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
const StyledLabel = /*#__PURE__*/styled(FormControlLabel).withConfig({
  displayName: "radio__StyledLabel",
  componentId: "sc-15qeq6r-1"
})(["&.MuiFormControlLabel-root{margin:0;}"]);
const defaultLabelTypographyProps = {
  size: 'medium',
  variant: 'body',
  prominent: false
};
function Radio(props) {
  const {
    label,
    checked,
    dataCy,
    onChange,
    onClick,
    value,
    name,
    disabled,
    className,
    labelTypographyProps = defaultLabelTypographyProps
  } = props;
  const handleClick = useCallback(event => {
    onClick === null || onClick === void 0 ? void 0 : onClick(event, value);
  }, [onClick, value]);
  const inputProps = useMemo(() => {
    return {
      'data-cy': dataCy ? "".concat(dataCy) : undefined
    };
  }, [dataCy]);
  const control = jsx(StyledRadio, {
    inputProps: inputProps,
    checked: checked,
    onChange: onChange,
    onClick: handleClick,
    name: name,
    value: value,
    disabled: disabled,
    size: "small"
  });
  return jsx(StyledLabel, {
    className: className,
    label: label && typeof label === 'object' ? label : label ? jsx(Typography, {
      variant: labelTypographyProps.variant,
      size: labelTypographyProps.size,
      prominent: labelTypographyProps.prominent,
      tagName: "span",
      children: label
    }) : null,
    control: control
  });
}
const RadioReduxFormWrapper = props => {
  const {
    label,
    dataCy,
    disabled,
    input
  } = props;
  const handleChange = useCallback(event => {
    input.onChange(event);
  }, [input]);
  return jsx(Radio, {
    value: input.value,
    label: label,
    checked: input.checked,
    onChange: handleChange,
    disabled: disabled,
    name: input.name,
    dataCy: dataCy
  });
};
const RadioFormikWrapper = props => {
  const {
    value,
    name,
    label,
    dataCy,
    disabled,
    onClick
  } = props;
  const [field] = useField(name);
  const handleClick = useCallback(event => {
    field.onChange(event);
    onClick === null || onClick === void 0 ? void 0 : onClick(event, value);
  }, [field, onClick, value]);
  return jsx(Radio, {
    value: value,
    label: label,
    checked: field.value === value,
    onClick: handleClick,
    disabled: disabled,
    name: name,
    dataCy: dataCy
  });
};
const StyledMUIRadioGroup = /*#__PURE__*/styled(MUIRadioGroup).withConfig({
  displayName: "radio-group__StyledMUIRadioGroup",
  componentId: "sc-1a3vcb-0"
})(["&.MuiFormGroup-root{flex-direction:", ";gap:", ";}"], props => props.stack ? 'column' : 'row', props => props.stack ? 0 : '16px');
const StyledRow$2 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "radio-group__StyledRow",
  componentId: "sc-1a3vcb-1"
})(["min-height:", ";"], props => props.columnRow ? "".concat(props.rowHeight, "px") : 'auto');
function RadioGroup(props) {
  const {
    disabled,
    name,
    value,
    onChange,
    options,
    optionValue,
    optionLabel,
    stack = false,
    labelTypographyProps,
    rowHeight = 48
  } = props;
  const getOptionLabel = useCallback(item => {
    if (typeof optionLabel === 'function') {
      return optionLabel(item);
    }
    return "".concat(item[optionLabel]);
  }, [optionLabel]);
  const handleChange = useCallback(event => {
    onChange(event.target.value);
  }, [onChange]);
  return jsx(StyledMUIRadioGroup, {
    stack: stack,
    name: name,
    value: value,
    onChange: handleChange,
    children: options.map((option, index) => {
      const radioValue = option[optionValue];
      const additionalContent = option.additionalContent;
      const dataCy = 'dataCy' in option && option.dataCy && typeof option.dataCy === 'string' ? option.dataCy : "".concat(name, "-radio-option-").concat(radioValue);
      const checked = radioValue === value;
      const RadioJSX = jsx(Radio, {
        disabled: disabled,
        value: radioValue,
        checked: checked,
        label: getOptionLabel(option),
        dataCy: dataCy,
        labelTypographyProps: labelTypographyProps
      });
      return jsx(StyledRow$2, {
        vAlign: "center",
        hAlign: "flex-start",
        columnRow: stack,
        rowHeight: rowHeight,
        children: checked && additionalContent ? jsxs(Layout, {
          stack: true,
          children: [RadioJSX, additionalContent]
        }) : RadioJSX
      }, index);
    })
  });
}
function RadioGroupFormikWrapper(props) {
  const [field,, helpers] = useField(props.name);
  const {
    setValue
  } = helpers;
  const {
    options,
    optionValue,
    optionLabel,
    stack,
    name,
    rowHeight
  } = props;
  const handleChange = useCallback(value => {
    return setValue(value);
  }, [setValue]);
  return jsx(RadioGroup, {
    name: name,
    stack: stack,
    options: options,
    optionLabel: optionLabel,
    optionValue: optionValue,
    value: field.value,
    onChange: handleChange,
    rowHeight: rowHeight
  });
}
function RadioGroupReduxFormWrapper(props) {
  const {
    stack,
    options,
    optionValue,
    optionLabel,
    input,
    rowHeight
  } = props;
  const handleChange = useCallback(value => {
    input.onChange(value);
  }, [input]);
  return jsx(RadioGroup, {
    stack: stack,
    name: input.name,
    value: input.value,
    options: options,
    optionLabel: optionLabel,
    optionValue: optionValue,
    onChange: handleChange,
    rowHeight: rowHeight
  });
}
var $$h = _export;
var $includes = arrayIncludes.includes;
var fails$6 = fails$q;
var addToUnscopables$1 = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$6(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$h({
  target: 'Array',
  proto: true,
  forced: BROKEN_ON_SPARSE
}, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');
var $$g = _export;
var iterate$4 = iterate$7;
var aCallable$7 = aCallable$i;
var anObject$6 = anObject$n;
var getIteratorDirect$4 = getIteratorDirect$9;

// `Iterator.prototype.find` method
// https://github.com/tc39/proposal-iterator-helpers
$$g({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  find: function find(predicate) {
    anObject$6(this);
    aCallable$7(predicate);
    var record = getIteratorDirect$4(this);
    var counter = 0;
    return iterate$4(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).result;
  }
});
const CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS = ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'FIFTH', 'LAST'];
const CUSTOM_MONTH_OCCURRENCE_DAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
const repeatOnCustomDatesDay = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY', 'DAY', 'WEEKDAY', 'WEEKEND_DAY'];
const isRepeatOnCustomDatesDay = val => {
  if (!val || typeof val !== 'string') {
    return false;
  }
  return repeatOnCustomDatesDay.includes(val);
};
const ordinalIdentifierOptions = CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS.map(identifier => {
  return {
    value: identifier,
    label: identifier[0].toUpperCase() + identifier.slice(1).toLowerCase()
  };
});
const getRepeatOnCustomDayMonthOptions = () => {
  const mondayDate = setDayOfWeek(new Date(), 1);
  return [...new Array(7).fill(0).map((val, index) => {
    return {
      label: formatDate(addDays(mondayDate, index), DATE_FORMATS.DAY_SHORT),
      labelLong: formatDate(addDays(mondayDate, index), DATE_FORMATS.DAY_LONG),
      value: CUSTOM_MONTH_OCCURRENCE_DAYS[index]
    };
  }), {
    label: 'Day',
    labelLong: 'Day',
    value: 'DAY'
  }, {
    label: 'Weekday',
    labelLong: 'Weekday',
    value: 'WEEKDAY'
  }, {
    label: 'Weekend day',
    labelLong: 'Weekend day',
    value: 'WEEKEND_DAY'
  }];
};
const formatCustomMonthDayOrdinalIdentifiers = identifier => {
  if (identifier === 'LAST') {
    return 'last';
  }
  const index = CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS.findIndex(item => item === identifier);
  if (!Number.isInteger(index)) {
    return '';
  }
  return formatOrdinals(index + 1);
};
const formatCustomMonthDay = value => {
  const options = getRepeatOnCustomDayMonthOptions();
  const option = options.find(option => option.value === value);
  if (!option) {
    return '';
  }
  return option.labelLong;
};
const StyledLayout$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "custom-month-dates-select__StyledLayout",
  componentId: "sc-4p88na-0"
})(["border-radius:28px;background-color:", ";"], COMPONENT_LEVEL_BACKGROUND_COLOR['high']);
function CustomMonthDatesSelect(props) {
  const {
    value,
    className,
    onChange
  } = props;
  const customMonthDayOptions = useMemo(() => {
    return getRepeatOnCustomDayMonthOptions();
  }, []);
  const handleOrdinalIdentifierChange = useCallback(val => {
    onChange(Object.assign(Object.assign({}, value), {
      ordinalIdentifier: val
    }));
  }, [onChange, value]);
  const handleDayChange = useCallback(val => {
    if (!isRepeatOnCustomDatesDay(val)) {
      return;
    }
    onChange(Object.assign(Object.assign({}, value), {
      day: val
    }));
  }, [onChange, value]);
  return jsxs(StyledLayout$1, {
    className: className,
    gap: 24,
    pt: 24,
    pb: 24,
    pr: 24,
    pl: 24,
    children: [jsx(RadioGroup, {
      stack: true,
      name: "custom-month-oridinal-identifier-group",
      value: value.ordinalIdentifier,
      options: ordinalIdentifierOptions,
      optionLabel: "label",
      optionValue: "value",
      onChange: handleOrdinalIdentifierChange
    }), jsx(RadioGroup, {
      stack: true,
      name: "custom-month-day-group",
      value: value.day,
      options: customMonthDayOptions,
      optionLabel: "label",
      optionValue: "value",
      onChange: handleDayChange
    })]
  });
}
const StyledCustomMonthDaysSelectDialog = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "custom-month-dates-select-dialog__StyledCustomMonthDaysSelectDialog",
  componentId: "unc353-0"
})([".MuiPaper-root{width:315px;}"]);
const StyledCustomMonthDatesSelect = /*#__PURE__*/styled(CustomMonthDatesSelect).withConfig({
  displayName: "custom-month-dates-select-dialog__StyledCustomMonthDatesSelect",
  componentId: "unc353-1"
})(["margin:-24px -24px 0 -24px;"]);
function CustomMonthDatesSelectDialog(props) {
  const {
    open,
    anchorElement,
    value,
    onSelect,
    onClose
  } = props;
  const [state, setState] = useState(() => {
    return {
      ordinalIdentifier: value.ordinalIdentifier,
      day: value.day
    };
  });
  const handleSelect = useCallback(() => {
    onSelect(state);
  }, [onSelect, state]);
  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);
  const selectBtnDisable = !state.day || !state.ordinalIdentifier;
  const titleJSX = undefined;
  const contentJSX = jsx(StyledCustomMonthDatesSelect, {
    value: state,
    onChange: setState
  });
  const actionsJSX = jsxs(Layout, {
    gap: 8,
    hAlign: "flex-end",
    children: [jsx(Button, {
      variant: "text",
      onClick: handleCancel,
      children: "Cancel"
    }), jsx(Button, {
      variant: "text",
      onClick: handleSelect,
      disabled: selectBtnDisable,
      children: "OK"
    })]
  });
  return jsx(StyledCustomMonthDaysSelectDialog, {
    open: open,
    anchorElement: anchorElement,
    onClose: onClose,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX
  });
}
var getBuiltIn$4 = getBuiltIn$8;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var wellKnownSymbol$6 = wellKnownSymbol$l;
var DESCRIPTORS$2 = descriptors;
var SPECIES$3 = wellKnownSymbol$6('species');
var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);
  if (DESCRIPTORS$2 && Constructor && !Constructor[SPECIES$3]) {
    defineBuiltInAccessor(Constructor, SPECIES$3, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  }
};
var uncurryThis$5 = functionUncurryThis;
var fails$5 = fails$q;
var isCallable$5 = isCallable$n;
var classof$2 = classof$7;
var getBuiltIn$3 = getBuiltIn$8;
var inspectSource$1 = inspectSource$3;
var noop = function () {/* empty */};
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$5(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};
var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  switch (classof$2(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction':
      return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};
isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$5(function () {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var isConstructor$1 = isConstructor$2;
var tryToString = tryToString$5;
var $TypeError$4 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$1(argument)) return argument;
  throw new $TypeError$4(tryToString(argument) + ' is not a constructor');
};
var anObject$5 = anObject$n;
var aConstructor = aConstructor$1;
var isNullOrUndefined = isNullOrUndefined$5;
var wellKnownSymbol$5 = wellKnownSymbol$l;
var SPECIES$2 = wellKnownSymbol$5('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$5(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject$5(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};
var $TypeError$3 = TypeError;
var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw new $TypeError$3('Not enough arguments');
  return passed;
};
var userAgent$2 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);
var global$9 = global$p;
var apply$1 = functionApply;
var bind$5 = functionBindContext;
var isCallable$4 = isCallable$n;
var hasOwn$1 = hasOwnProperty_1;
var fails$4 = fails$q;
var html = html$2;
var arraySlice = arraySlice$2;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;
var set = global$9.setImmediate;
var clear = global$9.clearImmediate;
var process$3 = global$9.process;
var Dispatch = global$9.Dispatch;
var Function$1 = global$9.Function;
var MessageChannel = global$9.MessageChannel;
var String$1 = global$9.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;
fails$4(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$9.location;
});
var run = function (id) {
  if (hasOwn$1(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};
var runner = function (id) {
  return function () {
    run(id);
  };
};
var eventListener = function (event) {
  run(event.data);
};
var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$9.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$4(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
    // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$5(port.postMessage, port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global$9.addEventListener && isCallable$4(global$9.postMessage) && !global$9.importScripts && $location && $location.protocol !== 'file:' && !fails$4(globalPostMessageDefer)) {
    defer = globalPostMessageDefer;
    global$9.addEventListener('message', eventListener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}
var task$1 = {
  set: set,
  clear: clear
};
var global$8 = global$p;
var DESCRIPTORS$1 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS$1) return global$8[name];
  var descriptor = getOwnPropertyDescriptor(global$8, name);
  return descriptor && descriptor.value;
};
var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};
Queue$2.prototype = {
  add: function (item) {
    var entry = {
      item: item,
      next: null
    };
    var tail = this.tail;
    if (tail) tail.next = entry;else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};
var queue$1 = Queue$2;
var userAgent$1 = engineUserAgent;
var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';
var userAgent = engineUserAgent;
var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);
var global$7 = global$p;
var safeGetBuiltIn = safeGetBuiltIn$1;
var bind$4 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;
var MutationObserver = global$7.MutationObserver || global$7.WebKitMutationObserver;
var document$2 = global$7.document;
var process$2 = global$7.process;
var Promise$1 = global$7.Promise;
var microtask$1 = safeGetBuiltIn('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();
  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$2.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, {
      characterData: true
    });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$4(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
    // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessage
    // - onreadystatechange
    // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$4(macrotask, global$7);
    notify$1 = function () {
      macrotask(flush);
    };
  }
  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}
var microtask_1 = microtask$1;
var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) {/* empty */}
};
var perform$3 = function (exec) {
  try {
    return {
      error: false,
      value: exec()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};
var global$6 = global$p;
var promiseNativeConstructor = global$6.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';
var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;
var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1 && typeof window == 'object' && typeof document == 'object';
var global$5 = global$p;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$3 = isCallable$n;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$4 = wellKnownSymbol$l;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;
NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$1 = wellKnownSymbol$4('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$3(global$5.PromiseRejectionEvent);
var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) {
      resolve(1);
    });
    var FakePromise = function (exec) {
      exec(function () {/* empty */}, function () {/* empty */});
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$1] = FakePromise;
    SUBCLASSING = promise.then(function () {/* empty */}) instanceof FakePromise;
    if (!SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  }
  return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});
var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};
var newPromiseCapability$2 = {};
var aCallable$6 = aCallable$i;
var $TypeError$2 = TypeError;
var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$2('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$6(resolve);
  this.reject = aCallable$6(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};
var $$f = _export;
var IS_NODE = engineIsNode;
var global$4 = global$p;
var call$4 = functionCall;
var defineBuiltIn$1 = defineBuiltIn$7;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$5 = aCallable$i;
var isCallable$2 = isCallable$n;
var isObject$5 = isObject$e;
var anInstance = anInstance$2;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;
var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$4.TypeError;
var document$1 = global$4.document;
var process$1 = global$4.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$4.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$5(it) && isCallable$2(then = it.then) ? then : false;
};
var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$4(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};
var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};
var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$4.dispatchEvent(event);
  } else event = {
    promise: promise,
    reason: reason
  };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$4['on' + name])) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};
var onUnhandled = function (state) {
  call$4(task, global$4, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};
var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function (state) {
  call$4(task, global$4, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};
var bind$3 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};
var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};
var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = {
          done: false
        };
        try {
          call$4(then, value, bind$3(internalResolve, wrapper, state), bind$3(internalReject, wrapper, state));
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({
      done: false
    }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$5(executor);
    call$4(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$3(internalResolve, state), bind$3(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$1(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$2(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process$1.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$3(internalResolve, state);
    this.reject = bind$3(internalReject, state);
  };
  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
  if (isCallable$2(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;
    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$1(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$4(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
      }, {
        unsafe: true
      });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) {/* empty */}

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$2) {
      setPrototypeOf$2(NativePromisePrototype$1, PromisePrototype);
    }
  }
}
$$f({
  global: true,
  constructor: true,
  wrap: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$4
}, {
  Promise: PromiseConstructor
});
setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);
var wellKnownSymbol$3 = wellKnownSymbol$l;
var ITERATOR$2 = wellKnownSymbol$3('iterator');
var SAFE_CLOSING = false;
try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return {
        done: !!called++
      };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {/* empty */}
var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) {
    return false;
  } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };
    exec(object);
  } catch (error) {/* empty */}
  return ITERATION_SUPPORT;
};
var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;
var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () {/* empty */});
});
var $$e = _export;
var call$3 = functionCall;
var aCallable$4 = aCallable$i;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$3 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$e({
  target: 'Promise',
  stat: true,
  forced: PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$4(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$3(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$3($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});
var $$d = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$2 = getBuiltIn$8;
var isCallable$1 = isCallable$n;
var defineBuiltIn = defineBuiltIn$7;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$d({
  target: 'Promise',
  proto: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$2,
  real: true
}, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$1(NativePromiseConstructor)) {
  var method = getBuiltIn$2('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, {
      unsafe: true
    });
  }
}
var $$c = _export;
var call$2 = functionCall;
var aCallable$3 = aCallable$i;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate$2 = iterate$7;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$c({
  target: 'Promise',
  stat: true,
  forced: PROMISE_STATICS_INCORRECT_ITERATION
}, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$3(C.resolve);
      iterate$2(iterable, function (promise) {
        call$2($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});
var $$b = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$b({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR$1
}, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});
var anObject$4 = anObject$n;
var isObject$4 = isObject$e;
var newPromiseCapability = newPromiseCapability$2;
var promiseResolve$1 = function (C, x) {
  anObject$4(C);
  if (isObject$4(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};
var $$a = _export;
var getBuiltIn$1 = getBuiltIn$8;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;
getBuiltIn$1('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$a({
  target: 'Promise',
  stat: true,
  forced: FORCED_PROMISE_CONSTRUCTOR
}, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});
const isRange = value => {
  if (!value || typeof value !== 'object') {
    return false;
  }
  return 'from' in value && isDate$2(value.from) && 'to' in value && isDate$2(value.to);
};
const isDate$1 = value => {
  if (!value) {
    return false;
  }
  if (Array.isArray(value)) {
    return false;
  }
  if (isRange(value)) {
    return false;
  }
  return isDate$2(value);
};
const StyledIconButton = /*#__PURE__*/styled(IconButton).withConfig({
  displayName: "date-picker-input__StyledIconButton",
  componentId: "sc-1g8g9zu-0"
})(["position:relative;left:8px;"]);
const StyledCalendarPopover = /*#__PURE__*/styled(Popover).withConfig({
  displayName: "date-picker-input__StyledCalendarPopover",
  componentId: "sc-1g8g9zu-1"
})([".MuiPaper-root{background-color:transparent;min-height:", "px;border-radius:28px;box-shadow:none;overflow:visible;}"], props => props.dense ? 515 : 545);
const DatePickerWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "date-picker-input__DatePickerWrapper",
  componentId: "sc-1g8g9zu-2"
})(["border-radius:28px;font-family:Poppins,'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-style:normal;background-color:", ";max-width:unset;box-shadow:", ";.DayPicker-Caption{display:none;}.DayPicker-NavBar{display:none;}.DayPicker-Weekday,.DayPicker-Day{height:", "px;width:", "px;padding:0;color:", ";&:hover{background-color:", ";}.custom-date-cell{position:relative;background-color:transparent;z-index:10;height:", "px;width:", "px;display:flex;justify-content:center;align-items:center;}", "}", ""], COMPONENT_LEVEL_BACKGROUND_COLOR['high'], props => props.standalone ? 'none' : props.theme.shadows[2], props => props.dense ? 40 : 48, props => props.dense ? 36 : 48, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, COMPONENT_LEVEL_BACKGROUND_COLOR['high'], props => props.dense ? 40 : 48, props => props.dense ? 36 : 48, typographyVariantStyles['body-large'], CommonDatePickerStyles);
const CalendarContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "date-picker-input__CalendarContainer",
  componentId: "sc-1g8g9zu-3"
})(["max-width:450px;margin:0 auto;position:relative;border-radius:28px;"]);
const inputLabelProps$2 = {
  shrink: true
};
const getDisplayMonthDate = value => {
  const today = new Date();
  if (!value) {
    return today;
  }
  if (isRange(value)) {
    return value.from;
  }
  if (isDate$1(value)) {
    return value;
  }
  return today;
};
function DatePickerInput(props) {
  const {
    dataCy,
    disabled,
    label,
    placeholder,
    helperText,
    error,
    onChange,
    onBlur,
    value,
    name,
    className,
    disabledDays,
    disablePastDays = false,
    variant = 'input',
    withHeader = true,
    dense = false,
    onOpen,
    clearable,
    withTailingIcon = true,
    initialMonthDate,
    required
  } = props;
  const {
    firstDayOfWeek
  } = useHubUIConfigContext();
  const {
    open,
    isOpen,
    close,
    anchorElement
  } = useOpenState();
  const [today] = useState(new Date());
  const [displayDate, setDisplayDate] = useState(getDisplayMonthDate(value || initialMonthDate));
  const [showYearMonthSelect, setShowYearMonthSelect] = useState(false);
  useEffect(() => {
    setDisplayDate(getDisplayMonthDate(value || initialMonthDate));
  }, [initialMonthDate, value]);
  const handleClose = useCallback(() => {
    close();
    setDisplayDate(getDisplayMonthDate(value));
  }, [close, value]);
  const InputProps = useMemo(() => {
    return {
      startAdornment: clearable && value ? getStartAdornment('today', 'on-surface-variant') : null,
      endAdornment: clearable && value ? jsx(InputAdornment, {
        position: "end",
        children: jsx(StyledIconButton, {
          icon: "cancel",
          onClick: event => {
            event.stopPropagation();
            onChange(null);
          }
        })
      }) : withTailingIcon ? getEndAdornment('today') : null,
      inputProps: {
        'data-cy': dataCy ? "".concat(dataCy, "-input") : undefined
      }
    };
  }, [clearable, value, dataCy, onChange, withTailingIcon]);
  const handleDateChange = useCallback((date, dayModifiers) => {
    if (dayModifiers.disabled) {
      return;
    }
    if (isDate$1(value) && isSameDay(date, value) && variant === 'input') {
      close();
    } else {
      onChange(date);
      close();
    }
  }, [close, onChange, value, variant]);
  const handleCloseYearMonthSelect = useCallback(() => {
    setShowYearMonthSelect(false);
  }, []);
  const handleYearMonthChange = useCallback(date => {
    setDisplayDate(date);
    setShowYearMonthSelect(false);
  }, []);
  const disableDaysInner = useMemo(() => {
    if (disabledDays) {
      return disabledDays;
    }
    if (disablePastDays) {
      return date => {
        return isBefore(date, today, 'day');
      };
    }
    return undefined;
  }, [disablePastDays, disabledDays, today]);
  const monthDate = useMemo(() => {
    return isDate$1(displayDate) ? displayDate : toDate(displayDate);
  }, [displayDate]);
  const modifiers = useMemo(() => {
    return isRange(value) ? {
      range: value,
      from: value.from,
      to: value.to
    } : undefined;
  }, [value]);
  const datePickerValue = useMemo(() => {
    if (isRange(value)) {
      return value;
    } else if (isDate$1(value)) {
      return value;
    }
    return undefined;
  }, [value]);
  const DatePicker = jsxs(DatePickerWrapper, {
    stack: true,
    dense: dense,
    standalone: variant === 'standalone',
    className: "hub-ui__date-picker",
    children: [withHeader ? jsx(DateHeader, {
      label: "Select date",
      date: isDate$1(value) ? value : today
    }) : null, jsxs(CalendarContainer, {
      children: [jsx(DateNavigation, {
        date: displayDate,
        onChange: date => setDisplayDate(date),
        onOpen: () => setShowYearMonthSelect(true),
        open: showYearMonthSelect
      }), jsx(ReactDatePicker, {
        firstDayOfWeek: firstDayOfWeek,
        month: monthDate,
        modifiers: modifiers,
        selectedDays: datePickerValue,
        onDayClick: handleDateChange,
        disabledDays: disableDaysInner,
        weekdayElement: jsx(Weekday, {
          dense: dense
        }),
        renderDay: (date, modifiers) => {
          let dateCellDataCy;
          if (dataCy) {
            dateCellDataCy = "".concat(dataCy, "-selection-[").concat(formatDate(date, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT), "]");
          } else {
            dateCellDataCy = "[".concat(formatDate(date, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT), "]");
          }
          return jsx("div", {
            className: "custom-date-cell",
            "data-cy": dateCellDataCy,
            children: date.getDate()
          });
        }
      }), showYearMonthSelect ? jsx(YearMonthSelect, {
        displayDate: displayDate,
        onChange: handleYearMonthChange,
        onClose: handleCloseYearMonthSelect,
        dense: dense
      }) : null]
    })]
  });
  const handleInputClick = useCallback(event => {
    if (disabled) {
      return;
    }
    open(event);
    onOpen === null || onOpen === void 0 ? void 0 : onOpen(event);
  }, [disabled, open, onOpen]);
  const displayInputValue = useMemo(() => {
    return isDate$1(value) ? formatDate(value) : '';
  }, [value]);
  const Input = jsx(StyledInput$1, {
    fullWidth: true,
    error: error,
    variant: "outlined",
    type: "text",
    label: label,
    helperText: helperText,
    placeholder: placeholder,
    name: name,
    className: className,
    "data-cy": dataCy,
    disabled: disabled,
    value: displayInputValue,
    InputProps: InputProps,
    InputLabelProps: inputLabelProps$2,
    onBlur: onBlur,
    onClick: handleInputClick,
    required: required
  });
  if (variant === 'standalone') {
    return DatePicker;
  }
  return jsxs(Fragment, {
    children: [Input, jsx(StyledCalendarPopover, {
      "data-in-portal": "true",
      dense: dense,
      open: isOpen,
      anchorEl: anchorElement,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      PaperProps: {
        elevation: 2
      },
      children: DatePicker
    })]
  });
}
const DatePickerInputFormikWrapper = props => {
  const {
    dense,
    withHeader,
    name,
    className,
    disabledDays,
    disabled,
    label,
    placeholder,
    helperText,
    dataCy,
    onChange,
    variant,
    onOpen,
    clearable,
    withTailingIcon,
    initialMonthDate,
    required
  } = props;
  const [field, meta, helpers] = useField(name);
  const {
    setValue,
    setTouched
  } = helpers;
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  const handleChange = useCallback(date => {
    Promise.all([setValue(date, true), setTouched(true, false)]).then(() => {
      if (onChange) {
        onChange(date);
      }
    });
  }, [onChange, setTouched, setValue]);
  const handleBlur = useCallback(() => {
    setTouched(true);
  }, [setTouched]);
  return jsx(DatePickerInput, {
    withTailingIcon: withTailingIcon,
    withHeader: withHeader,
    dense: dense,
    variant: variant,
    value: field.value,
    onBlur: handleBlur,
    onChange: handleChange,
    name: name,
    className: className,
    dataCy: dataCy,
    label: label,
    disabled: disabled,
    error: hasErrors,
    placeholder: placeholder,
    helperText: errorMsg || helperText,
    disabledDays: disabledDays,
    onOpen: onOpen,
    clearable: clearable,
    initialMonthDate: initialMonthDate,
    required: required
  });
};
const DatePickerReduxFormWrapper = props => {
  const {
    variant,
    meta,
    input,
    className,
    name,
    dataCy,
    disabled,
    label,
    placeholder,
    helperText,
    disabledDays,
    onOpen,
    clearable,
    withHeader,
    withTailingIcon,
    initialMonthDate,
    required
  } = props;
  const hasErrors = Boolean(meta.error);
  const errorMsg = Array.isArray(meta.error) ? meta.error[0] : meta.error;
  const handleChange = useCallback(date => {
    input.onChange(date);
  }, [input]);
  return jsx(DatePickerInput, {
    variant: variant,
    value: input.value,
    onChange: handleChange,
    onBlur: input.onBlur,
    name: input.name || name,
    className: className,
    dataCy: dataCy,
    label: label,
    disabled: disabled,
    placeholder: placeholder,
    error: meta.touched && hasErrors,
    helperText: meta.touched && errorMsg || helperText,
    disabledDays: disabledDays,
    onOpen: onOpen,
    clearable: clearable,
    withTailingIcon: withTailingIcon,
    withHeader: withHeader,
    initialMonthDate: initialMonthDate,
    required: required
  });
};
const Weekday = props => {
  const {
    className,
    localeUtils,
    locale,
    weekday,
    dense
  } = props;
  if (!localeUtils || weekday === undefined) {
    return null;
  }
  const weekdayName = localeUtils.formatWeekdayShort(weekday, locale);
  return jsx("div", {
    className: className,
    title: weekdayName,
    children: dense ? weekdayName[0] : weekdayName
  });
};

// a string of all valid unicode whitespaces
var whitespaces$4 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';
var uncurryThis$4 = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var toString$5 = toString$a;
var whitespaces$3 = whitespaces$4;
var replace$1 = uncurryThis$4(''.replace);
var ltrim = RegExp('^[' + whitespaces$3 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$3 + '])[' + whitespaces$3 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$5(requireObjectCoercible$1($this));
    if (TYPE & 1) string = replace$1(string, ltrim, '');
    if (TYPE & 2) string = replace$1(string, rtrim, '$1');
    return string;
  };
};
var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};
var global$3 = global$p;
var fails$3 = fails$q;
var uncurryThis$3 = functionUncurryThis;
var toString$4 = toString$a;
var trim$1 = stringTrim.trim;
var whitespaces$2 = whitespaces$4;
var $parseInt = global$3.parseInt;
var Symbol$2 = global$3.Symbol;
var ITERATOR$1 = Symbol$2 && Symbol$2.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis$3(hex.exec);
var FORCED$2 = $parseInt(whitespaces$2 + '08') !== 8 || $parseInt(whitespaces$2 + '0x16') !== 22
// MS Edge 18- broken with boxed symbols
|| ITERATOR$1 && !fails$3(function () {
  $parseInt(Object(ITERATOR$1));
});

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$2 ? function parseInt(string, radix) {
  var S = trim$1(toString$4(string));
  return $parseInt(S, radix >>> 0 || (exec(hex, S) ? 16 : 10));
} : $parseInt;
var $$9 = _export;
var parseInt$1 = numberParseInt;

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$$9({
  target: 'Number',
  stat: true,
  forced: Number.parseInt !== parseInt$1
}, {
  parseInt: parseInt$1
});
const days = new Array(31).fill(0).map((val, i) => i + 1);
const StyledLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "days-of-month-select__StyledLayout",
  componentId: "sc-1d92o1o-0"
})(["border-radius:28px;background-color:", ";"], COMPONENT_LEVEL_BACKGROUND_COLOR['high']);
const DayChip = /*#__PURE__*/styled.div.withConfig({
  displayName: "days-of-month-select__DayChip",
  componentId: "sc-1d92o1o-1"
})(["height:", ";width:", ";display:inline-flex;justify-content:center;align-items:center;cursor:pointer;"], props => props.dense ? '40px' : '48px', props => props.dense ? '40px' : '48px');
const DayTypography = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "days-of-month-select__DayTypography",
  componentId: "sc-1d92o1o-2"
})(["height:40px;width:40px;display:flex;justify-content:center;border-radius:100px;align-items:center;position:relative;", ""], props => {
  return getChipCommonStyles({
    selected: props.selected
  });
});
function DaysOfMonthSelect(props) {
  const {
    selected = [],
    onChange,
    className,
    dense = false
  } = props;
  const selectedMap = useMemo(() => {
    return (selected || []).reduce((acc, selectedDay) => {
      acc[selectedDay] = true;
      return acc;
    }, {});
  }, [selected]);
  const handleDayClick = day => {
    const newDayState = !selectedMap[day];
    const newSelected = Object.assign(Object.assign({}, selectedMap), {
      [day]: newDayState
    });
    const newValue = Object.keys(newSelected).filter(key => newSelected[Number.parseInt(key)]).map(val => Number.parseInt(val));
    onChange(newValue);
  };
  return jsxs(StyledLayout, {
    stack: true,
    className: className,
    children: [jsx(Layout, {
      pt: 16,
      pb: 12,
      pl: 24,
      pr: 12,
      children: jsx(Typography, {
        variant: "label",
        size: "large",
        color: "on-surface-variant",
        children: "Select date/s"
      })
    }), jsx(Divider, {}), jsxs(Layout, {
      wrap: true,
      pt: 16,
      pb: 12,
      pl: 24,
      pr: 12,
      gap: dense ? 2 : 0,
      children: [jsx(DayChip, {
        dense: dense
      }), jsx(DayChip, {
        dense: dense
      }), days.map(day => {
        const isSelected = selectedMap[day];
        return jsx(DayChip, {
          dense: dense,
          "data-role": "button",
          "data-cy": "days-month-select-".concat(day),
          onClick: () => {
            handleDayClick(day);
          },
          children: jsx(DayTypography, {
            selected: isSelected,
            color: isSelected ? 'on-primary' : undefined,
            children: day
          })
        }, day);
      })]
    })]
  });
}
const StyledDialog$3 = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "days-of-month-select-dialog__StyledDialog",
  componentId: "a21kch-0"
})([".MuiPaper-root{width:384px;}"]);
const StyledDaysOfMonthSelect = /*#__PURE__*/styled(DaysOfMonthSelect).withConfig({
  displayName: "days-of-month-select-dialog__StyledDaysOfMonthSelect",
  componentId: "a21kch-1"
})(["margin:-24px -24px 0 -24px;width:calc(100% + 48px);max-width:unset;"]);
function DaysOfMonthSelectDialog(props) {
  const {
    selected = [],
    open,
    anchorElement,
    onClose,
    onSelect
  } = props;
  const [state, setState] = useState(selected);
  useEffect(() => {
    setState(selected);
  }, [selected]);
  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);
  const handleSelect = useCallback(() => {
    onSelect(state);
  }, [onSelect, state]);
  const handleDaysChange = useCallback(days => {
    setState(days);
  }, []);
  const titleJSX = undefined;
  const contentJSX = jsx(StyledDaysOfMonthSelect, {
    selected: state,
    onChange: handleDaysChange
  });
  const actionsJSX = jsxs(Layout, {
    gap: 8,
    hAlign: "flex-end",
    children: [jsx(Button, {
      variant: "text",
      onClick: handleCancel,
      children: "Cancel"
    }), jsx(Button, {
      variant: "text",
      onClick: handleSelect,
      children: "OK"
    })]
  });
  return jsx(StyledDialog$3, {
    open: open,
    anchorElement: anchorElement,
    onClose: onClose,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX
  });
}
var $$8 = _export;
var anObject$3 = anObject$n;
var iterate$1 = iterate$7;
var getIteratorDirect$3 = getIteratorDirect$9;
var push = [].push;

// `Iterator.prototype.toArray` method
// https://github.com/tc39/proposal-iterator-helpers
$$8({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  toArray: function toArray() {
    var result = [];
    iterate$1(getIteratorDirect$3(anObject$3(this)), push, {
      that: result,
      IS_RECORD: true
    });
    return result;
  }
});
function useKeyDown(keyActions) {
  useEffect(() => {
    const handleKeyDown = event => {
      var _a;
      if (keyActions[event.key]) {
        (_a = keyActions[event.key]) === null || _a === void 0 ? void 0 : _a.call(keyActions, event);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [keyActions]);
}
const LIST_BOX_DEFAULT_HEIGHT = 380;
const ListBox = /*#__PURE__*/styled.div.withConfig({
  displayName: "ListBoxComponent__ListBox",
  componentId: "fby6ui-0"
})(["overflow:hidden;"]);
const Scrollable = /*#__PURE__*/styled.div.withConfig({
  displayName: "ListBoxComponent__Scrollable",
  componentId: "fby6ui-1"
})(["max-height:calc(", "px - ", "px);overflow:auto;"], LIST_BOX_DEFAULT_HEIGHT, props => props.staticItemsCount * 40);
const StaticOptionContainer = /*#__PURE__*/styled(ListItem$1).withConfig({
  displayName: "ListBoxComponent__StaticOptionContainer",
  componentId: "fby6ui-2"
})(["&.MuiListItem-root{width:100%;height:40px;padding:", "px 12px;li{width:100%;}&[data-focus='true'],&[aria-selected='true'],&:hover{background-color:", ";}}"], props => props.theme.designSpacing['--Spacing-100'], props => props.theme.designTokens.color.color.surfaces['surface-container-highest'].value);
const ListBoxComponent = /*#__PURE__*/React__default.forwardRef((props, ref) => {
  const {
      children,
      staticOptions = []
    } = props,
    rest = __rest(props, ["children", "staticOptions"]);
  const handleScrollableElemRef = useCallback(scrollableRef => {
    if (scrollableRef) {
      const selectedOption = scrollableRef.querySelector('[aria-selected="true"]');
      if (selectedOption) {
        selectedOption.scrollIntoView({
          behavior: 'instant',
          block: 'center'
        });
      }
    }
  }, []);
  const childrenCount = useMemo(() => {
    if (children) {
      return Children.toArray(children).length;
    }
    return 0;
  }, [children]);
  const staticItemsCount = staticOptions.length;
  const keyboardAction = useMemo(() => {
    const scroll = () => {
      const focusedElem = document.querySelector('[role="option"][data-focus="true"]');
      const scrollableElem = document.querySelector('[data-scrollable]');
      scrollIntoView(focusedElem, scrollableElem);
    };
    return {
      ArrowUp: event => {
        scroll();
      },
      ArrowDown: event => {
        scroll();
      }
    };
  }, []);
  useKeyDown(keyboardAction);
  return jsx(ListBox, {
    children: jsxs(List$2, Object.assign({
      ref: ref
    }, rest, {
      children: [jsx(Scrollable, {
        ref: handleScrollableElemRef,
        "data-scrollable": true,
        staticItemsCount: staticItemsCount,
        children: children
      }), staticItemsCount > 0 && childrenCount >= 1 ? jsx(Divider, {}) : null, staticOptions.map((option, index) => {
        return jsx(StaticOptionContainer, {
          button: true,
          tabIndex: -1,
          "data-option-index": childrenCount + index,
          "data-cy": option.dataCy,
          onClick: option.onClick,
          children: option.label
        }, index);
      })]
    }))
  });
});
const StyledSelect = /*#__PURE__*/styled(Autocomplete).withConfig({
  displayName: "select__StyledSelect",
  componentId: "sc-1blfte2-0"
})(["&.MuiAutocomplete-root{.MuiAutocomplete-endAdornment{top:calc(50% - 16px);}", "}"], props => {
  if (props.multiple) {
    return css([".MuiInputBase-root{padding-top:12px;padding-bottom:4px;textarea.MuiOutlinedInput-input{padding-top:16px;padding-bottom:6px;}}.MuiOutlinedInput-input{margin-top:-16px;}"]);
  } else {
    return css([".MuiOutlinedInput-input{margin-top:-9.5px;}"]);
  }
});
const commonPopperStyles = /*#__PURE__*/css(["&.MuiAutocomplete-popper{.MuiAutocomplete-paper{border-radius:4px;background-color:", ";box-shadow:", ";}.MuiAutocomplete-listbox{padding:0;max-height:", "px;}.MuiAutocomplete-groupLabel{background-color:", ";border-bottom:1px solid ", ";}.MuiAutocomplete-option{padding:0;min-height:0;div{min-height:40px;width:100%;padding:", "px 12px;}&[data-focus='true'],&[aria-selected='true']{background-color:", " !important;}&:hover{background-color:", " !important;}.option{height:100%;}}}"], props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value, props => props.theme.shadows[2], LIST_BOX_DEFAULT_HEIGHT + 1, COMPONENT_LEVEL_BACKGROUND_COLOR['high'], props => props.theme.designTokens.color.color.light['outline-variant'].value, props => props.theme.designSpacing['--Spacing-100'], props => props.theme.designTokens.color.color.surfaces['surface-container-highest'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value);
const StyledDividerWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "select__StyledDividerWrapper",
  componentId: "sc-1blfte2-1"
})(["min-height:unset !important;cursor:unset;pointer-events:none;padding-left:0 !important;padding-right:0 !important;"]);
const StyledDivider = /*#__PURE__*/styled(Divider).withConfig({
  displayName: "select__StyledDivider",
  componentId: "sc-1blfte2-2"
})(["min-height:unset !important;padding:0 !important;"]);
const StyledTypography = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "select__StyledTypography",
  componentId: "sc-1blfte2-3"
})(["display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;-webkit-line-clamp:3;"]);
const DefaultPopper = /*#__PURE__*/styled(Popper).withConfig({
  displayName: "select__DefaultPopper",
  componentId: "sc-1blfte2-4"
})(["", " &.MuiAutocomplete-popper{", ";.MuiAutocomplete-paper{background-color:", ";}.MuiAutocomplete-option{&[data-focus='true'],&[aria-selected='true'],&:hover{background-color:", ";}}}"], commonPopperStyles, props => props.popperWidth && "width: ".concat(props.popperWidth, "px !important"), COMPONENT_LEVEL_BACKGROUND_COLOR['default'], COMPONENT_LEVEL_ON_BACKGROUND_COLOR['default']);
const HighPopper = /*#__PURE__*/styled(Popper).withConfig({
  displayName: "select__HighPopper",
  componentId: "sc-1blfte2-5"
})(["", " &.MuiAutocomplete-popper{", ";.MuiAutocomplete-paper{background-color:", ";}.MuiAutocomplete-option{&[data-focus='true'],&[aria-selected='true'],&:hover{background-color:", ";}}}"], commonPopperStyles, props => props.popperWidth && "width: ".concat(props.popperWidth, "px !important"), props => {
  return COMPONENT_LEVEL_BACKGROUND_COLOR['high'];
}, COMPONENT_LEVEL_BACKGROUND_COLOR['high']);
const HighestPopper = /*#__PURE__*/styled(Popper).withConfig({
  displayName: "select__HighestPopper",
  componentId: "sc-1blfte2-6"
})(["", " &.MuiAutocomplete-popper{", ";.MuiAutocomplete-paper{background-color:", ";}.MuiAutocomplete-option{&[data-focus='true'],&[aria-selected='true'],&:hover{background-color:", ";}}}"], commonPopperStyles, props => props.popperWidth && "width: ".concat(props.popperWidth, "px !important"), COMPONENT_LEVEL_BACKGROUND_COLOR['highest'], COMPONENT_LEVEL_ON_BACKGROUND_COLOR['highest']);
const StyledChip = /*#__PURE__*/styled(Chip).withConfig({
  displayName: "select__StyledChip",
  componentId: "sc-1blfte2-7"
})(["&.MuiChip-root{height:26px;position:relative;top:-4px;}"]);
const AdornmentCenterContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "select__AdornmentCenterContainer",
  componentId: "sc-1blfte2-8"
})(["margin-top:auto;margin-bottom:auto;transform:translateY(-4.5px);"]);
const inputLabelProps$1 = {
  shrink: true
};
function Select(props) {
  const {
    name,
    options,
    optionLabel,
    optionValue,
    label,
    value,
    onChange,
    disableClearable,
    dataCy,
    placeholder,
    staticOptions,
    multiple,
    fixedOptions,
    className,
    error,
    helperText,
    level = 'high',
    onBlur,
    StartAdornment,
    labelRenderer,
    groupBy,
    disabled,
    required,
    isOpen,
    onClose,
    onOpen,
    disableCloseOnSelect,
    popperWidth,
    customFilterOptions
  } = props;
  const isControlled = isOpen !== undefined && onClose !== undefined && onOpen !== undefined;
  const [open, setOpen] = useState(false);
  const handleChange = (event, newValue) => {
    const closeDropdown = () => {
      if (disableCloseOnSelect) {
        return false;
      }
      isControlled ? onClose === null || onClose === void 0 ? void 0 : onClose() : setOpen(false);
    };
    if (multiple) {
      if (!Array.isArray(newValue)) {
        onChange(event, []);
      } else {
        onChange(event, newValue);
      }
    } else {
      if (Array.isArray(newValue)) {
        // type check
        closeDropdown();
        onChange(event, null);
      } else if (!newValue || typeof newValue === 'string') {
        closeDropdown();
        onChange(event, null);
      } else {
        closeDropdown();
        onChange(event, newValue);
      }
    }
  };
  const getOptionLabel = useCallback(item => {
    if (!item) {
      return '';
    }
    if (typeof optionLabel === 'function') {
      return optionLabel(item);
    }
    return item[optionLabel] ? "".concat(item[optionLabel]) : '';
  }, [optionLabel]);
  const filterOptions = useCallback((options, state) => {
    if (customFilterOptions) {
      return customFilterOptions(options, state);
    }
    return options.filter(option => {
      const label = state.getOptionLabel(option);
      return searchStringCompare(label, state.inputValue);
    });
  }, [customFilterOptions]);
  const renderOption = useCallback((optionProps, option) => {
    if (optionProps.divider) {
      return jsx(StyledDividerWrapper, {
        children: jsx(StyledDivider, {})
      });
    }
    if (labelRenderer) {
      return labelRenderer(optionProps);
    }
    const label = getOptionLabel(optionProps);
    let optionDataCy = '';
    if (name) {
      optionDataCy = "".concat(name, "-option-").concat(createCySelector(label));
    } else {
      optionDataCy = "option-".concat(createCySelector(label));
    }
    return jsx("div", {
      "data-in-portal": "true",
      "data-cy": optionDataCy,
      onClick: event => {
        if (multiple) {
          return;
        }
        if (!value) {
          return;
        }
        if (value[optionValue] === optionProps[optionValue]) {
          // same option clicked
          onChange(event, value);
          isControlled ? onClose === null || onClose === void 0 ? void 0 : onClose() : setOpen(false);
        }
      },
      children: jsx(StyledTypography, {
        variant: "body",
        size: "medium",
        tagName: "span",
        className: "option",
        children: label
      })
    });
  }, [labelRenderer, getOptionLabel, name, multiple, value, optionValue, onChange, isControlled, onClose]);
  const renderTag = useCallback((tagValue, getTagProps) => {
    return tagValue.map((tag, index) => {
      const tagProps = getTagProps({
        index
      });
      const isDividerOnly = tag => 'divider' in tag && Object.keys(tag).length === 1;
      return jsx(StyledChip, Object.assign({}, tagProps, {
        disabled: Boolean((fixedOptions || []).find(fixedOption => fixedOption[optionValue] === tag[optionValue])),
        label: "".concat(getOptionLabel(tag)),
        startIcon: !isDividerOnly(tag) ? tag.startIcon : undefined
      }));
    });
  }, [fixedOptions, optionValue, getOptionLabel]);
  const getOptionSelected = useCallback((option, value) => {
    if (!value) {
      return false;
    }
    return option[optionValue] === value[optionValue];
  }, [optionValue]);
  const selectValue = useMemo(() => {
    if (multiple) {
      const fixedOptionsToSpread = fixedOptions || [];
      const valueToSpread = Array.isArray(value) ? value : [];
      return [...fixedOptionsToSpread, ...valueToSpread.filter(option => !fixedOptionsToSpread.find(fixedOption => fixedOption[optionValue] === option[optionValue]))];
    } else {
      return value ? value : null;
    }
  }, [fixedOptions, multiple, optionValue, value]);
  const renderInput = useCallback((params, value) => {
    return jsx(StyledInput$1, Object.assign({
      multiline: params.multiple
    }, params, {
      label: label,
      placeholder: placeholder,
      error: error,
      helperText: helperText,
      onBlur: onBlur,
      variant: "outlined",
      type: "text",
      disabled: disabled,
      InputProps: Object.assign(Object.assign({}, params.InputProps), {
        startAdornment: multiple ? params.InputProps.startAdornment : value && StartAdornment && jsx(AdornmentCenterContainer, {
          children: jsx(StartAdornment, {
            value: value
          })
        }),
        inputProps: Object.assign(Object.assign({}, params.inputProps), {
          'data-cy': dataCy ? dataCy : undefined,
          name: name
        })
      }),
      InputLabelProps: inputLabelProps$1,
      required: required
    }));
  }, [label, placeholder, error, helperText, onBlur, disabled, multiple, StartAdornment, dataCy, name, required]);
  const handleClose = useCallback(event => {
    isControlled ? onClose === null || onClose === void 0 ? void 0 : onClose(event) : setOpen(false);
  }, [isControlled, onClose]);
  const handleOpen = useCallback(event => {
    isControlled ? onOpen === null || onOpen === void 0 ? void 0 : onOpen(event) : setOpen(true);
    setOpen(true);
  }, [isControlled, onOpen]);
  const ListboxProps = useMemo(() => {
    return {
      staticOptions
    };
  }, [staticOptions]);
  const PopperComponent = useMemo(() => {
    return props => {
      switch (level) {
        case 'high':
          return jsx(HighPopper, Object.assign({}, props, {
            popperWidth: popperWidth
          }));
        case 'highest':
          return jsx(HighestPopper, Object.assign({}, props, {
            popperWidth: popperWidth
          }));
        default:
          return jsx(DefaultPopper, Object.assign({}, props, {
            popperWidth: popperWidth
          }));
      }
    };
  }, [level, popperWidth]);
  return jsx(StyledSelect, {
    className: className,
    disableCloseOnSelect: true,
    autoHighlight: true,
    open: isControlled ? isOpen : open,
    multiple: multiple,
    filterSelectedOptions: Boolean(multiple),
    onOpen: handleOpen,
    onClose: handleClose,
    options: options,
    getOptionLabel: getOptionLabel,
    filterOptions: filterOptions,
    renderOption: renderOption,
    value: selectValue,
    fullWidth: true,
    disableClearable: disableClearable,
    onChange: handleChange,
    PopperComponent: PopperComponent,
    disabled: disabled,
    renderInput: params => renderInput(Object.assign(Object.assign({}, params), {
      multiple
    }), selectValue),
    closeIcon: jsx(Icon, {
      name: "cancel"
    }),
    popupIcon: jsx(Icon, {
      name: "chevronDown"
    }),
    renderTags: renderTag,
    getOptionSelected: getOptionSelected,
    ListboxComponent: ListBoxComponent,
    ListboxProps: ListboxProps,
    groupBy: groupBy,
    title: label,
    getOptionDisabled: option => 'disabled' in option && Boolean(option.disabled) || 'divider' in option && Boolean(option.divider)
  });
}
function SelectFormikWrapper(props) {
  const {
    name,
    multiple,
    className,
    options,
    fixedOptions,
    dataCy,
    label,
    placeholder,
    optionLabel,
    optionValue,
    helperText,
    disableClearable,
    staticOptions,
    onChange,
    StartAdornment,
    level,
    required,
    disabled
  } = props;
  const [field, meta, helpers] = useField(name);
  const handleChange = useCallback((event, value) => {
    helpers.setValue(value);
    // TODO
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
  }, [helpers, onChange]);
  const handleMultipleChange = useCallback((event, value) => {
    helpers.setValue(value);
    // TODO
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
  }, [helpers, onChange]);
  const handleBlur = useCallback(() => {
    helpers.setTouched(true);
  }, [helpers]);
  const hasErrors = Boolean(meta.error);
  const errorMsg = Array.isArray(meta.error) ? meta.error[0] : meta.error;
  if (multiple) {
    return jsx(Select, {
      disabled: disabled,
      className: className,
      optionValue: optionValue,
      multiple: multiple,
      fixedOptions: fixedOptions,
      dataCy: dataCy,
      options: options,
      label: label,
      placeholder: placeholder,
      error: meta.touched && hasErrors,
      helperText: meta.touched && errorMsg || helperText,
      value: field.value || null,
      onChange: handleMultipleChange,
      onBlur: handleBlur,
      optionLabel: optionLabel,
      disableClearable: disableClearable,
      staticOptions: staticOptions,
      StartAdornment: StartAdornment,
      level: level,
      required: required
    });
  }
  return jsx(Select, {
    disabled: disabled,
    className: className,
    optionValue: optionValue,
    dataCy: dataCy,
    options: options,
    label: label,
    placeholder: placeholder,
    error: meta.touched && hasErrors,
    helperText: meta.touched && errorMsg || helperText,
    value: field.value || null,
    onChange: handleChange,
    onBlur: handleBlur,
    optionLabel: optionLabel,
    disableClearable: disableClearable,
    staticOptions: staticOptions,
    StartAdornment: StartAdornment,
    level: level,
    required: required
  });
}
function SelectReduxFormWrapper(props) {
  const {
    input,
    dataCy,
    options,
    label,
    optionLabel,
    staticOptions,
    disableClearable,
    placeholder,
    multiple,
    fixedOptions,
    optionValue,
    className,
    helperText,
    meta,
    onChange,
    StartAdornment,
    level,
    labelRenderer,
    groupBy,
    required,
    disabled
  } = props;
  const handleChange = useCallback((event, value) => {
    input.onChange(value);
    // TODO
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
  }, [input, onChange]);
  const handleMultipleChange = useCallback((event, value) => {
    input.onChange(value);
    // TODO
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
  }, [input, onChange]);
  const handleBlur = useCallback(() => {
    meta.dispatch(touch(meta.form, input.name));
  }, [input.name, meta]);
  const hasErrors = Boolean(meta.error);
  const errorMsg = Array.isArray(meta.error) ? meta.error[0] : meta.error;
  if (multiple) {
    return jsx(Select, {
      disabled: disabled,
      name: input.name,
      className: className,
      optionValue: optionValue,
      multiple: multiple,
      fixedOptions: fixedOptions,
      dataCy: dataCy,
      options: options,
      label: label,
      placeholder: placeholder,
      error: meta.touched && hasErrors,
      helperText: meta.touched && errorMsg || helperText,
      value: input.value || null,
      onChange: handleMultipleChange,
      onBlur: handleBlur,
      optionLabel: optionLabel,
      disableClearable: disableClearable,
      staticOptions: staticOptions,
      StartAdornment: StartAdornment,
      level: level,
      labelRenderer: labelRenderer,
      groupBy: groupBy,
      required: required
    });
  }
  return jsx(Select, {
    disabled: disabled,
    name: input.name,
    className: className,
    optionValue: optionValue,
    dataCy: dataCy,
    options: options,
    label: label,
    placeholder: placeholder,
    error: meta.touched && hasErrors,
    helperText: meta.touched && errorMsg || helperText,
    value: input.value || null,
    onChange: handleChange,
    onBlur: handleBlur,
    optionLabel: optionLabel,
    disableClearable: disableClearable,
    staticOptions: staticOptions,
    StartAdornment: StartAdornment,
    level: level,
    labelRenderer: labelRenderer,
    groupBy: groupBy,
    required: required
  });
}
const pickerId = 'custom-range-picker-dialog';
const updateDates = function (type, durationType) {
  let weekStartsAt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  const now = new Date();
  let addFunction;
  let startOfFn;
  let endOfFn;
  switch (durationType) {
    case 'week':
      addFunction = addWeeks;
      startOfFn = startOfWeek;
      endOfFn = endOfWeek;
      break;
    case 'quarter':
      addFunction = addQuarters;
      startOfFn = startOfQuarter;
      endOfFn = endOfQuarter;
      break;
    case 'year':
      addFunction = addYears;
      startOfFn = startOfYear;
      endOfFn = endOfYear;
      break;
    default:
    case 'month':
      addFunction = addMonths;
      startOfFn = startOfMonth;
      endOfFn = endOfMonth;
      break;
  }
  switch (type) {
    case 'Last':
      return {
        start: startOfFn(addFunction(now, -1), weekStartsAt),
        end: endOfFn(addFunction(now, -1), weekStartsAt),
        dateState: 'Last',
        periodType: durationType
      };
    case 'Next':
      return {
        start: startOfFn(addFunction(now, 1), weekStartsAt),
        end: endOfFn(addFunction(now, 1), weekStartsAt),
        dateState: 'Next',
        periodType: durationType
      };
    case 'This':
      return {
        start: startOfFn(now, weekStartsAt),
        end: endOfFn(now, weekStartsAt),
        dateState: 'This',
        periodType: durationType
      };
  }
};
const getDropdownDateRangesOptions = withCustom => {
  const options = [withCustom ? {
    dateState: 'Custom',
    periodType: 'custom',
    value: 'custom',
    label: 'Custom Time Range',
    dataCy: 'range-option-custom',
    getRange: () => {
      return undefined;
    }
  } : undefined, {
    dateState: 'This',
    periodType: 'week',
    value: 'this-week',
    label: 'This Week',
    dataCy: 'range-option-this-week',
    getRange: weekStartsAt => updateDates('This', 'week', weekStartsAt)
  }, {
    dateState: 'Last',
    periodType: 'week',
    value: 'last-week',
    label: 'Last Week',
    dataCy: 'range-option-last-week',
    getRange: weekStartsAt => updateDates('Last', 'week', weekStartsAt)
  }, {
    dateState: 'Next',
    periodType: 'week',
    value: 'next-week',
    label: 'Next Week',
    dataCy: 'range-option-next-week',
    getRange: weekStartsAt => updateDates('Next', 'week', weekStartsAt)
  }, {
    dateState: 'This',
    periodType: 'month',
    value: 'this-month',
    label: 'This Month',
    dataCy: 'range-option-this-month',
    getRange: () => updateDates('This', 'month')
  }, {
    dateState: 'Last',
    periodType: 'month',
    value: 'last-month',
    label: 'Last Month',
    dataCy: 'range-option-last-month',
    getRange: () => updateDates('Last', 'month')
  }, {
    dateState: 'Next',
    periodType: 'month',
    value: 'next-month',
    label: 'Next Month',
    dataCy: 'range-option-next-month',
    getRange: () => updateDates('Next', 'month')
  }, {
    dateState: 'This',
    periodType: 'quarter',
    value: 'this-quarter',
    label: 'This Quarter',
    dataCy: 'range-option-this-quarter',
    getRange: () => updateDates('This', 'quarter')
  }, {
    dateState: 'Last',
    periodType: 'quarter',
    value: 'last-quarter',
    label: 'Last Quarter',
    dataCy: 'range-option-last-quarter',
    getRange: () => updateDates('Last', 'quarter')
  }, {
    dateState: 'Next',
    periodType: 'quarter',
    value: 'next-quarter',
    label: 'Next Quarter',
    dataCy: 'range-option-next-quarter',
    getRange: () => updateDates('Next', 'quarter')
  }, {
    dateState: 'This',
    periodType: 'year',
    value: 'this-year',
    label: 'This Year',
    dataCy: 'range-option-this-year',
    getRange: () => updateDates('This', 'year')
  }, {
    dateState: 'Last',
    periodType: 'year',
    value: 'last-year',
    label: 'Last Year',
    dataCy: 'range-option-last-year',
    getRange: () => updateDates('Last', 'year')
  }, {
    dateState: 'Next',
    periodType: 'year',
    value: 'next-year',
    label: 'Next Year',
    dataCy: 'range-option-next-year',
    getRange: () => updateDates('Next', 'year')
  }];
  return options.filter(option => {
    return Boolean(option);
  });
};
const customDropdownDateRangesOption = {
  dateState: 'Custom',
  periodType: 'custom',
  value: 'custom',
  label: 'Custom Time Range',
  dataCy: 'range-option-custom',
  disabled: true,
  getRange: () => undefined
};
function RangePicker(props) {
  const {
    stack,
    dataCy = 'range-picker',
    name = 'range-picker',
    value,
    disabled,
    onChange,
    showPredefinedOptions = false,
    weekStartsAt = 1,
    customDatesVariant = 'inline',
    className
  } = props;
  const dropdownDateRangesOptions = useMemo(() => {
    return getDropdownDateRangesOptions(customDatesVariant === 'dialog');
  }, [customDatesVariant]);
  const [state, setState] = useState(() => {
    const initialSelected = dropdownDateRangesOptions.find(option => option.dateState === value.dateState && option.periodType === value.periodType) || customDropdownDateRangesOption;
    let label = initialSelected.label;
    if (customDatesVariant === 'dialog' && value.start && value.end && initialSelected.value === 'custom') {
      label = "".concat(formatDate(value.start, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT), " - ").concat(formatDate(value.end, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT));
    }
    return {
      previousSelectedOption: null,
      rangeSelectedOption: Object.assign(Object.assign({}, initialSelected), {
        label: label
      })
    };
  });
  const {
    isOpen: isCustomDatesDialogOpen,
    open: openCustomDatesDialog,
    anchorElement: customDatesDialogAnchorElement,
    close: closeCustomDatesDialog
  } = useOpenState();
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectClose = useCallback(event => {
    var _a;
    if (event.nativeEvent instanceof FocusEvent) {
      const relatedTarget = event.relatedTarget;
      if (customDatesVariant === 'inline') {
        setIsSelectOpen(false);
      } else if (relatedTarget && relatedTarget instanceof Element) {
        if (!(((_a = relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.parentElement) === null || _a === void 0 ? void 0 : _a.id) === pickerId)) {
          setIsSelectOpen(false);
        }
      }
    } else {
      setIsSelectOpen(false);
    }
  }, [customDatesVariant]);
  const handleSelectOpen = useCallback(() => {
    setIsSelectOpen(true);
  }, []);
  const handlePredefinedRangeClick = useCallback((event, selectedRange) => {
    if (!selectedRange) {
      return;
    }
    if (customDatesVariant === 'inline') {
      setIsSelectOpen(false);
    }
    if (selectedRange.value === 'custom' || !selectedRange.getRange) {
      if (customDatesVariant === 'dialog') {
        openCustomDatesDialog(event);
        setState(prev => {
          return Object.assign(Object.assign({}, prev), {
            rangeSelectedOption: selectedRange,
            previousSelectedOption: prev.rangeSelectedOption
          });
        });
      } else {
        setState(prev => Object.assign(Object.assign({}, prev), {
          predefinedSelectedDate: selectedRange.value
        }));
      }
    } else {
      const newDatesState = selectedRange.getRange(weekStartsAt);
      if (!newDatesState) {
        return;
      }
      setIsSelectOpen(false);
      onChange({
        dateState: newDatesState.dateState,
        end: newDatesState.end,
        start: newDatesState.start,
        periodType: newDatesState.periodType
      });
      setState(prev => {
        return Object.assign(Object.assign({}, prev), {
          rangeSelectedOption: selectedRange
        });
      });
    }
  }, [customDatesVariant, onChange, openCustomDatesDialog, weekStartsAt]);
  const handleStartDateChange = useCallback(date => {
    onChange(Object.assign(Object.assign({}, value), {
      start: date,
      dateState: customDropdownDateRangesOption.dateState,
      periodType: customDropdownDateRangesOption.periodType
    }));
    setState(prev => Object.assign(Object.assign({}, prev), {
      rangeSelectedOption: customDropdownDateRangesOption
    }));
  }, [onChange, value]);
  const handleEndDateChange = useCallback(date => {
    onChange(Object.assign(Object.assign({}, value), {
      end: date,
      dateState: customDropdownDateRangesOption.dateState,
      periodType: customDropdownDateRangesOption.periodType
    }));
    setState(prev => Object.assign(Object.assign({}, prev), {
      rangeSelectedOption: customDropdownDateRangesOption
    }));
  }, [onChange, value]);
  const handleCustomDatesDialogSubmit = useCallback(dates => {
    onChange(Object.assign(Object.assign({}, value), {
      start: dates.start,
      end: dates.end,
      dateState: customDropdownDateRangesOption.dateState,
      periodType: customDropdownDateRangesOption.periodType
    }));
    setState(prev => Object.assign(Object.assign({}, prev), {
      previousSelectedOption: null,
      rangeSelectedOption: Object.assign(Object.assign({}, customDropdownDateRangesOption), {
        label: "".concat(formatDate(dates.start, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT), " - ").concat(formatDate(dates.end, DATE_FORMATS.YEAR_MONTH_DAY_FORMAT))
      })
    }));
    closeCustomDatesDialog();
    setIsSelectOpen(false);
  }, [closeCustomDatesDialog, onChange, value]);
  const handleCustomDatesDialogCancel = useCallback(() => {
    setState(prev => Object.assign(Object.assign({}, prev), {
      rangeSelectedOption: prev.previousSelectedOption ? prev.previousSelectedOption : prev.rangeSelectedOption
    }));
    closeCustomDatesDialog();
  }, [closeCustomDatesDialog]);
  return jsx(Layout, {
    stack: true,
    gap: "--Spacing-200",
    hAlign: "center",
    className: className,
    children: jsxs(Layout, {
      gap: 24,
      stack: stack,
      stretch: true,
      children: [showPredefinedOptions || customDatesVariant === 'dialog' ? jsxs(Fragment, {
        children: [jsx(Select, {
          isOpen: isSelectOpen,
          onClose: handleSelectClose,
          onOpen: handleSelectOpen,
          dataCy: "".concat(dataCy, "-date-range-buttons"),
          name: "".concat(name, "-date-range-buttons"),
          disableClearable: true,
          value: state.rangeSelectedOption,
          onChange: handlePredefinedRangeClick,
          options: dropdownDateRangesOptions,
          label: "Time range",
          optionLabel: "label",
          optionValue: "value",
          disabled: disabled,
          disableCloseOnSelect: true,
          labelRenderer: option => {
            return jsxs(Layout, {
              hAlign: "space-between",
              children: [jsx(Typography, {
                variant: "label",
                size: "large",
                prominent: true,
                tagName: "span",
                children: option.label
              }), option.value === 'custom' ? jsx(Icon, {
                name: "today"
              }) : null]
            });
          }
        }), isCustomDatesDialogOpen ? jsx(CustomDatesDialog, {
          onCancel: handleCustomDatesDialogCancel,
          onSubmit: handleCustomDatesDialogSubmit,
          initialValue: value,
          anchorElement: customDatesDialogAnchorElement
        }) : null]
      }) : null, customDatesVariant === 'inline' ? jsxs(Fragment, {
        children: [jsx(DatePickerInput, {
          disabled: disabled,
          dataCy: "".concat(dataCy, "-start-input"),
          name: "".concat(name, "-start-input"),
          label: "Start date",
          value: value.start,
          onChange: handleStartDateChange,
          disabledDays: day => {
            return isAfter(day, value.end, 'day');
          },
          helperText: "YYYY-MM-DD"
        }), jsx(DatePickerInput, {
          disabled: disabled,
          dataCy: "".concat(dataCy, "-end-input"),
          name: "".concat(name, "-end-input"),
          label: "End date",
          value: value.end,
          onChange: handleEndDateChange,
          disabledDays: day => {
            return isBefore(day, value.start, 'day');
          },
          helperText: "YYYY-MM-DD"
        })]
      }) : null]
    })
  });
}
const DialogContentLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "range-picker__DialogContentLayout",
  componentId: "sc-1fz13cy-0"
})(["min-width:324px;"]);
const HeaderLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "range-picker__HeaderLayout",
  componentId: "sc-1fz13cy-1"
})(["width:100%;"]);
const CustomDatesDialog = props => {
  const {
    anchorElement,
    name,
    dataCy,
    initialValue,
    onSubmit,
    onCancel
  } = props;
  const [value, setValue] = useState({
    start: initialValue.start,
    end: initialValue.end
  });
  const handleClear = useCallback(() => {
    setValue({
      start: undefined,
      end: undefined
    });
  }, []);
  const submitDisabled = !value.start && !value.end;
  const handleSubmit = useCallback(() => {
    if (value.start && value.end) {
      onSubmit({
        start: value.start,
        end: value.end
      });
    }
  }, [onSubmit, value]);
  const titleJSX = jsxs(HeaderLayout, {
    stack: true,
    gap: "--Spacing-100",
    children: [jsx(Typography, {
      variant: "label",
      size: "large",
      color: "on-surface-variant",
      children: "Custom Time Range"
    }), jsxs(HeaderLayout, {
      gap: "--Spacing-100",
      hAlign: "space-between",
      vAlign: "center",
      children: [jsx(Typography, {
        variant: "headline",
        size: "medium",
        children: "Enter dates"
      }), jsx(Icon, {
        name: "today"
      })]
    })]
  });
  const contentJSX = jsxs(DialogContentLayout, {
    gap: "--Spacing-150",
    children: [jsx(DatePickerInput, {
      dataCy: "".concat(dataCy, "-start-input"),
      name: "".concat(name, "-start-input"),
      label: "Start date",
      value: value.start,
      onChange: date => {
        setValue(prev => Object.assign(Object.assign({}, prev), {
          start: date || undefined
        }));
      },
      disabledDays: day => {
        return value.end ? isAfter(day, value.end, 'day') : false;
      },
      helperText: "YYYY-MM-DD"
    }), jsx(DatePickerInput, {
      dataCy: "".concat(dataCy, "-end-input"),
      name: "".concat(name, "-end-input"),
      label: "End date",
      value: value.end,
      onChange: date => {
        setValue(prev => Object.assign(Object.assign({}, prev), {
          end: date || undefined
        }));
      },
      disabledDays: day => {
        return value.start ? isBefore(day, value.start, 'day') : false;
      },
      helperText: "YYYY-MM-DD"
    })]
  });
  const actionsJSX = jsxs(Layout, {
    hAlign: "space-between",
    children: [jsx(Button, {
      variant: "text",
      onClick: handleClear,
      children: "Clear"
    }), jsxs(Layout, {
      gap: "--Spacing-100",
      children: [jsx(Button, {
        variant: "text",
        onClick: onCancel,
        children: "Cancel"
      }), jsx(Button, {
        variant: "text",
        disabled: submitDisabled,
        onClick: handleSubmit,
        children: "OK"
      })]
    })]
  });
  return jsx(Dialog, {
    id: pickerId,
    headerDivider: true,
    open: true,
    anchorElement: anchorElement,
    onClose: onCancel,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX,
    anchorOriginPosition: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOriginPosition: {
      vertical: 'top',
      horizontal: 'right'
    }
  });
};
const weekDays$1 = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const WeekDaysSelectedFormat = props => {
  const {
    selected
  } = props;
  if (!selected) {
    return null;
  }
  return weekDays$1.filter(weekDay => selected[weekDay]).map(weekDay => getFirstLetterUpperCase(weekDay)).join(', ');
};
const Ce = 0,
  Lt = 1,
  Yt = 2,
  En = 4;
function sn(t) {
  return () => t;
}
function lo(t) {
  t();
}
function ne(t, e) {
  return n => t(e(n));
}
function ln(t, e) {
  return () => t(e);
}
function Hn(t, e) {
  return n => t(e, n);
}
function Ae(t) {
  return t !== void 0;
}
function co() {
  for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    t[_key3] = arguments[_key3];
  }
  return () => {
    t.map(lo);
  };
}
function Gt() {}
function ye(t, e) {
  return e(t), t;
}
function uo(t, e) {
  return e(t);
}
function X() {
  for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    t[_key4] = arguments[_key4];
  }
  return t;
}
function K(t, e) {
  return t(Lt, e);
}
function M(t, e) {
  t(Ce, e);
}
function We(t) {
  t(Yt);
}
function lt(t) {
  return t(En);
}
function F(t, e) {
  return K(t, Hn(e, Ce));
}
function Rt(t, e) {
  const n = t(Lt, o => {
    n(), e(o);
  });
  return n;
}
function cn(t) {
  let e, n;
  return o => r => {
    e = r, n && clearTimeout(n), n = setTimeout(() => {
      o(e);
    }, t);
  };
}
function Bn(t, e) {
  return t === e;
}
function Y() {
  let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Bn;
  let e;
  return n => o => {
    t(e, o) || (e = o, n(o));
  };
}
function V(t) {
  return e => n => {
    t(n) && e(n);
  };
}
function H(t) {
  return e => ne(e, t);
}
function vt(t) {
  return e => () => {
    e(t);
  };
}
function x(t) {
  for (var _len5 = arguments.length, e = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    e[_key5 - 1] = arguments[_key5];
  }
  const n = ao(...e);
  return (o, r) => {
    switch (o) {
      case Yt:
        We(t);
        return;
      case Lt:
        return K(t, n(r));
    }
  };
}
function bt(t, e) {
  return n => o => {
    n(e = t(e, o));
  };
}
function qt(t) {
  return e => n => {
    t > 0 ? t-- : e(n);
  };
}
function zt(t) {
  let e = null,
    n;
  return o => r => {
    e = r, !n && (n = setTimeout(() => {
      n = void 0, o(e);
    }, t));
  };
}
function G() {
  for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    t[_key6] = arguments[_key6];
  }
  const e = new Array(t.length);
  let n = 0,
    o = null;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, c => {
      const d = n;
      n = n | l, e[i] = c, d !== r && n === r && o && (o(), o = null);
    });
  }), s => i => {
    const l = () => {
      s([i].concat(e));
    };
    n === r ? l() : o = l;
  };
}
function ao() {
  for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    t[_key7] = arguments[_key7];
  }
  return e => t.reduceRight(uo, e);
}
function fo(t) {
  let e, n;
  const o = () => e == null ? void 0 : e();
  return function (r, s) {
    switch (r) {
      case Lt:
        return s ? n === s ? void 0 : (o(), n = s, e = K(t, s), e) : (o(), Gt);
      case Yt:
        o(), n = null;
        return;
    }
  };
}
function w(t) {
  let e = t;
  const n = $$7();
  return (o, r) => {
    switch (o) {
      case Ce:
        e = r;
        break;
      case Lt:
        {
          r(e);
          break;
        }
      case En:
        return e;
    }
    return n(o, r);
  };
}
function ct(t, e) {
  return ye(w(e), n => F(t, n));
}
function $$7() {
  const t = [];
  return (e, n) => {
    switch (e) {
      case Ce:
        t.slice().forEach(o => {
          o(n);
        });
        return;
      case Yt:
        t.splice(0, t.length);
        return;
      case Lt:
        return t.push(n), () => {
          const o = t.indexOf(n);
          o > -1 && t.splice(o, 1);
        };
    }
  };
}
function pt(t) {
  return ye($$7(), e => F(t, e));
}
function U(t) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let {
    singleton: n
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    singleton: !0
  };
  return {
    constructor: t,
    dependencies: e,
    id: mo(),
    singleton: n
  };
}
const mo = () => Symbol();
function po(t) {
  const e = /* @__PURE__ */new Map(),
    n = _ref34 => {
      let {
        constructor: o,
        dependencies: r,
        id: s,
        singleton: i
      } = _ref34;
      if (i && e.has(s)) return e.get(s);
      const l = o(r.map(c => n(c)));
      return i && e.set(s, l), l;
    };
  return n(t);
}
function rt() {
  for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    t[_key8] = arguments[_key8];
  }
  const e = $$7(),
    n = new Array(t.length);
  let o = 0;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, c => {
      n[i] = c, o = o | l, o === r && M(e, n);
    });
  }), function (s, i) {
    switch (s) {
      case Yt:
        {
          We(e);
          return;
        }
      case Lt:
        return o === r && i(n), K(e, i);
    }
  };
}
function A(t) {
  let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Bn;
  return x(t, Y(e));
}
function un() {
  for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    t[_key9] = arguments[_key9];
  }
  return function (e, n) {
    switch (e) {
      case Yt:
        return;
      case Lt:
        return co(...t.map(o => K(o, n)));
    }
  };
}
var ht = /* @__PURE__ */(t => (t[t.DEBUG = 0] = "DEBUG", t[t.INFO = 1] = "INFO", t[t.WARN = 2] = "WARN", t[t.ERROR = 3] = "ERROR", t))(ht || {});
const ho = {
    0: "debug",
    3: "error",
    1: "log",
    2: "warn"
  },
  go = () => typeof globalThis > "u" ? window : globalThis,
  Pt = U(() => {
    const t = w(3
    /* ERROR */);
    return {
      log: w(function (n, o) {
        let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var i;
        const s = (i = go().VIRTUOSO_LOG_LEVEL) != null ? i : lt(t);
        r >= s && console[ho[r]]("%creact-virtuoso: %c%s %o", "color: #0253b3; font-weight: bold", "color: initial", n, o);
      }),
      logLevel: t
    };
  }, [], {
    singleton: !0
  });
function Et(t, e, n) {
  return Me(t, e, n).callbackRef;
}
function Me(t, e, n) {
  const o = React__default.useRef(null);
  let r = s => {};
  if (typeof ResizeObserver < "u") {
    const s = React__default.useMemo(() => new ResizeObserver(i => {
      const l = () => {
        const c = i[0].target;
        c.offsetParent !== null && t(c);
      };
      n ? l() : requestAnimationFrame(l);
    }), [t]);
    r = i => {
      i && e ? (s.observe(i), o.current = i) : (o.current && s.unobserve(o.current), o.current = null);
    };
  }
  return {
    callbackRef: r,
    ref: o
  };
}
function kn(t, e, n, o, r, s, i, l, c) {
  const d = React__default.useCallback(f => {
    const S = Io(f.children, e, l ? "offsetWidth" : "offsetHeight", r);
    let p = f.parentElement;
    for (; !p.dataset.virtuosoScroller;) p = p.parentElement;
    const m = p.lastElementChild.dataset.viewportType === "window",
      C = i ? l ? i.scrollLeft : i.scrollTop : m ? l ? window.pageXOffset || document.documentElement.scrollLeft : window.pageYOffset || document.documentElement.scrollTop : l ? p.scrollLeft : p.scrollTop,
      I = i ? l ? i.scrollWidth : i.scrollHeight : m ? l ? document.documentElement.scrollWidth : document.documentElement.scrollHeight : l ? p.scrollWidth : p.scrollHeight,
      y = i ? l ? i.offsetWidth : i.offsetHeight : m ? l ? window.innerWidth : window.innerHeight : l ? p.offsetWidth : p.offsetHeight;
    o({
      scrollHeight: I,
      scrollTop: Math.max(C, 0),
      viewportHeight: y
    }), s == null || s(l ? an("column-gap", getComputedStyle(f).columnGap, r) : an("row-gap", getComputedStyle(f).rowGap, r)), S !== null && t(S);
  }, [t, e, r, s, i, o]);
  return Me(d, n, c);
}
function Io(t, e, n, o) {
  const r = t.length;
  if (r === 0) return null;
  const s = [];
  for (let i = 0; i < r; i++) {
    const l = t.item(i);
    if (l.dataset.index === void 0) continue;
    const c = parseInt(l.dataset.index),
      d = parseFloat(l.dataset.knownSize),
      f = e(l, n);
    if (f === 0 && o("Zero-sized element, this should not happen", {
      child: l
    }, ht.ERROR), f === d) continue;
    const S = s[s.length - 1];
    s.length === 0 || S.size !== f || S.endIndex !== c - 1 ? s.push({
      endIndex: c,
      size: f,
      startIndex: c
    }) : s[s.length - 1].endIndex++;
  }
  return s;
}
function an(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n("".concat(t, " was not resolved to pixel value correctly"), e, ht.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}
function _e(t, e, n) {
  const o = React__default.useRef(null),
    r = React__default.useCallback(c => {
      if (!(c != null && c.offsetParent)) return;
      const d = c.getBoundingClientRect(),
        f = d.width;
      let S, p;
      if (e) {
        const m = e.getBoundingClientRect(),
          C = d.top - m.top;
        p = m.height - Math.max(0, C), S = C + e.scrollTop;
      } else p = window.innerHeight - Math.max(0, d.top), S = d.top + window.pageYOffset;
      o.current = {
        offsetTop: S,
        visibleHeight: p,
        visibleWidth: f
      }, t(o.current);
    }, [t, e]),
    {
      callbackRef: s,
      ref: i
    } = Me(r, !0, n),
    l = React__default.useCallback(() => {
      r(i.current);
    }, [r, i]);
  return React__default.useEffect(() => {
    if (e) {
      e.addEventListener("scroll", l);
      const c = new ResizeObserver(() => {
        requestAnimationFrame(l);
      });
      return c.observe(e), () => {
        e.removeEventListener("scroll", l), c.unobserve(e);
      };
    } else return window.addEventListener("scroll", l), window.addEventListener("resize", l), () => {
      window.removeEventListener("scroll", l), window.removeEventListener("resize", l);
    };
  }, [l, e]), s;
}
const at = U(() => {
    const t = $$7(),
      e = $$7(),
      n = w(0),
      o = $$7(),
      r = w(0),
      s = $$7(),
      i = $$7(),
      l = w(0),
      c = w(0),
      d = w(0),
      f = w(0),
      S = $$7(),
      p = $$7(),
      m = w(!1),
      C = w(!1),
      I = w(!1);
    return F(x(t, H(_ref35 => {
      let {
        scrollTop: y
      } = _ref35;
      return y;
    })), e), F(x(t, H(_ref36 => {
      let {
        scrollHeight: y
      } = _ref36;
      return y;
    })), i), F(e, r), {
      deviation: n,
      fixedFooterHeight: d,
      fixedHeaderHeight: c,
      footerHeight: f,
      headerHeight: l,
      horizontalDirection: C,
      scrollBy: p,
      // input
      scrollContainerState: t,
      scrollHeight: i,
      scrollingInProgress: m,
      // signals
      scrollTo: S,
      scrollTop: e,
      skipAnimationFrameInResizeObserver: I,
      smoothScrollTargetReached: o,
      // state
      statefulScrollTop: r,
      viewportHeight: s
    };
  }, [], {
    singleton: !0
  }),
  oe = {
    lvl: 0
  };
function On(t, e) {
  const n = t.length;
  if (n === 0) return [];
  let {
    index: o,
    value: r
  } = e(t[0]);
  const s = [];
  for (let i = 1; i < n; i++) {
    const {
      index: l,
      value: c
    } = e(t[i]);
    s.push({
      end: l - 1,
      start: o,
      value: r
    }), o = l, r = c;
  }
  return s.push({
    end: 1 / 0,
    start: o,
    value: r
  }), s;
}
function j(t) {
  return t === oe;
}
function re(t, e) {
  if (!j(t)) return e === t.k ? t.v : e < t.k ? re(t.l, e) : re(t.r, e);
}
function wt(t, e) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "k";
  if (j(t)) return [-1 / 0, void 0];
  if (Number(t[n]) === e) return [t.k, t.v];
  if (Number(t[n]) < e) {
    const o = wt(t.r, e, n);
    return o[0] === -1 / 0 ? [t.k, t.v] : o;
  }
  return wt(t.l, e, n);
}
function mt(t, e, n) {
  return j(t) ? Ln(e, n, 1) : e === t.k ? ot(t, {
    k: e,
    v: n
  }) : e < t.k ? dn(ot(t, {
    l: mt(t.l, e, n)
  })) : dn(ot(t, {
    r: mt(t.r, e, n)
  }));
}
function Kt() {
  return oe;
}
function ve(t, e, n) {
  if (j(t)) return [];
  const o = wt(t, e)[0];
  return So(ze(t, o, n));
}
function Fe(t, e) {
  if (j(t)) return oe;
  const {
    k: n,
    l: o,
    r
  } = t;
  if (e === n) {
    if (j(o)) return r;
    if (j(r)) return o;
    {
      const [s, i] = zn(o);
      return ge(ot(t, {
        k: s,
        l: Fn(o),
        v: i
      }));
    }
  } else return e < n ? ge(ot(t, {
    l: Fe(o, e)
  })) : ge(ot(t, {
    r: Fe(r, e)
  }));
}
function _t(t) {
  return j(t) ? [] : [..._t(t.l), {
    k: t.k,
    v: t.v
  }, ..._t(t.r)];
}
function ze(t, e, n) {
  if (j(t)) return [];
  const {
    k: o,
    l: r,
    r: s,
    v: i
  } = t;
  let l = [];
  return o > e && (l = l.concat(ze(r, e, n))), o >= e && o <= n && l.push({
    k: o,
    v: i
  }), o <= n && (l = l.concat(ze(s, e, n))), l;
}
function ge(t) {
  const {
    l: e,
    lvl: n,
    r: o
  } = t;
  if (o.lvl >= n - 1 && e.lvl >= n - 1) return t;
  if (n > o.lvl + 1) {
    if (He(e)) return Pn(ot(t, {
      lvl: n - 1
    }));
    if (!j(e) && !j(e.r)) return ot(e.r, {
      l: ot(e, {
        r: e.r.l
      }),
      lvl: n,
      r: ot(t, {
        l: e.r.r,
        lvl: n - 1
      })
    });
    throw new Error("Unexpected empty nodes");
  } else {
    if (He(t)) return Le(ot(t, {
      lvl: n - 1
    }));
    if (!j(o) && !j(o.l)) {
      const r = o.l,
        s = He(r) ? o.lvl - 1 : o.lvl;
      return ot(r, {
        l: ot(t, {
          lvl: n - 1,
          r: r.l
        }),
        lvl: r.lvl + 1,
        r: Le(ot(o, {
          l: r.r,
          lvl: s
        }))
      });
    } else throw new Error("Unexpected empty nodes");
  }
}
function ot(t, e) {
  return Ln(e.k !== void 0 ? e.k : t.k, e.v !== void 0 ? e.v : t.v, e.lvl !== void 0 ? e.lvl : t.lvl, e.l !== void 0 ? e.l : t.l, e.r !== void 0 ? e.r : t.r);
}
function Fn(t) {
  return j(t.r) ? t.l : ge(ot(t, {
    r: Fn(t.r)
  }));
}
function He(t) {
  return j(t) || t.lvl > t.r.lvl;
}
function zn(t) {
  return j(t.r) ? [t.k, t.v] : zn(t.r);
}
function Ln(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : oe;
  let r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : oe;
  return {
    k: t,
    l: o,
    lvl: n,
    r,
    v: e
  };
}
function dn(t) {
  return Le(Pn(t));
}
function Pn(t) {
  const {
    l: e
  } = t;
  return !j(e) && e.lvl === t.lvl ? ot(e, {
    r: ot(t, {
      l: e.r
    })
  }) : t;
}
function Le(t) {
  const {
    lvl: e,
    r: n
  } = t;
  return !j(n) && !j(n.r) && n.lvl === e && n.r.lvl === e ? ot(n, {
    l: ot(t, {
      r: n.l
    }),
    lvl: e + 1
  }) : t;
}
function So(t) {
  return On(t, _ref37 => {
    let {
      k: e,
      v: n
    } = _ref37;
    return {
      index: e,
      value: n
    };
  });
}
function Vn(t, e) {
  return !!(t && t.startIndex === e.startIndex && t.endIndex === e.endIndex);
}
function se(t, e) {
  return !!(t && t[0] === e[0] && t[1] === e[1]);
}
const Ge = U(() => ({
  recalcInProgress: w(!1)
}), [], {
  singleton: !0
});
function An(t, e, n) {
  return t[Se(t, e, n)];
}
function Se(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  let r = t.length - 1;
  for (; o <= r;) {
    const s = Math.floor((o + r) / 2),
      i = t[s],
      l = n(i, e);
    if (l === 0) return s;
    if (l === -1) {
      if (r - o < 2) return s - 1;
      r = s - 1;
    } else {
      if (r === o) return s;
      o = s + 1;
    }
  }
  throw new Error("Failed binary finding record in array - ".concat(t.join(","), ", searched for ").concat(e));
}
function xo(t, e, n, o) {
  const r = Se(t, e, o),
    s = Se(t, n, o, r);
  return t.slice(r, s + 1);
}
function Ct(t, e) {
  return Math.round(t.getBoundingClientRect()[e]);
}
function be(t) {
  return !j(t.groupOffsetTree);
}
function Ne(_ref38, e) {
  let {
    index: t
  } = _ref38;
  return e === t ? 0 : e < t ? -1 : 1;
}
function To() {
  return {
    groupIndices: [],
    groupOffsetTree: Kt(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    offsetTree: [],
    sizeTree: Kt()
  };
}
function wo(t, e) {
  let n = j(t) ? 0 : 1 / 0;
  for (const o of e) {
    const {
      endIndex: r,
      size: s,
      startIndex: i
    } = o;
    if (n = Math.min(n, i), j(t)) {
      t = mt(t, 0, s);
      continue;
    }
    const l = ve(t, i - 1, r + 1);
    if (l.some(Ho(o))) continue;
    let c = !1,
      d = !1;
    for (const {
      end: f,
      start: S,
      value: p
    } of l) c ? (r >= S || s === p) && (t = Fe(t, S)) : (d = p !== s, c = !0), f > r && r >= S && p !== s && (t = mt(t, r + 1, p));
    d && (t = mt(t, i, s));
  }
  return [t, n];
}
function Co(t) {
  return typeof t.groupIndex < "u";
}
function yo(_ref39, e) {
  let {
    offset: t
  } = _ref39;
  return e === t ? 0 : e < t ? -1 : 1;
}
function ie(t, e, n) {
  if (e.length === 0) return 0;
  const {
      index: o,
      offset: r,
      size: s
    } = An(e, t, Ne),
    i = t - o,
    l = s * i + (i - 1) * n + r;
  return l > 0 ? l + n : l;
}
function Wn(t, e) {
  if (!be(e)) return t;
  let n = 0;
  for (; e.groupIndices[n] <= t + n;) n++;
  return t + n;
}
function Mn(t, e, n) {
  if (Co(t)) return e.groupIndices[t.groupIndex] + 1;
  {
    const o = t.index === "LAST" ? n : t.index;
    let r = Wn(o, e);
    return r = Math.max(0, r, Math.min(n, r)), r;
  }
}
function vo(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return o > 0 && (e = Math.max(e, An(t, o, Ne).offset)), On(xo(t, e, n, yo), Eo);
}
function bo(t, _ref40) {
  let [e, n, o, r] = _ref40;
  e.length > 0 && o("received item sizes", e, ht.DEBUG);
  const s = t.sizeTree;
  let i = s,
    l = 0;
  if (n.length > 0 && j(s) && e.length === 2) {
    const p = e[0].size,
      m = e[1].size;
    i = n.reduce((C, I) => mt(mt(C, I, p), I + 1, m), i);
  } else [i, l] = wo(i, e);
  if (i === s) return t;
  const {
    lastIndex: c,
    lastOffset: d,
    lastSize: f,
    offsetTree: S
  } = Pe(t.offsetTree, l, i, r);
  return {
    groupIndices: n,
    groupOffsetTree: n.reduce((p, m) => mt(p, m, ie(m, S, r)), Kt()),
    lastIndex: c,
    lastOffset: d,
    lastSize: f,
    offsetTree: S,
    sizeTree: i
  };
}
function Ro(t) {
  return _t(t).map((_ref41, o, r) => {
    let {
      k: e,
      v: n
    } = _ref41;
    const s = r[o + 1];
    return {
      endIndex: s ? s.k - 1 : 1 / 0,
      size: n,
      startIndex: e
    };
  });
}
function fn(t, e) {
  let n = 0,
    o = 0;
  for (; n < t;) n += e[o + 1] - e[o] - 1, o++;
  return o - (n === t ? 0 : 1);
}
function Pe(t, e, n, o) {
  let r = t,
    s = 0,
    i = 0,
    l = 0,
    c = 0;
  if (e !== 0) {
    c = Se(r, e - 1, Ne), l = r[c].offset;
    const f = wt(n, e - 1);
    s = f[0], i = f[1], r.length && r[c].size === wt(n, e)[1] && (c -= 1), r = r.slice(0, c + 1);
  } else r = [];
  for (const {
    start: d,
    value: f
  } of ve(n, e, 1 / 0)) {
    const S = d - s,
      p = S * i + l + S * o;
    r.push({
      index: d,
      offset: p,
      size: f
    }), s = d, l = p, i = f;
  }
  return {
    lastIndex: s,
    lastOffset: l,
    lastSize: i,
    offsetTree: r
  };
}
function Eo(t) {
  return {
    index: t.index,
    value: t
  };
}
function Ho(t) {
  const {
    endIndex: e,
    size: n,
    startIndex: o
  } = t;
  return r => r.start === o && (r.end === e || r.end === 1 / 0) && r.value === n;
}
const Bo = {
    offsetHeight: "height",
    offsetWidth: "width"
  },
  Ht = U(_ref42 => {
    let [{
      log: t
    }, {
      recalcInProgress: e
    }] = _ref42;
    const n = $$7(),
      o = $$7(),
      r = ct(o, 0),
      s = $$7(),
      i = $$7(),
      l = w(0),
      c = w([]),
      d = w(void 0),
      f = w(void 0),
      S = w((h, a) => Ct(h, Bo[a])),
      p = w(void 0),
      m = w(0),
      C = To(),
      I = ct(x(n, G(c, t, m), bt(bo, C), Y()), C),
      y = ct(x(c, Y(), bt((h, a) => ({
        current: a,
        prev: h.current
      }), {
        current: [],
        prev: []
      }), H(_ref43 => {
        let {
          prev: h
        } = _ref43;
        return h;
      })), []);
    F(x(c, V(h => h.length > 0), G(I, m), H(_ref44 => {
      let [h, a, R] = _ref44;
      const k = h.reduce((O, z, P) => mt(O, z, ie(z, a.offsetTree, R) || P), Kt());
      return {
        ...a,
        groupIndices: h,
        groupOffsetTree: k
      };
    })), I), F(x(o, G(I), V(_ref45 => {
      let [h, {
        lastIndex: a
      }] = _ref45;
      return h < a;
    }), H(_ref46 => {
      let [h, {
        lastIndex: a,
        lastSize: R
      }] = _ref46;
      return [{
        endIndex: a,
        size: R,
        startIndex: h
      }];
    })), n), F(d, f);
    const g = ct(x(d, H(h => h === void 0)), !0);
    F(x(f, V(h => h !== void 0 && j(lt(I).sizeTree)), H(h => [{
      endIndex: 0,
      size: h,
      startIndex: 0
    }])), n);
    const u = pt(x(n, G(I), bt((_ref47, _ref48) => {
      let {
        sizes: h
      } = _ref47;
      let [a, R] = _ref48;
      return {
        changed: R !== h,
        sizes: R
      };
    }, {
      changed: !1,
      sizes: C
    }), H(h => h.changed)));
    K(x(l, bt((h, a) => ({
      diff: h.prev - a,
      prev: a
    }), {
      diff: 0,
      prev: 0
    }), H(h => h.diff)), h => {
      const {
        groupIndices: a
      } = lt(I);
      if (h > 0) M(e, !0), M(s, h + fn(h, a));else if (h < 0) {
        const R = lt(y);
        R.length > 0 && (h -= fn(-h, R)), M(i, h);
      }
    }), K(x(l, G(t)), _ref49 => {
      let [h, a] = _ref49;
      h < 0 && a("`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value", {
        firstItemIndex: l
      }, ht.ERROR);
    });
    const T = pt(s);
    F(x(s, G(I), H(_ref50 => {
      let [h, a] = _ref50;
      const R = a.groupIndices.length > 0,
        k = [],
        O = a.lastSize;
      if (R) {
        const z = re(a.sizeTree, 0);
        let P = 0,
          D = 0;
        for (; P < h;) {
          const B = a.groupIndices[D],
            q = a.groupIndices.length === D + 1 ? 1 / 0 : a.groupIndices[D + 1] - B - 1;
          k.push({
            endIndex: B,
            size: z,
            startIndex: B
          }), k.push({
            endIndex: B + 1 + q - 1,
            size: O,
            startIndex: B + 1
          }), D++, P += q + 1;
        }
        const J = _t(a.sizeTree);
        return P !== h && J.shift(), J.reduce((B, _ref51) => {
          let {
            k: q,
            v: st
          } = _ref51;
          let dt = B.ranges;
          return B.prevSize !== 0 && (dt = [...B.ranges, {
            endIndex: q + h - 1,
            size: B.prevSize,
            startIndex: B.prevIndex
          }]), {
            prevIndex: q + h,
            prevSize: st,
            ranges: dt
          };
        }, {
          prevIndex: h,
          prevSize: 0,
          ranges: k
        }).ranges;
      }
      return _t(a.sizeTree).reduce((z, _ref52) => {
        let {
          k: P,
          v: D
        } = _ref52;
        return {
          prevIndex: P + h,
          prevSize: D,
          ranges: [...z.ranges, {
            endIndex: P + h - 1,
            size: z.prevSize,
            startIndex: z.prevIndex
          }]
        };
      }, {
        prevIndex: 0,
        prevSize: O,
        ranges: []
      }).ranges;
    })), n);
    const b = pt(x(i, G(I, m), H(_ref53 => {
      let [h, {
        offsetTree: a
      }, R] = _ref53;
      const k = -h;
      return ie(k, a, R);
    })));
    return F(x(i, G(I, m), H(_ref54 => {
      let [h, a, R] = _ref54;
      if (a.groupIndices.length > 0) {
        if (j(a.sizeTree)) return a;
        let O = Kt();
        const z = lt(y);
        let P = 0,
          D = 0,
          J = 0;
        for (; P < -h;) {
          J = z[D];
          const B = z[D + 1] - J - 1;
          D++, P += B + 1;
        }
        if (O = _t(a.sizeTree).reduce((B, _ref55) => {
          let {
            k: q,
            v: st
          } = _ref55;
          return mt(B, Math.max(0, q + h), st);
        }, O), P !== -h) {
          const B = re(a.sizeTree, J);
          O = mt(O, 0, B);
          const q = wt(a.sizeTree, -h + 1)[1];
          O = mt(O, 1, q);
        }
        return {
          ...a,
          sizeTree: O,
          ...Pe(a.offsetTree, 0, O, R)
        };
      } else {
        const O = _t(a.sizeTree).reduce((z, _ref56) => {
          let {
            k: P,
            v: D
          } = _ref56;
          return mt(z, Math.max(0, P + h), D);
        }, Kt());
        return {
          ...a,
          sizeTree: O,
          ...Pe(a.offsetTree, 0, O, R)
        };
      }
    })), I), {
      beforeUnshiftWith: T,
      // input
      data: p,
      defaultItemSize: f,
      firstItemIndex: l,
      fixedItemSize: d,
      gap: m,
      groupIndices: c,
      itemSize: S,
      listRefresh: u,
      shiftWith: i,
      shiftWithOffset: b,
      sizeRanges: n,
      // output
      sizes: I,
      statefulTotalCount: r,
      totalCount: o,
      trackItemSizes: g,
      unshiftWith: s
    };
  }, X(Pt, Ge), {
    singleton: !0
  });
function ko(t) {
  return t.reduce((e, n) => (e.groupIndices.push(e.totalCount), e.totalCount += n + 1, e), {
    groupIndices: [],
    totalCount: 0
  });
}
const _n = U(_ref57 => {
    let [{
      groupIndices: t,
      sizes: e,
      totalCount: n
    }, {
      headerHeight: o,
      scrollTop: r
    }] = _ref57;
    const s = $$7(),
      i = $$7(),
      l = pt(x(s, H(ko)));
    return F(x(l, H(c => c.totalCount)), n), F(x(l, H(c => c.groupIndices)), t), F(x(rt(r, e, o), V(_ref58 => {
      let [c, d] = _ref58;
      return be(d);
    }), H(_ref59 => {
      let [c, d, f] = _ref59;
      return wt(d.groupOffsetTree, Math.max(c - f, 0), "v")[0];
    }), Y(), H(c => [c])), i), {
      groupCounts: s,
      topItemsIndexes: i
    };
  }, X(Ht, at)),
  Vt = U(_ref60 => {
    let [{
      log: t
    }] = _ref60;
    const e = w(!1),
      n = pt(x(e, V(o => o), Y()));
    return K(e, o => {
      o && lt(t)("props updated", {}, ht.DEBUG);
    }), {
      didMount: n,
      propsReady: e
    };
  }, X(Pt), {
    singleton: !0
  }),
  Oo = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function Gn(t) {
  const e = typeof t == "number" ? {
    index: t
  } : t;
  return e.align || (e.align = "start"), (!e.behavior || !Oo) && (e.behavior = "auto"), e.offset || (e.offset = 0), e;
}
const ce = U(_ref61 => {
  let [{
    gap: t,
    listRefresh: e,
    sizes: n,
    totalCount: o
  }, {
    fixedFooterHeight: r,
    fixedHeaderHeight: s,
    footerHeight: i,
    headerHeight: l,
    scrollingInProgress: c,
    scrollTo: d,
    smoothScrollTargetReached: f,
    viewportHeight: S
  }, {
    log: p
  }] = _ref61;
  const m = $$7(),
    C = $$7(),
    I = w(0);
  let y = null,
    g = null,
    u = null;
  function T() {
    y && (y(), y = null), u && (u(), u = null), g && (clearTimeout(g), g = null), M(c, !1);
  }
  return F(x(m, G(n, S, o, I, l, i, p), G(t, s, r), H(_ref62 => {
    let [[b, h, a, R, k, O, z, P], D, J, nt] = _ref62;
    const B = Gn(b),
      {
        align: q,
        behavior: st,
        offset: dt
      } = B,
      St = R - 1,
      ft = Mn(B, h, St);
    let ut = ie(ft, h.offsetTree, D) + O;
    q === "end" ? (ut += J + wt(h.sizeTree, ft)[1] - a + nt, ft === St && (ut += z)) : q === "center" ? ut += (J + wt(h.sizeTree, ft)[1] - a + nt) / 2 : ut -= k, dt && (ut += dt);
    const At = xt => {
      T(), xt ? (P("retrying to scroll to", {
        location: b
      }, ht.DEBUG), M(m, b)) : (M(C, !0), P("list did not change, scroll successful", {}, ht.DEBUG));
    };
    if (T(), st === "smooth") {
      let xt = !1;
      u = K(e, Xt => {
        xt = xt || Xt;
      }), y = Rt(f, () => {
        At(xt);
      });
    } else y = Rt(x(e, Fo(150)), At);
    return g = setTimeout(() => {
      T();
    }, 1200), M(c, !0), P("scrolling from index to", {
      behavior: st,
      index: ft,
      top: ut
    }, ht.DEBUG), {
      behavior: st,
      top: ut
    };
  })), d), {
    scrollTargetReached: C,
    scrollToIndex: m,
    topListHeight: I
  };
}, X(Ht, at, Pt), {
  singleton: !0
});
function Fo(t) {
  return e => {
    const n = setTimeout(() => {
      e(!1);
    }, t);
    return o => {
      o && (e(!0), clearTimeout(n));
    };
  };
}
function De(t, e) {
  t == 0 ? e() : requestAnimationFrame(() => {
    De(t - 1, e);
  });
}
function $e(t, e) {
  const n = e - 1;
  return typeof t == "number" ? t : t.index === "LAST" ? n : t.index;
}
const ue = U(_ref63 => {
  let [{
    defaultItemSize: t,
    listRefresh: e,
    sizes: n
  }, {
    scrollTop: o
  }, {
    scrollTargetReached: r,
    scrollToIndex: s
  }, {
    didMount: i
  }] = _ref63;
  const l = w(!0),
    c = w(0),
    d = w(!0);
  return F(x(i, G(c), V(_ref64 => {
    let [f, S] = _ref64;
    return !!S;
  }), vt(!1)), l), F(x(i, G(c), V(_ref65 => {
    let [f, S] = _ref65;
    return !!S;
  }), vt(!1)), d), K(x(rt(e, i), G(l, n, t, d), V(_ref66 => {
    let [[, f], S, {
      sizeTree: p
    }, m, C] = _ref66;
    return f && (!j(p) || Ae(m)) && !S && !C;
  }), G(c)), _ref67 => {
    let [, f] = _ref67;
    Rt(r, () => {
      M(d, !0);
    }), De(4, () => {
      Rt(o, () => {
        M(l, !0);
      }), M(s, f);
    });
  }), {
    initialItemFinalLocationReached: d,
    initialTopMostItemIndex: c,
    scrolledToInitialItem: l
  };
}, X(Ht, at, ce, Vt), {
  singleton: !0
});
function Nn(t, e) {
  return Math.abs(t - e) < 1.01;
}
const le = "up",
  te = "down",
  zo = "none",
  Lo = {
    atBottom: !1,
    notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
    state: {
      offsetBottom: 0,
      scrollHeight: 0,
      scrollTop: 0,
      viewportHeight: 0
    }
  },
  Po = 0,
  ae = U(_ref68 => {
    let [{
      footerHeight: t,
      headerHeight: e,
      scrollBy: n,
      scrollContainerState: o,
      scrollTop: r,
      viewportHeight: s
    }] = _ref68;
    const i = w(!1),
      l = w(!0),
      c = $$7(),
      d = $$7(),
      f = w(4),
      S = w(Po),
      p = ct(x(un(x(A(r), qt(1), vt(!0)), x(A(r), qt(1), vt(!1), cn(100))), Y()), !1),
      m = ct(x(un(x(n, vt(!0)), x(n, vt(!1), cn(200))), Y()), !1);
    F(x(rt(A(r), A(S)), H(_ref69 => {
      let [u, T] = _ref69;
      return u <= T;
    }), Y()), l), F(x(l, zt(50)), d);
    const C = pt(x(rt(o, A(s), A(e), A(t), A(f)), bt((u, _ref70) => {
        let [{
          scrollHeight: T,
          scrollTop: b
        }, h, a, R, k] = _ref70;
        const O = b + h - T > -k,
          z = {
            scrollHeight: T,
            scrollTop: b,
            viewportHeight: h
          };
        if (O) {
          let D, J;
          return b > u.state.scrollTop ? (D = "SCROLLED_DOWN", J = u.state.scrollTop - b) : (D = "SIZE_DECREASED", J = u.state.scrollTop - b || u.scrollTopDelta), {
            atBottom: !0,
            atBottomBecause: D,
            scrollTopDelta: J,
            state: z
          };
        }
        let P;
        return z.scrollHeight > u.state.scrollHeight ? P = "SIZE_INCREASED" : h < u.state.viewportHeight ? P = "VIEWPORT_HEIGHT_DECREASING" : b < u.state.scrollTop ? P = "SCROLLING_UPWARDS" : P = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: P,
          state: z
        };
      }, Lo), Y((u, T) => u && u.atBottom === T.atBottom))),
      I = ct(x(o, bt((u, _ref71) => {
        let {
          scrollHeight: T,
          scrollTop: b,
          viewportHeight: h
        } = _ref71;
        if (Nn(u.scrollHeight, T)) return {
          changed: !1,
          jump: 0,
          scrollHeight: T,
          scrollTop: b
        };
        {
          const a = T - (b + h) < 1;
          return u.scrollTop !== b && a ? {
            changed: !0,
            jump: u.scrollTop - b,
            scrollHeight: T,
            scrollTop: b
          } : {
            changed: !0,
            jump: 0,
            scrollHeight: T,
            scrollTop: b
          };
        }
      }, {
        changed: !1,
        jump: 0,
        scrollHeight: 0,
        scrollTop: 0
      }), V(u => u.changed), H(u => u.jump)), 0);
    F(x(C, H(u => u.atBottom)), i), F(x(i, zt(50)), c);
    const y = w(te);
    F(x(o, H(_ref72 => {
      let {
        scrollTop: u
      } = _ref72;
      return u;
    }), Y(), bt((u, T) => lt(m) ? {
      direction: u.direction,
      prevScrollTop: T
    } : {
      direction: T < u.prevScrollTop ? le : te,
      prevScrollTop: T
    }, {
      direction: te,
      prevScrollTop: 0
    }), H(u => u.direction)), y), F(x(o, zt(50), vt(zo)), y);
    const g = w(0);
    return F(x(p, V(u => !u), vt(0)), g), F(x(r, zt(100), G(p), V(_ref73 => {
      let [u, T] = _ref73;
      return !!T;
    }), bt((_ref74, _ref75) => {
      let [u, T] = _ref74;
      let [b] = _ref75;
      return [T, b];
    }, [0, 0]), H(_ref76 => {
      let [u, T] = _ref76;
      return T - u;
    })), g), {
      atBottomState: C,
      atBottomStateChange: c,
      atBottomThreshold: f,
      atTopStateChange: d,
      atTopThreshold: S,
      isAtBottom: i,
      isAtTop: l,
      isScrolling: p,
      lastJumpDueToItemResize: I,
      scrollDirection: y,
      scrollVelocity: g
    };
  }, X(at)),
  xe = "top",
  Te = "bottom",
  mn = "none";
function pn(t, e, n) {
  return typeof t == "number" ? n === le && e === xe || n === te && e === Te ? t : 0 : n === le ? e === xe ? t.main : t.reverse : e === Te ? t.main : t.reverse;
}
function hn(t, e) {
  var n;
  return typeof t == "number" ? t : (n = t[e]) != null ? n : 0;
}
const Ue = U(_ref77 => {
  let [{
    deviation: t,
    fixedHeaderHeight: e,
    headerHeight: n,
    scrollTop: o,
    viewportHeight: r
  }] = _ref77;
  const s = $$7(),
    i = w(0),
    l = w(0),
    c = w(0),
    d = ct(x(rt(A(o), A(r), A(n), A(s, se), A(c), A(i), A(e), A(t), A(l)), H(_ref78 => {
      let [f, S, p, [m, C], I, y, g, u, T] = _ref78;
      const b = f - u,
        h = y + g,
        a = Math.max(p - b, 0);
      let R = mn;
      const k = hn(T, xe),
        O = hn(T, Te);
      return m -= u, m += p + g, C += p + g, C -= u, m > f + h - k && (R = le), C < f - a + S + O && (R = te), R !== mn ? [Math.max(b - p - pn(I, xe, R) - k, 0), b - a - g + S + pn(I, Te, R) + O] : null;
    }), V(f => f != null), Y(se)), [0, 0]);
  return {
    increaseViewportBy: l,
    // input
    listBoundary: s,
    overscan: c,
    topListHeight: i,
    // output
    visibleRange: d
  };
}, X(at), {
  singleton: !0
});
function Vo(t, e, n) {
  if (be(e)) {
    const o = Wn(t, e);
    return [{
      index: wt(e.groupOffsetTree, o)[0],
      offset: 0,
      size: 0
    }, {
      data: n == null ? void 0 : n[0],
      index: o,
      offset: 0,
      size: 0
    }];
  }
  return [{
    data: n == null ? void 0 : n[0],
    index: t,
    offset: 0,
    size: 0
  }];
}
const Be = {
  bottom: 0,
  firstItemIndex: 0,
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  topItems: [],
  topListHeight: 0,
  totalCount: 0
};
function Ie(t, e, n, o, r, s) {
  const {
    lastIndex: i,
    lastOffset: l,
    lastSize: c
  } = r;
  let d = 0,
    f = 0;
  if (t.length > 0) {
    d = t[0].offset;
    const I = t[t.length - 1];
    f = I.offset + I.size;
  }
  const S = n - i,
    p = l + S * c + (S - 1) * o,
    m = d,
    C = p - f;
  return {
    bottom: f,
    firstItemIndex: s,
    items: gn(t, r, s),
    offsetBottom: C,
    offsetTop: d,
    top: m,
    topItems: gn(e, r, s),
    topListHeight: e.reduce((I, y) => y.size + I, 0),
    totalCount: n
  };
}
function Dn(t, e, n, o, r, s) {
  let i = 0;
  if (n.groupIndices.length > 0) for (const f of n.groupIndices) {
    if (f - i >= t) break;
    i++;
  }
  const l = t + i,
    c = $e(e, l),
    d = Array.from({
      length: l
    }).map((f, S) => ({
      data: s[S + c],
      index: S + c,
      offset: 0,
      size: 0
    }));
  return Ie(d, [], l, r, n, o);
}
function gn(t, e, n) {
  if (t.length === 0) return [];
  if (!be(e)) return t.map(d => ({
    ...d,
    index: d.index + n,
    originalIndex: d.index
  }));
  const o = t[0].index,
    r = t[t.length - 1].index,
    s = [],
    i = ve(e.groupOffsetTree, o, r);
  let l,
    c = 0;
  for (const d of t) {
    (!l || l.end < d.index) && (l = i.shift(), c = e.groupIndices.indexOf(l.start));
    let f;
    d.index === l.start ? f = {
      index: c,
      type: "group"
    } : f = {
      groupIndex: c,
      index: d.index - (c + 1) + n
    }, s.push({
      ...f,
      data: d.data,
      offset: d.offset,
      originalIndex: d.index,
      size: d.size
    });
  }
  return s;
}
const Nt = U(_ref79 => {
    let [{
      data: t,
      firstItemIndex: e,
      gap: n,
      sizes: o,
      totalCount: r
    }, s, {
      listBoundary: i,
      topListHeight: l,
      visibleRange: c
    }, {
      initialTopMostItemIndex: d,
      scrolledToInitialItem: f
    }, {
      topListHeight: S
    }, p, {
      didMount: m
    }, {
      recalcInProgress: C
    }] = _ref79;
    const I = w([]),
      y = w(0),
      g = $$7();
    F(s.topItemsIndexes, I);
    const u = ct(x(rt(m, C, A(c, se), A(r), A(o), A(d), f, A(I), A(e), A(n), t), V(_ref80 => {
      let [a, R,, k,,,,,,, O] = _ref80;
      const z = O && O.length !== k;
      return a && !R && !z;
    }), H(_ref81 => {
      let [,, [a, R], k, O, z, P, D, J, nt, B] = _ref81;
      const q = O,
        {
          offsetTree: st,
          sizeTree: dt
        } = q,
        St = lt(y);
      if (k === 0) return {
        ...Be,
        totalCount: k
      };
      if (a === 0 && R === 0) return St === 0 ? {
        ...Be,
        totalCount: k
      } : Dn(St, z, O, J, nt, B || []);
      if (j(dt)) return St > 0 ? null : Ie(Vo($e(z, k), q, B), [], k, nt, q, J);
      const ft = [];
      if (D.length > 0) {
        const Wt = D[0],
          yt = D[D.length - 1];
        let Bt = 0;
        for (const v of ve(dt, Wt, yt)) {
          const N = v.value,
            Q = Math.max(v.start, Wt),
            it = Math.min(v.end, yt);
          for (let tt = Q; tt <= it; tt++) ft.push({
            data: B == null ? void 0 : B[tt],
            index: tt,
            offset: Bt,
            size: N
          }), Bt += N;
        }
      }
      if (!P) return Ie([], ft, k, nt, q, J);
      const ut = D.length > 0 ? D[D.length - 1] + 1 : 0,
        At = vo(st, a, R, ut);
      if (At.length === 0) return null;
      const xt = k - 1,
        Xt = ye([], Wt => {
          for (const yt of At) {
            const Bt = yt.value;
            let v = Bt.offset,
              N = yt.start;
            const Q = Bt.size;
            if (Bt.offset < a) {
              N += Math.floor((a - Bt.offset + nt) / (Q + nt));
              const tt = N - yt.start;
              v += tt * Q + tt * nt;
            }
            N < ut && (v += (ut - N) * Q, N = ut);
            const it = Math.min(yt.end, xt);
            for (let tt = N; tt <= it && !(v >= R); tt++) Wt.push({
              data: B == null ? void 0 : B[tt],
              index: tt,
              offset: v,
              size: Q
            }), v += Q + nt;
          }
        });
      return Ie(Xt, ft, k, nt, q, J);
    }),
    //@ts-expect-error filter needs to be fixed
    V(a => a !== null), Y()), Be);
    F(x(t, V(Ae), H(a => a == null ? void 0 : a.length)), r), F(x(u, H(a => a.topListHeight)), S), F(S, l), F(x(u, H(a => [a.top, a.bottom])), i), F(x(u, H(a => a.items)), g);
    const T = pt(x(u, V(_ref82 => {
        let {
          items: a
        } = _ref82;
        return a.length > 0;
      }), G(r, t), V(_ref83 => {
        let [{
          items: a
        }, R] = _ref83;
        return a[a.length - 1].originalIndex === R - 1;
      }), H(_ref84 => {
        let [, a, R] = _ref84;
        return [a - 1, R];
      }), Y(se), H(_ref85 => {
        let [a] = _ref85;
        return a;
      }))),
      b = pt(x(u, zt(200), V(_ref86 => {
        let {
          items: a,
          topItems: R
        } = _ref86;
        return a.length > 0 && a[0].originalIndex === R.length;
      }), H(_ref87 => {
        let {
          items: a
        } = _ref87;
        return a[0].index;
      }), Y())),
      h = pt(x(u, V(_ref88 => {
        let {
          items: a
        } = _ref88;
        return a.length > 0;
      }), H(_ref89 => {
        let {
          items: a
        } = _ref89;
        let R = 0,
          k = a.length - 1;
        for (; a[R].type === "group" && R < k;) R++;
        for (; a[k].type === "group" && k > R;) k--;
        return {
          endIndex: a[k].index,
          startIndex: a[R].index
        };
      }), Y(Vn)));
    return {
      endReached: T,
      initialItemCount: y,
      itemsRendered: g,
      listState: u,
      rangeChanged: h,
      startReached: b,
      topItemsIndexes: I,
      ...p
    };
  }, X(Ht, _n, Ue, ue, ce, ae, Vt, Ge), {
    singleton: !0
  }),
  $n = U(_ref90 => {
    let [{
      fixedFooterHeight: t,
      fixedHeaderHeight: e,
      footerHeight: n,
      headerHeight: o
    }, {
      listState: r
    }] = _ref90;
    const s = $$7(),
      i = ct(x(rt(n, t, o, e, r), H(_ref91 => {
        let [l, c, d, f, S] = _ref91;
        return l + c + d + f + S.offsetBottom + S.bottom;
      })), 0);
    return F(A(i), s), {
      totalListHeight: i,
      totalListHeightChanged: s
    };
  }, X(at, Nt), {
    singleton: !0
  }),
  Ao = U(_ref92 => {
    let [{
      viewportHeight: t
    }, {
      totalListHeight: e
    }] = _ref92;
    const n = w(!1),
      o = ct(x(rt(n, t, e), V(_ref93 => {
        let [r] = _ref93;
        return r;
      }), H(_ref94 => {
        let [, r, s] = _ref94;
        return Math.max(0, r - s);
      }), zt(0), Y()), 0);
    return {
      alignToBottom: n,
      paddingTopAddition: o
    };
  }, X(at, $n), {
    singleton: !0
  });
function In(t) {
  return t ? t === "smooth" ? "smooth" : "auto" : !1;
}
const Wo = (t, e) => typeof t == "function" ? In(t(e)) : e && In(t),
  Mo = U(_ref95 => {
    let [{
      listRefresh: t,
      totalCount: e
    }, {
      atBottomState: n,
      isAtBottom: o
    }, {
      scrollToIndex: r
    }, {
      scrolledToInitialItem: s
    }, {
      didMount: i,
      propsReady: l
    }, {
      log: c
    }, {
      scrollingInProgress: d
    }] = _ref95;
    const f = w(!1),
      S = $$7();
    let p = null;
    function m(I) {
      M(r, {
        align: "end",
        behavior: I,
        index: "LAST"
      });
    }
    K(x(rt(x(A(e), qt(1)), i), G(A(f), o, s, d), H(_ref96 => {
      let [[I, y], g, u, T, b] = _ref96;
      let h = y && T,
        a = "auto";
      return h && (a = Wo(g, u || b), h = h && !!a), {
        followOutputBehavior: a,
        shouldFollow: h,
        totalCount: I
      };
    }), V(_ref97 => {
      let {
        shouldFollow: I
      } = _ref97;
      return I;
    })), _ref98 => {
      let {
        followOutputBehavior: I,
        totalCount: y
      } = _ref98;
      p && (p(), p = null), p = Rt(t, () => {
        lt(c)("following output to ", {
          totalCount: y
        }, ht.DEBUG), m(I), p = null;
      });
    });
    function C(I) {
      const y = Rt(n, g => {
        I && !g.atBottom && g.notAtBottomBecause === "SIZE_INCREASED" && !p && (lt(c)("scrolling to bottom due to increased size", {}, ht.DEBUG), m("auto"));
      });
      setTimeout(y, 100);
    }
    return K(x(rt(A(f), e, l), V(_ref99 => {
      let [I,, y] = _ref99;
      return I && y;
    }), bt((_ref100, _ref101) => {
      let {
        value: I
      } = _ref100;
      let [, y] = _ref101;
      return {
        refreshed: I === y,
        value: y
      };
    }, {
      refreshed: !1,
      value: 0
    }), V(_ref102 => {
      let {
        refreshed: I
      } = _ref102;
      return I;
    }), G(f, e)), _ref103 => {
      let [, I] = _ref103;
      lt(s) && C(I !== !1);
    }), K(S, () => {
      C(lt(f) !== !1);
    }), K(rt(A(f), n), _ref104 => {
      let [I, y] = _ref104;
      I && !y.atBottom && y.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING" && m("auto");
    }), {
      autoscrollToBottom: S,
      followOutput: f
    };
  }, X(Ht, ae, ce, ue, Vt, Pt, at)),
  _o = U(_ref105 => {
    let [{
      data: t,
      firstItemIndex: e,
      gap: n,
      sizes: o
    }, {
      initialTopMostItemIndex: r
    }, {
      initialItemCount: s,
      listState: i
    }, {
      didMount: l
    }] = _ref105;
    return F(x(l, G(s), V(_ref106 => {
      let [, c] = _ref106;
      return c !== 0;
    }), G(r, o, e, n, t), H(_ref107 => {
      let [[, c], d, f, S, p, m = []] = _ref107;
      return Dn(c, d, f, S, p, m);
    })), i), {};
  }, X(Ht, ue, Nt, Vt), {
    singleton: !0
  }),
  Go = U(_ref108 => {
    let [{
      didMount: t
    }, {
      scrollTo: e
    }, {
      listState: n
    }] = _ref108;
    const o = w(0);
    return K(x(t, G(o), V(_ref109 => {
      let [, r] = _ref109;
      return r !== 0;
    }), H(_ref110 => {
      let [, r] = _ref110;
      return {
        top: r
      };
    })), r => {
      Rt(x(n, qt(1), V(s => s.items.length > 1)), () => {
        requestAnimationFrame(() => {
          M(e, r);
        });
      });
    }), {
      initialScrollTop: o
    };
  }, X(Vt, at, Nt), {
    singleton: !0
  }),
  No = _ref111 => {
    let {
      itemBottom: t,
      itemTop: e,
      locationParams: {
        align: n,
        behavior: o,
        ...r
      },
      viewportBottom: s,
      viewportTop: i
    } = _ref111;
    return e < i ? {
      ...r,
      align: n != null ? n : "start",
      behavior: o
    } : t > s ? {
      ...r,
      align: n != null ? n : "end",
      behavior: o
    } : null;
  },
  Do = U(_ref112 => {
    let [{
      gap: t,
      sizes: e,
      totalCount: n
    }, {
      fixedFooterHeight: o,
      fixedHeaderHeight: r,
      headerHeight: s,
      scrollingInProgress: i,
      scrollTop: l,
      viewportHeight: c
    }, {
      scrollToIndex: d
    }] = _ref112;
    const f = $$7();
    return F(x(f, G(e, c, n, s, r, o, l), G(t), H(_ref113 => {
      let [[S, p, m, C, I, y, g, u], T] = _ref113;
      const {
          align: b,
          behavior: h,
          calculateViewLocation: a = No,
          done: R,
          ...k
        } = S,
        O = Mn(S, p, C - 1),
        z = ie(O, p.offsetTree, T) + I + y,
        P = z + wt(p.sizeTree, O)[1],
        D = u + y,
        J = u + m - g,
        nt = a({
          itemBottom: P,
          itemTop: z,
          locationParams: {
            align: b,
            behavior: h,
            ...k
          },
          viewportBottom: J,
          viewportTop: D
        });
      return nt ? R && Rt(x(i, V(B => !B),
      // skips the initial publish of false, and the cleanup call.
      // but if scrollingInProgress is true, we skip the initial publish.
      qt(lt(i) ? 1 : 2)), R) : R && R(), nt;
    }), V(S => S !== null)), d), {
      scrollIntoView: f
    };
  }, X(Ht, at, ce, Nt, Pt), {
    singleton: !0
  }),
  Un = U(_ref114 => {
    let [{
      scrollVelocity: t
    }] = _ref114;
    const e = w(!1),
      n = $$7(),
      o = w(!1);
    return F(x(t, G(o, e, n), V(_ref115 => {
      let [r, s] = _ref115;
      return !!s;
    }), H(_ref116 => {
      let [r, s, i, l] = _ref116;
      const {
        enter: c,
        exit: d
      } = s;
      if (i) {
        if (d(r, l)) return !1;
      } else if (c(r, l)) return !0;
      return i;
    }), Y()), e), K(x(rt(e, t, n), G(o)), _ref117 => {
      let [[r, s, i], l] = _ref117;
      r && l && l.change && l.change(s, i);
    }), {
      isSeeking: e,
      scrollSeekConfiguration: o,
      scrollSeekRangeChanged: n,
      scrollVelocity: t
    };
  }, X(ae), {
    singleton: !0
  }),
  Ke = U(_ref118 => {
    let [{
      scrollContainerState: t,
      scrollTo: e
    }] = _ref118;
    const n = $$7(),
      o = $$7(),
      r = $$7(),
      s = w(!1),
      i = w(void 0);
    return F(x(rt(n, o), H(_ref119 => {
      let [{
        scrollHeight: l,
        scrollTop: c,
        viewportHeight: d
      }, {
        offsetTop: f
      }] = _ref119;
      return {
        scrollHeight: l,
        scrollTop: Math.max(0, c - f),
        viewportHeight: d
      };
    })), t), F(x(e, G(o), H(_ref120 => {
      let [l, {
        offsetTop: c
      }] = _ref120;
      return {
        ...l,
        top: l.top + c
      };
    })), r), {
      customScrollParent: i,
      // config
      useWindowScroll: s,
      // input
      windowScrollContainerState: n,
      // signals
      windowScrollTo: r,
      windowViewportRect: o
    };
  }, X(at)),
  $o = U(_ref121 => {
    let [{
      sizeRanges: t,
      sizes: e
    }, {
      headerHeight: n,
      scrollTop: o
    }, {
      initialTopMostItemIndex: r
    }, {
      didMount: s
    }, {
      useWindowScroll: i,
      windowScrollContainerState: l,
      windowViewportRect: c
    }] = _ref121;
    const d = $$7(),
      f = w(void 0),
      S = w(null),
      p = w(null);
    return F(l, S), F(c, p), K(x(d, G(e, o, i, S, p, n)), _ref122 => {
      let [m, C, I, y, g, u, T] = _ref122;
      const b = Ro(C.sizeTree);
      y && g !== null && u !== null && (I = g.scrollTop - u.offsetTop), I -= T, m({
        ranges: b,
        scrollTop: I
      });
    }), F(x(f, V(Ae), H(Uo)), r), F(x(s, G(f), V(_ref123 => {
      let [, m] = _ref123;
      return m !== void 0;
    }), Y(), H(_ref124 => {
      let [, m] = _ref124;
      return m.ranges;
    })), t), {
      getState: d,
      restoreStateFrom: f
    };
  }, X(Ht, at, ue, Vt, Ke));
function Uo(t) {
  return {
    align: "start",
    index: 0,
    offset: t.scrollTop
  };
}
const Ko = U(_ref125 => {
  let [{
    topItemsIndexes: t
  }] = _ref125;
  const e = w(0);
  return F(x(e, V(n => n >= 0), H(n => Array.from({
    length: n
  }).map((o, r) => r))), t), {
    topItemCount: e
  };
}, X(Nt));
function Kn(t) {
  let e = !1,
    n;
  return () => (e || (e = !0, n = t()), n);
}
const jo = Kn(() => /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent)),
  qo = U(_ref126 => {
    let [{
      deviation: t,
      scrollBy: e,
      scrollingInProgress: n,
      scrollTop: o
    }, {
      isAtBottom: r,
      isScrolling: s,
      lastJumpDueToItemResize: i,
      scrollDirection: l
    }, {
      listState: c
    }, {
      beforeUnshiftWith: d,
      gap: f,
      shiftWithOffset: S,
      sizes: p
    }, {
      log: m
    }, {
      recalcInProgress: C
    }] = _ref126;
    const I = pt(x(c, G(i), bt((_ref127, _ref128) => {
      let [, g, u, T] = _ref127;
      let [{
        bottom: b,
        items: h,
        offsetBottom: a,
        totalCount: R
      }, k] = _ref128;
      const O = b + a;
      let z = 0;
      return u === R && g.length > 0 && h.length > 0 && (h[0].originalIndex === 0 && g[0].originalIndex === 0 || (z = O - T, z !== 0 && (z += k))), [z, h, R, O];
    }, [0, [], 0, 0]), V(_ref129 => {
      let [g] = _ref129;
      return g !== 0;
    }), G(o, l, n, r, m, C), V(_ref130 => {
      let [, g, u, T,,, b] = _ref130;
      return !b && !T && g !== 0 && u === le;
    }), H(_ref131 => {
      let [[g],,,,, u] = _ref131;
      return u("Upward scrolling compensation", {
        amount: g
      }, ht.DEBUG), g;
    })));
    function y(g) {
      g > 0 ? (M(e, {
        behavior: "auto",
        top: -g
      }), M(t, 0)) : (M(t, 0), M(e, {
        behavior: "auto",
        top: -g
      }));
    }
    return K(x(I, G(t, s)), _ref132 => {
      let [g, u, T] = _ref132;
      T && jo() ? M(t, u - g) : y(-g);
    }), K(x(rt(ct(s, !1), t, C), V(_ref133 => {
      let [g, u, T] = _ref133;
      return !g && !T && u !== 0;
    }), H(_ref134 => {
      let [g, u] = _ref134;
      return u;
    }), zt(1)), y), F(x(S, H(g => ({
      top: -g
    }))), e), K(x(d, G(p, f), H(_ref135 => {
      let [g, {
        groupIndices: u,
        lastSize: T,
        sizeTree: b
      }, h] = _ref135;
      function a(R) {
        return R * (T + h);
      }
      if (u.length === 0) return a(g);
      {
        let R = 0;
        const k = re(b, 0);
        let O = 0,
          z = 0;
        for (; O < g;) {
          O++, R += k;
          let P = u.length === z + 1 ? 1 / 0 : u[z + 1] - u[z] - 1;
          O + P > g && (R -= k, P = g - O + 1), O += P, R += a(P), z++;
        }
        return R;
      }
    })), g => {
      M(t, g), requestAnimationFrame(() => {
        M(e, {
          top: g
        }), requestAnimationFrame(() => {
          M(t, 0), M(C, !1);
        });
      });
    }), {
      deviation: t
    };
  }, X(at, ae, Nt, Ht, Pt, Ge)),
  Yo = U(_ref136 => {
    let [t, e, n, o, r, s, i, l, c, d] = _ref136;
    return {
      ...t,
      ...e,
      ...n,
      ...o,
      ...r,
      ...s,
      ...i,
      ...l,
      ...c,
      ...d
    };
  }, X(Ue, _o, Vt, Un, $n, Go, Ao, Ke, Do, Pt)),
  jn = U(_ref137 => {
    let [{
      data: t,
      defaultItemSize: e,
      firstItemIndex: n,
      fixedItemSize: o,
      gap: r,
      groupIndices: s,
      itemSize: i,
      sizeRanges: l,
      sizes: c,
      statefulTotalCount: d,
      totalCount: f,
      trackItemSizes: S
    }, {
      initialItemFinalLocationReached: p,
      initialTopMostItemIndex: m,
      scrolledToInitialItem: C
    }, I, y, g, {
      listState: u,
      topItemsIndexes: T,
      ...b
    }, {
      scrollToIndex: h
    }, a, {
      topItemCount: R
    }, {
      groupCounts: k
    }, O] = _ref137;
    return F(b.rangeChanged, O.scrollSeekRangeChanged), F(x(O.windowViewportRect, H(z => z.visibleHeight)), I.viewportHeight), {
      data: t,
      defaultItemHeight: e,
      firstItemIndex: n,
      fixedItemHeight: o,
      gap: r,
      groupCounts: k,
      initialItemFinalLocationReached: p,
      initialTopMostItemIndex: m,
      scrolledToInitialItem: C,
      sizeRanges: l,
      topItemCount: R,
      topItemsIndexes: T,
      // input
      totalCount: f,
      ...g,
      groupIndices: s,
      itemSize: i,
      listState: u,
      scrollToIndex: h,
      // output
      statefulTotalCount: d,
      trackItemSizes: S,
      // exported from stateFlagsSystem
      ...b,
      // the bag of IO from featureGroup1System
      ...O,
      ...I,
      sizes: c,
      ...y
    };
  }, X(Ht, ue, at, $o, Mo, Nt, ce, qo, Ko, _n, Yo));
function Zo(t, e) {
  const n = {},
    o = {};
  let r = 0;
  const s = t.length;
  for (; r < s;) o[t[r]] = 1, r += 1;
  for (const i in e) Object.hasOwn(o, i) || (n[i] = e[i]);
  return n;
}
const pe = typeof document < "u" ? React__default.useLayoutEffect : React__default.useEffect;
function je(t, e, n) {
  const o = Object.keys(e.required || {}),
    r = Object.keys(e.optional || {}),
    s = Object.keys(e.methods || {}),
    i = Object.keys(e.events || {}),
    l = React__default.createContext({});
  function c(g, u) {
    g.propsReady && M(g.propsReady, !1);
    for (const T of o) {
      const b = g[e.required[T]];
      M(b, u[T]);
    }
    for (const T of r) if (T in u) {
      const b = g[e.optional[T]];
      M(b, u[T]);
    }
    g.propsReady && M(g.propsReady, !0);
  }
  function d(g) {
    return s.reduce((u, T) => (u[T] = b => {
      const h = g[e.methods[T]];
      M(h, b);
    }, u), {});
  }
  function f(g) {
    return i.reduce((u, T) => (u[T] = fo(g[e.events[T]]), u), {});
  }
  const S = React__default.forwardRef((g, u) => {
      const {
          children: T,
          ...b
        } = g,
        [h] = React__default.useState(() => ye(po(t), k => {
          c(k, b);
        })),
        [a] = React__default.useState(ln(f, h));
      pe(() => {
        for (const k of i) k in b && K(a[k], b[k]);
        return () => {
          Object.values(a).map(We);
        };
      }, [b, a, h]), pe(() => {
        c(h, b);
      }), React__default.useImperativeHandle(u, sn(d(h)));
      const R = n;
      return /* @__PURE__ */jsx(l.Provider, {
        value: h,
        children: n ? /* @__PURE__ */jsx(R, {
          ...Zo([...o, ...r, ...i], b),
          children: T
        }) : T
      });
    }),
    p = g => React__default.useCallback(Hn(M, React__default.useContext(l)[g]), [g]),
    m = g => {
      const T = React__default.useContext(l)[g],
        b = React__default.useCallback(h => K(T, h), [T]);
      return React__default.useSyncExternalStore(b, () => lt(T), () => lt(T));
    },
    C = g => {
      const T = React__default.useContext(l)[g],
        [b, h] = React__default.useState(ln(lt, T));
      return pe(() => K(T, a => {
        a !== b && h(sn(a));
      }), [T, b]), b;
    },
    I = React__default.version.startsWith("18") ? m : C;
  return {
    Component: S,
    useEmitter: (g, u) => {
      const b = React__default.useContext(l)[g];
      pe(() => K(b, u), [u, b]);
    },
    useEmitterValue: I,
    usePublisher: p
  };
}
const Re = React__default.createContext(void 0),
  qn = React__default.createContext(void 0),
  Yn = typeof document < "u" ? React__default.useLayoutEffect : React__default.useEffect;
function Zn(t, e, n) {
  let o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Gt;
  let r = arguments.length > 4 ? arguments[4] : undefined;
  let s = arguments.length > 5 ? arguments[5] : undefined;
  const i = React__default.useRef(null),
    l = React__default.useRef(null),
    c = React__default.useRef(null),
    d = React__default.useCallback(p => {
      const m = p.target,
        C = m === window || m === document,
        I = s ? C ? window.pageXOffset || document.documentElement.scrollLeft : m.scrollLeft : C ? window.pageYOffset || document.documentElement.scrollTop : m.scrollTop,
        y = s ? C ? document.documentElement.scrollWidth : m.scrollWidth : C ? document.documentElement.scrollHeight : m.scrollHeight,
        g = s ? C ? window.innerWidth : m.offsetWidth : C ? window.innerHeight : m.offsetHeight,
        u = () => {
          t({
            scrollHeight: y,
            scrollTop: Math.max(I, 0),
            viewportHeight: g
          });
        };
      p.suppressFlushSync ? u() : io.flushSync(u), l.current !== null && (I === l.current || I <= 0 || I === y - g) && (l.current = null, e(!0), c.current && (clearTimeout(c.current), c.current = null));
    }, [t, e]);
  React__default.useEffect(() => {
    const p = r || i.current;
    return o(r || i.current), d({
      suppressFlushSync: !0,
      target: p
    }), p.addEventListener("scroll", d, {
      passive: !0
    }), () => {
      o(null), p.removeEventListener("scroll", d);
    };
  }, [i, d, n, o, r]);
  function f(p) {
    const m = i.current;
    if (!m || (s ? "offsetWidth" in m && m.offsetWidth === 0 : "offsetHeight" in m && m.offsetHeight === 0)) return;
    const C = p.behavior === "smooth";
    let I, y, g;
    m === window ? (y = Math.max(Ct(document.documentElement, s ? "width" : "height"), s ? document.documentElement.scrollWidth : document.documentElement.scrollHeight), I = s ? window.innerWidth : window.innerHeight, g = s ? document.documentElement.scrollLeft : document.documentElement.scrollTop) : (y = m[s ? "scrollWidth" : "scrollHeight"], I = Ct(m, s ? "width" : "height"), g = m[s ? "scrollLeft" : "scrollTop"]);
    const u = y - I;
    if (p.top = Math.ceil(Math.max(Math.min(u, p.top), 0)), Nn(I, y) || p.top === g) {
      t({
        scrollHeight: y,
        scrollTop: g,
        viewportHeight: I
      }), C && e(!0);
      return;
    }
    C ? (l.current = p.top, c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      c.current = null, l.current = null, e(!0);
    }, 1e3)) : l.current = null, s && (p = {
      behavior: p.behavior,
      left: p.top
    }), m.scrollTo(p);
  }
  function S(p) {
    s && (p = {
      behavior: p.behavior,
      left: p.top
    }), i.current.scrollBy(p);
  }
  return {
    scrollByCallback: S,
    scrollerRef: i,
    scrollToCallback: f
  };
}
const ke = "-webkit-sticky",
  Sn = "sticky",
  Xn = Kn(() => {
    if (typeof document > "u") return Sn;
    const t = document.createElement("div");
    return t.style.position = ke, t.style.position === ke ? ke : Sn;
  });
function qe(t) {
  return t;
}
const Xo = /* @__PURE__ */U(() => {
    const t = w(c => "Item ".concat(c)),
      e = w(null),
      n = w(c => "Group ".concat(c)),
      o = w({}),
      r = w(qe),
      s = w("div"),
      i = w(Gt),
      l = function (c) {
        let d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return ct(x(o, H(f => f[c]), Y()), d);
      };
    return {
      components: o,
      computeItemKey: r,
      context: e,
      EmptyPlaceholder: l("EmptyPlaceholder"),
      FooterComponent: l("Footer"),
      GroupComponent: l("Group", "div"),
      groupContent: n,
      HeaderComponent: l("Header"),
      HeaderFooterTag: s,
      ItemComponent: l("Item", "div"),
      itemContent: t,
      ListComponent: l("List", "div"),
      ScrollerComponent: l("Scroller", "div"),
      scrollerRef: i,
      ScrollSeekPlaceholder: l("ScrollSeekPlaceholder"),
      TopItemListComponent: l("TopItemList")
    };
  }),
  Jo = /* @__PURE__ */U(_ref138 => {
    let [t, e] = _ref138;
    return {
      ...t,
      ...e
    };
  }, X(jn, Xo)),
  Qo = _ref139 => {
    let {
      height: t
    } = _ref139;
    return /* @__PURE__ */jsx("div", {
      style: {
        height: t
      }
    });
  },
  tr = {
    overflowAnchor: "none",
    position: Xn(),
    zIndex: 1
  },
  Jn = {
    overflowAnchor: "none"
  },
  er = {
    ...Jn,
    display: "inline-block",
    height: "100%"
  },
  xn = /* @__PURE__ */React__default.memo(function (_ref140) {
    let {
      showTopList: e = !1
    } = _ref140;
    const n = W("listState"),
      o = gt("sizeRanges"),
      r = W("useWindowScroll"),
      s = W("customScrollParent"),
      i = gt("windowScrollContainerState"),
      l = gt("scrollContainerState"),
      c = s || r ? i : l,
      d = W("itemContent"),
      f = W("context"),
      S = W("groupContent"),
      p = W("trackItemSizes"),
      m = W("itemSize"),
      C = W("log"),
      I = gt("gap"),
      y = W("horizontalDirection"),
      {
        callbackRef: g
      } = kn(o, m, p, e ? Gt : c, C, I, s, y, W("skipAnimationFrameInResizeObserver")),
      [u, T] = React__default.useState(0);
    Xe("deviation", B => {
      u !== B && T(B);
    });
    const b = W("EmptyPlaceholder"),
      h = W("ScrollSeekPlaceholder") || Qo,
      a = W("ListComponent"),
      R = W("ItemComponent"),
      k = W("GroupComponent"),
      O = W("computeItemKey"),
      z = W("isSeeking"),
      P = W("groupIndices").length > 0,
      D = W("alignToBottom"),
      J = W("initialItemFinalLocationReached"),
      nt = e ? {} : {
        boxSizing: "border-box",
        ...(y ? {
          display: "inline-block",
          height: "100%",
          marginLeft: u !== 0 ? u : D ? "auto" : 0,
          paddingLeft: n.offsetTop,
          paddingRight: n.offsetBottom,
          whiteSpace: "nowrap"
        } : {
          marginTop: u !== 0 ? u : D ? "auto" : 0,
          paddingBottom: n.offsetBottom,
          paddingTop: n.offsetTop
        }),
        ...(J ? {} : {
          visibility: "hidden"
        })
      };
    return !e && n.totalCount === 0 && b ? /* @__PURE__ */jsx(b, {
      ...Z(b, f)
    }) : /* @__PURE__ */jsx(a, {
      ...Z(a, f),
      "data-testid": e ? "virtuoso-top-item-list" : "virtuoso-item-list",
      ref: g,
      style: nt,
      children: (e ? n.topItems : n.items).map(B => {
        const q = B.originalIndex,
          st = O(q + n.firstItemIndex, B.data, f);
        return z ? /* @__PURE__ */createElement$2(h, {
          ...Z(h, f),
          height: B.size,
          index: B.index,
          key: st,
          type: B.type || "item",
          ...(B.type === "group" ? {} : {
            groupIndex: B.groupIndex
          })
        }) : B.type === "group" ? /* @__PURE__ */createElement$2(k, {
          ...Z(k, f),
          "data-index": q,
          "data-item-index": B.index,
          "data-known-size": B.size,
          key: st,
          style: tr
        }, S(B.index, f)) : /* @__PURE__ */createElement$2(R, {
          ...Z(R, f),
          ...Qn(R, B.data),
          "data-index": q,
          "data-item-group-index": B.groupIndex,
          "data-item-index": B.index,
          "data-known-size": B.size,
          key: st,
          style: y ? er : Jn
        }, P ? d(B.index, B.groupIndex, B.data, f) : d(B.index, B.data, f));
      })
    });
  }),
  nr = {
    height: "100%",
    outline: "none",
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
  },
  or = {
    outline: "none",
    overflowX: "auto",
    position: "relative"
  },
  Zt = t => ({
    height: "100%",
    position: "absolute",
    top: 0,
    width: "100%",
    ...(t ? {
      display: "flex",
      flexDirection: "column"
    } : {})
  }),
  rr = {
    position: Xn(),
    top: 0,
    width: "100%",
    zIndex: 1
  };
function Z(t, e) {
  if (typeof t != "string") return {
    context: e
  };
}
function Qn(t, e) {
  return {
    item: typeof t == "string" ? void 0 : e
  };
}
const sr = /* @__PURE__ */React__default.memo(function () {
    const e = W("HeaderComponent"),
      n = gt("headerHeight"),
      o = W("HeaderFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, W("skipAnimationFrameInResizeObserver")),
      s = W("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  }),
  ir = /* @__PURE__ */React__default.memo(function () {
    const e = W("FooterComponent"),
      n = gt("footerHeight"),
      o = W("HeaderFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, W("skipAnimationFrameInResizeObserver")),
      s = W("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  });
function Ye(_ref141) {
  let {
    useEmitter: t,
    useEmitterValue: e,
    usePublisher: n
  } = _ref141;
  return React__default.memo(function (_ref142) {
    let {
      children: s,
      style: i,
      ...l
    } = _ref142;
    const c = n("scrollContainerState"),
      d = e("ScrollerComponent"),
      f = n("smoothScrollTargetReached"),
      S = e("scrollerRef"),
      p = e("context"),
      m = e("horizontalDirection") || !1,
      {
        scrollByCallback: C,
        scrollerRef: I,
        scrollToCallback: y
      } = Zn(c, f, d, S, void 0, m);
    return t("scrollTo", y), t("scrollBy", C), /* @__PURE__ */jsx(d, {
      "data-testid": "virtuoso-scroller",
      "data-virtuoso-scroller": !0,
      ref: I,
      style: {
        ...(m ? or : nr),
        ...i
      },
      tabIndex: 0,
      ...l,
      ...Z(d, p),
      children: s
    });
  });
}
function Ze(_ref143) {
  let {
    useEmitter: t,
    useEmitterValue: e,
    usePublisher: n
  } = _ref143;
  return React__default.memo(function (_ref144) {
    let {
      children: s,
      style: i,
      ...l
    } = _ref144;
    const c = n("windowScrollContainerState"),
      d = e("ScrollerComponent"),
      f = n("smoothScrollTargetReached"),
      S = e("totalListHeight"),
      p = e("deviation"),
      m = e("customScrollParent"),
      C = e("context"),
      {
        scrollByCallback: I,
        scrollerRef: y,
        scrollToCallback: g
      } = Zn(c, f, d, Gt, m);
    return Yn(() => (y.current = m || window, () => {
      y.current = null;
    }), [y, m]), t("windowScrollTo", g), t("scrollBy", I), /* @__PURE__ */jsx(d, {
      "data-virtuoso-scroller": !0,
      style: {
        position: "relative",
        ...i,
        ...(S !== 0 ? {
          height: S + p
        } : {})
      },
      ...l,
      ...Z(d, C),
      children: s
    });
  });
}
const lr = _ref145 => {
    let {
      children: t
    } = _ref145;
    const e = React__default.useContext(Re),
      n = gt("viewportHeight"),
      o = gt("fixedItemHeight"),
      r = W("alignToBottom"),
      s = W("horizontalDirection"),
      i = React__default.useMemo(() => ne(n, c => Ct(c, s ? "width" : "height")), [n, s]),
      l = Et(i, !0, W("skipAnimationFrameInResizeObserver"));
    return React__default.useEffect(() => {
      e && (n(e.viewportHeight), o(e.itemHeight));
    }, [e, n, o]), /* @__PURE__ */jsx("div", {
      "data-viewport-type": "element",
      ref: l,
      style: Zt(r),
      children: t
    });
  },
  cr = _ref146 => {
    let {
      children: t
    } = _ref146;
    const e = React__default.useContext(Re),
      n = gt("windowViewportRect"),
      o = gt("fixedItemHeight"),
      r = W("customScrollParent"),
      s = _e(n, r, W("skipAnimationFrameInResizeObserver")),
      i = W("alignToBottom");
    return React__default.useEffect(() => {
      e && (o(e.itemHeight), n({
        offsetTop: 0,
        visibleHeight: e.viewportHeight,
        visibleWidth: 100
      }));
    }, [e, n, o]), /* @__PURE__ */jsx("div", {
      "data-viewport-type": "window",
      ref: s,
      style: Zt(i),
      children: t
    });
  },
  ur = _ref147 => {
    let {
      children: t
    } = _ref147;
    const e = W("TopItemListComponent") || "div",
      n = W("headerHeight"),
      o = {
        ...rr,
        marginTop: "".concat(n, "px")
      },
      r = W("context");
    return /* @__PURE__ */jsx(e, {
      style: o,
      ...Z(e, r),
      children: t
    });
  },
  ar = /* @__PURE__ */React__default.memo(function (e) {
    const n = W("useWindowScroll"),
      o = W("topItemsIndexes").length > 0,
      r = W("customScrollParent"),
      s = W("context"),
      i = r || n ? fr : dr,
      l = r || n ? cr : lr;
    return /* @__PURE__ */jsxs(i, {
      ...e,
      ...Z(i, s),
      children: [o && /* @__PURE__ */jsx(ur, {
        children: /* @__PURE__ */jsx(xn, {
          showTopList: !0
        })
      }), /* @__PURE__ */jsxs(l, {
        children: [/* @__PURE__ */jsx(sr, {}), /* @__PURE__ */jsx(xn, {}), /* @__PURE__ */jsx(ir, {})]
      })]
    });
  }),
  {
    Component: to,
    useEmitter: Xe,
    useEmitterValue: W,
    usePublisher: gt
  } = /* @__PURE__ */je(Jo, {
    events: {
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      endReached: "endReached",
      groupIndices: "groupIndices",
      isScrolling: "isScrolling",
      itemsRendered: "itemsRendered",
      rangeChanged: "rangeChanged",
      startReached: "startReached",
      totalListHeightChanged: "totalListHeightChanged"
    },
    methods: {
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState",
      scrollBy: "scrollBy",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollToIndex: "scrollToIndex"
    },
    optional: {
      alignToBottom: "alignToBottom",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      components: "components",
      computeItemKey: "computeItemKey",
      context: "context",
      customScrollParent: "customScrollParent",
      data: "data",
      defaultItemHeight: "defaultItemHeight",
      firstItemIndex: "firstItemIndex",
      fixedItemHeight: "fixedItemHeight",
      followOutput: "followOutput",
      groupContent: "groupContent",
      groupCounts: "groupCounts",
      headerFooterTag: "HeaderFooterTag",
      horizontalDirection: "horizontalDirection",
      increaseViewportBy: "increaseViewportBy",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      itemContent: "itemContent",
      itemSize: "itemSize",
      logLevel: "logLevel",
      overscan: "overscan",
      restoreStateFrom: "restoreStateFrom",
      scrollerRef: "scrollerRef",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver",
      topItemCount: "topItemCount",
      totalCount: "totalCount",
      useWindowScroll: "useWindowScroll"
    },
    required: {}
  }, ar),
  dr = /* @__PURE__ */Ye({
    useEmitter: Xe,
    useEmitterValue: W,
    usePublisher: gt
  }),
  fr = /* @__PURE__ */Ze({
    useEmitter: Xe,
    useEmitterValue: W,
    usePublisher: gt
  }),
  $r = to,
  wn = {
    bottom: 0,
    itemHeight: 0,
    items: [],
    itemWidth: 0,
    offsetBottom: 0,
    offsetTop: 0,
    top: 0
  },
  br = {
    bottom: 0,
    itemHeight: 0,
    items: [{
      index: 0
    }],
    itemWidth: 0,
    offsetBottom: 0,
    offsetTop: 0,
    top: 0
  },
  {
    ceil: Cn,
    floor: we,
    max: ee,
    min: Oe,
    round: yn
  } = Math;
function vn(t, e, n) {
  return Array.from({
    length: e - t + 1
  }).map((o, r) => ({
    data: n === null ? null : n[r + t],
    index: r + t
  }));
}
function Rr(t) {
  return {
    ...br,
    items: t
  };
}
function he(t, e) {
  return t && t.width === e.width && t.height === e.height;
}
function Er(t, e) {
  return t && t.column === e.column && t.row === e.row;
}
const Hr = /* @__PURE__ */U(_ref148 => {
  let [{
    increaseViewportBy: t,
    listBoundary: e,
    overscan: n,
    visibleRange: o
  }, {
    footerHeight: r,
    headerHeight: s,
    scrollBy: i,
    scrollContainerState: l,
    scrollTo: c,
    scrollTop: d,
    smoothScrollTargetReached: f,
    viewportHeight: S
  }, p, m, {
    didMount: C,
    propsReady: I
  }, {
    customScrollParent: y,
    useWindowScroll: g,
    windowScrollContainerState: u,
    windowScrollTo: T,
    windowViewportRect: b
  }, h] = _ref148;
  const a = w(0),
    R = w(0),
    k = w(wn),
    O = w({
      height: 0,
      width: 0
    }),
    z = w({
      height: 0,
      width: 0
    }),
    P = $$7(),
    D = $$7(),
    J = w(0),
    nt = w(null),
    B = w({
      column: 0,
      row: 0
    }),
    q = $$7(),
    st = $$7(),
    dt = w(!1),
    St = w(0),
    ft = w(!0),
    ut = w(!1),
    At = w(!1);
  K(x(C, G(St), V(_ref149 => {
    let [v, N] = _ref149;
    return !!N;
  })), () => {
    M(ft, !1);
  }), K(x(rt(C, ft, z, O, St, ut), V(_ref150 => {
    let [v, N, Q, it,, tt] = _ref150;
    return v && !N && Q.height !== 0 && it.height !== 0 && !tt;
  })), _ref151 => {
    let [,,,, v] = _ref151;
    M(ut, !0), De(1, () => {
      M(P, v);
    }), Rt(x(d), () => {
      M(e, [0, 0]), M(ft, !0);
    });
  }), F(x(st, V(v => v != null && v.scrollTop > 0), vt(0)), R), K(x(C, G(st), V(_ref152 => {
    let [, v] = _ref152;
    return v != null;
  })), _ref153 => {
    let [, v] = _ref153;
    v && (M(O, v.viewport), M(z, v.item), M(B, v.gap), v.scrollTop > 0 && (M(dt, !0), Rt(x(d, qt(1)), N => {
      M(dt, !1);
    }), M(c, {
      top: v.scrollTop
    })));
  }), F(x(O, H(_ref154 => {
    let {
      height: v
    } = _ref154;
    return v;
  })), S), F(x(rt(A(O, he), A(z, he), A(B, (v, N) => v && v.column === N.column && v.row === N.row), A(d)), H(_ref155 => {
    let [v, N, Q, it] = _ref155;
    return {
      gap: Q,
      item: N,
      scrollTop: it,
      viewport: v
    };
  })), q), F(x(rt(A(a), o, A(B, Er), A(z, he), A(O, he), A(nt), A(R), A(dt), A(ft), A(St)), V(_ref156 => {
    let [,,,,,,, v] = _ref156;
    return !v;
  }), H(_ref157 => {
    let [v, [N, Q], it, tt, kt, Jt, Dt,, de, Ot] = _ref157;
    const {
        column: Ft,
        row: Qt
      } = it,
      {
        height: fe,
        width: Ee
      } = tt,
      {
        width: Qe
      } = kt;
    if (Dt === 0 && (v === 0 || Qe === 0)) return wn;
    if (Ee === 0) {
      const rn = $e(Ot, v),
        ro = rn + Math.max(Dt - 1, 0);
      return Rr(vn(rn, ro, Jt));
    }
    const me = eo(Qe, Ee, Ft);
    let $t, Mt;
    de ? N === 0 && Q === 0 && Dt > 0 ? ($t = 0, Mt = Dt - 1) : ($t = me * we((N + Qt) / (fe + Qt)), Mt = me * Cn((Q + Qt) / (fe + Qt)) - 1, Mt = Oe(v - 1, ee(Mt, me - 1)), $t = Oe(Mt, ee(0, $t))) : ($t = 0, Mt = -1);
    const tn = vn($t, Mt, Jt),
      {
        bottom: en,
        top: nn
      } = bn(kt, it, tt, tn),
      on = Cn(v / me),
      oo = on * fe + (on - 1) * Qt - en;
    return {
      bottom: en,
      itemHeight: fe,
      items: tn,
      itemWidth: Ee,
      offsetBottom: oo,
      offsetTop: nn,
      top: nn
    };
  })), k), F(x(nt, V(v => v !== null), H(v => v.length)), a), F(x(rt(O, z, k, B), V(_ref158 => {
    let [v, N, {
      items: Q
    }] = _ref158;
    return Q.length > 0 && N.height !== 0 && v.height !== 0;
  }), H(_ref159 => {
    let [v, N, {
      items: Q
    }, it] = _ref159;
    const {
      bottom: tt,
      top: kt
    } = bn(v, it, N, Q);
    return [kt, tt];
  }), Y(se)), e);
  const xt = w(!1);
  F(x(d, G(xt), H(_ref160 => {
    let [v, N] = _ref160;
    return N || v !== 0;
  })), xt);
  const Xt = pt(x(rt(k, a), V(_ref161 => {
      let [{
        items: v
      }] = _ref161;
      return v.length > 0;
    }), G(xt), V(_ref162 => {
      let [[v, N], Q] = _ref162;
      const tt = v.items[v.items.length - 1].index === N - 1;
      return (Q || v.bottom > 0 && v.itemHeight > 0 && v.offsetBottom === 0 && v.items.length === N) && tt;
    }), H(_ref163 => {
      let [[, v]] = _ref163;
      return v - 1;
    }), Y())),
    Wt = pt(x(A(k), V(_ref164 => {
      let {
        items: v
      } = _ref164;
      return v.length > 0 && v[0].index === 0;
    }), vt(0), Y())),
    yt = pt(x(A(k), G(dt), V(_ref165 => {
      let [{
        items: v
      }, N] = _ref165;
      return v.length > 0 && !N;
    }), H(_ref166 => {
      let [{
        items: v
      }] = _ref166;
      return {
        endIndex: v[v.length - 1].index,
        startIndex: v[0].index
      };
    }), Y(Vn), zt(0)));
  F(yt, m.scrollSeekRangeChanged), F(x(P, G(O, z, a, B), H(_ref167 => {
    let [v, N, Q, it, tt] = _ref167;
    const kt = Gn(v),
      {
        align: Jt,
        behavior: Dt,
        offset: de
      } = kt;
    let Ot = kt.index;
    Ot === "LAST" && (Ot = it - 1), Ot = ee(0, Ot, Oe(it - 1, Ot));
    let Ft = Ve(N, tt, Q, Ot);
    return Jt === "end" ? Ft = yn(Ft - N.height + Q.height) : Jt === "center" && (Ft = yn(Ft - N.height / 2 + Q.height / 2)), de && (Ft += de), {
      behavior: Dt,
      top: Ft
    };
  })), c);
  const Bt = ct(x(k, H(v => v.offsetBottom + v.bottom)), 0);
  return F(x(b, H(v => ({
    height: v.visibleHeight,
    width: v.visibleWidth
  }))), O), {
    customScrollParent: y,
    // input
    data: nt,
    deviation: J,
    footerHeight: r,
    gap: B,
    headerHeight: s,
    increaseViewportBy: t,
    initialItemCount: R,
    itemDimensions: z,
    overscan: n,
    restoreStateFrom: st,
    scrollBy: i,
    scrollContainerState: l,
    scrollHeight: D,
    scrollTo: c,
    scrollToIndex: P,
    scrollTop: d,
    smoothScrollTargetReached: f,
    totalCount: a,
    useWindowScroll: g,
    viewportDimensions: O,
    windowScrollContainerState: u,
    windowScrollTo: T,
    windowViewportRect: b,
    ...m,
    // output
    gridState: k,
    horizontalDirection: At,
    initialTopMostItemIndex: St,
    totalListHeight: Bt,
    ...p,
    endReached: Xt,
    propsReady: I,
    rangeChanged: yt,
    startReached: Wt,
    stateChanged: q,
    stateRestoreInProgress: dt,
    ...h
  };
}, X(Ue, at, ae, Un, Vt, Ke, Pt));
function eo(t, e, n) {
  return ee(1, we((t + n) / (we(e) + n)));
}
function bn(t, e, n, o) {
  const {
    height: r
  } = n;
  if (r === void 0 || o.length === 0) return {
    bottom: 0,
    top: 0
  };
  const s = Ve(t, e, n, o[0].index);
  return {
    bottom: Ve(t, e, n, o[o.length - 1].index) + r,
    top: s
  };
}
function Ve(t, e, n, o) {
  const r = eo(t.width, n.width, e.column),
    s = we(o / r),
    i = s * n.height + ee(0, s - 1) * e.row;
  return i > 0 ? i + e.row : i;
}
const Br = /* @__PURE__ */U(() => {
    const t = w(S => "Item ".concat(S)),
      e = w({}),
      n = w(null),
      o = w("virtuoso-grid-item"),
      r = w("virtuoso-grid-list"),
      s = w(qe),
      i = w("div"),
      l = w(Gt),
      c = function (S) {
        let p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return ct(x(e, H(m => m[S]), Y()), p);
      },
      d = w(!1),
      f = w(!1);
    return F(A(f), d), {
      components: e,
      computeItemKey: s,
      context: n,
      FooterComponent: c("Footer"),
      HeaderComponent: c("Header"),
      headerFooterTag: i,
      itemClassName: o,
      ItemComponent: c("Item", "div"),
      itemContent: t,
      listClassName: r,
      ListComponent: c("List", "div"),
      readyStateChanged: d,
      reportReadyState: f,
      ScrollerComponent: c("Scroller", "div"),
      scrollerRef: l,
      ScrollSeekPlaceholder: c("ScrollSeekPlaceholder", "div")
    };
  }),
  kr = /* @__PURE__ */U(_ref168 => {
    let [t, e] = _ref168;
    return {
      ...t,
      ...e
    };
  }, X(Hr, Br)),
  Or = /* @__PURE__ */React__default.memo(function () {
    const e = et("gridState"),
      n = et("listClassName"),
      o = et("itemClassName"),
      r = et("itemContent"),
      s = et("computeItemKey"),
      i = et("isSeeking"),
      l = It("scrollHeight"),
      c = et("ItemComponent"),
      d = et("ListComponent"),
      f = et("ScrollSeekPlaceholder"),
      S = et("context"),
      p = It("itemDimensions"),
      m = It("gap"),
      C = et("log"),
      I = et("stateRestoreInProgress"),
      y = It("reportReadyState"),
      g = Et(React__default.useMemo(() => u => {
        const T = u.parentElement.parentElement.scrollHeight;
        l(T);
        const b = u.firstChild;
        if (b) {
          const {
            height: h,
            width: a
          } = b.getBoundingClientRect();
          p({
            height: h,
            width: a
          });
        }
        m({
          column: Rn("column-gap", getComputedStyle(u).columnGap, C),
          row: Rn("row-gap", getComputedStyle(u).rowGap, C)
        });
      }, [l, p, m, C]), !0, !1);
    return Yn(() => {
      e.itemHeight > 0 && e.itemWidth > 0 && y(!0);
    }, [e]), I ? null : /* @__PURE__ */jsx(d, {
      className: n,
      ref: g,
      ...Z(d, S),
      "data-testid": "virtuoso-item-list",
      style: {
        paddingBottom: e.offsetBottom,
        paddingTop: e.offsetTop
      },
      children: e.items.map(u => {
        const T = s(u.index, u.data, S);
        return i ? /* @__PURE__ */jsx(f, {
          ...Z(f, S),
          height: e.itemHeight,
          index: u.index,
          width: e.itemWidth
        }, T) : /* @__PURE__ */createElement$2(c, {
          ...Z(c, S),
          className: o,
          "data-index": u.index,
          key: T
        }, r(u.index, u.data, S));
      })
    });
  }),
  Fr = React__default.memo(function () {
    const e = et("HeaderComponent"),
      n = It("headerHeight"),
      o = et("headerFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, !1),
      s = et("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  }),
  zr = React__default.memo(function () {
    const e = et("FooterComponent"),
      n = It("footerHeight"),
      o = et("headerFooterTag"),
      r = Et(React__default.useMemo(() => i => {
        n(Ct(i, "height"));
      }, [n]), !0, !1),
      s = et("context");
    return e ? /* @__PURE__ */jsx(o, {
      ref: r,
      children: /* @__PURE__ */jsx(e, {
        ...Z(e, s)
      })
    }) : null;
  }),
  Lr = _ref169 => {
    let {
      children: t
    } = _ref169;
    const e = React__default.useContext(qn),
      n = It("itemDimensions"),
      o = It("viewportDimensions"),
      r = Et(React__default.useMemo(() => s => {
        o(s.getBoundingClientRect());
      }, [o]), !0, !1);
    return React__default.useEffect(() => {
      e && (o({
        height: e.viewportHeight,
        width: e.viewportWidth
      }), n({
        height: e.itemHeight,
        width: e.itemWidth
      }));
    }, [e, o, n]), /* @__PURE__ */jsx("div", {
      ref: r,
      style: Zt(!1),
      children: t
    });
  },
  Pr = _ref170 => {
    let {
      children: t
    } = _ref170;
    const e = React__default.useContext(qn),
      n = It("windowViewportRect"),
      o = It("itemDimensions"),
      r = et("customScrollParent"),
      s = _e(n, r, !1);
    return React__default.useEffect(() => {
      e && (o({
        height: e.itemHeight,
        width: e.itemWidth
      }), n({
        offsetTop: 0,
        visibleHeight: e.viewportHeight,
        visibleWidth: e.viewportWidth
      }));
    }, [e, n, o]), /* @__PURE__ */jsx("div", {
      ref: s,
      style: Zt(!1),
      children: t
    });
  },
  Vr = /* @__PURE__ */React__default.memo(function (_ref171) {
    let {
      ...e
    } = _ref171;
    const n = et("useWindowScroll"),
      o = et("customScrollParent"),
      r = o || n ? Mr : Wr,
      s = o || n ? Pr : Lr,
      i = et("context");
    return /* @__PURE__ */jsx(r, {
      ...e,
      ...Z(r, i),
      children: /* @__PURE__ */jsxs(s, {
        children: [/* @__PURE__ */jsx(Fr, {}), /* @__PURE__ */jsx(Or, {}), /* @__PURE__ */jsx(zr, {})]
      })
    });
  }),
  {
    Component: Ar,
    useEmitter: no,
    useEmitterValue: et,
    usePublisher: It
  } = /* @__PURE__ */je(kr, {
    events: {
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      endReached: "endReached",
      isScrolling: "isScrolling",
      rangeChanged: "rangeChanged",
      readyStateChanged: "readyStateChanged",
      startReached: "startReached",
      stateChanged: "stateChanged"
    },
    methods: {
      scrollBy: "scrollBy",
      scrollTo: "scrollTo",
      scrollToIndex: "scrollToIndex"
    },
    optional: {
      components: "components",
      computeItemKey: "computeItemKey",
      context: "context",
      customScrollParent: "customScrollParent",
      data: "data",
      headerFooterTag: "headerFooterTag",
      increaseViewportBy: "increaseViewportBy",
      initialItemCount: "initialItemCount",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      itemClassName: "itemClassName",
      itemContent: "itemContent",
      listClassName: "listClassName",
      logLevel: "logLevel",
      overscan: "overscan",
      restoreStateFrom: "restoreStateFrom",
      scrollerRef: "scrollerRef",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      totalCount: "totalCount",
      useWindowScroll: "useWindowScroll"
    }
  }, Vr),
  Wr = /* @__PURE__ */Ye({
    useEmitter: no,
    useEmitterValue: et,
    usePublisher: It
  }),
  Mr = /* @__PURE__ */Ze({
    useEmitter: no,
    useEmitterValue: et,
    usePublisher: It
  });
function Rn(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n("".concat(t, " was not resolved to pixel value correctly"), e, ht.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}
const increaseViewport = {
  top: 200,
  bottom: 200
};
const StyledListWrapper$3 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "list__StyledListWrapper",
  componentId: "sc-1tu604n-0"
})(["min-height:200px;flex:1 1 auto;"]);
const StyleListItemWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "list__StyleListItemWrapper",
  componentId: "sc-1tu604n-1"
})(["width:100%;display:flex;align-items:center;border-bottom:", ";cursor:", ";opacity:", ";", " &:hover{background-color:", ";}"], props => {
  if (props.withDivider) {
    return "1px solid ".concat(props.theme.designTokens.color.color.light['outline-variant'].value);
  }
  return 0;
}, props => {
  if (props.disabled) {
    return 'auto';
  }
  return props.clickable ? 'pointer' : 'auto';
}, props => props.disabled ? 0.5 : 1, props => {
  if (props.clickable) {
    return css(["& *{cursor:pointer;}"]);
  }
}, props => !props.disabled && props.clickable ? props.theme.designTokens.color.color.surfaces['surface-container-highest'].value : '');
function ListComponent(props) {
  const {
    items: itemsProp,
    emptyText,
    onItemClick,
    virtualized,
    rowRenderer,
    idKey,
    withDivider = true,
    className
  } = props;
  const clickable = Boolean(onItemClick);
  const items = useMemo(() => {
    return itemsProp.filter(item => !item.hidden);
  }, [itemsProp]);
  const innerRowRenderer = useCallback(index => {
    const item = items[index];
    return jsx(StyleListItemWrapper$1, {
      withDivider: withDivider,
      className: "hub-ui__list-item",
      "data-cy": item.dataCy,
      "data-role": clickable ? 'button' : 'presentation',
      clickable: clickable,
      onClick: () => {
        if (item.disabled) {
          return;
        }
        onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item);
      },
      disabled: item.disabled,
      children: rowRenderer(item)
    });
  }, [clickable, items, onItemClick, rowRenderer, withDivider]);
  const emptyJSX = !items.length && emptyText ? jsx(Typography, {
    align: "center",
    children: emptyText
  }) : null;
  if (!virtualized) {
    return jsxs(Fragment, {
      children: [emptyJSX, jsx(Layout, {
        stack: true,
        className: className,
        children: items.map((item, index) => {
          return jsx(StyleListItemWrapper$1, {
            withDivider: withDivider,
            "data-cy": item.dataCy,
            "data-role": clickable ? 'button' : 'presentation',
            clickable: clickable,
            disabled: item.disabled,
            onClick: () => {
              if (item.disabled) {
                return;
              }
              onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item);
            },
            children: rowRenderer(item)
          }, idKey ? item[idKey] || index : index);
        })
      })]
    });
  }
  return jsxs(Fragment, {
    children: [emptyJSX, jsx(StyledListWrapper$3, {
      stack: true,
      className: className,
      children: jsx(AutoSizer, {
        children: _ref172 => {
          let {
            height,
            width
          } = _ref172;
          return jsx($r, {
            style: {
              height,
              width
            },
            totalCount: items.length,
            itemContent: innerRowRenderer,
            increaseViewportBy: increaseViewport
          });
        }
      })
    })]
  });
}
const List = /*#__PURE__*/React__default.memo(ListComponent);
const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const defaultSelectedDays = {
  monday: false,
  tuesday: false,
  wednesday: false,
  thursday: false,
  sunday: false,
  saturday: false,
  friday: false
};
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "week-days-checkbox-list__StyledButton",
  componentId: "sc-1z0sh0u-0"
})(["&.MuiButton-root{border-radius:8px;height:32px;padding:6px 12px;min-width:unset;width:auto;.MuiButton-label{width:auto;}}"]);
const StyledList = /*#__PURE__*/styled(List).withConfig({
  displayName: "week-days-checkbox-list__StyledList",
  componentId: "sc-1z0sh0u-1"
})(["&{.hub-ui__list-item{border-bottom:1px solid rgba(189,202,192,0.4);}}"]);
const StyledListItem$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "week-days-checkbox-list__StyledListItem",
  componentId: "sc-1z0sh0u-2"
})(["height:100%;width:100%;background-color:", ";"], props => props.checked ? props.theme.designTokens.color.color.surfaces['surface-container-highest'].value : 'transparent');
function WeekDaysCheckboxList(props) {
  const {
    value: valueProp,
    onChange,
    variant = 'checkboxes'
  } = props;
  const value = valueProp ? valueProp : defaultSelectedDays;
  if (variant === 'list') {
    return jsx(StyledList, {
      virtualized: true,
      onItemClick: _ref173 => {
        let {
          weekDay
        } = _ref173;
        onChange(Object.assign(Object.assign({}, value), {
          [weekDay]: !value[weekDay]
        }));
      },
      items: weekDays.map(weekDay => {
        return {
          label: firstLetterToUpperCase(weekDay),
          weekDay
        };
      }),
      rowRenderer: item => {
        return jsx(StyledListItem$1, {
          dataCy: "week-day-".concat(createCySelector(item.weekDay)),
          vAlign: "center",
          checked: value[item.weekDay],
          children: jsx(Typography, {
            variant: "body",
            size: "medium",
            children: item.label
          })
        });
      }
    });
  }
  if (variant === 'buttons') {
    return jsx(Layout, {
      gap: "--Spacing-100",
      children: weekDays.map(weekDay => {
        const label = weekDay.charAt(0).toUpperCase();
        return jsx(StyledButton, {
          variant: value[weekDay] ? 'filled' : 'outlined',
          dataCy: "week-day-".concat(weekDay),
          onClick: () => {
            onChange(Object.assign(Object.assign({}, value), {
              [weekDay]: !value[weekDay]
            }));
          },
          children: label
        }, weekDay);
      })
    });
  }
  return jsx(Layout, {
    gap: "--Spacing-200",
    children: weekDays.map(weekDay => {
      const label = firstLetterToUpperCase(weekDay);
      return jsx(Checkbox, {
        name: "week-day-".concat(weekDay),
        dataCy: "week-day-".concat(weekDay),
        checked: value[weekDay],
        onChange: () => {
          onChange(Object.assign(Object.assign({}, value), {
            [weekDay]: !value[weekDay]
          }));
        },
        label: label
      }, weekDay);
    })
  });
}
const StyledDialog$2 = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "basic-dialog__StyledDialog",
  componentId: "sc-1eqbh9k-0"
})(["& .MuiPaper-root{width:315px;}"]);
function BasicDialog(props) {
  const {
    open,
    anchorElement,
    icon,
    title,
    content,
    action1Text,
    onAction1,
    action2Text,
    onAction2,
    onClose,
    className,
    divider
  } = props;
  const titleJSX = jsx(Typography, {
    variant: "headline",
    size: "small",
    children: typeof title === 'function' ? title() : title
  });
  const contentJSX = jsx(Typography, {
    variant: "body",
    size: "medium",
    color: "on-surface-variant",
    children: typeof content === 'function' ? content() : content
  });
  const actionsJSX = jsxs(Layout, {
    gap: 8,
    hAlign: "flex-end",
    children: [jsx(Button, {
      variant: "text",
      onClick: onAction2,
      children: typeof action2Text === 'function' ? action2Text() : action2Text
    }), jsx(Button, {
      variant: "filled",
      onClick: onAction1,
      children: typeof action1Text === 'function' ? action1Text() : action1Text
    })]
  });
  return jsx(StyledDialog$2, {
    open: open,
    anchorElement: anchorElement,
    icon: icon,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX,
    onClose: onClose,
    className: className,
    divider: divider
  });
}
const StyledCheckboxListDialog$1 = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "checkbox-list-dialog__StyledCheckboxListDialog",
  componentId: "enisb4-0"
})([".MuiPaper-root{width:315px;height:510px;}"]);
function CheckboxListDialog(props) {
  const {
    open,
    anchorElement,
    icon,
    title,
    onClose,
    options,
    withSearch,
    searchPlaceholder,
    onSearch,
    searchLabel,
    withSelectAll,
    optionLabel,
    optionValue,
    action2Text,
    onAction2,
    onAction1,
    action1Text,
    divider,
    className,
    onChange,
    checked = [],
    checkboxItemProps
  } = props;
  const [selected, setSelected] = useState(checked);
  const handleSelectedChange = useCallback(selected => {
    setSelected(selected);
    onChange === null || onChange === void 0 ? void 0 : onChange(selected);
  }, [onChange]);
  const titleJSX = title ? jsx(Typography, {
    variant: "headline",
    size: "small",
    children: typeof title === 'function' ? title() : title
  }) : undefined;
  const handleAction1Click = useCallback(() => {
    onAction1 === null || onAction1 === void 0 ? void 0 : onAction1(selected);
  }, [selected, onAction1]);
  const handleAction2Click = useCallback(() => {
    onAction2 === null || onAction2 === void 0 ? void 0 : onAction2(selected);
  }, [selected, onAction2]);
  const hasAction1 = Boolean(onAction1 && action1Text);
  const hasAction2 = Boolean(onAction2 && action2Text);
  const contentJSX = jsx(CheckboxList, {
    options: options,
    selected: selected,
    onChange: handleSelectedChange,
    withSelectAll: withSelectAll,
    withSearch: withSearch,
    optionLabel: optionLabel,
    optionValue: optionValue,
    onSearch: onSearch,
    searchLabel: searchLabel,
    searchPlaceholder: searchPlaceholder,
    itemProps: checkboxItemProps
  });
  const actionsJSX = hasAction1 || hasAction2 ? jsxs(Layout, {
    pt: 8,
    gap: 8,
    hAlign: "flex-end",
    children: [hasAction2 ? jsx(Button, {
      variant: "text",
      onClick: handleAction2Click,
      children: typeof action2Text === 'function' ? action2Text() : action2Text
    }) : null, hasAction1 ? jsx(Button, {
      variant: "filled",
      onClick: handleAction1Click,
      children: typeof action1Text === 'function' ? action1Text() : action1Text
    }) : null]
  }) : undefined;
  return jsx(StyledCheckboxListDialog$1, {
    open: open,
    anchorElement: anchorElement,
    icon: icon,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX,
    onClose: onClose,
    divider: divider,
    className: className
  });
}
var classof$1 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof$1(argument) === 'Array';
};
var $TypeError$1 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$1('Maximum allowed index exceeded');
  return it;
};
var isArray$1 = isArray$2;
var lengthOfArrayLike$1 = lengthOfArrayLike$6;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var bind$2 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$2(mapper, thisArg) : false;
  var element, elementLen;
  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$1(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }
      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};
var flattenIntoArray_1 = flattenIntoArray$1;
var isArray = isArray$2;
var isConstructor = isConstructor$2;
var isObject$3 = isObject$e;
var wellKnownSymbol$2 = wellKnownSymbol$l;
var SPECIES = wellKnownSymbol$2('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;else if (isObject$3(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }
  return C === undefined ? $Array : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $$6 = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$2 = aCallable$i;
var toObject = toObject$7;
var lengthOfArrayLike = lengthOfArrayLike$6;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$6({
  target: 'Array',
  proto: true
}, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable$2(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');
var call$1 = functionCall;
var anObject$2 = anObject$n;
var getIteratorDirect$2 = getIteratorDirect$9;
var getIteratorMethod = getIteratorMethod$3;
var getIteratorFlattenable$1 = function (obj, stringHandling) {
  if (!stringHandling || typeof obj !== 'string') anObject$2(obj);
  var method = getIteratorMethod(obj);
  return getIteratorDirect$2(anObject$2(method !== undefined ? call$1(method, obj) : obj));
};
var $$5 = _export;
var call = functionCall;
var aCallable$1 = aCallable$i;
var anObject$1 = anObject$n;
var getIteratorDirect$1 = getIteratorDirect$9;
var getIteratorFlattenable = getIteratorFlattenable$1;
var createIteratorProxy = iteratorCreateProxy;
var iteratorClose = iteratorClose$4;
var IS_PURE = isPure;
var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var mapper = this.mapper;
  var result, inner;
  while (true) {
    if (inner = this.inner) try {
      result = anObject$1(call(inner.next, inner.iterator));
      if (!result.done) return result.value;
      this.inner = null;
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    result = anObject$1(call(this.next, iterator));
    if (this.done = !!result.done) return;
    try {
      this.inner = getIteratorFlattenable(mapper(result.value, this.counter++), false);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
  }
});

// `Iterator.prototype.flatMap` method
// https://github.com/tc39/proposal-iterator-helpers
$$5({
  target: 'Iterator',
  proto: true,
  real: true,
  forced: IS_PURE
}, {
  flatMap: function flatMap(mapper) {
    anObject$1(this);
    aCallable$1(mapper);
    return new IteratorProxy(getIteratorDirect$1(this), {
      mapper: mapper,
      inner: null
    });
  }
});
const StyledTreeItem = /*#__PURE__*/styled(TreeItem).withConfig({
  displayName: "checkbox-tree-dialog__StyledTreeItem",
  componentId: "sc-12yzaj4-0"
})(["&.MuiTreeItem-root{.MuiTreeItem-group{border-bottom:1px solid ", ";}.MuiTreeItem-label:hover{background-color:transparent;}&.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label{background-color:transparent !important;}.MuiTreeItem-iconContainer{width:24px;}.MuiTreeItem-content{padding:0;}}"], props => props.theme.designTokens.color.color.light['outline-variant'].value);
const StyledCheckboxListDialog = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "checkbox-tree-dialog__StyledCheckboxListDialog",
  componentId: "sc-12yzaj4-1"
})([".hub-ui__dialog-container{overflow:auto;}.MuiPaper-root{width:315px;height:510px;}"]);
const CheckboxTreeDialog = /*#__PURE__*/React__default.memo(props => {
  const {
    open,
    anchorElement,
    icon,
    onClose,
    divider,
    className,
    options: optionsProp,
    checked,
    onChange
  } = props;
  const options = useMemo(() => {
    return optionsProp.map(addChildrenValuesImmutable);
  }, [optionsProp]);
  const allLeaves = useMemo(() => {
    return options.reduce((acc, option) => {
      var _a;
      return acc.concat(((_a = option.childrenValues) === null || _a === void 0 ? void 0 : _a.length) ? option.childrenValues : [option.value]);
    }, []);
  }, [options]);
  const countSelected = useMemo(() => {
    return Object.values(checked).reduce((acc, value) => {
      return value ? acc + 1 : acc;
    }, 0);
  }, [checked]);
  const allSelected = countSelected === allLeaves.length;
  const indeterminate = Boolean(!allSelected && countSelected);
  const handleSelectAll = useCallback(event => {
    const newSelected = {};
    allLeaves.forEach(value => {
      newSelected[value] = event.target.checked;
    });
    onChange(newSelected);
  }, [allLeaves, onChange]);
  const handleChange = useCallback((newCheckedValue, option) => {
    var _a;
    const newSelected = Object.assign({}, checked);
    if ((_a = option.childrenValues) === null || _a === void 0 ? void 0 : _a.length) {
      option.childrenValues.forEach(value => {
        newSelected[value] = newCheckedValue;
      });
    } else {
      newSelected[option.value] = newCheckedValue;
    }
    onChange(newSelected);
  }, [onChange, checked]);
  const contentJSX = jsxs(Layout, {
    stack: true,
    children: [jsxs(Layout, {
      gap: "--Spacing-150",
      vAlign: "center",
      children: [jsx(Layout, {
        flex: "0 0 40px",
        children: jsx(Checkbox, {
          name: "checkbox-tree-dialog-select-all",
          checked: allSelected,
          indeterminate: indeterminate,
          onChange: handleSelectAll
        })
      }), jsx(Typography, {
        variant: "label",
        size: "large",
        prominent: true,
        children: "Select All"
      })]
    }), jsx(Layout, {
      stack: true,
      flex: "1 1 auto",
      children: jsx(TreeView, {
        defaultCollapseIcon: jsx(Icon, {
          name: "chevronDown",
          size: 24
        }),
        defaultExpandIcon: jsx(Icon, {
          name: "navigateNext",
          size: 24
        }),
        children: options.map(option => {
          return jsx(CheckboxTreeItem, {
            option: option,
            checked: checked,
            onChange: handleChange
          }, option.value);
        })
      })
    })]
  });
  const titleJSX = undefined;
  const actionsJSX = undefined;
  return jsx(StyledCheckboxListDialog, {
    open: open,
    anchorElement: anchorElement,
    icon: icon,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX,
    onClose: onClose,
    divider: divider,
    className: className
  });
});
function CheckboxTreeItem(props) {
  var _a;
  const {
    option,
    checked,
    onChange
  } = props;
  const {
    isSelected,
    isIndeterminate
  } = useMemo(() => {
    var _a, _b, _c;
    if ((_a = option === null || option === void 0 ? void 0 : option.children) === null || _a === void 0 ? void 0 : _a.length) {
      const countAll = (_b = option.childrenValues) === null || _b === void 0 ? void 0 : _b.length;
      const countSelected = (_c = option.childrenValues) === null || _c === void 0 ? void 0 : _c.reduce((acc, childValue) => {
        return checked[childValue] ? acc + 1 : acc;
      }, 0);
      return {
        isSelected: countAll === countSelected,
        isIndeterminate: Boolean(countAll !== countSelected && countSelected)
      };
    }
    return {
      isSelected: Boolean(checked[option.value]),
      isIndeterminate: false
    };
  }, [option, checked]);
  return jsx(StyledTreeItem, {
    nodeId: option.value,
    label: jsxs(Layout, {
      gap: "--Spacing-150",
      vAlign: "center",
      children: [jsx(Layout, {
        flex: "0 0 40px",
        children: jsx(Checkbox, {
          name: option.value,
          indeterminate: isIndeterminate,
          checked: isSelected,
          onClick: event => {
            event.stopPropagation();
          },
          onChange: event => {
            onChange(event.target.checked, option);
          }
        }, option.value)
      }), jsx(Typography, {
        variant: "label",
        size: "large",
        prominent: true,
        children: option.label
      })]
    }),
    children: (_a = option.children) === null || _a === void 0 ? void 0 : _a.map(child => {
      return jsx(CheckboxTreeItem, {
        option: child,
        checked: checked,
        onChange: onChange
      }, child.value);
    })
  });
}
function addChildrenValuesImmutable(node) {
  // If the node has no children, return a new node with childrenValues as an empty array
  if (!node.children || node.children.length === 0) {
    return Object.assign(Object.assign({}, node), {
      childrenValues: []
    });
  }
  // Recursively process each child and collect their values
  const newChildren = node.children.map(addChildrenValuesImmutable);
  // Collect the values of all children and their respective childrenValues
  const childrenValues = newChildren.flatMap(child => {
    var _a;
    const childrenCount = ((_a = child.children) === null || _a === void 0 ? void 0 : _a.length) || 0;
    return [...(childrenCount === 0 ? [child.value] : []), ...(child.childrenValues || [])];
  });
  // Return a new node with updated children and childrenValues
  return Object.assign(Object.assign({}, node), {
    children: newChildren,
    childrenValues
  });
}
const StyledListWrapper$2 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "radio-list__StyledListWrapper",
  componentId: "sc-1xz6mk9-0"
})(["flex-grow:1;min-height:100px;"]);
const StyledRow$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "radio-list__StyledRow",
  componentId: "sc-1xz6mk9-1"
})(["height:100%;cursor:pointer;border-bottom:1px solid ", ";"], props => props.theme.designTokens.color.color.light['outline-variant'].value);
function RadioList(props) {
  const {
    options,
    optionValue,
    optionLabel,
    value,
    name,
    onChange,
    className
  } = props;
  const listRef = useRef(null);
  const getOptionLabel = useCallback(item => {
    if (typeof optionLabel === 'function') {
      return optionLabel(item);
    }
    return "".concat(item[optionLabel]);
  }, [optionLabel]);
  const rowRenderer = useCallback(props => {
    const {
      key,
      style,
      index
    } = props;
    const isChecked = (value === null || value === void 0 ? void 0 : value[optionValue]) === options[index][optionValue];
    return jsx("div", {
      style: style,
      onClick: () => {
        onChange(options[index]);
      },
      children: jsxs(StyledRow$1, {
        hAlign: "space-between",
        vAlign: "center",
        children: [jsx(Typography, {
          children: getOptionLabel(options[index])
        }), jsx(Radio, {
          name: name,
          onChange: () => {
            onChange(options[index]);
          },
          checked: isChecked,
          value: options[index][optionValue]
        })]
      })
    }, key);
  }, [value, optionValue, options, getOptionLabel, name, onChange]);
  return jsx(StyledListWrapper$2, {
    stack: true,
    stretch: true,
    className: className,
    children: jsx(AutoSizer, {
      children: _ref174 => {
        let {
          height,
          width
        } = _ref174;
        return jsx(List$1, {
          ref: listRef,
          width: width,
          height: height,
          rowCount: options.length,
          rowHeight: 56,
          rowRenderer: rowRenderer
        });
      }
    })
  });
}
function openableHoc(WrappedComponent) {
  const OpenableComponent = props => {
    const {
      open
    } = props;
    const key = useMemo(() => {
      return open ? uuid.v1() : undefined;
    }, [open]);
    return jsx(WrappedComponent, Object.assign({}, props), key);
  };
  return OpenableComponent;
}
const StyledRadioListDialog = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "radio-list-dialog__StyledRadioListDialog",
  componentId: "klmy43-0"
})([".MuiPaper-root{height:510px;width:315px;}"]);
const RadioListDialog = openableHoc(props => {
  const {
    open,
    anchorElement,
    icon,
    title,
    subtitle,
    onClose,
    options,
    optionValue,
    optionLabel,
    action2Text,
    onAction2,
    onAction1,
    action1Text,
    divider,
    className
  } = props;
  const [value, setValue] = useState(null);
  const handleAction1Click = useCallback(() => {
    if (!value) {
      return;
    }
    onAction1(value);
  }, [value, onAction1]);
  const handleAction2Click = useCallback(() => {
    onAction2(value);
  }, [value, onAction2]);
  const handleChange = useCallback(newValue => {
    setValue(newValue);
  }, []);
  const titleJSX = jsxs(Layout, {
    stack: true,
    gap: 16,
    children: [jsx(Typography, {
      variant: "headline",
      size: "small",
      children: typeof title === 'function' ? title() : title
    }), jsx(Typography, {
      variant: "body",
      size: "medium",
      color: "on-surface-variant",
      children: typeof subtitle === 'function' ? subtitle() : subtitle
    })]
  });
  const contentJSX = jsx(RadioList, {
    name: "radio-list",
    value: value,
    options: options,
    optionLabel: optionLabel,
    optionValue: optionValue,
    onChange: handleChange
  });
  const actionsJSX = jsxs(Layout, {
    pt: 8,
    gap: 8,
    hAlign: "flex-end",
    children: [jsx(Button, {
      variant: "text",
      onClick: handleAction2Click,
      children: typeof action2Text === 'function' ? action2Text() : action2Text
    }), jsx(Button, {
      variant: "filled",
      onClick: handleAction1Click,
      disabled: value === null,
      children: typeof action1Text === 'function' ? action1Text() : action1Text
    })]
  });
  return jsx(StyledRadioListDialog, {
    open: open,
    anchorElement: anchorElement,
    icon: icon,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX,
    onClose: onClose,
    divider: divider,
    className: className
  });
});
const StyledDot = /*#__PURE__*/styled.div.withConfig({
  displayName: "dot__StyledDot",
  componentId: "sc-5nu7ah-0"
})(["display:inline-block;height:var(--dot-size);width:var(--dot-size);border-radius:100%;background-color:var(--dot-color);"]);
function Dot(props) {
  const {
    color = '#42B381',
    size = 40,
    className
  } = props;
  const styles = useMemo(() => {
    return {
      '--dot-color': getColor(color),
      '--dot-size': "".concat(size, "px")
    };
  }, [color, size]);
  return jsx(StyledDot, {
    style: styles,
    className: className,
    color: color
  });
}
const StyledFab = /*#__PURE__*/styled(Fab$1).withConfig({
  displayName: "fab__StyledFab",
  componentId: "sc-1mz3k0y-0"
})(["&.MuiFab-root{border-radius:14px;background-color:", ";height:46px;width:46px;&:hover{background-color:", ";}}"], props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value, props => props.theme.designTokens.color.color['state-layers'].light['primary']['opacity-0.12'].value);
const Fab = /*#__PURE__*/React__default.forwardRef((_ref175, ref) => {
  let {
    onClick,
    icon,
    iconSize: _iconSize = 24,
    color: _color = 'primary'
  } = _ref175;
  return jsx(StyledFab, {
    onClick: onClick,
    ref: ref,
    children: jsx(Icon, {
      name: icon,
      size: _iconSize,
      color: _color
    })
  });
});
var $$4 = _export;
var iterate = iterate$7;
var aCallable = aCallable$i;
var anObject = anObject$n;
var getIteratorDirect = getIteratorDirect$9;

// `Iterator.prototype.some` method
// https://github.com/tc39/proposal-iterator-helpers
$$4({
  target: 'Iterator',
  proto: true,
  real: true
}, {
  some: function some(predicate) {
    anObject(this);
    aCallable(predicate);
    var record = getIteratorDirect(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop();
    }, {
      IS_RECORD: true,
      INTERRUPTED: true
    }).stopped;
  }
});
const StyledSwitch = /*#__PURE__*/styled(MuiSwitch).withConfig({
  displayName: "switch__StyledSwitch",
  componentId: "sc-1g7v87a-0"
})(["&.MuiSwitch-root{display:flex;width:52px;height:32px;padding:2px 4px;justify-content:flex-end;align-items:center;flex-shrink:0;.MuiSwitch-colorSecondary{color:", ";&.MuiSwitch-switchBase{padding:8px;}.MuiSwitch-thumb{height:16px;width:16px;box-shadow:none;}& + .MuiSwitch-track{opacity:1;height:28px;border-radius:100px;border:2px solid ", ";background-color:", ";}&.Mui-checked{color:", ";& + .MuiSwitch-track{border:2px solid ", ";background-color:", ";}}}.MuiButtonBase-root.Mui-disabled{color:", ";opacity:0.38;+ .MuiSwitch-track{border:2px solid ", ";background-color:", ";}}.MuiButtonBase-root.Mui-checked.Mui-disabled{color:", ";opacity:1;+ .MuiSwitch-track{border:0;background-color:", ";}}}"], props => props.theme.designTokens.color.color.light.outline.value, props => props.theme.designTokens.color.color.light.outline.value, props => props.theme.designTokens.color.color.surfaces['surface-container-highest'].value, props => props.theme.designTokens.color['on color'].primary['on-primary'].value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color.color.primary.primary.value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color.color['state-layers'].light['surface-variant']['opacity-0.12'].value, props => props.theme.designTokens.color.color.surfaces.surface.value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value);
function Switch(props) {
  const {
    checked,
    onChange,
    className,
    dataCy,
    label,
    labelPosition = 'left',
    disabled,
    noWrap,
    name,
    helperText
  } = props;
  const inputProps = useMemo(() => {
    return {
      'data-cy': dataCy,
      name: name
    };
  }, [name, dataCy]);
  const labelJSX = jsxs(Layout, {
    stack: true,
    gap: "--Spacing-100",
    children: [label ? jsx(Typography, {
      variant: "body",
      size: "medium",
      noWrap: noWrap,
      children: label
    }) : null, helperText ? jsx(Typography, {
      variant: "body",
      size: "small",
      noWrap: noWrap,
      children: helperText
    }) : null]
  });
  return jsxs(Layout, {
    vAlign: helperText ? 'flex-start' : 'center',
    gap: "--Spacing-50",
    children: [labelPosition === 'left' ? labelJSX : null, jsx(StyledSwitch, {
      className: className,
      checked: checked,
      onChange: onChange,
      inputProps: inputProps,
      disabled: disabled
    }), labelPosition === 'right' ? labelJSX : null]
  });
}
const StyledDialog$1 = /*#__PURE__*/styled(Dialog).withConfig({
  displayName: "add-resources-dialog__StyledDialog",
  componentId: "gzlijv-0"
})([".MuiPaper-root{height:600px;width:350px;}"]);
const StyledContentContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "add-resources-dialog__StyledContentContainer",
  componentId: "gzlijv-1"
})(["height:100%;width:100%;"]);
const AddResourcesDialog = openableHoc(props => {
  const {
    open,
    anchorElement,
    onClose,
    onAdd,
    resources = [],
    resourceKeyWord = 'resource'
  } = props;
  const {
    value: displaySearchText,
    setDebouncedValue: setSearchText,
    debounced: debouncedSearchText
  } = useDebouncedValue({
    defaultValue: ''
  });
  const [onlyWithNoPolicy, setOnlyWithNoPolicy] = useState(false);
  const [selectedResources, setSelectedResources] = useState([]);
  const dataCy = 'add-resources';
  const handleSearchChange = useCallback(event => {
    setSearchText(event.target.value);
  }, [setSearchText]);
  const handleNotOnPolicyChange = useCallback(event => {
    setOnlyWithNoPolicy(event.target.checked);
  }, []);
  const handleSelectedResourcesChange = useCallback(selected => {
    setSelectedResources(selected);
  }, []);
  const handleAction1Click = useCallback(() => {
    onAdd(selectedResources);
  }, [selectedResources, onAdd]);
  const handleAction2Click = useCallback(() => {
    onClose();
  }, [onClose]);
  const filteredResources = useMemo(() => {
    return resources.filter(resource => {
      return searchStringCompare(resource.name, debouncedSearchText) && (onlyWithNoPolicy ? !resource.toilPolicyId : true);
    });
  }, [debouncedSearchText, onlyWithNoPolicy, resources]);
  const isSelectedWithPolicy = useMemo(() => {
    return selectedResources.some(resource => resource.toilPolicyId);
  }, [selectedResources]);
  const titleJSX = jsx(Typography, {
    variant: "headline",
    size: "small",
    children: "Add Resource"
  });
  const contentJSX = jsxs(StyledContentContainer, {
    stack: true,
    stretch: true,
    gap: 24,
    hAlign: "center",
    children: [jsx(TextField, {
      name: "search",
      dataCy: "".concat(dataCy, "-search-field"),
      label: "Filter",
      placeholder: "Name of ".concat(resourceKeyWord),
      value: displaySearchText,
      onChange: handleSearchChange
    }), jsx(Switch, {
      label: "Show only those not on a policy",
      checked: onlyWithNoPolicy,
      onChange: handleNotOnPolicyChange
    }), jsx(CheckboxList, {
      withSelectAll: true,
      options: filteredResources,
      selected: selectedResources,
      optionLabel: "name",
      labelRenderer: resource => {
        return jsxs(Layout, {
          stack: true,
          gap: "--Spacing-50",
          children: [jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            children: resource.name
          }), resource.toilPolicyName ? jsxs(Typography, {
            variant: "body",
            size: "small",
            children: ["(", resource.toilPolicyName, ")"]
          }) : null]
        });
      },
      optionValue: "_id",
      onChange: handleSelectedResourcesChange,
      emptyStateText: "No ".concat(resourceKeyWord, " on a list")
    }), isSelectedWithPolicy ? jsxs(Layout, {
      gap: 17,
      children: [jsx(Layout, {
        flex: "0 0 24px",
        children: jsx(Icon, {
          name: "error",
          color: "error"
        })
      }), jsx(Typography, {
        variant: "body",
        size: "small",
        children: "Attention: Your selections are currently assigned to another policy. Confirming will move them to the new policy."
      })]
    }) : null]
  });
  const actionsJSX = jsxs(Layout, {
    pt: 8,
    gap: 8,
    hAlign: "flex-end",
    children: [jsx(Button, {
      variant: "text",
      onClick: handleAction2Click,
      children: "Cancel"
    }), jsx(Button, {
      variant: "filled",
      onClick: handleAction1Click,
      disabled: !(selectedResources === null || selectedResources === void 0 ? void 0 : selectedResources.length),
      children: "Add"
    })]
  });
  return jsx(StyledDialog$1, {
    open: open,
    anchorElement: anchorElement,
    title: titleJSX,
    content: contentJSX,
    actions: actionsJSX,
    onClose: onClose
  });
});
const infoTileVariantStyles = {
  primary: css(["&.primary{background:", ";}"], props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value),
  secondary: css(["&.secondary{background:", ";}"], props => props.theme.designTokens.color.color.surfaces['surface-container-highest'].value)
};
const StyledInfoTile = /*#__PURE__*/styled(Card).withConfig({
  displayName: "info-tile__StyledInfoTile",
  componentId: "vuoes5-0"
})(["&.MuiPaper-root{padding:16px;border-radius:8px;", ""], () => {
  return Object.keys(infoTileVariantStyles).map(variantKey => {
    return infoTileVariantStyles[variantKey];
  });
});
const paperProps$3 = {
  elevation: 0
};
function InfoTile(_ref176) {
  let {
    tileVariant,
    title,
    className,
    value,
    additionalInfo,
    iconName,
    unit,
    dataCy
  } = _ref176;
  return jsx(StyledInfoTile, Object.assign({
    className: classNames(tileVariant, className)
  }, paperProps$3, {
    "data-cy": dataCy,
    children: jsxs(Layout, {
      stack: true,
      gap: 24,
      children: [jsxs(Layout, {
        hAlign: "center",
        vAlign: "center",
        gap: "--Spacing-100",
        children: [jsx(Icon, {
          name: iconName,
          color: "outline-variant",
          size: 32
        }), jsx(Typography, {
          variant: "label",
          size: "large",
          align: "center",
          children: title
        })]
      }), jsxs(Layout, {
        hAlign: "center",
        vAlign: "flex-end",
        gap: "--Spacing-50",
        children: [jsx(Typography, {
          variant: "display",
          size: "medium",
          color: "on-surface",
          children: value
        }), jsx(Typography, {
          variant: "body",
          size: "small",
          color: "on-surface",
          children: unit
        })]
      }), additionalInfo && jsxs(Fragment, {
        children: [jsx(Divider, {}), jsxs(Layout, {
          hAlign: "flex-end",
          gap: 16,
          children: [jsxs(Layout, {
            stack: true,
            hAlign: "flex-end",
            gap: "--Spacing-50",
            flex: "1 1 50%",
            children: [jsx(Typography, {
              variant: "body",
              size: "small",
              color: "neutral30",
              children: additionalInfo.left.title
            }), jsxs(Layout, {
              gap: "--Spacing-50",
              vAlign: "flex-end",
              hAlign: "center",
              children: [jsx(Typography, {
                variant: "body",
                size: "medium",
                color: "neutral30",
                children: additionalInfo.left.value
              }), jsx(Typography, {
                variant: "body",
                size: "small",
                color: "neutral60",
                children: additionalInfo.left.unit
              })]
            })]
          }), jsx(Layout, {
            children: jsx(Divider, {
              type: "vertical"
            })
          }), jsx(Layout, {
            hAlign: "flex-start",
            gap: 16,
            flex: "1 1 50%",
            children: jsxs(Layout, {
              stack: true,
              gap: "--Spacing-50",
              children: [jsx(Typography, {
                variant: "body",
                size: "small",
                color: "neutral30",
                children: additionalInfo.right.title
              }), jsxs(Layout, {
                gap: "--Spacing-50",
                vAlign: "flex-end",
                hAlign: "center",
                children: [jsx(Typography, {
                  variant: "body",
                  size: "medium",
                  color: "neutral30",
                  children: additionalInfo.right.value
                }), jsx(Typography, {
                  variant: "body",
                  size: "small",
                  color: "neutral60",
                  children: additionalInfo.right.unit
                })]
              })]
            })
          })]
        })]
      })]
    })
  }));
}
const StyledListTile = /*#__PURE__*/styled(Card).withConfig({
  displayName: "list-tile__StyledListTile",
  componentId: "sc-154730i-0"
})(["&.MuiPaper-root{border-radius:8px;padding:", "px 16px;background:", ";color:", ";}"], props => props.theme.designSpacing['--Spacing-100'], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
const FullHeightLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "list-tile__FullHeightLayout",
  componentId: "sc-154730i-1"
})(["height:100%;"]);
const StyledListWrapper$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "list-tile__StyledListWrapper",
  componentId: "sc-154730i-2"
})(["min-height:300px;margin:0 -16px;"]);
const StyledRow = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "list-tile__StyledRow",
  componentId: "sc-154730i-3"
})(["height:100%;cursor:pointer;border-bottom:1px solid ", ";padding-top:", "px;padding-bottom:", "px;margin:0 16px;"], props => props.theme.designTokens.color.color.light['outline-variant'].value, props => props.theme.designSpacing['--Spacing-100'], props => props.theme.designSpacing['--Spacing-50']);
const paperProps$2 = {
  elevation: 0
};
const ListTile = _ref177 => {
  let {
    title,
    subtitle,
    options,
    emptyText,
    className
  } = _ref177;
  const listRef = useRef(null);
  const rowRenderer = useCallback(props => {
    const {
      key,
      style,
      index
    } = props;
    return jsx("div", {
      style: style,
      children: jsxs(StyledRow, {
        vAlign: "center",
        gap: "--Spacing-100",
        children: [jsx(Icon, {
          name: options[index].icon,
          color: "outline-variant",
          size: 16
        }), jsxs(Layout, {
          hAlign: "space-between",
          stretch: true,
          children: [jsxs(Layout, {
            stack: true,
            gap: "--Spacing-50",
            children: [jsx(Typography, {
              variant: "body",
              size: "medium",
              children: options[index].title
            }), jsx(Typography, {
              variant: "body",
              size: "small",
              color: "on-surface-variant",
              children: options[index].subtitle
            })]
          }), jsxs(Layout, {
            stack: true,
            hAlign: "flex-end",
            gap: "--Spacing-50",
            children: [jsx(Typography, {
              variant: "body",
              size: "medium",
              children: options[index].text
            }), jsx(Typography, {
              variant: "body",
              size: "small",
              color: "on-surface-variant",
              children: options[index].caption
            })]
          })]
        })]
      })
    }, key);
  }, [options]);
  return jsx(StyledListTile, Object.assign({
    className: className
  }, paperProps$2, {
    children: jsxs(FullHeightLayout, {
      stack: true,
      gap: 40,
      children: [jsxs(Layout, {
        stack: true,
        gap: "--Spacing-100",
        children: [jsx(Typography, {
          variant: "label",
          size: "small",
          children: title
        }), jsx(Typography, {
          variant: "body",
          size: "small",
          children: subtitle
        })]
      }), jsx(StyledListWrapper$1, {
        stack: true,
        stretch: true,
        children: options.length ? jsx(AutoSizer, {
          children: _ref178 => {
            let {
              height,
              width
            } = _ref178;
            return jsx(List$1, {
              ref: listRef,
              rowCount: options.length,
              height: height,
              width: width,
              rowHeight: 58,
              rowRenderer: rowRenderer
            });
          }
        }) : jsx(Typography, {
          align: "center",
          size: "large",
          prominent: true,
          children: emptyText
        })
      })]
    })
  }));
};
const StyledSmallInfoTile = /*#__PURE__*/styled(Card).withConfig({
  displayName: "small-info-tile__StyledSmallInfoTile",
  componentId: "x9yce3-0"
})(["&.MuiPaper-root{border-radius:8px;padding:", "px 16px;background:", ";color:", ";}"], props => props.theme.designSpacing['--Spacing-100'], props => props.theme.designTokens.color.color.surfaces['surface-container'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
const paperProps$1 = {
  elevation: 0
};
function SmallInfoTile(_ref179) {
  let {
    title,
    value,
    text
  } = _ref179;
  return jsx(StyledSmallInfoTile, Object.assign({}, paperProps$1, {
    children: jsxs(Layout, {
      stack: true,
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "label",
        size: "small",
        children: title
      }), jsxs(Layout, {
        stack: true,
        gap: "--Spacing-50",
        children: [jsx(Typography, {
          variant: "title",
          size: "large",
          children: value
        }), jsx(Layout, {
          hAlign: "flex-end",
          children: jsx(Typography, {
            variant: "body",
            size: "small",
            children: text
          })
        })]
      })]
    })
  }));
}
var _path, _path2, _path3, _path4;
var _excluded$1 = ["title", "titleId"];
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var SvgAmazonG225 = function SvgAmazonG225(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 424,
    height: 132,
    viewBox: "0 0 424 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.4621 31.2132V70.5868C95.4621 71.225 95.2085 71.8371 94.7572 72.2884C94.3059 72.7397 93.6938 72.9932 93.0556 72.9932H80.6264C79.9883 72.9929 79.3763 72.7393 78.9251 72.2881C78.4739 71.8368 78.2202 71.2249 78.22 70.5868V6.54366C78.22 5.90542 78.4735 5.29333 78.9248 4.84203C79.3761 4.39073 79.9882 4.13719 80.6264 4.13719H92.1282C92.7665 4.13719 93.3786 4.39073 93.8299 4.84203C94.2812 5.29333 94.5347 5.90542 94.5347 6.54366V15.5626C94.5347 15.5626 98.6463 2.69734 110.848 2.69734C110.848 2.69734 122.918 1.23839 127.825 14.6342C127.825 14.6342 131.937 2.69734 144.404 2.69734C144.404 2.69734 162.945 1.5949 162.945 20.7798L163.086 31.3458V70.7194C163.086 71.3576 162.833 71.9697 162.381 72.421C161.93 72.8723 161.318 73.1259 160.68 73.1259H148.249C147.611 73.1256 146.999 72.8719 146.548 72.4207C146.097 71.9695 145.843 71.3575 145.843 70.7194L145.73 27.7647C146.083 18.0381 138.214 18.7458 138.214 18.7458C128.311 18.923 129.264 31.3458 129.264 31.3458V70.7194C129.264 71.3576 129.011 71.9697 128.559 72.421C128.108 72.8723 127.496 73.1259 126.858 73.1259H114.428C113.79 73.1256 113.178 72.8719 112.727 72.4207C112.276 71.9695 112.022 71.3575 112.022 70.7194V28.7367C112.022 28.7367 112.749 18.6567 103.906 18.6567C103.907 18.6567 95.1533 17.5075 95.4621 31.2132ZM415.853 31.0954V70.4679C415.852 71.1061 415.599 71.718 415.147 72.1692C414.696 72.6205 414.084 72.8741 413.446 72.8744L400.519 73.1248C399.881 73.1245 399.269 72.8709 398.818 72.4196C398.367 71.9684 398.113 71.3565 398.113 70.7183V28.7367C398.113 28.7367 398.84 18.6567 389.998 18.6567C389.998 18.6567 381.553 18.2407 381.553 34.0451V70.5857C381.553 71.2238 381.299 71.8358 380.848 72.287C380.397 72.7383 379.785 72.9919 379.147 72.9922H366.716C366.078 72.9919 365.466 72.7383 365.015 72.287C364.564 71.8358 364.31 71.2238 364.31 70.5857V6.54366C364.31 5.90551 364.564 5.29358 365.015 4.84234C365.466 4.3911 366.078 4.13747 366.716 4.13719H378.218C378.856 4.13719 379.468 4.39073 379.92 4.84203C380.371 5.29333 380.625 5.90542 380.625 6.54366V15.5626C380.625 15.5626 384.736 2.69734 396.938 2.69734C396.938 2.69734 410.009 0.71423 414.412 14.3848C414.413 14.3838 415.853 17.2041 415.853 31.0954ZM326.109 2.43208C310.214 2.43208 297.328 15.8279 297.328 38.3753C297.328 58.2265 307.275 74.3185 326.109 74.3185C343.881 74.3185 354.89 58.2265 354.89 38.3753C354.89 16.2258 342.004 2.43208 326.109 2.43208ZM336.141 39.1711C336.141 47.6595 335.08 52.169 335.08 52.169C333.57 61.1423 327.056 61.155 326.096 61.1073C325.059 61.1487 318.49 61.0553 317.131 52.169C317.131 52.169 316.07 47.6595 316.07 39.1711V37.7567C316.07 29.2682 317.131 24.7588 317.131 24.7588C318.49 15.8724 325.06 15.7791 326.096 15.8194C327.056 15.7716 333.57 15.7833 335.08 24.7588C335.08 24.7588 336.141 29.2682 336.141 37.7567V39.1711ZM290.113 15.4735V6.28476C290.113 5.64661 289.86 5.03468 289.408 4.58344C288.957 4.1322 288.345 3.87857 287.707 3.87829H246.623C245.985 3.87829 245.373 4.13183 244.921 4.58313C244.47 5.03443 244.217 5.64653 244.217 6.28476V15.4024C244.217 16.0405 244.47 16.6525 244.922 17.1037C245.373 17.555 245.985 17.8086 246.623 17.8089H268.053L242.688 54.6062C242.688 54.6062 241.688 56.0981 241.721 57.7459V68.9389C241.721 68.9389 241.555 72.7768 245.908 70.5496C245.908 70.5496 253.639 65.8789 266.602 65.8789C266.602 65.8789 279.403 65.7197 287.938 70.9518C287.938 70.9518 291.481 72.5624 291.481 69.0206V59.278C291.481 59.278 291.803 56.6997 288.421 55.0901C288.421 55.0901 278.598 49.6957 265.716 50.5806L290.113 15.4735ZM68.627 61.5402L64.7361 55.6174C63.4978 53.4062 63.587 50.9297 63.587 50.9297V23.6086C64.1175 0.000139117 37.9445 2.03418 37.9445 2.03418C14.6777 2.03418 11.2409 20.1411 11.2409 20.1411C10.2711 23.7815 13.0914 23.8696 13.0914 23.8696L24.4606 25.023C24.4606 25.023 26.3991 25.4665 27.1047 23.1587C27.1047 23.1587 28.6019 15.2592 36.9747 15.2592C46.0849 15.2592 45.9904 23.0781 45.9904 23.0781V29.6237C27.804 30.2317 19.376 35.2802 19.376 35.2802C8.1469 41.6465 8.85356 54.2911 8.85356 54.2911C8.85356 74.8925 28.4831 74.0076 28.4831 74.0076C41.0385 74.0076 48.4659 64.8125 48.4659 64.8125C50.6761 68.7044 54.7441 72.416 54.7441 72.416C56.7792 74.623 58.9003 72.7704 58.9003 72.7704L68.0964 64.9016C70.1294 63.397 68.627 61.5402 68.627 61.5402ZM34.6106 61.2855C28.7048 61.2855 26.5095 55.4169 27.4899 49.649C28.4714 43.8811 33.5687 39.3483 45.9915 39.4809V42.9877C46.4318 58.3072 39.5265 61.2855 34.6106 61.2855ZM233.797 61.5402L229.907 55.6174C228.669 53.4062 228.757 50.9297 228.757 50.9297V23.6086C229.287 0.000139117 203.114 2.03418 203.114 2.03418C179.848 2.03418 176.411 20.1411 176.411 20.1411C175.441 23.7815 178.261 23.8696 178.261 23.8696L189.631 25.023C189.631 25.023 191.569 25.4665 192.275 23.1587C192.275 23.1587 193.772 15.2592 202.145 15.2592C211.255 15.2592 211.16 23.0781 211.16 23.0781V29.6237C192.975 30.2317 184.546 35.2802 184.546 35.2802C173.317 41.6465 174.024 54.2911 174.024 54.2911C174.024 74.8925 193.653 74.0076 193.653 74.0076C206.209 74.0076 213.636 64.8125 213.636 64.8125C215.847 68.7044 219.913 72.416 219.913 72.416C221.948 74.623 224.07 72.7704 224.07 72.7704L233.265 64.9016C235.299 63.397 233.797 61.5402 233.797 61.5402ZM199.781 61.2855C193.875 61.2855 191.68 55.4169 192.66 49.649C193.641 43.8811 198.739 39.3483 211.16 39.4809V42.9877C211.602 58.3072 204.698 61.2855 199.781 61.2855Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.094 113.253C265.094 113.253 264.054 115.062 265.332 115.467C265.332 115.467 266.775 116.03 268.574 114.36C268.574 114.36 281.699 102.895 282.015 82.0221C282.015 82.0221 282.111 79.4151 281.065 78.7021C281.065 78.7021 276.954 75.0648 262.169 76.1715C262.169 76.1715 249.281 77.0415 242.246 83.2879C242.246 83.2879 241.613 83.8408 241.613 84.5517C241.613 84.5517 241.461 86.087 245.329 85.4217C245.329 85.4217 258.215 83.602 265.885 84.5517C265.885 84.5517 269.839 85.026 270.946 86.3714C270.946 86.3714 272.765 87.8738 271.815 92.8533C271.815 92.8555 269.205 105.505 265.094 113.253Z",
    fill: "#F3971B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.496 93.2281C262.496 93.2281 264.421 95.7216 261.315 97.8723C261.315 97.8723 228.139 124.409 172.433 124.409C172.433 124.409 115.092 127.238 67.212 83.7348C67.212 83.7348 65.5334 82.261 66.5753 80.8912C66.5753 80.8912 67.5069 79.6307 69.9187 81.0016C69.9187 81.0016 114.959 109.068 174.113 109.068C174.113 109.068 215.229 110.659 257.406 92.6212C257.406 92.6212 260.766 90.88 262.496 93.2281Z",
    fill: "#F3971B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365.59 112.058C365.59 113.708 365.155 115.238 364.285 116.648C363.445 118.028 362.185 119.168 360.505 120.068C358.855 120.938 356.89 121.418 354.61 121.508V125.153H351.73V121.463C348.55 121.193 345.985 120.248 344.035 118.628C342.085 116.978 341.05 114.743 340.93 111.923H349.12C349.3 113.723 350.17 114.878 351.73 115.388V108.278C349.39 107.678 347.515 107.093 346.105 106.523C344.725 105.953 343.51 105.038 342.46 103.778C341.41 102.518 340.885 100.793 340.885 98.6033C340.885 95.8733 341.89 93.6833 343.9 92.0333C345.94 90.3833 348.55 89.4533 351.73 89.2433V85.5983H354.61V89.2433C357.76 89.4833 360.25 90.3983 362.08 91.9883C363.91 93.5783 364.93 95.7833 365.14 98.6033H356.905C356.725 96.9833 355.96 95.9333 354.61 95.4533V102.428C357.1 103.118 359.02 103.733 360.37 104.273C361.72 104.813 362.92 105.713 363.97 106.973C365.05 108.203 365.59 109.898 365.59 112.058ZM349.03 98.2433C349.03 98.9933 349.255 99.6233 349.705 100.133C350.185 100.643 350.86 101.093 351.73 101.483V95.2283C350.89 95.3783 350.23 95.7083 349.75 96.2183C349.27 96.6983 349.03 97.3733 349.03 98.2433ZM354.61 115.523C355.51 115.373 356.215 115.013 356.725 114.443C357.265 113.873 357.535 113.168 357.535 112.328C357.535 111.548 357.28 110.918 356.77 110.438C356.29 109.928 355.57 109.493 354.61 109.133V115.523ZM370.279 115.073C371.299 114.263 371.764 113.888 371.674 113.948C374.614 111.518 376.924 109.523 378.604 107.963C380.314 106.403 381.754 104.768 382.924 103.058C384.094 101.348 384.679 99.6833 384.679 98.0633C384.679 96.8333 384.394 95.8733 383.824 95.1833C383.254 94.4933 382.399 94.1483 381.259 94.1483C380.119 94.1483 379.219 94.5833 378.559 95.4533C377.929 96.2933 377.614 97.4933 377.614 99.0533H370.189C370.249 96.5033 370.789 94.3733 371.809 92.6633C372.859 90.9533 374.224 89.6933 375.904 88.8833C377.614 88.0733 379.504 87.6683 381.574 87.6683C385.144 87.6683 387.829 88.5833 389.629 90.4133C391.459 92.2433 392.374 94.6283 392.374 97.5683C392.374 100.778 391.279 103.763 389.089 106.523C386.899 109.253 384.109 111.923 380.719 114.533H392.869V120.788H370.279V115.073ZM419.387 95.0933H405.347V101.303C405.947 100.643 406.787 100.103 407.867 99.6833C408.947 99.2633 410.117 99.0533 411.377 99.0533C413.627 99.0533 415.487 99.5633 416.957 100.583C418.457 101.603 419.552 102.923 420.242 104.543C420.932 106.163 421.277 107.918 421.277 109.808C421.277 113.318 420.287 116.108 418.307 118.178C416.327 120.218 413.537 121.238 409.937 121.238C407.537 121.238 405.452 120.833 403.682 120.023C401.912 119.183 400.547 118.028 399.587 116.558C398.627 115.088 398.102 113.393 398.012 111.473H405.527C405.707 112.403 406.142 113.183 406.832 113.813C407.522 114.413 408.467 114.713 409.667 114.713C411.077 114.713 412.127 114.263 412.817 113.363C413.507 112.463 413.852 111.263 413.852 109.763C413.852 108.293 413.492 107.168 412.772 106.388C412.052 105.608 411.002 105.218 409.622 105.218C408.602 105.218 407.762 105.473 407.102 105.983C406.442 106.463 406.007 107.108 405.797 107.918H398.372V88.3433H419.387V95.0933Z",
    fill: "#171D19"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAmazonG225);
const imageStyles = _ref180 => {
  let {
    height,
    width
  } = _ref180;
  return css(["width:", "px;height:", "px;"], width, height);
};
const svgImages = {
  amazonG2: styled(ForwardRef).withConfig({
    displayName: "image__amazonG2",
    componentId: "sc-9rdagg-0"
  })(["", ""], props => imageStyles(props))
};
const ImageComponent = /*#__PURE__*/styled.img.withConfig({
  displayName: "image__ImageComponent",
  componentId: "sc-9rdagg-1"
})(["", ""], props => imageStyles(props));
const imageNamesArray = [...Object.keys(svgImages), 'image'].sort();
function Image(props) {
  const {
    name,
    height,
    width,
    className,
    src,
    alt
  } = props;
  if (name === 'image') {
    if (!src) {
      console.error('src is required for standard images');
      return null;
    }
    return jsx(ImageComponent, {
      src: src,
      alt: alt || '',
      name: "image",
      className: className,
      height: height,
      width: width
    });
  }
  const SvgIcon = svgImages[name];
  if (!SvgIcon) {
    console.error("Invalid image name: ".concat(name));
    return null;
  }
  return jsx(SvgIcon, {
    name: name,
    className: className,
    height: height,
    width: width
  });
}
const ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "tooltip__ContentWrapper",
  componentId: "sc-16spw91-0"
})(["display:inline-block;"]);
const Tooltip = /*#__PURE__*/styled(props => {
  const {
    placement,
    disabled,
    children,
    interactive,
    title,
    withArrow = true,
    className,
    enterDelay
  } = props;
  const classes = useMemo(() => {
    return {
      popper: className
    };
  }, [className]);
  if (!title || disabled) {
    return children;
  }
  return jsx(MuiTooltip, {
    placement: placement,
    interactive: interactive,
    classes: classes,
    title: title,
    arrow: withArrow,
    enterDelay: enterDelay,
    children: jsx(ContentWrapper, {
      className: classNames(className, 'hub-ui__tooltip-content-wrapper'),
      children: children
    })
  });
}).withConfig({
  displayName: "tooltip__Tooltip",
  componentId: "sc-16spw91-1"
})(["& .MuiTooltip-tooltip{padding:14px;border-radius:10px;color:", ";background-color:", ";box-shadow:", ";.MuiTooltip-arrow{color:", ";}}"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => {
  return COMPONENT_LEVEL_BACKGROUND_COLOR[props.level || 'highest'];
}, props => props.theme.shadows[4], props => {
  return COMPONENT_LEVEL_BACKGROUND_COLOR[props.level || 'highest'];
});
const DefaultTooltipContent = /*#__PURE__*/React__default.memo(props => {
  const {
    icon,
    header,
    content,
    actionButton1,
    actionButton2
  } = props;
  return jsxs(Layout, {
    stack: true,
    gap: 6,
    children: [jsxs(Layout, {
      gap: 2,
      children: [icon ? jsx(Layout, {
        flex: "0 0 32px",
        children: jsx(Icon, {
          name: icon
        })
      }) : null, jsxs(Layout, {
        stack: true,
        gap: 3,
        hAlign: "flex-start",
        children: [jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          align: "left",
          children: header
        }), jsx(Typography, {
          align: "left",
          children: content
        })]
      })]
    }), jsxs(Layout, {
      gap: "--Spacing-200",
      children: [actionButton1 ? jsx(Button, {
        variant: actionButton1.variant || 'text',
        onClick: actionButton1.onClick,
        endIcon: actionButton1.endIcon,
        children: actionButton1.text
      }) : null, actionButton2 ? jsx(Button, {
        variant: actionButton2.variant || 'text',
        onClick: actionButton2.onClick,
        endIcon: actionButton2.endIcon,
        children: actionButton2.text
      }) : null]
    })]
  });
});
const heights$1 = hasSupportingText => ({
  0: hasSupportingText ? '72px' : '56px',
  [-2]: hasSupportingText ? '64px' : '48px',
  [-4]: hasSupportingText ? '52px' : '40px'
});
const paddings = {
  0: '8px',
  [-2]: '4px',
  [-4]: '2px'
};
const StyledListItem = /*#__PURE__*/styled(ListItem$1).withConfig({
  displayName: "list-item__StyledListItem",
  componentId: "sc-10t9b3i-0"
})(["&.MuiListItem-root{display:flex;flex:1 1 auto;gap:16px;max-width:100%;padding-top:", ";padding-bottom:", ";}&.MuiListItem-gutters{padding-left:16px;padding-right:24px;}&.MuiButtonBase-root{gap:16px;color:", ";background:", ";", " min-height:", ";}"], props => paddings[props.density], props => paddings[props.density], props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.isActive ? props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value : 'transparent', props => {
  if (!props.clickable) {
    return css(["&:hover{cursor:unset;background:transparent;}"]);
  }
  return css(["&:hover{background:", ";}&:focus{background:", ";}"], props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value);
}, props => heights$1(props.hasSupportingText)[props.density]);
const Wrapper$1 = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "list-item__Wrapper",
  componentId: "sc-10t9b3i-1"
})(["width:100%;", ""], props => {
  if (props.clickable) {
    return css(["& *{cursor:pointer;}"]);
  }
});
const TextContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "list-item__TextContainer",
  componentId: "sc-10t9b3i-2"
})(["white-space:normal;word-wrap:break-word;", ""], props => {
  return props.noWrap ? css(["overflow:hidden;"]) : undefined;
});
const StyledTooltip$1 = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "list-item__StyledTooltip",
  componentId: "sc-10t9b3i-3"
})(["display:inline-flex;flex:1 1 auto;"]);
function ListItem(props) {
  const {
    density = 0,
    dataCy,
    label,
    supportingText,
    startAdornment,
    endAdornment,
    onClick,
    withDivider,
    isActive = false,
    className,
    onMouseEnter,
    onMouseLeave,
    disabled,
    noWrap,
    labelTooltip = false
  } = props;
  return jsxs(Wrapper$1, {
    stack: true,
    clickable: Boolean(onClick),
    className: className,
    children: [jsxs(StyledListItem, {
      button: true,
      clickable: Boolean(onClick),
      disabled: disabled,
      "data-cy": dataCy,
      density: density,
      onClick: disabled ? undefined : onClick,
      isActive: isActive,
      className: "hub-ui__list-item",
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      hasSupportingText: Boolean(supportingText),
      children: [startAdornment && typeof startAdornment === 'string' ? jsx(Layout, {
        flex: "0 0 24px",
        hAlign: "center",
        children: jsx(Icon, {
          name: startAdornment,
          color: 'on-surface'
        })
      }) : startAdornment ? startAdornment : null, typeof label === 'string' ? jsxs(TextContainer, {
        stack: true,
        flex: "1 1 auto",
        noWrap: noWrap,
        children: [labelTooltip ? jsx(StyledTooltip$1, {
          title: labelTooltip,
          enterDelay: 1000,
          withArrow: false,
          children: jsx(Typography, {
            variant: "label",
            size: "large",
            prominent: true,
            noWrap: noWrap,
            children: label
          })
        }) : jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          noWrap: noWrap,
          title: label,
          children: label
        }), jsx(Typography, {
          variant: "body",
          size: "medium",
          color: "on-surface-variant",
          noWrap: noWrap,
          title: supportingText,
          children: supportingText
        })]
      }) : typeof label === 'function' ? label() : label, endAdornment && typeof endAdornment === 'string' ? jsx(Layout, {
        flex: "0 0 24px",
        hAlign: "center",
        children: jsx(Icon, {
          name: endAdornment,
          color: 'on-surface'
        })
      }) : endAdornment ? endAdornment : null]
    }), withDivider ? jsx(Divider, {}) : null]
  });
}
const LogoContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "logo__LogoContainer",
  componentId: "sc-4o1cuj-0"
})(["container-type:inline-size;"]);
const VerticalLogoText = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "logo__VerticalLogoText",
  componentId: "sc-4o1cuj-1"
})(["text-align:center;margin-top:", "px !important;width:", "px !important;font-size:17cqw !important;"], _ref181 => {
  let {
    iconSize
  } = _ref181;
  return iconSize * 0.1;
}, _ref182 => {
  let {
    iconSize
  } = _ref182;
  return iconSize;
});
const HorizontalLogoText = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "logo__HorizontalLogoText",
  componentId: "sc-4o1cuj-2"
})(["font-size:", "px !important;margin-top:", "px !important;"], _ref183 => {
  let {
    iconSize
  } = _ref183;
  return iconSize * 0.4;
}, _ref184 => {
  let {
    iconSize
  } = _ref184;
  return iconSize * 0.1;
});
const HorizontalLargeLogoText = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "logo__HorizontalLargeLogoText",
  componentId: "sc-4o1cuj-3"
})(["font-size:", "px !important;"], _ref185 => {
  let {
    iconSize
  } = _ref185;
  return iconSize;
});
const VerticalLayout = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "logo__VerticalLayout",
  componentId: "sc-4o1cuj-4"
})(["width:fit-content;"]);
function Logo(_ref186) {
  let {
    variant = 'horizontal',
    logoSize,
    logoColor,
    fontColor
  } = _ref186;
  const colorOfFont = fontColor || logoColor;
  if (variant === 'icon') {
    return jsx(Icon, {
      name: "hp_logo",
      size: logoSize,
      color: logoColor
    });
  }
  if (variant === 'vertical') {
    return jsxs(VerticalLayout, {
      stack: true,
      children: [jsx(Icon, {
        name: "hp_logo",
        size: logoSize,
        color: logoColor
      }), jsx(LogoContainer, {
        children: jsx(VerticalLogoText, {
          iconSize: logoSize,
          color: colorOfFont,
          children: "hubplanner"
        })
      })]
    });
  }
  const LogoTextComponent = variant === 'horizontal-large' ? HorizontalLargeLogoText : HorizontalLogoText;
  return jsxs(Layout, {
    vAlign: "center",
    gap: logoSize * 0.2,
    children: [jsx(Icon, {
      name: "hp_logo",
      size: logoSize,
      color: logoColor
    }), jsx(LogoTextComponent, {
      iconSize: logoSize,
      color: colorOfFont,
      weight: 600,
      children: "hubplanner"
    })]
  });
}
const heights = {
  0: '56px',
  [-2]: '48px',
  [-4]: '40px'
};
const StyledMenuItem = /*#__PURE__*/styled(MenuItem$1).withConfig({
  displayName: "menu-item__StyledMenuItem",
  componentId: "oonsmx-0"
})(["&.MuiMenuItem-root{padding-top:8px;padding-bottom:8px;}&.MuiListItem-gutters{padding-left:12px;padding-right:12px;}&.MuiButtonBase-root{gap:12px;color:", ";background:", ";&:hover{background:", ";}height:", ";}"], props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.isActive ? props.theme.designTokens.color.color.surfaces['surface-container-highest'].value : 'transparent', props => props.theme.designTokens.color.color.surfaces['surface-container-highest'].value, props => heights[props.density]);
const Wrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "menu-item__Wrapper",
  componentId: "oonsmx-1"
})(["margin-bottom:", "px;width:100%;", ""], props => props.withDivider ? 8 : 0, props => {
  if (props.clickable) {
    return css(["& *{cursor:pointer;}"]);
  }
});
function MenuItem(props) {
  const {
    density = 0,
    dataCy,
    label,
    startIcon,
    endIcon,
    endIconColor,
    onClick,
    withDivider,
    isActive = false,
    className,
    onMouseEnter,
    onMouseLeave,
    disabled
  } = props;
  return jsxs(Wrapper, {
    stack: true,
    gap: "--Spacing-100",
    clickable: Boolean(onClick),
    withDivider: withDivider,
    className: className,
    children: [jsxs(StyledMenuItem, {
      disabled: disabled,
      "data-cy": dataCy,
      density: density,
      onClick: disabled ? undefined : onClick,
      isActive: isActive,
      className: "hub-ui__menu-item",
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: [jsxs(Layout, {
        gap: "--Spacing-100",
        flex: "1 1 auto",
        children: [startIcon ? jsx(Icon, {
          name: startIcon,
          color: 'on-surface'
        }) : null, typeof label === 'string' ? jsx(Typography, {
          variant: "label",
          size: "large",
          prominent: true,
          children: label
        }) : label]
      }), endIcon ? jsx(Icon, {
        name: endIcon,
        color: endIconColor ? endIconColor : 'on-surface'
      }) : null]
    }), withDivider ? jsx(Divider, {}) : null]
  });
}
const isDivider$1 = value => {
  if (!value) {
    return false;
  }
  return 'divider' in value && value.divider;
};
const StyledMenu = /*#__PURE__*/styled(MenuComponent).withConfig({
  displayName: "menu__StyledMenu",
  componentId: "q03hbi-0"
})([".MuiMenu-paper{background:", ";text-align:left;}"], props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value);
const StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "menu__StyledTooltip",
  componentId: "q03hbi-1"
})(["&.hub-ui__tooltip-content-wrapper{width:100%;}"]);
const MenuDivider = /*#__PURE__*/styled(Divider).withConfig({
  displayName: "menu__MenuDivider",
  componentId: "q03hbi-2"
})(["margin:8px 0;"]);
const paperProps = {
  elevation: 2,
  style: {
    maxHeight: '500px'
  }
};
function Menu(_ref187) {
  let {
    options,
    isOpen,
    density = 0,
    anchorElement,
    onClose,
    closeOnSelect,
    active,
    transformOrigins,
    anchorOrigins
  } = _ref187;
  const anchorOrigin = useMemo(() => ({
    vertical: (anchorOrigins === null || anchorOrigins === void 0 ? void 0 : anchorOrigins.vertical) || 'bottom',
    horizontal: (anchorOrigins === null || anchorOrigins === void 0 ? void 0 : anchorOrigins.horizontal) || 'left'
  }), [anchorOrigins]);
  const transformOrigin = useMemo(() => ({
    vertical: (transformOrigins === null || transformOrigins === void 0 ? void 0 : transformOrigins.vertical) || 'top',
    horizontal: (transformOrigins === null || transformOrigins === void 0 ? void 0 : transformOrigins.horizontal) || 'left'
  }), [transformOrigins]);
  return jsx(StyledMenu, {
    open: isOpen,
    anchorEl: anchorElement,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    onClose: onClose,
    getContentAnchorEl: null,
    PaperProps: paperProps,
    children: options.map((option, index) => {
      if (isDivider$1(option)) {
        return jsx(MenuDivider, {}, index);
      }
      const menuItemJSX = jsx(MenuItem, {
        disabled: option.disabled,
        dataCy: option.dataCy,
        label: option.label,
        onClick: event => {
          var _a;
          if (closeOnSelect) {
            onClose();
          }
          (_a = option.onClick) === null || _a === void 0 ? void 0 : _a.call(option, event, option);
        },
        startIcon: option.startIcon,
        endIcon: option.endIcon,
        endIconColor: option.endIconColor,
        density: density,
        isActive: !isDivider$1(active) && ((active === null || active === void 0 ? void 0 : active.id) === option.label || option.isActive),
        withDivider: option.withDivider,
        onMouseEnter: event => {
          var _a;
          (_a = option.onMouseEnter) === null || _a === void 0 ? void 0 : _a.call(option, event, option);
        },
        onMouseLeave: option.onMouseLeave
      }, "".concat(option.label, "-menu-item"));
      if (option.tooltip) {
        return jsx(StyledTooltip, {
          title: jsx(DefaultTooltipContent, {
            header: option.tooltip.header,
            content: option.tooltip.content
          }),
          children: menuItemJSX
        }, option.id);
      }
      return menuItemJSX;
    })
  });
}
function MenuButton(_ref188) {
  let {
    options,
    density,
    children,
    dataCy,
    variant = 'filled',
    disabled = false,
    className,
    startIcon,
    endIcon,
    closeOnSelect
  } = _ref188;
  const {
    anchorElement,
    isOpen,
    open,
    close
  } = useOpenState();
  return jsxs(Fragment, {
    children: [jsx(Button, {
      onClick: open,
      dataCy: dataCy,
      variant: variant,
      disabled: disabled,
      className: className,
      startIcon: startIcon,
      endIcon: endIcon,
      children: children
    }), jsx(Menu, {
      isOpen: isOpen,
      onClose: close,
      anchorElement: anchorElement,
      options: options,
      density: density,
      closeOnSelect: closeOnSelect
    })]
  });
}
function MenuIconButton(_ref189) {
  let {
    options,
    density,
    variant = 'standard',
    icon,
    dataCy,
    className,
    disabled,
    closeOnSelect
  } = _ref189;
  const {
    anchorElement,
    isOpen,
    open,
    close
  } = useOpenState();
  return jsxs(Fragment, {
    children: [jsx(IconButton, {
      onClick: open,
      variant: variant,
      icon: icon,
      dataCy: dataCy,
      className: className,
      disabled: disabled
    }), jsx(Menu, {
      isOpen: isOpen,
      onClose: close,
      anchorElement: anchorElement,
      options: options,
      density: density,
      closeOnSelect: closeOnSelect
    })]
  });
}
const StyledDialog = /*#__PURE__*/styled(Dialog$1).withConfig({
  displayName: "delete-modal__StyledDialog",
  componentId: "sc-1ac43ic-0"
})(["& .MuiBackdrop-root{background-color:transparent;}"]);
const StyledPaper$1 = /*#__PURE__*/styled(Card$1).withConfig({
  displayName: "delete-modal__StyledPaper",
  componentId: "sc-1ac43ic-1"
})(["&.MuiPaper-root{border-radius:28px;width:315px;background-color:", ";}"], props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value);
const DeleteModal = /*#__PURE__*/React__default.memo(props => {
  const {
    title,
    content,
    cancelText,
    onCancel,
    confirmText,
    onConfirm,
    className,
    confirmDataCy,
    cancelDataCy
  } = props;
  return jsxs(StyledDialog, {
    open: true,
    onClose: onCancel,
    className: className,
    PaperComponent: StyledPaper$1,
    children: [jsxs(Layout, {
      stack: true,
      hAlign: "center",
      gap: "--Spacing-150",
      pt: 24,
      pl: 24,
      pr: 24,
      children: [jsx(Icon, {
        name: "error"
      }), jsx(Typography, {
        variant: "headline",
        size: "small",
        align: "center",
        children: typeof title === 'function' ? title() : title
      }), jsx(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface-variant",
        children: typeof content === 'function' ? content() : content
      })]
    }), jsxs(Layout, {
      gap: 8,
      hAlign: "center",
      pt: 24,
      pl: 24,
      pr: 24,
      pb: 24,
      children: [jsx(Button, {
        variant: "text",
        onClick: onCancel,
        dataCy: cancelDataCy,
        children: typeof cancelText === 'function' ? cancelText() : cancelText
      }), jsx(Button, {
        variant: "destructive",
        onClick: onConfirm,
        dataCy: confirmDataCy,
        children: typeof confirmText === 'function' ? confirmText() : confirmText
      })]
    })]
  });
});
const StyledModal = /*#__PURE__*/styled(Dialog$1).withConfig({
  displayName: "modal__StyledModal",
  componentId: "sc-1fbxsua-0"
})(["", " ", ""], props => !props.backdrop && css([".MuiBackdrop-root{background-color:transparent;}"]), props => props.variant === 'overlay' && css([".MuiBackdrop-root{background-color:rgba(1,1,1,0.5);backdrop-filter:blur(4px);}"]));
const StyledPaper = /*#__PURE__*/styled(Card$1).attrs({
  className: 'hub-ui__modal-paper'
}).withConfig({
  displayName: "modal__StyledPaper",
  componentId: "sc-1fbxsua-1"
})(["&.MuiPaper-root{border-radius:", ";padding:0;background-color:", ";min-width:", ";", "}"], props => props.modalVariant === 'overlay' ? '0' : '28px', props => {
  if (props.modalVariant === 'overlay') {
    return 'transparent';
  }
  return COMPONENT_LEVEL_BACKGROUND_COLOR[props.level];
}, props => {
  switch (props.modalVariant) {
    case 'modal':
      return '666px';
    case 'dialog':
      return '350px';
    case 'overlay':
      return '100%';
    default:
      return '350px';
  }
}, props => (props.fullHeight || props.modalVariant === 'overlay') && css(["height:100%;"]));
const StyledContent = /*#__PURE__*/styled(DialogContent).withConfig({
  displayName: "modal__StyledContent",
  componentId: "sc-1fbxsua-2"
})(["&.MuiDialogContent-root{padding:", ";flex-grow:1;flex-direction:column;display:flex;}"], props => {
  if (props.variant === 'overlay') {
    return '0';
  }
  if (props.variant === 'modal') {
    return props.hasFooter ? '24px 32px 24px 32px' : '24px 32px 36px 32px';
  }
  return props.hasFooter ? '12px 24px 24px 24px' : '24px 24px 24px 24px';
});
const StyledActions = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal__StyledActions",
  componentId: "sc-1fbxsua-3"
})(["padding:", ";"], props => {
  if (props.variant === 'overlay') {
    return '0';
  }
  if (props.variant === 'modal') {
    return '24px 32px 36px 32px';
  }
  return '24px 24px 24px 24px';
});
const CloseIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal__CloseIconContainer",
  componentId: "sc-1fbxsua-4"
})(["position:absolute;right:", ";top:", ";"], props => {
  switch (props.variant) {
    case 'modal':
      return '32px';
    case 'overlay':
      return '48px';
    default:
      return '24px';
  }
}, props => {
  switch (props.variant) {
    case 'modal':
      return '32px';
    case 'overlay':
      return '48px';
    default:
      return '24px';
  }
});
const TitleContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal__TitleContainer",
  componentId: "sc-1fbxsua-5"
})(["display:flex;align-items:center;padding:", ";"], props => props.variant === 'overlay' ? '0' : "".concat(props.paddings.pt, "px ").concat(props.paddings.pr + (props.hideCloseButton ? 0 : 56), "px ").concat(props.paddings.pb, "px ").concat(props.paddings.pl, "px"));
function Modal(props) {
  const {
    className,
    title,
    content,
    actions,
    extendedActions,
    onClose,
    variant = 'modal',
    topDivider = props.variant === 'modal',
    bottomDivider = props.variant === 'dialog',
    backdrop = false,
    fullWidth,
    fullHeight = false,
    level = props.variant === 'modal' ? 'default' : 'high',
    hideCloseButton = false,
    disableBackdropClick
  } = props;
  const hasFooter = Boolean(actions);
  const paddings = useMemo(() => {
    if (variant === 'overlay') {
      return {
        pt: 0,
        pb: 0,
        pr: 0,
        pl: 0
      };
    }
    return variant === 'modal' ? {
      pt: 32,
      pb: 24,
      pr: 36,
      pl: 36
    } : {
      pt: 24,
      pb: 12,
      pr: 24,
      pl: 24
    };
  }, [variant]);
  const paperProps = useMemo(() => {
    const defaultProps = {
      modalVariant: variant,
      fullHeight,
      level
    };
    if (variant === 'modal') {
      return Object.assign(Object.assign({}, defaultProps), {
        elevation: 4
      });
    }
    if (variant === 'overlay') {
      return Object.assign(Object.assign({}, defaultProps), {
        elevation: 0
      });
    }
    return Object.assign(Object.assign({}, defaultProps), {
      elevation: 2
    });
  }, [variant, fullHeight, level]);
  const fullWidthProps = fullWidth ? {
    fullWidth: true,
    maxWidth: fullWidth
  } : {
    fullWidth: false,
    maxWidth: false
  };
  const handleModalClose = useCallback((event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return;
    }
    onClose && onClose();
  }, [disableBackdropClick, onClose]);
  return jsxs(StyledModal, Object.assign({
    className: className,
    open: true,
    PaperProps: paperProps,
    onClose: handleModalClose,
    backdrop: backdrop,
    variant: variant,
    PaperComponent: StyledPaper
  }, fullWidthProps, {
    children: [jsxs(TitleContainer, {
      paddings: paddings,
      hideCloseButton: hideCloseButton,
      variant: variant,
      children: [title, !hideCloseButton ? jsx(CloseIconContainer, {
        variant: variant,
        children: jsx(IconButton, {
          icon: "close",
          onClick: onClose,
          dataCy: "close-modal"
        })
      }) : null]
    }), topDivider && variant !== 'overlay' ? jsx(Layout, {
      pl: paddings.pl,
      pr: paddings.pr,
      children: jsx(Divider, {})
    }) : null, jsx(StyledContent, {
      hasFooter: hasFooter,
      variant: variant,
      children: content
    }), bottomDivider && variant !== 'overlay' ? jsx(Layout, {
      pl: paddings.pl,
      pr: paddings.pr,
      children: jsx(Divider, {})
    }) : null, hasFooter ? jsx(StyledActions, {
      variant: variant,
      children: jsxs(Layout, {
        hAlign: "space-between",
        children: [jsx("div", {
          children: extendedActions
        }), jsx("div", {
          children: actions
        })]
      })
    }) : null]
  }));
}
const ELEMENT_WIDTH$1 = 135;
const StyledNavigationBar = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "navigation-barstyled__StyledNavigationBar",
  componentId: "bervvw-0"
})(["background-color:", ";border-radius:94px;padding:0 8px;"], props => props.theme.designTokens.color.color.surfaces['surface-container-low'].value);
const StyledNavigationElement = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "navigation-barstyled__StyledNavigationElement",
  componentId: "bervvw-1"
})(["padding:12px 0 16px 0;cursor:pointer;width:", "px;& *{cursor:pointer;}", " ", " ", ""], ELEMENT_WIDTH$1, props => props.disabled && css(["opacity:0.4;pointer-events:none;"]), props => !props.isActive && css(["&:hover{.iconContainer{background-color:", ";}}"], props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value), props => props.isActive && css([".iconContainer{background-color:", ";}"], props => props.theme.designTokens.color.color.surfaces['secondary-container'].value));
const StyledNavigationMoreElement = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "navigation-barstyled__StyledNavigationMoreElement",
  componentId: "bervvw-2"
})(["padding:12px 0 16px 0;cursor:pointer;& *{cursor:pointer;}", " ", ""], props => !props.isActive && css(["&:hover{.iconContainer{background-color:", ";}}"], props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.08'].value), props => props.isActive && css([".iconContainer{background-color:", ";}"], props => props.theme.designTokens.color.color.surfaces['secondary-container'].value));
const StyledIconContainer = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "navigation-barstyled__StyledIconContainer",
  componentId: "bervvw-3"
})(["padding:4px 20px;border-radius:16px;position:relative;"]);
const StyledMoreOptionsContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "navigation-barstyled__StyledMoreOptionsContainer",
  componentId: "bervvw-4"
})(["display:flex;align-items:center;"]);
const ErrorIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "navigation-barstyled__ErrorIconContainer",
  componentId: "bervvw-5"
})(["position:absolute;height:16px;width:16px;top:2px;right:16px;background-color:", ";border-radius:100%;"], props => props.theme.designTokens.color['on color'].primary['on-primary'].value);
const ErrorIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "navigation-barstyled__ErrorIcon",
  componentId: "bervvw-6"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);
var defineProperty = objectDefineProperty.f;
var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () {
      return Source[key];
    },
    set: function (it) {
      Source[key] = it;
    }
  });
};
var isCallable = isCallable$n;
var isObject$2 = isObject$e;
var setPrototypeOf$1 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
  // it can work only with native `setPrototypeOf`
  setPrototypeOf$1 &&
  // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
  isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject$2(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};
var toString$3 = toString$a;
var normalizeStringArgument$1 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$3(argument);
};
var isObject$1 = isObject$e;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$1(options) && 'cause' in options) {
    createNonEnumerableProperty$2(O, 'cause', options.cause);
  }
};
var uncurryThis$2 = functionUncurryThis;
var $Error = Error;
var replace = uncurryThis$2(''.replace);
var TEST = function (arg) {
  return String(new $Error(arg).stack);
}('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  }
  return stack;
};
var fails$2 = fails$q;
var createPropertyDescriptor = createPropertyDescriptor$5;
var errorStackInstallable = !fails$2(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});
var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;
var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);else createNonEnumerableProperty$1(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};
var getBuiltIn = getBuiltIn$8;
var hasOwn = hasOwnProperty_1;
var createNonEnumerableProperty = createNonEnumerableProperty$9;
var isPrototypeOf = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var copyConstructorProperties = copyConstructorProperties$2;
var proxyAccessor = proxyAccessor$1;
var inheritIfRequired = inheritIfRequired$1;
var normalizeStringArgument = normalizeStringArgument$1;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var DESCRIPTORS = descriptors;
var wrapErrorConstructorWithCause$1 = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);
  if (!OriginalError) return;
  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;
  if (!FORCED) return OriginalError;
  var BaseError = getBuiltIn('Error');
  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });
  WrappedError.prototype = OriginalErrorPrototype;
  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);else copyConstructorProperties(WrappedError, BaseError, {
      name: true
    });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }
  copyConstructorProperties(WrappedError, OriginalError);
  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) {/* empty */}
  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $$3 = _export;
var global$2 = global$p;
var apply = functionApply;
var wrapErrorConstructorWithCause = wrapErrorConstructorWithCause$1;
var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global$2[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$1 = new Error('e', {
  cause: 7
}).cause !== 7;
var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$1);
  $$3({
    global: true,
    constructor: true,
    arity: 1,
    forced: FORCED$1
  }, O);
};
var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$1);
    $$3({
      target: WEB_ASSEMBLY,
      stat: true,
      constructor: true,
      arity: 1,
      forced: FORCED$1
    }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) {
    return apply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) {
    return apply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) {
    return apply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) {
    return apply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) {
    return apply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) {
    return apply(init, this, arguments);
  };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) {
    return apply(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) {
    return apply(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) {
    return apply(init, this, arguments);
  };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) {
    return apply(init, this, arguments);
  };
});
const isBarOption = option => 'icon' in option && 'label' in option;
const isTabIcon = option => 'icon' in option && 'title' in option;
const isExtraTabIcon = option => 'startIcon' in option && 'title' in option;
const transformToMenuOption = (option, lastIndex) => {
  const base = {
    id: option.id,
    dataCy: option.dataCy,
    withDivider: !lastIndex,
    hasError: option.hasError,
    disabled: option.disabled
  };
  if (isBarOption(option)) {
    return Object.assign(Object.assign({}, base), {
      label: option.label,
      title: option.label,
      startIcon: option.icon,
      desc: (option === null || option === void 0 ? void 0 : option.desc) || option.label,
      tooltip: option.tooltip
    });
  }
  if (isTabIcon(option)) {
    return Object.assign(Object.assign({}, base), {
      label: option.title,
      title: option.title,
      desc: option.desc,
      startIcon: option.icon
    });
  }
  if (isExtraTabIcon(option)) {
    return Object.assign(Object.assign({}, base), {
      label: option.title,
      title: option.title,
      desc: option.desc,
      startIcon: option.startIcon
    });
  }
  throw new Error('Invalid option type');
};
const transformToOptionType = menuOption => {
  return Object.assign(Object.assign({}, menuOption), {
    label: ''
  });
};
const isDivider = value => {
  if (!value) {
    return false;
  }
  return 'divider' in value && value.divider;
};
const MoreOptionsMenu = _ref190 => {
  let {
    open,
    close,
    isOpen,
    moreOptionsActive,
    moreOptionsMapped,
    anchorElement,
    active
  } = _ref190;
  const hasSomeError = useMemo(() => {
    return moreOptionsMapped.some(option => 'hasError' in option && option.hasError);
  }, [moreOptionsMapped]);
  return jsxs(Fragment, {
    children: [jsx(StyledMoreOptionsContainer, {
      onClick: open,
      "data-cy": "navigation-bar-more-options",
      children: jsx(StyledNavigationMoreElement, {
        stack: true,
        gap: "--Spacing-50",
        vAlign: "center",
        hAlign: "center",
        isActive: moreOptionsActive,
        children: jsxs(StyledIconContainer, {
          hAlign: "center",
          vAlign: "center",
          className: "iconContainer",
          children: [jsx(Icon, {
            name: "moreVert",
            color: moreOptionsActive ? 'on-secondary' : 'on-surface-variant'
          }), hasSomeError ? jsx(ErrorIconContainer, {
            children: jsx(ErrorIcon, {
              name: "error",
              color: "error",
              size: 20
            })
          }) : null]
        })
      })
    }), jsx(Menu, {
      isOpen: isOpen,
      onClose: close,
      anchorElement: anchorElement,
      options: moreOptionsMapped,
      closeOnSelect: true,
      density: -2,
      active: active && transformToOptionType(active)
    })]
  });
};
var MoreOptionsMenu$1 = /*#__PURE__*/React__default.memo(MoreOptionsMenu);
const ELEMENT_WIDTH = 135;
const ITEM_MIN_COUNT = 1;
const useResponsiveOptions = (options, width) => {
  const elementsThatCanFit = useMemo(() => {
    const MODAL_WIDTH = width;
    const totalFittableElements = Math.floor(MODAL_WIDTH / ELEMENT_WIDTH);
    return Math.max(totalFittableElements - 1, ITEM_MIN_COUNT);
  }, [width]);
  return useMemo(() => {
    const splitIndex = elementsThatCanFit + options.slice(0, elementsThatCanFit).filter(isDivider).length;
    const shownOptions = options.filter(option => !isDivider(option)).slice(0, elementsThatCanFit).map((option, i, arr) => transformToMenuOption(option, i === arr.length - 1));
    const moreOptions = options.slice(splitIndex).map((option, i, arr) => isDivider(option) ? option : transformToMenuOption(option, i === arr.length - 1));
    return [shownOptions, moreOptions];
  }, [options, elementsThatCanFit]);
};
function NavigationBar(props) {
  const {
    open,
    isOpen,
    close,
    anchorElement
  } = useOpenState();
  const [ref, width] = useElementSize();
  const {
    options,
    active,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = props;
  const [shownOptions, moreOptions] = useResponsiveOptions(options, width);
  const moreOptionsActive = React__default.useMemo(() => {
    return moreOptions.length > 0 && moreOptions.some(el => !isDivider(el) && el.id === (active === null || active === void 0 ? void 0 : active.id));
  }, [moreOptions, active === null || active === void 0 ? void 0 : active.id]);
  const moreOptionsMapped = useMemo(() => {
    return moreOptions.map(el => Object.assign(Object.assign(Object.assign({}, el), 'hasError' in el && el.hasError ? {
      endIcon: 'error',
      endIconColor: 'error'
    } : {}), {
      onClick: event => !isDivider(el) && onClick(event, el),
      onMouseEnter: event => {
        isOpen && onMouseEnter && !isDivider(el) && onMouseEnter(event, el);
      },
      onMouseLeave: event => {
        isOpen && onMouseLeave && onMouseLeave(event);
      }
    }));
  }, [isOpen, moreOptions, onClick, onMouseEnter, onMouseLeave]);
  return jsxs(StyledNavigationBar, {
    gap: "--Spacing-100",
    hAlign: "space-around",
    ref: ref,
    children: [shownOptions.map(el => {
      const isActive = (active === null || active === void 0 ? void 0 : active.id) === el.id;
      if (el.tooltip) {
        return jsx(Tooltip, {
          interactive: el.tooltip.interactive,
          title: jsx(DefaultTooltipContent, {
            header: el.tooltip.header,
            content: el.tooltip.content,
            icon: el.tooltip.icon,
            actionButton1: el.tooltip.actionButton1,
            actionButton2: el.tooltip.actionButton2
          }),
          children: jsx(NavigationBarOption, {
            el: el,
            isActive: isActive,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
          })
        });
      } else {
        return jsx(NavigationBarOption, {
          el: el,
          isActive: isActive,
          onClick: onClick,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        });
      }
    }), moreOptions.length > 0 && jsx(MoreOptionsMenu$1, {
      open: open,
      close: close,
      isOpen: isOpen,
      moreOptionsActive: moreOptionsActive,
      moreOptionsMapped: moreOptionsMapped,
      anchorElement: anchorElement,
      active: active
    })]
  });
}
const NavigationBarOption = props => {
  const {
    el,
    isActive,
    onClick,
    onMouseLeave,
    onMouseEnter
  } = props;
  return jsx("div", {
    role: "button",
    "data-cy": el.dataCy,
    onClick: event => {
      if (el.disabled) {
        return;
      }
      onClick(event, el);
    },
    onMouseEnter: event => onMouseEnter && onMouseEnter(event, el),
    onMouseLeave: event => onMouseLeave && onMouseLeave(event),
    "data-active": isActive ? 'true' : 'false',
    children: jsxs(StyledNavigationElement, {
      stack: true,
      gap: "--Spacing-50",
      vAlign: "center",
      hAlign: "center",
      isActive: isActive,
      disabled: el.disabled,
      children: [jsxs(StyledIconContainer, {
        hAlign: "center",
        vAlign: "center",
        className: "iconContainer",
        children: [jsx(Icon, {
          name: el.startIcon,
          color: isActive ? 'on-secondary' : 'on-surface-variant'
        }), el.hasError ? jsx(ErrorIconContainer, {
          children: jsx(ErrorIcon, {
            name: "error",
            color: "error",
            size: 20
          })
        }) : null]
      }), jsx(Typography, {
        variant: "label",
        size: "medium",
        color: isActive ? 'on-surface' : 'on-surface-variant',
        prominent: isActive ? true : false,
        align: "center",
        children: el.label
      })]
    })
  });
};
var global$1 = global$p;
var fails$1 = fails$q;
var uncurryThis$1 = functionUncurryThis;
var toString$2 = toString$a;
var trim = stringTrim.trim;
var whitespaces$1 = whitespaces$4;
var charAt = uncurryThis$1(''.charAt);
var $parseFloat = global$1.parseFloat;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var FORCED = 1 / $parseFloat(whitespaces$1 + '-0') !== -Infinity
// MS Edge 18- broken with boxed symbols
|| ITERATOR && !fails$1(function () {
  $parseFloat(Object(ITERATOR));
});

// `parseFloat` method
// https://tc39.es/ecma262/#sec-parsefloat-string
var numberParseFloat = FORCED ? function parseFloat(string) {
  var trimmedString = trim(toString$2(string));
  var result = $parseFloat(trimmedString);
  return result === 0 && charAt(trimmedString, 0) === '-' ? -0 : result;
} : $parseFloat;
var $$2 = _export;
var parseFloat$1 = numberParseFloat;

// `Number.parseFloat` method
// https://tc39.es/ecma262/#sec-number.parseFloat
// eslint-disable-next-line es/no-number-parsefloat -- required for testing
$$2({
  target: 'Number',
  stat: true,
  forced: Number.parseFloat !== parseFloat$1
}, {
  parseFloat: parseFloat$1
});
const SPECIAL_CHARS = ['e', 'E', '+', '-'];
const inputLabelProps = {
  shrink: true
};
const StyledNumberInput = /*#__PURE__*/styled(StyledInput$1).withConfig({
  displayName: "number-input__StyledNumberInput",
  componentId: "sc-1bdsv7v-0"
})(["input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none !important;margin:0;}input[type='number']{-moz-appearance:textfield;}&.MuiTextField-root .MuiInputBase-root{.MuiInputAdornment-positionEnd{", "}.MuiOutlinedInput-input{", "}&.MuiOutlinedInput-adornedEnd{", "}}"], props => {
  if (props.withSpinButtons) {
    return css(["margin-left:5px;"]);
  }
}, props => {
  if (props.withSpinButtons) {
    return css(["padding-right:0;"]);
  }
}, props => {
  if (props.withSpinButtons) {
    return css(["padding-right:5px;"]);
  }
});
function NumberInput(props) {
  const {
    name,
    className,
    dataCy,
    disabled,
    label,
    placeholder,
    value,
    onChange,
    error,
    helperText,
    min,
    max,
    onKeyPress,
    onFocus,
    onBlur,
    onClick,
    startAdornment,
    endAdornment,
    step = 'any',
    integerOnly = false,
    defaultValue,
    required,
    withSpinButtons = false,
    disableSpecialChars
  } = props;
  const inputRef = useRef(null);
  const onIncrement = useCallback(() => {
    var _a;
    if (!inputRef.current) {
      return;
    }
    const event = new Event('change', {
      bubbles: true
    });
    const stepToUse = isNumber(step) ? step : 1;
    const baseValue = (_a = value !== null && value !== void 0 ? value : min) !== null && _a !== void 0 ? _a : 0;
    const newValue = baseValue + stepToUse;
    let dispatchedValue;
    if (isNumber(max)) {
      dispatchedValue = Math.min(newValue, max);
    } else {
      dispatchedValue = newValue;
    }
    inputRef.current.value = "".concat(dispatchedValue);
    inputRef.current.dispatchEvent(event);
    onChange(event, dispatchedValue);
  }, [max, min, onChange, step, value]);
  const onDecrement = useCallback(() => {
    var _a;
    if (!inputRef.current) {
      return;
    }
    const event = new Event('change', {
      bubbles: true
    });
    const stepToUse = isNumber(step) ? step : 1;
    const baseValue = (_a = value !== null && value !== void 0 ? value : min) !== null && _a !== void 0 ? _a : 0;
    const newValue = baseValue - stepToUse;
    let dispatchedValue;
    if (isNumber(min)) {
      dispatchedValue = Math.max(newValue, min);
    } else {
      dispatchedValue = newValue;
    }
    inputRef.current.value = "".concat(dispatchedValue);
    inputRef.current.dispatchEvent(event);
    onChange(event, dispatchedValue);
  }, [min, onChange, step, value]);
  const InputProps = useMemo(() => {
    return {
      startAdornment: getStartAdornment(startAdornment),
      endAdornment: getNumberInputEndAdornment({
        endAdornment,
        onIncrement,
        onDecrement,
        withSpinButtons,
        disabled
      }),
      inputProps: {
        min,
        max,
        step,
        'data-cy': dataCy ? "".concat(dataCy, "-input") : undefined,
        onKeyPress
      }
    };
  }, [dataCy, disabled, endAdornment, max, min, onDecrement, onIncrement, onKeyPress, startAdornment, step, withSpinButtons]);
  React__default.useEffect(() => {
    const handleWheel = e => e.preventDefault();
    const ref = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
    if (ref) {
      ref.addEventListener('wheel', handleWheel, {
        passive: true
      });
    }
    return () => {
      if (ref) {
        ref.removeEventListener('wheel', handleWheel);
      }
    };
  }, []);
  const handleKeyDown = useCallback(event => {
    if (isNumber(step) && step % 1 === 0 && (event.key === '.' || event.key === ',')) {
      event.preventDefault();
    }
    if (disableSpecialChars && SPECIAL_CHARS.includes(event.key)) {
      event.preventDefault();
    }
  }, [disableSpecialChars, step]);
  const handleChange = useCallback(event => {
    if (!onChange) {
      return;
    }
    const parseFunction = integerOnly ? Number.parseInt : Number.parseFloat;
    const value = event.target.value ? parseFunction(event.target.value) : undefined;
    onChange(event, value);
  }, [integerOnly, onChange]);
  return jsx(StyledNumberInput, {
    fullWidth: true,
    inputRef: inputRef,
    error: error,
    variant: "outlined",
    type: "number",
    label: label,
    helperText: helperText,
    placeholder: placeholder,
    name: name,
    className: className,
    "data-cy": dataCy,
    disabled: disabled,
    value: value,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: onClick,
    InputProps: InputProps,
    InputLabelProps: inputLabelProps,
    defaultValue: defaultValue,
    required: required,
    withSpinButtons: withSpinButtons,
    onKeyDown: handleKeyDown
  });
}
function NumberInputFormikWrapper(props) {
  const {
    name,
    className,
    dataCy,
    disabled,
    label,
    placeholder,
    helperText,
    min,
    max,
    onKeyPress,
    onFocus,
    onBlur,
    startAdornment,
    endAdornment,
    step,
    onClick,
    onChange,
    integerOnly,
    required,
    disableSpecialChars,
    withSpinButtons
  } = props;
  const [field, meta, helpers] = useField(name);
  const hasErrors = meta.touched ? Boolean(meta.error) : false;
  const errorMsg = meta.touched ? Array.isArray(meta.error) ? meta.error[0] : meta.error : undefined;
  const handleChange = useCallback((event, value) => {
    Promise.all([helpers.setValue(value, true), helpers.setTouched(true, false)]).then(() => {
      if (onChange) {
        onChange(event, value);
      }
    });
  }, [helpers, onChange]);
  const handleBlur = useCallback(event => {
    if (!meta.touched) {
      helpers.setTouched(true, true).then(() => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
      });
    } else {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }
  }, [helpers, meta.touched, onBlur]);
  return jsx(NumberInput, {
    name: name,
    className: className,
    dataCy: dataCy,
    disabled: disabled,
    label: label,
    placeholder: placeholder,
    error: meta.touched && hasErrors,
    helperText: meta.touched && errorMsg || helperText,
    value: field.value,
    onChange: handleChange,
    min: min,
    max: max,
    onKeyPress: onKeyPress,
    onFocus: onFocus,
    onBlur: handleBlur,
    onClick: onClick,
    startAdornment: startAdornment,
    endAdornment: endAdornment,
    step: step,
    integerOnly: integerOnly,
    required: required,
    disableSpecialChars: disableSpecialChars,
    withSpinButtons: withSpinButtons
  });
}
function NumberInputReduxFormWrapper(props) {
  const {
    input,
    className,
    disabled,
    label,
    dataCy,
    min,
    max,
    placeholder,
    helperText,
    meta,
    onKeyPress,
    startAdornment,
    endAdornment,
    onClick,
    integerOnly,
    required,
    disableSpecialChars,
    withSpinButtons
  } = props;
  const hasErrors = Boolean(meta.error);
  const errorMsg = Array.isArray(meta.error) ? meta.error[0] : meta.error;
  return jsx(NumberInput, {
    value: input.value,
    name: input.name,
    onChange: input.onChange,
    min: min,
    max: max,
    dataCy: dataCy,
    disabled: disabled,
    label: label,
    placeholder: placeholder,
    helperText: meta.touched && errorMsg || helperText,
    error: meta.touched && hasErrors,
    className: className,
    onKeyPress: onKeyPress,
    onBlur: input.onBlur,
    onFocus: input.onFocus,
    onClick: onClick,
    startAdornment: startAdornment,
    endAdornment: endAdornment,
    integerOnly: integerOnly,
    required: required,
    disableSpecialChars: disableSpecialChars,
    withSpinButtons: withSpinButtons
  });
}
function NumberSwitcher(_ref191) {
  let {
    value,
    min,
    max,
    onChange,
    dataCy
  } = _ref191;
  return jsxs(Layout, {
    hAlign: "space-between",
    vAlign: "center",
    gap: 10,
    children: [jsx(IconButton, {
      dataCy: dataCy ? "".concat(dataCy, "-previous-button") : undefined,
      icon: "navigateBefore",
      disabled: value === min,
      onClick: () => onChange(value - 1)
    }), jsx(Typography, {
      variant: "label",
      size: "large",
      children: value
    }), jsx(IconButton, {
      dataCy: dataCy ? "".concat(dataCy, "-next-button") : undefined,
      icon: "navigateNext",
      disabled: value === max,
      onClick: () => onChange(value + 1)
    })]
  });
}
function PageHeader(_ref192) {
  let {
    title,
    subtitle,
    icon,
    withDivider
  } = _ref192;
  return jsxs(Layout, {
    stack: true,
    gap: "--Spacing-200",
    flex: "0",
    children: [jsxs(Layout, {
      vAlign: "stretch",
      gap: "--Spacing-300",
      children: [jsx(Icon, {
        className: icon.className,
        color: "on-surface",
        size: 80,
        name: icon.name
      }), jsxs(Layout, {
        stack: true,
        vAlign: "space-between",
        children: [jsx(Typography, {
          variant: "headline",
          size: "medium",
          color: "on-surface",
          children: title
        }), jsx(Typography, {
          variant: "body",
          size: "small",
          color: "on-surface",
          children: subtitle
        })]
      })]
    }), withDivider && jsx(Divider$1, {})]
  });
}
function PageWrapper(_ref193) {
  let {
    children
  } = _ref193;
  return jsx(Layout, {
    stack: true,
    vAlign: "stretch",
    pt: "--Spacing-300",
    gap: "--Spacing-200",
    pl: 80,
    pr: 80,
    children: children
  });
}
function Pagination(_ref194) {
  let {
    pageIndex,
    pageSize,
    itemsAmount,
    dataCy,
    onChange
  } = _ref194;
  const startAmount = pageIndex * pageSize;
  const endAmount = (pageIndex + 1) * pageSize;
  const defaultStartAmountValue = itemsAmount ? 1 : 0;
  return jsxs(Layout, {
    vAlign: "center",
    hAlign: "space-between",
    gap: "--Spacing-100",
    children: [jsxs(Layout, {
      hAlign: "space-between",
      gap: "--Spacing-100",
      children: [jsx(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface",
        children: startAmount ? startAmount + 1 : defaultStartAmountValue
      }), jsx(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface",
        children: "-"
      }), jsx(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface",
        children: endAmount > itemsAmount ? itemsAmount : endAmount
      }), jsxs(Typography, {
        variant: "body",
        size: "medium",
        color: "on-surface",
        children: ["of ", itemsAmount]
      })]
    }), jsxs(Layout, {
      children: [jsx(IconButton, {
        disabled: pageIndex - 1 < 0,
        dataCy: dataCy && "".concat(dataCy, "-previousPage"),
        iconSize: 24,
        icon: "navigateBefore",
        onClick: () => onChange(pageIndex - 1)
      }), jsx(IconButton, {
        disabled: endAmount >= itemsAmount,
        dataCy: dataCy && "".concat(dataCy, "-nextPage"),
        iconSize: 24,
        icon: "navigateNext",
        onClick: () => onChange(pageIndex + 1)
      })]
    })]
  });
}
var isObject = isObject$e;
var classof = classofRaw$2;
var wellKnownSymbol$1 = wellKnownSymbol$l;
var MATCH$1 = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};
var isRegExp = isRegexp;
var $TypeError = TypeError;
var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  }
  return it;
};
var wellKnownSymbol = wellKnownSymbol$l;
var MATCH = wellKnownSymbol('match');
var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) {/* empty */}
  }
  return false;
};
var $$1 = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$7;
var toString$1 = toString$a;
var correctIsRegExpLogic = correctIsRegexpLogic;
var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$1({
  target: 'String',
  proto: true,
  forced: !correctIsRegExpLogic('includes')
}, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(toString$1(requireObjectCoercible(this)), toString$1(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
  }
});
var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails = fails$q;
var whitespaces = whitespaces$4;
var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};
var $ = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({
  target: 'String',
  proto: true,
  forced: forcedStringTrimMethod('trim')
}, {
  trim: function trim() {
    return $trim(this);
  }
});
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var _excluded = ["cdnSuffix", "cdnUrl", "countryCode", "style", "svg"];
var DEFAULT_CDN_URL = 'https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/';
var DEFAULT_CDN_SUFFIX = 'svg';
// offset between uppercase ascii and regional indicator symbols
var OFFSET = 127397;
var ReactCountryFlag = function ReactCountryFlag(_ref) {
  var _ref$cdnSuffix = _ref.cdnSuffix,
    cdnSuffix = _ref$cdnSuffix === void 0 ? DEFAULT_CDN_SUFFIX : _ref$cdnSuffix,
    _ref$cdnUrl = _ref.cdnUrl,
    cdnUrl = _ref$cdnUrl === void 0 ? DEFAULT_CDN_URL : _ref$cdnUrl,
    countryCode = _ref.countryCode,
    style = _ref.style,
    _ref$svg = _ref.svg,
    svg = _ref$svg === void 0 ? false : _ref$svg,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (typeof countryCode !== 'string') {
    return null;
  }
  if (svg) {
    var flagUrl = "" + cdnUrl + countryCode.toLowerCase() + "." + cdnSuffix;
    return createElement$2("img", Object.assign({}, props, {
      src: flagUrl,
      style: _extends({
        display: 'inline-block',
        width: '1em',
        height: '1em',
        verticalAlign: 'middle'
      }, style)
    }));
  }
  var emoji = countryCode.toUpperCase().replace(/./g, function (_char) {
    return String.fromCodePoint(_char.charCodeAt(0) + OFFSET);
  });
  return createElement$2("span", Object.assign({
    role: "img"
  }, props, {
    style: _extends({
      display: 'inline-block',
      fontSize: '1em',
      lineHeight: '1em',
      verticalAlign: 'middle'
    }, style)
  }), emoji);
};
const DEFAULT_COUNTRY = {
  label: '',
  value: '',
  inputLabel: '',
  callingCode: ''
};
const FLAG_STYLE = {
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  objectFit: 'cover',
  fontSize: '24px',
  lineHeight: '24px'
};
const DEFAULT_FORM_WIDTH = 200;
const SELECTED_FORM_WIDTH = 250;
const DEFAULT_PLACEHOLDER = '(+_) ___-____';
const createCountryOption = country => {
  const callingCode = getCountryCallingCode(country.code);
  return {
    value: country.code,
    inputLabel: country.code,
    callingCode,
    label: "".concat(country.name, " +").concat(callingCode)
  };
};
const formatPhoneNumber = (value, currentCallingCode, newCallingCode) => {
  if (!value) return "+".concat(newCallingCode);
  const restOfNumber = currentCallingCode ? value.slice(currentCallingCode.length + 1) : value.replace(/^\+/, '');
  return "+".concat(newCallingCode).concat(restOfNumber).trim();
};
const StyledFormControl = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "phone-number-input__StyledFormControl",
  componentId: "sc-1h7d9d5-0"
})(["&.MuiFormControl-root{min-width:", "px;}&.muiselect-select:focus{background:transparent;}"], _ref195 => {
  let {
    countrySelected
  } = _ref195;
  return countrySelected ? SELECTED_FORM_WIDTH : DEFAULT_FORM_WIDTH;
});
const CountryFlag = /*#__PURE__*/React__default.memo(_ref196 => {
  let {
    country
  } = _ref196;
  return jsx(ReactCountryFlag, {
    className: "countryFlag",
    countryCode: (country === null || country === void 0 ? void 0 : country.value) || '',
    alt: country === null || country === void 0 ? void 0 : country.label,
    "aria-label": country === null || country === void 0 ? void 0 : country.label,
    style: FLAG_STYLE,
    svg: true
  });
});
const CountryLabel = /*#__PURE__*/React__default.memo(_ref197 => {
  let {
    country
  } = _ref197;
  return jsxs(Layout, {
    gap: "--Spacing-50",
    vAlign: "center",
    hAlign: "space-between",
    flex: "1",
    children: [jsx(Typography, {
      variant: "label",
      size: "large",
      prominent: true,
      children: country.label
    }), jsx(CountryFlag, {
      country: country
    })]
  });
});
const CountrySelect = /*#__PURE__*/React__default.memo(_ref198 => {
  let {
    countries,
    value,
    onChange
  } = _ref198;
  const options = useMemo(() => countries.map(createCountryOption), [countries]);
  const handleChange = useCallback((_, value) => onChange(value), [onChange]);
  return jsx(StyledFormControl, {
    variant: "outlined",
    countrySelected: Boolean(value.value),
    children: jsx(Select, {
      disableClearable: true,
      options: options,
      value: value,
      onChange: handleChange,
      optionLabel: "inputLabel",
      optionValue: "value",
      popperWidth: DEFAULT_FORM_WIDTH,
      StartAdornment: _ref199 => {
        let {
          value: country
        } = _ref199;
        return (country === null || country === void 0 ? void 0 : country.value) ? jsx(CountryFlag, {
          country: country
        }) : jsx(Icon, {
          name: "language",
          size: 24
        });
      },
      labelRenderer: country => jsx(CountryLabel, {
        country: country
      }),
      placeholder: "Choose your country",
      customFilterOptions: (options, state) => {
        return options.filter(option => {
          var _a, _b, _c, _d;
          const searchValue = state.inputValue.toLowerCase().trim();
          return ((_a = option.value) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchValue)) || ((_b = option.inputLabel) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchValue)) || ((_c = option.callingCode) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(searchValue)) || ((_d = option.label) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchValue));
        });
      },
      dataCy: "phone-country-select"
    })
  });
});
const CustomPhoneInput = /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef((props, ref) => {
  const {
    value,
    onChange,
    placeholder
  } = props;
  const handleInputChange = useCallback(event => {
    onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
  }, [onChange]);
  return jsx(TextField, {
    inputRef: ref,
    label: "Phone Number",
    placeholder: placeholder,
    value: value || '',
    onChange: handleInputChange,
    dataCy: "phone-number-input"
  });
}));
const PhoneNumberInput = /*#__PURE__*/React__default.memo(_ref200 => {
  let {
    value,
    onChange,
    name,
    placeholder,
    countries,
    defaultCountryCode,
    country,
    setCountry
  } = _ref200;
  const parsedNumber = useMemo(() => parsePhoneNumber(value || ''), [value]);
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  useLayoutEffect(() => {
    if (!value && !country.value && defaultCountryCode) {
      const matchingCountry = countries.find(c => c.code === defaultCountryCode);
      if (matchingCountry) {
        const countryOption = createCountryOption(matchingCountry);
        setCountry(countryOption);
        onChangeRef.current("+".concat(countryOption.callingCode));
      }
    }
  }, [defaultCountryCode, countries, value, country.value, setCountry]);
  useEffect(() => {
    if (!value || value === '+') return;
    if (!(parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.country)) return;
    const matchingCountry = countries.find(c => c.code === parsedNumber.country);
    if (!matchingCountry) return;
    const newCountryOption = createCountryOption(matchingCountry);
    if (newCountryOption.value !== country.value) {
      setCountry(newCountryOption);
    }
  }, [parsedNumber === null || parsedNumber === void 0 ? void 0 : parsedNumber.country, countries, country.value, value, setCountry]);
  const handleCountryChange = useCallback(newCountry => {
    if (newCountry.callingCode) {
      const newNumber = formatPhoneNumber(value, country.callingCode, newCountry.callingCode);
      if (newNumber !== value) {
        onChange(newNumber);
      }
    }
    setCountry(newCountry);
  }, [value, onChange, country, setCountry]);
  const handleValueChange = useCallback(number => {
    onChange(number || '');
  }, [onChange]);
  return jsxs(Layout, {
    gap: "--Spacing-100",
    children: [jsx(CountrySelect, {
      value: country,
      onChange: handleCountryChange,
      countries: countries
    }), jsx(Input, {
      name: name,
      value: value,
      onChange: handleValueChange,
      inputComponent: CustomPhoneInput,
      placeholder: placeholder || DEFAULT_PLACEHOLDER,
      "data-cy": "phone-number-input"
    })]
  });
});
const StyledLinear = /*#__PURE__*/styled(LinearProgress).withConfig({
  displayName: "progress__StyledLinear",
  componentId: "gk369s-0"
})([".MuiLinearProgress-colorPrimary{background-color:", ";}.MuiLinearProgress-barColorPrimary{background-color:", ";}.MuiLinearProgress-bar1Indeterminate{transition:none;}.MuiLinearProgress-bar2Indeterminate{transition:none;animation:none;}"], props => props.theme.designTokens.color.color.surfaces['primary-container'].value, props => props.theme.designTokens.color.color.primary.primary.value);
const StyledCircular = /*#__PURE__*/styled(CircularProgress).withConfig({
  displayName: "progress__StyledCircular",
  componentId: "gk369s-1"
})(["&.MuiCircularProgress-colorPrimary{color:", ";}"], props => props.theme.designTokens.color.color.primary.primary.value);
function Progress(props) {
  const {
    className
  } = props;
  if (props.variant === 'linear') {
    return jsx(StyledLinear, {
      className: className
    });
  }
  const {
    size = 24
  } = props;
  return jsx(StyledCircular, {
    className: className,
    size: size
  });
}
const StyledInput = /*#__PURE__*/styled(TextField$1).withConfig({
  displayName: "search-bar__StyledInput",
  componentId: "sc-1lsswe4-0"
})(["&.MuiTextField-root{", ";padding:", ";border-radius:28px 28px ", ";background:", ";color:", ";", " input{padding-left:8px;padding-right:8px;&::placeholder{", ";color:", ";opacity:1;}}}"], () => typographyVariantStyles['body-medium'], props => props.hasOptions ? '0px 12px' : '0px 12px 0px 16px', props => props.open ? '0 0' : '28px 28px', props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value, props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.open && css(["border-bottom:1px solid ", ";"], props => props.theme.designTokens.color.color.light.outline.value), () => typographyVariantStyles['body-medium'], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value);
const StyledPopper = /*#__PURE__*/styled(Popper$1).withConfig({
  displayName: "search-bar__StyledPopper",
  componentId: "sc-1lsswe4-1"
})(["margin-top:-3px;.MuiPaper-root{background-color:", ";border-radius:0 0 28px 28px;margin-left:-12px;margin-right:-12px;}.MuiAutocomplete-listbox{padding:0;}"], props => props.theme.designTokens.color.color.surfaces['surface-container-high'].value);
const StyledAutocomplete = /*#__PURE__*/styled(Autocomplete).withConfig({
  displayName: "search-bar__StyledAutocomplete",
  componentId: "sc-1lsswe4-2"
})(["&.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot{padding-right:0px;}.MuiAutocomplete-inputRoot{min-height:41px;}.MuiAutocomplete-clearIndicator{padding:0 2px;}"]);
const StyledOption = /*#__PURE__*/styled.li.withConfig({
  displayName: "search-bar__StyledOption",
  componentId: "sc-1lsswe4-3"
})(["padding:8px 16px;"]);
function SearchBar(_ref201) {
  let {
    options = [],
    placeholder,
    onChange,
    value,
    dataCy
  } = _ref201;
  const filter = createFilterOptions();
  const [open, setOpen] = useState(false);
  return jsx(StyledAutocomplete, {
    freeSolo: true,
    options: options,
    open: open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
    PopperComponent: props => jsx(StyledPopper, Object.assign({}, props, {
      placement: "bottom-start"
    })),
    closeIcon: jsx(Icon, {
      name: "close"
    }),
    value: value,
    onInputChange: (event, newInputValue) => {
      onChange && onChange(newInputValue);
    },
    filterOptions: (options, params) => filter(options, params),
    PaperComponent: props => jsx(Paper, Object.assign({}, props, {
      elevation: 0
    })),
    renderOption: option => jsx(StyledOption, {
      children: option
    }),
    renderInput: params => jsx(StyledInput, Object.assign({}, params, {
      open: open && !!options.length,
      fullWidth: true,
      type: "text",
      placeholder: placeholder,
      hasOptions: Boolean(options === null || options === void 0 ? void 0 : options.length),
      InputProps: Object.assign(Object.assign(Object.assign(Object.assign({}, params.InputProps), {
        disableUnderline: true,
        startAdornment: options.length ? jsx(IconButton, {
          iconSize: 24,
          onClick: () => setOpen(!open),
          icon: open && !!options.length ? 'arrowBack' : 'menu'
        }) : null
      }), !value && {
        endAdornment: jsx(Icon, {
          name: "search"
        })
      }), {
        inputProps: Object.assign(Object.assign({}, params.inputProps), {
          'data-cy': dataCy ? "".concat(dataCy, "-input") : undefined
        })
      })
    }))
  });
}
const StyledSegmentedButton = /*#__PURE__*/styled(ButtonGroup).withConfig({
  displayName: "segmented-button__StyledSegmentedButton",
  componentId: "sc-15ugh08-0"
})(["max-height:48px;padding:4px;"]);
function SegmentedButton(props) {
  const {
    dataCy
  } = props;
  return jsxs(StyledSegmentedButton, {
    "data-cy": dataCy,
    children: [jsx(Button, {
      variant: "filled",
      startIcon: "check",
      children: "Label"
    }), jsx(Button, {
      children: "Label"
    }), jsx(Button, {
      children: "Label"
    })]
  });
}
const sizeVariants = {
  small: {
    sliderTopPosition: -4,
    trackHeight: 11,
    markerTopPosition: 17,
    thumbHeight: 32,
    thumbTopPosition: 7,
    valueLabelLeft: 0,
    valueLabelTop: -10,
    valueLabelSize: 24,
    valueLabelPadding: "8px 12px"
  },
  default: {
    sliderTopPosition: 0,
    trackHeight: 16,
    markerTopPosition: 19,
    thumbHeight: 44,
    thumbTopPosition: 4,
    valueLabelLeft: 4,
    valueLabelTop: -24,
    valueLabelSize: 32,
    valueLabelPadding: "12px 16px"
  }
};
const variantColors = {
  blue: {
    rail: designTokens.color.color.surfaces['surface-container-low'].value,
    track: designTokens.color.color.surfaces['tertiary-container'].value,
    marker: designTokens.color['on color'].surface['on-tertiary-container'].value,
    markerActive: designTokens.color['on color'].surface['on-tertiary-container'].value,
    thumb: designTokens.color.color.surfaces['tertiary-container'].value,
    valueLabelBackground: designTokens.color.color.surfaces['tertiary-container'].value,
    valueLabelColor: designTokens.color['on color'].surface['on-tertiary-container'].value
  },
  green: {
    rail: designTokens.color.color.surfaces['primary-container'].value,
    track: designTokens.color.color.primary.primary.value,
    thumb: designTokens.color.color.primary.primary.value,
    marker: designTokens.color['on color'].surface['on-tertiary-container'].value,
    markerActive: designTokens.color.color.surfaces['primary-container'].value,
    valueLabelBackground: designTokens.color.color.primary.primary.value,
    valueLabelColor: designTokens.color['on color'].primary['on-primary'].value
  },
  red: {
    rail: designTokens.color.color.surfaces['surface-container-low'].value,
    track: designTokens.color.color.surfaces['error-container'].value,
    thumb: designTokens.color.color.surfaces['error-container'].value,
    marker: designTokens.color['on color'].surface['on-tertiary-container'].value,
    markerActive: designTokens.color['on color'].surface['on-error-container'].value,
    valueLabelBackground: designTokens.color.color.surfaces['error-container'].value,
    valueLabelColor: designTokens.color['on color'].surface['on-error-container'].value
  }
};
const StyledSliderWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "slider__StyledSliderWrapper",
  componentId: "abn8dn-0"
})(["width:100%;"]);
const StyledSlider = /*#__PURE__*/styled(MuiSlider).withConfig({
  displayName: "slider__StyledSlider",
  componentId: "abn8dn-1"
})(["&.MuiSlider-root.MuiSlider-colorPrimary{position:relative;top:", "px;.MuiSlider-rail{height:", "px;border-radius:16px;opacity:1;background-color:", ";&:after{display:block;content:'';position:relative;left:calc(100% - 6px);height:", "px;width:12px;background-color:", ";border-top-right-radius:16px;border-bottom-right-radius:16px;}}.MuiSlider-track{border-top-left-radius:16px;border-bottom-left-radius:16px;height:", "px;opacity:1;background-color:", ";&:before{display:block;content:'';position:relative;left:-4px;height:", "px;width:10px;background-color:", ";border-top-left-radius:16px;border-bottom-left-radius:16px;}}.MuiSlider-thumb{height:44px;width:2px;padding:0 6px;border-radius:2px;background-color:", ";top:0;&.Mui-focusVisible{box-shadow:none;}&:hover,&:active,&:focus,&:focus-visible{box-shadow:none;}&:after{content:'';display:block;height:", "px;width:2px;border-radius:2px;top:", "px;left:5px;background-color:", ";}}.MuiSlider-mark{top:", "px;height:4px;width:4px;border-radius:100%;background-color:", ";&Active{opacity:1;background-color:", ";}}.MuiSlider-markLabel{display:none;}span:nth-last-child(1 of .MuiSlider-mark){left:calc(100% - 4px) !important;}.MuiSlider-valueLabel{top:", "px;left:calc(-50% - ", "px);> span{background-color:", ";border-radius:100%;padding:", ";width:", "px;height:", "px;transform:unset;> span{transform:unset;color:", ";}}}&.Mui-disabled{.MuiSlider-rail{background-color:", ";&:after{background-color:transparent;}}.MuiSlider-track{background-color:transparent;&:before{background-color:transparent;}}.MuiSlider-mark{opacity:0.38;background-color:", ";}.MuiSlider-thumb{&:after{opacity:0.38;background-color:", ";}}}}"], props => sizeVariants[props.size].sliderTopPosition, props => sizeVariants[props.size].trackHeight, props => variantColors[props.variant].rail, props => sizeVariants[props.size].trackHeight, props => variantColors[props.variant].rail, props => sizeVariants[props.size].trackHeight, props => variantColors[props.variant].track, props => sizeVariants[props.size].trackHeight, props => variantColors[props.variant].track, props => getColor(props.sliderThumbBackgroundColor), props => sizeVariants[props.size].thumbHeight, props => sizeVariants[props.size].thumbTopPosition, props => variantColors[props.variant].thumb, props => sizeVariants[props.size].markerTopPosition, props => variantColors[props.variant].marker, props => variantColors[props.variant].markerActive, props => sizeVariants[props.size].valueLabelTop, props => sizeVariants[props.size].valueLabelLeft, props => variantColors[props.variant].valueLabelBackground, props => sizeVariants[props.size].valueLabelPadding, props => sizeVariants[props.size].valueLabelSize, props => sizeVariants[props.size].valueLabelSize, props => variantColors[props.variant].valueLabelColor, props => props.theme.designTokens.color.color['state-layers'].light['on-surface']['opacity-0.12'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value, props => props.theme.designTokens.color['on color'].surface['on-surface'].value);
function Slider(props) {
  const {
    getAriaValueText,
    scale,
    valueLabelFormat,
    dataCy,
    className,
    value,
    onChange,
    onChangeCommitted,
    max,
    min,
    step,
    marks,
    valueLabelDisplay,
    disabled,
    variant = 'green',
    size = 'default',
    sliderThumbBackgroundColor = 'surface-container'
  } = props;
  const [innerValue, setInnerValue] = useState(value);
  const handleChange = useCallback((event, value) => {
    setInnerValue(value);
    if (onChange) {
      onChange(event, value);
    }
  }, [onChange]);
  const debouncedHandleChangeCommitted = useMemo(() => {
    return debounce$1((event, value) => {
      if (onChangeCommitted) {
        onChangeCommitted(event, value);
      }
    }, 350);
  }, [onChangeCommitted]);
  const handleChangeCommitted = useCallback((event, value) => {
    setInnerValue(value);
    debouncedHandleChangeCommitted(event, value);
  }, [debouncedHandleChangeCommitted]);
  const wrapperPaddingTop = useMemo(() => {
    if (valueLabelDisplay === 'off') {
      return 0;
    }
    if (size === 'small') {
      return 28;
    }
    return 36;
  }, [size, valueLabelDisplay]);
  return jsx(StyledSliderWrapper, {
    pt: wrapperPaddingTop,
    children: jsx(StyledSlider, {
      size: size,
      variant: variant,
      className: className,
      "data-cy": dataCy,
      disabled: disabled,
      value: innerValue,
      onChange: handleChange,
      onChangeCommitted: handleChangeCommitted,
      min: min,
      max: max,
      step: step,
      marks: marks,
      valueLabelDisplay: disabled ? 'off' : valueLabelDisplay,
      getAriaValueText: getAriaValueText,
      scale: scale,
      valueLabelFormat: valueLabelFormat,
      sliderThumbBackgroundColor: sliderThumbBackgroundColor
    })
  });
}
const SlidesContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "slides__SlidesContainer",
  componentId: "tojz4o-0"
})(["height:100%;transition:all 0.1s;& > div{height:100%;.react-swipeable-view-container{height:100%;}}"]);
function Slides(props) {
  const {
    items,
    mainComponent,
    className
  } = props;
  const [state, setState] = useState({
    slidesIndex: null,
    currentSlideIndex: 0
  });
  const nextSlide = useCallback(() => {
    setState(prev => Object.assign(Object.assign({}, prev), {
      currentSlideIndex: prev.currentSlideIndex + 1
    }));
  }, []);
  const prevSlide = useCallback(() => {
    setState(prev => ({
      slidesIndex: prev.currentSlideIndex === 1 ? null : prev.slidesIndex,
      currentSlideIndex: prev.currentSlideIndex - 1
    }));
  }, []);
  const topSlide = useCallback(() => {
    setState(() => ({
      slidesIndex: null,
      currentSlideIndex: 0
    }));
  }, []);
  const toSlidesGroup = useCallback(index => {
    setState({
      slidesIndex: index,
      currentSlideIndex: 1
    });
  }, []);
  const enhancedSlides = useMemo(() => {
    return items({
      nextSlide,
      prevSlide,
      topSlide
    });
  }, [nextSlide, prevSlide, items, topSlide]);
  const enhancedMainComponent = useMemo(() => {
    return mainComponent({
      toSlidesGroup
    });
  }, [mainComponent, toSlidesGroup]);
  const containerRef = useRef(null);
  const slidesToDisplay = useMemo(() => {
    if (state.slidesIndex === null) {
      return [enhancedMainComponent];
    }
    return [enhancedMainComponent, ...enhancedSlides[state.slidesIndex]];
  }, [state.slidesIndex, enhancedSlides, enhancedMainComponent]);
  return jsx(SlidesContainer, {
    className: className,
    ref: containerRef,
    children: jsx(SwipeableViews, {
      index: state.currentSlideIndex,
      children: slidesToDisplay.map((slide, index) => {
        return slide;
      })
    })
  });
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys$3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
// re-exporting type to make it easy to use

var getDistanceToEdge = {
  top: function top(rect, client) {
    return Math.abs(client.y - rect.top);
  },
  right: function right(rect, client) {
    return Math.abs(rect.right - client.x);
  },
  bottom: function bottom(rect, client) {
    return Math.abs(rect.bottom - client.y);
  },
  left: function left(rect, client) {
    return Math.abs(client.x - rect.left);
  }
};

// using a symbol so we can guarantee a key with a unique value
var uniqueKey = Symbol('closestEdge');

/**
 * Adds a unique `Symbol` to the `userData` object. Use with `extractClosestEdge()` for type safe lookups.
 */
function attachClosestEdge(userData, _ref) {
  var _entries$sort$0$edge, _entries$sort$;
  var element = _ref.element,
    input = _ref.input,
    allowedEdges = _ref.allowedEdges;
  var client = {
    x: input.clientX,
    y: input.clientY
  };
  // I tried caching the result of `getBoundingClientRect()` for a single
  // frame in order to improve performance.
  // However, on measurement I saw no improvement. So no longer caching
  var rect = element.getBoundingClientRect();
  var entries = allowedEdges.map(function (edge) {
    return {
      edge: edge,
      value: getDistanceToEdge[edge](rect, client)
    };
  });

  // edge can be `null` when `allowedEdges` is []
  var addClosestEdge = (_entries$sort$0$edge = (_entries$sort$ = entries.sort(function (a, b) {
    return a.value - b.value;
  })[0]) === null || _entries$sort$ === void 0 ? void 0 : _entries$sort$.edge) !== null && _entries$sort$0$edge !== void 0 ? _entries$sort$0$edge : null;
  return _objectSpread$3(_objectSpread$3({}, userData), {}, _defineProperty({}, uniqueKey, addClosestEdge));
}

/**
 * Returns the value added by `attachClosestEdge()` to the `userData` object. It will return `null` if there is no value.
 */
function extractClosestEdge(userData) {
  var _ref2;
  return (_ref2 = userData[uniqueKey]) !== null && _ref2 !== void 0 ? _ref2 : null;
}
function getReorderDestinationIndex(_ref) {
  var startIndex = _ref.startIndex,
    closestEdgeOfTarget = _ref.closestEdgeOfTarget,
    indexOfTarget = _ref.indexOfTarget,
    axis = _ref.axis;
  // invalid index's
  if (startIndex === -1 || indexOfTarget === -1) {
    return startIndex;
  }

  // if we are targeting the same index we don't need to do anything
  if (startIndex === indexOfTarget) {
    return startIndex;
  }
  if (closestEdgeOfTarget == null) {
    return indexOfTarget;
  }
  var isGoingAfter = axis === 'vertical' && closestEdgeOfTarget === 'bottom' || axis === 'horizontal' && closestEdgeOfTarget === 'right';
  var isMovingForward = startIndex < indexOfTarget;
  // moving forward
  if (isMovingForward) {
    return isGoingAfter ? indexOfTarget : indexOfTarget - 1;
  }
  // moving backwards
  return isGoingAfter ? indexOfTarget + 1 : indexOfTarget;
}

/** Create a new combined function that will call all the provided functions */
function combine() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function cleanup() {
    fns.forEach(function (fn) {
      return fn();
    });
  };
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray$2(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray$2(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$2(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$2(r, e) || _nonIterableRest();
}
var dist = {};
var bind$1 = {};
Object.defineProperty(bind$1, "__esModule", {
  value: true
});
bind$1.bind = void 0;
function bind(target, _a) {
  var type = _a.type,
    listener = _a.listener,
    options = _a.options;
  target.addEventListener(type, listener, options);
  return function unbind() {
    target.removeEventListener(type, listener, options);
  };
}
bind$1.bind = bind;
var bindAll$1 = {};
var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(bindAll$1, "__esModule", {
  value: true
});
bindAll$1.bindAll = void 0;
var bind_1 = bind$1;
function toOptions(value) {
  if (typeof value === 'undefined') {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return {
      capture: value
    };
  }
  return value;
}
function getBinding(original, sharedOptions) {
  if (sharedOptions == null) {
    return original;
  }
  var binding = __assign(__assign({}, original), {
    options: __assign(__assign({}, toOptions(sharedOptions)), toOptions(original.options))
  });
  return binding;
}
function bindAll(target, bindings, sharedOptions) {
  var unbinds = bindings.map(function (original) {
    var binding = getBinding(original, sharedOptions);
    return (0, bind_1.bind)(target, binding);
  });
  return function unbindAll() {
    unbinds.forEach(function (unbind) {
      return unbind();
    });
  };
}
bindAll$1.bindAll = bindAll;
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.bindAll = exports.bind = void 0;
  var bind_1 = bind$1;
  Object.defineProperty(exports, "bind", {
    enumerable: true,
    get: function () {
      return bind_1.bind;
    }
  });
  var bind_all_1 = bindAll$1;
  Object.defineProperty(exports, "bindAll", {
    enumerable: true,
    get: function () {
      return bind_all_1.bindAll;
    }
  });
})(dist);

// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var honeyPotDataAttribute = 'data-pdnd-honey-pot';
function isHoneyPotElement(target) {
  return target instanceof Element && target.hasAttribute(honeyPotDataAttribute);
}
function getElementFromPointWithoutHoneypot(client) {
  // eslint-disable-next-line no-restricted-syntax
  var _document$elementsFro = document.elementsFromPoint(client.x, client.y),
    _document$elementsFro2 = _slicedToArray(_document$elementsFro, 2),
    top = _document$elementsFro2[0],
    second = _document$elementsFro2[1];
  if (!top) {
    return null;
  }
  if (isHoneyPotElement(top)) {
    return second !== null && second !== void 0 ? second : null;
  }
  return top;
}

// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var maxZIndex = 2147483647;
function ownKeys$2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var honeyPotSize = 2;
var halfHoneyPotSize = honeyPotSize / 2;

/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/
function floorToClosestPixel(point) {
  return {
    x: Math.floor(point.x),
    y: Math.floor(point.y)
  };
}

/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */
function pullBackByHalfHoneyPotSize(point) {
  return {
    x: point.x - halfHoneyPotSize,
    y: point.y - halfHoneyPotSize
  };
}

/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */
function preventGoingBackwardsOffScreen(point) {
  return {
    x: Math.max(point.x, 0),
    y: Math.max(point.y, 0)
  };
}

/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */
function preventGoingForwardsOffScreen(point) {
  return {
    x: Math.min(point.x, window.innerWidth - honeyPotSize),
    y: Math.min(point.y, window.innerHeight - honeyPotSize)
  };
}

/**
 * Create a `2x2` `DOMRect` around the `client` position
 */
function getHoneyPotRectFor(_ref) {
  var client = _ref.client;
  var point = preventGoingForwardsOffScreen(preventGoingBackwardsOffScreen(pullBackByHalfHoneyPotSize(floorToClosestPixel(client))));

  // When debugging, it is helpful to
  // make this element a bit bigger
  return DOMRect.fromRect({
    x: point.x,
    y: point.y,
    width: honeyPotSize,
    height: honeyPotSize
  });
}
function getRectStyles(_ref2) {
  var clientRect = _ref2.clientRect;
  return {
    left: "".concat(clientRect.left, "px"),
    top: "".concat(clientRect.top, "px"),
    width: "".concat(clientRect.width, "px"),
    height: "".concat(clientRect.height, "px")
  };
}
function isWithin(_ref3) {
  var client = _ref3.client,
    clientRect = _ref3.clientRect;
  return (
    // is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width &&
    // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height
  );
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */
function mountHoneyPot(_ref4) {
  var initial = _ref4.initial;
  var element = document.createElement('div');
  element.setAttribute(honeyPotDataAttribute, 'true');

  // can shift during the drag thanks to Firefox
  var clientRect = getHoneyPotRectFor({
    client: initial
  });
  Object.assign(element.style, _objectSpread$2(_objectSpread$2({
    // Setting a background color explicitly to avoid any inherited styles.
    // Looks like this could be `opacity: 0`, but worried that _might_
    // cause the element to be ignored on some platforms.
    // When debugging, set backgroundColor to something like "red".
    backgroundColor: 'transparent',
    position: 'fixed',
    // Being explicit to avoid inheriting styles
    padding: 0,
    margin: 0,
    boxSizing: 'border-box'
  }, getRectStyles({
    clientRect: clientRect
  })), {}, {
    // We want this element to absorb pointer events,
    // it's kind of the whole point 😉
    pointerEvents: 'auto',
    // Want to make sure the honey pot is top of everything else.
    // Don't need to worry about native drag previews, as they will
    // have been rendered (and removed) before the honey pot is rendered
    zIndex: maxZIndex
  }));
  document.body.appendChild(element);

  /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */
  var unbindPointerMove = dist.bind(window, {
    type: 'pointermove',
    listener: function listener(event) {
      var client = {
        x: event.clientX,
        y: event.clientY
      };
      clientRect = getHoneyPotRectFor({
        client: client
      });
      Object.assign(element.style, getRectStyles({
        clientRect: clientRect
      }));
    },
    // using capture so we are less likely to be impacted by event stopping
    options: {
      capture: true
    }
  });
  return function finish(_ref5) {
    var current = _ref5.current;
    // Don't need this any more
    unbindPointerMove();

    // If the user is hover the honey pot, we remove it
    // so that the user can continue to interact with the page normally.
    if (isWithin({
      client: current,
      clientRect: clientRect
    })) {
      element.remove();
      return;
    }
    function cleanup() {
      unbindPostDragEvents();
      element.remove();
    }
    var unbindPostDragEvents = dist.bindAll(window, [{
      type: 'pointerdown',
      listener: cleanup
    }, {
      type: 'pointermove',
      listener: cleanup
    }, {
      type: 'focusin',
      listener: cleanup
    }, {
      type: 'focusout',
      listener: cleanup
    },
    // a 'pointerdown' should happen before 'dragstart', but just being super safe
    {
      type: 'dragstart',
      listener: cleanup
    },
    // if the user has dragged something out of the window
    // and then is dragging something back into the window
    // the first events we will see are "dragenter" (and then "dragover").
    // So if we see any of these we need to clear the post drag fix.
    {
      type: 'dragenter',
      listener: cleanup
    }, {
      type: 'dragover',
      listener: cleanup
    }

    // Not adding a "wheel" event listener, as "wheel" by itself does not
    // resolve the bug.
    ], {
      // Using `capture` so less likely to be impacted by other code stopping events
      capture: true
    });
  };
}
function makeHoneyPotFix() {
  var latestPointerMove = null;
  function bindEvents() {
    // For sanity, only collecting this value from when events are first bound.
    // This prevents the case where a super old "pointermove" could be used
    // from a prior interaction.
    latestPointerMove = null;
    return dist.bind(window, {
      type: 'pointermove',
      listener: function listener(event) {
        latestPointerMove = {
          x: event.clientX,
          y: event.clientY
        };
      },
      // listening for pointer move in capture phase
      // so we are less likely to be impacted by events being stopped.
      options: {
        capture: true
      }
    });
  }
  function getOnPostDispatch() {
    var finish = null;
    return function onPostEvent(_ref6) {
      var eventName = _ref6.eventName,
        payload = _ref6.payload;
      // We are adding the honey pot `onDragStart` so we don't
      // impact the creation of the native drag preview.
      if (eventName === 'onDragStart') {
        var _latestPointerMove;
        var input = payload.location.initial.input;

        // Sometimes there will be no latest "pointermove" (eg iOS).
        // In which case, we use the start position of the drag.
        var initial = (_latestPointerMove = latestPointerMove) !== null && _latestPointerMove !== void 0 ? _latestPointerMove : {
          x: input.clientX,
          y: input.clientY
        };

        // Don't need to defensively call `finish()` as `onDrop` from
        // one interaction is guaranteed to be called before `onDragStart`
        // of the next.
        finish = mountHoneyPot({
          initial: initial
        });
      }
      if (eventName === 'onDrop') {
        var _finish;
        var _input = payload.location.current.input;
        (_finish = finish) === null || _finish === void 0 || _finish({
          current: {
            x: _input.clientX,
            y: _input.clientY
          }
        });
        finish = null;
        // this interaction is finished, we want to use
        // the latest "pointermove" for each interaction
        latestPointerMove = null;
      }
    };
  }
  return {
    bindEvents: bindEvents,
    getOnPostDispatch: getOnPostDispatch
  };
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$2(r);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$2(r) || _nonIterableSpread();
}

/** Provide a function that you only ever want to be called a single time */
function once(fn) {
  var cache = null;
  return function wrapped() {
    if (!cache) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var result = fn.apply(this, args);
      cache = {
        result: result
      };
    }
    return cache.result;
  };
}

// using `cache` as our `isFirefox()` result will not change in a browser

/**
 * Returns `true` if a `Firefox` browser
 * */
var isFirefox = once(function isFirefox() {
  if (process.env.NODE_ENV === 'test') {
    return false;
  }
  return navigator.userAgent.includes('Firefox');
});

// using `cache` as our `isSafari()` result will not change in a browser

/**
 * Returns `true` if a `Safari` browser.
 * Returns `true` if the browser is running on iOS (they are all Safari).
 * */
var isSafari = once(function isSafari() {
  if (process.env.NODE_ENV === 'test') {
    return false;
  }
  var _navigator = navigator,
    userAgent = _navigator.userAgent;
  return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */

// Using symbols for event properties so we don't clash with
// anything on the `event` object
var symbols = {
  isLeavingWindow: Symbol('leaving'),
  isEnteringWindow: Symbol('entering')
};
function isLeavingWindowInSafari(_ref2) {
  var dragLeave = _ref2.dragLeave;
  if (!isSafari()) {
    return false;
  }
  return dragLeave.hasOwnProperty(symbols.isLeavingWindow);
}
(function fixSafari() {
  // Don't do anything when server side rendering
  if (typeof window === 'undefined') {
    return;
  }

  // rather than checking the userAgent for "jsdom" we can do this check
  // so that the check will be removed completely in production code
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  if (!isSafari()) {
    return;
  }
  function getInitialState() {
    return {
      enterCount: 0,
      isOverWindow: false
    };
  }
  var state = getInitialState();
  function resetState() {
    state = getInitialState();
  }

  // These event listeners are bound _forever_ and _never_ removed
  // We don't bother cleaning up these event listeners (for now)
  // as this workaround is only for Safari

  // This is how the event count works:
  //
  // lift (+1 enterCount)
  // - dragstart(draggable) [enterCount: 0]
  // - dragenter(draggable) [enterCount: 1]
  // leaving draggable (+0 enterCount)
  // - dragenter(document.body) [enterCount: 2]
  // - dragleave(draggable) [enterCount: 1]
  // leaving window (-1 enterCount)
  // - dragleave(document.body) [enterCount: 0] {leaving the window}

  // Things to note:
  // - dragenter and dragleave bubble
  // - the first dragenter when entering a window might not be on `window`
  //   - it could be on an element that is pressed up against the window
  //   - (so we cannot rely on `event.target` values)

  dist.bindAll(window, [{
    type: 'dragstart',
    listener: function listener() {
      state.enterCount = 0;
      // drag start occurs in the source window
      state.isOverWindow = true;
      // When a drag first starts it will also trigger a "dragenter" on the draggable element
    }
  }, {
    type: 'drop',
    listener: resetState
  }, {
    type: 'dragend',
    listener: resetState
  }, {
    type: 'dragenter',
    listener: function listener(event) {
      if (!state.isOverWindow && state.enterCount === 0) {
        // Patching the `event` object
        // The `event` object is shared with all event listeners for the event
        // @ts-expect-error: adding property to the event object
        event[symbols.isEnteringWindow] = true;
      }
      state.isOverWindow = true;
      state.enterCount++;
    }
  }, {
    type: 'dragleave',
    listener: function listener(event) {
      state.enterCount--;
      if (state.isOverWindow && state.enterCount === 0) {
        // Patching the `event` object as it is shared with all event listeners
        // The `event` object is shared with all event listeners for the event
        // @ts-expect-error: adding property to the event object
        event[symbols.isLeavingWindow] = true;
        state.isOverWindow = false;
      }
    }
  }],
  // using `capture: true` so that adding event listeners
  // in bubble phase will have the correct symbols
  {
    capture: true
  });
})();

/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */
function isNodeLike(target) {
  return 'nodeName' in target;
}

/**
 * Is an `EventTarget` a `Node` from another `window`?
 */
function isFromAnotherWindow(eventTarget) {
  return isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}
function isLeavingWindow(_ref) {
  var dragLeave = _ref.dragLeave;
  var type = dragLeave.type,
    relatedTarget = dragLeave.relatedTarget;
  if (type !== 'dragleave') {
    return false;
  }
  if (isSafari()) {
    return isLeavingWindowInSafari({
      dragLeave: dragLeave
    });
  }

  // Standard check: if going to `null` we are leaving the `window`
  if (relatedTarget == null) {
    return true;
  }

  /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */

  if (isFirefox()) {
    return isFromAnotherWindow(relatedTarget);
  }

  /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */

  // Case 2
  // Using `instanceof` check as the element will be in the same `window`
  return relatedTarget instanceof HTMLIFrameElement;
}
function getBindingsForBrokenDrags(_ref) {
  var onDragEnd = _ref.onDragEnd;
  return [
  // ## Detecting drag ending for removed draggables
  //
  // If a draggable element is removed during a drag and the user drops:
  // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
  // 2. if not over a valid drop target (or cancelled): we get nothing
  // The "dragend" event will not fire on the source draggable if it has been
  // removed from the DOM.
  // So we need to figure out if a drag operation has finished by looking at other events
  // We can do this by looking at other events

  // ### First detection: "pointermove" events

  // 1. "pointermove" events cannot fire during a drag and drop operation
  // according to the spec. So if we get a "pointermove" it means that
  // the drag and drop operations has finished. So if we get a "pointermove"
  // we know that the drag is over
  // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
  // other pointer events. However, firefox will allow a few
  // pointer event to get through after a drag starts.
  // The most I've seen is 3
  {
    type: 'pointermove',
    listener: function () {
      var callCount = 0;
      return function listener() {
        // Using 20 as it is far bigger than the most observed (3)
        if (callCount < 20) {
          callCount++;
          return;
        }
        onDragEnd();
      };
    }()
  },
  // ### Second detection: "pointerdown" events

  // If we receive this event then we know that a drag operation has finished
  // and potentially another one is about to start.
  // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
  {
    type: 'pointerdown',
    listener: onDragEnd
  }];
}
function getInput(event) {
  return {
    altKey: event.altKey,
    button: event.button,
    buttons: event.buttons,
    ctrlKey: event.ctrlKey,
    metaKey: event.metaKey,
    shiftKey: event.shiftKey,
    clientX: event.clientX,
    clientY: event.clientY,
    pageX: event.pageX,
    pageY: event.pageY
  };
}
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;
  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    lastArgs = args;
    if (frameId) {
      return;
    }
    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };
  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }
    cancelAnimationFrame(frameId);
    frameId = null;
  };
  return wrapperFn;
};
var rafSchd$1 = rafSchd;
var scheduleOnDrag = rafSchd$1(function (fn) {
  return fn();
});
var dragStart = function () {
  var scheduled = null;
  function schedule(fn) {
    var frameId = requestAnimationFrame(function () {
      scheduled = null;
      fn();
    });
    scheduled = {
      frameId: frameId,
      fn: fn
    };
  }
  function flush() {
    if (scheduled) {
      cancelAnimationFrame(scheduled.frameId);
      scheduled.fn();
      scheduled = null;
    }
  }
  return {
    schedule: schedule,
    flush: flush
  };
}();
function makeDispatch(_ref) {
  var source = _ref.source,
    initial = _ref.initial,
    dispatchEvent = _ref.dispatchEvent;
  var previous = {
    dropTargets: []
  };
  function safeDispatch(args) {
    dispatchEvent(args);
    previous = {
      dropTargets: args.payload.location.current.dropTargets
    };
  }
  var dispatch = {
    start: function start(_ref2) {
      var nativeSetDragImage = _ref2.nativeSetDragImage;
      // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
      // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
      var location = {
        current: initial,
        previous: previous,
        initial: initial
      };
      // a `onGenerateDragPreview` does _not_ add another entry for `previous`
      // onDragPreview
      safeDispatch({
        eventName: 'onGenerateDragPreview',
        payload: {
          source: source,
          location: location,
          nativeSetDragImage: nativeSetDragImage
        }
      });
      dragStart.schedule(function () {
        safeDispatch({
          eventName: 'onDragStart',
          payload: {
            source: source,
            location: location
          }
        });
      });
    },
    dragUpdate: function dragUpdate(_ref3) {
      var current = _ref3.current;
      dragStart.flush();
      scheduleOnDrag.cancel();
      safeDispatch({
        eventName: 'onDropTargetChange',
        payload: {
          source: source,
          location: {
            initial: initial,
            previous: previous,
            current: current
          }
        }
      });
    },
    drag: function drag(_ref4) {
      var current = _ref4.current;
      scheduleOnDrag(function () {
        dragStart.flush();
        var location = {
          initial: initial,
          previous: previous,
          current: current
        };
        safeDispatch({
          eventName: 'onDrag',
          payload: {
            source: source,
            location: location
          }
        });
      });
    },
    drop: function drop(_ref5) {
      var current = _ref5.current,
        updatedSourcePayload = _ref5.updatedSourcePayload;
      dragStart.flush();
      scheduleOnDrag.cancel();
      safeDispatch({
        eventName: 'onDrop',
        payload: {
          source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
          location: {
            current: current,
            previous: previous,
            initial: initial
          }
        }
      });
    }
  };
  return dispatch;
}
var globalState = {
  isActive: false
};
function canStart() {
  return !globalState.isActive;
}
function getNativeSetDragImage(event) {
  if (event.dataTransfer) {
    // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
  }
  return null;
}
function hasHierarchyChanged(_ref) {
  var current = _ref.current,
    next = _ref.next;
  if (current.length !== next.length) {
    return true;
  }
  // not checking stickiness, data or dropEffect,
  // just whether the hierarchy has changed
  for (var i = 0; i < current.length; i++) {
    if (current[i].element !== next[i].element) {
      return true;
    }
  }
  return false;
}
function start(_ref2) {
  var event = _ref2.event,
    dragType = _ref2.dragType,
    getDropTargetsOver = _ref2.getDropTargetsOver,
    dispatchEvent = _ref2.dispatchEvent;
  if (!canStart()) {
    return;
  }
  var initial = getStartLocation({
    event: event,
    dragType: dragType,
    getDropTargetsOver: getDropTargetsOver
  });
  globalState.isActive = true;
  var state = {
    current: initial
  };

  // Setting initial drop effect for the drag
  setDropEffectOnEvent({
    event: event,
    current: initial.dropTargets
  });
  var dispatch = makeDispatch({
    source: dragType.payload,
    dispatchEvent: dispatchEvent,
    initial: initial
  });
  function updateState(next) {
    // only looking at whether hierarchy has changed to determine whether something as 'changed'
    var hasChanged = hasHierarchyChanged({
      current: state.current.dropTargets,
      next: next.dropTargets
    });

    // Always updating the state to include latest data, dropEffect and stickiness
    // Only updating consumers if the hierarchy has changed in some way
    // Consumers can get the latest data by using `onDrag`
    state.current = next;
    if (hasChanged) {
      dispatch.dragUpdate({
        current: state.current
      });
    }
  }
  function onUpdateEvent(event) {
    var input = getInput(event);

    // If we are over the honey pot, we need to get the element
    // that the user would have been over if not for the honey pot
    var target = isHoneyPotElement(event.target) ? getElementFromPointWithoutHoneypot({
      x: input.clientX,
      y: input.clientY
    }) : event.target;
    var nextDropTargets = getDropTargetsOver({
      target: target,
      input: input,
      source: dragType.payload,
      current: state.current.dropTargets
    });
    if (nextDropTargets.length) {
      // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
      event.preventDefault();
      setDropEffectOnEvent({
        event: event,
        current: nextDropTargets
      });
    }
    updateState({
      dropTargets: nextDropTargets,
      input: input
    });
  }
  function cancel() {
    // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
    // a "dragleave" event is fired on the active drop target before a "dragend" event.
    // We are replicating that behaviour in `cancel` if there are any active drop targets to
    // ensure consistent behaviour.
    //
    // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
    // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)

    if (state.current.dropTargets.length) {
      updateState({
        dropTargets: [],
        input: state.current.input
      });
    }
    dispatch.drop({
      current: state.current,
      updatedSourcePayload: null
    });
    finish();
  }
  function finish() {
    globalState.isActive = false;
    unbindEvents();
  }
  var unbindEvents = dist.bindAll(window, [{
    // 👋 Note: we are repurposing the `dragover` event as our `drag` event
    // this is because firefox does not publish pointer coordinates during
    // a `drag` event, but does for every other type of drag event
    // `dragover` fires on all elements that are being dragged over
    // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
    // 🦊😤
    type: 'dragover',
    listener: function listener(event) {
      // We need to regularly calculate the drop targets in order to allow:
      //  - dynamic `canDrop()` checks
      //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
      // Sadly we cannot schedule inspecting changes resulting from this event
      // we need to be able to conditionally cancel the event with `event.preventDefault()`
      // to enable the correct native drop experience.

      // 1. check to see if anything has changed
      onUpdateEvent(event);

      // 2. let consumers know a move has occurred
      // This will include the latest 'input' values
      dispatch.drag({
        current: state.current
      });
    }
  }, {
    type: 'dragenter',
    listener: onUpdateEvent
  }, {
    type: 'dragleave',
    listener: function listener(event) {
      if (!isLeavingWindow({
        dragLeave: event
      })) {
        return;
      }

      /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/

      updateState({
        input: state.current.input,
        dropTargets: []
      });
      if (dragType.startedFrom === 'external') {
        cancel();
      }
    }
  }, {
    // A "drop" can only happen if the browser allowed the drop
    type: 'drop',
    listener: function listener(event) {
      // Capture the final input.
      // We are capturing the final `input` for the
      // most accurate honey pot experience
      state.current = {
        dropTargets: state.current.dropTargets,
        input: getInput(event)
      };

      /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */

      if (!state.current.dropTargets.length) {
        cancel();
        return;
      }
      event.preventDefault();

      // applying the latest drop effect to the event
      setDropEffectOnEvent({
        event: event,
        current: state.current.dropTargets
      });
      dispatch.drop({
        current: state.current,
        // When dropping something native, we need to extract the latest
        // `.items` from the "drop" event as it is now accessible
        updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
      });
      finish();
    }
  }, {
    // "dragend" fires when on the drag source (eg a draggable element)
    // when the drag is finished.
    // "dragend" will fire after "drop" (if there was a successful drop)
    // "dragend" does not fire if the draggable source has been removed during the drag
    // or for external drag sources (eg files)

    // This "dragend" listener will not fire if there was a successful drop
    // as we will have already removed the event listener

    type: 'dragend',
    listener: function listener(event) {
      // In firefox, the position of the "dragend" event can
      // be a bit different to the last "dragover" event.
      // Updating the input so we can get the best possible
      // information for the honey pot.
      state.current = {
        dropTargets: state.current.dropTargets,
        input: getInput(event)
      };
      cancel();
    }
  }].concat(_toConsumableArray(getBindingsForBrokenDrags({
    onDragEnd: cancel
  }))),
  // Once we have started a managed drag operation it is important that we see / own all drag events
  // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
  // all "drop" events in the bubble phase on the `document.body`.
  // This meant that we never saw the "drop" event.
  {
    capture: true
  });
  dispatch.start({
    nativeSetDragImage: getNativeSetDragImage(event)
  });
}
function setDropEffectOnEvent(_ref3) {
  var _current$;
  var event = _ref3.event,
    current = _ref3.current;
  // setting the `dropEffect` to be the innerMost drop targets dropEffect
  var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
  if (innerMost != null && event.dataTransfer) {
    event.dataTransfer.dropEffect = innerMost;
  }
}
function getStartLocation(_ref4) {
  var event = _ref4.event,
    dragType = _ref4.dragType,
    getDropTargetsOver = _ref4.getDropTargetsOver;
  var input = getInput(event);

  // When dragging from outside of the browser,
  // the drag is not being sourced from any local drop targets
  if (dragType.startedFrom === 'external') {
    return {
      input: input,
      dropTargets: []
    };
  }
  var dropTargets = getDropTargetsOver({
    input: input,
    source: dragType.payload,
    target: event.target,
    current: []
  });
  return {
    input: input,
    dropTargets: dropTargets
  };
}
var lifecycle = {
  canStart: canStart,
  start: start
};

// Extending `Map` to allow us to link Key and Values together

var ledger = new Map();
function registerUsage(_ref) {
  var typeKey = _ref.typeKey,
    mount = _ref.mount;
  var entry = ledger.get(typeKey);
  if (entry) {
    entry.usageCount++;
    return entry;
  }
  var initial = {
    typeKey: typeKey,
    unmount: mount(),
    usageCount: 1
  };
  ledger.set(typeKey, initial);
  return initial;
}
function register(args) {
  var entry = registerUsage(args);
  return function unregister() {
    entry.usageCount--;
    if (entry.usageCount > 0) {
      return;
    }
    // Only a single usage left, remove it
    entry.unmount();
    ledger.delete(args.typeKey);
  };
}
function addAttribute(element, _ref) {
  var attribute = _ref.attribute,
    value = _ref.value;
  element.setAttribute(attribute, value);
  return function () {
    return element.removeAttribute(attribute);
  };
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _createForOfIteratorHelper$1(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray$1(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
  }
}
function _arrayLikeToArray$1(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function copyReverse(array) {
  return array.slice(0).reverse();
}
function makeDropTarget(_ref) {
  var typeKey = _ref.typeKey,
    defaultDropEffect = _ref.defaultDropEffect;
  var registry = new WeakMap();
  var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
  var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
  function addToRegistry(args) {
    registry.set(args.element, args);
    return function () {
      return registry.delete(args.element);
    };
  }
  function dropTargetForConsumers(args) {
    // Guardrail: warn if the draggable element is already registered
    if (process.env.NODE_ENV !== 'production') {
      var existing = registry.get(args.element);
      if (existing) {
        // eslint-disable-next-line no-console
        console.warn("You have already registered a [".concat(typeKey, "] dropTarget on the same element"), {
          existing: existing,
          proposed: args
        });
      }
      if (args.element instanceof HTMLIFrameElement) {
        // eslint-disable-next-line no-console
        console.warn("\n            We recommend not registering <iframe> elements as drop targets\n            as it can result in some strange browser event ordering.\n          " // Removing newlines and excessive whitespace
        .replace(/\s{2,}/g, ' ').trim());
      }
    }
    return combine(addAttribute(args.element, {
      attribute: dropTargetDataAtt,
      value: 'true'
    }), addToRegistry(args));
  }
  function getActualDropTargets(_ref2) {
    var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
    var source = _ref2.source,
      target = _ref2.target,
      input = _ref2.input,
      _ref2$result = _ref2.result,
      result = _ref2$result === void 0 ? [] : _ref2$result;
    if (target == null) {
      return result;
    }
    if (!(target instanceof Element)) {
      // For "text-selection" drags, the original `target`
      // is not an `Element`, so we need to start looking from
      // the parent element
      if (target instanceof Node) {
        return getActualDropTargets({
          source: source,
          target: target.parentElement,
          input: input,
          result: result
        });
      }

      // not sure what we are working with,
      // so we can exit.
      return result;
    }
    var closest = target.closest(dropTargetSelector);

    // Cannot find anything else
    if (closest == null) {
      return result;
    }
    var args = registry.get(closest);

    // error: something had a dropTargetSelector but we could not
    // find a match. For now, failing silently
    if (args == null) {
      return result;
    }
    var feedback = {
      input: input,
      source: source,
      element: args.element
    };

    // if dropping is not allowed, skip this drop target
    // and continue looking up the DOM tree
    if (args.canDrop && !args.canDrop(feedback)) {
      return getActualDropTargets({
        source: source,
        target: args.element.parentElement,
        input: input,
        result: result
      });
    }

    // calculate our new record
    var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
    var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
    var record = {
      data: data,
      element: args.element,
      dropEffect: dropEffect,
      // we are collecting _actual_ drop targets, so these are
      // being applied _not_ due to stickiness
      isActiveDueToStickiness: false
    };
    return getActualDropTargets({
      source: source,
      target: args.element.parentElement,
      input: input,
      // Using bubble ordering. Same ordering as `event.getPath()`
      result: [].concat(_toConsumableArray(result), [record])
    });
  }
  function notifyCurrent(_ref3) {
    var eventName = _ref3.eventName,
      payload = _ref3.payload;
    var _iterator = _createForOfIteratorHelper$1(payload.location.current.dropTargets),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _entry$eventName;
        var record = _step.value;
        var entry = registry.get(record.element);
        var args = _objectSpread$1(_objectSpread$1({}, payload), {}, {
          self: record
        });
        entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry,
        // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        args);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  var actions = {
    onGenerateDragPreview: notifyCurrent,
    onDrag: notifyCurrent,
    onDragStart: notifyCurrent,
    onDrop: notifyCurrent,
    onDropTargetChange: function onDropTargetChange(_ref4) {
      var payload = _ref4.payload;
      var isCurrent = new Set(payload.location.current.dropTargets.map(function (record) {
        return record.element;
      }));
      var visited = new Set();
      var _iterator2 = _createForOfIteratorHelper$1(payload.location.previous.dropTargets),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _entry$onDropTargetCh;
          var record = _step2.value;
          visited.add(record.element);
          var entry = registry.get(record.element);
          var isOver = isCurrent.has(record.element);
          var args = _objectSpread$1(_objectSpread$1({}, payload), {}, {
            self: record
          });
          entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);

          // if we cannot find the drop target in the current array, then it has been left
          if (!isOver) {
            var _entry$onDragLeave;
            entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper$1(payload.location.current.dropTargets),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _entry$onDropTargetCh2, _entry$onDragEnter;
          var _record = _step3.value;
          // already published an update to this drop target
          if (visited.has(_record.element)) {
            continue;
          }
          // at this point we have a new drop target that is being entered into
          var _args = _objectSpread$1(_objectSpread$1({}, payload), {}, {
            self: _record
          });
          var _entry = registry.get(_record.element);
          _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
          _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  };
  function dispatchEvent(args) {
    actions[args.eventName](args);
  }
  function getIsOver(_ref5) {
    var source = _ref5.source,
      target = _ref5.target,
      input = _ref5.input,
      current = _ref5.current;
    var actual = getActualDropTargets({
      source: source,
      target: target,
      input: input
    });

    // stickiness is only relevant when we have less
    // drop targets than we did before
    if (actual.length >= current.length) {
      return actual;
    }

    // less 'actual' drop targets than before,
    // we need to see if 'stickiness' applies

    // An old drop target will continue to be dropped on if:
    // 1. it has the same parent
    // 2. nothing exists in it's previous index

    var lastCaptureOrdered = copyReverse(current);
    var actualCaptureOrdered = copyReverse(actual);
    var resultCaptureOrdered = [];
    for (var index = 0; index < lastCaptureOrdered.length; index++) {
      var _argsForLast$getIsSti;
      var last = lastCaptureOrdered[index];
      var fresh = actualCaptureOrdered[index];

      // if a record is in the new index -> use that
      // it will have the latest data + dropEffect
      if (fresh != null) {
        resultCaptureOrdered.push(fresh);
        continue;
      }

      // At this point we have no drop target in the old spot
      // Check to see if we can use a previous sticky drop target

      // The "parent" is the one inside of `resultCaptureOrdered`
      // (the parent might be a drop target that was sticky)
      var parent = resultCaptureOrdered[index - 1];
      var lastParent = lastCaptureOrdered[index - 1];

      // Stickiness is based on parent relationships, so if the parent relationship has change
      // then we can stop our search
      if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) {
        break;
      }

      // We need to check whether the old drop target can still be dropped on

      var argsForLast = registry.get(last.element);

      // We cannot drop on a drop target that is no longer mounted
      if (!argsForLast) {
        break;
      }
      var feedback = {
        input: input,
        source: source,
        element: argsForLast.element
      };

      // We cannot drop on a drop target that no longer allows being dropped on
      if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) {
        break;
      }

      // We cannot drop on a drop target that is no longer sticky
      if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) {
        break;
      }

      // Note: intentionally not recollecting `getData()` or `getDropEffect()`
      // Previous values for `data` and `dropEffect` will be borrowed
      // This is to prevent things like the 'closest edge' changing when
      // no longer over a drop target.
      // We could change our mind on this behaviour in the future

      resultCaptureOrdered.push(_objectSpread$1(_objectSpread$1({}, last), {}, {
        // making it clear to consumers this drop target is active due to stickiness
        isActiveDueToStickiness: true
      }));
    }

    // return bubble ordered result
    return copyReverse(resultCaptureOrdered);
  }
  return {
    dropTargetForConsumers: dropTargetForConsumers,
    getIsOver: getIsOver,
    dispatchEvent: dispatchEvent
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function makeMonitor() {
  var registry = new Set();
  var dragging = null;
  function tryAddToActive(monitor) {
    if (!dragging) {
      return;
    }
    // Monitor is allowed to monitor events if:
    // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
    // 2. `canMonitor` returns true
    if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) {
      dragging.active.add(monitor);
    }
  }
  function monitorForConsumers(args) {
    // We are giving each `args` a new reference so that you
    // can create multiple monitors with the same `args`.
    var entry = _objectSpread({}, args);
    registry.add(entry);

    // if there is an active drag we need to see if this new monitor is relevant
    tryAddToActive(entry);
    return function cleanup() {
      registry.delete(entry);

      // We need to stop publishing events during a drag to this monitor!
      if (dragging) {
        dragging.active.delete(entry);
      }
    };
  }
  function dispatchEvent(_ref) {
    var eventName = _ref.eventName,
      payload = _ref.payload;
    if (eventName === 'onGenerateDragPreview') {
      dragging = {
        canMonitorArgs: {
          initial: payload.location.initial,
          source: payload.source
        },
        active: new Set()
      };
      var _iterator = _createForOfIteratorHelper(registry),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var monitor = _step.value;
          tryAddToActive(monitor);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    // This should never happen.
    if (!dragging) {
      return;
    }

    // Creating an array from the set _before_ iterating
    // This is so that monitors added during the current event will not be called.
    // This behaviour matches native EventTargets where an event listener
    // cannot add another event listener during an active event to the same
    // event target in the same event (for us we have a single global event target)
    var active = Array.from(dragging.active);
    for (var _i = 0, _active = active; _i < _active.length; _i++) {
      var _monitor = _active[_i];
      // A monitor can be removed by another monitor during an event.
      // We need to check that the monitor is still registered before calling it
      if (dragging.active.has(_monitor)) {
        var _monitor$eventName;
        // @ts-expect-error: I cannot get this type working!
        (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
      }
    }
    if (eventName === 'onDrop') {
      dragging.active.clear();
      dragging = null;
    }
  }
  return {
    dispatchEvent: dispatchEvent,
    monitorForConsumers: monitorForConsumers
  };
}
function makeAdapter(_ref) {
  var typeKey = _ref.typeKey,
    mount = _ref.mount,
    dispatchEventToSource = _ref.dispatchEventToSource,
    onPostDispatch = _ref.onPostDispatch,
    defaultDropEffect = _ref.defaultDropEffect;
  var monitorAPI = makeMonitor();
  var dropTargetAPI = makeDropTarget({
    typeKey: typeKey,
    defaultDropEffect: defaultDropEffect
  });
  function dispatchEvent(args) {
    // 1. forward the event to source
    dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);

    // 2. forward the event to relevant dropTargets
    dropTargetAPI.dispatchEvent(args);

    // 3. forward event to monitors
    monitorAPI.dispatchEvent(args);

    // 4. post consumer dispatch (used for honey pot fix)
    onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
  }
  function start(_ref2) {
    var event = _ref2.event,
      dragType = _ref2.dragType;
    lifecycle.start({
      event: event,
      dragType: dragType,
      getDropTargetsOver: dropTargetAPI.getIsOver,
      dispatchEvent: dispatchEvent
    });
  }
  function registerUsage() {
    function mountAdapter() {
      var api = {
        canStart: lifecycle.canStart,
        start: start
      };
      return mount(api);
    }
    return register({
      typeKey: typeKey,
      mount: mountAdapter
    });
  }
  return {
    registerUsage: registerUsage,
    dropTarget: dropTargetAPI.dropTargetForConsumers,
    monitor: monitorAPI.monitorForConsumers
  };
}

// using `cache` as our `isAndroid()` result will not change in a browser
var isAndroid = once(function isAndroid() {
  return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var androidFallbackText = 'pdnd:android-fallback';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var textMediaType = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var URLMediaType = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */
var elementAdapterNativeDataKey = 'application/vnd.pdnd';
var draggableRegistry = new WeakMap();
function addToRegistry(args) {
  draggableRegistry.set(args.element, args);
  return function cleanup() {
    draggableRegistry.delete(args.element);
  };
}
var honeyPotFix = makeHoneyPotFix();
var adapter = makeAdapter({
  typeKey: 'element',
  defaultDropEffect: 'move',
  mount: function mount(api) {
    /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */
    return combine(honeyPotFix.bindEvents(), dist.bind(document, {
      type: 'dragstart',
      listener: function listener(event) {
        var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
        if (!api.canStart(event)) {
          return;
        }

        // If the "dragstart" event is cancelled, then a drag won't start
        // There will be no further drag operation events (eg no "dragend" event)
        if (event.defaultPrevented) {
          return;
        }

        // Technically `dataTransfer` can be `null` according to the types
        // But that behaviour does not seem to appear in the spec.
        // If there is not `dataTransfer`, we can assume something is wrong and not
        // start a drag
        if (!event.dataTransfer) {
          // Including this code on "test" and "development" environments:
          // - Browser tests commonly run against "development" builds
          // - Unit tests commonly run in "test"
          if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn("\n              It appears as though you have are not testing DragEvents correctly.\n\n              - If you are unit testing, ensure you have polyfilled DragEvent.\n              - If you are browser testing, ensure you are dispatching drag events correctly.\n\n              Please see our testing guides for more information:\n              https://atlassian.design/components/pragmatic-drag-and-drop/core-package/testing\n            ".replace(/ {2}/g, ''));
          }
          return;
        }

        // the closest parent that is a draggable element will be marked as
        // the `event.target` for the event
        var target = event.target;

        // this source is only for elements
        // Note: only HTMLElements can have the "draggable" attribute
        if (!(target instanceof HTMLElement)) {
          return null;
        }

        // see if the thing being dragged is owned by us
        var entry = draggableRegistry.get(target);

        // no matching element found
        // → dragging an element with `draggable="true"` that is not controlled by us
        if (!entry) {
          return null;
        }

        /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */

        var input = getInput(event);
        var feedback = {
          element: entry.element,
          dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
          input: input
        };

        // Check: does the draggable want to allow dragging?
        if (entry.canDrag && !entry.canDrag(feedback)) {
          // cancel drag operation if we cannot drag
          event.preventDefault();
          return null;
        }

        // Check: is there a drag handle and is the user using it?
        if (entry.dragHandle) {
          // technically don't need this util, but just being
          // consistent with how we look up what is under the users
          // cursor.
          var over = getElementFromPointWithoutHoneypot({
            x: input.clientX,
            y: input.clientY
          });

          // if we are not dragging from the drag handle (or something inside the drag handle)
          // then we will cancel the active drag
          if (!entry.dragHandle.contains(over)) {
            event.preventDefault();
            return null;
          }
        }

        /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */
        var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
        if (nativeData) {
          for (var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              data = _Object$entries$_i[1];
            event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
          }
        }

        /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */
        if (isAndroid() && !event.dataTransfer.types.includes(textMediaType) && !event.dataTransfer.types.includes(URLMediaType)) {
          event.dataTransfer.setData(textMediaType, androidFallbackText);
        }

        /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */
        event.dataTransfer.setData(elementAdapterNativeDataKey, '');
        var payload = {
          element: entry.element,
          dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
          data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
        };
        var dragType = {
          type: 'element',
          payload: payload,
          startedFrom: 'internal'
        };
        api.start({
          event: event,
          dragType: dragType
        });
      }
    }));
  },
  dispatchEventToSource: function dispatchEventToSource(_ref) {
    var _draggableRegistry$ge, _draggableRegistry$ge2;
    var eventName = _ref.eventName,
      payload = _ref.payload;
    // During a drag operation, a draggable can be:
    // - remounted with different functions
    // - removed completely
    // So we need to get the latest entry from the registry in order
    // to call the latest event functions

    (_draggableRegistry$ge = draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge,
    // I cannot seem to get the types right here.
    // TS doesn't seem to like that one event can need `nativeSetDragImage`
    // @ts-expect-error
    payload);
  },
  onPostDispatch: honeyPotFix.getOnPostDispatch()
});
var dropTargetForElements = adapter.dropTarget;
function draggable(args) {
  // Guardrail: warn if the drag handle is not contained in draggable element
  if (process.env.NODE_ENV !== 'production') {
    if (args.dragHandle && !args.element.contains(args.dragHandle)) {
      // eslint-disable-next-line no-console
      console.warn('Drag handle element must be contained in draggable element', {
        element: args.element,
        dragHandle: args.dragHandle
      });
    }
  }
  // Guardrail: warn if the draggable element is already registered
  if (process.env.NODE_ENV !== 'production') {
    var existing = draggableRegistry.get(args.element);
    if (existing) {
      // eslint-disable-next-line no-console
      console.warn('You have already registered a `draggable` on the same element', {
        existing: existing,
        proposed: args
      });
    }
  }
  return combine(
  // making the draggable register the adapter rather than drop targets
  // this is because you *must* have a draggable element to start a drag
  // but you _might_ not have any drop targets immediately
  // (You might create drop targets async)
  adapter.registerUsage(), addToRegistry(args), addAttribute(args.element, {
    attribute: 'draggable',
    value: 'true'
  }));
}

/** Common event payload for all events */

/** A map containing payloads for all events */

/** Common event payload for all drop target events */

/** A map containing payloads for all events on drop targets */

/** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */

/** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */

/** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */

/**
 * Reorder a provided `list`
 * Returns a new array and does not modify the original array
 */
function reorder(_ref) {
  var list = _ref.list,
    startIndex = _ref.startIndex,
    finishIndex = _ref.finishIndex;
  if (startIndex === -1 || finishIndex === -1) {
    return list;
  }
  var result = Array.from(list);
  var _result$splice = result.splice(startIndex, 1),
    _result$splice2 = _slicedToArray(_result$splice, 1),
    removed = _result$splice2[0];
  result.splice(finishIndex, 0, removed);
  return result;
}
var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }
  if (isProduction) {
    throw new Error(prefix);
  }
  var provided = typeof message === 'function' ? message() : message;
  var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
  throw new Error(value);
}
const StyledListWrapper = /*#__PURE__*/styled(Layout).withConfig({
  displayName: "sortable-list__StyledListWrapper",
  componentId: "sc-1wyv7mw-0"
})(["min-height:200px;flex:1 1 auto;"]);
const StyleListItemWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "sortable-list__StyleListItemWrapper",
  componentId: "sc-1wyv7mw-1"
})(["width:100%;position:relative;display:flex;align-items:center;border-bottom:", ";cursor:", ";opacity:", ";", " &:hover{background-color:", ";}"], props => {
  if (props.withDivider) {
    return "1px solid ".concat(props.theme.designTokens.color.color.light['outline-variant'].value);
  }
  return 0;
}, props => {
  if (props.disabled) {
    return 'auto';
  }
  return props.clickable ? 'pointer' : 'auto';
}, props => props.disabled ? 0.5 : 1, props => {
  if (props.clickable) {
    return css(["& *{cursor:pointer;}"]);
  }
  if (props.isDragging || props.preview) {
    return css(["&:before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:white;opacity:0.9;}"]);
  }
}, props => !props.disabled && props.clickable ? props.theme.designTokens.color.color.surfaces['surface-container-highest'].value : '');
const SortableListItemComponent = props => {
  const {
    item,
    idKey,
    index,
    rowRenderer,
    items,
    withDivider,
    disabledDragDrop
  } = props;
  const ref = useRef(null);
  const [isDragging, setIsDragging] = useState(false); // create a state for dragging
  const [closestEdge, setClosestEdge] = useState(null);
  const [sourceIndex, setSourceIndex] = useState(null);
  useEffect(() => {
    if (disabledDragDrop) {
      return;
    }
    const itemElement = ref.current;
    if (!itemElement) {
      return () => {
        // do nothing
      };
    }
    invariant(itemElement); // Ensure the card element exists
    return combine(draggable({
      element: itemElement,
      // Attach the card element to draggable
      getInitialData: () => ({
        id: item[idKey],
        index: index
      }),
      // Attach card data to a draggable item when dragging starts
      onDragStart: () => setIsDragging(true),
      // set isDragging to true when dragging starts
      onDrop: () => setIsDragging(false) // set isDragging to false when dragging ends
    }), dropTargetForElements({
      element: itemElement,
      getData: _ref202 => {
        let {
          input,
          element
        } = _ref202;
        return attachClosestEdge({
          id: item[idKey],
          index: index
        }, {
          input,
          element,
          allowedEdges: ['top', 'bottom']
        });
      },
      getIsSticky: () => true,
      // To make a drop target "sticky"
      onDrag(_ref203) {
        let {
          self,
          source
        } = _ref203;
        const isSource = source.element === itemElement;
        if (isSource) {
          setSourceIndex(null);
          setClosestEdge(null);
          return;
        }
        const closestEdge = extractClosestEdge(self.data);
        const sourceIndex = source.data.index;
        invariant(typeof sourceIndex === 'number');
        const isItemBeforeSource = index === sourceIndex - 1;
        const isItemAfterSource = index === sourceIndex + 1;
        const isDropIndicatorHidden = isItemBeforeSource && closestEdge === 'bottom' || isItemAfterSource && closestEdge === 'top';
        if (isDropIndicatorHidden) {
          setSourceIndex(null);
          setClosestEdge(null);
          return;
        }
        setSourceIndex(sourceIndex);
        setClosestEdge(closestEdge);
      },
      onDragEnter(_ref204) {
        let {
          self,
          source
        } = _ref204;
        const isSource = source.element === itemElement;
        if (isSource) {
          setSourceIndex(null);
          setClosestEdge(null);
          return;
        }
        const closestEdge = extractClosestEdge(self.data);
        const sourceIndex = source.data.index;
        invariant(typeof sourceIndex === 'number');
        const isItemBeforeSource = index === sourceIndex - 1;
        const isItemAfterSource = index === sourceIndex + 1;
        const isDropIndicatorHidden = isItemBeforeSource && closestEdge === 'bottom' || isItemAfterSource && closestEdge === 'top';
        if (isDropIndicatorHidden) {
          setSourceIndex(null);
          setClosestEdge(null);
          return;
        }
        setSourceIndex(sourceIndex);
        setClosestEdge(closestEdge);
      },
      onDragLeave() {
        setSourceIndex(null);
        setClosestEdge(null);
      },
      onDrop() {
        setSourceIndex(null);
        setClosestEdge(null);
      }
    }));
  }, [disabledDragDrop, idKey, index, item]);
  const preview = sourceIndex !== null && (closestEdge === 'top' || closestEdge === 'bottom') ? jsx(StyleListItemWrapper, {
    withDivider: withDivider,
    isDragging: false,
    preview: true,
    children: rowRenderer(items[sourceIndex])
  }) : null;
  return jsxs(Fragment, {
    children: [closestEdge === 'top' ? preview : null, jsx(StyleListItemWrapper, {
      withDivider: withDivider,
      className: "hub-ui__sortable-list-item",
      ref: ref,
      isDragging: isDragging,
      children: rowRenderer(item)
    }), closestEdge === 'bottom' ? preview : null]
  });
};
function isItemData(data) {
  return 'id' in data && 'index' in data;
}
function SortableListComponent(props) {
  const {
    items: itemsProp,
    emptyText,
    virtualized,
    rowRenderer,
    idKey,
    onReorder,
    withDivider = true,
    disabledDragDrop
  } = props;
  const [, setIsDraggedOver] = useState(false);
  const dropRef = useRef(null);
  const items = useMemo(() => {
    return itemsProp.filter(item => !item.hidden);
  }, [itemsProp]);
  const innerRowRenderer = useCallback(index => {
    const item = items[index];
    return jsx(SortableListItemComponent, {
      disabledDragDrop: disabledDragDrop,
      withDivider: withDivider,
      item: item,
      items: items,
      idKey: idKey,
      index: index,
      rowRenderer: rowRenderer
    });
  }, [disabledDragDrop, idKey, items, rowRenderer, withDivider]);
  const emptyJSX = !items.length && emptyText ? jsx(Typography, {
    align: "center",
    children: emptyText
  }) : null;
  const reorderItem = useCallback(_ref205 => {
    let {
      startIndex,
      indexOfTarget,
      closestEdgeOfTarget
    } = _ref205;
    const finishIndex = getReorderDestinationIndex({
      startIndex,
      closestEdgeOfTarget,
      indexOfTarget,
      axis: 'vertical'
    });
    if (finishIndex === startIndex) {
      // If there would be no change, we skip the update
      return;
    }
    onReorder(reorder({
      list: items,
      startIndex,
      finishIndex
    }));
  }, [items, onReorder]);
  useEffect(() => {
    if (disabledDragDrop) {
      return;
    }
    const dropElement = dropRef.current;
    invariant(dropElement);
    return dropTargetForElements({
      element: dropElement,
      onDragStart: () => setIsDraggedOver(true),
      onDragEnter: () => setIsDraggedOver(true),
      onDragLeave: () => setIsDraggedOver(false),
      onDrop: _ref206 => {
        let {
          location,
          source
        } = _ref206;
        const target = location.current.dropTargets[0];
        if (!target) {
          return;
        }
        const sourceData = source.data;
        const targetData = target.data;
        if (!isItemData(sourceData) || !isItemData(targetData)) {
          return;
        }
        const indexOfTarget = items.findIndex(item => item[idKey] === targetData.id);
        if (indexOfTarget < 0) {
          return;
        }
        const closestEdgeOfTarget = extractClosestEdge(targetData);
        reorderItem({
          startIndex: sourceData.index,
          indexOfTarget,
          closestEdgeOfTarget
        });
        setIsDraggedOver(false);
      },
      getData: () => ({
        id: 'sortable-list'
      }),
      getIsSticky: () => true
    });
  }, [disabledDragDrop, idKey, items, reorderItem]);
  if (!virtualized) {
    return jsxs(Fragment, {
      children: [emptyJSX, jsx(Layout, {
        stack: true,
        ref: dropRef,
        children: items.map((item, index) => {
          return jsx(SortableListItemComponent, {
            disabledDragDrop: disabledDragDrop,
            withDivider: withDivider,
            items: items,
            item: item,
            idKey: idKey,
            index: index,
            rowRenderer: rowRenderer
          });
        })
      })]
    });
  }
  return jsxs(Fragment, {
    children: [emptyJSX, jsx(StyledListWrapper, {
      stack: true,
      ref: dropRef,
      children: jsx(AutoSizer, {
        children: _ref207 => {
          let {
            height,
            width
          } = _ref207;
          return jsx($r, {
            style: {
              height,
              width
            },
            totalCount: items.length,
            itemContent: innerRowRenderer
          });
        }
      })
    })]
  });
}
const SortableList = /*#__PURE__*/React__default.memo(SortableListComponent);
const StyledTable = /*#__PURE__*/styled.table.withConfig({
  displayName: "table__StyledTable",
  componentId: "sc-12pd6g5-0"
})(["padding:", "px;border-spacing:0;border-collapse:collapse;table-layout:fixed;width:100%;"], props => props.theme.designSpacing['--Spacing-200']);
const StyledHeaderTR = /*#__PURE__*/styled.tr.withConfig({
  displayName: "table__StyledHeaderTR",
  componentId: "sc-12pd6g5-1"
})(["color:", ";background:", ";border:none;"], props => props.theme.designTokens.color['on color'].surface['on-surface-variant'].value, props => props.theme.designTokens.color.color.surfaces['surface-container-low'].value);
const StyledTH = /*#__PURE__*/styled.th.withConfig({
  displayName: "table__StyledTH",
  componentId: "sc-12pd6g5-2"
})(["padding:", ";width:", "px;max-width:", "px;box-sizing:border-box;"], props => "12px ".concat(props.theme.designSpacing['--Spacing-200'], "px"), props => props.width, props => props.width);
const StyledTHDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "table__StyledTHDiv",
  componentId: "sc-12pd6g5-3"
})(["display:flex;align-items:center;justify-content:flex-start;&.center{justify-content:center;}&.right{justify-content:flex-end;}", ""], props => props.isSortable && css(["cursor:pointer;"]));
const StyledTR = /*#__PURE__*/styled.tr.withConfig({
  displayName: "table__StyledTR",
  componentId: "sc-12pd6g5-4"
})(["border-bottom:", ";background:", ";"], props => "1px solid ".concat(props.theme.designTokens.color.color.surfaces['surface-container-low'].value), props => props.theme.designTokens.color.color.surfaces['surface'].value);
const StyledTD = /*#__PURE__*/styled.td.withConfig({
  displayName: "table__StyledTD",
  componentId: "sc-12pd6g5-5"
})(["padding:", ";width:", "px;max-width:", "px;box-sizing:border-box;text-align:start;&.center{text-align:center;}&.right{text-align:end;}"], props => "".concat(props.theme.designSpacing['--Spacing-150'], "px ").concat(props.theme.designSpacing['--Spacing-200'], "px"), props => props.width, props => props.width);
const StyledNoData = /*#__PURE__*/styled.tr.withConfig({
  displayName: "table__StyledNoData",
  componentId: "sc-12pd6g5-6"
})(["background:", ";td{padding:16px;}"], props => props.theme.designTokens.color.color.surfaces['surface'].value);
function Table(_ref208) {
  let {
    data,
    columns,
    enableSelection = false,
    filterText = '',
    pagination = {
      pageIndex: 0,
      pageSize: 10
    },
    rowSelection,
    setRowSelection,
    noDataText,
    noFilterDataText,
    sorting,
    setSorting,
    columnVisibility,
    className
  } = _ref208;
  const selectColumn = useMemo(() => [{
    id: 'select',
    header: _ref209 => {
      let {
        table
      } = _ref209;
      return jsx(Checkbox, {
        size: 14,
        name: "selectAll",
        checked: table.getIsAllRowsSelected(),
        onChange: table.getToggleAllRowsSelectedHandler()
      });
    },
    cell: _ref210 => {
      let {
        row
      } = _ref210;
      return jsx(Checkbox, {
        size: 14,
        name: "checkboxRow",
        checked: row.getIsSelected(),
        onChange: row.getToggleSelectedHandler()
      });
    },
    meta: {
      className: 'right',
      headerClassName: 'center'
    },
    size: 50,
    enableResizing: false
  }], []);
  const columnsDef = [...(enableSelection ? [...selectColumn] : []), ...columns];
  const table = useReactTable({
    data,
    columns: columnsDef,
    getCoreRowModel: getCoreRowModel(),
    enableMultiRowSelection: enableSelection,
    onRowSelectionChange: setRowSelection,
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    enableSortingRemoval: false,
    enableColumnResizing: false,
    enableGlobalFilter: true,
    enableHiding: true,
    state: {
      columnVisibility,
      rowSelection,
      sorting,
      globalFilter: filterText,
      pagination
    }
  });
  const Arrows = _ref211 => {
    let {
      sort
    } = _ref211;
    if (!sort) return null;
    if (sort === 'asc') return jsx(Icon, {
      name: "arrowDropDown",
      size: 18
    });
    return jsx(Icon, {
      name: "arrowDropUp",
      size: 18
    });
  };
  return jsxs(StyledTable, {
    className: className,
    children: [jsx("thead", {
      children: table.getHeaderGroups().map(headerGroup => jsx(StyledHeaderTR, {
        children: headerGroup.headers.map(_ref212 => {
          let {
            id,
            isPlaceholder,
            column,
            getContext,
            getSize
          } = _ref212;
          var _a, _b;
          const textAlign = (() => {
            var _a, _b;
            switch ((_b = (_a = column.columnDef) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.headerClassName) {
              case 'right':
                return 'right';
              case 'center':
                return 'center';
              default:
                return 'left';
            }
          })();
          return jsx(StyledTH, {
            width: getSize(),
            children: jsxs(StyledTHDiv, {
              className: (_b = (_a = column.columnDef) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.headerClassName,
              onClick: column.getToggleSortingHandler(),
              isSortable: column.getCanSort(),
              children: [jsx(Typography, {
                variant: "label",
                size: "medium",
                prominent: true,
                align: textAlign,
                children: isPlaceholder ? null : flexRender(column.columnDef.header, getContext())
              }), jsx(Arrows, {
                sort: column.getIsSorted()
              })]
            })
          }, id);
        })
      }, headerGroup.id))
    }), table.getRowModel().rows.length ? jsx("tbody", {
      children: table.getRowModel().rows.map(row => jsx(StyledTR, {
        children: row.getVisibleCells().map(cell => {
          var _a, _b;
          return jsx(StyledTD, {
            width: cell.column.getSize(),
            className: (_b = (_a = cell.column.columnDef) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.className,
            children: flexRender(cell.column.columnDef.cell, cell.getContext())
          }, cell.id);
        })
      }, row.id))
    }) : jsx(StyledNoData, {
      children: jsx("td", {
        colSpan: columnsDef.length,
        children: jsx(Layout, {
          vAlign: "center",
          hAlign: "center",
          children: jsx(Typography, {
            variant: "title",
            size: "large",
            className: "fullWidth",
            children: filterText ? noFilterDataText : noDataText
          })
        })
      })
    })]
  });
}
const TagContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "tag__TagContainer",
  componentId: "ocdk9i-0"
})(["border-radius:4px;padding:1.5px 4px;background-color:", ";"], _ref213 => {
  let {
    theme
  } = _ref213;
  return theme.designTokens.color.color.surfaces['surface-container-highest'].value;
});
function Tag(_ref214) {
  let {
    title
  } = _ref214;
  return jsx(TagContainer, {
    children: jsx(Typography, {
      size: "small",
      children: title
    })
  });
}

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key];
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache: Cache,
  split: split,
  normalizePath: normalizePath,
  setter: function (path) {
    var parts = normalizePath(path);
    return setCache.get(path) || setCache.set(path, function setter(obj, value) {
      var index = 0;
      var len = parts.length;
      var data = obj;
      while (index < len - 1) {
        var part = parts[index];
        if (part === '__proto__' || part === 'constructor' || part === 'prototype') {
          return obj;
        }
        data = data[parts[index++]];
      }
      data[parts[index]] = value;
    });
  },
  getter: function (path, safe) {
    var parts = normalizePath(path);
    return getCache.get(path) || getCache.set(path, function getter(data) {
      var index = 0,
        len = parts.length;
      while (index < len) {
        if (data != null || !safe) data = data[parts[index++]];else return;
      }
      return data;
    });
  },
  join: function (segments) {
    return segments.reduce(function (path, part) {
      return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
    }, '');
  },
  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  }
};
function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(path, split(path).map(function (part) {
    return part.replace(CLEAN_QUOTES_REGEX, '$2');
  }));
}
function split(path) {
  return path.match(SPLIT_REGEX) || [''];
}
function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}
var toposort$1 = {
  exports: {}
};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$1.exports = function (edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$1.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor = nodes.length,
    sorted = new Array(cursor),
    visited = {},
    i = cursor
    // Better data structures make algorithm much faster.
    ,
    outgoingEdges = makeOutgoingEdges(edges),
    nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function (edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    }
  });
  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }
  return sorted;
  function visit(node, i, predecessors) {
    if (predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch (e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep);
    }
    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
    }
    if (visited[i]) return;
    visited[i] = true;
    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);
    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i);
      predecessors.delete(node);
    }
    sorted[--cursor] = node;
  }
}
function uniqueNodes(arr) {
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res;
}
const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val) {
  let quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"".concat(val, "\"") : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = 'Error';
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? "".concat(this.errors.length, " errors occurred") : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    // Attempt to make the path more friendly for error message interpolation.
    const path = params.label || params.path || 'this';
    // Store the original path under `originalPath` so it isn't lost to custom
    // message functions; e.g., ones provided in `setLocale()` calls.
    params = Object.assign({}, params, {
      path,
      originalPath: params.path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = 'Error';
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}
let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: _ref215 => {
    let {
      path,
      type,
      value,
      originalValue
    } = _ref215;
    const castMsg = originalValue != null && originalValue !== value ? " (cast from the value `".concat(printValue(originalValue, true), "`).") : '.';
    return type !== 'mixed' ? "".concat(path, " must be a `").concat(type, "` type, ") + "but the final value was: `".concat(printValue(value, true), "`") + castMsg : "".concat(path, " must match the configured type. ") + "The validated value was: `".concat(printValue(value, true), "`") + castMsg;
  }
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  datetime: '${path} must be a valid ISO date-time',
  datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}',
  exact: '${path} object contains unknown properties: ${properties}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
let tuple = {
  notType: params => {
    const {
      path,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen) return "".concat(path, " tuple value has too few items, expected a length of ").concat(typeLen, " but got ").concat(value.length, " for value: `").concat(printValue(value, true), "`");
      if (value.length > typeLen) return "".concat(path, " tuple value has too many items, expected a length of ").concat(typeLen, " but got ").concat(value.length, " for value: `").concat(printValue(value, true), "`");
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});
const isSchema = obj => obj && obj.__isYupSchema__;
class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === 'function' ? is : function () {
      for (var _len10 = arguments.length, values = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        values[_key10] = arguments[_key10];
      }
      return values.every(value => value === is);
    };
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map(ref =>
    // TODO: ? operator here?
    ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === undefined ||
    // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}
const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }

  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return "Ref(".concat(this.key, ")");
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}

// @ts-ignore
Reference.prototype.__isYupRef = true;
const isAbsent = value => value == null;
function createValidation(config) {
  function validate(_ref216, panic, next) {
    let {
      value,
      path = '',
      options,
      originalValue,
      schema
    } = _ref216;
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError() {
      let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params);
      for (const key of Object.keys(nextParams)) nextParams[key] = resolve(nextParams[key]);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve,
      options,
      originalValue,
      schema
    };
    const handleResult = validOrError => {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    const handleError = err => {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        if (options.sync) {
          throw new Error("Validation test of type: \"".concat(ctx.type, "\" returned a Promise during a synchronous validate. ") + "This test will finish after the validate call has returned");
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}
function getIn(schema, path, value) {
  let context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : value;
  let parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === 'tuple';
    let idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error("Yup.reach cannot implicitly index into a tuple type. the path part \"".concat(lastPartDebug, "\" must contain an index to the tuple element, e.g. \"").concat(lastPartDebug, "[0]\""));
      if (value && idx >= value.length) {
        throw new Error("Yup.reach cannot resolve an array item at index: ".concat(_part, ", in the path: ").concat(path, ". ") + "because there is no value at that index. ");
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: ".concat(path, ". ") + "(failed at: ".concat(lastPartDebug, " which is a type: \"").concat(schema.type, "\")"));
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}
class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach(value => next.add(value));
    removeItems.forEach(value => next.delete(value));
    return next;
  }
}

// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function clone(src) {
  let seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  let copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    for (const v of src) copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
  } else {
    throw Error("Unable to clone ".concat(src));
  }
  return copy;
}

// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(s => {
      s.nonNullable();
    });
  }

  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    const next = Object.create(Object.getPrototypeOf(this));

    // @ts-expect-error this is readonly
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);

    // @ts-expect-error this is readonly
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta() {
    if (arguments.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, arguments.length <= 0 ? undefined : arguments[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: ".concat(this.type, " and ").concat(schema.type));
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

    // start with the current tests
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null) return true;
      if (this.spec.optional && v === undefined) return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }

  /**
   * Run the configured transform pipeline over an input value.
   */

  cast(value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === 'ignore-optionality';
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError("The value of ".concat(options.path || 'field', " could not be cast to a value ") + "that satisfies the schema type: \"".concat(resolvedSchema.type, "\". \n\n") + "attempted value: ".concat(formattedValue, " \n") + (formattedResult !== formattedValue ? "result of cast: ".concat(formattedResult) : ''));
    }
    return result;
  }
  _cast(rawValue, options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
    if (value === undefined) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let panic = arguments.length > 2 ? arguments[2] : undefined;
    let next = arguments.length > 3 ? arguments[3] : undefined;
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test) initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, initialErrors => {
      // even if we aren't ending early we can't proceed further if the types aren't correct
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }

  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = arg => {
      if (fired) return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = arg => {
      if (fired) return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count) return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest(_ref217) {
    let {
      key,
      index,
      parent,
      parentPath,
      originalParent,
      options
    } = _ref217;
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError('Must include `key` or `index` for nested validations');
    }
    const isIndex = typeof k === 'number';
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: undefined,
      // index: undefined,
      [isIndex ? 'index' : 'key']: k,
      path: isIndex || k.includes('.') ? "".concat(parentPath || '', "[").concat(isIndex ? k : "\"".concat(k, "\""), "]") : (parentPath ? "".concat(parentPath, ".") : '') + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this, options) : clone(defaultValue);
  }
  getDefault(options
  // If schema is defaulted we know it's at least not undefined
  ) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict() {
    let isStrict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: 'nullable',
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: 'optionality',
      test(value) {
        return value === undefined ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.defined;
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.notNull;
    return this.nullability(false, message);
  }
  required() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.required;
    return this.clone().withMutation(next => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation(next => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */

  test() {
    let opts;
    if (arguments.length === 1) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
        opts = {
          test: arguments.length <= 0 ? undefined : arguments[0]
        };
      } else {
        opts = arguments.length <= 0 ? undefined : arguments[0];
      }
    } else if (arguments.length === 2) {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        test: arguments.length <= 1 ? undefined : arguments[1]
      };
    } else {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        message: arguments.length <= 1 ? undefined : arguments[1],
        test: arguments.length <= 2 ? undefined : arguments[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore readonly array
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: 'typeError',
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value)) return this.createError({
          params: {
            type: this.schema.type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.oneOf;
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: 'oneOf',
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.notOneOf;
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: Array.from(invalids).join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip() {
    let strip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }
}
// @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) Schema.prototype["".concat(method, "At")] = function (path, value) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], Object.assign({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;

/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

// prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  const struct = parseDateStruct(date);
  if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

  // timestamps without timezone identifiers should be considered local time
  if (struct.z === undefined && struct.plusMinus === undefined) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date);
  if (!regexResult) return null;

  // use of toNumber() avoids NaN timestamps caused by “undefined”
  // values being passed to Date constructor
  return {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ?
    // allow arbitrary sub-second precision beyond milliseconds
    toNumber(regexResult[7].substring(0, 3)) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
    z: regexResult[8] || undefined,
    plusMinus: regexResult[9] || undefined,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
}
function toNumber(str) {
  let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Number(str) || defaultValue;
}

//
// Number Interfaces
//

let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
class DateSchema extends Schema {
  constructor() {
    super({
      type: 'date',
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError("`".concat(name, "` must be a Date or a value that can be `cast()` to a Date"));
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.min;
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max) {
    let message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.max;
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
const useFormValidation = _ref218 => {
  let {
    validationSchema,
    initialValues
  } = _ref218;
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState(() => Object.keys(initialValues).reduce((acc, key) => Object.assign(Object.assign({}, acc), {
    [key]: false
  }), {}));
  const validateField = useCallback((field, value) => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield validationSchema.validateAt(field, {
        [field]: value
      });
      setErrors(prev => Object.assign(Object.assign({}, prev), {
        [field]: ''
      }));
      return '';
    } catch (err) {
      if (err && typeof err === 'object' && 'message' in err) {
        const error = err.message;
        setErrors(prev => Object.assign(Object.assign({}, prev), {
          [field]: error
        }));
        return error;
      }
      return '';
    }
  }), [validationSchema]);
  const handleBlur = useCallback((field, value) => {
    setTouched(prev => Object.assign(Object.assign({}, prev), {
      [field]: true
    }));
    validateField(field, value);
  }, [validateField]);
  const handleChange = useCallback((field, value) => {
    if (touched[field]) {
      validateField(field, value);
    }
  }, [touched, validateField]);
  const validateAll = useCallback(values => __awaiter(void 0, void 0, void 0, function* () {
    try {
      yield validationSchema.validate(values, {
        abortEarly: false
      });
      setErrors({});
      return true;
    } catch (err) {
      if (err instanceof ValidationError) {
        const newErrors = {};
        err.inner.forEach(error => {
          if (error.path) {
            newErrors[error.path] = error.message;
          }
        });
        setErrors(newErrors);
        setTouched(Object.keys(values).reduce((acc, key) => Object.assign(Object.assign({}, acc), {
          [key]: true
        }), {}));
      }
      return false;
    }
  }), [validationSchema]);
  const resetValidation = useCallback(() => {
    setErrors({});
    setTouched(Object.keys(initialValues).reduce((acc, key) => Object.assign(Object.assign({}, acc), {
      [key]: false
    }), {}));
  }, [initialValues]);
  return {
    errors,
    touched,
    validateField,
    handleBlur,
    handleChange,
    validateAll,
    resetValidation,
    isFieldValid: field => !errors[field],
    getFieldError: field => touched[field] ? errors[field] : ''
  };
};
function usePrevious(value) {
  const ref = useRef(null);
  useEffect(() => {
    if (value) {
      ref.current = value;
    }
  }, [value]);
  return ref.current;
}
const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight
  }));
  const handleResize = useCallback(() => {
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }, []);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
  return screenSize;
};
export { AVATAR_PLACEHOLDER, AVATAR_PLACEHOLDER_2, AWS_S3_URL, Accordion, AddResourcesDialog, Alert, Avatar, BasicDialog, Button, COLORS, CUSTOM_MONTH_OCCURRENCE_DAYS, CUSTOM_MONTH_OCCURRENCE_ORDINAL_IDENTIFIERS, Calendar, Checkbox, CheckboxFormikWrapper, CheckboxList, CheckboxList as CheckboxListBook, CheckboxListDialog, CheckboxListFormikWrapper, CheckboxReduxFormWrapper, CheckboxTreeDialog, Chip, ColorPicker, ColorPickerDialog, ColorPickerDialogFormikWrapper, ColorPickerDialogReduxFormWrapper, ColorPickerFormikWrapper, ColorPickerReduxFormWrapper, ContextMenu, ContextMenuItem, CurrentColor, CustomMonthDatesSelect, CustomMonthDatesSelectDialog, DEFAULT_COLOR, DEFAULT_COUNTRY, DatePickerInput, DatePickerInputFormikWrapper, DatePickerReduxFormWrapper, DaysOfMonthSelect, DaysOfMonthSelectDialog, DefaultTooltipContent, DeleteModal, Dialog, Divider, Dot, Fab, HubUIConfigContextProvider, ICONS_WITH_STROKE, ICONS_WITH_STROKE_AND_FILL, Icon, IconButton, Image, InfoTile, Layout, List, ListItem, ListTile, Logo, Menu, MenuButton, MenuDivider, MenuIconButton, MenuItem, Modal, NavigationBar, NumberInput, NumberInputFormikWrapper, NumberInputReduxFormWrapper, NumberSwitcher, ObjectSet, PageHeader, PageWrapper, Pagination, PhoneNumberInput, Progress, Radio, RadioFormikWrapper, RadioGroup, RadioGroupFormikWrapper, RadioGroupReduxFormWrapper, RadioList, RadioListDialog, RadioReduxFormWrapper, RangePicker, SearchBar, SegmentedButton, Select, SelectFormikWrapper, SelectReduxFormWrapper, Slider, Slides, SmallInfoTile, SortableList, StyledCheckbox$1 as StyledCheckbox, StyledContextMenuItem, Switch, Table, Tag, TextField, TextFieldFormikWrapper, TextFieldReduxFormWrapper, ThemeProvider, Tooltip, Typography, WeekDaysCheckboxList, WeekDaysSelectedFormat, customDropdownDateRangesOption, designSpacing, formatCustomMonthDay, formatCustomMonthDayOrdinalIdentifiers, getRepeatOnCustomDayMonthOptions, hubTheme, iconNamesArray, imageNamesArray, isAvatarPlaceholder, isDivider$1 as isDivider, isIcon, isRepeatOnCustomDatesDay, openableHoc, ordinalIdentifierOptions, repeatOnCustomDatesDay, typographyVariantStyles, useAccordionState, useDebouncedValue, useFormValidation, useHubUIConfigContext, useKeyDown, useOpenState, usePrevious, useResponsiveOptions, useScreenSize };